/*!
  * Bowser - a browser detector
  * https://github.com/ded/bowser
  * MIT License | (c) Dustin Diaz 2015
  */

!function (name, definition) {
  if (typeof module != 'undefined' && module.exports) module.exports = definition()
  else if (typeof define == 'function' && define.amd) define(definition)
  else this[name] = definition()
}('bowser', function () {
  /**
    * See useragents.js for examples of navigator.userAgent
    */

  var t = true

  function detect(ua) {

    function getFirstMatch(regex) {
      var match = ua.match(regex);
      return (match && match.length > 1 && match[1]) || '';
    }

    function getSecondMatch(regex) {
      var match = ua.match(regex);
      return (match && match.length > 1 && match[2]) || '';
    }

    var iosdevice = getFirstMatch(/(ipod|iphone|ipad)/i).toLowerCase()
      , likeAndroid = /like android/i.test(ua)
      , android = !likeAndroid && /android/i.test(ua)
      , chromeBook = /CrOS/.test(ua)
      , edgeVersion = getFirstMatch(/edge\/(\d+(\.\d+)?)/i)
      , versionIdentifier = getFirstMatch(/version\/(\d+(\.\d+)?)/i)
      , tablet = /tablet/i.test(ua)
      , mobile = !tablet && /[^-]mobi/i.test(ua)
      , result

    if (/opera|opr/i.test(ua)) {
      result = {
        name: 'Opera'
      , opera: t
      , version: versionIdentifier || getFirstMatch(/(?:opera|opr)[\s\/](\d+(\.\d+)?)/i)
      }
    }
    else if (/yabrowser/i.test(ua)) {
      result = {
        name: 'Yandex Browser'
      , yandexbrowser: t
      , version: versionIdentifier || getFirstMatch(/(?:yabrowser)[\s\/](\d+(\.\d+)?)/i)
      }
    }
    else if (/windows phone/i.test(ua)) {
      result = {
        name: 'Windows Phone'
      , windowsphone: t
      }
      if (edgeVersion) {
        result.msedge = t
        result.version = edgeVersion
      }
      else {
        result.msie = t
        result.version = getFirstMatch(/iemobile\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/msie|trident/i.test(ua)) {
      result = {
        name: 'Internet Explorer'
      , msie: t
      , version: getFirstMatch(/(?:msie |rv:)(\d+(\.\d+)?)/i)
      }
    } else if (chromeBook) {
      result = {
        name: 'Chrome'
      , chromeBook: t
      , chrome: t
      , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
      }
    } else if (/chrome.+? edge/i.test(ua)) {
      result = {
        name: 'Microsoft Edge'
      , msedge: t
      , version: edgeVersion
      }
    }
    else if (/chrome|crios|crmo/i.test(ua)) {
      result = {
        name: 'Chrome'
      , chrome: t
      , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
      }
    }
    else if (iosdevice) {
      result = {
        name : iosdevice == 'iphone' ? 'iPhone' : iosdevice == 'ipad' ? 'iPad' : 'iPod'
      }
      // WTF: version is not part of user agent in web apps
      if (versionIdentifier) {
        result.version = versionIdentifier
      }
    }
    else if (/sailfish/i.test(ua)) {
      result = {
        name: 'Sailfish'
      , sailfish: t
      , version: getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/seamonkey\//i.test(ua)) {
      result = {
        name: 'SeaMonkey'
      , seamonkey: t
      , version: getFirstMatch(/seamonkey\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/firefox|iceweasel/i.test(ua)) {
      result = {
        name: 'Firefox'
      , firefox: t
      , version: getFirstMatch(/(?:firefox|iceweasel)[ \/](\d+(\.\d+)?)/i)
      }
      if (/\((mobile|tablet);[^\)]*rv:[\d\.]+\)/i.test(ua)) {
        result.firefoxos = t
      }
    }
    else if (/silk/i.test(ua)) {
      result =  {
        name: 'Amazon Silk'
      , silk: t
      , version : getFirstMatch(/silk\/(\d+(\.\d+)?)/i)
      }
    }
    else if (android) {
      result = {
        name: 'Android'
      , version: versionIdentifier
      }
    }
    else if (/phantom/i.test(ua)) {
      result = {
        name: 'PhantomJS'
      , phantom: t
      , version: getFirstMatch(/phantomjs\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/blackberry|\bbb\d+/i.test(ua) || /rim\stablet/i.test(ua)) {
      result = {
        name: 'BlackBerry'
      , blackberry: t
      , version: versionIdentifier || getFirstMatch(/blackberry[\d]+\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/(web|hpw)os/i.test(ua)) {
      result = {
        name: 'WebOS'
      , webos: t
      , version: versionIdentifier || getFirstMatch(/w(?:eb)?osbrowser\/(\d+(\.\d+)?)/i)
      };
      /touchpad\//i.test(ua) && (result.touchpad = t)
    }
    else if (/bada/i.test(ua)) {
      result = {
        name: 'Bada'
      , bada: t
      , version: getFirstMatch(/dolfin\/(\d+(\.\d+)?)/i)
      };
    }
    else if (/tizen/i.test(ua)) {
      result = {
        name: 'Tizen'
      , tizen: t
      , version: getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.\d+)?)/i) || versionIdentifier
      };
    }
    else if (/safari/i.test(ua)) {
      result = {
        name: 'Safari'
      , safari: t
      , version: versionIdentifier
      }
    }
    else {
      result = {
        name: getFirstMatch(/^(.*)\/(.*) /),
        version: getSecondMatch(/^(.*)\/(.*) /)
     };
   }

    // set webkit or gecko flag for browsers based on these engines
    if (!result.msedge && /(apple)?webkit/i.test(ua)) {
      result.name = result.name || "Webkit"
      result.webkit = t
      if (!result.version && versionIdentifier) {
        result.version = versionIdentifier
      }
    } else if (!result.opera && /gecko\//i.test(ua)) {
      result.name = result.name || "Gecko"
      result.gecko = t
      result.version = result.version || getFirstMatch(/gecko\/(\d+(\.\d+)?)/i)
    }

    // set OS flags for platforms that have multiple browsers
    if (!result.msedge && (android || result.silk)) {
      result.android = t
    } else if (iosdevice) {
      result[iosdevice] = t
      result.ios = t
    }

    // OS version extraction
    var osVersion = '';
    if (result.windowsphone) {
      osVersion = getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i);
    } else if (iosdevice) {
      osVersion = getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i);
      osVersion = osVersion.replace(/[_\s]/g, '.');
    } else if (android) {
      osVersion = getFirstMatch(/android[ \/-](\d+(\.\d+)*)/i);
    } else if (result.webos) {
      osVersion = getFirstMatch(/(?:web|hpw)os\/(\d+(\.\d+)*)/i);
    } else if (result.blackberry) {
      osVersion = getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i);
    } else if (result.bada) {
      osVersion = getFirstMatch(/bada\/(\d+(\.\d+)*)/i);
    } else if (result.tizen) {
      osVersion = getFirstMatch(/tizen[\/\s](\d+(\.\d+)*)/i);
    }
    if (osVersion) {
      result.osversion = osVersion;
    }

    // device type extraction
    var osMajorVersion = osVersion.split('.')[0];
    if (tablet || iosdevice == 'ipad' || (android && (osMajorVersion == 3 || (osMajorVersion == 4 && !mobile))) || result.silk) {
      result.tablet = t
    } else if (mobile || iosdevice == 'iphone' || iosdevice == 'ipod' || android || result.blackberry || result.webos || result.bada) {
      result.mobile = t
    }

    // Graded Browser Support
    // http://developer.yahoo.com/yui/articles/gbs
    if (result.msedge ||
        (result.msie && result.version >= 10) ||
        (result.yandexbrowser && result.version >= 15) ||
        (result.chrome && result.version >= 20) ||
        (result.firefox && result.version >= 20.0) ||
        (result.safari && result.version >= 6) ||
        (result.opera && result.version >= 10.0) ||
        (result.ios && result.osversion && result.osversion.split(".")[0] >= 6) ||
        (result.blackberry && result.version >= 10.1)
        ) {
      result.a = t;
    }
    else if ((result.msie && result.version < 10) ||
        (result.chrome && result.version < 20) ||
        (result.firefox && result.version < 20.0) ||
        (result.safari && result.version < 6) ||
        (result.opera && result.version < 10.0) ||
        (result.ios && result.osversion && result.osversion.split(".")[0] < 6)
        ) {
      result.c = t
    } else result.x = t

    return result
  }

  var bowser = detect(typeof navigator !== 'undefined' ? navigator.userAgent : '')

  bowser.test = function (browserList) {
    for (var i = 0; i < browserList.length; ++i) {
      var browserItem = browserList[i];
      if (typeof browserItem=== 'string') {
        if (browserItem in bowser) {
          return true;
        }
      }
    }
    return false;
  }

  /*
   * Set our detect method to the main bowser object so we can
   * reuse it to test other user agents.
   * This is needed to implement future tests.
   */
  bowser._detect = detect;

  return bowser
});

(function () {
/**
 * @license almond 0.3.1 Copyright (c) 2011-2014, The Dojo Foundation All Rights Reserved.
 * Available via the MIT or new BSD license.
 * see: http://github.com/jrburke/almond for details
 */
//Going sloppy to avoid 'use strict' string cost, but strict practices should
//be followed.
/*jslint sloppy: true */
/*global setTimeout: false */

var requirejs, require, define;
(function (undef) {
    var main, req, makeMap, handlers,
        defined = {},
        waiting = {},
        config = {},
        defining = {},
        hasOwn = Object.prototype.hasOwnProperty,
        aps = [].slice,
        jsSuffixRegExp = /\.js$/;

    function hasProp(obj, prop) {
        return hasOwn.call(obj, prop);
    }

    /**
     * Given a relative module name, like ./something, normalize it to
     * a real name that can be mapped to a path.
     * @param {String} name the relative name
     * @param {String} baseName a real name that the name arg is relative
     * to.
     * @returns {String} normalized name
     */
    function normalize(name, baseName) {
        var nameParts, nameSegment, mapValue, foundMap, lastIndex,
            foundI, foundStarMap, starI, i, j, part,
            baseParts = baseName && baseName.split("/"),
            map = config.map,
            starMap = (map && map['*']) || {};

        //Adjust any relative paths.
        if (name && name.charAt(0) === ".") {
            //If have a base name, try to normalize against it,
            //otherwise, assume it is a top-level require that will
            //be relative to baseUrl in the end.
            if (baseName) {
                name = name.split('/');
                lastIndex = name.length - 1;

                // Node .js allowance:
                if (config.nodeIdCompat && jsSuffixRegExp.test(name[lastIndex])) {
                    name[lastIndex] = name[lastIndex].replace(jsSuffixRegExp, '');
                }

                //Lop off the last part of baseParts, so that . matches the
                //"directory" and not name of the baseName's module. For instance,
                //baseName of "one/two/three", maps to "one/two/three.js", but we
                //want the directory, "one/two" for this normalization.
                name = baseParts.slice(0, baseParts.length - 1).concat(name);

                //start trimDots
                for (i = 0; i < name.length; i += 1) {
                    part = name[i];
                    if (part === ".") {
                        name.splice(i, 1);
                        i -= 1;
                    } else if (part === "..") {
                        if (i === 1 && (name[2] === '..' || name[0] === '..')) {
                            //End of the line. Keep at least one non-dot
                            //path segment at the front so it can be mapped
                            //correctly to disk. Otherwise, there is likely
                            //no path mapping for a path starting with '..'.
                            //This can still fail, but catches the most reasonable
                            //uses of ..
                            break;
                        } else if (i > 0) {
                            name.splice(i - 1, 2);
                            i -= 2;
                        }
                    }
                }
                //end trimDots

                name = name.join("/");
            } else if (name.indexOf('./') === 0) {
                // No baseName, so this is ID is resolved relative
                // to baseUrl, pull off the leading dot.
                name = name.substring(2);
            }
        }

        //Apply map config if available.
        if ((baseParts || starMap) && map) {
            nameParts = name.split('/');

            for (i = nameParts.length; i > 0; i -= 1) {
                nameSegment = nameParts.slice(0, i).join("/");

                if (baseParts) {
                    //Find the longest baseName segment match in the config.
                    //So, do joins on the biggest to smallest lengths of baseParts.
                    for (j = baseParts.length; j > 0; j -= 1) {
                        mapValue = map[baseParts.slice(0, j).join('/')];

                        //baseName segment has  config, find if it has one for
                        //this name.
                        if (mapValue) {
                            mapValue = mapValue[nameSegment];
                            if (mapValue) {
                                //Match, update name to the new value.
                                foundMap = mapValue;
                                foundI = i;
                                break;
                            }
                        }
                    }
                }

                if (foundMap) {
                    break;
                }

                //Check for a star map match, but just hold on to it,
                //if there is a shorter segment match later in a matching
                //config, then favor over this star map.
                if (!foundStarMap && starMap && starMap[nameSegment]) {
                    foundStarMap = starMap[nameSegment];
                    starI = i;
                }
            }

            if (!foundMap && foundStarMap) {
                foundMap = foundStarMap;
                foundI = starI;
            }

            if (foundMap) {
                nameParts.splice(0, foundI, foundMap);
                name = nameParts.join('/');
            }
        }

        return name;
    }

    function makeRequire(relName, forceSync) {
        return function () {
            //A version of a require function that passes a moduleName
            //value for items that may need to
            //look up paths relative to the moduleName
            var args = aps.call(arguments, 0);

            //If first arg is not require('string'), and there is only
            //one arg, it is the array form without a callback. Insert
            //a null so that the following concat is correct.
            if (typeof args[0] !== 'string' && args.length === 1) {
                args.push(null);
            }
            return req.apply(undef, args.concat([relName, forceSync]));
        };
    }

    function makeNormalize(relName) {
        return function (name) {
            return normalize(name, relName);
        };
    }

    function makeLoad(depName) {
        return function (value) {
            defined[depName] = value;
        };
    }

    function callDep(name) {
        if (hasProp(waiting, name)) {
            var args = waiting[name];
            delete waiting[name];
            defining[name] = true;
            main.apply(undef, args);
        }

        if (!hasProp(defined, name) && !hasProp(defining, name)) {
            throw new Error('No ' + name);
        }
        return defined[name];
    }

    //Turns a plugin!resource to [plugin, resource]
    //with the plugin being undefined if the name
    //did not have a plugin prefix.
    function splitPrefix(name) {
        var prefix,
            index = name ? name.indexOf('!') : -1;
        if (index > -1) {
            prefix = name.substring(0, index);
            name = name.substring(index + 1, name.length);
        }
        return [prefix, name];
    }

    /**
     * Makes a name map, normalizing the name, and using a plugin
     * for normalization if necessary. Grabs a ref to plugin
     * too, as an optimization.
     */
    makeMap = function (name, relName) {
        var plugin,
            parts = splitPrefix(name),
            prefix = parts[0];

        name = parts[1];

        if (prefix) {
            prefix = normalize(prefix, relName);
            plugin = callDep(prefix);
        }

        //Normalize according
        if (prefix) {
            if (plugin && plugin.normalize) {
                name = plugin.normalize(name, makeNormalize(relName));
            } else {
                name = normalize(name, relName);
            }
        } else {
            name = normalize(name, relName);
            parts = splitPrefix(name);
            prefix = parts[0];
            name = parts[1];
            if (prefix) {
                plugin = callDep(prefix);
            }
        }

        //Using ridiculous property names for space reasons
        return {
            f: prefix ? prefix + '!' + name : name, //fullName
            n: name,
            pr: prefix,
            p: plugin
        };
    };

    function makeConfig(name) {
        return function () {
            return (config && config.config && config.config[name]) || {};
        };
    }

    handlers = {
        require: function (name) {
            return makeRequire(name);
        },
        exports: function (name) {
            var e = defined[name];
            if (typeof e !== 'undefined') {
                return e;
            } else {
                return (defined[name] = {});
            }
        },
        module: function (name) {
            return {
                id: name,
                uri: '',
                exports: defined[name],
                config: makeConfig(name)
            };
        }
    };

    main = function (name, deps, callback, relName) {
        var cjsModule, depName, ret, map, i,
            args = [],
            callbackType = typeof callback,
            usingExports;

        //Use name if no relName
        relName = relName || name;

        //Call the callback to define the module, if necessary.
        if (callbackType === 'undefined' || callbackType === 'function') {
            //Pull out the defined dependencies and pass the ordered
            //values to the callback.
            //Default to [require, exports, module] if no deps
            deps = !deps.length && callback.length ? ['require', 'exports', 'module'] : deps;
            for (i = 0; i < deps.length; i += 1) {
                map = makeMap(deps[i], relName);
                depName = map.f;

                //Fast path CommonJS standard dependencies.
                if (depName === "require") {
                    args[i] = handlers.require(name);
                } else if (depName === "exports") {
                    //CommonJS module spec 1.1
                    args[i] = handlers.exports(name);
                    usingExports = true;
                } else if (depName === "module") {
                    //CommonJS module spec 1.1
                    cjsModule = args[i] = handlers.module(name);
                } else if (hasProp(defined, depName) ||
                           hasProp(waiting, depName) ||
                           hasProp(defining, depName)) {
                    args[i] = callDep(depName);
                } else if (map.p) {
                    map.p.load(map.n, makeRequire(relName, true), makeLoad(depName), {});
                    args[i] = defined[depName];
                } else {
                    throw new Error(name + ' missing ' + depName);
                }
            }

            ret = callback ? callback.apply(defined[name], args) : undefined;

            if (name) {
                //If setting exports via "module" is in play,
                //favor that over return value and exports. After that,
                //favor a non-undefined return value over exports use.
                if (cjsModule && cjsModule.exports !== undef &&
                        cjsModule.exports !== defined[name]) {
                    defined[name] = cjsModule.exports;
                } else if (ret !== undef || !usingExports) {
                    //Use the return value from the function.
                    defined[name] = ret;
                }
            }
        } else if (name) {
            //May just be an object definition for the module. Only
            //worry about defining if have a module name.
            defined[name] = callback;
        }
    };

    requirejs = require = req = function (deps, callback, relName, forceSync, alt) {
        if (typeof deps === "string") {
            if (handlers[deps]) {
                //callback in this case is really relName
                return handlers[deps](callback);
            }
            //Just return the module wanted. In this scenario, the
            //deps arg is the module name, and second arg (if passed)
            //is just the relName.
            //Normalize module name, if it contains . or ..
            return callDep(makeMap(deps, callback).f);
        } else if (!deps.splice) {
            //deps is a config object, not an array.
            config = deps;
            if (config.deps) {
                req(config.deps, config.callback);
            }
            if (!callback) {
                return;
            }

            if (callback.splice) {
                //callback is an array, which means it is a dependency list.
                //Adjust args if there are dependencies
                deps = callback;
                callback = relName;
                relName = null;
            } else {
                deps = undef;
            }
        }

        //Support require(['a'])
        callback = callback || function () {};

        //If relName is a function, it is an errback handler,
        //so remove it.
        if (typeof relName === 'function') {
            relName = forceSync;
            forceSync = alt;
        }

        //Simulate async callback;
        if (forceSync) {
            main(undef, deps, callback, relName);
        } else {
            //Using a non-zero value because of concern for what old browsers
            //do, and latest browsers "upgrade" to 4 if lower value is used:
            //http://www.whatwg.org/specs/web-apps/current-work/multipage/timers.html#dom-windowtimers-settimeout:
            //If want a value immediately, use require('id') instead -- something
            //that works in almond on the global level, but not guaranteed and
            //unlikely to work in other AMD implementations.
            setTimeout(function () {
                main(undef, deps, callback, relName);
            }, 4);
        }

        return req;
    };

    /**
     * Just drops the config on the floor, but returns req in case
     * the config return value is used.
     */
    req.config = function (cfg) {
        return req(cfg);
    };

    /**
     * Expose module registry for debugging and tooling
     */
    requirejs._defined = defined;

    define = function (name, deps, callback) {
        if (typeof name !== 'string') {
            throw new Error('See almond README: incorrect module build, no module name');
        }

        //This module may not have dependencies
        if (!deps.splice) {
            //deps is not an array, so probably means
            //an object literal or factory function for
            //the value. Adjust args.
            callback = deps;
            deps = [];
        }

        if (!hasProp(defined, name) && !hasProp(waiting, name)) {
            waiting[name] = [name, deps, callback];
        }
    };

    define.amd = {
        jQuery: true
    };
}());

define("almond", function(){});

require.config({
    paths: {
        "vendor": "../../vendor",
        "almond": "../../vendor/bower/almond/almond",
        "underscore": "../../vendor/bower/underscore/underscore-min",
        "backbone": "../../vendor/bower/backbone/backbone",
        "bootstrap": "../../vendor/bower/bootstrap/dist/js/bootstrap.min",
        "backbone-super": "../../vendor/bower/backbone-super/backbone-super/backbone-super",
        "bootstrap-select": "../../vendor/bower/bootstrap-select/dist/js/bootstrap-select.min",
        "bootstrap-tabcollapse": "../../vendor/bower/bootstrap-tabcollapse/bootstrap-tabcollapse",
        "bootstrap-datepicker": "../../vendor/bower/bootstrap-datepicker/dist/js/bootstrap-datepicker.min",
        "bootstrap-datepicker-languages-AMD": "./libs/bootstrap-datepicker-languages-AMD",
        "jquery-gestures": "./libs/jgestures.min", // http://jgestures.codeplex.com/
        "jquery-mousewheel": "../../vendor/bower/jquery-mousewheel/jquery.mousewheel",
        "TweenLite": "../../vendor/bower/gsap/src/minified/TweenLite.min",
        "gsap": "../../vendor/bower/gsap/src/minified/TweenMax.min",
        "gsap-scrollto": "../../vendor/bower/gsap/src/minified/plugins/ScrollToPlugin.min",
        "gsap-interval": "./libs/TweenMaxInterval",
        "hammerjs": "../../vendor/bower/hammerjs/hammer.min",
        "jquery.hammer": "./libs/jquery.hammer",
        "bowser": "../../vendor/bower/bowser/bowser.min",
        "moment": "../../vendor/bower/moment/min/moment.min",
        "object-fit-polyfill": "../../vendor/bower/object-fit-polyfill/src/objectFitPolyfill",
        'cryptojs-core': '../../vendor/bower/cryptojslib/components/core',
        'cryptojs-md5': '../../vendor/bower/cryptojslib/components/md5',
        'cryptojs-base64': '../../vendor/bower/cryptojslib/components/enc-base64',
        "swiper":  "../../vendor/bower/swiper/dist/js/swiper",
        "store2": "./libs/store2",
        "Clock": "./libs/Clock",
        "modernizr": "./libs/modernizr.min",
        "james-search": "../../vendor/bower/eismann-theme-components-search-ui/dist/js/james-search",
    },
    shim: {
        "bootstrap": {
            deps: ["jquery"]
        },
        "backbone-touch": {
            deps: ["backbone"]
        },
        "backbone-super": {
            deps: ["backbone"]
        },
        "bootstrap-select": {
            deps: ["bootstrap"]
        },
        "bootstrap-tabcollapse": {
            deps: ["bootstrap"]
        },
        "bootstrap-datepicker": {
            deps: ["bootstrap"]
        },
        "bootstrap-datepicker-languages-AMD": {
            deps: ["bootstrap-datepicker"]
        },
        "backbone": {
            exports: "Backbone",
            deps: ["jquery", "underscore"]
        },
        'cryptojs-core': {
            exports: 'CryptoJS'
        },
        'cryptojs-md5': {
            deps: ['cryptojs-core'],
            exports: 'CryptoJS'
        },
        'cryptojs-base64': {
            deps: ['cryptojs-core'],
            exports: 'CryptoJS'
        },
        "underscore": {
            exports: "_"
        },
        "jquery-gestures": {
            deps: ["jquery"]
        },
        "jquery.hammer": {
            deps: ["hammerjs"]
        },
        "jquery.TubePlayer": {
            deps: ["jquery"]
        },
        "bowser": {
            exports: "bowser"
        },
        "modernizr": {
            exports: "Modernizr"
        },
        "james-search": {
            exports: "jamesSearch"
        },
    },
    urlArgs: "bust= " + String((new Date()).getTime())
});

define("config", function(){});

/*! modernizr 3.3.1 (Custom Build) | MIT *
 * http://modernizr.com/download/?-cookies-cssanimations-csscolumns-ellipsis-flexbox-geolocation-history-inputtypes-svg-touchevents-video-setclasses !*/
!function(e,t,n){function o(e,t){return typeof e===t}function i(){var e,t,n,i,r,s,a;for(var l in w)if(w.hasOwnProperty(l)){if(e=[],t=w[l],t.name&&(e.push(t.name.toLowerCase()),t.options&&t.options.aliases&&t.options.aliases.length))for(n=0;n<t.options.aliases.length;n++)e.push(t.options.aliases[n].toLowerCase());for(i=o(t.fn,"function")?t.fn():t.fn,r=0;r<e.length;r++)s=e[r],a=s.split("."),1===a.length?Modernizr[a[0]]=i:(!Modernizr[a[0]]||Modernizr[a[0]]instanceof Boolean||(Modernizr[a[0]]=new Boolean(Modernizr[a[0]])),Modernizr[a[0]][a[1]]=i),g.push((i?"":"no-")+a.join("-"))}}function r(e){var t=b.className,n=Modernizr._config.classPrefix||"";if(C&&(t=t.baseVal),Modernizr._config.enableJSClass){var o=new RegExp("(^|\\s)"+n+"no-js(\\s|$)");t=t.replace(o,"$1"+n+"js$2")}Modernizr._config.enableClasses&&(t+=" "+n+e.join(" "+n),C?b.className.baseVal=t:b.className=t)}function s(){return"function"!=typeof t.createElement?t.createElement(arguments[0]):C?t.createElementNS.call(t,"http://www.w3.org/2000/svg",arguments[0]):t.createElement.apply(t,arguments)}function a(){var e=t.body;return e||(e=s(C?"svg":"body"),e.fake=!0),e}function l(e,n,o,i){var r,l,c,u,d="modernizr",f=s("div"),p=a();if(parseInt(o,10))for(;o--;)c=s("div"),c.id=i?i[o]:d+(o+1),f.appendChild(c);return r=s("style"),r.type="text/css",r.id="s"+d,(p.fake?p:f).appendChild(r),p.appendChild(f),r.styleSheet?r.styleSheet.cssText=e:r.appendChild(t.createTextNode(e)),f.id=d,p.fake&&(p.style.background="",p.style.overflow="hidden",u=b.style.overflow,b.style.overflow="hidden",b.appendChild(p)),l=n(f,e),p.fake?(p.parentNode.removeChild(p),b.style.overflow=u,b.offsetHeight):f.parentNode.removeChild(f),!!l}function c(e,t){return!!~(""+e).indexOf(t)}function u(e){return e.replace(/([a-z])-([a-z])/g,function(e,t,n){return t+n.toUpperCase()}).replace(/^-/,"")}function d(e,t){return function(){return e.apply(t,arguments)}}function f(e,t,n){var i;for(var r in e)if(e[r]in t)return n===!1?e[r]:(i=t[e[r]],o(i,"function")?d(i,n||t):i);return!1}function p(e){return e.replace(/([A-Z])/g,function(e,t){return"-"+t.toLowerCase()}).replace(/^ms-/,"-ms-")}function m(t,o){var i=t.length;if("CSS"in e&&"supports"in e.CSS){for(;i--;)if(e.CSS.supports(p(t[i]),o))return!0;return!1}if("CSSSupportsRule"in e){for(var r=[];i--;)r.push("("+p(t[i])+":"+o+")");return r=r.join(" or "),l("@supports ("+r+") { #modernizr { position: absolute; } }",function(e){return"absolute"==getComputedStyle(e,null).position})}return n}function h(e,t,i,r){function a(){d&&(delete O.style,delete O.modElem)}if(r=o(r,"undefined")?!1:r,!o(i,"undefined")){var l=m(e,i);if(!o(l,"undefined"))return l}for(var d,f,p,h,v,y=["modernizr","tspan"];!O.style;)d=!0,O.modElem=s(y.shift()),O.style=O.modElem.style;for(p=e.length,f=0;p>f;f++)if(h=e[f],v=O.style[h],c(h,"-")&&(h=u(h)),O.style[h]!==n){if(r||o(i,"undefined"))return a(),"pfx"==t?h:!0;try{O.style[h]=i}catch(g){}if(O.style[h]!=v)return a(),"pfx"==t?h:!0}return a(),!1}function v(e,t,n,i,r){var s=e.charAt(0).toUpperCase()+e.slice(1),a=(e+" "+A.join(s+" ")+s).split(" ");return o(t,"string")||o(t,"undefined")?h(a,t,i,r):(a=(e+" "+z.join(s+" ")+s).split(" "),f(a,t,n))}function y(e,t,o){return v(e,n,n,t,o)}var g=[],w=[],x={_version:"3.3.1",_config:{classPrefix:"",enableClasses:!0,enableJSClass:!0,usePrefixes:!0},_q:[],on:function(e,t){var n=this;setTimeout(function(){t(n[e])},0)},addTest:function(e,t,n){w.push({name:e,fn:t,options:n})},addAsyncTest:function(e){w.push({name:null,fn:e})}},Modernizr=function(){};Modernizr.prototype=x,Modernizr=new Modernizr,Modernizr.addTest("cookies",function(){try{t.cookie="cookietest=1";var e=-1!=t.cookie.indexOf("cookietest=");return t.cookie="cookietest=1; expires=Thu, 01-Jan-1970 00:00:01 GMT",e}catch(n){return!1}}),Modernizr.addTest("geolocation","geolocation"in navigator),Modernizr.addTest("history",function(){var t=navigator.userAgent;return-1===t.indexOf("Android 2.")&&-1===t.indexOf("Android 4.0")||-1===t.indexOf("Mobile Safari")||-1!==t.indexOf("Chrome")||-1!==t.indexOf("Windows Phone")?e.history&&"pushState"in e.history:!1}),Modernizr.addTest("svg",!!t.createElementNS&&!!t.createElementNS("http://www.w3.org/2000/svg","svg").createSVGRect);var b=t.documentElement,C="svg"===b.nodeName.toLowerCase(),T=x._config.usePrefixes?" -webkit- -moz- -o- -ms- ".split(" "):["",""];x._prefixes=T,Modernizr.addTest("video",function(){var e=s("video"),t=!1;try{(t=!!e.canPlayType)&&(t=new Boolean(t),t.ogg=e.canPlayType('video/ogg; codecs="theora"').replace(/^no$/,""),t.h264=e.canPlayType('video/mp4; codecs="avc1.42E01E"').replace(/^no$/,""),t.webm=e.canPlayType('video/webm; codecs="vp8, vorbis"').replace(/^no$/,""),t.vp9=e.canPlayType('video/webm; codecs="vp9"').replace(/^no$/,""),t.hls=e.canPlayType('application/x-mpegURL; codecs="avc1.42E01E"').replace(/^no$/,""))}catch(n){}return t});var S=s("input"),k="search tel url email datetime date month week time datetime-local number range color".split(" "),_={};Modernizr.inputtypes=function(e){for(var o,i,r,s=e.length,a="1)",l=0;s>l;l++)S.setAttribute("type",o=e[l]),r="text"!==S.type&&"style"in S,r&&(S.value=a,S.style.cssText="position:absolute;visibility:hidden;",/^range$/.test(o)&&S.style.WebkitAppearance!==n?(b.appendChild(S),i=t.defaultView,r=i.getComputedStyle&&"textfield"!==i.getComputedStyle(S,null).WebkitAppearance&&0!==S.offsetHeight,b.removeChild(S)):/^(search|tel)$/.test(o)||(r=/^(url|email)$/.test(o)?S.checkValidity&&S.checkValidity()===!1:S.value!=a)),_[e[l]]=!!r;return _}(k);var P=x.testStyles=l;Modernizr.addTest("touchevents",function(){var n;if("ontouchstart"in e||e.DocumentTouch&&t instanceof DocumentTouch)n=!0;else{var o=["@media (",T.join("touch-enabled),("),"heartz",")","{#modernizr{top:9px;position:absolute}}"].join("");P(o,function(e){n=9===e.offsetTop})}return n});var E="Moz O ms Webkit",A=x._config.usePrefixes?E.split(" "):[];x._cssomPrefixes=A;var z=x._config.usePrefixes?E.toLowerCase().split(" "):[];x._domPrefixes=z;var N={elem:s("modernizr")};Modernizr._q.push(function(){delete N.elem});var O={style:N.elem.style};Modernizr._q.unshift(function(){delete O.style}),x.testAllProps=v,x.testAllProps=y,Modernizr.addTest("cssanimations",y("animationName","a",!0)),Modernizr.addTest("ellipsis",y("textOverflow","ellipsis")),Modernizr.addTest("flexbox",y("flexBasis","1px",!0)),function(){Modernizr.addTest("csscolumns",function(){var e=!1,t=y("columnCount");try{(e=!!t)&&(e=new Boolean(e))}catch(n){}return e});for(var e,t,n=["Width","Span","Fill","Gap","Rule","RuleColor","RuleStyle","RuleWidth","BreakBefore","BreakAfter","BreakInside"],o=0;o<n.length;o++)e=n[o].toLowerCase(),t=y("column"+n[o]),("breakbefore"===e||"breakafter"===e||"breakinside"==e)&&(t=t||y(n[o])),Modernizr.addTest("csscolumns."+e,t)}(),i(),r(g),delete x.addTest,delete x.addAsyncTest;for(var $=0;$<Modernizr._q.length;$++)Modernizr._q[$]();e.Modernizr=Modernizr}(window,document);
define("modernizr", (function (global) {
    return function () {
        var ret, fn;
        return ret || global.Modernizr;
    };
}(this)));

/*!
  * Bowser - a browser detector
  * https://github.com/ded/bowser
  * MIT License | (c) Dustin Diaz 2015
  */
!function(e,t){typeof module!="undefined"&&module.exports?module.exports=t():typeof define=="function"&&define.amd?define('bowser',t):this[e]=t()}("bowser",function(){function t(t){function n(e){var n=t.match(e);return n&&n.length>1&&n[1]||""}function r(e){var n=t.match(e);return n&&n.length>1&&n[2]||""}var i=n(/(ipod|iphone|ipad)/i).toLowerCase(),s=/like android/i.test(t),o=!s&&/android/i.test(t),u=/CrOS/.test(t),a=n(/edge\/(\d+(\.\d+)?)/i),f=n(/version\/(\d+(\.\d+)?)/i),l=/tablet/i.test(t),c=!l&&/[^-]mobi/i.test(t),h;/opera|opr/i.test(t)?h={name:"Opera",opera:e,version:f||n(/(?:opera|opr)[\s\/](\d+(\.\d+)?)/i)}:/yabrowser/i.test(t)?h={name:"Yandex Browser",yandexbrowser:e,version:f||n(/(?:yabrowser)[\s\/](\d+(\.\d+)?)/i)}:/windows phone/i.test(t)?(h={name:"Windows Phone",windowsphone:e},a?(h.msedge=e,h.version=a):(h.msie=e,h.version=n(/iemobile\/(\d+(\.\d+)?)/i))):/msie|trident/i.test(t)?h={name:"Internet Explorer",msie:e,version:n(/(?:msie |rv:)(\d+(\.\d+)?)/i)}:u?h={name:"Chrome",chromeBook:e,chrome:e,version:n(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)}:/chrome.+? edge/i.test(t)?h={name:"Microsoft Edge",msedge:e,version:a}:/chrome|crios|crmo/i.test(t)?h={name:"Chrome",chrome:e,version:n(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)}:i?(h={name:i=="iphone"?"iPhone":i=="ipad"?"iPad":"iPod"},f&&(h.version=f)):/sailfish/i.test(t)?h={name:"Sailfish",sailfish:e,version:n(/sailfish\s?browser\/(\d+(\.\d+)?)/i)}:/seamonkey\//i.test(t)?h={name:"SeaMonkey",seamonkey:e,version:n(/seamonkey\/(\d+(\.\d+)?)/i)}:/firefox|iceweasel/i.test(t)?(h={name:"Firefox",firefox:e,version:n(/(?:firefox|iceweasel)[ \/](\d+(\.\d+)?)/i)},/\((mobile|tablet);[^\)]*rv:[\d\.]+\)/i.test(t)&&(h.firefoxos=e)):/silk/i.test(t)?h={name:"Amazon Silk",silk:e,version:n(/silk\/(\d+(\.\d+)?)/i)}:o?h={name:"Android",version:f}:/phantom/i.test(t)?h={name:"PhantomJS",phantom:e,version:n(/phantomjs\/(\d+(\.\d+)?)/i)}:/blackberry|\bbb\d+/i.test(t)||/rim\stablet/i.test(t)?h={name:"BlackBerry",blackberry:e,version:f||n(/blackberry[\d]+\/(\d+(\.\d+)?)/i)}:/(web|hpw)os/i.test(t)?(h={name:"WebOS",webos:e,version:f||n(/w(?:eb)?osbrowser\/(\d+(\.\d+)?)/i)},/touchpad\//i.test(t)&&(h.touchpad=e)):/bada/i.test(t)?h={name:"Bada",bada:e,version:n(/dolfin\/(\d+(\.\d+)?)/i)}:/tizen/i.test(t)?h={name:"Tizen",tizen:e,version:n(/(?:tizen\s?)?browser\/(\d+(\.\d+)?)/i)||f}:/safari/i.test(t)?h={name:"Safari",safari:e,version:f}:h={name:n(/^(.*)\/(.*) /),version:r(/^(.*)\/(.*) /)},!h.msedge&&/(apple)?webkit/i.test(t)?(h.name=h.name||"Webkit",h.webkit=e,!h.version&&f&&(h.version=f)):!h.opera&&/gecko\//i.test(t)&&(h.name=h.name||"Gecko",h.gecko=e,h.version=h.version||n(/gecko\/(\d+(\.\d+)?)/i)),!h.msedge&&(o||h.silk)?h.android=e:i&&(h[i]=e,h.ios=e);var p="";h.windowsphone?p=n(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i):i?(p=n(/os (\d+([_\s]\d+)*) like mac os x/i),p=p.replace(/[_\s]/g,".")):o?p=n(/android[ \/-](\d+(\.\d+)*)/i):h.webos?p=n(/(?:web|hpw)os\/(\d+(\.\d+)*)/i):h.blackberry?p=n(/rim\stablet\sos\s(\d+(\.\d+)*)/i):h.bada?p=n(/bada\/(\d+(\.\d+)*)/i):h.tizen&&(p=n(/tizen[\/\s](\d+(\.\d+)*)/i)),p&&(h.osversion=p);var d=p.split(".")[0];if(l||i=="ipad"||o&&(d==3||d==4&&!c)||h.silk)h.tablet=e;else if(c||i=="iphone"||i=="ipod"||o||h.blackberry||h.webos||h.bada)h.mobile=e;return h.msedge||h.msie&&h.version>=10||h.yandexbrowser&&h.version>=15||h.chrome&&h.version>=20||h.firefox&&h.version>=20||h.safari&&h.version>=6||h.opera&&h.version>=10||h.ios&&h.osversion&&h.osversion.split(".")[0]>=6||h.blackberry&&h.version>=10.1?h.a=e:h.msie&&h.version<10||h.chrome&&h.version<20||h.firefox&&h.version<20||h.safari&&h.version<6||h.opera&&h.version<10||h.ios&&h.osversion&&h.osversion.split(".")[0]<6?h.c=e:h.x=e,h}var e=!0,n=t(typeof navigator!="undefined"?navigator.userAgent:"");return n.test=function(e){for(var t=0;t<e.length;++t){var r=e[t];if(typeof r=="string"&&r in n)return!0}return!1},n._detect=t,n});
//     Underscore.js 1.8.3
//     http://underscorejs.org
//     (c) 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
//     Underscore may be freely distributed under the MIT license.
(function(){function n(n){function t(t,r,e,u,i,o){for(;i>=0&&o>i;i+=n){var a=u?u[i]:i;e=r(e,t[a],a,t)}return e}return function(r,e,u,i){e=b(e,i,4);var o=!k(r)&&m.keys(r),a=(o||r).length,c=n>0?0:a-1;return arguments.length<3&&(u=r[o?o[c]:c],c+=n),t(r,e,u,o,c,a)}}function t(n){return function(t,r,e){r=x(r,e);for(var u=O(t),i=n>0?0:u-1;i>=0&&u>i;i+=n)if(r(t[i],i,t))return i;return-1}}function r(n,t,r){return function(e,u,i){var o=0,a=O(e);if("number"==typeof i)n>0?o=i>=0?i:Math.max(i+a,o):a=i>=0?Math.min(i+1,a):i+a+1;else if(r&&i&&a)return i=r(e,u),e[i]===u?i:-1;if(u!==u)return i=t(l.call(e,o,a),m.isNaN),i>=0?i+o:-1;for(i=n>0?o:a-1;i>=0&&a>i;i+=n)if(e[i]===u)return i;return-1}}function e(n,t){var r=I.length,e=n.constructor,u=m.isFunction(e)&&e.prototype||a,i="constructor";for(m.has(n,i)&&!m.contains(t,i)&&t.push(i);r--;)i=I[r],i in n&&n[i]!==u[i]&&!m.contains(t,i)&&t.push(i)}var u=this,i=u._,o=Array.prototype,a=Object.prototype,c=Function.prototype,f=o.push,l=o.slice,s=a.toString,p=a.hasOwnProperty,h=Array.isArray,v=Object.keys,g=c.bind,y=Object.create,d=function(){},m=function(n){return n instanceof m?n:this instanceof m?void(this._wrapped=n):new m(n)};"undefined"!=typeof exports?("undefined"!=typeof module&&module.exports&&(exports=module.exports=m),exports._=m):u._=m,m.VERSION="1.8.3";var b=function(n,t,r){if(t===void 0)return n;switch(null==r?3:r){case 1:return function(r){return n.call(t,r)};case 2:return function(r,e){return n.call(t,r,e)};case 3:return function(r,e,u){return n.call(t,r,e,u)};case 4:return function(r,e,u,i){return n.call(t,r,e,u,i)}}return function(){return n.apply(t,arguments)}},x=function(n,t,r){return null==n?m.identity:m.isFunction(n)?b(n,t,r):m.isObject(n)?m.matcher(n):m.property(n)};m.iteratee=function(n,t){return x(n,t,1/0)};var _=function(n,t){return function(r){var e=arguments.length;if(2>e||null==r)return r;for(var u=1;e>u;u++)for(var i=arguments[u],o=n(i),a=o.length,c=0;a>c;c++){var f=o[c];t&&r[f]!==void 0||(r[f]=i[f])}return r}},j=function(n){if(!m.isObject(n))return{};if(y)return y(n);d.prototype=n;var t=new d;return d.prototype=null,t},w=function(n){return function(t){return null==t?void 0:t[n]}},A=Math.pow(2,53)-1,O=w("length"),k=function(n){var t=O(n);return"number"==typeof t&&t>=0&&A>=t};m.each=m.forEach=function(n,t,r){t=b(t,r);var e,u;if(k(n))for(e=0,u=n.length;u>e;e++)t(n[e],e,n);else{var i=m.keys(n);for(e=0,u=i.length;u>e;e++)t(n[i[e]],i[e],n)}return n},m.map=m.collect=function(n,t,r){t=x(t,r);for(var e=!k(n)&&m.keys(n),u=(e||n).length,i=Array(u),o=0;u>o;o++){var a=e?e[o]:o;i[o]=t(n[a],a,n)}return i},m.reduce=m.foldl=m.inject=n(1),m.reduceRight=m.foldr=n(-1),m.find=m.detect=function(n,t,r){var e;return e=k(n)?m.findIndex(n,t,r):m.findKey(n,t,r),e!==void 0&&e!==-1?n[e]:void 0},m.filter=m.select=function(n,t,r){var e=[];return t=x(t,r),m.each(n,function(n,r,u){t(n,r,u)&&e.push(n)}),e},m.reject=function(n,t,r){return m.filter(n,m.negate(x(t)),r)},m.every=m.all=function(n,t,r){t=x(t,r);for(var e=!k(n)&&m.keys(n),u=(e||n).length,i=0;u>i;i++){var o=e?e[i]:i;if(!t(n[o],o,n))return!1}return!0},m.some=m.any=function(n,t,r){t=x(t,r);for(var e=!k(n)&&m.keys(n),u=(e||n).length,i=0;u>i;i++){var o=e?e[i]:i;if(t(n[o],o,n))return!0}return!1},m.contains=m.includes=m.include=function(n,t,r,e){return k(n)||(n=m.values(n)),("number"!=typeof r||e)&&(r=0),m.indexOf(n,t,r)>=0},m.invoke=function(n,t){var r=l.call(arguments,2),e=m.isFunction(t);return m.map(n,function(n){var u=e?t:n[t];return null==u?u:u.apply(n,r)})},m.pluck=function(n,t){return m.map(n,m.property(t))},m.where=function(n,t){return m.filter(n,m.matcher(t))},m.findWhere=function(n,t){return m.find(n,m.matcher(t))},m.max=function(n,t,r){var e,u,i=-1/0,o=-1/0;if(null==t&&null!=n){n=k(n)?n:m.values(n);for(var a=0,c=n.length;c>a;a++)e=n[a],e>i&&(i=e)}else t=x(t,r),m.each(n,function(n,r,e){u=t(n,r,e),(u>o||u===-1/0&&i===-1/0)&&(i=n,o=u)});return i},m.min=function(n,t,r){var e,u,i=1/0,o=1/0;if(null==t&&null!=n){n=k(n)?n:m.values(n);for(var a=0,c=n.length;c>a;a++)e=n[a],i>e&&(i=e)}else t=x(t,r),m.each(n,function(n,r,e){u=t(n,r,e),(o>u||1/0===u&&1/0===i)&&(i=n,o=u)});return i},m.shuffle=function(n){for(var t,r=k(n)?n:m.values(n),e=r.length,u=Array(e),i=0;e>i;i++)t=m.random(0,i),t!==i&&(u[i]=u[t]),u[t]=r[i];return u},m.sample=function(n,t,r){return null==t||r?(k(n)||(n=m.values(n)),n[m.random(n.length-1)]):m.shuffle(n).slice(0,Math.max(0,t))},m.sortBy=function(n,t,r){return t=x(t,r),m.pluck(m.map(n,function(n,r,e){return{value:n,index:r,criteria:t(n,r,e)}}).sort(function(n,t){var r=n.criteria,e=t.criteria;if(r!==e){if(r>e||r===void 0)return 1;if(e>r||e===void 0)return-1}return n.index-t.index}),"value")};var F=function(n){return function(t,r,e){var u={};return r=x(r,e),m.each(t,function(e,i){var o=r(e,i,t);n(u,e,o)}),u}};m.groupBy=F(function(n,t,r){m.has(n,r)?n[r].push(t):n[r]=[t]}),m.indexBy=F(function(n,t,r){n[r]=t}),m.countBy=F(function(n,t,r){m.has(n,r)?n[r]++:n[r]=1}),m.toArray=function(n){return n?m.isArray(n)?l.call(n):k(n)?m.map(n,m.identity):m.values(n):[]},m.size=function(n){return null==n?0:k(n)?n.length:m.keys(n).length},m.partition=function(n,t,r){t=x(t,r);var e=[],u=[];return m.each(n,function(n,r,i){(t(n,r,i)?e:u).push(n)}),[e,u]},m.first=m.head=m.take=function(n,t,r){return null==n?void 0:null==t||r?n[0]:m.initial(n,n.length-t)},m.initial=function(n,t,r){return l.call(n,0,Math.max(0,n.length-(null==t||r?1:t)))},m.last=function(n,t,r){return null==n?void 0:null==t||r?n[n.length-1]:m.rest(n,Math.max(0,n.length-t))},m.rest=m.tail=m.drop=function(n,t,r){return l.call(n,null==t||r?1:t)},m.compact=function(n){return m.filter(n,m.identity)};var S=function(n,t,r,e){for(var u=[],i=0,o=e||0,a=O(n);a>o;o++){var c=n[o];if(k(c)&&(m.isArray(c)||m.isArguments(c))){t||(c=S(c,t,r));var f=0,l=c.length;for(u.length+=l;l>f;)u[i++]=c[f++]}else r||(u[i++]=c)}return u};m.flatten=function(n,t){return S(n,t,!1)},m.without=function(n){return m.difference(n,l.call(arguments,1))},m.uniq=m.unique=function(n,t,r,e){m.isBoolean(t)||(e=r,r=t,t=!1),null!=r&&(r=x(r,e));for(var u=[],i=[],o=0,a=O(n);a>o;o++){var c=n[o],f=r?r(c,o,n):c;t?(o&&i===f||u.push(c),i=f):r?m.contains(i,f)||(i.push(f),u.push(c)):m.contains(u,c)||u.push(c)}return u},m.union=function(){return m.uniq(S(arguments,!0,!0))},m.intersection=function(n){for(var t=[],r=arguments.length,e=0,u=O(n);u>e;e++){var i=n[e];if(!m.contains(t,i)){for(var o=1;r>o&&m.contains(arguments[o],i);o++);o===r&&t.push(i)}}return t},m.difference=function(n){var t=S(arguments,!0,!0,1);return m.filter(n,function(n){return!m.contains(t,n)})},m.zip=function(){return m.unzip(arguments)},m.unzip=function(n){for(var t=n&&m.max(n,O).length||0,r=Array(t),e=0;t>e;e++)r[e]=m.pluck(n,e);return r},m.object=function(n,t){for(var r={},e=0,u=O(n);u>e;e++)t?r[n[e]]=t[e]:r[n[e][0]]=n[e][1];return r},m.findIndex=t(1),m.findLastIndex=t(-1),m.sortedIndex=function(n,t,r,e){r=x(r,e,1);for(var u=r(t),i=0,o=O(n);o>i;){var a=Math.floor((i+o)/2);r(n[a])<u?i=a+1:o=a}return i},m.indexOf=r(1,m.findIndex,m.sortedIndex),m.lastIndexOf=r(-1,m.findLastIndex),m.range=function(n,t,r){null==t&&(t=n||0,n=0),r=r||1;for(var e=Math.max(Math.ceil((t-n)/r),0),u=Array(e),i=0;e>i;i++,n+=r)u[i]=n;return u};var E=function(n,t,r,e,u){if(!(e instanceof t))return n.apply(r,u);var i=j(n.prototype),o=n.apply(i,u);return m.isObject(o)?o:i};m.bind=function(n,t){if(g&&n.bind===g)return g.apply(n,l.call(arguments,1));if(!m.isFunction(n))throw new TypeError("Bind must be called on a function");var r=l.call(arguments,2),e=function(){return E(n,e,t,this,r.concat(l.call(arguments)))};return e},m.partial=function(n){var t=l.call(arguments,1),r=function(){for(var e=0,u=t.length,i=Array(u),o=0;u>o;o++)i[o]=t[o]===m?arguments[e++]:t[o];for(;e<arguments.length;)i.push(arguments[e++]);return E(n,r,this,this,i)};return r},m.bindAll=function(n){var t,r,e=arguments.length;if(1>=e)throw new Error("bindAll must be passed function names");for(t=1;e>t;t++)r=arguments[t],n[r]=m.bind(n[r],n);return n},m.memoize=function(n,t){var r=function(e){var u=r.cache,i=""+(t?t.apply(this,arguments):e);return m.has(u,i)||(u[i]=n.apply(this,arguments)),u[i]};return r.cache={},r},m.delay=function(n,t){var r=l.call(arguments,2);return setTimeout(function(){return n.apply(null,r)},t)},m.defer=m.partial(m.delay,m,1),m.throttle=function(n,t,r){var e,u,i,o=null,a=0;r||(r={});var c=function(){a=r.leading===!1?0:m.now(),o=null,i=n.apply(e,u),o||(e=u=null)};return function(){var f=m.now();a||r.leading!==!1||(a=f);var l=t-(f-a);return e=this,u=arguments,0>=l||l>t?(o&&(clearTimeout(o),o=null),a=f,i=n.apply(e,u),o||(e=u=null)):o||r.trailing===!1||(o=setTimeout(c,l)),i}},m.debounce=function(n,t,r){var e,u,i,o,a,c=function(){var f=m.now()-o;t>f&&f>=0?e=setTimeout(c,t-f):(e=null,r||(a=n.apply(i,u),e||(i=u=null)))};return function(){i=this,u=arguments,o=m.now();var f=r&&!e;return e||(e=setTimeout(c,t)),f&&(a=n.apply(i,u),i=u=null),a}},m.wrap=function(n,t){return m.partial(t,n)},m.negate=function(n){return function(){return!n.apply(this,arguments)}},m.compose=function(){var n=arguments,t=n.length-1;return function(){for(var r=t,e=n[t].apply(this,arguments);r--;)e=n[r].call(this,e);return e}},m.after=function(n,t){return function(){return--n<1?t.apply(this,arguments):void 0}},m.before=function(n,t){var r;return function(){return--n>0&&(r=t.apply(this,arguments)),1>=n&&(t=null),r}},m.once=m.partial(m.before,2);var M=!{toString:null}.propertyIsEnumerable("toString"),I=["valueOf","isPrototypeOf","toString","propertyIsEnumerable","hasOwnProperty","toLocaleString"];m.keys=function(n){if(!m.isObject(n))return[];if(v)return v(n);var t=[];for(var r in n)m.has(n,r)&&t.push(r);return M&&e(n,t),t},m.allKeys=function(n){if(!m.isObject(n))return[];var t=[];for(var r in n)t.push(r);return M&&e(n,t),t},m.values=function(n){for(var t=m.keys(n),r=t.length,e=Array(r),u=0;r>u;u++)e[u]=n[t[u]];return e},m.mapObject=function(n,t,r){t=x(t,r);for(var e,u=m.keys(n),i=u.length,o={},a=0;i>a;a++)e=u[a],o[e]=t(n[e],e,n);return o},m.pairs=function(n){for(var t=m.keys(n),r=t.length,e=Array(r),u=0;r>u;u++)e[u]=[t[u],n[t[u]]];return e},m.invert=function(n){for(var t={},r=m.keys(n),e=0,u=r.length;u>e;e++)t[n[r[e]]]=r[e];return t},m.functions=m.methods=function(n){var t=[];for(var r in n)m.isFunction(n[r])&&t.push(r);return t.sort()},m.extend=_(m.allKeys),m.extendOwn=m.assign=_(m.keys),m.findKey=function(n,t,r){t=x(t,r);for(var e,u=m.keys(n),i=0,o=u.length;o>i;i++)if(e=u[i],t(n[e],e,n))return e},m.pick=function(n,t,r){var e,u,i={},o=n;if(null==o)return i;m.isFunction(t)?(u=m.allKeys(o),e=b(t,r)):(u=S(arguments,!1,!1,1),e=function(n,t,r){return t in r},o=Object(o));for(var a=0,c=u.length;c>a;a++){var f=u[a],l=o[f];e(l,f,o)&&(i[f]=l)}return i},m.omit=function(n,t,r){if(m.isFunction(t))t=m.negate(t);else{var e=m.map(S(arguments,!1,!1,1),String);t=function(n,t){return!m.contains(e,t)}}return m.pick(n,t,r)},m.defaults=_(m.allKeys,!0),m.create=function(n,t){var r=j(n);return t&&m.extendOwn(r,t),r},m.clone=function(n){return m.isObject(n)?m.isArray(n)?n.slice():m.extend({},n):n},m.tap=function(n,t){return t(n),n},m.isMatch=function(n,t){var r=m.keys(t),e=r.length;if(null==n)return!e;for(var u=Object(n),i=0;e>i;i++){var o=r[i];if(t[o]!==u[o]||!(o in u))return!1}return!0};var N=function(n,t,r,e){if(n===t)return 0!==n||1/n===1/t;if(null==n||null==t)return n===t;n instanceof m&&(n=n._wrapped),t instanceof m&&(t=t._wrapped);var u=s.call(n);if(u!==s.call(t))return!1;switch(u){case"[object RegExp]":case"[object String]":return""+n==""+t;case"[object Number]":return+n!==+n?+t!==+t:0===+n?1/+n===1/t:+n===+t;case"[object Date]":case"[object Boolean]":return+n===+t}var i="[object Array]"===u;if(!i){if("object"!=typeof n||"object"!=typeof t)return!1;var o=n.constructor,a=t.constructor;if(o!==a&&!(m.isFunction(o)&&o instanceof o&&m.isFunction(a)&&a instanceof a)&&"constructor"in n&&"constructor"in t)return!1}r=r||[],e=e||[];for(var c=r.length;c--;)if(r[c]===n)return e[c]===t;if(r.push(n),e.push(t),i){if(c=n.length,c!==t.length)return!1;for(;c--;)if(!N(n[c],t[c],r,e))return!1}else{var f,l=m.keys(n);if(c=l.length,m.keys(t).length!==c)return!1;for(;c--;)if(f=l[c],!m.has(t,f)||!N(n[f],t[f],r,e))return!1}return r.pop(),e.pop(),!0};m.isEqual=function(n,t){return N(n,t)},m.isEmpty=function(n){return null==n?!0:k(n)&&(m.isArray(n)||m.isString(n)||m.isArguments(n))?0===n.length:0===m.keys(n).length},m.isElement=function(n){return!(!n||1!==n.nodeType)},m.isArray=h||function(n){return"[object Array]"===s.call(n)},m.isObject=function(n){var t=typeof n;return"function"===t||"object"===t&&!!n},m.each(["Arguments","Function","String","Number","Date","RegExp","Error"],function(n){m["is"+n]=function(t){return s.call(t)==="[object "+n+"]"}}),m.isArguments(arguments)||(m.isArguments=function(n){return m.has(n,"callee")}),"function"!=typeof/./&&"object"!=typeof Int8Array&&(m.isFunction=function(n){return"function"==typeof n||!1}),m.isFinite=function(n){return isFinite(n)&&!isNaN(parseFloat(n))},m.isNaN=function(n){return m.isNumber(n)&&n!==+n},m.isBoolean=function(n){return n===!0||n===!1||"[object Boolean]"===s.call(n)},m.isNull=function(n){return null===n},m.isUndefined=function(n){return n===void 0},m.has=function(n,t){return null!=n&&p.call(n,t)},m.noConflict=function(){return u._=i,this},m.identity=function(n){return n},m.constant=function(n){return function(){return n}},m.noop=function(){},m.property=w,m.propertyOf=function(n){return null==n?function(){}:function(t){return n[t]}},m.matcher=m.matches=function(n){return n=m.extendOwn({},n),function(t){return m.isMatch(t,n)}},m.times=function(n,t,r){var e=Array(Math.max(0,n));t=b(t,r,1);for(var u=0;n>u;u++)e[u]=t(u);return e},m.random=function(n,t){return null==t&&(t=n,n=0),n+Math.floor(Math.random()*(t-n+1))},m.now=Date.now||function(){return(new Date).getTime()};var B={"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#x27;","`":"&#x60;"},T=m.invert(B),R=function(n){var t=function(t){return n[t]},r="(?:"+m.keys(n).join("|")+")",e=RegExp(r),u=RegExp(r,"g");return function(n){return n=null==n?"":""+n,e.test(n)?n.replace(u,t):n}};m.escape=R(B),m.unescape=R(T),m.result=function(n,t,r){var e=null==n?void 0:n[t];return e===void 0&&(e=r),m.isFunction(e)?e.call(n):e};var q=0;m.uniqueId=function(n){var t=++q+"";return n?n+t:t},m.templateSettings={evaluate:/<%([\s\S]+?)%>/g,interpolate:/<%=([\s\S]+?)%>/g,escape:/<%-([\s\S]+?)%>/g};var K=/(.)^/,z={"'":"'","\\":"\\","\r":"r","\n":"n","\u2028":"u2028","\u2029":"u2029"},D=/\\|'|\r|\n|\u2028|\u2029/g,L=function(n){return"\\"+z[n]};m.template=function(n,t,r){!t&&r&&(t=r),t=m.defaults({},t,m.templateSettings);var e=RegExp([(t.escape||K).source,(t.interpolate||K).source,(t.evaluate||K).source].join("|")+"|$","g"),u=0,i="__p+='";n.replace(e,function(t,r,e,o,a){return i+=n.slice(u,a).replace(D,L),u=a+t.length,r?i+="'+\n((__t=("+r+"))==null?'':_.escape(__t))+\n'":e?i+="'+\n((__t=("+e+"))==null?'':__t)+\n'":o&&(i+="';\n"+o+"\n__p+='"),t}),i+="';\n",t.variable||(i="with(obj||{}){\n"+i+"}\n"),i="var __t,__p='',__j=Array.prototype.join,"+"print=function(){__p+=__j.call(arguments,'');};\n"+i+"return __p;\n";try{var o=new Function(t.variable||"obj","_",i)}catch(a){throw a.source=i,a}var c=function(n){return o.call(this,n,m)},f=t.variable||"obj";return c.source="function("+f+"){\n"+i+"}",c},m.chain=function(n){var t=m(n);return t._chain=!0,t};var P=function(n,t){return n._chain?m(t).chain():t};m.mixin=function(n){m.each(m.functions(n),function(t){var r=m[t]=n[t];m.prototype[t]=function(){var n=[this._wrapped];return f.apply(n,arguments),P(this,r.apply(m,n))}})},m.mixin(m),m.each(["pop","push","reverse","shift","sort","splice","unshift"],function(n){var t=o[n];m.prototype[n]=function(){var r=this._wrapped;return t.apply(r,arguments),"shift"!==n&&"splice"!==n||0!==r.length||delete r[0],P(this,r)}}),m.each(["concat","join","slice"],function(n){var t=o[n];m.prototype[n]=function(){return P(this,t.apply(this._wrapped,arguments))}}),m.prototype.value=function(){return this._wrapped},m.prototype.valueOf=m.prototype.toJSON=m.prototype.value,m.prototype.toString=function(){return""+this._wrapped},"function"==typeof define&&define.amd&&define("underscore",[],function(){return m})}).call(this);
//# sourceMappingURL=underscore-min.map;
//     Backbone.js 1.3.3

//     (c) 2010-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
//     Backbone may be freely distributed under the MIT license.
//     For all details and documentation:
//     http://backbonejs.org

(function(factory) {

  // Establish the root object, `window` (`self`) in the browser, or `global` on the server.
  // We use `self` instead of `window` for `WebWorker` support.
  var root = (typeof self == 'object' && self.self === self && self) ||
            (typeof global == 'object' && global.global === global && global);

  // Set up Backbone appropriately for the environment. Start with AMD.
  if (typeof define === 'function' && define.amd) {
    define('backbone',['underscore', 'jquery', 'exports'], function(_, $, exports) {
      // Export global even in AMD case in case this script is loaded with
      // others that may still expect a global Backbone.
      root.Backbone = factory(root, exports, _, $);
    });

  // Next for Node.js or CommonJS. jQuery may not be needed as a module.
  } else if (typeof exports !== 'undefined') {
    var _ = require('underscore'), $;
    try { $ = require('jquery'); } catch (e) {}
    factory(root, exports, _, $);

  // Finally, as a browser global.
  } else {
    root.Backbone = factory(root, {}, root._, (root.jQuery || root.Zepto || root.ender || root.$));
  }

})(function(root, Backbone, _, $) {

  // Initial Setup
  // -------------

  // Save the previous value of the `Backbone` variable, so that it can be
  // restored later on, if `noConflict` is used.
  var previousBackbone = root.Backbone;

  // Create a local reference to a common array method we'll want to use later.
  var slice = Array.prototype.slice;

  // Current version of the library. Keep in sync with `package.json`.
  Backbone.VERSION = '1.3.3';

  // For Backbone's purposes, jQuery, Zepto, Ender, or My Library (kidding) owns
  // the `$` variable.
  Backbone.$ = $;

  // Runs Backbone.js in *noConflict* mode, returning the `Backbone` variable
  // to its previous owner. Returns a reference to this Backbone object.
  Backbone.noConflict = function() {
    root.Backbone = previousBackbone;
    return this;
  };

  // Turn on `emulateHTTP` to support legacy HTTP servers. Setting this option
  // will fake `"PATCH"`, `"PUT"` and `"DELETE"` requests via the `_method` parameter and
  // set a `X-Http-Method-Override` header.
  Backbone.emulateHTTP = false;

  // Turn on `emulateJSON` to support legacy servers that can't deal with direct
  // `application/json` requests ... this will encode the body as
  // `application/x-www-form-urlencoded` instead and will send the model in a
  // form param named `model`.
  Backbone.emulateJSON = false;

  // Proxy Backbone class methods to Underscore functions, wrapping the model's
  // `attributes` object or collection's `models` array behind the scenes.
  //
  // collection.filter(function(model) { return model.get('age') > 10 });
  // collection.each(this.addView);
  //
  // `Function#apply` can be slow so we use the method's arg count, if we know it.
  var addMethod = function(length, method, attribute) {
    switch (length) {
      case 1: return function() {
        return _[method](this[attribute]);
      };
      case 2: return function(value) {
        return _[method](this[attribute], value);
      };
      case 3: return function(iteratee, context) {
        return _[method](this[attribute], cb(iteratee, this), context);
      };
      case 4: return function(iteratee, defaultVal, context) {
        return _[method](this[attribute], cb(iteratee, this), defaultVal, context);
      };
      default: return function() {
        var args = slice.call(arguments);
        args.unshift(this[attribute]);
        return _[method].apply(_, args);
      };
    }
  };
  var addUnderscoreMethods = function(Class, methods, attribute) {
    _.each(methods, function(length, method) {
      if (_[method]) Class.prototype[method] = addMethod(length, method, attribute);
    });
  };

  // Support `collection.sortBy('attr')` and `collection.findWhere({id: 1})`.
  var cb = function(iteratee, instance) {
    if (_.isFunction(iteratee)) return iteratee;
    if (_.isObject(iteratee) && !instance._isModel(iteratee)) return modelMatcher(iteratee);
    if (_.isString(iteratee)) return function(model) { return model.get(iteratee); };
    return iteratee;
  };
  var modelMatcher = function(attrs) {
    var matcher = _.matches(attrs);
    return function(model) {
      return matcher(model.attributes);
    };
  };

  // Backbone.Events
  // ---------------

  // A module that can be mixed in to *any object* in order to provide it with
  // a custom event channel. You may bind a callback to an event with `on` or
  // remove with `off`; `trigger`-ing an event fires all callbacks in
  // succession.
  //
  //     var object = {};
  //     _.extend(object, Backbone.Events);
  //     object.on('expand', function(){ alert('expanded'); });
  //     object.trigger('expand');
  //
  var Events = Backbone.Events = {};

  // Regular expression used to split event strings.
  var eventSplitter = /\s+/;

  // Iterates over the standard `event, callback` (as well as the fancy multiple
  // space-separated events `"change blur", callback` and jQuery-style event
  // maps `{event: callback}`).
  var eventsApi = function(iteratee, events, name, callback, opts) {
    var i = 0, names;
    if (name && typeof name === 'object') {
      // Handle event maps.
      if (callback !== void 0 && 'context' in opts && opts.context === void 0) opts.context = callback;
      for (names = _.keys(name); i < names.length ; i++) {
        events = eventsApi(iteratee, events, names[i], name[names[i]], opts);
      }
    } else if (name && eventSplitter.test(name)) {
      // Handle space-separated event names by delegating them individually.
      for (names = name.split(eventSplitter); i < names.length; i++) {
        events = iteratee(events, names[i], callback, opts);
      }
    } else {
      // Finally, standard events.
      events = iteratee(events, name, callback, opts);
    }
    return events;
  };

  // Bind an event to a `callback` function. Passing `"all"` will bind
  // the callback to all events fired.
  Events.on = function(name, callback, context) {
    return internalOn(this, name, callback, context);
  };

  // Guard the `listening` argument from the public API.
  var internalOn = function(obj, name, callback, context, listening) {
    obj._events = eventsApi(onApi, obj._events || {}, name, callback, {
      context: context,
      ctx: obj,
      listening: listening
    });

    if (listening) {
      var listeners = obj._listeners || (obj._listeners = {});
      listeners[listening.id] = listening;
    }

    return obj;
  };

  // Inversion-of-control versions of `on`. Tell *this* object to listen to
  // an event in another object... keeping track of what it's listening to
  // for easier unbinding later.
  Events.listenTo = function(obj, name, callback) {
    if (!obj) return this;
    var id = obj._listenId || (obj._listenId = _.uniqueId('l'));
    var listeningTo = this._listeningTo || (this._listeningTo = {});
    var listening = listeningTo[id];

    // This object is not listening to any other events on `obj` yet.
    // Setup the necessary references to track the listening callbacks.
    if (!listening) {
      var thisId = this._listenId || (this._listenId = _.uniqueId('l'));
      listening = listeningTo[id] = {obj: obj, objId: id, id: thisId, listeningTo: listeningTo, count: 0};
    }

    // Bind callbacks on obj, and keep track of them on listening.
    internalOn(obj, name, callback, this, listening);
    return this;
  };

  // The reducing API that adds a callback to the `events` object.
  var onApi = function(events, name, callback, options) {
    if (callback) {
      var handlers = events[name] || (events[name] = []);
      var context = options.context, ctx = options.ctx, listening = options.listening;
      if (listening) listening.count++;

      handlers.push({callback: callback, context: context, ctx: context || ctx, listening: listening});
    }
    return events;
  };

  // Remove one or many callbacks. If `context` is null, removes all
  // callbacks with that function. If `callback` is null, removes all
  // callbacks for the event. If `name` is null, removes all bound
  // callbacks for all events.
  Events.off = function(name, callback, context) {
    if (!this._events) return this;
    this._events = eventsApi(offApi, this._events, name, callback, {
      context: context,
      listeners: this._listeners
    });
    return this;
  };

  // Tell this object to stop listening to either specific events ... or
  // to every object it's currently listening to.
  Events.stopListening = function(obj, name, callback) {
    var listeningTo = this._listeningTo;
    if (!listeningTo) return this;

    var ids = obj ? [obj._listenId] : _.keys(listeningTo);

    for (var i = 0; i < ids.length; i++) {
      var listening = listeningTo[ids[i]];

      // If listening doesn't exist, this object is not currently
      // listening to obj. Break out early.
      if (!listening) break;

      listening.obj.off(name, callback, this);
    }

    return this;
  };

  // The reducing API that removes a callback from the `events` object.
  var offApi = function(events, name, callback, options) {
    if (!events) return;

    var i = 0, listening;
    var context = options.context, listeners = options.listeners;

    // Delete all events listeners and "drop" events.
    if (!name && !callback && !context) {
      var ids = _.keys(listeners);
      for (; i < ids.length; i++) {
        listening = listeners[ids[i]];
        delete listeners[listening.id];
        delete listening.listeningTo[listening.objId];
      }
      return;
    }

    var names = name ? [name] : _.keys(events);
    for (; i < names.length; i++) {
      name = names[i];
      var handlers = events[name];

      // Bail out if there are no events stored.
      if (!handlers) break;

      // Replace events if there are any remaining.  Otherwise, clean up.
      var remaining = [];
      for (var j = 0; j < handlers.length; j++) {
        var handler = handlers[j];
        if (
          callback && callback !== handler.callback &&
            callback !== handler.callback._callback ||
              context && context !== handler.context
        ) {
          remaining.push(handler);
        } else {
          listening = handler.listening;
          if (listening && --listening.count === 0) {
            delete listeners[listening.id];
            delete listening.listeningTo[listening.objId];
          }
        }
      }

      // Update tail event if the list has any events.  Otherwise, clean up.
      if (remaining.length) {
        events[name] = remaining;
      } else {
        delete events[name];
      }
    }
    return events;
  };

  // Bind an event to only be triggered a single time. After the first time
  // the callback is invoked, its listener will be removed. If multiple events
  // are passed in using the space-separated syntax, the handler will fire
  // once for each event, not once for a combination of all events.
  Events.once = function(name, callback, context) {
    // Map the event into a `{event: once}` object.
    var events = eventsApi(onceMap, {}, name, callback, _.bind(this.off, this));
    if (typeof name === 'string' && context == null) callback = void 0;
    return this.on(events, callback, context);
  };

  // Inversion-of-control versions of `once`.
  Events.listenToOnce = function(obj, name, callback) {
    // Map the event into a `{event: once}` object.
    var events = eventsApi(onceMap, {}, name, callback, _.bind(this.stopListening, this, obj));
    return this.listenTo(obj, events);
  };

  // Reduces the event callbacks into a map of `{event: onceWrapper}`.
  // `offer` unbinds the `onceWrapper` after it has been called.
  var onceMap = function(map, name, callback, offer) {
    if (callback) {
      var once = map[name] = _.once(function() {
        offer(name, once);
        callback.apply(this, arguments);
      });
      once._callback = callback;
    }
    return map;
  };

  // Trigger one or many events, firing all bound callbacks. Callbacks are
  // passed the same arguments as `trigger` is, apart from the event name
  // (unless you're listening on `"all"`, which will cause your callback to
  // receive the true name of the event as the first argument).
  Events.trigger = function(name) {
    if (!this._events) return this;

    var length = Math.max(0, arguments.length - 1);
    var args = Array(length);
    for (var i = 0; i < length; i++) args[i] = arguments[i + 1];

    eventsApi(triggerApi, this._events, name, void 0, args);
    return this;
  };

  // Handles triggering the appropriate event callbacks.
  var triggerApi = function(objEvents, name, callback, args) {
    if (objEvents) {
      var events = objEvents[name];
      var allEvents = objEvents.all;
      if (events && allEvents) allEvents = allEvents.slice();
      if (events) triggerEvents(events, args);
      if (allEvents) triggerEvents(allEvents, [name].concat(args));
    }
    return objEvents;
  };

  // A difficult-to-believe, but optimized internal dispatch function for
  // triggering events. Tries to keep the usual cases speedy (most internal
  // Backbone events have 3 arguments).
  var triggerEvents = function(events, args) {
    var ev, i = -1, l = events.length, a1 = args[0], a2 = args[1], a3 = args[2];
    switch (args.length) {
      case 0: while (++i < l) (ev = events[i]).callback.call(ev.ctx); return;
      case 1: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1); return;
      case 2: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2); return;
      case 3: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2, a3); return;
      default: while (++i < l) (ev = events[i]).callback.apply(ev.ctx, args); return;
    }
  };

  // Aliases for backwards compatibility.
  Events.bind   = Events.on;
  Events.unbind = Events.off;

  // Allow the `Backbone` object to serve as a global event bus, for folks who
  // want global "pubsub" in a convenient place.
  _.extend(Backbone, Events);

  // Backbone.Model
  // --------------

  // Backbone **Models** are the basic data object in the framework --
  // frequently representing a row in a table in a database on your server.
  // A discrete chunk of data and a bunch of useful, related methods for
  // performing computations and transformations on that data.

  // Create a new model with the specified attributes. A client id (`cid`)
  // is automatically generated and assigned for you.
  var Model = Backbone.Model = function(attributes, options) {
    var attrs = attributes || {};
    options || (options = {});
    this.cid = _.uniqueId(this.cidPrefix);
    this.attributes = {};
    if (options.collection) this.collection = options.collection;
    if (options.parse) attrs = this.parse(attrs, options) || {};
    var defaults = _.result(this, 'defaults');
    attrs = _.defaults(_.extend({}, defaults, attrs), defaults);
    this.set(attrs, options);
    this.changed = {};
    this.initialize.apply(this, arguments);
  };

  // Attach all inheritable methods to the Model prototype.
  _.extend(Model.prototype, Events, {

    // A hash of attributes whose current and previous value differ.
    changed: null,

    // The value returned during the last failed validation.
    validationError: null,

    // The default name for the JSON `id` attribute is `"id"`. MongoDB and
    // CouchDB users may want to set this to `"_id"`.
    idAttribute: 'id',

    // The prefix is used to create the client id which is used to identify models locally.
    // You may want to override this if you're experiencing name clashes with model ids.
    cidPrefix: 'c',

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // Return a copy of the model's `attributes` object.
    toJSON: function(options) {
      return _.clone(this.attributes);
    },

    // Proxy `Backbone.sync` by default -- but override this if you need
    // custom syncing semantics for *this* particular model.
    sync: function() {
      return Backbone.sync.apply(this, arguments);
    },

    // Get the value of an attribute.
    get: function(attr) {
      return this.attributes[attr];
    },

    // Get the HTML-escaped value of an attribute.
    escape: function(attr) {
      return _.escape(this.get(attr));
    },

    // Returns `true` if the attribute contains a value that is not null
    // or undefined.
    has: function(attr) {
      return this.get(attr) != null;
    },

    // Special-cased proxy to underscore's `_.matches` method.
    matches: function(attrs) {
      return !!_.iteratee(attrs, this)(this.attributes);
    },

    // Set a hash of model attributes on the object, firing `"change"`. This is
    // the core primitive operation of a model, updating the data and notifying
    // anyone who needs to know about the change in state. The heart of the beast.
    set: function(key, val, options) {
      if (key == null) return this;

      // Handle both `"key", value` and `{key: value}` -style arguments.
      var attrs;
      if (typeof key === 'object') {
        attrs = key;
        options = val;
      } else {
        (attrs = {})[key] = val;
      }

      options || (options = {});

      // Run validation.
      if (!this._validate(attrs, options)) return false;

      // Extract attributes and options.
      var unset      = options.unset;
      var silent     = options.silent;
      var changes    = [];
      var changing   = this._changing;
      this._changing = true;

      if (!changing) {
        this._previousAttributes = _.clone(this.attributes);
        this.changed = {};
      }

      var current = this.attributes;
      var changed = this.changed;
      var prev    = this._previousAttributes;

      // For each `set` attribute, update or delete the current value.
      for (var attr in attrs) {
        val = attrs[attr];
        if (!_.isEqual(current[attr], val)) changes.push(attr);
        if (!_.isEqual(prev[attr], val)) {
          changed[attr] = val;
        } else {
          delete changed[attr];
        }
        unset ? delete current[attr] : current[attr] = val;
      }

      // Update the `id`.
      if (this.idAttribute in attrs) this.id = this.get(this.idAttribute);

      // Trigger all relevant attribute changes.
      if (!silent) {
        if (changes.length) this._pending = options;
        for (var i = 0; i < changes.length; i++) {
          this.trigger('change:' + changes[i], this, current[changes[i]], options);
        }
      }

      // You might be wondering why there's a `while` loop here. Changes can
      // be recursively nested within `"change"` events.
      if (changing) return this;
      if (!silent) {
        while (this._pending) {
          options = this._pending;
          this._pending = false;
          this.trigger('change', this, options);
        }
      }
      this._pending = false;
      this._changing = false;
      return this;
    },

    // Remove an attribute from the model, firing `"change"`. `unset` is a noop
    // if the attribute doesn't exist.
    unset: function(attr, options) {
      return this.set(attr, void 0, _.extend({}, options, {unset: true}));
    },

    // Clear all attributes on the model, firing `"change"`.
    clear: function(options) {
      var attrs = {};
      for (var key in this.attributes) attrs[key] = void 0;
      return this.set(attrs, _.extend({}, options, {unset: true}));
    },

    // Determine if the model has changed since the last `"change"` event.
    // If you specify an attribute name, determine if that attribute has changed.
    hasChanged: function(attr) {
      if (attr == null) return !_.isEmpty(this.changed);
      return _.has(this.changed, attr);
    },

    // Return an object containing all the attributes that have changed, or
    // false if there are no changed attributes. Useful for determining what
    // parts of a view need to be updated and/or what attributes need to be
    // persisted to the server. Unset attributes will be set to undefined.
    // You can also pass an attributes object to diff against the model,
    // determining if there *would be* a change.
    changedAttributes: function(diff) {
      if (!diff) return this.hasChanged() ? _.clone(this.changed) : false;
      var old = this._changing ? this._previousAttributes : this.attributes;
      var changed = {};
      for (var attr in diff) {
        var val = diff[attr];
        if (_.isEqual(old[attr], val)) continue;
        changed[attr] = val;
      }
      return _.size(changed) ? changed : false;
    },

    // Get the previous value of an attribute, recorded at the time the last
    // `"change"` event was fired.
    previous: function(attr) {
      if (attr == null || !this._previousAttributes) return null;
      return this._previousAttributes[attr];
    },

    // Get all of the attributes of the model at the time of the previous
    // `"change"` event.
    previousAttributes: function() {
      return _.clone(this._previousAttributes);
    },

    // Fetch the model from the server, merging the response with the model's
    // local attributes. Any changed attributes will trigger a "change" event.
    fetch: function(options) {
      options = _.extend({parse: true}, options);
      var model = this;
      var success = options.success;
      options.success = function(resp) {
        var serverAttrs = options.parse ? model.parse(resp, options) : resp;
        if (!model.set(serverAttrs, options)) return false;
        if (success) success.call(options.context, model, resp, options);
        model.trigger('sync', model, resp, options);
      };
      wrapError(this, options);
      return this.sync('read', this, options);
    },

    // Set a hash of model attributes, and sync the model to the server.
    // If the server returns an attributes hash that differs, the model's
    // state will be `set` again.
    save: function(key, val, options) {
      // Handle both `"key", value` and `{key: value}` -style arguments.
      var attrs;
      if (key == null || typeof key === 'object') {
        attrs = key;
        options = val;
      } else {
        (attrs = {})[key] = val;
      }

      options = _.extend({validate: true, parse: true}, options);
      var wait = options.wait;

      // If we're not waiting and attributes exist, save acts as
      // `set(attr).save(null, opts)` with validation. Otherwise, check if
      // the model will be valid when the attributes, if any, are set.
      if (attrs && !wait) {
        if (!this.set(attrs, options)) return false;
      } else if (!this._validate(attrs, options)) {
        return false;
      }

      // After a successful server-side save, the client is (optionally)
      // updated with the server-side state.
      var model = this;
      var success = options.success;
      var attributes = this.attributes;
      options.success = function(resp) {
        // Ensure attributes are restored during synchronous saves.
        model.attributes = attributes;
        var serverAttrs = options.parse ? model.parse(resp, options) : resp;
        if (wait) serverAttrs = _.extend({}, attrs, serverAttrs);
        if (serverAttrs && !model.set(serverAttrs, options)) return false;
        if (success) success.call(options.context, model, resp, options);
        model.trigger('sync', model, resp, options);
      };
      wrapError(this, options);

      // Set temporary attributes if `{wait: true}` to properly find new ids.
      if (attrs && wait) this.attributes = _.extend({}, attributes, attrs);

      var method = this.isNew() ? 'create' : (options.patch ? 'patch' : 'update');
      if (method === 'patch' && !options.attrs) options.attrs = attrs;
      var xhr = this.sync(method, this, options);

      // Restore attributes.
      this.attributes = attributes;

      return xhr;
    },

    // Destroy this model on the server if it was already persisted.
    // Optimistically removes the model from its collection, if it has one.
    // If `wait: true` is passed, waits for the server to respond before removal.
    destroy: function(options) {
      options = options ? _.clone(options) : {};
      var model = this;
      var success = options.success;
      var wait = options.wait;

      var destroy = function() {
        model.stopListening();
        model.trigger('destroy', model, model.collection, options);
      };

      options.success = function(resp) {
        if (wait) destroy();
        if (success) success.call(options.context, model, resp, options);
        if (!model.isNew()) model.trigger('sync', model, resp, options);
      };

      var xhr = false;
      if (this.isNew()) {
        _.defer(options.success);
      } else {
        wrapError(this, options);
        xhr = this.sync('delete', this, options);
      }
      if (!wait) destroy();
      return xhr;
    },

    // Default URL for the model's representation on the server -- if you're
    // using Backbone's restful methods, override this to change the endpoint
    // that will be called.
    url: function() {
      var base =
        _.result(this, 'urlRoot') ||
        _.result(this.collection, 'url') ||
        urlError();
      if (this.isNew()) return base;
      var id = this.get(this.idAttribute);
      return base.replace(/[^\/]$/, '$&/') + encodeURIComponent(id);
    },

    // **parse** converts a response into the hash of attributes to be `set` on
    // the model. The default implementation is just to pass the response along.
    parse: function(resp, options) {
      return resp;
    },

    // Create a new model with identical attributes to this one.
    clone: function() {
      return new this.constructor(this.attributes);
    },

    // A model is new if it has never been saved to the server, and lacks an id.
    isNew: function() {
      return !this.has(this.idAttribute);
    },

    // Check if the model is currently in a valid state.
    isValid: function(options) {
      return this._validate({}, _.extend({}, options, {validate: true}));
    },

    // Run validation against the next complete set of model attributes,
    // returning `true` if all is well. Otherwise, fire an `"invalid"` event.
    _validate: function(attrs, options) {
      if (!options.validate || !this.validate) return true;
      attrs = _.extend({}, this.attributes, attrs);
      var error = this.validationError = this.validate(attrs, options) || null;
      if (!error) return true;
      this.trigger('invalid', this, error, _.extend(options, {validationError: error}));
      return false;
    }

  });

  // Underscore methods that we want to implement on the Model, mapped to the
  // number of arguments they take.
  var modelMethods = {keys: 1, values: 1, pairs: 1, invert: 1, pick: 0,
      omit: 0, chain: 1, isEmpty: 1};

  // Mix in each Underscore method as a proxy to `Model#attributes`.
  addUnderscoreMethods(Model, modelMethods, 'attributes');

  // Backbone.Collection
  // -------------------

  // If models tend to represent a single row of data, a Backbone Collection is
  // more analogous to a table full of data ... or a small slice or page of that
  // table, or a collection of rows that belong together for a particular reason
  // -- all of the messages in this particular folder, all of the documents
  // belonging to this particular author, and so on. Collections maintain
  // indexes of their models, both in order, and for lookup by `id`.

  // Create a new **Collection**, perhaps to contain a specific type of `model`.
  // If a `comparator` is specified, the Collection will maintain
  // its models in sort order, as they're added and removed.
  var Collection = Backbone.Collection = function(models, options) {
    options || (options = {});
    if (options.model) this.model = options.model;
    if (options.comparator !== void 0) this.comparator = options.comparator;
    this._reset();
    this.initialize.apply(this, arguments);
    if (models) this.reset(models, _.extend({silent: true}, options));
  };

  // Default options for `Collection#set`.
  var setOptions = {add: true, remove: true, merge: true};
  var addOptions = {add: true, remove: false};

  // Splices `insert` into `array` at index `at`.
  var splice = function(array, insert, at) {
    at = Math.min(Math.max(at, 0), array.length);
    var tail = Array(array.length - at);
    var length = insert.length;
    var i;
    for (i = 0; i < tail.length; i++) tail[i] = array[i + at];
    for (i = 0; i < length; i++) array[i + at] = insert[i];
    for (i = 0; i < tail.length; i++) array[i + length + at] = tail[i];
  };

  // Define the Collection's inheritable methods.
  _.extend(Collection.prototype, Events, {

    // The default model for a collection is just a **Backbone.Model**.
    // This should be overridden in most cases.
    model: Model,

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // The JSON representation of a Collection is an array of the
    // models' attributes.
    toJSON: function(options) {
      return this.map(function(model) { return model.toJSON(options); });
    },

    // Proxy `Backbone.sync` by default.
    sync: function() {
      return Backbone.sync.apply(this, arguments);
    },

    // Add a model, or list of models to the set. `models` may be Backbone
    // Models or raw JavaScript objects to be converted to Models, or any
    // combination of the two.
    add: function(models, options) {
      return this.set(models, _.extend({merge: false}, options, addOptions));
    },

    // Remove a model, or a list of models from the set.
    remove: function(models, options) {
      options = _.extend({}, options);
      var singular = !_.isArray(models);
      models = singular ? [models] : models.slice();
      var removed = this._removeModels(models, options);
      if (!options.silent && removed.length) {
        options.changes = {added: [], merged: [], removed: removed};
        this.trigger('update', this, options);
      }
      return singular ? removed[0] : removed;
    },

    // Update a collection by `set`-ing a new list of models, adding new ones,
    // removing models that are no longer present, and merging models that
    // already exist in the collection, as necessary. Similar to **Model#set**,
    // the core operation for updating the data contained by the collection.
    set: function(models, options) {
      if (models == null) return;

      options = _.extend({}, setOptions, options);
      if (options.parse && !this._isModel(models)) {
        models = this.parse(models, options) || [];
      }

      var singular = !_.isArray(models);
      models = singular ? [models] : models.slice();

      var at = options.at;
      if (at != null) at = +at;
      if (at > this.length) at = this.length;
      if (at < 0) at += this.length + 1;

      var set = [];
      var toAdd = [];
      var toMerge = [];
      var toRemove = [];
      var modelMap = {};

      var add = options.add;
      var merge = options.merge;
      var remove = options.remove;

      var sort = false;
      var sortable = this.comparator && at == null && options.sort !== false;
      var sortAttr = _.isString(this.comparator) ? this.comparator : null;

      // Turn bare objects into model references, and prevent invalid models
      // from being added.
      var model, i;
      for (i = 0; i < models.length; i++) {
        model = models[i];

        // If a duplicate is found, prevent it from being added and
        // optionally merge it into the existing model.
        var existing = this.get(model);
        if (existing) {
          if (merge && model !== existing) {
            var attrs = this._isModel(model) ? model.attributes : model;
            if (options.parse) attrs = existing.parse(attrs, options);
            existing.set(attrs, options);
            toMerge.push(existing);
            if (sortable && !sort) sort = existing.hasChanged(sortAttr);
          }
          if (!modelMap[existing.cid]) {
            modelMap[existing.cid] = true;
            set.push(existing);
          }
          models[i] = existing;

        // If this is a new, valid model, push it to the `toAdd` list.
        } else if (add) {
          model = models[i] = this._prepareModel(model, options);
          if (model) {
            toAdd.push(model);
            this._addReference(model, options);
            modelMap[model.cid] = true;
            set.push(model);
          }
        }
      }

      // Remove stale models.
      if (remove) {
        for (i = 0; i < this.length; i++) {
          model = this.models[i];
          if (!modelMap[model.cid]) toRemove.push(model);
        }
        if (toRemove.length) this._removeModels(toRemove, options);
      }

      // See if sorting is needed, update `length` and splice in new models.
      var orderChanged = false;
      var replace = !sortable && add && remove;
      if (set.length && replace) {
        orderChanged = this.length !== set.length || _.some(this.models, function(m, index) {
          return m !== set[index];
        });
        this.models.length = 0;
        splice(this.models, set, 0);
        this.length = this.models.length;
      } else if (toAdd.length) {
        if (sortable) sort = true;
        splice(this.models, toAdd, at == null ? this.length : at);
        this.length = this.models.length;
      }

      // Silently sort the collection if appropriate.
      if (sort) this.sort({silent: true});

      // Unless silenced, it's time to fire all appropriate add/sort/update events.
      if (!options.silent) {
        for (i = 0; i < toAdd.length; i++) {
          if (at != null) options.index = at + i;
          model = toAdd[i];
          model.trigger('add', model, this, options);
        }
        if (sort || orderChanged) this.trigger('sort', this, options);
        if (toAdd.length || toRemove.length || toMerge.length) {
          options.changes = {
            added: toAdd,
            removed: toRemove,
            merged: toMerge
          };
          this.trigger('update', this, options);
        }
      }

      // Return the added (or merged) model (or models).
      return singular ? models[0] : models;
    },

    // When you have more items than you want to add or remove individually,
    // you can reset the entire set with a new list of models, without firing
    // any granular `add` or `remove` events. Fires `reset` when finished.
    // Useful for bulk operations and optimizations.
    reset: function(models, options) {
      options = options ? _.clone(options) : {};
      for (var i = 0; i < this.models.length; i++) {
        this._removeReference(this.models[i], options);
      }
      options.previousModels = this.models;
      this._reset();
      models = this.add(models, _.extend({silent: true}, options));
      if (!options.silent) this.trigger('reset', this, options);
      return models;
    },

    // Add a model to the end of the collection.
    push: function(model, options) {
      return this.add(model, _.extend({at: this.length}, options));
    },

    // Remove a model from the end of the collection.
    pop: function(options) {
      var model = this.at(this.length - 1);
      return this.remove(model, options);
    },

    // Add a model to the beginning of the collection.
    unshift: function(model, options) {
      return this.add(model, _.extend({at: 0}, options));
    },

    // Remove a model from the beginning of the collection.
    shift: function(options) {
      var model = this.at(0);
      return this.remove(model, options);
    },

    // Slice out a sub-array of models from the collection.
    slice: function() {
      return slice.apply(this.models, arguments);
    },

    // Get a model from the set by id, cid, model object with id or cid
    // properties, or an attributes object that is transformed through modelId.
    get: function(obj) {
      if (obj == null) return void 0;
      return this._byId[obj] ||
        this._byId[this.modelId(obj.attributes || obj)] ||
        obj.cid && this._byId[obj.cid];
    },

    // Returns `true` if the model is in the collection.
    has: function(obj) {
      return this.get(obj) != null;
    },

    // Get the model at the given index.
    at: function(index) {
      if (index < 0) index += this.length;
      return this.models[index];
    },

    // Return models with matching attributes. Useful for simple cases of
    // `filter`.
    where: function(attrs, first) {
      return this[first ? 'find' : 'filter'](attrs);
    },

    // Return the first model with matching attributes. Useful for simple cases
    // of `find`.
    findWhere: function(attrs) {
      return this.where(attrs, true);
    },

    // Force the collection to re-sort itself. You don't need to call this under
    // normal circumstances, as the set will maintain sort order as each item
    // is added.
    sort: function(options) {
      var comparator = this.comparator;
      if (!comparator) throw new Error('Cannot sort a set without a comparator');
      options || (options = {});

      var length = comparator.length;
      if (_.isFunction(comparator)) comparator = _.bind(comparator, this);

      // Run sort based on type of `comparator`.
      if (length === 1 || _.isString(comparator)) {
        this.models = this.sortBy(comparator);
      } else {
        this.models.sort(comparator);
      }
      if (!options.silent) this.trigger('sort', this, options);
      return this;
    },

    // Pluck an attribute from each model in the collection.
    pluck: function(attr) {
      return this.map(attr + '');
    },

    // Fetch the default set of models for this collection, resetting the
    // collection when they arrive. If `reset: true` is passed, the response
    // data will be passed through the `reset` method instead of `set`.
    fetch: function(options) {
      options = _.extend({parse: true}, options);
      var success = options.success;
      var collection = this;
      options.success = function(resp) {
        var method = options.reset ? 'reset' : 'set';
        collection[method](resp, options);
        if (success) success.call(options.context, collection, resp, options);
        collection.trigger('sync', collection, resp, options);
      };
      wrapError(this, options);
      return this.sync('read', this, options);
    },

    // Create a new instance of a model in this collection. Add the model to the
    // collection immediately, unless `wait: true` is passed, in which case we
    // wait for the server to agree.
    create: function(model, options) {
      options = options ? _.clone(options) : {};
      var wait = options.wait;
      model = this._prepareModel(model, options);
      if (!model) return false;
      if (!wait) this.add(model, options);
      var collection = this;
      var success = options.success;
      options.success = function(m, resp, callbackOpts) {
        if (wait) collection.add(m, callbackOpts);
        if (success) success.call(callbackOpts.context, m, resp, callbackOpts);
      };
      model.save(null, options);
      return model;
    },

    // **parse** converts a response into a list of models to be added to the
    // collection. The default implementation is just to pass it through.
    parse: function(resp, options) {
      return resp;
    },

    // Create a new collection with an identical list of models as this one.
    clone: function() {
      return new this.constructor(this.models, {
        model: this.model,
        comparator: this.comparator
      });
    },

    // Define how to uniquely identify models in the collection.
    modelId: function(attrs) {
      return attrs[this.model.prototype.idAttribute || 'id'];
    },

    // Private method to reset all internal state. Called when the collection
    // is first initialized or reset.
    _reset: function() {
      this.length = 0;
      this.models = [];
      this._byId  = {};
    },

    // Prepare a hash of attributes (or other model) to be added to this
    // collection.
    _prepareModel: function(attrs, options) {
      if (this._isModel(attrs)) {
        if (!attrs.collection) attrs.collection = this;
        return attrs;
      }
      options = options ? _.clone(options) : {};
      options.collection = this;
      var model = new this.model(attrs, options);
      if (!model.validationError) return model;
      this.trigger('invalid', this, model.validationError, options);
      return false;
    },

    // Internal method called by both remove and set.
    _removeModels: function(models, options) {
      var removed = [];
      for (var i = 0; i < models.length; i++) {
        var model = this.get(models[i]);
        if (!model) continue;

        var index = this.indexOf(model);
        this.models.splice(index, 1);
        this.length--;

        // Remove references before triggering 'remove' event to prevent an
        // infinite loop. #3693
        delete this._byId[model.cid];
        var id = this.modelId(model.attributes);
        if (id != null) delete this._byId[id];

        if (!options.silent) {
          options.index = index;
          model.trigger('remove', model, this, options);
        }

        removed.push(model);
        this._removeReference(model, options);
      }
      return removed;
    },

    // Method for checking whether an object should be considered a model for
    // the purposes of adding to the collection.
    _isModel: function(model) {
      return model instanceof Model;
    },

    // Internal method to create a model's ties to a collection.
    _addReference: function(model, options) {
      this._byId[model.cid] = model;
      var id = this.modelId(model.attributes);
      if (id != null) this._byId[id] = model;
      model.on('all', this._onModelEvent, this);
    },

    // Internal method to sever a model's ties to a collection.
    _removeReference: function(model, options) {
      delete this._byId[model.cid];
      var id = this.modelId(model.attributes);
      if (id != null) delete this._byId[id];
      if (this === model.collection) delete model.collection;
      model.off('all', this._onModelEvent, this);
    },

    // Internal method called every time a model in the set fires an event.
    // Sets need to update their indexes when models change ids. All other
    // events simply proxy through. "add" and "remove" events that originate
    // in other collections are ignored.
    _onModelEvent: function(event, model, collection, options) {
      if (model) {
        if ((event === 'add' || event === 'remove') && collection !== this) return;
        if (event === 'destroy') this.remove(model, options);
        if (event === 'change') {
          var prevId = this.modelId(model.previousAttributes());
          var id = this.modelId(model.attributes);
          if (prevId !== id) {
            if (prevId != null) delete this._byId[prevId];
            if (id != null) this._byId[id] = model;
          }
        }
      }
      this.trigger.apply(this, arguments);
    }

  });

  // Underscore methods that we want to implement on the Collection.
  // 90% of the core usefulness of Backbone Collections is actually implemented
  // right here:
  var collectionMethods = {forEach: 3, each: 3, map: 3, collect: 3, reduce: 0,
      foldl: 0, inject: 0, reduceRight: 0, foldr: 0, find: 3, detect: 3, filter: 3,
      select: 3, reject: 3, every: 3, all: 3, some: 3, any: 3, include: 3, includes: 3,
      contains: 3, invoke: 0, max: 3, min: 3, toArray: 1, size: 1, first: 3,
      head: 3, take: 3, initial: 3, rest: 3, tail: 3, drop: 3, last: 3,
      without: 0, difference: 0, indexOf: 3, shuffle: 1, lastIndexOf: 3,
      isEmpty: 1, chain: 1, sample: 3, partition: 3, groupBy: 3, countBy: 3,
      sortBy: 3, indexBy: 3, findIndex: 3, findLastIndex: 3};

  // Mix in each Underscore method as a proxy to `Collection#models`.
  addUnderscoreMethods(Collection, collectionMethods, 'models');

  // Backbone.View
  // -------------

  // Backbone Views are almost more convention than they are actual code. A View
  // is simply a JavaScript object that represents a logical chunk of UI in the
  // DOM. This might be a single item, an entire list, a sidebar or panel, or
  // even the surrounding frame which wraps your whole app. Defining a chunk of
  // UI as a **View** allows you to define your DOM events declaratively, without
  // having to worry about render order ... and makes it easy for the view to
  // react to specific changes in the state of your models.

  // Creating a Backbone.View creates its initial element outside of the DOM,
  // if an existing element is not provided...
  var View = Backbone.View = function(options) {
    this.cid = _.uniqueId('view');
    _.extend(this, _.pick(options, viewOptions));
    this._ensureElement();
    this.initialize.apply(this, arguments);
  };

  // Cached regex to split keys for `delegate`.
  var delegateEventSplitter = /^(\S+)\s*(.*)$/;

  // List of view options to be set as properties.
  var viewOptions = ['model', 'collection', 'el', 'id', 'attributes', 'className', 'tagName', 'events'];

  // Set up all inheritable **Backbone.View** properties and methods.
  _.extend(View.prototype, Events, {

    // The default `tagName` of a View's element is `"div"`.
    tagName: 'div',

    // jQuery delegate for element lookup, scoped to DOM elements within the
    // current view. This should be preferred to global lookups where possible.
    $: function(selector) {
      return this.$el.find(selector);
    },

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // **render** is the core function that your view should override, in order
    // to populate its element (`this.el`), with the appropriate HTML. The
    // convention is for **render** to always return `this`.
    render: function() {
      return this;
    },

    // Remove this view by taking the element out of the DOM, and removing any
    // applicable Backbone.Events listeners.
    remove: function() {
      this._removeElement();
      this.stopListening();
      return this;
    },

    // Remove this view's element from the document and all event listeners
    // attached to it. Exposed for subclasses using an alternative DOM
    // manipulation API.
    _removeElement: function() {
      this.$el.remove();
    },

    // Change the view's element (`this.el` property) and re-delegate the
    // view's events on the new element.
    setElement: function(element) {
      this.undelegateEvents();
      this._setElement(element);
      this.delegateEvents();
      return this;
    },

    // Creates the `this.el` and `this.$el` references for this view using the
    // given `el`. `el` can be a CSS selector or an HTML string, a jQuery
    // context or an element. Subclasses can override this to utilize an
    // alternative DOM manipulation API and are only required to set the
    // `this.el` property.
    _setElement: function(el) {
      this.$el = el instanceof Backbone.$ ? el : Backbone.$(el);
      this.el = this.$el[0];
    },

    // Set callbacks, where `this.events` is a hash of
    //
    // *{"event selector": "callback"}*
    //
    //     {
    //       'mousedown .title':  'edit',
    //       'click .button':     'save',
    //       'click .open':       function(e) { ... }
    //     }
    //
    // pairs. Callbacks will be bound to the view, with `this` set properly.
    // Uses event delegation for efficiency.
    // Omitting the selector binds the event to `this.el`.
    delegateEvents: function(events) {
      events || (events = _.result(this, 'events'));
      if (!events) return this;
      this.undelegateEvents();
      for (var key in events) {
        var method = events[key];
        if (!_.isFunction(method)) method = this[method];
        if (!method) continue;
        var match = key.match(delegateEventSplitter);
        this.delegate(match[1], match[2], _.bind(method, this));
      }
      return this;
    },

    // Add a single event listener to the view's element (or a child element
    // using `selector`). This only works for delegate-able events: not `focus`,
    // `blur`, and not `change`, `submit`, and `reset` in Internet Explorer.
    delegate: function(eventName, selector, listener) {
      this.$el.on(eventName + '.delegateEvents' + this.cid, selector, listener);
      return this;
    },

    // Clears all callbacks previously bound to the view by `delegateEvents`.
    // You usually don't need to use this, but may wish to if you have multiple
    // Backbone views attached to the same DOM element.
    undelegateEvents: function() {
      if (this.$el) this.$el.off('.delegateEvents' + this.cid);
      return this;
    },

    // A finer-grained `undelegateEvents` for removing a single delegated event.
    // `selector` and `listener` are both optional.
    undelegate: function(eventName, selector, listener) {
      this.$el.off(eventName + '.delegateEvents' + this.cid, selector, listener);
      return this;
    },

    // Produces a DOM element to be assigned to your view. Exposed for
    // subclasses using an alternative DOM manipulation API.
    _createElement: function(tagName) {
      return document.createElement(tagName);
    },

    // Ensure that the View has a DOM element to render into.
    // If `this.el` is a string, pass it through `$()`, take the first
    // matching element, and re-assign it to `el`. Otherwise, create
    // an element from the `id`, `className` and `tagName` properties.
    _ensureElement: function() {
      if (!this.el) {
        var attrs = _.extend({}, _.result(this, 'attributes'));
        if (this.id) attrs.id = _.result(this, 'id');
        if (this.className) attrs['class'] = _.result(this, 'className');
        this.setElement(this._createElement(_.result(this, 'tagName')));
        this._setAttributes(attrs);
      } else {
        this.setElement(_.result(this, 'el'));
      }
    },

    // Set attributes from a hash on this view's element.  Exposed for
    // subclasses using an alternative DOM manipulation API.
    _setAttributes: function(attributes) {
      this.$el.attr(attributes);
    }

  });

  // Backbone.sync
  // -------------

  // Override this function to change the manner in which Backbone persists
  // models to the server. You will be passed the type of request, and the
  // model in question. By default, makes a RESTful Ajax request
  // to the model's `url()`. Some possible customizations could be:
  //
  // * Use `setTimeout` to batch rapid-fire updates into a single request.
  // * Send up the models as XML instead of JSON.
  // * Persist models via WebSockets instead of Ajax.
  //
  // Turn on `Backbone.emulateHTTP` in order to send `PUT` and `DELETE` requests
  // as `POST`, with a `_method` parameter containing the true HTTP method,
  // as well as all requests with the body as `application/x-www-form-urlencoded`
  // instead of `application/json` with the model in a param named `model`.
  // Useful when interfacing with server-side languages like **PHP** that make
  // it difficult to read the body of `PUT` requests.
  Backbone.sync = function(method, model, options) {
    var type = methodMap[method];

    // Default options, unless specified.
    _.defaults(options || (options = {}), {
      emulateHTTP: Backbone.emulateHTTP,
      emulateJSON: Backbone.emulateJSON
    });

    // Default JSON-request options.
    var params = {type: type, dataType: 'json'};

    // Ensure that we have a URL.
    if (!options.url) {
      params.url = _.result(model, 'url') || urlError();
    }

    // Ensure that we have the appropriate request data.
    if (options.data == null && model && (method === 'create' || method === 'update' || method === 'patch')) {
      params.contentType = 'application/json';
      params.data = JSON.stringify(options.attrs || model.toJSON(options));
    }

    // For older servers, emulate JSON by encoding the request into an HTML-form.
    if (options.emulateJSON) {
      params.contentType = 'application/x-www-form-urlencoded';
      params.data = params.data ? {model: params.data} : {};
    }

    // For older servers, emulate HTTP by mimicking the HTTP method with `_method`
    // And an `X-HTTP-Method-Override` header.
    if (options.emulateHTTP && (type === 'PUT' || type === 'DELETE' || type === 'PATCH')) {
      params.type = 'POST';
      if (options.emulateJSON) params.data._method = type;
      var beforeSend = options.beforeSend;
      options.beforeSend = function(xhr) {
        xhr.setRequestHeader('X-HTTP-Method-Override', type);
        if (beforeSend) return beforeSend.apply(this, arguments);
      };
    }

    // Don't process data on a non-GET request.
    if (params.type !== 'GET' && !options.emulateJSON) {
      params.processData = false;
    }

    // Pass along `textStatus` and `errorThrown` from jQuery.
    var error = options.error;
    options.error = function(xhr, textStatus, errorThrown) {
      options.textStatus = textStatus;
      options.errorThrown = errorThrown;
      if (error) error.call(options.context, xhr, textStatus, errorThrown);
    };

    // Make the request, allowing the user to override any Ajax options.
    var xhr = options.xhr = Backbone.ajax(_.extend(params, options));
    model.trigger('request', model, xhr, options);
    return xhr;
  };

  // Map from CRUD to HTTP for our default `Backbone.sync` implementation.
  var methodMap = {
    'create': 'POST',
    'update': 'PUT',
    'patch': 'PATCH',
    'delete': 'DELETE',
    'read': 'GET'
  };

  // Set the default implementation of `Backbone.ajax` to proxy through to `$`.
  // Override this if you'd like to use a different library.
  Backbone.ajax = function() {
    return Backbone.$.ajax.apply(Backbone.$, arguments);
  };

  // Backbone.Router
  // ---------------

  // Routers map faux-URLs to actions, and fire events when routes are
  // matched. Creating a new one sets its `routes` hash, if not set statically.
  var Router = Backbone.Router = function(options) {
    options || (options = {});
    if (options.routes) this.routes = options.routes;
    this._bindRoutes();
    this.initialize.apply(this, arguments);
  };

  // Cached regular expressions for matching named param parts and splatted
  // parts of route strings.
  var optionalParam = /\((.*?)\)/g;
  var namedParam    = /(\(\?)?:\w+/g;
  var splatParam    = /\*\w+/g;
  var escapeRegExp  = /[\-{}\[\]+?.,\\\^$|#\s]/g;

  // Set up all inheritable **Backbone.Router** properties and methods.
  _.extend(Router.prototype, Events, {

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // Manually bind a single named route to a callback. For example:
    //
    //     this.route('search/:query/p:num', 'search', function(query, num) {
    //       ...
    //     });
    //
    route: function(route, name, callback) {
      if (!_.isRegExp(route)) route = this._routeToRegExp(route);
      if (_.isFunction(name)) {
        callback = name;
        name = '';
      }
      if (!callback) callback = this[name];
      var router = this;
      Backbone.history.route(route, function(fragment) {
        var args = router._extractParameters(route, fragment);
        if (router.execute(callback, args, name) !== false) {
          router.trigger.apply(router, ['route:' + name].concat(args));
          router.trigger('route', name, args);
          Backbone.history.trigger('route', router, name, args);
        }
      });
      return this;
    },

    // Execute a route handler with the provided parameters.  This is an
    // excellent place to do pre-route setup or post-route cleanup.
    execute: function(callback, args, name) {
      if (callback) callback.apply(this, args);
    },

    // Simple proxy to `Backbone.history` to save a fragment into the history.
    navigate: function(fragment, options) {
      Backbone.history.navigate(fragment, options);
      return this;
    },

    // Bind all defined routes to `Backbone.history`. We have to reverse the
    // order of the routes here to support behavior where the most general
    // routes can be defined at the bottom of the route map.
    _bindRoutes: function() {
      if (!this.routes) return;
      this.routes = _.result(this, 'routes');
      var route, routes = _.keys(this.routes);
      while ((route = routes.pop()) != null) {
        this.route(route, this.routes[route]);
      }
    },

    // Convert a route string into a regular expression, suitable for matching
    // against the current location hash.
    _routeToRegExp: function(route) {
      route = route.replace(escapeRegExp, '\\$&')
                   .replace(optionalParam, '(?:$1)?')
                   .replace(namedParam, function(match, optional) {
                     return optional ? match : '([^/?]+)';
                   })
                   .replace(splatParam, '([^?]*?)');
      return new RegExp('^' + route + '(?:\\?([\\s\\S]*))?$');
    },

    // Given a route, and a URL fragment that it matches, return the array of
    // extracted decoded parameters. Empty or unmatched parameters will be
    // treated as `null` to normalize cross-browser behavior.
    _extractParameters: function(route, fragment) {
      var params = route.exec(fragment).slice(1);
      return _.map(params, function(param, i) {
        // Don't decode the search params.
        if (i === params.length - 1) return param || null;
        return param ? decodeURIComponent(param) : null;
      });
    }

  });

  // Backbone.History
  // ----------------

  // Handles cross-browser history management, based on either
  // [pushState](http://diveintohtml5.info/history.html) and real URLs, or
  // [onhashchange](https://developer.mozilla.org/en-US/docs/DOM/window.onhashchange)
  // and URL fragments. If the browser supports neither (old IE, natch),
  // falls back to polling.
  var History = Backbone.History = function() {
    this.handlers = [];
    this.checkUrl = _.bind(this.checkUrl, this);

    // Ensure that `History` can be used outside of the browser.
    if (typeof window !== 'undefined') {
      this.location = window.location;
      this.history = window.history;
    }
  };

  // Cached regex for stripping a leading hash/slash and trailing space.
  var routeStripper = /^[#\/]|\s+$/g;

  // Cached regex for stripping leading and trailing slashes.
  var rootStripper = /^\/+|\/+$/g;

  // Cached regex for stripping urls of hash.
  var pathStripper = /#.*$/;

  // Has the history handling already been started?
  History.started = false;

  // Set up all inheritable **Backbone.History** properties and methods.
  _.extend(History.prototype, Events, {

    // The default interval to poll for hash changes, if necessary, is
    // twenty times a second.
    interval: 50,

    // Are we at the app root?
    atRoot: function() {
      var path = this.location.pathname.replace(/[^\/]$/, '$&/');
      return path === this.root && !this.getSearch();
    },

    // Does the pathname match the root?
    matchRoot: function() {
      var path = this.decodeFragment(this.location.pathname);
      var rootPath = path.slice(0, this.root.length - 1) + '/';
      return rootPath === this.root;
    },

    // Unicode characters in `location.pathname` are percent encoded so they're
    // decoded for comparison. `%25` should not be decoded since it may be part
    // of an encoded parameter.
    decodeFragment: function(fragment) {
      return decodeURI(fragment.replace(/%25/g, '%2525'));
    },

    // In IE6, the hash fragment and search params are incorrect if the
    // fragment contains `?`.
    getSearch: function() {
      var match = this.location.href.replace(/#.*/, '').match(/\?.+/);
      return match ? match[0] : '';
    },

    // Gets the true hash value. Cannot use location.hash directly due to bug
    // in Firefox where location.hash will always be decoded.
    getHash: function(window) {
      var match = (window || this).location.href.match(/#(.*)$/);
      return match ? match[1] : '';
    },

    // Get the pathname and search params, without the root.
    getPath: function() {
      var path = this.decodeFragment(
        this.location.pathname + this.getSearch()
      ).slice(this.root.length - 1);
      return path.charAt(0) === '/' ? path.slice(1) : path;
    },

    // Get the cross-browser normalized URL fragment from the path or hash.
    getFragment: function(fragment) {
      if (fragment == null) {
        if (this._usePushState || !this._wantsHashChange) {
          fragment = this.getPath();
        } else {
          fragment = this.getHash();
        }
      }
      return fragment.replace(routeStripper, '');
    },

    // Start the hash change handling, returning `true` if the current URL matches
    // an existing route, and `false` otherwise.
    start: function(options) {
      if (History.started) throw new Error('Backbone.history has already been started');
      History.started = true;

      // Figure out the initial configuration. Do we need an iframe?
      // Is pushState desired ... is it available?
      this.options          = _.extend({root: '/'}, this.options, options);
      this.root             = this.options.root;
      this._wantsHashChange = this.options.hashChange !== false;
      this._hasHashChange   = 'onhashchange' in window && (document.documentMode === void 0 || document.documentMode > 7);
      this._useHashChange   = this._wantsHashChange && this._hasHashChange;
      this._wantsPushState  = !!this.options.pushState;
      this._hasPushState    = !!(this.history && this.history.pushState);
      this._usePushState    = this._wantsPushState && this._hasPushState;
      this.fragment         = this.getFragment();

      // Normalize root to always include a leading and trailing slash.
      this.root = ('/' + this.root + '/').replace(rootStripper, '/');

      // Transition from hashChange to pushState or vice versa if both are
      // requested.
      if (this._wantsHashChange && this._wantsPushState) {

        // If we've started off with a route from a `pushState`-enabled
        // browser, but we're currently in a browser that doesn't support it...
        if (!this._hasPushState && !this.atRoot()) {
          var rootPath = this.root.slice(0, -1) || '/';
          this.location.replace(rootPath + '#' + this.getPath());
          // Return immediately as browser will do redirect to new url
          return true;

        // Or if we've started out with a hash-based route, but we're currently
        // in a browser where it could be `pushState`-based instead...
        } else if (this._hasPushState && this.atRoot()) {
          this.navigate(this.getHash(), {replace: true});
        }

      }

      // Proxy an iframe to handle location events if the browser doesn't
      // support the `hashchange` event, HTML5 history, or the user wants
      // `hashChange` but not `pushState`.
      if (!this._hasHashChange && this._wantsHashChange && !this._usePushState) {
        this.iframe = document.createElement('iframe');
        this.iframe.src = 'javascript:0';
        this.iframe.style.display = 'none';
        this.iframe.tabIndex = -1;
        var body = document.body;
        // Using `appendChild` will throw on IE < 9 if the document is not ready.
        var iWindow = body.insertBefore(this.iframe, body.firstChild).contentWindow;
        iWindow.document.open();
        iWindow.document.close();
        iWindow.location.hash = '#' + this.fragment;
      }

      // Add a cross-platform `addEventListener` shim for older browsers.
      var addEventListener = window.addEventListener || function(eventName, listener) {
        return attachEvent('on' + eventName, listener);
      };

      // Depending on whether we're using pushState or hashes, and whether
      // 'onhashchange' is supported, determine how we check the URL state.
      if (this._usePushState) {
        addEventListener('popstate', this.checkUrl, false);
      } else if (this._useHashChange && !this.iframe) {
        addEventListener('hashchange', this.checkUrl, false);
      } else if (this._wantsHashChange) {
        this._checkUrlInterval = setInterval(this.checkUrl, this.interval);
      }

      if (!this.options.silent) return this.loadUrl();
    },

    // Disable Backbone.history, perhaps temporarily. Not useful in a real app,
    // but possibly useful for unit testing Routers.
    stop: function() {
      // Add a cross-platform `removeEventListener` shim for older browsers.
      var removeEventListener = window.removeEventListener || function(eventName, listener) {
        return detachEvent('on' + eventName, listener);
      };

      // Remove window listeners.
      if (this._usePushState) {
        removeEventListener('popstate', this.checkUrl, false);
      } else if (this._useHashChange && !this.iframe) {
        removeEventListener('hashchange', this.checkUrl, false);
      }

      // Clean up the iframe if necessary.
      if (this.iframe) {
        document.body.removeChild(this.iframe);
        this.iframe = null;
      }

      // Some environments will throw when clearing an undefined interval.
      if (this._checkUrlInterval) clearInterval(this._checkUrlInterval);
      History.started = false;
    },

    // Add a route to be tested when the fragment changes. Routes added later
    // may override previous routes.
    route: function(route, callback) {
      this.handlers.unshift({route: route, callback: callback});
    },

    // Checks the current URL to see if it has changed, and if it has,
    // calls `loadUrl`, normalizing across the hidden iframe.
    checkUrl: function(e) {
      var current = this.getFragment();

      // If the user pressed the back button, the iframe's hash will have
      // changed and we should use that for comparison.
      if (current === this.fragment && this.iframe) {
        current = this.getHash(this.iframe.contentWindow);
      }

      if (current === this.fragment) return false;
      if (this.iframe) this.navigate(current);
      this.loadUrl();
    },

    // Attempt to load the current URL fragment. If a route succeeds with a
    // match, returns `true`. If no defined routes matches the fragment,
    // returns `false`.
    loadUrl: function(fragment) {
      // If the root doesn't match, no routes can match either.
      if (!this.matchRoot()) return false;
      fragment = this.fragment = this.getFragment(fragment);
      return _.some(this.handlers, function(handler) {
        if (handler.route.test(fragment)) {
          handler.callback(fragment);
          return true;
        }
      });
    },

    // Save a fragment into the hash history, or replace the URL state if the
    // 'replace' option is passed. You are responsible for properly URL-encoding
    // the fragment in advance.
    //
    // The options object can contain `trigger: true` if you wish to have the
    // route callback be fired (not usually desirable), or `replace: true`, if
    // you wish to modify the current URL without adding an entry to the history.
    navigate: function(fragment, options) {
      if (!History.started) return false;
      if (!options || options === true) options = {trigger: !!options};

      // Normalize the fragment.
      fragment = this.getFragment(fragment || '');

      // Don't include a trailing slash on the root.
      var rootPath = this.root;
      if (fragment === '' || fragment.charAt(0) === '?') {
        rootPath = rootPath.slice(0, -1) || '/';
      }
      var url = rootPath + fragment;

      // Strip the hash and decode for matching.
      fragment = this.decodeFragment(fragment.replace(pathStripper, ''));

      if (this.fragment === fragment) return;
      this.fragment = fragment;

      // If pushState is available, we use it to set the fragment as a real URL.
      if (this._usePushState) {
        this.history[options.replace ? 'replaceState' : 'pushState']({}, document.title, url);

      // If hash changes haven't been explicitly disabled, update the hash
      // fragment to store history.
      } else if (this._wantsHashChange) {
        this._updateHash(this.location, fragment, options.replace);
        if (this.iframe && fragment !== this.getHash(this.iframe.contentWindow)) {
          var iWindow = this.iframe.contentWindow;

          // Opening and closing the iframe tricks IE7 and earlier to push a
          // history entry on hash-tag change.  When replace is true, we don't
          // want this.
          if (!options.replace) {
            iWindow.document.open();
            iWindow.document.close();
          }

          this._updateHash(iWindow.location, fragment, options.replace);
        }

      // If you've told us that you explicitly don't want fallback hashchange-
      // based history, then `navigate` becomes a page refresh.
      } else {
        return this.location.assign(url);
      }
      if (options.trigger) return this.loadUrl(fragment);
    },

    // Update the hash location, either replacing the current entry, or adding
    // a new one to the browser history.
    _updateHash: function(location, fragment, replace) {
      if (replace) {
        var href = location.href.replace(/(javascript:|#).*$/, '');
        location.replace(href + '#' + fragment);
      } else {
        // Some browsers require that `hash` contains a leading #.
        location.hash = '#' + fragment;
      }
    }

  });

  // Create the default Backbone.history.
  Backbone.history = new History;

  // Helpers
  // -------

  // Helper function to correctly set up the prototype chain for subclasses.
  // Similar to `goog.inherits`, but uses a hash of prototype properties and
  // class properties to be extended.
  var extend = function(protoProps, staticProps) {
    var parent = this;
    var child;

    // The constructor function for the new subclass is either defined by you
    // (the "constructor" property in your `extend` definition), or defaulted
    // by us to simply call the parent constructor.
    if (protoProps && _.has(protoProps, 'constructor')) {
      child = protoProps.constructor;
    } else {
      child = function(){ return parent.apply(this, arguments); };
    }

    // Add static properties to the constructor function, if supplied.
    _.extend(child, parent, staticProps);

    // Set the prototype chain to inherit from `parent`, without calling
    // `parent`'s constructor function and add the prototype properties.
    child.prototype = _.create(parent.prototype, protoProps);
    child.prototype.constructor = child;

    // Set a convenience property in case the parent's prototype is needed
    // later.
    child.__super__ = parent.prototype;

    return child;
  };

  // Set up inheritance for the model, collection, router, view and history.
  Model.extend = Collection.extend = Router.extend = View.extend = History.extend = extend;

  // Throw an error when a URL is needed, and none is supplied.
  var urlError = function() {
    throw new Error('A "url" property or function must be specified');
  };

  // Wrap an optional error callback with a fallback error event.
  var wrapError = function(model, options) {
    var error = options.error;
    options.error = function(resp) {
      if (error) error.call(options.context, model, resp, options);
      model.trigger('error', model, resp, options);
    };
  };

  return Backbone;
});

// This is a plugin, constructed from parts of Backbone.js and John Resig's inheritance script.
// (See http://backbonejs.org, http://ejohn.org/blog/simple-javascript-inheritance/)
// No credit goes to me as I did absolutely nothing except patch these two together.
(function(root, factory) {

  // Set up Backbone appropriately for the environment. Start with AMD.
  if (typeof define === 'function' && define.amd) {
    define('backbone-super',['underscore', 'backbone'], function(_, Backbone) {
      // Export global even in AMD case in case this script is loaded with
      // others that may still expect a global Backbone.
      factory( _, Backbone);
    });

  // Next for Node.js or CommonJS.
  } else if (typeof exports !== 'undefined') {
    var _ = require('underscore'),
		Backbone = require('backbone');
    factory(_, Backbone);

  // Finally, as a browser global.
  } else {
    factory(root._, root.Backbone);
  }

}(this, function factory(_, Backbone) {
	Backbone.Model.extend = Backbone.Collection.extend = Backbone.Router.extend = Backbone.View.extend = function(protoProps, classProps) {
		var child = inherits(this, protoProps, classProps);
		child.extend = this.extend;
		return child;
	};
	var unImplementedSuper = function(method){throw "Super does not implement this method: " + method;};

	var ctor = function(){}, inherits = function(parent, protoProps, staticProps) {
		var child, _super = parent.prototype, fnTest = /\b_super\b/;

		// The constructor function for the new subclass is either defined by you
		// (the "constructor" property in your `extend` definition), or defaulted
		// by us to simply call the parent's constructor.
		if (protoProps && protoProps.hasOwnProperty('constructor')) {
			child = protoProps.constructor;
		} else {
			child = function(){ return parent.apply(this, arguments); };
		}

		// Inherit class (static) properties from parent.
		_.extend(child, parent, staticProps);

		// Set the prototype chain to inherit from `parent`, without calling
		// `parent`'s constructor function.
		ctor.prototype = parent.prototype;
		child.prototype = new ctor();

		// Add prototype properties (instance properties) to the subclass,
		// if supplied.
		if (protoProps) {
			_.extend(child.prototype, protoProps);

			// Copy the properties over onto the new prototype
			for (var name in protoProps) {
				// Check if we're overwriting an existing function
				if (typeof protoProps[name] == "function" &&  fnTest.test(protoProps[name])) {
					child.prototype[name] = (function(name, fn) {
						var wrapper = function() {
							var tmp = this._super;

							// Add a new ._super() method that is the same method
							// but on the super-class
							this._super = _super[name] || unImplementedSuper(name);

							// The method only need to be bound temporarily, so we
							// remove it when we're done executing
							var ret;
							try {
								ret = fn.apply(this, arguments);
							} finally {
								this._super = tmp;
							}
							return ret;
						};

						//we must move properties from old function to new
						for (var prop in fn) {
							wrapper[prop] = fn[prop];
							delete fn[prop];
						}

						return wrapper;
					})(name, protoProps[name]);
				}
			}
		}

		// Add static properties to the constructor function, if supplied.
		if (staticProps) _.extend(child, staticProps);

		// Correctly set child's `prototype.constructor`.
		child.prototype.constructor = child;

		// Set a convenience property in case the parent's prototype is needed later.
		child.__super__ = parent.prototype;

		return child;
	};

	return inherits;
}));


/*!
 * Bootstrap v3.3.6 (http://getbootstrap.com)
 * Copyright 2011-2015 Twitter, Inc.
 * Licensed under the MIT license
 */
if("undefined"==typeof jQuery)throw new Error("Bootstrap's JavaScript requires jQuery");+function(a){"use strict";var b=a.fn.jquery.split(" ")[0].split(".");if(b[0]<2&&b[1]<9||1==b[0]&&9==b[1]&&b[2]<1||b[0]>2)throw new Error("Bootstrap's JavaScript requires jQuery version 1.9.1 or higher, but lower than version 3")}(jQuery),+function(a){"use strict";function b(){var a=document.createElement("bootstrap"),b={WebkitTransition:"webkitTransitionEnd",MozTransition:"transitionend",OTransition:"oTransitionEnd otransitionend",transition:"transitionend"};for(var c in b)if(void 0!==a.style[c])return{end:b[c]};return!1}a.fn.emulateTransitionEnd=function(b){var c=!1,d=this;a(this).one("bsTransitionEnd",function(){c=!0});var e=function(){c||a(d).trigger(a.support.transition.end)};return setTimeout(e,b),this},a(function(){a.support.transition=b(),a.support.transition&&(a.event.special.bsTransitionEnd={bindType:a.support.transition.end,delegateType:a.support.transition.end,handle:function(b){return a(b.target).is(this)?b.handleObj.handler.apply(this,arguments):void 0}})})}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var c=a(this),e=c.data("bs.alert");e||c.data("bs.alert",e=new d(this)),"string"==typeof b&&e[b].call(c)})}var c='[data-dismiss="alert"]',d=function(b){a(b).on("click",c,this.close)};d.VERSION="3.3.6",d.TRANSITION_DURATION=150,d.prototype.close=function(b){function c(){g.detach().trigger("closed.bs.alert").remove()}var e=a(this),f=e.attr("data-target");f||(f=e.attr("href"),f=f&&f.replace(/.*(?=#[^\s]*$)/,""));var g=a(f);b&&b.preventDefault(),g.length||(g=e.closest(".alert")),g.trigger(b=a.Event("close.bs.alert")),b.isDefaultPrevented()||(g.removeClass("in"),a.support.transition&&g.hasClass("fade")?g.one("bsTransitionEnd",c).emulateTransitionEnd(d.TRANSITION_DURATION):c())};var e=a.fn.alert;a.fn.alert=b,a.fn.alert.Constructor=d,a.fn.alert.noConflict=function(){return a.fn.alert=e,this},a(document).on("click.bs.alert.data-api",c,d.prototype.close)}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.button"),f="object"==typeof b&&b;e||d.data("bs.button",e=new c(this,f)),"toggle"==b?e.toggle():b&&e.setState(b)})}var c=function(b,d){this.$element=a(b),this.options=a.extend({},c.DEFAULTS,d),this.isLoading=!1};c.VERSION="3.3.6",c.DEFAULTS={loadingText:"loading..."},c.prototype.setState=function(b){var c="disabled",d=this.$element,e=d.is("input")?"val":"html",f=d.data();b+="Text",null==f.resetText&&d.data("resetText",d[e]()),setTimeout(a.proxy(function(){d[e](null==f[b]?this.options[b]:f[b]),"loadingText"==b?(this.isLoading=!0,d.addClass(c).attr(c,c)):this.isLoading&&(this.isLoading=!1,d.removeClass(c).removeAttr(c))},this),0)},c.prototype.toggle=function(){var a=!0,b=this.$element.closest('[data-toggle="buttons"]');if(b.length){var c=this.$element.find("input");"radio"==c.prop("type")?(c.prop("checked")&&(a=!1),b.find(".active").removeClass("active"),this.$element.addClass("active")):"checkbox"==c.prop("type")&&(c.prop("checked")!==this.$element.hasClass("active")&&(a=!1),this.$element.toggleClass("active")),c.prop("checked",this.$element.hasClass("active")),a&&c.trigger("change")}else this.$element.attr("aria-pressed",!this.$element.hasClass("active")),this.$element.toggleClass("active")};var d=a.fn.button;a.fn.button=b,a.fn.button.Constructor=c,a.fn.button.noConflict=function(){return a.fn.button=d,this},a(document).on("click.bs.button.data-api",'[data-toggle^="button"]',function(c){var d=a(c.target);d.hasClass("btn")||(d=d.closest(".btn")),b.call(d,"toggle"),a(c.target).is('input[type="radio"]')||a(c.target).is('input[type="checkbox"]')||c.preventDefault()}).on("focus.bs.button.data-api blur.bs.button.data-api",'[data-toggle^="button"]',function(b){a(b.target).closest(".btn").toggleClass("focus",/^focus(in)?$/.test(b.type))})}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.carousel"),f=a.extend({},c.DEFAULTS,d.data(),"object"==typeof b&&b),g="string"==typeof b?b:f.slide;e||d.data("bs.carousel",e=new c(this,f)),"number"==typeof b?e.to(b):g?e[g]():f.interval&&e.pause().cycle()})}var c=function(b,c){this.$element=a(b),this.$indicators=this.$element.find(".carousel-indicators"),this.options=c,this.paused=null,this.sliding=null,this.interval=null,this.$active=null,this.$items=null,this.options.keyboard&&this.$element.on("keydown.bs.carousel",a.proxy(this.keydown,this)),"hover"==this.options.pause&&!("ontouchstart"in document.documentElement)&&this.$element.on("mouseenter.bs.carousel",a.proxy(this.pause,this)).on("mouseleave.bs.carousel",a.proxy(this.cycle,this))};c.VERSION="3.3.6",c.TRANSITION_DURATION=600,c.DEFAULTS={interval:5e3,pause:"hover",wrap:!0,keyboard:!0},c.prototype.keydown=function(a){if(!/input|textarea/i.test(a.target.tagName)){switch(a.which){case 37:this.prev();break;case 39:this.next();break;default:return}a.preventDefault()}},c.prototype.cycle=function(b){return b||(this.paused=!1),this.interval&&clearInterval(this.interval),this.options.interval&&!this.paused&&(this.interval=setInterval(a.proxy(this.next,this),this.options.interval)),this},c.prototype.getItemIndex=function(a){return this.$items=a.parent().children(".item"),this.$items.index(a||this.$active)},c.prototype.getItemForDirection=function(a,b){var c=this.getItemIndex(b),d="prev"==a&&0===c||"next"==a&&c==this.$items.length-1;if(d&&!this.options.wrap)return b;var e="prev"==a?-1:1,f=(c+e)%this.$items.length;return this.$items.eq(f)},c.prototype.to=function(a){var b=this,c=this.getItemIndex(this.$active=this.$element.find(".item.active"));return a>this.$items.length-1||0>a?void 0:this.sliding?this.$element.one("slid.bs.carousel",function(){b.to(a)}):c==a?this.pause().cycle():this.slide(a>c?"next":"prev",this.$items.eq(a))},c.prototype.pause=function(b){return b||(this.paused=!0),this.$element.find(".next, .prev").length&&a.support.transition&&(this.$element.trigger(a.support.transition.end),this.cycle(!0)),this.interval=clearInterval(this.interval),this},c.prototype.next=function(){return this.sliding?void 0:this.slide("next")},c.prototype.prev=function(){return this.sliding?void 0:this.slide("prev")},c.prototype.slide=function(b,d){var e=this.$element.find(".item.active"),f=d||this.getItemForDirection(b,e),g=this.interval,h="next"==b?"left":"right",i=this;if(f.hasClass("active"))return this.sliding=!1;var j=f[0],k=a.Event("slide.bs.carousel",{relatedTarget:j,direction:h});if(this.$element.trigger(k),!k.isDefaultPrevented()){if(this.sliding=!0,g&&this.pause(),this.$indicators.length){this.$indicators.find(".active").removeClass("active");var l=a(this.$indicators.children()[this.getItemIndex(f)]);l&&l.addClass("active")}var m=a.Event("slid.bs.carousel",{relatedTarget:j,direction:h});return a.support.transition&&this.$element.hasClass("slide")?(f.addClass(b),f[0].offsetWidth,e.addClass(h),f.addClass(h),e.one("bsTransitionEnd",function(){f.removeClass([b,h].join(" ")).addClass("active"),e.removeClass(["active",h].join(" ")),i.sliding=!1,setTimeout(function(){i.$element.trigger(m)},0)}).emulateTransitionEnd(c.TRANSITION_DURATION)):(e.removeClass("active"),f.addClass("active"),this.sliding=!1,this.$element.trigger(m)),g&&this.cycle(),this}};var d=a.fn.carousel;a.fn.carousel=b,a.fn.carousel.Constructor=c,a.fn.carousel.noConflict=function(){return a.fn.carousel=d,this};var e=function(c){var d,e=a(this),f=a(e.attr("data-target")||(d=e.attr("href"))&&d.replace(/.*(?=#[^\s]+$)/,""));if(f.hasClass("carousel")){var g=a.extend({},f.data(),e.data()),h=e.attr("data-slide-to");h&&(g.interval=!1),b.call(f,g),h&&f.data("bs.carousel").to(h),c.preventDefault()}};a(document).on("click.bs.carousel.data-api","[data-slide]",e).on("click.bs.carousel.data-api","[data-slide-to]",e),a(window).on("load",function(){a('[data-ride="carousel"]').each(function(){var c=a(this);b.call(c,c.data())})})}(jQuery),+function(a){"use strict";function b(b){var c,d=b.attr("data-target")||(c=b.attr("href"))&&c.replace(/.*(?=#[^\s]+$)/,"");return a(d)}function c(b){return this.each(function(){var c=a(this),e=c.data("bs.collapse"),f=a.extend({},d.DEFAULTS,c.data(),"object"==typeof b&&b);!e&&f.toggle&&/show|hide/.test(b)&&(f.toggle=!1),e||c.data("bs.collapse",e=new d(this,f)),"string"==typeof b&&e[b]()})}var d=function(b,c){this.$element=a(b),this.options=a.extend({},d.DEFAULTS,c),this.$trigger=a('[data-toggle="collapse"][href="#'+b.id+'"],[data-toggle="collapse"][data-target="#'+b.id+'"]'),this.transitioning=null,this.options.parent?this.$parent=this.getParent():this.addAriaAndCollapsedClass(this.$element,this.$trigger),this.options.toggle&&this.toggle()};d.VERSION="3.3.6",d.TRANSITION_DURATION=350,d.DEFAULTS={toggle:!0},d.prototype.dimension=function(){var a=this.$element.hasClass("width");return a?"width":"height"},d.prototype.show=function(){if(!this.transitioning&&!this.$element.hasClass("in")){var b,e=this.$parent&&this.$parent.children(".panel").children(".in, .collapsing");if(!(e&&e.length&&(b=e.data("bs.collapse"),b&&b.transitioning))){var f=a.Event("show.bs.collapse");if(this.$element.trigger(f),!f.isDefaultPrevented()){e&&e.length&&(c.call(e,"hide"),b||e.data("bs.collapse",null));var g=this.dimension();this.$element.removeClass("collapse").addClass("collapsing")[g](0).attr("aria-expanded",!0),this.$trigger.removeClass("collapsed").attr("aria-expanded",!0),this.transitioning=1;var h=function(){this.$element.removeClass("collapsing").addClass("collapse in")[g](""),this.transitioning=0,this.$element.trigger("shown.bs.collapse")};if(!a.support.transition)return h.call(this);var i=a.camelCase(["scroll",g].join("-"));this.$element.one("bsTransitionEnd",a.proxy(h,this)).emulateTransitionEnd(d.TRANSITION_DURATION)[g](this.$element[0][i])}}}},d.prototype.hide=function(){if(!this.transitioning&&this.$element.hasClass("in")){var b=a.Event("hide.bs.collapse");if(this.$element.trigger(b),!b.isDefaultPrevented()){var c=this.dimension();this.$element[c](this.$element[c]())[0].offsetHeight,this.$element.addClass("collapsing").removeClass("collapse in").attr("aria-expanded",!1),this.$trigger.addClass("collapsed").attr("aria-expanded",!1),this.transitioning=1;var e=function(){this.transitioning=0,this.$element.removeClass("collapsing").addClass("collapse").trigger("hidden.bs.collapse")};return a.support.transition?void this.$element[c](0).one("bsTransitionEnd",a.proxy(e,this)).emulateTransitionEnd(d.TRANSITION_DURATION):e.call(this)}}},d.prototype.toggle=function(){this[this.$element.hasClass("in")?"hide":"show"]()},d.prototype.getParent=function(){return a(this.options.parent).find('[data-toggle="collapse"][data-parent="'+this.options.parent+'"]').each(a.proxy(function(c,d){var e=a(d);this.addAriaAndCollapsedClass(b(e),e)},this)).end()},d.prototype.addAriaAndCollapsedClass=function(a,b){var c=a.hasClass("in");a.attr("aria-expanded",c),b.toggleClass("collapsed",!c).attr("aria-expanded",c)};var e=a.fn.collapse;a.fn.collapse=c,a.fn.collapse.Constructor=d,a.fn.collapse.noConflict=function(){return a.fn.collapse=e,this},a(document).on("click.bs.collapse.data-api",'[data-toggle="collapse"]',function(d){var e=a(this);e.attr("data-target")||d.preventDefault();var f=b(e),g=f.data("bs.collapse"),h=g?"toggle":e.data();c.call(f,h)})}(jQuery),+function(a){"use strict";function b(b){var c=b.attr("data-target");c||(c=b.attr("href"),c=c&&/#[A-Za-z]/.test(c)&&c.replace(/.*(?=#[^\s]*$)/,""));var d=c&&a(c);return d&&d.length?d:b.parent()}function c(c){c&&3===c.which||(a(e).remove(),a(f).each(function(){var d=a(this),e=b(d),f={relatedTarget:this};e.hasClass("open")&&(c&&"click"==c.type&&/input|textarea/i.test(c.target.tagName)&&a.contains(e[0],c.target)||(e.trigger(c=a.Event("hide.bs.dropdown",f)),c.isDefaultPrevented()||(d.attr("aria-expanded","false"),e.removeClass("open").trigger(a.Event("hidden.bs.dropdown",f)))))}))}function d(b){return this.each(function(){var c=a(this),d=c.data("bs.dropdown");d||c.data("bs.dropdown",d=new g(this)),"string"==typeof b&&d[b].call(c)})}var e=".dropdown-backdrop",f='[data-toggle="dropdown"]',g=function(b){a(b).on("click.bs.dropdown",this.toggle)};g.VERSION="3.3.6",g.prototype.toggle=function(d){var e=a(this);if(!e.is(".disabled, :disabled")){var f=b(e),g=f.hasClass("open");if(c(),!g){"ontouchstart"in document.documentElement&&!f.closest(".navbar-nav").length&&a(document.createElement("div")).addClass("dropdown-backdrop").insertAfter(a(this)).on("click",c);var h={relatedTarget:this};if(f.trigger(d=a.Event("show.bs.dropdown",h)),d.isDefaultPrevented())return;e.trigger("focus").attr("aria-expanded","true"),f.toggleClass("open").trigger(a.Event("shown.bs.dropdown",h))}return!1}},g.prototype.keydown=function(c){if(/(38|40|27|32)/.test(c.which)&&!/input|textarea/i.test(c.target.tagName)){var d=a(this);if(c.preventDefault(),c.stopPropagation(),!d.is(".disabled, :disabled")){var e=b(d),g=e.hasClass("open");if(!g&&27!=c.which||g&&27==c.which)return 27==c.which&&e.find(f).trigger("focus"),d.trigger("click");var h=" li:not(.disabled):visible a",i=e.find(".dropdown-menu"+h);if(i.length){var j=i.index(c.target);38==c.which&&j>0&&j--,40==c.which&&j<i.length-1&&j++,~j||(j=0),i.eq(j).trigger("focus")}}}};var h=a.fn.dropdown;a.fn.dropdown=d,a.fn.dropdown.Constructor=g,a.fn.dropdown.noConflict=function(){return a.fn.dropdown=h,this},a(document).on("click.bs.dropdown.data-api",c).on("click.bs.dropdown.data-api",".dropdown form",function(a){a.stopPropagation()}).on("click.bs.dropdown.data-api",f,g.prototype.toggle).on("keydown.bs.dropdown.data-api",f,g.prototype.keydown).on("keydown.bs.dropdown.data-api",".dropdown-menu",g.prototype.keydown)}(jQuery),+function(a){"use strict";function b(b,d){return this.each(function(){var e=a(this),f=e.data("bs.modal"),g=a.extend({},c.DEFAULTS,e.data(),"object"==typeof b&&b);f||e.data("bs.modal",f=new c(this,g)),"string"==typeof b?f[b](d):g.show&&f.show(d)})}var c=function(b,c){this.options=c,this.$body=a(document.body),this.$element=a(b),this.$dialog=this.$element.find(".modal-dialog"),this.$backdrop=null,this.isShown=null,this.originalBodyPad=null,this.scrollbarWidth=0,this.ignoreBackdropClick=!1,this.options.remote&&this.$element.find(".modal-content").load(this.options.remote,a.proxy(function(){this.$element.trigger("loaded.bs.modal")},this))};c.VERSION="3.3.6",c.TRANSITION_DURATION=300,c.BACKDROP_TRANSITION_DURATION=150,c.DEFAULTS={backdrop:!0,keyboard:!0,show:!0},c.prototype.toggle=function(a){return this.isShown?this.hide():this.show(a)},c.prototype.show=function(b){var d=this,e=a.Event("show.bs.modal",{relatedTarget:b});this.$element.trigger(e),this.isShown||e.isDefaultPrevented()||(this.isShown=!0,this.checkScrollbar(),this.setScrollbar(),this.$body.addClass("modal-open"),this.escape(),this.resize(),this.$element.on("click.dismiss.bs.modal",'[data-dismiss="modal"]',a.proxy(this.hide,this)),this.$dialog.on("mousedown.dismiss.bs.modal",function(){d.$element.one("mouseup.dismiss.bs.modal",function(b){a(b.target).is(d.$element)&&(d.ignoreBackdropClick=!0)})}),this.backdrop(function(){var e=a.support.transition&&d.$element.hasClass("fade");d.$element.parent().length||d.$element.appendTo(d.$body),d.$element.show().scrollTop(0),d.adjustDialog(),e&&d.$element[0].offsetWidth,d.$element.addClass("in"),d.enforceFocus();var f=a.Event("shown.bs.modal",{relatedTarget:b});e?d.$dialog.one("bsTransitionEnd",function(){d.$element.trigger("focus").trigger(f)}).emulateTransitionEnd(c.TRANSITION_DURATION):d.$element.trigger("focus").trigger(f)}))},c.prototype.hide=function(b){b&&b.preventDefault(),b=a.Event("hide.bs.modal"),this.$element.trigger(b),this.isShown&&!b.isDefaultPrevented()&&(this.isShown=!1,this.escape(),this.resize(),a(document).off("focusin.bs.modal"),this.$element.removeClass("in").off("click.dismiss.bs.modal").off("mouseup.dismiss.bs.modal"),this.$dialog.off("mousedown.dismiss.bs.modal"),a.support.transition&&this.$element.hasClass("fade")?this.$element.one("bsTransitionEnd",a.proxy(this.hideModal,this)).emulateTransitionEnd(c.TRANSITION_DURATION):this.hideModal())},c.prototype.enforceFocus=function(){a(document).off("focusin.bs.modal").on("focusin.bs.modal",a.proxy(function(a){this.$element[0]===a.target||this.$element.has(a.target).length||this.$element.trigger("focus")},this))},c.prototype.escape=function(){this.isShown&&this.options.keyboard?this.$element.on("keydown.dismiss.bs.modal",a.proxy(function(a){27==a.which&&this.hide()},this)):this.isShown||this.$element.off("keydown.dismiss.bs.modal")},c.prototype.resize=function(){this.isShown?a(window).on("resize.bs.modal",a.proxy(this.handleUpdate,this)):a(window).off("resize.bs.modal")},c.prototype.hideModal=function(){var a=this;this.$element.hide(),this.backdrop(function(){a.$body.removeClass("modal-open"),a.resetAdjustments(),a.resetScrollbar(),a.$element.trigger("hidden.bs.modal")})},c.prototype.removeBackdrop=function(){this.$backdrop&&this.$backdrop.remove(),this.$backdrop=null},c.prototype.backdrop=function(b){var d=this,e=this.$element.hasClass("fade")?"fade":"";if(this.isShown&&this.options.backdrop){var f=a.support.transition&&e;if(this.$backdrop=a(document.createElement("div")).addClass("modal-backdrop "+e).appendTo(this.$body),this.$element.on("click.dismiss.bs.modal",a.proxy(function(a){return this.ignoreBackdropClick?void(this.ignoreBackdropClick=!1):void(a.target===a.currentTarget&&("static"==this.options.backdrop?this.$element[0].focus():this.hide()))},this)),f&&this.$backdrop[0].offsetWidth,this.$backdrop.addClass("in"),!b)return;f?this.$backdrop.one("bsTransitionEnd",b).emulateTransitionEnd(c.BACKDROP_TRANSITION_DURATION):b()}else if(!this.isShown&&this.$backdrop){this.$backdrop.removeClass("in");var g=function(){d.removeBackdrop(),b&&b()};a.support.transition&&this.$element.hasClass("fade")?this.$backdrop.one("bsTransitionEnd",g).emulateTransitionEnd(c.BACKDROP_TRANSITION_DURATION):g()}else b&&b()},c.prototype.handleUpdate=function(){this.adjustDialog()},c.prototype.adjustDialog=function(){var a=this.$element[0].scrollHeight>document.documentElement.clientHeight;this.$element.css({paddingLeft:!this.bodyIsOverflowing&&a?this.scrollbarWidth:"",paddingRight:this.bodyIsOverflowing&&!a?this.scrollbarWidth:""})},c.prototype.resetAdjustments=function(){this.$element.css({paddingLeft:"",paddingRight:""})},c.prototype.checkScrollbar=function(){var a=window.innerWidth;if(!a){var b=document.documentElement.getBoundingClientRect();a=b.right-Math.abs(b.left)}this.bodyIsOverflowing=document.body.clientWidth<a,this.scrollbarWidth=this.measureScrollbar()},c.prototype.setScrollbar=function(){var a=parseInt(this.$body.css("padding-right")||0,10);this.originalBodyPad=document.body.style.paddingRight||"",this.bodyIsOverflowing&&this.$body.css("padding-right",a+this.scrollbarWidth)},c.prototype.resetScrollbar=function(){this.$body.css("padding-right",this.originalBodyPad)},c.prototype.measureScrollbar=function(){var a=document.createElement("div");a.className="modal-scrollbar-measure",this.$body.append(a);var b=a.offsetWidth-a.clientWidth;return this.$body[0].removeChild(a),b};var d=a.fn.modal;a.fn.modal=b,a.fn.modal.Constructor=c,a.fn.modal.noConflict=function(){return a.fn.modal=d,this},a(document).on("click.bs.modal.data-api",'[data-toggle="modal"]',function(c){var d=a(this),e=d.attr("href"),f=a(d.attr("data-target")||e&&e.replace(/.*(?=#[^\s]+$)/,"")),g=f.data("bs.modal")?"toggle":a.extend({remote:!/#/.test(e)&&e},f.data(),d.data());d.is("a")&&c.preventDefault(),f.one("show.bs.modal",function(a){a.isDefaultPrevented()||f.one("hidden.bs.modal",function(){d.is(":visible")&&d.trigger("focus")})}),b.call(f,g,this)})}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.tooltip"),f="object"==typeof b&&b;(e||!/destroy|hide/.test(b))&&(e||d.data("bs.tooltip",e=new c(this,f)),"string"==typeof b&&e[b]())})}var c=function(a,b){this.type=null,this.options=null,this.enabled=null,this.timeout=null,this.hoverState=null,this.$element=null,this.inState=null,this.init("tooltip",a,b)};c.VERSION="3.3.6",c.TRANSITION_DURATION=150,c.DEFAULTS={animation:!0,placement:"top",selector:!1,template:'<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',trigger:"hover focus",title:"",delay:0,html:!1,container:!1,viewport:{selector:"body",padding:0}},c.prototype.init=function(b,c,d){if(this.enabled=!0,this.type=b,this.$element=a(c),this.options=this.getOptions(d),this.$viewport=this.options.viewport&&a(a.isFunction(this.options.viewport)?this.options.viewport.call(this,this.$element):this.options.viewport.selector||this.options.viewport),this.inState={click:!1,hover:!1,focus:!1},this.$element[0]instanceof document.constructor&&!this.options.selector)throw new Error("`selector` option must be specified when initializing "+this.type+" on the window.document object!");for(var e=this.options.trigger.split(" "),f=e.length;f--;){var g=e[f];if("click"==g)this.$element.on("click."+this.type,this.options.selector,a.proxy(this.toggle,this));else if("manual"!=g){var h="hover"==g?"mouseenter":"focusin",i="hover"==g?"mouseleave":"focusout";this.$element.on(h+"."+this.type,this.options.selector,a.proxy(this.enter,this)),this.$element.on(i+"."+this.type,this.options.selector,a.proxy(this.leave,this))}}this.options.selector?this._options=a.extend({},this.options,{trigger:"manual",selector:""}):this.fixTitle()},c.prototype.getDefaults=function(){return c.DEFAULTS},c.prototype.getOptions=function(b){return b=a.extend({},this.getDefaults(),this.$element.data(),b),b.delay&&"number"==typeof b.delay&&(b.delay={show:b.delay,hide:b.delay}),b},c.prototype.getDelegateOptions=function(){var b={},c=this.getDefaults();return this._options&&a.each(this._options,function(a,d){c[a]!=d&&(b[a]=d)}),b},c.prototype.enter=function(b){var c=b instanceof this.constructor?b:a(b.currentTarget).data("bs."+this.type);return c||(c=new this.constructor(b.currentTarget,this.getDelegateOptions()),a(b.currentTarget).data("bs."+this.type,c)),b instanceof a.Event&&(c.inState["focusin"==b.type?"focus":"hover"]=!0),c.tip().hasClass("in")||"in"==c.hoverState?void(c.hoverState="in"):(clearTimeout(c.timeout),c.hoverState="in",c.options.delay&&c.options.delay.show?void(c.timeout=setTimeout(function(){"in"==c.hoverState&&c.show()},c.options.delay.show)):c.show())},c.prototype.isInStateTrue=function(){for(var a in this.inState)if(this.inState[a])return!0;return!1},c.prototype.leave=function(b){var c=b instanceof this.constructor?b:a(b.currentTarget).data("bs."+this.type);return c||(c=new this.constructor(b.currentTarget,this.getDelegateOptions()),a(b.currentTarget).data("bs."+this.type,c)),b instanceof a.Event&&(c.inState["focusout"==b.type?"focus":"hover"]=!1),c.isInStateTrue()?void 0:(clearTimeout(c.timeout),c.hoverState="out",c.options.delay&&c.options.delay.hide?void(c.timeout=setTimeout(function(){"out"==c.hoverState&&c.hide()},c.options.delay.hide)):c.hide())},c.prototype.show=function(){var b=a.Event("show.bs."+this.type);if(this.hasContent()&&this.enabled){this.$element.trigger(b);var d=a.contains(this.$element[0].ownerDocument.documentElement,this.$element[0]);if(b.isDefaultPrevented()||!d)return;var e=this,f=this.tip(),g=this.getUID(this.type);this.setContent(),f.attr("id",g),this.$element.attr("aria-describedby",g),this.options.animation&&f.addClass("fade");var h="function"==typeof this.options.placement?this.options.placement.call(this,f[0],this.$element[0]):this.options.placement,i=/\s?auto?\s?/i,j=i.test(h);j&&(h=h.replace(i,"")||"top"),f.detach().css({top:0,left:0,display:"block"}).addClass(h).data("bs."+this.type,this),this.options.container?f.appendTo(this.options.container):f.insertAfter(this.$element),this.$element.trigger("inserted.bs."+this.type);var k=this.getPosition(),l=f[0].offsetWidth,m=f[0].offsetHeight;if(j){var n=h,o=this.getPosition(this.$viewport);h="bottom"==h&&k.bottom+m>o.bottom?"top":"top"==h&&k.top-m<o.top?"bottom":"right"==h&&k.right+l>o.width?"left":"left"==h&&k.left-l<o.left?"right":h,f.removeClass(n).addClass(h)}var p=this.getCalculatedOffset(h,k,l,m);this.applyPlacement(p,h);var q=function(){var a=e.hoverState;e.$element.trigger("shown.bs."+e.type),e.hoverState=null,"out"==a&&e.leave(e)};a.support.transition&&this.$tip.hasClass("fade")?f.one("bsTransitionEnd",q).emulateTransitionEnd(c.TRANSITION_DURATION):q()}},c.prototype.applyPlacement=function(b,c){var d=this.tip(),e=d[0].offsetWidth,f=d[0].offsetHeight,g=parseInt(d.css("margin-top"),10),h=parseInt(d.css("margin-left"),10);isNaN(g)&&(g=0),isNaN(h)&&(h=0),b.top+=g,b.left+=h,a.offset.setOffset(d[0],a.extend({using:function(a){d.css({top:Math.round(a.top),left:Math.round(a.left)})}},b),0),d.addClass("in");var i=d[0].offsetWidth,j=d[0].offsetHeight;"top"==c&&j!=f&&(b.top=b.top+f-j);var k=this.getViewportAdjustedDelta(c,b,i,j);k.left?b.left+=k.left:b.top+=k.top;var l=/top|bottom/.test(c),m=l?2*k.left-e+i:2*k.top-f+j,n=l?"offsetWidth":"offsetHeight";d.offset(b),this.replaceArrow(m,d[0][n],l)},c.prototype.replaceArrow=function(a,b,c){this.arrow().css(c?"left":"top",50*(1-a/b)+"%").css(c?"top":"left","")},c.prototype.setContent=function(){var a=this.tip(),b=this.getTitle();a.find(".tooltip-inner")[this.options.html?"html":"text"](b),a.removeClass("fade in top bottom left right")},c.prototype.hide=function(b){function d(){"in"!=e.hoverState&&f.detach(),e.$element.removeAttr("aria-describedby").trigger("hidden.bs."+e.type),b&&b()}var e=this,f=a(this.$tip),g=a.Event("hide.bs."+this.type);return this.$element.trigger(g),g.isDefaultPrevented()?void 0:(f.removeClass("in"),a.support.transition&&f.hasClass("fade")?f.one("bsTransitionEnd",d).emulateTransitionEnd(c.TRANSITION_DURATION):d(),this.hoverState=null,this)},c.prototype.fixTitle=function(){var a=this.$element;(a.attr("title")||"string"!=typeof a.attr("data-original-title"))&&a.attr("data-original-title",a.attr("title")||"").attr("title","")},c.prototype.hasContent=function(){return this.getTitle()},c.prototype.getPosition=function(b){b=b||this.$element;var c=b[0],d="BODY"==c.tagName,e=c.getBoundingClientRect();null==e.width&&(e=a.extend({},e,{width:e.right-e.left,height:e.bottom-e.top}));var f=d?{top:0,left:0}:b.offset(),g={scroll:d?document.documentElement.scrollTop||document.body.scrollTop:b.scrollTop()},h=d?{width:a(window).width(),height:a(window).height()}:null;return a.extend({},e,g,h,f)},c.prototype.getCalculatedOffset=function(a,b,c,d){return"bottom"==a?{top:b.top+b.height,left:b.left+b.width/2-c/2}:"top"==a?{top:b.top-d,left:b.left+b.width/2-c/2}:"left"==a?{top:b.top+b.height/2-d/2,left:b.left-c}:{top:b.top+b.height/2-d/2,left:b.left+b.width}},c.prototype.getViewportAdjustedDelta=function(a,b,c,d){var e={top:0,left:0};if(!this.$viewport)return e;var f=this.options.viewport&&this.options.viewport.padding||0,g=this.getPosition(this.$viewport);if(/right|left/.test(a)){var h=b.top-f-g.scroll,i=b.top+f-g.scroll+d;h<g.top?e.top=g.top-h:i>g.top+g.height&&(e.top=g.top+g.height-i)}else{var j=b.left-f,k=b.left+f+c;j<g.left?e.left=g.left-j:k>g.right&&(e.left=g.left+g.width-k)}return e},c.prototype.getTitle=function(){var a,b=this.$element,c=this.options;return a=b.attr("data-original-title")||("function"==typeof c.title?c.title.call(b[0]):c.title)},c.prototype.getUID=function(a){do a+=~~(1e6*Math.random());while(document.getElementById(a));return a},c.prototype.tip=function(){if(!this.$tip&&(this.$tip=a(this.options.template),1!=this.$tip.length))throw new Error(this.type+" `template` option must consist of exactly 1 top-level element!");return this.$tip},c.prototype.arrow=function(){return this.$arrow=this.$arrow||this.tip().find(".tooltip-arrow")},c.prototype.enable=function(){this.enabled=!0},c.prototype.disable=function(){this.enabled=!1},c.prototype.toggleEnabled=function(){this.enabled=!this.enabled},c.prototype.toggle=function(b){var c=this;b&&(c=a(b.currentTarget).data("bs."+this.type),c||(c=new this.constructor(b.currentTarget,this.getDelegateOptions()),a(b.currentTarget).data("bs."+this.type,c))),b?(c.inState.click=!c.inState.click,c.isInStateTrue()?c.enter(c):c.leave(c)):c.tip().hasClass("in")?c.leave(c):c.enter(c)},c.prototype.destroy=function(){var a=this;clearTimeout(this.timeout),this.hide(function(){a.$element.off("."+a.type).removeData("bs."+a.type),a.$tip&&a.$tip.detach(),a.$tip=null,a.$arrow=null,a.$viewport=null})};var d=a.fn.tooltip;a.fn.tooltip=b,a.fn.tooltip.Constructor=c,a.fn.tooltip.noConflict=function(){return a.fn.tooltip=d,this}}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.popover"),f="object"==typeof b&&b;(e||!/destroy|hide/.test(b))&&(e||d.data("bs.popover",e=new c(this,f)),"string"==typeof b&&e[b]())})}var c=function(a,b){this.init("popover",a,b)};if(!a.fn.tooltip)throw new Error("Popover requires tooltip.js");c.VERSION="3.3.6",c.DEFAULTS=a.extend({},a.fn.tooltip.Constructor.DEFAULTS,{placement:"right",trigger:"click",content:"",template:'<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'}),c.prototype=a.extend({},a.fn.tooltip.Constructor.prototype),c.prototype.constructor=c,c.prototype.getDefaults=function(){return c.DEFAULTS},c.prototype.setContent=function(){var a=this.tip(),b=this.getTitle(),c=this.getContent();a.find(".popover-title")[this.options.html?"html":"text"](b),a.find(".popover-content").children().detach().end()[this.options.html?"string"==typeof c?"html":"append":"text"](c),a.removeClass("fade top bottom left right in"),a.find(".popover-title").html()||a.find(".popover-title").hide()},c.prototype.hasContent=function(){return this.getTitle()||this.getContent()},c.prototype.getContent=function(){var a=this.$element,b=this.options;return a.attr("data-content")||("function"==typeof b.content?b.content.call(a[0]):b.content)},c.prototype.arrow=function(){return this.$arrow=this.$arrow||this.tip().find(".arrow")};var d=a.fn.popover;a.fn.popover=b,a.fn.popover.Constructor=c,a.fn.popover.noConflict=function(){return a.fn.popover=d,this}}(jQuery),+function(a){"use strict";function b(c,d){this.$body=a(document.body),this.$scrollElement=a(a(c).is(document.body)?window:c),this.options=a.extend({},b.DEFAULTS,d),this.selector=(this.options.target||"")+" .nav li > a",this.offsets=[],this.targets=[],this.activeTarget=null,this.scrollHeight=0,this.$scrollElement.on("scroll.bs.scrollspy",a.proxy(this.process,this)),this.refresh(),this.process()}function c(c){return this.each(function(){var d=a(this),e=d.data("bs.scrollspy"),f="object"==typeof c&&c;e||d.data("bs.scrollspy",e=new b(this,f)),"string"==typeof c&&e[c]()})}b.VERSION="3.3.6",b.DEFAULTS={offset:10},b.prototype.getScrollHeight=function(){return this.$scrollElement[0].scrollHeight||Math.max(this.$body[0].scrollHeight,document.documentElement.scrollHeight)},b.prototype.refresh=function(){var b=this,c="offset",d=0;this.offsets=[],this.targets=[],this.scrollHeight=this.getScrollHeight(),a.isWindow(this.$scrollElement[0])||(c="position",d=this.$scrollElement.scrollTop()),this.$body.find(this.selector).map(function(){var b=a(this),e=b.data("target")||b.attr("href"),f=/^#./.test(e)&&a(e);return f&&f.length&&f.is(":visible")&&[[f[c]().top+d,e]]||null}).sort(function(a,b){return a[0]-b[0]}).each(function(){b.offsets.push(this[0]),b.targets.push(this[1])})},b.prototype.process=function(){var a,b=this.$scrollElement.scrollTop()+this.options.offset,c=this.getScrollHeight(),d=this.options.offset+c-this.$scrollElement.height(),e=this.offsets,f=this.targets,g=this.activeTarget;if(this.scrollHeight!=c&&this.refresh(),b>=d)return g!=(a=f[f.length-1])&&this.activate(a);if(g&&b<e[0])return this.activeTarget=null,this.clear();for(a=e.length;a--;)g!=f[a]&&b>=e[a]&&(void 0===e[a+1]||b<e[a+1])&&this.activate(f[a])},b.prototype.activate=function(b){this.activeTarget=b,this.clear();var c=this.selector+'[data-target="'+b+'"],'+this.selector+'[href="'+b+'"]',d=a(c).parents("li").addClass("active");
d.parent(".dropdown-menu").length&&(d=d.closest("li.dropdown").addClass("active")),d.trigger("activate.bs.scrollspy")},b.prototype.clear=function(){a(this.selector).parentsUntil(this.options.target,".active").removeClass("active")};var d=a.fn.scrollspy;a.fn.scrollspy=c,a.fn.scrollspy.Constructor=b,a.fn.scrollspy.noConflict=function(){return a.fn.scrollspy=d,this},a(window).on("load.bs.scrollspy.data-api",function(){a('[data-spy="scroll"]').each(function(){var b=a(this);c.call(b,b.data())})})}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.tab");e||d.data("bs.tab",e=new c(this)),"string"==typeof b&&e[b]()})}var c=function(b){this.element=a(b)};c.VERSION="3.3.6",c.TRANSITION_DURATION=150,c.prototype.show=function(){var b=this.element,c=b.closest("ul:not(.dropdown-menu)"),d=b.data("target");if(d||(d=b.attr("href"),d=d&&d.replace(/.*(?=#[^\s]*$)/,"")),!b.parent("li").hasClass("active")){var e=c.find(".active:last a"),f=a.Event("hide.bs.tab",{relatedTarget:b[0]}),g=a.Event("show.bs.tab",{relatedTarget:e[0]});if(e.trigger(f),b.trigger(g),!g.isDefaultPrevented()&&!f.isDefaultPrevented()){var h=a(d);this.activate(b.closest("li"),c),this.activate(h,h.parent(),function(){e.trigger({type:"hidden.bs.tab",relatedTarget:b[0]}),b.trigger({type:"shown.bs.tab",relatedTarget:e[0]})})}}},c.prototype.activate=function(b,d,e){function f(){g.removeClass("active").find("> .dropdown-menu > .active").removeClass("active").end().find('[data-toggle="tab"]').attr("aria-expanded",!1),b.addClass("active").find('[data-toggle="tab"]').attr("aria-expanded",!0),h?(b[0].offsetWidth,b.addClass("in")):b.removeClass("fade"),b.parent(".dropdown-menu").length&&b.closest("li.dropdown").addClass("active").end().find('[data-toggle="tab"]').attr("aria-expanded",!0),e&&e()}var g=d.find("> .active"),h=e&&a.support.transition&&(g.length&&g.hasClass("fade")||!!d.find("> .fade").length);g.length&&h?g.one("bsTransitionEnd",f).emulateTransitionEnd(c.TRANSITION_DURATION):f(),g.removeClass("in")};var d=a.fn.tab;a.fn.tab=b,a.fn.tab.Constructor=c,a.fn.tab.noConflict=function(){return a.fn.tab=d,this};var e=function(c){c.preventDefault(),b.call(a(this),"show")};a(document).on("click.bs.tab.data-api",'[data-toggle="tab"]',e).on("click.bs.tab.data-api",'[data-toggle="pill"]',e)}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.affix"),f="object"==typeof b&&b;e||d.data("bs.affix",e=new c(this,f)),"string"==typeof b&&e[b]()})}var c=function(b,d){this.options=a.extend({},c.DEFAULTS,d),this.$target=a(this.options.target).on("scroll.bs.affix.data-api",a.proxy(this.checkPosition,this)).on("click.bs.affix.data-api",a.proxy(this.checkPositionWithEventLoop,this)),this.$element=a(b),this.affixed=null,this.unpin=null,this.pinnedOffset=null,this.checkPosition()};c.VERSION="3.3.6",c.RESET="affix affix-top affix-bottom",c.DEFAULTS={offset:0,target:window},c.prototype.getState=function(a,b,c,d){var e=this.$target.scrollTop(),f=this.$element.offset(),g=this.$target.height();if(null!=c&&"top"==this.affixed)return c>e?"top":!1;if("bottom"==this.affixed)return null!=c?e+this.unpin<=f.top?!1:"bottom":a-d>=e+g?!1:"bottom";var h=null==this.affixed,i=h?e:f.top,j=h?g:b;return null!=c&&c>=e?"top":null!=d&&i+j>=a-d?"bottom":!1},c.prototype.getPinnedOffset=function(){if(this.pinnedOffset)return this.pinnedOffset;this.$element.removeClass(c.RESET).addClass("affix");var a=this.$target.scrollTop(),b=this.$element.offset();return this.pinnedOffset=b.top-a},c.prototype.checkPositionWithEventLoop=function(){setTimeout(a.proxy(this.checkPosition,this),1)},c.prototype.checkPosition=function(){if(this.$element.is(":visible")){var b=this.$element.height(),d=this.options.offset,e=d.top,f=d.bottom,g=Math.max(a(document).height(),a(document.body).height());"object"!=typeof d&&(f=e=d),"function"==typeof e&&(e=d.top(this.$element)),"function"==typeof f&&(f=d.bottom(this.$element));var h=this.getState(g,b,e,f);if(this.affixed!=h){null!=this.unpin&&this.$element.css("top","");var i="affix"+(h?"-"+h:""),j=a.Event(i+".bs.affix");if(this.$element.trigger(j),j.isDefaultPrevented())return;this.affixed=h,this.unpin="bottom"==h?this.getPinnedOffset():null,this.$element.removeClass(c.RESET).addClass(i).trigger(i.replace("affix","affixed")+".bs.affix")}"bottom"==h&&this.$element.offset({top:g-b-f})}};var d=a.fn.affix;a.fn.affix=b,a.fn.affix.Constructor=c,a.fn.affix.noConflict=function(){return a.fn.affix=d,this},a(window).on("load",function(){a('[data-spy="affix"]').each(function(){var c=a(this),d=c.data();d.offset=d.offset||{},null!=d.offsetBottom&&(d.offset.bottom=d.offsetBottom),null!=d.offsetTop&&(d.offset.top=d.offsetTop),b.call(c,d)})})}(jQuery);
define("bootstrap", ["jquery"], function(){});

define('views/FormView',['require','exports','module','backbone'],function (require, exports, module) {
    'use strict';

    // External dependencies.
    var Backbone = require('backbone');

    var ModuleFormView = Backbone.View.extend({

        events: {
            'focus .module-form .has-error input': 'onHasErrorFocus',
            'click .module-form .has-error-content': 'onHasErrorContentClick',
            'click .read-more-link': 'onReadMoreLinkClick',
            'click .read-more-rollback-link': 'onReadMoreRollbackLinkClick',
            'focus .module-form input, .module-form textarea': 'onInputFocus',
            'blur .module-form input, .module-form textarea': 'onInputBlur',
            'refresh .module-form input, .module-form textarea': 'onRefreshInput',
            'change .module-form .checkbox.needs-validation input': 'onCheckboxChange',
            'change .module-form .radio.needs-validation input': 'onRadioChange',
            'change .module-form .radio input.radio-custom-number': 'onShowCustomerNumberChange',
            'change .module-form .checkbox input.checkbox-optional-pw': 'onShowOptionalPwChange',

            'focus .module-form .needs-validation:not(.checkbox):not(.radio)': 'removeValidation',
            'blur .module-form .needs-validation:not(.checkbox)': 'validate',
            'change .module-form select.needs-validation': 'validateBs',
        },

        initialize: function () {
            this.render();
            this.refreshForm();
            this.addEventListeners();
            $(window).on('refresh-form', _.bind(this.refreshForm, this));
        },

        render: function (e) {
            this.$el.addClass('rendered');
        },

        addEventListeners: function (e) {
            $('form').each($.proxy(function(index, el) {
                var $form = $(el);

                $form.find('button[type="submit"]').on('click', $.proxy(function(index, el) {
                    if (!$form.is(':valid')) {
                        $form.find('.needs-validation').each($.proxy(function(index, el) {
                            var $el = $(el);
                            var $subEl = $el.find('input:not([type="hidden"])');
                            var $bsSelect = $el.closest('.bootstrap-select');
                            var isElValid = $el.hasClass('form-control') && !$el.is(':valid') || false;
                            var isSubElValid = $subEl.hasClass('form-control') && !$subEl.is(':valid') || false;
                            var isEmpty = $el.hasClass('form-control') && $el.data('required') && _.isEmpty($el.val()) || false;
                            var isSubElEmpty = $subEl.hasClass('form-control') && $el.data('required') && _.isEmpty($subEl.val()) || false;

                            var $select = $el.find('select');
                            var isBootstrapSelect = $el.hasClass('bootstrap-select');

                            if (isBootstrapSelect) {
                                isEmpty = $select.hasClass('form-control') && $select.data('required') && _.isEmpty($select.val()) || false;
                            }

                            if (isElValid || isSubElValid || isEmpty || isSubElEmpty) {
                                if (isBootstrapSelect) {
                                    $el.addClass('was-validated');
                                    $el.find('.dropdown-toggle').addClass('bs-invalid');
                                } else {
                                    $el.addClass('was-validated').addClass('is-invalid');
                                    $el.filter('.checkbox, .radio').addClass('is-invalid');
                                }
                            }
                        }, this));
                    }
                }, this));
            }, this));
        },

        refreshForm: function () {
            $('input,textarea').each($.proxy(function(index, el) {
                this.checkValue($(el));
            }, this));
        },

        checkValue: function ($element) {
            var $group = $element.closest('.form-group');

            $element.attr('value', $element.val());
            if ($element.val() !== '') {
                $group.addClass('has-value');
            } else {
                $group.removeClass('has-value');
            }

            $group.removeClass('has-focus');
        },

        removeValidation: function (e) {
            var $el = $(e.currentTarget);
            this.removeValidated($el);
            this.removeValid($el);
        },

        validate: function (e) {
            var $el = $(e.currentTarget);

            this.addValidated($el);
        },

        validateBs: function (e) {
            var $el = $(e.currentTarget).closest('.bootstrap-select');
            $el.addClass('was-validated');
        },

        addValidated: function ($el) {
            $el.addClass('was-validated');

            var $select = $el.find('select');
            var isEmpty = $el.hasClass('form-control') && $el.data('required') && _.isEmpty($el.val()) || false;
            var isBootstrapSelect = $el.hasClass('bootstrap-select');

            if (isBootstrapSelect) {
                isEmpty = $select.hasClass('form-control') && $select.data('required') && _.isEmpty($select.val()) || false;
            }

            if (isEmpty) {
                if (isBootstrapSelect) {
                    $el.find('.dropdown-toggle').addClass('bs-invalid');
                } else {
                    $el.addClass('is-invalid');
                }
            }
        },

        removeValidated: function ($el) {
            $el.removeClass('was-validated');
        },

        removeValid: function ($el) {
            $el.removeClass('valid invalid is-valid is-invalid');

            if ($el.hasClass('bootstrap-select')) {
                $el.find('.dropdown-toggle').removeClass('bs-invalid');
            }
        },

        onHasErrorFocus: function (e) {
            var $element = $(e.currentTarget);

            var $wrapper = $element.closest('.has-error');

            if (!$wrapper.find('.has-error-content').hasClass('persist')) {
                $wrapper.find('.has-error-content').remove();
                $wrapper.removeClass('has-error');
            }
        },

        onHasErrorContentClick: function (e) {
            var $target = $(e.target);
            var $element = $(e.currentTarget);
            var $wrapper = $element.closest('.has-error');

            if (!$target.is('a')) {
                if (e && e.preventDefault) e.preventDefault();
                if (e && e.stopImmediatePropagation) e.stopImmediatePropagation();
            }

            if ($wrapper.data('ignore-click')) {
                return;
            }

            if (!$wrapper.find('.has-error-content').hasClass('persist')) {
                $wrapper.find('.has-error-content').remove();
                $wrapper.removeClass('has-error');
            }
        },

        onReadMoreLinkClick: function (e) {
            e.preventDefault();
            var $el = $(e.currentTarget);
            $('#' + $el.data('for')).prop('checked', true);
        },

        onReadMoreRollbackLinkClick: function (e) {
            e.preventDefault();
            var $el = $(e.currentTarget);
            $('#' + $el.data('for')).prop('checked', false);
        },

        onInputFocus: function (e) {
            var $element = $(e.currentTarget);
            var $group = $element.closest('.form-group');

            var type = $element.attr('type');

            if (!type) {
                if ($element.is('textarea')) {
                    type = 'textarea';
                }
            }

            switch (type) {
                case 'text':
                case 'color':
                case 'date':
                case 'datetime':
                case 'datetime-local':
                case 'email':
                case 'file':
                case 'image':
                case 'month':
                case 'number':
                case 'password':
                case 'range':
                case 'search':
                case 'tel':
                case 'time':
                case 'url':
                case 'week':
                case 'textarea':
                    $group.addClass('has-focus');
                    break;
            }
        },

        onInputBlur: function (e) {
            this.checkValue($(e.currentTarget));
        },

        onRefreshInput: function (e) {
            this.checkValue($(e.currentTarget));
        },

        onCheckboxChange: function (e) {
            var $el = $(e.currentTarget);
            var $wrapper = $el.closest('.checkbox.needs-validation');

            this.addValidated($wrapper);
            this.removeValid($wrapper);

            if ($el.is(':checked')) {
                $wrapper.addClass('valid');
            } else {
                $wrapper.addClass('invalid');
            }
        },

        onRadioChange: function (e) {
            var $el = $(e.currentTarget);
            var $wrapper = $el.closest('.radio.needs-validation');
            var $allWrappers = $el.closest('form').find('input[name="' + $el.attr('name') + '"]');
            $allWrappers = $allWrappers.closest('.radio.needs-validation');

            this.removeValid($allWrappers);
            this.addValidated($wrapper);

            if ($el.is(':checked')) {
                $wrapper.addClass('valid');
            } else {
                $wrapper.addClass('invalid');
            }
        },

        onShowCustomerNumberChange: function (e) {
            var $el = $(e.currentTarget);
            var $target = this.$($el.data('target'));
            var $input = $target.find('input');

            if ($el.val() === "1" && $target.length) {
                $target.removeClass('collapsed');

                if ($input.data('required') === true) {
                    $input.attr('required', 'required');
                }
            } else {
                $target.addClass('collapsed');
                $input.removeAttr('required');
            }
        },

        onShowOptionalPwChange: function (e) {
            var $el = $(e.currentTarget);
            var $target = this.$($el.data('target'));
            var $input = $target.find('input');
            var $elToShow = null;
            var $elToHide = null;

            $el.prop('disabled', true);

            if ($target.length) {
                if ($el.is(':checked')) {
                    $elToShow = $target.find('.option-no-pw');
                    $elToHide = $target.find('.option-pw')
                    $input.removeAttr('required');
                } else {
                    $elToShow = $target.find('.option-pw');
                    $elToHide = $target.find('.option-no-pw')
                    $input.attr('required', 'required');
                }

                $target.addClass('collapsed');

                _.delay(function () {
                    $target.removeClass('collapsed');
                    $elToHide.addClass('hidden');
                    $elToShow.removeClass('hidden');
                    $el.prop('disabled', false);
                }, 400);
            }
        },
    });

    module.exports = ModuleFormView;
});

define('dev',['require','exports','module','views/FormView'],function (require, exports, module) {
    'use strict';

    (function () {
        var steps = {
            'start': {
                template: '#module-login-start',
                data: {},
            },
            'pw': {
                template: '#module-login-pw',
                data: {email: 'test@example.com'},
            },
            'zip': {
                template: '#module-login-zip',
                data: {customerNumberExtern: 'A123456789'},
            },
            'forgot-pw': {
                template: '#module-login-forgot-pw',
                data: {identifier: 'test@example.com'},
            },
            'country-zip': {
                template: '#module-login-country-zip',
                data: {},
            },
            'email-new': {
                template: '#module-login-email-new',
                data: {},
            },
            'code': {
                template: '#module-login-code',
                data: {},
            },
            'pw-new': {
                template: '#module-login-pw-new',
                data: {},
            },
        };

        function renderStep(step) {
            console.log('step:', step, '-', steps[step].template);
            console.log(steps[step].data);

            var $container = $('#login-screen');
            var tmpl = _.template($(steps[step].template).html());
            var html = tmpl(steps[step].data);
            $container.empty().append(html);

            var FormView = require('views/FormView');
            new FormView({
                el: '#login-screen .module-form',
            });

            $container.find('.selectpicker').selectpicker({ size: 4 });
        }

        $('.render-step').on('click', function(e) {
            var step = $(e.currentTarget).data('step');
            renderStep(step);
        });
    })();
});

define('theme',['require','exports','module','underscore','backbone','backbone-super','bootstrap','dev'],function (require, exports, module) {
    "use strict";

    // External dependencies.
    var _ = require("underscore");

    var Backbone = require("backbone");
    require("backbone-super");
    require("bootstrap");
    require('dev');

    // Alias the module for easier identification.
    var theme = module.exports;

    // The root path to run the application through.
    theme.root = $("body").data("root") || "/";

    theme.views = [];
});

;(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    define('james-search',[], factory);
  } else if (typeof exports === 'object') {
    module.exports = factory();
  } else {
    root.JamesSearch = factory();
  }
}(this, function() {
//     Underscore.js 1.8.3
//     http://underscorejs.org
//     (c) 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
//     Underscore may be freely distributed under the MIT license.

var Utils = {};

// Save bytes in the minified (but not gzipped) version:
Utils.ArrayProto = Array.prototype;

// Create quick reference variables for speed access to core prototypes.
Utils.slice = Utils.ArrayProto.slice;

// Save bytes in the minified (but not gzipped) version:
Utils.FuncProto = Function.prototype;

// All **ECMAScript 5** native function implementations that we hope to use
// are declared here.
Utils.nativeBind = Utils.FuncProto.bind;
Utils.nativeCreate = Object.create;

// Naked function reference for surrogate-prototype-swapping.
Utils.Ctor = function () {};

// Get the current timestamp as an integer.
Utils.now = Date.now || function () {
    return new Date().getTime();
};

// Is a given variable an object?
Utils.isObject = function (obj) {
    var type = typeof obj;
    return type === 'function' || type === 'object' && !!obj;
};

// Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
// IE 11 (#1621), and in Safari 8 (#1929).
if (typeof /./ != 'function' && typeof Int8Array != 'object') {
    Utils.isFunction = function (obj) {
        return typeof obj == 'function' || false;
    };
}

/**
 * An internal function for creating a new object that inherits from another.
 * @param  {Object} prototype
 * @return {Object}
 */
var baseCreate = function (prototype) {
    if (!Utils.isObject(prototype)) return {};
    if (Utils.nativeCreate) return Utils.nativeCreate(prototype);
    Utils.Ctor.prototype = prototype;
    var result = new Utils.Ctor;
    Utils.Ctor.prototype = null;
    return result;
};

/**
 * Determines whether to execute a function as a constructor
 * or a normal function with the provided arguments.
 * @param  {Function} sourceFunc
 * @param  {Function} boundFunc
 * @param  {Object} context
 * @param  {Object} callingContext
 * @param  {Mixed} args
 * @return {Object}
 */
Utils.executeBound = function (sourceFunc, boundFunc, context, callingContext, args) {
    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
    var self = baseCreate(sourceFunc.prototype);
    var result = sourceFunc.apply(self, args);
    if (Utils.isObject(result)) return result;
    return self;
};

//
/**
 * Create a function bound to a given object (assigning `this`, and arguments,
 * optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if available.
 * @param  {Function} func
 * @param  {Object} context
 * @return {Function}
 */
Utils.bind = function (func, context) {
    if (Utils.nativeBind && func.bind === Utils.nativeBind) return Utils.nativeBind.apply(func, Utils.slice.call(arguments, 1));
    if (!Utils.isFunction(func)) throw new TypeError('Bind must be called on a function');
    var args = Utils.slice.call(arguments, 2);
    var bound = function () {
        return Utils.executeBound(func, bound, context, this, args.concat(Utils.slice.call(arguments)));
    };
    return bound;
};

/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing.
 * @param  {Function} func
 * @param  {Integer} wait
 * @param  {Boolean} immediate
 * @return {Function}
 */
Utils.debounce = function (func, wait, immediate) {
    var timeout, args, context, timestamp, result;

    var later = function () {
        var last = Utils.now() - timestamp;

        if (last < wait && last >= 0) {
            timeout = setTimeout(later, wait - last);
        } else {
            timeout = null;
            if (!immediate) {
                result = func.apply(context, args);
                if (!timeout) context = args = null;
            }
        }
    };

    return function () {
        context = this;
        args = arguments;
        timestamp = Utils.now();
        var callNow = immediate && !timeout;
        if (!timeout) timeout = setTimeout(later, wait);
        if (callNow) {
            result = func.apply(context, args);
            context = args = null;
        }

        return result;
    };
};

/**
 * Parse a given value as boolean.
 * @param  {Mixed} options
 * @param  {Mixed} def
 * @return {Boolean}
 */
Utils.parseBoolean = function (data, def) {
    var out;

    if (typeof data === 'boolean') {
        out = data;
    } else if (typeof data === 'string') {
        out = JSON.parse(data);
    } else if (typeof def === 'boolean') {
        out = def;
    } else if (typeof def === 'string') {
        out = JSON.parse(def);
    } else {
        out = false;
    }

    return out;
};


/**
 * Overwrite values in data.
 * @param {Object} data Serialized data array.
 * @param {String} name Name of the parameter.
 * @param {Mixed} value Value of the parameter.
 * @return {Object} Parsed serialized data array.
 */
Utils.addValuesToData = function (data, name, value) {
    var index = Utils.findInData(data, 'name', name);

    if (index < 0) {
        data.push({
            name: name,
            value: value
        });
    } else {
        data[index].value = value;
    }

    return data;
};


/**
 * Find an element in an array by attribute name.
 * @param {Array} array
 * @param {String} name
 * @param {Mixed} value
 * @return {Number}
 */
Utils.findInData = function (array, name, value) {
    if (Array.isArray(array)) {
        for (var i = 0; i < array.length; i++) {
            if (array[i][name] === value) {
                return i;
            }
        }
    }

    return -1;
};

/**
 * Zepto.js 1.2.0
 * @param  {Array} form
 * @return {String}
 */
Utils.serializeArray = function (form) {
    var name, type, result = [],
        add = function (value) {
            if (value.forEach) return value.forEach(add)
            result.push({
                name: name,
                value: value
            })
        }
    if (form) Array.prototype.forEach.call(form.elements, function (field, _) {
        type = field.type, name = field.name
        if (name && field.nodeName.toLowerCase() != 'fieldset' &&
            !field.disabled && type != 'submit' && type != 'reset' && type != 'button' && type != 'file' &&
            ((type != 'radio' && type != 'checkbox') || field.checked))
            add(field.value)
    })
    return result
}

/**
 * Zepto.js 1.2.0
 * @param  {DOMElement} form
 * @return {String}
 */
Utils.serialize = function (form) {
    var result = [];
    Utils.serializeArray(form).forEach(function (el) {
        result.push(encodeURIComponent(el.name) + '=' + encodeURIComponent(el.value));
    })
    return result.join('&');
};

/**
 * Parse the data of the form.
 * @param {Object} data Serialized data array.
 * @return {Object} Parsed serialized data array.
 */
Utils.parseFormData = function (data) {
    var output = [],
        i, j, item;

    for (i = 0; i < data.length; i++) {
        item = data[i];

        if (Array.isArray(item.value) && item.value.length > 1) {
            for (j = 0; j < item.value.length; j++) {
                if (item.value[j]) {
                    output.push(item.name + '[]=' + encodeURIComponent(item.value[j] || ''));
                }
            }
        } else if (Array.isArray(item.value)) {
            output.push(item.name + '=' + encodeURIComponent(item.value[0] || ''));
        } else {
            output.push(item.name + '=' + encodeURIComponent(item.value || ''));
        }
    }

    return output.join('&');
};

/**
 * Allow attaching "document ready" event listeners.
 * @param  {Function} cb A callback
 */
Utils.ready = function ready(cb) {
    if (document.attachEvent ? document.readyState === 'complete' : document.readyState !== 'loading') {
        cb();
    } else {
        document.addEventListener('DOMContentLoaded', cb);
    }
}

/**
 * http://youmightnotneedjquery.com
 * @param  {DOMElement} el
 * @param  {String} className
 * @return {Boolean}
 */
Utils.hasClass = function (el, className) {
    if (el.classList)
        return el.classList.contains(className);
    else
        return new RegExp('(^| )' + className + '( |$)', 'gi').test(el.className);
};

/**
 * http://youmightnotneedjquery.com
 * @param  {DOMElement} el
 * @param  {String} className
 * @return {DOMElement}
 */
Utils.addClass = function (el, className) {
    if (el.classList)
        return el.classList.add(className);
    else
        return el.className += ' ' + className;
};

/**
 * http://youmightnotneedjquery.com
 * @param  {DOMElement} el
 * @param  {String} className
 * @return {DOMElement}
 */
Utils.removeClass = function (el, className) {
    if (el.classList) {
        return el.classList.remove(className);
    }

    return el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
};

/**
 * https://developer.mozilla.org/en-US/docs/Web/API/Element/closest
 * @param  {DOMElement} el
 * @param  {String} className
 * @return {DOMElement || null}
 */
Utils.closest = function (el, selector) {
    if (!document.documentElement.contains(el)) return null;

    do {
        if (Utils.matches(el, selector)) return el;
        el = el.parentElement || el.parentNode;
    } while (el !== null && el.nodeType === 1);
    return null;
};

/**
 * http://youmightnotneedjquery.com
 * @param  {DOMElement} el
 * @param  {String} selector
 * @return {Boolean}
 */
Utils.matches = function(el, selector) {
  return (el.matches || el.matchesSelector || el.msMatchesSelector || el.mozMatchesSelector || el.webkitMatchesSelector || el.oMatchesSelector).call(el, selector);
};

//
/**
 * https://github.com/nefe/You-Dont-Need-jQuery
 * @param  {DOMElement} el
 * @return {Object}
 */
Utils.offset = function (el) {
    var box = el.getBoundingClientRect();

    return {
        top: box.top + window.pageYOffset - document.documentElement.clientTop,
        left: box.left + window.pageXOffset - document.documentElement.clientLeft,
    };
};

/**
 * Force HTML to TEXT.
 * @param  {String} html
 * @return {String}
 */
Utils.htmlToText = function (html) {
    var el = document.createElement('DIV');
    el.innerHTML = html || '';

    return (el.textContent || '').trim();
};

/**
 * Force TEXT to HTML.
 * @param  {String} html
 * @return {String}
 */
Utils.textToHTML = function (html) {
    var el = document.createElement('DIV');
    el.innerHTML = (html || '').trim();

    return el.firstChild;
};

/**
 * List of document listeners to allow removing them later.
 * @static
 * @type {Object}
 */
Utils.documentListeners = {};

/**
 * Add an event listener to document (for elements that possble were not renderen when attaching the event listener).
 * @param {String} name Name of the event.
 * @param {String} selector The selector to be matched.
 * @param {Function} handler The callback function.
 */
Utils.addDocumentEvent = function(name, selector, handler) {
    var listener = function(e) {
        if (Utils.matches(e.target, selector + ', ' + selector + ' *')) {
            handler.apply(document, arguments);
        }
    };

    if (!handler.guid) {
        handler.guid = Object.keys(Utils.documentListeners).length;
    }

    Utils.documentListeners[handler.guid] = listener;
    document.addEventListener(name, listener, false);
};

/**
 * Remove an event listener from document.
 * @param {String} selector The selector to be matched.
 * @param {Function} handler The callback function.
 */
Utils.removeDocumentEvent = function(name, handler) {
    if (Object.keys(Utils.documentListeners).length && !isNaN(handler.guid)) {
        document.removeEventListener(name, Utils.documentListeners[handler.guid]);
    }
};

/**
 * Add an event listener.
 * @param {Object} obj The object the listener should be added.
 * @param {String} name ID of the event to be listened.
 * @param {Function} callback Callback function.
 * @return {this}
 */
Utils.on = Utils.addEventListener = function (obj, name, callback) {
    if (Utils.isObject(obj) && name && callback && typeof callback == 'function') {
        if (!('listeners' in obj) || !Array.isArray(obj.listeners)) {
            obj.listeners = [];
        }

        // Add a new listener
        obj.listeners.push({
            name: name,
            callback: callback
        });
    }

    return obj;
};

/**
 * Remove an event listener.
 * @param {Object} obj The object the listener should be added.
 * @param {String} name ID of the event to be listened.
 * @param {Function} callback Callback function.
 */
Utils.off = Utils.removeEventListener = function (obj, name, callback) {
    if (Utils.isObject(obj) && name) {
        var i, item;
        if ('listeners' in obj && Array.isArray(obj.listeners)) {
            for (i = obj.listeners.length - 1; i >= 0; i--) {
                item = obj.listeners[i];

                // Remove the desired object
                if (item.name == name && ((!callback) || (item.callback === callback))) {
                    obj.listeners.splice(i, 1);
                }
            }
        }
    } else if (Utils.isObject(obj)) {
        // Remove all the listeners.
        obj.listeners = [];
    }

    return obj;
};

/**
 * Trigger an event to current listeners and trigger it also to the DOM.
 * @param {Object} obj The object the listener should be added.
 * @param {String} name ID of the event to be triggered.
 * @param {Array} data Attached data.
 */
Utils.trigger = function (obj, name, data) {
    if (!name) return;

    // The target for the event trigger.
    var target = document;

    // DOM trigger
    // Create the event.
    var event = document.createEvent('Event');

    // Define that the event name is 'build'.
    event.initEvent(name, true, true);

    // Add data to the event
    event.data = data;

    if (Utils.isObject(obj)) {
        if (obj.el instanceof HTMLElement) {
            // Target can be any HTMLElement.
            target = obj.el;
        }

        target.dispatchEvent(event);

        if ('listeners' in obj && Array.isArray(obj.listeners)) {
            var i, item;
            for (i = obj.listeners.length - 1; i >= 0; i--) {
                item = obj.listeners[i];

                // Find & fire the desired listeners
                if (item.name === name && item.callback && 'el' in obj) {
                    item.callback.call(obj.el, event);
                }
            }
        }
    }
};

var Mustache = {};

(function (mustache) {

    var objectToString = Object.prototype.toString;
    var isArray = Array.isArray || function isArrayPolyfill(object) {
        return objectToString.call(object) === '[object Array]';
    };

    function isFunction(object) {
        return typeof object === 'function';
    }

    /**
     * More correct typeof string handling array
     * which normally returns typeof 'object'
     */
    function typeStr(obj) {
        return isArray(obj) ? 'array' : typeof obj;
    }

    function escapeRegExp(string) {
        return string.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, '\\$&');
    }

    /**
     * Null safe way of checking whether or not an object,
     * including its prototype, has a given property
     */
    function hasProperty(obj, propName) {
        return obj != null && typeof obj === 'object' && (propName in obj);
    }

    // Workaround for https://issues.apache.org/jira/browse/COUCHDB-577
    // See https://github.com/janl/mustache.js/issues/189
    var regExpTest = RegExp.prototype.test;

    function testRegExp(re, string) {
        return regExpTest.call(re, string);
    }

    var nonSpaceRe = /\S/;

    function isWhitespace(string) {
        return !testRegExp(nonSpaceRe, string);
    }

    var entityMap = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
        '/': '&#x2F;',
        '`': '&#x60;',
        '=': '&#x3D;'
    };

    function escapeHtml(string) {
        return String(string).replace(/[&<>"'`=\/]/g, function fromEntityMap(s) {
            return entityMap[s];
        });
    }

    var whiteRe = /\s*/;
    var spaceRe = /\s+/;
    var equalsRe = /\s*=/;
    var curlyRe = /\s*\}/;
    var tagRe = /#|\^|\/|>|\{|&|=|!/;

    /**
     * Breaks up the given `template` string into a tree of tokens. If the `tags`
     * argument is given here it must be an array with two string values: the
     * opening and closing tags used in the template (e.g. [ "<%", "%>" ]). Of
     * course, the default is to use mustaches (i.e. mustache.tags).
     *
     * A token is an array with at least 4 elements. The first element is the
     * mustache symbol that was used inside the tag, e.g. "#" or "&". If the tag
     * did not contain a symbol (i.e. {{myValue}}) this element is "name". For
     * all text that appears outside a symbol this element is "text".
     *
     * The second element of a token is its "value". For mustache tags this is
     * whatever else was inside the tag besides the opening symbol. For text tokens
     * this is the text itself.
     *
     * The third and fourth elements of the token are the start and end indices,
     * respectively, of the token in the original template.
     *
     * Tokens that are the root node of a subtree contain two more elements: 1) an
     * array of tokens in the subtree and 2) the index in the original template at
     * which the closing tag for that section begins.
     */
    function parseTemplate(template, tags) {
        if (!template)
            return [];

        var sections = []; // Stack to hold section tokens
        var tokens = []; // Buffer to hold the tokens
        var spaces = []; // Indices of whitespace tokens on the current line
        var hasTag = false; // Is there a {{tag}} on the current line?
        var nonSpace = false; // Is there a non-space char on the current line?

        // Strips all whitespace tokens array for the current line
        // if there was a {{#tag}} on it and otherwise only space.
        function stripSpace() {
            if (hasTag && !nonSpace) {
                while (spaces.length)
                    delete tokens[spaces.pop()];
            } else {
                spaces = [];
            }

            hasTag = false;
            nonSpace = false;
        }

        var openingTagRe, closingTagRe, closingCurlyRe;

        function compileTags(tagsToCompile) {
            if (typeof tagsToCompile === 'string')
                tagsToCompile = tagsToCompile.split(spaceRe, 2);

            if (!isArray(tagsToCompile) || tagsToCompile.length !== 2)
                throw new Error('Invalid tags: ' + tagsToCompile);

            openingTagRe = new RegExp(escapeRegExp(tagsToCompile[0]) + '\\s*');
            closingTagRe = new RegExp('\\s*' + escapeRegExp(tagsToCompile[1]));
            closingCurlyRe = new RegExp('\\s*' + escapeRegExp('}' + tagsToCompile[1]));
        }

        compileTags(tags || mustache.tags);

        var scanner = new Scanner(template);

        var start, type, value, chr, token, openSection;
        while (!scanner.eos()) {
            start = scanner.pos;

            // Match any text between tags.
            value = scanner.scanUntil(openingTagRe);

            if (value) {
                for (var i = 0, valueLength = value.length; i < valueLength; ++i) {
                    chr = value.charAt(i);

                    if (isWhitespace(chr)) {
                        spaces.push(tokens.length);
                    } else {
                        nonSpace = true;
                    }

                    tokens.push(['text', chr, start, start + 1]);
                    start += 1;

                    // Check for whitespace on the current line.
                    if (chr === '\n')
                        stripSpace();
                }
            }

            // Match the opening tag.
            if (!scanner.scan(openingTagRe))
                break;

            hasTag = true;

            // Get the tag type.
            type = scanner.scan(tagRe) || 'name';
            scanner.scan(whiteRe);

            // Get the tag value.
            if (type === '=') {
                value = scanner.scanUntil(equalsRe);
                scanner.scan(equalsRe);
                scanner.scanUntil(closingTagRe);
            } else if (type === '{') {
                value = scanner.scanUntil(closingCurlyRe);
                scanner.scan(curlyRe);
                scanner.scanUntil(closingTagRe);
                type = '&';
            } else {
                value = scanner.scanUntil(closingTagRe);
            }

            // Match the closing tag.
            if (!scanner.scan(closingTagRe))
                throw new Error('Unclosed tag at ' + scanner.pos);

            token = [type, value, start, scanner.pos];
            tokens.push(token);

            if (type === '#' || type === '^') {
                sections.push(token);
            } else if (type === '/') {
                // Check section nesting.
                openSection = sections.pop();

                if (!openSection)
                    throw new Error('Unopened section "' + value + '" at ' + start);

                if (openSection[1] !== value)
                    throw new Error('Unclosed section "' + openSection[1] + '" at ' + start);
            } else if (type === 'name' || type === '{' || type === '&') {
                nonSpace = true;
            } else if (type === '=') {
                // Set the tags for the next time around.
                compileTags(value);
            }
        }

        // Make sure there are no open sections when we're done.
        openSection = sections.pop();

        if (openSection)
            throw new Error('Unclosed section "' + openSection[1] + '" at ' + scanner.pos);

        return nestTokens(squashTokens(tokens));
    }

    /**
     * Combines the values of consecutive text tokens in the given `tokens` array
     * to a single token.
     */
    function squashTokens(tokens) {
        var squashedTokens = [];

        var token, lastToken;
        for (var i = 0, numTokens = tokens.length; i < numTokens; ++i) {
            token = tokens[i];

            if (token) {
                if (token[0] === 'text' && lastToken && lastToken[0] === 'text') {
                    lastToken[1] += token[1];
                    lastToken[3] = token[3];
                } else {
                    squashedTokens.push(token);
                    lastToken = token;
                }
            }
        }

        return squashedTokens;
    }

    /**
     * Forms the given array of `tokens` into a nested tree structure where
     * tokens that represent a section have two additional items: 1) an array of
     * all tokens that appear in that section and 2) the index in the original
     * template that represents the end of that section.
     */
    function nestTokens(tokens) {
        var nestedTokens = [];
        var collector = nestedTokens;
        var sections = [];

        var token, section;
        for (var i = 0, numTokens = tokens.length; i < numTokens; ++i) {
            token = tokens[i];

            switch (token[0]) {
                case '#':
                case '^':
                    collector.push(token);
                    sections.push(token);
                    collector = token[4] = [];
                    break;
                case '/':
                    section = sections.pop();
                    section[5] = token[2];
                    collector = sections.length > 0 ? sections[sections.length - 1][4] : nestedTokens;
                    break;
                default:
                    collector.push(token);
            }
        }

        return nestedTokens;
    }

    /**
     * A simple string scanner that is used by the template parser to find
     * tokens in template strings.
     */
    function Scanner(string) {
        this.string = string;
        this.tail = string;
        this.pos = 0;
    }

    /**
     * Returns `true` if the tail is empty (end of string).
     */
    Scanner.prototype.eos = function eos() {
        return this.tail === '';
    };

    /**
     * Tries to match the given regular expression at the current position.
     * Returns the matched text if it can match, the empty string otherwise.
     */
    Scanner.prototype.scan = function scan(re) {
        var match = this.tail.match(re);

        if (!match || match.index !== 0)
            return '';

        var string = match[0];

        this.tail = this.tail.substring(string.length);
        this.pos += string.length;

        return string;
    };

    /**
     * Skips all text until the given regular expression can be matched. Returns
     * the skipped string, which is the entire tail if no match can be made.
     */
    Scanner.prototype.scanUntil = function scanUntil(re) {
        var index = this.tail.search(re),
            match;

        switch (index) {
            case -1:
                match = this.tail;
                this.tail = '';
                break;
            case 0:
                match = '';
                break;
            default:
                match = this.tail.substring(0, index);
                this.tail = this.tail.substring(index);
        }

        this.pos += match.length;

        return match;
    };

    /**
     * Represents a rendering context by wrapping a view object and
     * maintaining a reference to the parent context.
     */
    function Context(view, parentContext) {
        this.view = view;
        this.cache = {
            '.': this.view
        };
        this.parent = parentContext;
    }

    /**
     * Creates a new context using the given view with this context
     * as the parent.
     */
    Context.prototype.push = function push(view) {
        return new Context(view, this);
    };

    /**
     * Returns the value of the given name in this context, traversing
     * up the context hierarchy if the value is absent in this context's view.
     */
    Context.prototype.lookup = function lookup(name) {
        var cache = this.cache;

        var value;
        if (cache.hasOwnProperty(name)) {
            value = cache[name];
        } else {
            var context = this,
                names, index, lookupHit = false;

            while (context) {
                if (name.indexOf('.') > 0) {
                    value = context.view;
                    names = name.split('.');
                    index = 0;

                    /**
                     * Using the dot notion path in `name`, we descend through the
                     * nested objects.
                     *
                     * To be certain that the lookup has been successful, we have to
                     * check if the last object in the path actually has the property
                     * we are looking for. We store the result in `lookupHit`.
                     *
                     * This is specially necessary for when the value has been set to
                     * `undefined` and we want to avoid looking up parent contexts.
                     **/
                    while (value != null && index < names.length) {
                        if (index === names.length - 1)
                            lookupHit = hasProperty(value, names[index]);

                        value = value[names[index++]];
                    }
                } else {
                    value = context.view[name];
                    lookupHit = hasProperty(context.view, name);
                }

                if (lookupHit)
                    break;

                context = context.parent;
            }

            cache[name] = value;
        }

        if (isFunction(value))
            value = value.call(this.view);

        return value;
    };

    /**
     * A Writer knows how to take a stream of tokens and render them to a
     * string, given a context. It also maintains a cache of templates to
     * avoid the need to parse the same template twice.
     */
    function Writer() {
        this.cache = {};
    }

    /**
     * Clears all cached templates in this writer.
     */
    Writer.prototype.clearCache = function clearCache() {
        this.cache = {};
    };

    /**
     * Parses and caches the given `template` and returns the array of tokens
     * that is generated from the parse.
     */
    Writer.prototype.parse = function parse(template, tags) {
        var cache = this.cache;
        var tokens = cache[template];

        if (tokens == null)
            tokens = cache[template] = parseTemplate(template, tags);

        return tokens;
    };

    /**
     * High-level method that is used to render the given `template` with
     * the given `view`.
     *
     * The optional `partials` argument may be an object that contains the
     * names and templates of partials that are used in the template. It may
     * also be a function that is used to load partial templates on the fly
     * that takes a single argument: the name of the partial.
     */
    Writer.prototype.render = function render(template, view, partials) {
        var tokens = this.parse(template);
        var context = (view instanceof Context) ? view : new Context(view);
        return this.renderTokens(tokens, context, partials, template);
    };

    /**
     * Low-level method that renders the given array of `tokens` using
     * the given `context` and `partials`.
     *
     * Note: The `originalTemplate` is only ever used to extract the portion
     * of the original template that was contained in a higher-order section.
     * If the template doesn't use higher-order sections, this argument may
     * be omitted.
     */
    Writer.prototype.renderTokens = function renderTokens(tokens, context, partials, originalTemplate) {
        var buffer = '';

        var token, symbol, value;
        for (var i = 0, numTokens = tokens.length; i < numTokens; ++i) {
            value = undefined;
            token = tokens[i];
            symbol = token[0];

            if (symbol === '#') value = this.renderSection(token, context, partials, originalTemplate);
            else if (symbol === '^') value = this.renderInverted(token, context, partials, originalTemplate);
            else if (symbol === '>') value = this.renderPartial(token, context, partials, originalTemplate);
            else if (symbol === '&') value = this.unescapedValue(token, context);
            else if (symbol === 'name') value = this.escapedValue(token, context);
            else if (symbol === 'text') value = this.rawValue(token);

            if (value !== undefined)
                buffer += value;
        }

        return buffer;
    };

    Writer.prototype.renderSection = function renderSection(token, context, partials, originalTemplate) {
        var self = this;
        var buffer = '';
        var value = context.lookup(token[1]);

        // This function is used to render an arbitrary template
        // in the current context by higher-order sections.
        function subRender(template) {
            return self.render(template, context, partials);
        }

        if (!value) return;

        if (isArray(value)) {
            for (var j = 0, valueLength = value.length; j < valueLength; ++j) {
                buffer += this.renderTokens(token[4], context.push(value[j]), partials, originalTemplate);
            }
        } else if (typeof value === 'object' || typeof value === 'string' || typeof value === 'number') {
            buffer += this.renderTokens(token[4], context.push(value), partials, originalTemplate);
        } else if (isFunction(value)) {
            if (typeof originalTemplate !== 'string')
                throw new Error('Cannot use higher-order sections without the original template');

            // Extract the portion of the original template that the section contains.
            value = value.call(context.view, originalTemplate.slice(token[3], token[5]), subRender);

            if (value != null)
                buffer += value;
        } else {
            buffer += this.renderTokens(token[4], context, partials, originalTemplate);
        }
        return buffer;
    };

    Writer.prototype.renderInverted = function renderInverted(token, context, partials, originalTemplate) {
        var value = context.lookup(token[1]);

        // Use JavaScript's definition of falsy. Include empty arrays.
        // See https://github.com/janl/mustache.js/issues/186
        if (!value || (isArray(value) && value.length === 0))
            return this.renderTokens(token[4], context, partials, originalTemplate);
    };

    Writer.prototype.renderPartial = function renderPartial(token, context, partials) {
        if (!partials) return;

        var value = isFunction(partials) ? partials(token[1]) : partials[token[1]];
        if (value != null)
            return this.renderTokens(this.parse(value), context, partials, value);
    };

    Writer.prototype.unescapedValue = function unescapedValue(token, context) {
        var value = context.lookup(token[1]);
        if (value != null)
            return value;
    };

    Writer.prototype.escapedValue = function escapedValue(token, context) {
        var value = context.lookup(token[1]);
        if (value != null)
            return mustache.escape(value);
    };

    Writer.prototype.rawValue = function rawValue(token) {
        return token[1];
    };

    mustache.name = 'mustache.js';
    mustache.version = '2.3.0';
    mustache.tags = ['{{', '}}'];

    // All high-level mustache.* functions use this writer.
    var defaultWriter = new Writer();

    /**
     * Clears all cached templates in the default writer.
     */
    mustache.clearCache = function clearCache() {
        return defaultWriter.clearCache();
    };

    /**
     * Parses and caches the given template in the default writer and returns the
     * array of tokens it contains. Doing this ahead of time avoids the need to
     * parse templates on the fly as they are rendered.
     */
    mustache.parse = function parse(template, tags) {
        return defaultWriter.parse(template, tags);
    };

    /**
     * Renders the `template` with the given `view` and `partials` using the
     * default writer.
     */
    mustache.render = function render(template, view, partials) {
        if (typeof template !== 'string') {
            throw new TypeError('Invalid template! Template should be a "string" ' +
                'but "' + typeStr(template) + '" was given as the first ' +
                'argument for mustache#render(template, view, partials)');
        }

        return defaultWriter.render(template, view, partials);
    };

    // This is here for backwards compatibility with 0.4.x.,
    /*eslint-disable */ // eslint wants camel cased function name
    mustache.to_html = function to_html(template, view, partials, send) {
        /*eslint-enable*/

        var result = mustache.render(template, view, partials);

        if (isFunction(send)) {
            send(result);
        } else {
            return result;
        }
    };

    // Export the escaping function so that the user may override it.
    // See https://github.com/janl/mustache.js/issues/244
    mustache.escape = escapeHtml;

    // Export these mainly for testing, but also for advanced usage.
    mustache.Scanner = Scanner;
    mustache.Context = Context;
    mustache.Writer = Writer;
})(Mustache);

/**
 * @class JamesSearch
 * @param {String@DOMElement} el
 * @param {Object} options
 * @return {JamesSearch} New instance of JamesSearch.
 * @this JamesSearch
 */
var JamesSearch = function (options) {
    JamesSearch.instances.push(this);
    JamesSearch.prototype.initialize.call(this, options);
};

// Constructor.
JamesSearch.prototype.constructor = JamesSearch;

/**
 * Hold all JamesSearch instances.
 * @static
 * @type {Array}
 */
JamesSearch.instances = [];

/**
 * Create one or more JamesSearch instances if a global object|array jamesSearchOptions is defined.
 * @static
 */
JamesSearch.autoCreate = function() {
    var i = 0;

    Utils.ready(function () {
        if ('jamesSearchOptions' in window) {
            if (Array.isArray(jamesSearchOptions)) {
                for (i = 0; i < jamesSearchOptions.length; i++) {
                    new JamesSearch(jamesSearchOptions[i]);
                }
            } else {
                new JamesSearch(jamesSearchOptions);
            }
        }
    });
};

/**
 * Destroy all JamesSearch instances.
 * @static
 */
JamesSearch.destroyAll = function() {
    if (JamesSearch.instances) {
        Array.prototype.forEach.call(JamesSearch.instances, function(instance, i) {
            JamesSearch.destroyInstance(instance);
        });
    }
};

/**
 * Destroy a specific JamesSearch instance.
 * @static
 * @param  {JamesSearch} instance A JamesSearch instance.
 */
JamesSearch.destroyInstance = function(instance) {
    var index = JamesSearch.instances.indexOf(instance);
    if (index !== -1) {
        JamesSearch.instances.splice(index, 1);
    }

    if (instance.constructor === JamesSearch) {
        instance.destroy();
    }
};

/**
 * Define the error messages.
 * @static
 * @enum {String}
 */
JamesSearch.ERROR = {
    noDomObject: 'JamesSearch error: DOM Object not found',
    templateNotFound: 'JamesSearch error: Template not found',
    formNotFound: 'JamesSearch error: Form Element not found',
    inputNotFound: 'JamesSearch error: Input text Element not found',
};

/**
 * Define the type of events.
 * @static
 * @enum {String}
 */
JamesSearch.EVENTS = {
    ready:                      'james-search-ready',

    // Request events
    beforeSend:                 'james-search-before-send',
    success:                    'james-search-success',
    error:                      'james-search-error',
    complete:                   'james-search-complete',

    suggestTrackingBeforeSend:  'james-search-suggest-tracking-before-send',
    searchTrackingBeforeSend:   'james-search-search-tracking-before-send',

    // UI changes events
    boxBeforeAdd:               'james-search-box-before-add',
    boxAdded:                   'james-search-box-added',
    boxBeforeUpdate:            'james-search-box-before-update',
    boxUpdated:                 'james-search-box-updated',
    boxShown:                   'james-search-box-shown',
    boxEnter:                   'james-search-box-enter',
    boxLeave:                   'james-search-box-leave',
    boxHidden:                  'james-search-box-hidden',
    boxRemoved:                 'james-search-box-removed',
    boxBeforeResize:            'james-search-box-before-resize',
    boxResized:                 'james-search-box-resized',

    // User interaction events
    inputFocus:                 'james-search-input-focus',
    inputBlur:                  'james-search-input-blur',
    inputEnter:                 'james-search-input-enter',
    inputLeave:                 'james-search-input-leave',
    inputChange:                'james-search-input-change',
    inputUpdate:                'james-search-input-update',
};

/**
 * Triggered on ready.
 * @event JamesSearch#ready
 */

/**
 * Triggered before an ajax request is sent.
 * @event JamesSearch#before-send
 * @property {Mixed} data - The data to be sent.
 */

/**
 * Triggered on ajax request success.
 * @event JamesSearch#success
 * @property {Object} data - The data received.
 */

/**
 * Triggered on ajax request error.
 * @event JamesSearch#error
 * @property {XMLHttpRequest} xhr
 */

/**
 * Triggered on ajax request completed.
 * @event JamesSearch#complete
 * @property {XMLHttpRequest} xhr
 */

/**
 * Triggered before a suggest tracking ajax request is sent.
 * @event JamesSearch#suggest-tracking-before-send
 * @property {Mixed} data - The data to be sent.
 */

/**
 * Triggered before a search tracking ajax request is sent.
 * @event JamesSearch#search-tracking-before-send
 * @property {Mixed} data - The data to be sent.
 */

/**
 * Triggered before the autosuggest box has been added.
 * @event JamesSearch#box-before-add
 * @property {String} html - The box html.
 */

/**
 * Triggered after the autosuggest box has been added.
 * @event JamesSearch#box-added
 * @property {String|DOMElement} html - The box element.
 */

/**
 * Triggered before the autosuggest box has been updated.
 * @event JamesSearch#box-before-update
 * @property {String} html - The box html.
 */

/**
 * Triggered after the autosuggest box has been updated.
 * @event JamesSearch#box-updated
 * @property {String|DOMElement} html - The box element.
 */

/**
 * Triggered after the autosuggest box has been showed.
 * @event JamesSearch#box-shown
 * @property {String|DOMElement} html - The box element.
 */

/**
 * Triggered on entering the autosuggest box.
 * @event JamesSearch#box-enter
 */

/**
 * Triggered on leaving the autosuggest box.
 * @event JamesSearch#box-leave
 */

/**
 * Triggered after the autosuggest box has been hidden.
 * @event JamesSearch#box-hidden
 */

/**
 * Triggered after the autosuggest box has been removed.
 * @event JamesSearch#box-removed
 */

/**
 * Triggered after a window resize event and before new styles be applied to the autosuggest box.
 * @event JamesSearch#box-before-resize
 * @property {Object} style - Object with styles to be applied to the autosuggest box.
*/

/**
 * Triggered after a window resize event and after new styles has been applied to the autosuggest box.
 * @event JamesSearch#box-resized
 * @property {CSSStyleDeclaration} style - The style object of the autosuggest box.
 */

/**
 * Triggered on focusing the autosuggest input.
 * @event JamesSearch#input-focus
 * @property {DOMElement} el - The target input element.
 */

/**
 * Triggered on blurring the autosuggest input.
 * @event JamesSearch#input-blur
 * @property {DOMElement} el - The target input element.
 */

/**
 * Triggered on entering the autosuggest input.
 * @event JamesSearch#input-enter
 * @property {DOMElement} el - The target input element.
 */

/**
 * Triggered on leaving the autosuggest input.
 * @event JamesSearch#input-leave
 */

/**
 * Triggered on input change
 * @event JamesSearch#input-change
 * @property {Event} originalEvent - The original event from input element.
 */

/**
 * @namespace
 * @property {Object} defaults - Default options.
 * @property {Boolean} defaults.debug - Disable the remove box handlers of mouseleave and blur events for debugging/sytling; preventDefault when click on tracking links. Default: 'false'.
 *
 * @property {Object} defaults.suggest - Default suggest options.
 * @property {String|DOMElement} defaults.suggest.el - The el id or the element itsself.
 * @property {String|Array} defaults.suggest.token - Current token from data service.
 * @property {String} defaults.suggest.url - Target URL.
 * @property {String} defaults.suggest.trackingUrl - Target tracking URL.
 * @property {String} defaults.suggest.method - Method used in the request. Default: 'GET'.
 * @property {Array|Number} defaults.suggest.limit - Max elements showed. Default: '10'.
 * @property {Array|Number} defaults.suggest.offset - Page showed. Default: '0'.
 * @property {Array|Number} defaults.suggest.crop - Crop the text. Default: '250'.
 * @property {Number} defaults.suggest.minChars - Minimum length char for queries. Default: '3'.
 * @property {Number} defaults.suggest.delay - Delay of the trigger in milliseconds (ms). Default: '100'.
 * @property {String} defaults.suggest.position - Position of the box. Values: 'left' | 'right'. Default: 'left'.
 * @property {String} defaults.suggest.template - Template used to render the box or ID of the script tag where the template is contained.
 * @property {String} defaults.suggest.wrapperTemplate - Template used to render the box or ID of the script tag where the template is contained. Default: '&lt;div class="james-search-box"&gt;&lt;/div&gt;'.
 * @property {Boolean} defaults.suggest.keyboard - Give support to keyboard commands (escape, arrow up & arrow down) Default: 'true'.
 * @property {Boolean} defaults.suggest.horizontalKeyboard - Give support to keyboard commands (arrow right, arrow left). Useful when using columns. Default: 'false'.
 * @property {Number} defaults.suggest.margin - Margin to the border of the screen. Default: '15'.
 * @property {String} defaults.suggest.autoWidth - Set the default width rendering. Values: 'auto'|'fixed'. Default: 'auto'.
 * @property {Array} defaults.suggest.delimiters - Change the default delimiter tags of Mustache.js. Default: 'null'.
 * @property {Boolean} defaults.suggest.blurRemove - Remove the box from DOM when the focus is out. Default: 'false'.
 * @property {Boolean} defaults.suggest.inputDebounceDelay - Determines the amount of time (ms) that must pass until the debounced function is called again when changing the input. Default: '300'.
 *
 * @property {Object} defaults.search - Default search options.
 * @property {String} defaults.search.query - The query send to JamesSearch.
 * @property {String} defaults.search.selector - The selector of the link to search click URL.
 * @property {String} defaults.search.trackingUrl - Target tracking URL.
 * @property {String} defaults.search.method - Method used in the request. Default: 'GET'.
 */
JamesSearch.defaults = {
    debug: false,
    suggest: {
        el: null,
        token: [],
        url: '',
        trackingUrl: '',
        method: 'GET',
        limit: 10,
        offset: 0,
        crop: 250,
        minChars: 3,
        delay: 100,
        position: 'left',
        template: '',
        wrapperTemplate: '<div class="james-search-box"></div>',
        keyboard: true,
        horizontalKeyboard: false,
        margin: 15,
        autoWidth: 'auto',
        delimiters: null,
        blurRemove: false,
        inputDebounceDelay: 300,
    },
    search: {
        query: '',
        selector: '.results .link',
        trackingUrl: '',
        method: 'GET',
    },
};

/**
 * The function called after a new instance has been created.
 * @private
 * @param {Object} options
 */
JamesSearch.prototype.initialize = function (options) {
    this.window = null;
    this.body = null;
    this.form = null;
    this.input = null;
    this.box = null;
    this.query = '';
    this.listeners = [];

    this.xhr = null;

    this.parseOptions(options);
    this.bindFunctions();

    // Start the plugin (deferred)
    setTimeout(this.start, 0);
};

/**
 * Parse options into James own properties.
 * @function JamesSearch#parseOptions
 * @private
 * @param {Object} options
 * @return {this}
 * @throws noDomObject {Error} - DOM Object not found
 */
JamesSearch.prototype.parseOptions = function (options) {
    // Keep a reference to options
    this.options = options || {};

    // Deep clone defaults.
    this.defaults = JSON.parse(JSON.stringify(JamesSearch.defaults));

    this.debug = Utils.parseBoolean(this.options.debug, this.defaults.debug);

    if (options.suggest) {
        // Keep a reference to the dom element
        if (typeof options.suggest.el === 'string') {
            this.el = document.getElementById(options.suggest.el.replace(/#/, ''));
        } else if (options.suggest.el instanceof HTMLElement) {
            this.el = options.suggest.el;
        }

        // Throw an error if no element is found
        if (!this.el) {
            throw (this.ERROR.noDomObject);
        }

        this.form = this.options.suggest.form || this.defaults.suggest.form;
        this.form = document.getElementById(this.form.replace(/#/, ''));
        if (!this.form) {
            throw JamesSearch.ERROR.formNotFound;
        }

        // Extend manually the variables
        this.headers = this.options.suggest.headers || this.defaults.suggest.headers;
        this.token = this.options.suggest.token || this.defaults.suggest.token;
        this.url = this.options.suggest.url || this.defaults.suggest.url;
        this.method = (this.options.suggest.method || this.defaults.suggest.method).toUpperCase();
        this.suggestTrackingUrl = this.options.suggest.trackingUrl || this.defaults.suggest.trackingUrl;
        this.limit = this.options.suggest.limit || this.defaults.suggest.limit;
        this.offset = this.options.suggest.offset || this.defaults.suggest.offset;
        this.crop = this.options.suggest.crop || this.defaults.suggest.crop;
        this.minChars = this.options.suggest.minChars || this.defaults.suggest.minChars;
        this.delay = this.options.suggest.delay || this.defaults.suggest.delay;
        this.position = this.options.suggest.position || this.defaults.suggest.position;
        this.margin = this.options.suggest.margin || this.defaults.suggest.margin;
        this.autoWidth = this.options.suggest.autoWidth || this.defaults.suggest.autoWidth;
        this.delimiters = this.options.suggest.delimiters || this.defaults.suggest.delimiters;

        // Parse booleans
        this.keyboard = Utils.parseBoolean(this.options.suggest.keyboard, this.defaults.suggest.keyboard);
        this.horizontalKeyboard = Utils.parseBoolean(this.options.suggest.horizontalKeyboard, this.defaults.suggest.horizontalKeyboard);
        this.blurRemove = Utils.parseBoolean(this.options.suggest.blurRemove, this.defaults.suggest.blurRemove);
        this.inputDebounceDelay = this.options.suggest.inputDebounceDelay || this.defaults.suggest.inputDebounceDelay;

        // Init the template
        this.template = this.initTemplate(this.options.suggest.template || '');

        // Init the wrapper template
        this.wrapperTemplate = this.initTemplate(this.options.suggest.wrapperTemplate || this.defaults.suggest.wrapperTemplate);

        // Parse the Array variables
        if (!Array.isArray(this.token)) {
            this.token = this.token.split(',');
        }
        if (!Array.isArray(this.limit)) {
            this.limit = String(this.limit).split(',');
        }
        if (!Array.isArray(this.offset)) {
            this.offset = String(this.offset).split(',');
        }
        if (!Array.isArray(this.crop)) {
            this.crop = String(this.crop).split(',');
        }
        if (this.delimiters && !Array.isArray(this.delimiters)) {
            this.delimiters = this.delimiters.split(',');
        }
    }


    if (options.search) {
        this.searchQuery = this.options.search.query || this.defaults.search.query;
        this.searchSelector = this.options.search.selector || this.defaults.search.selector;
        this.searchTrackingUrl = this.options.search.trackingUrl || this.defaults.search.trackingUrl;
        this.searchMethod = (this.options.search.method || this.defaults.search.method).toUpperCase();
    }

    return this;
};

/**
 * Bind functions.
 * @function JamesSearch#bindFunctions
 * @private
 * @return {this}
 */
JamesSearch.prototype.bindFunctions = function () {
    this.start = Utils.bind(this.start, this);
    this.render = Utils.bind(this.render, this);
    this.onFormChange = Utils.bind(this.onFormChange, this);
    this.onSuccess = Utils.bind(this.onSuccess, this);
    this.onError = Utils.bind(this.onError, this);
    this.suggest = Utils.bind(Utils.debounce(this.suggest, this.delay), this);
    this.onScroll = Utils.bind(this.onScroll, this);
    this.onResize = Utils.bind(this.onResize, this);
    this.onFocus = Utils.bind(this.onFocus, this);
    this.onBlur = Utils.bind(this.onBlur, this);
    this.onMouseEnter = Utils.bind(this.onMouseEnter, this);
    this.onMouseLeave = Utils.bind(this.onMouseLeave, this);
    this.onSuggestLinkClick = Utils.bind(this.onSuggestLinkClick, this);
    this.onKeyup = Utils.bind(this.onKeyup, this);
    this.onKeydown = Utils.bind(this.onKeydown, this);
    this.onReadyStateChange = Utils.bind(this.onReadyStateChange, this);
    this.onSearchLinkClick = Utils.bind(this.onSearchLinkClick, this);

    return this;
};

/**
 * @function JamesSearch#initTemplate
 * @private
 * @param {String} template
 * @param {String} alternative
 * @throws templateNotFound {Error} - Template not found
 */
JamesSearch.prototype.initTemplate = function (template, alternative) {
    // Trim the string.
    template = (template || '').trim();

    // If no template id is defined try an alternative or throw an error.
    if (!template && alternative) {
        return alternative;
    } else if (!template) {
        throw JamesSearch.ERROR.templateNotFound + ' [' + template + ']';
    }

    // Find the template.
    if (template.charAt(0) === '#') {
        template = template.substr(1);

        if (!document.getElementById(template)) {
            throw JamesSearch.ERROR.templateNotFound + ' [' + template + ']';
        }

        template = document.getElementById(template).textContent;

        // If no template id is defined try an alternative or throw an error.
        if (!template && alternative) {
            return alternative;
        } else if (!template) {
            throw JamesSearch.ERROR.templateNotFound + ' [' + template + ']';
        }
    } else { // If it is not an ID.
        return template;
    }

    return template;
};

/**
 * Start the plugin
 * @function JamesSearch#start
 * @private
 * @fires JamesSearch#james-search-ready - Triggered on ready
 * @return {this}
 */
JamesSearch.prototype.start = function () {
    if (this.el) {
        this.render();
        this.trigger(JamesSearch.EVENTS.ready);
    }

    if (this.searchSelector) {
        this.enableSearchEvents();
    }

    return this;
};

/**
 * Render the elements
 * @function JamesSearch#render
 * @throws formNotFound {Error} - Form Element not found
 * @throws inputNotFound {Error} - Input text Element not found
 */
JamesSearch.prototype.render = function () {
    // Keep references to DOM elements.
    this.window = window;
    this.body = document.body;

    this.input = this.form.querySelector('.james-search-input');
    if (!this.input) throw JamesSearch.ERROR.inputNotFound;

    // Keep the last value.
    this.query = this.input.value || '';

    // Disable the autocomplete.
    this.input.setAttribute('autocomplete', 'off');

    // Cached template.
    if (this.delimiters) {
        Mustache.parse(this.template, this.delimiters);
        Mustache.parse(this.wrapperTemplate, this.delimiters);
    } else {
        Mustache.parse(this.template);
        Mustache.parse(this.wrapperTemplate);
    }

    this.enableEvents();
    this.resize();
};

/**
 * Enable the associated events.
 * @function JamesSearch#enableEvents
 */
JamesSearch.prototype.enableEvents = function () {
    this.disableEvents();

    if (this.el) {
        this.window.addEventListener('resize', this.onResize);
        this.window.addEventListener('scroll', this.onScroll);

        this.input.addEventListener('focus', this.onFocus);
        this.input.addEventListener('blur', this.onBlur);
        this.input.addEventListener('mouseenter', this.onMouseEnter);
        this.input.addEventListener('mouseleave', this.onMouseLeave);
        this.input.addEventListener('keyup', this.onKeyup);
        this.input.addEventListener('keydown', Utils.debounce(this.onKeydown, this.inputDebounceDelay));
        this.form.addEventListener('input', Utils.debounce(this.onFormChange, this.inputDebounceDelay));
    }
};

/**
 * Disable the associated events.
 * @function JamesSearch#disableEvents
 */
JamesSearch.prototype.disableEvents = function () {
    if (this.el) {
        this.window.removeEventListener('resize', this.onResize);
        this.window.removeEventListener('scroll', this.onScroll);

        this.form.removeEventListener('input', this.onFormChange);

        this.input.removeEventListener('focus', this.onFocus);
        this.input.removeEventListener('blur', this.onBlur);
        this.input.removeEventListener('mouseenter', this.onMouseEnter);
        this.input.removeEventListener('mouseleave', this.onMouseLeave);
        this.input.removeEventListener('keyup', this.onKeyup);
        this.input.removeEventListener('keydown', this.onKeydown);
    }
};

/**
 * Enable the associated search events.
 * @function JamesSearch#enableSearchEvents
 */
JamesSearch.prototype.enableSearchEvents = function () {
    if (this.searchSelector) {
        this.disableSearchEvents();
        Utils.addDocumentEvent('click', this.searchSelector, this.onSearchLinkClick);
    }
};

/**
 * Disable the associated search events.
 * @function JamesSearch#disableSearchEvents
 */
JamesSearch.prototype.disableSearchEvents = function () {
    if (this.searchSelector) {
        Utils.removeDocumentEvent('click', this.onSearchLinkClick);
    }
};

/**
 * Handles the change events in the form data.
 * @function JamesSearch#onFormChange
 * @private
 * @param {Event} e The corresponding event.
 * @fires JamesSearch#james-search-input-change - Triggered on input change
 */
JamesSearch.prototype.onFormChange = function (e) {
    if (e.target !== this.input) return;

    this.trigger(JamesSearch.EVENTS.inputChange, {originalEvent: e});
    this.suggest();
};

/**
 * Start the suggestion process.
 * @function JamesSearch#suggest
 * @fires JamesSearch#james-search-before-send - Triggered before ajax send.
 */
JamesSearch.prototype.suggest = function () {
    // Abort the previous xhr if exist.
    this.abort();

    // Keep the last value.
    this.query = (this.input.value || '').trim();

    // Check the minmax value of the query.
    if (this.query.length < this.minChars) {
        this.removeBox();

        return;
    }

    var data = this.collectSuggestData();
    this.trigger(JamesSearch.EVENTS.beforeSend, data);
    this.submitSuggestRequest(data);
};

/**
 * Submit the suggest request.
 * @function JamesSearch#submitSuggestTracking
 * @param {Object} data The data to be sent.
 */
JamesSearch.prototype.submitSuggestRequest = function (data) {
    data = this.parseFormData(data, this.method);
    this.xhr = this.createXhr(this.method, this.url, data);
    this.xhr.onreadystatechange = this.onReadyStateChange;
    this.sendXhr(this.method, this.xhr, data);
};

/**
 * Create and open a XhrHttpRequest.
 * @function JamesSearch#createXhr
 * @param {String} method The method of the request.
 * @param {String} url The url of the request.
 * @param {Object} data Serialized data array.
 * @return {XMLHttpRequest} Parsed serialized data array.
 */
JamesSearch.prototype.createXhr = function (method, url, data) {
    var xhr = new XMLHttpRequest();

    if (method === 'GET') {
        url += url.indexOf('?') < 0 ? '?' : '&';
        xhr.open(method, url + data, true);
    } else {
        xhr.open(method, url, true);
    }

    if (this.headers.length) {
        for (var i = 0; i < this.headers.length; i++) {
            var header = this.headers[i].split(':');
            var key = header.shift().trim();
            var value = header.shift().trim();
            xhr.setRequestHeader(key, value);
        }
    }

    return xhr;
};

/**
 * Send a xhr request.
 * @function JamesSearch#sendXhr
 * @param {String} method The request method.
 * @param {XMLHttpRequest} xhr The XMLHttpRequest.
 * @param {Object} data The data to be sent.
 */
JamesSearch.prototype.sendXhr = function (method, xhr, data) {
    if (method === 'GET') {
        xhr.send();
    } else {
        // Send the proper header information along with the request.
        xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
        xhr.setRequestHeader('Connection', 'keep-alive');
        xhr.send(data);
    }
};

/**
 * Prepare data to be sent.
 * @function JamesSearch#collectSuggestData
 * @return {Object} Parsed serialized data array.
 */
JamesSearch.prototype.collectSuggestData = function () {
    var data = Utils.serializeArray(this.form);

    // Add JS values to data.
    data = this.convertToTokenArray(data, 'limit', this.limit);
    data = this.convertToTokenArray(data, 'offset', this.offset);
    data = this.convertToTokenArray(data, 'crop', this.crop);

    return data;
};

/**
 * Convert a parameter into an associative array (key[token] = value).
 * @function JamesSearch#parseFormData
 * @param {Object} data The data the attribute "key" will be added to.
 * @param {String} key The key of the list.
 * @return {Array} list The list with the values.
 */
JamesSearch.prototype.convertToTokenArray = function (data, key, list) {
    Array.prototype.forEach.call(this.token, function(token, i) {
        var value = '';

        if (i > list.length - 1) {
            value = list[0];
        } else {
            value = list[i];
        }

        // Transform list into an associative array (list[token] = value).
        data = Utils.addValuesToData(data, key + '[' + token + ']', value);
    });

    return data;
};

/**
 * Parse the data of the form.
 * @function JamesSearch#parseFormData
 * @param {Object} data Serialized data array.
 * @param {String} method The method of the request.
 * @return {Object} Parsed serialized data array.
 */
JamesSearch.prototype.parseFormData = function (data, method) {
    return Utils.parseFormData(data);
};

/**
 * Abort the current suggestion process.
 * @function JamesSearch#abort
 */
JamesSearch.prototype.abort = function () {
    if (this.xhr && this.xhr.abort) {
        this.xhr.abort();
    }

    this.xhr = null;
};

/**
 * On ready state change event handler.
 * @function JamesSearch#onReadyStateChange
 * @private
 * @param {Event} e The corresponding event.
 * @fires JamesSearch#james-search-complete - Triggered on Ajax complete.
 */
JamesSearch.prototype.onReadyStateChange = function (e) {
    switch (this.xhr.readyState) {
        case 0: // UNINITIALIZED
        case 1: // LOADING
        case 2: // LOADED
        case 3: // INTERACTIVE
            break;
        case 4: // COMPLETED
            this.trigger(JamesSearch.EVENTS.complete, {xhr: this.xhr});

            if (this.xhr.status >= 200 && this.xhr.status < 400) {
                this.onSuccess(this.xhr.responseText);
            } else {
                this.onError(this.xhr);
            }

            break;
    }
};

/**
 * Handles the event 'success'.
 * @function JamesSearch#onSuccess
 * @private
 * @fires JamesSearch#james-search-success - Triggered on Ajax success.
 */
JamesSearch.prototype.onSuccess = function (data) {
    var i, j, result, autosuggest, section, hit, item, items;
    var regexRemoveMark = new RegExp('<[^>]*>', 'g');

    // Create an object reference to provide manipulation
    if (typeof data === 'string') {
        data = JSON.parse(data);
    } else {
        data = {};
    }

    this.trigger(JamesSearch.EVENTS.success, data);

    // We will parse the objects replacing the token name for alias and adding the token as an attr.
    if (Array.isArray(data)) {
        result = {};

        for (i = 0; i < data.length; i++) {
            section = data[i];

            if (section.kind === 'document') {
                items = [];
                for (j = 0; j < section.hits.length; j++) {
                    hit = section.hits[j].highlighted;

                    item = {
                        id: hit._product && hit._product.id ? hit._product.id : '',
                        articleNumberText: hit._product && hit._product.productNumber ? String(hit._product.productNumber) : '',
                        url: hit._common_i18n && hit._common_i18n.url ? hit._common_i18n.url : '',
                        image: hit._common && hit._common.imageUrl ? hit._common.imageUrl : '',
                        title: hit._product_i18n && hit._product_i18n.name ? hit._product_i18n.name : '',
                        content: hit._product_i18n && hit._product_i18n.description ? hit._product_i18n.description : '',
                    };

                    // Overwrite articleNumber for rendering in add-to-cart btn.
                    item.articleNumber = item.articleNumberText.replace(regexRemoveMark, '');

                    items.push(item);
                }

                result.products = {
                    total: section.found,
                    items: items,
                };
            } else if (section.kind === 'query-completion') {
                items = [];
                for (j = 0; j < section.hits.length; j++) {
                    hit = section.hits[j].highlighted;
                    items.push(hit);
                }

                autosuggest = items;
            }
        }
    }

    result.query = this.query;
    result.content = true;
    result.blogarticles = true;
    result.recipes = true;
    result.frequentlyaskedquestions = true;

    this.addBox();
    this.updateBox({result: result, autosuggest: autosuggest});
};

/**
 * Handles the event 'error'.
 * @function JamesSearch#onError
 * @private
 * @fires JamesSearch#james-search-error - Triggered on Ajax error.
 */
JamesSearch.prototype.onError = function (xhr) {
    this.trigger(JamesSearch.EVENTS.error, {xhr: xhr});
    this.removeBox();
};

/**
 * Add the autosuggest box to DOM.
 * @function JamesSearch#addBox
 * @fires JamesSearch#james-search-box-before-add - Triggered before the autosuggest box has been added.
 * @fires JamesSearch#james-search-box-added - Triggered after the autosuggest box has been added.
 */
JamesSearch.prototype.addBox = function () {
    // Check if the box exists
    if (this.box) {
        this.removeBox(true);
    }

    var data = {
        html: Mustache.render(this.wrapperTemplate),
    };

    this.trigger(JamesSearch.EVENTS.boxBeforeAdd, data);

    this.box = Utils.textToHTML(data.html);
    this.body.appendChild(this.box);

    if (this.input === document.activeElement) {
        this.activateFocus();
    }

    this.trigger(JamesSearch.EVENTS.boxAdded, {box: this.box});
};

/**
 * Removes the autosuggest box from DOM.
 * @function JamesSearch#removeBox
 * @param {Boolean} force Force remove box (for debug purposes only).
 * @fires JamesSearch#james-search-box-removed - Triggered after the autosuggest box has been removed.
 */
JamesSearch.prototype.removeBox = function (force) {
    // Check if the box exists
    if (!this.box) return;

    // Go away if in debug mode.
    if (this.debug && !force) return;

    // Disable the events on elements within the box
    this.disableBoxEvents();

    // Remove the box
    this.box.parentNode.removeChild(this.box);
    this.box = null;

    this.trigger(JamesSearch.EVENTS.boxRemoved);
};

/**
 * Updates the content of the box.
 * @function JamesSearch#updateBox
 * @param {Object} JSON parsed data.
 * @fires JamesSearch#james-search-box-before-update - Triggered before the autosuggest box has been updated.
 * @fires JamesSearch#james-search-box-updated - Triggered after the autosuggest box has been updated.
 */
JamesSearch.prototype.updateBox = function (data) {
    // Check if the box exists
    if (!this.box) return;

    this.disableBoxEvents();

    // Render the template.
    data = {
        html: (Mustache.render(this.template, data) || '').trim(),
    };

    this.trigger(JamesSearch.EVENTS.boxBeforeUpdate, data);

    this.box.innerHTML = data.html;

    if (data.html === '') {
        Utils.addClass(this.box, 'empty');
    } else {
        Utils.removeClass(this.box, 'empty');
    }

    this.enableBoxEvents();
    this.resize();

    this.trigger(JamesSearch.EVENTS.boxUpdated, {box: this.box});
};

/**
 * Handle the focus event on input.
 * @function JamesSearch#onFocus
 * @private
 * @param {Event} e The corresponding event.
 * @fires JamesSearch#james-search-input-focus - Triggered on focusing the autosuggest input.
 */
JamesSearch.prototype.onFocus = function (e) {
    this.trigger(JamesSearch.EVENTS.inputFocus, {el: e.currentTarget});
    this.activateFocus();
};

/**
 * Handle the blur event on input.
 * @function JamesSearch#onBlur
 * @private
 * @fires JamesSearch#james-search-input-blur - Triggered on blurring the autosuggest input.
 */
JamesSearch.prototype.onBlur = function (e) {
    this.trigger(JamesSearch.EVENTS.inputBlur, {el: e.currentTarget});

    this.input.value = this.query;
    this.deactivateFocus();
};

/**
 * Activate the box by focus.
 * @function JamesSearch#activateFocus
 * @param {Boolean} focus - Gain the focus on input.
 * @fires JamesSearch#james-search-box-shown - Triggered after the autosuggest box has been showed.
 */
JamesSearch.prototype.activateFocus = function (focus) {
    if (!this.box) return;

    Utils.addClass(this.box, 'focus');

    if (focus) {
        this.input.focus();
    }

    this.resize();

    this.trigger(JamesSearch.EVENTS.boxShown, {box: this.box});
};

/**
 * Hide the box by focus.
 * @function JamesSearch#deactivateFocus
 * @fires JamesSearch#james-search-box-hidden - Triggered after the autosuggest box has been hidden.
 */
JamesSearch.prototype.deactivateFocus = function () {
    if (!this.box) return;

    Utils.removeClass(this.box, 'focus');
    this.checkBoxStatus();
    this.trigger(JamesSearch.EVENTS.boxHidden);
};

/**
 * Handle the mouseenter event on mouse.
 * @function JamesSearch#onMouseEnter
 * @private
 * @param {Event} e The corresponding event.
 * @fires JamesSearch#james-search-input-enter - Triggered on entering the autosuggest input.
 */
JamesSearch.prototype.onMouseEnter = function (e) {
    var el = e.currentTarget;
    this.trigger(JamesSearch.EVENTS.inputEnter, {el: el});

    if (Utils.hasClass(el, 'james-search-input') && !Utils.hasClass(this.input, 'focus')) {
        return;
    }

    this.activateMouse();
};

/**
 * Handle the mouseleave event on mouse.
 * @function JamesSearch#onMouseLeave
 * @private
 * @fires JamesSearch#james-search-input-leave - Triggered on leaving the autosuggest input.
 */
JamesSearch.prototype.onMouseLeave = function () {
    this.trigger(JamesSearch.EVENTS.inputLeave);
    this.deactivateMouse();
};

/**
 * Activate the box by mouse.
 * @function JamesSearch#activateMouse
 * @fires JamesSearch#james-search-box-enter - Triggered on entering the autosuggest box.
 */
JamesSearch.prototype.activateMouse = function () {
    if (!this.box) return;

    this.trigger(JamesSearch.EVENTS.boxEnter);
    Utils.addClass(this.box, 'active');
};

/**
 * Hide the box by mouse.
 * @function JamesSearch#deactivateMouse
 * @fires JamesSearch#james-search-box-leave - Triggered on leaving the autosuggest box.
 */
JamesSearch.prototype.deactivateMouse = function () {
    if (!this.box) return;

    if (!this.debug) {
        this.trigger(JamesSearch.EVENTS.boxLeave);
        Utils.removeClass(this.box, 'active');
    }

    this.checkBoxStatus();
};

/**
 * Check if the box shall be removed.
 * @function JamesSearch#checkBoxStatus
 */
JamesSearch.prototype.checkBoxStatus = function () {
    if (!this.box) return;

    if (Utils.hasClass(this.box, 'active') || Utils.hasClass(this.box, 'focus')) {
        this.enableBoxEvents();
        return true;
    } else if (this.blurRemove) {
        this.removeBox();
        return false;
    }
};

/**
 * Add the events within the box.
 * @function JamesSearch#enableBoxEvents
 * @private
 */
JamesSearch.prototype.enableBoxEvents = function () {
    this.disableBoxEvents();

    this.box.addEventListener('mouseenter', this.onMouseEnter);
    this.box.addEventListener('mouseleave', this.onMouseLeave);

    var $links = this.box.querySelectorAll('.link');

    for (var i = $links.length - 1; i >= 0; i--) {
        $links[i].addEventListener('click', this.onSuggestLinkClick);
    }
};

/**
 * Remove the events within the box.
 * @function JamesSearch#disableBoxEvents
 * @private
 */
JamesSearch.prototype.disableBoxEvents = function () {
    this.box.removeEventListener('mouseenter', this.onMouseEnter);
    this.box.removeEventListener('mouseleave', this.onMouseLeave);

    var $links = this.box.querySelectorAll('.link');

    for (var i = $links.length - 1; i >= 0; i--) {
        $links[i].removeEventListener('click', this.onSuggestLinkClick);
    }
};

/**
 * Handles the event ´click´ on .links elements.
 * @function JamesSearch#onSuggestLinkClick
 * @private
 */
JamesSearch.prototype.onSuggestLinkClick = function (e) {
    var el = e.currentTarget,
        query = (el.getAttribute('data-query') || '').trim();

    if (this.debug) {
        e.preventDefault();
    }

    if (Utils.hasClass(el, 'james-search-autosuggest-link') && query) {
        if (e && e.preventDefault) e.preventDefault();
        if (e && e.stopImmediatePropagation) e.stopImmediatePropagation();

        this.updateInput(query, true);
    } else if (Utils.hasClass(el, 'james-search-autosuggest') && query) {
        if (e && e.preventDefault) e.preventDefault();
        if (e && e.stopImmediatePropagation) e.stopImmediatePropagation();

        this.updateInput(query);
    }

    this.trackSuggestClick(e);
};

/**
 * Updates the input element.
 * @function JamesSearch#updateInput
 * @param {String} query The input value will be updated with this String.
 * @param {Boolean} submit Submit the form.
 */
JamesSearch.prototype.updateInput = function (query, submit) {
    // Sanitize the string
    query = Utils.htmlToText(query);

    // Update the text
    this.input.value = query;

    // Get the focus
    this.input.focus();

    this.trigger(JamesSearch.EVENTS.inputUpdate, query);

    if (submit) {
        // Submit the form
        this.form.submit();
    } else {
        // Reload the box
        this.suggest();
    }
};

/**
 * Check if suggestTrackingUrl is defined and then track the click on suggest link.
 * @function JamesSearch#trackSuggestClick
 * @param {Event} e The corresponding event.
 * @fires JamesSearch#james-search-suggest-tracking-before-send - Triggered before suggest tracking send.
 */
JamesSearch.prototype.trackSuggestClick = function (e) {
    if (!this.suggestTrackingUrl) {
        return;
    }

    var el = e.currentTarget,
        id = Utils.htmlToText(el.getAttribute('data-id')),
        closestAlias = Utils.closest(el, '[data-alias]'),
        token = '',
        data = null;

    if (closestAlias) {
        token = closestAlias.getAttribute('data-token');
    }

    if (token !== '') {
        data = [];
        data = Utils.addValuesToData(data, 'token', token);
        data = Utils.addValuesToData(data, 'query', this.query);
        data = Utils.addValuesToData(data, 'id', id);

        this.trigger(JamesSearch.EVENTS.suggestTrackingBeforeSend, data);
        this.submitSuggestTracking(data);
    }
};

/**
 * Send a request to track the suggest.
 * @function JamesSearch#submitSuggestTracking
 * @private
 * @param {Object} data to be sent.
 */
JamesSearch.prototype.submitSuggestTracking = function (data) {
    data = this.parseFormData(data, this.method);
    var xhr = this.createXhr(this.method, this.suggestTrackingUrl, data);
    this.sendXhr(this.method, xhr, data);
};

/**
 * Handles the event ´keyup´ on input.
 * @function JamesSearch#onKeyup
 * @private
 * @param {Event} e The corresponding event.
 */
JamesSearch.prototype.onKeyup = function (e) {
    if (!this.keyboard || !this.box) return;

    var code = e.keyCode;

    switch (code) {
        case 27: // escape
        case 38: // arrow up
        case 40: // arrow down
            if (e && e.preventDefault) e.preventDefault();
            if (e && e.stopImmediatePropagation) e.stopImmediatePropagation();

            this.useKeycode(code);
            break;
        case 37: // arrow left
        case 39: // arrow right
            if (this.horizontalKeyboard) {
                if (e && e.preventDefault) e.preventDefault();
                if (e && e.stopImmediatePropagation) e.stopImmediatePropagation();

                this.useKeycode(code);
            }
            break;
    }
};

/**
 * Apply the given keycode.
 * @function JamesSearch#useKeycode
 * @param {Integer} code The key code.
 */
JamesSearch.prototype.useKeycode = function (code) {
    if (!this.box) return;

    switch (code) {
        case 27: // escape
            this.input.value = this.query;
            if (this.blurRemove) {
                this.removeBox();
            } else {
                this.deactivateFocus();
            }
            break;
        case 38: // arrow up
            this.highlightLink(-1);
            break;
        case 40: // arrow down
            this.highlightLink(1);
            break;
        case 13: // enter
            this.highlightLink(1);
            break;
        case 37: // arrow left
            this.highlightLink(-1, true);
            break;
        case 39: // arrow right
            this.highlightLink(1, true);
            break;
    }
};

/**
 * Highlight an element within the box.
 * @function JamesSearch#highlightLink
 * @private
 * @param {Integer} direction The direction to navigate (-1: up / left; 1:down / right).
 * @param {Boolean} horizontal Horizontal navigation.
 */
JamesSearch.prototype.highlightLink = function (direction, horizontal) {
    if (!this.box) return;

    var links = Array.from(this.box.querySelectorAll('.link')),
        link = this.findLinkToHighlight(direction, horizontal, links);

    this.highlightSelectedLink(link, links);
    this.scrollToSelectedLink(link);
    this.updateInputBySuggestLink(link);
};

/**
 * Highlight the selected link and remove highlight from other ones.
 * @function JamesSearch#findLinkToHighlight
 * @private
 * @param {Integer} direction The direction to navigate (-1: up / left; 1:down / right).
 * @param {Boolean} horizontal Horizontal navigation.
 * @param {Array} links Array with the links in the suggestBox.
 */
JamesSearch.prototype.findLinkToHighlight = function (direction, horizontal, links) {
    var i, j,
        selected = this.box.querySelector('.link.selected'),
        index = Array.prototype.indexOf.call(links, selected),
        currentGroup = selected ? selected.getAttribute('data-group') : null,
        found = false;

    // If horizontal / group move is required.
    if (selected && horizontal) {

        // Loop for finding the next/previous group.
        for (i = 1; i < links.length && !found; i++) {
            j = (index + ((direction < 0 ? -1 : 1) * i));

            while (j < 0) j += links.length;
            while (j >= links.length) j -= links.length;

            // If the group are differents, we search for the element.
            if (links[j].getAttribute('data-group') && links[j].getAttribute('data-group') !== currentGroup) {
                found = true;

                // Find the first sibling object if arrow left was pressed.
                if (direction < 0) {
                    while (j - 1 >= 0 && links[j - 1].getAttribute('data-group') && links[j].getAttribute('data-group') === links[j - 1].getAttribute('data-group')) {
                        j--;
                    }
                }
            }
        }

        index = j;
    } else {
        index += direction;
    }

    if (index < 0) {
        index = links.length - 1;
    } else if (index > links.length - 1) {
        index = 0;
    }

    return links[index];
};

/**
 * Highlight the selected link and remove highlight from other ones.
 * @function JamesSearch#highlightSelectedLink
 * @param {DOMElement} link The link to highlight.
 * @param {Array} links List with links to remove the highlight.
 */
JamesSearch.prototype.highlightSelectedLink = function (link, links) {
    for (var i = 0; i < links.length; i++) {
        Utils.removeClass(links[i], 'selected');
    }

    Utils.addClass(link, 'selected');
};

/**
 * Scroll to the selected link.
 * @function JamesSearch#scrollToLink
 * @private
 * @param {DOMElement} link The selected link.
 */
JamesSearch.prototype.scrollToSelectedLink = function (link) {
    // Scroll if necessary.
    var offsetBox = Utils.offset(this.box);
    var offsetLink = Utils.offset(link);

    var position = {
        top: offsetLink.top - offsetBox.top,
        left: offsetLink.left - offsetBox.left,
    };

    var boxSize = {
        width: this.box.offsetWidth,
        height: this.box.offsetHeight,
    };

    var linkSize = {
        width: link.offsetWidth,
        height: link.offsetHeight,
    };

    if (position.top < 0) {
        this.box.scrollTop += position.top;
    } else if (position.top >= boxSize.height) {
        this.box.scrollTop += position.top - boxSize.height + linkSize.height;
    }

    if (position.left < 0) {
        this.box.scrollLeft += position.left;
    } else if (position.left > boxSize.width) {
        this.box.scrollLeft += position.left - boxSize.width + linkSize.width;
    }
};

/**
 * Update the input field based on content of the suggest link.
 * @function JamesSearch#updateInputBySuggestLink
 * @param {DOMElement} link The selected link.
 */
JamesSearch.prototype.updateInputBySuggestLink = function (link) {
    var text = '';

    // Check if the element is an autosuggest.
    if (Utils.hasClass(link, 'james-search-autosuggest-link')) {
        // Sanitize the string.
        text = Utils.htmlToText(link.getAttribute('data-query'));

        if (text) {
            this.input.value = text;
        } else {
            this.input.value = this.query;
        }
    } else {
        this.input.value = this.query;
    }
};

/**
 * Handles the event ´onKeydown´ on input forn canceling the ENTER key when an autossugest link is selected.
 * @function JamesSearch#onKeydown
 * @private
 * @param {Event} e The corresponding event.
 */
JamesSearch.prototype.onKeydown = function (e) {
    // Check if the box and the keyboard are activated.
    if (e.keyCode === 13 && this.keyboard && this.box) {
        // Search for a selected autosuggest link.
        var $link = this.box.querySelector('.link.selected');
        var query = ($link.getAttribute('data-query') || '').trim();

        if (Utils.hasClass($link, 'james-search-autosuggest')) {
            // If success, cancel the event on ENTER.
            if (e && e.preventDefault) e.preventDefault();
            if (e && e.stopImmediatePropagation) e.stopImmediatePropagation();

            this.updateInput(query);

            return false;
        } else if (Utils.hasClass($link, 'james-search-autosuggest-link') && query) {
            this.updateInput(query, true);
        } else {
            // Cancel the event on ENTER and follow the link.
            if (e && e.preventDefault) e.preventDefault();
            if (e && e.stopImmediatePropagation) e.stopImmediatePropagation();

            $link.click();

            return false;
        }
    }
};

/**
 * Handles the event ´scroll´.
 * @function JamesSearch#onScroll
 * @private
 */
JamesSearch.prototype.onScroll = function () {
    this.resize();
};

/**
 * Handles the event ´resize´.
 * @function JamesSearch#onResize
 * @private
 */
JamesSearch.prototype.onResize = function () {
    this.resize();
};

/**
 * Resize and adjust the position.
 * @function JamesSearch#resize
 * @fires JamesSearch#james-search-box-before-resize - Triggered after a window resize event and before new styles be applied to the autosuggest box.
 * @fires JamesSearch#james-search-box-resized - Triggered after a window resize event and after new styles has been applied to the autosuggest box.
 */
JamesSearch.prototype.resize = function () {
    if (!this.box) return;

    // Reset the CSS of the box.
    var style = this.box.style;

    style.left = '';
    style.top = '';
    style.width = '';
    style.minWidth = '';
    style.maxWidth = '';

    // Get the offset of the input.
    var offset = Utils.offset(this.input);

    // Get the scroll and size of the window.
    var screen = {
        top: window.scrollY || document.documentElement.scrollTop,
        left: window.scrollX || document.documentElement.scrollLeft,
        width: this.body.offsetWidth,
        height: this.body.offsetHeight,
    };

    // Compute the absolute position and the width/height of the input.
    var position = {
        top: offset.top - screen.top,
        left: offset.left - screen.left,
        width: this.input.offsetWidth,
        height: this.input.offsetHeight,
    };

    // Get the size of the box.
    var box = {
        width: this.box.offsetWidth,
        height: this.box.offsetHeight,
    };

    // Compute the values.
    var computed = {
        top: position.top + position.height,
        minWidth: position.width,
    };

    if (box.width < position.width) {
        box.width = position.width;
    }

    // Force width.
    if (this.autoWidth === 'fixed') {
        box.width = position.width;
        computed.width = position.width;
    }

    // Set the position.
    if (this.position === 'left') {
        computed.left = position.left;
    } else {
        computed.left = position.left + position.width - box.width;
    }

    // Check the final size of the box.
    if (this.position === 'left' && (computed.left + box.width > screen.width - this.margin)) {
        computed.maxWidth = screen.width - computed.left - this.margin;
    } else if (this.position !== 'left' && computed.left < this.margin) {
        computed.left = this.margin;
        computed.maxWidth = position.left + position.width - computed.left;
    }

    // Force width.
    if (this.autoWidth === 'fixed') {
        computed.minWidth = position.width;
        computed.maxWidth = position.width;
    }

    var key = null;
    var properties = ['left', 'top', 'width', 'minWidth', 'maxWidth'];

    for (key in computed) {
        if (!isNaN(computed[key]) && computed[key] > 0 && properties.indexOf(key) !== -1) {
            computed[key] = computed[key] + 'px';
        }
    }

    this.trigger(JamesSearch.EVENTS.boxBeforeResize, { style: computed });

    // Apply the values.
    style = this.box.style;

    for (key in computed) {
        style[key] = computed[key];
    }

    this.trigger(JamesSearch.EVENTS.boxResized, { style: style });
};


/**
 * Handles the event ´click´ on search links.
 * @function JamesSearch#onSearchLinkClick
 * @private
 */
JamesSearch.prototype.onSearchLinkClick = function (e) {
    this.trackSearchClick(e);
};

/**
 * Check if searchTrackingUrl is defined and then track the click on suggest link.
 * @function JamesSearch#trackSearchClick
 * @param {Event} e The corresponding event.
 * @fires JamesSearch#james-search-search-tracking-before-send - Triggered before search tracking send.
 */
JamesSearch.prototype.trackSearchClick = function (e) {
    if (this.debug) {
        e.preventDefault();
    }

    if (!this.searchTrackingUrl) {
        return;
    }

    var el = e.target,
        id = Utils.htmlToText(el.getAttribute('data-id')),
        closestId = '',
        closestAlias = Utils.closest(el, '[data-alias]'),
        token = '',
        query = this.searchQuery,
        data = null;

    if (!id) {
        closestId = Utils.closest(el, '[data-id]');
        if (closestId) {
            id = closestId.getAttribute('data-id');
        }
    }

    if (closestAlias) {
        token = closestAlias.getAttribute('data-token');
    }

    if (token && query && id) {
        data = [];
        data = Utils.addValuesToData(data, 'token', token);
        data = Utils.addValuesToData(data, 'query', query);
        data = Utils.addValuesToData(data, 'id', id);

        this.trigger(JamesSearch.EVENTS.searchTrackingBeforeSend, data);
        this.submitSearchTracking(data);
    }
};

/**
 * Send a request to track the search.
 * @function JamesSearch#submitSearchTracking
 * @param {Object} data to be sent.
 */
JamesSearch.prototype.submitSearchTracking = function (data) {
    data = this.parseFormData(data, this.searchMethod);
    var xhr = this.createXhr(this.searchMethod, this.searchTrackingUrl, data);
    this.sendXhr(this.searchMethod, xhr, data);
};

/**
 * Add an event listener.
 * @function JamesSearch#on
 * @alias JamesSearch#addEventListener
 * @param {String} name ID of the event to be listened.
 * @param {Function} [callback] Callback function.
 */
JamesSearch.prototype.on = JamesSearch.prototype.addEventListener = function (name, callback) {
    Utils.on(this, name, callback);
};

/**
 * Remove an event listener.
 * @function JamesSearch#off
 * @alias JamesSearch#removeEventListener
 * @param {String} name ID of the event to be listened.
 * @param {Function} [callback] Callback function.
 */
JamesSearch.prototype.off = JamesSearch.prototype.removeEventListener = function (name, callback) {
    Utils.off(this, name, callback);
};

/**
 * Trigger an event to current listeners and trigger it also to the DOM:
 * @function JamesSearch#trigger
 * @param {String} name ID of the event to be triggered.
 * @param {Object[]} [data] Attached data.
 */
JamesSearch.prototype.trigger = function (name, data) {
    Utils.trigger(this, name, data);
};

/**
 * Destroys the instance. Use ´delete myJamesSearch.destroy();´;
 * @function JamesSearch#destroy
 * @return {this}
 */
JamesSearch.prototype.destroy = function () {
    this.removeBox(true);
    this.disableEvents();
    this.disableSearchEvents();
    Utils.off(this.listeners);

    return this;
};

return JamesSearch;
}));

/*!
 * Bootstrap-select v1.10.0 (http://silviomoreto.github.io/bootstrap-select)
 *
 * Copyright 2013-2016 bootstrap-select
 * Licensed under MIT (https://github.com/silviomoreto/bootstrap-select/blob/master/LICENSE)
 */
!function(a,b){"function"==typeof define&&define.amd?define('bootstrap-select',["jquery"],function(a){return b(a)}):"object"==typeof exports?module.exports=b(require("jquery")):b(jQuery)}(this,function(a){!function(a){"use strict";function b(b){var c=[{re:/[\xC0-\xC6]/g,ch:"A"},{re:/[\xE0-\xE6]/g,ch:"a"},{re:/[\xC8-\xCB]/g,ch:"E"},{re:/[\xE8-\xEB]/g,ch:"e"},{re:/[\xCC-\xCF]/g,ch:"I"},{re:/[\xEC-\xEF]/g,ch:"i"},{re:/[\xD2-\xD6]/g,ch:"O"},{re:/[\xF2-\xF6]/g,ch:"o"},{re:/[\xD9-\xDC]/g,ch:"U"},{re:/[\xF9-\xFC]/g,ch:"u"},{re:/[\xC7-\xE7]/g,ch:"c"},{re:/[\xD1]/g,ch:"N"},{re:/[\xF1]/g,ch:"n"}];return a.each(c,function(){b=b.replace(this.re,this.ch)}),b}function c(a){var b={"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#x27;","`":"&#x60;"},c="(?:"+Object.keys(b).join("|")+")",d=new RegExp(c),e=new RegExp(c,"g"),f=null==a?"":""+a;return d.test(f)?f.replace(e,function(a){return b[a]}):f}function d(b,c){var d=arguments,f=b,g=c;[].shift.apply(d);var h,i=this.each(function(){var b=a(this);if(b.is("select")){var c=b.data("selectpicker"),i="object"==typeof f&&f;if(c){if(i)for(var j in i)i.hasOwnProperty(j)&&(c.options[j]=i[j])}else{var k=a.extend({},e.DEFAULTS,a.fn.selectpicker.defaults||{},b.data(),i);k.template=a.extend({},e.DEFAULTS.template,a.fn.selectpicker.defaults?a.fn.selectpicker.defaults.template:{},b.data().template,i.template),b.data("selectpicker",c=new e(this,k,g))}"string"==typeof f&&(h=c[f]instanceof Function?c[f].apply(c,d):c.options[f])}});return"undefined"!=typeof h?h:i}String.prototype.includes||!function(){var a={}.toString,b=function(){try{var a={},b=Object.defineProperty,c=b(a,a,a)&&b}catch(d){}return c}(),c="".indexOf,d=function(b){if(null==this)throw new TypeError;var d=String(this);if(b&&"[object RegExp]"==a.call(b))throw new TypeError;var e=d.length,f=String(b),g=f.length,h=arguments.length>1?arguments[1]:void 0,i=h?Number(h):0;i!=i&&(i=0);var j=Math.min(Math.max(i,0),e);return g+j>e?!1:-1!=c.call(d,f,i)};b?b(String.prototype,"includes",{value:d,configurable:!0,writable:!0}):String.prototype.includes=d}(),String.prototype.startsWith||!function(){var a=function(){try{var a={},b=Object.defineProperty,c=b(a,a,a)&&b}catch(d){}return c}(),b={}.toString,c=function(a){if(null==this)throw new TypeError;var c=String(this);if(a&&"[object RegExp]"==b.call(a))throw new TypeError;var d=c.length,e=String(a),f=e.length,g=arguments.length>1?arguments[1]:void 0,h=g?Number(g):0;h!=h&&(h=0);var i=Math.min(Math.max(h,0),d);if(f+i>d)return!1;for(var j=-1;++j<f;)if(c.charCodeAt(i+j)!=e.charCodeAt(j))return!1;return!0};a?a(String.prototype,"startsWith",{value:c,configurable:!0,writable:!0}):String.prototype.startsWith=c}(),Object.keys||(Object.keys=function(a,b,c){c=[];for(b in a)c.hasOwnProperty.call(a,b)&&c.push(b);return c}),a.fn.triggerNative=function(a){var b,c=this[0];c.dispatchEvent?("function"==typeof Event?b=new Event(a,{bubbles:!0}):(b=document.createEvent("Event"),b.initEvent(a,!0,!1)),c.dispatchEvent(b)):(c.fireEvent&&(b=document.createEventObject(),b.eventType=a,c.fireEvent("on"+a,b)),this.trigger(a))},a.expr[":"].icontains=function(b,c,d){var e=a(b),f=(e.data("tokens")||e.text()).toUpperCase();return f.includes(d[3].toUpperCase())},a.expr[":"].ibegins=function(b,c,d){var e=a(b),f=(e.data("tokens")||e.text()).toUpperCase();return f.startsWith(d[3].toUpperCase())},a.expr[":"].aicontains=function(b,c,d){var e=a(b),f=(e.data("tokens")||e.data("normalizedText")||e.text()).toUpperCase();return f.includes(d[3].toUpperCase())},a.expr[":"].aibegins=function(b,c,d){var e=a(b),f=(e.data("tokens")||e.data("normalizedText")||e.text()).toUpperCase();return f.startsWith(d[3].toUpperCase())};var e=function(b,c,d){d&&(d.stopPropagation(),d.preventDefault()),this.$element=a(b),this.$newElement=null,this.$button=null,this.$menu=null,this.$lis=null,this.options=c,null===this.options.title&&(this.options.title=this.$element.attr("title")),this.val=e.prototype.val,this.render=e.prototype.render,this.refresh=e.prototype.refresh,this.setStyle=e.prototype.setStyle,this.selectAll=e.prototype.selectAll,this.deselectAll=e.prototype.deselectAll,this.destroy=e.prototype.destroy,this.remove=e.prototype.remove,this.show=e.prototype.show,this.hide=e.prototype.hide,this.init()};e.VERSION="1.10.0",e.DEFAULTS={noneSelectedText:"Nothing selected",noneResultsText:"No results matched {0}",countSelectedText:function(a,b){return 1==a?"{0} item selected":"{0} items selected"},maxOptionsText:function(a,b){return[1==a?"Limit reached ({n} item max)":"Limit reached ({n} items max)",1==b?"Group limit reached ({n} item max)":"Group limit reached ({n} items max)"]},selectAllText:"Select All",deselectAllText:"Deselect All",doneButton:!1,doneButtonText:"Close",multipleSeparator:", ",styleBase:"btn",style:"btn-default",size:"auto",title:null,selectedTextFormat:"values",width:!1,container:!1,hideDisabled:!1,showSubtext:!1,showIcon:!0,showContent:!0,dropupAuto:!0,header:!1,liveSearch:!1,liveSearchPlaceholder:null,liveSearchNormalize:!1,liveSearchStyle:"contains",actionsBox:!1,iconBase:"glyphicon",tickIcon:"glyphicon-ok",showTick:!1,template:{caret:'<span class="caret"></span>'},maxOptions:!1,mobile:!1,selectOnTab:!1,dropdownAlignRight:!1},e.prototype={constructor:e,init:function(){var b=this,c=this.$element.attr("id");this.$element.addClass("bs-select-hidden"),this.liObj={},this.multiple=this.$element.prop("multiple"),this.autofocus=this.$element.prop("autofocus"),this.$newElement=this.createView(),this.$element.after(this.$newElement).appendTo(this.$newElement),this.$button=this.$newElement.children("button"),this.$menu=this.$newElement.children(".dropdown-menu"),this.$menuInner=this.$menu.children(".inner"),this.$searchbox=this.$menu.find("input"),this.$element.removeClass("bs-select-hidden"),this.options.dropdownAlignRight&&this.$menu.addClass("dropdown-menu-right"),"undefined"!=typeof c&&(this.$button.attr("data-id",c),a('label[for="'+c+'"]').click(function(a){a.preventDefault(),b.$button.focus()})),this.checkDisabled(),this.clickListener(),this.options.liveSearch&&this.liveSearchListener(),this.render(),this.setStyle(),this.setWidth(),this.options.container&&this.selectPosition(),this.$menu.data("this",this),this.$newElement.data("this",this),this.options.mobile&&this.mobile(),this.$newElement.on({"hide.bs.dropdown":function(a){b.$element.trigger("hide.bs.select",a)},"hidden.bs.dropdown":function(a){b.$element.trigger("hidden.bs.select",a)},"show.bs.dropdown":function(a){b.$element.trigger("show.bs.select",a)},"shown.bs.dropdown":function(a){b.$element.trigger("shown.bs.select",a)}}),b.$element[0].hasAttribute("required")&&this.$element.on("invalid",function(){b.$button.addClass("bs-invalid").focus(),b.$element.on({"focus.bs.select":function(){b.$button.focus(),b.$element.off("focus.bs.select")},"shown.bs.select":function(){b.$element.val(b.$element.val()).off("shown.bs.select")},"rendered.bs.select":function(){this.validity.valid&&b.$button.removeClass("bs-invalid"),b.$element.off("rendered.bs.select")}})}),setTimeout(function(){b.$element.trigger("loaded.bs.select")})},createDropdown:function(){var b=this.multiple||this.options.showTick?" show-tick":"",d=this.$element.parent().hasClass("input-group")?" input-group-btn":"",e=this.autofocus?" autofocus":"",f=this.options.header?'<div class="popover-title"><button type="button" class="close" aria-hidden="true">&times;</button>'+this.options.header+"</div>":"",g=this.options.liveSearch?'<div class="bs-searchbox"><input type="text" class="form-control" autocomplete="off"'+(null===this.options.liveSearchPlaceholder?"":' placeholder="'+c(this.options.liveSearchPlaceholder)+'"')+"></div>":"",h=this.multiple&&this.options.actionsBox?'<div class="bs-actionsbox"><div class="btn-group btn-group-sm btn-block"><button type="button" class="actions-btn bs-select-all btn btn-default">'+this.options.selectAllText+'</button><button type="button" class="actions-btn bs-deselect-all btn btn-default">'+this.options.deselectAllText+"</button></div></div>":"",i=this.multiple&&this.options.doneButton?'<div class="bs-donebutton"><div class="btn-group btn-block"><button type="button" class="btn btn-sm btn-default">'+this.options.doneButtonText+"</button></div></div>":"",j='<div class="btn-group bootstrap-select'+b+d+'"><button type="button" class="'+this.options.styleBase+' dropdown-toggle" data-toggle="dropdown"'+e+'><span class="filter-option pull-left"></span>&nbsp;<span class="bs-caret">'+this.options.template.caret+'</span></button><div class="dropdown-menu open">'+f+g+h+'<ul class="dropdown-menu inner" role="menu"></ul>'+i+"</div></div>";return a(j)},createView:function(){var a=this.createDropdown(),b=this.createLi();return a.find("ul")[0].innerHTML=b,a},reloadLi:function(){this.destroyLi();var a=this.createLi();this.$menuInner[0].innerHTML=a},destroyLi:function(){this.$menu.find("li").remove()},createLi:function(){var d=this,e=[],f=0,g=document.createElement("option"),h=-1,i=function(a,b,c,d){return"<li"+("undefined"!=typeof c&""!==c?' class="'+c+'"':"")+("undefined"!=typeof b&null!==b?' data-original-index="'+b+'"':"")+("undefined"!=typeof d&null!==d?'data-optgroup="'+d+'"':"")+">"+a+"</li>"},j=function(a,e,f,g){return'<a tabindex="0"'+("undefined"!=typeof e?' class="'+e+'"':"")+("undefined"!=typeof f?' style="'+f+'"':"")+(d.options.liveSearchNormalize?' data-normalized-text="'+b(c(a))+'"':"")+("undefined"!=typeof g||null!==g?' data-tokens="'+g+'"':"")+">"+a+'<span class="'+d.options.iconBase+" "+d.options.tickIcon+' check-mark"></span></a>'};if(this.options.title&&!this.multiple&&(h--,!this.$element.find(".bs-title-option").length)){var k=this.$element[0];g.className="bs-title-option",g.appendChild(document.createTextNode(this.options.title)),g.value="",k.insertBefore(g,k.firstChild),void 0===a(k.options[k.selectedIndex]).attr("selected")&&(g.selected=!0)}return this.$element.find("option").each(function(b){var c=a(this);if(h++,!c.hasClass("bs-title-option")){var g=this.className||"",k=this.style.cssText,l=c.data("content")?c.data("content"):c.html(),m=c.data("tokens")?c.data("tokens"):null,n="undefined"!=typeof c.data("subtext")?'<small class="text-muted">'+c.data("subtext")+"</small>":"",o="undefined"!=typeof c.data("icon")?'<span class="'+d.options.iconBase+" "+c.data("icon")+'"></span> ':"",p="OPTGROUP"===this.parentNode.tagName,q=this.disabled||p&&this.parentNode.disabled;if(""!==o&&q&&(o="<span>"+o+"</span>"),d.options.hideDisabled&&q&&!p)return void h--;if(c.data("content")||(l=o+'<span class="text">'+l+n+"</span>"),p&&c.data("divider")!==!0){var r=" "+this.parentNode.className||"";if(0===c.index()){f+=1;var s=this.parentNode.label,t="undefined"!=typeof c.parent().data("subtext")?'<small class="text-muted">'+c.parent().data("subtext")+"</small>":"",u=c.parent().data("icon")?'<span class="'+d.options.iconBase+" "+c.parent().data("icon")+'"></span> ':"";s=u+'<span class="text">'+s+t+"</span>",0!==b&&e.length>0&&(h++,e.push(i("",null,"divider",f+"div"))),h++,e.push(i(s,null,"dropdown-header"+r,f))}if(d.options.hideDisabled&&q)return void h--;e.push(i(j(l,"opt "+g+r,k,m),b,"",f))}else c.data("divider")===!0?e.push(i("",b,"divider")):c.data("hidden")===!0?e.push(i(j(l,g,k,m),b,"hidden is-hidden")):(this.previousElementSibling&&"OPTGROUP"===this.previousElementSibling.tagName&&(h++,e.push(i("",null,"divider",f+"div"))),e.push(i(j(l,g,k,m),b)));d.liObj[b]=h}}),this.multiple||0!==this.$element.find("option:selected").length||this.options.title||this.$element.find("option").eq(0).prop("selected",!0).attr("selected","selected"),e.join("")},findLis:function(){return null==this.$lis&&(this.$lis=this.$menu.find("li")),this.$lis},render:function(b){var c,d=this;b!==!1&&this.$element.find("option").each(function(a){var b=d.findLis().eq(d.liObj[a]);d.setDisabled(a,this.disabled||"OPTGROUP"===this.parentNode.tagName&&this.parentNode.disabled,b),d.setSelected(a,this.selected,b)}),this.tabIndex();var e=this.$element.find("option").map(function(){if(this.selected){if(d.options.hideDisabled&&(this.disabled||"OPTGROUP"===this.parentNode.tagName&&this.parentNode.disabled))return;var b,c=a(this),e=c.data("icon")&&d.options.showIcon?'<i class="'+d.options.iconBase+" "+c.data("icon")+'"></i> ':"";return b=d.options.showSubtext&&c.data("subtext")&&!d.multiple?' <small class="text-muted">'+c.data("subtext")+"</small>":"","undefined"!=typeof c.attr("title")?c.attr("title"):c.data("content")&&d.options.showContent?c.data("content"):e+c.html()+b}}).toArray(),f=this.multiple?e.join(this.options.multipleSeparator):e[0];if(this.multiple&&this.options.selectedTextFormat.indexOf("count")>-1){var g=this.options.selectedTextFormat.split(">");if(g.length>1&&e.length>g[1]||1==g.length&&e.length>=2){c=this.options.hideDisabled?", [disabled]":"";var h=this.$element.find("option").not('[data-divider="true"], [data-hidden="true"]'+c).length,i="function"==typeof this.options.countSelectedText?this.options.countSelectedText(e.length,h):this.options.countSelectedText;f=i.replace("{0}",e.length.toString()).replace("{1}",h.toString())}}void 0==this.options.title&&(this.options.title=this.$element.attr("title")),"static"==this.options.selectedTextFormat&&(f=this.options.title),f||(f="undefined"!=typeof this.options.title?this.options.title:this.options.noneSelectedText),this.$button.attr("title",a.trim(f.replace(/<[^>]*>?/g,""))),this.$button.children(".filter-option").html(f),this.$element.trigger("rendered.bs.select")},setStyle:function(a,b){this.$element.attr("class")&&this.$newElement.addClass(this.$element.attr("class").replace(/selectpicker|mobile-device|bs-select-hidden|validate\[.*\]/gi,""));var c=a?a:this.options.style;"add"==b?this.$button.addClass(c):"remove"==b?this.$button.removeClass(c):(this.$button.removeClass(this.options.style),this.$button.addClass(c))},liHeight:function(b){if(b||this.options.size!==!1&&!this.sizeInfo){var c=document.createElement("div"),d=document.createElement("div"),e=document.createElement("ul"),f=document.createElement("li"),g=document.createElement("li"),h=document.createElement("a"),i=document.createElement("span"),j=this.options.header&&this.$menu.find(".popover-title").length>0?this.$menu.find(".popover-title")[0].cloneNode(!0):null,k=this.options.liveSearch?document.createElement("div"):null,l=this.options.actionsBox&&this.multiple&&this.$menu.find(".bs-actionsbox").length>0?this.$menu.find(".bs-actionsbox")[0].cloneNode(!0):null,m=this.options.doneButton&&this.multiple&&this.$menu.find(".bs-donebutton").length>0?this.$menu.find(".bs-donebutton")[0].cloneNode(!0):null;if(i.className="text",c.className=this.$menu[0].parentNode.className+" open",d.className="dropdown-menu open",e.className="dropdown-menu inner",f.className="divider",i.appendChild(document.createTextNode("Inner text")),h.appendChild(i),g.appendChild(h),e.appendChild(g),e.appendChild(f),j&&d.appendChild(j),k){var n=document.createElement("span");k.className="bs-searchbox",n.className="form-control",k.appendChild(n),d.appendChild(k)}l&&d.appendChild(l),d.appendChild(e),m&&d.appendChild(m),c.appendChild(d),document.body.appendChild(c);var o=h.offsetHeight,p=j?j.offsetHeight:0,q=k?k.offsetHeight:0,r=l?l.offsetHeight:0,s=m?m.offsetHeight:0,t=a(f).outerHeight(!0),u="function"==typeof getComputedStyle?getComputedStyle(d):!1,v=u?null:a(d),w=parseInt(u?u.paddingTop:v.css("paddingTop"))+parseInt(u?u.paddingBottom:v.css("paddingBottom"))+parseInt(u?u.borderTopWidth:v.css("borderTopWidth"))+parseInt(u?u.borderBottomWidth:v.css("borderBottomWidth")),x=w+parseInt(u?u.marginTop:v.css("marginTop"))+parseInt(u?u.marginBottom:v.css("marginBottom"))+2;document.body.removeChild(c),this.sizeInfo={liHeight:o,headerHeight:p,searchHeight:q,actionsHeight:r,doneButtonHeight:s,dividerHeight:t,menuPadding:w,menuExtras:x}}},setSize:function(){if(this.findLis(),this.liHeight(),this.options.header&&this.$menu.css("padding-top",0),this.options.size!==!1){var b,c,d,e,f=this,g=this.$menu,h=this.$menuInner,i=a(window),j=this.$newElement[0].offsetHeight,k=this.sizeInfo.liHeight,l=this.sizeInfo.headerHeight,m=this.sizeInfo.searchHeight,n=this.sizeInfo.actionsHeight,o=this.sizeInfo.doneButtonHeight,p=this.sizeInfo.dividerHeight,q=this.sizeInfo.menuPadding,r=this.sizeInfo.menuExtras,s=this.options.hideDisabled?".disabled":"",t=function(){d=f.$newElement.offset().top-i.scrollTop(),e=i.height()-d-j};if(t(),"auto"===this.options.size){var u=function(){var i,j=function(b,c){return function(d){return c?d.classList?d.classList.contains(b):a(d).hasClass(b):!(d.classList?d.classList.contains(b):a(d).hasClass(b))}},p=f.$menuInner[0].getElementsByTagName("li"),s=Array.prototype.filter?Array.prototype.filter.call(p,j("hidden",!1)):f.$lis.not(".hidden"),u=Array.prototype.filter?Array.prototype.filter.call(s,j("dropdown-header",!0)):s.filter(".dropdown-header");t(),b=e-r,f.options.container?(g.data("height")||g.data("height",g.height()),c=g.data("height")):c=g.height(),f.options.dropupAuto&&f.$newElement.toggleClass("dropup",d>e&&c>b-r),f.$newElement.hasClass("dropup")&&(b=d-r),i=s.length+u.length>3?3*k+r-2:0,g.css({"max-height":b+"px",overflow:"hidden","min-height":i+l+m+n+o+"px"}),h.css({"max-height":b-l-m-n-o-q+"px","overflow-y":"auto","min-height":Math.max(i-q,0)+"px"})};u(),this.$searchbox.off("input.getSize propertychange.getSize").on("input.getSize propertychange.getSize",u),i.off("resize.getSize scroll.getSize").on("resize.getSize scroll.getSize",u)}else if(this.options.size&&"auto"!=this.options.size&&this.$lis.not(s).length>this.options.size){var v=this.$lis.not(".divider").not(s).children().slice(0,this.options.size).last().parent().index(),w=this.$lis.slice(0,v+1).filter(".divider").length;b=k*this.options.size+w*p+q,f.options.container?(g.data("height")||g.data("height",g.height()),c=g.data("height")):c=g.height(),f.options.dropupAuto&&this.$newElement.toggleClass("dropup",d>e&&c>b-r),g.css({"max-height":b+l+m+n+o+"px",overflow:"hidden","min-height":""}),h.css({"max-height":b-q+"px","overflow-y":"auto","min-height":""})}}},setWidth:function(){if("auto"===this.options.width){this.$menu.css("min-width","0");var a=this.$menu.parent().clone().appendTo("body"),b=this.options.container?this.$newElement.clone().appendTo("body"):a,c=a.children(".dropdown-menu").outerWidth(),d=b.css("width","auto").children("button").outerWidth();a.remove(),b.remove(),this.$newElement.css("width",Math.max(c,d)+"px")}else"fit"===this.options.width?(this.$menu.css("min-width",""),this.$newElement.css("width","").addClass("fit-width")):this.options.width?(this.$menu.css("min-width",""),this.$newElement.css("width",this.options.width)):(this.$menu.css("min-width",""),this.$newElement.css("width",""));this.$newElement.hasClass("fit-width")&&"fit"!==this.options.width&&this.$newElement.removeClass("fit-width")},selectPosition:function(){this.$bsContainer=a('<div class="bs-container" />');var b,c,d=this,e=function(a){d.$bsContainer.addClass(a.attr("class").replace(/form-control|fit-width/gi,"")).toggleClass("dropup",a.hasClass("dropup")),b=a.offset(),c=a.hasClass("dropup")?0:a[0].offsetHeight,d.$bsContainer.css({top:b.top+c,left:b.left,width:a[0].offsetWidth})};this.$button.on("click",function(){var b=a(this);d.isDisabled()||(e(d.$newElement),d.$bsContainer.appendTo(d.options.container).toggleClass("open",!b.hasClass("open")).append(d.$menu))}),a(window).on("resize scroll",function(){e(d.$newElement)}),this.$element.on("hide.bs.select",function(){d.$menu.data("height",d.$menu.height()),d.$bsContainer.detach()})},setSelected:function(a,b,c){c||(c=this.findLis().eq(this.liObj[a])),c.toggleClass("selected",b)},setDisabled:function(a,b,c){c||(c=this.findLis().eq(this.liObj[a])),b?c.addClass("disabled").children("a").attr("href","#").attr("tabindex",-1):c.removeClass("disabled").children("a").removeAttr("href").attr("tabindex",0)},isDisabled:function(){return this.$element[0].disabled},checkDisabled:function(){var a=this;this.isDisabled()?(this.$newElement.addClass("disabled"),this.$button.addClass("disabled").attr("tabindex",-1)):(this.$button.hasClass("disabled")&&(this.$newElement.removeClass("disabled"),this.$button.removeClass("disabled")),-1!=this.$button.attr("tabindex")||this.$element.data("tabindex")||this.$button.removeAttr("tabindex")),this.$button.click(function(){return!a.isDisabled()})},tabIndex:function(){this.$element.data("tabindex")!==this.$element.attr("tabindex")&&-98!==this.$element.attr("tabindex")&&"-98"!==this.$element.attr("tabindex")&&(this.$element.data("tabindex",this.$element.attr("tabindex")),this.$button.attr("tabindex",this.$element.data("tabindex"))),this.$element.attr("tabindex",-98)},clickListener:function(){var b=this,c=a(document);this.$newElement.on("touchstart.dropdown",".dropdown-menu",function(a){a.stopPropagation()}),c.data("spaceSelect",!1),this.$button.on("keyup",function(a){/(32)/.test(a.keyCode.toString(10))&&c.data("spaceSelect")&&(a.preventDefault(),c.data("spaceSelect",!1))}),this.$button.on("click",function(){b.setSize()}),this.$element.on("shown.bs.select",function(){if(b.options.liveSearch||b.multiple){if(!b.multiple){var a=b.liObj[b.$element[0].selectedIndex];if("number"!=typeof a||b.options.size===!1)return;var c=b.$lis.eq(a)[0].offsetTop-b.$menuInner[0].offsetTop;c=c-b.$menuInner[0].offsetHeight/2+b.sizeInfo.liHeight/2,b.$menuInner[0].scrollTop=c}}else b.$menuInner.find(".selected a").focus()}),this.$menuInner.on("click","li a",function(c){var d=a(this),e=d.parent().data("originalIndex"),f=b.$element.val(),g=b.$element.prop("selectedIndex");if(b.multiple&&c.stopPropagation(),c.preventDefault(),!b.isDisabled()&&!d.parent().hasClass("disabled")){var h=b.$element.find("option"),i=h.eq(e),j=i.prop("selected"),k=i.parent("optgroup"),l=b.options.maxOptions,m=k.data("maxOptions")||!1;if(b.multiple){if(i.prop("selected",!j),b.setSelected(e,!j),d.blur(),l!==!1||m!==!1){var n=l<h.filter(":selected").length,o=m<k.find("option:selected").length;if(l&&n||m&&o)if(l&&1==l)h.prop("selected",!1),i.prop("selected",!0),b.$menuInner.find(".selected").removeClass("selected"),b.setSelected(e,!0);else if(m&&1==m){k.find("option:selected").prop("selected",!1),i.prop("selected",!0);var p=d.parent().data("optgroup");b.$menuInner.find('[data-optgroup="'+p+'"]').removeClass("selected"),b.setSelected(e,!0)}else{var q="function"==typeof b.options.maxOptionsText?b.options.maxOptionsText(l,m):b.options.maxOptionsText,r=q[0].replace("{n}",l),s=q[1].replace("{n}",m),t=a('<div class="notify"></div>');q[2]&&(r=r.replace("{var}",q[2][l>1?0:1]),s=s.replace("{var}",q[2][m>1?0:1])),i.prop("selected",!1),b.$menu.append(t),l&&n&&(t.append(a("<div>"+r+"</div>")),b.$element.trigger("maxReached.bs.select")),m&&o&&(t.append(a("<div>"+s+"</div>")),b.$element.trigger("maxReachedGrp.bs.select")),setTimeout(function(){b.setSelected(e,!1)},10),t.delay(750).fadeOut(300,function(){a(this).remove()})}}}else h.prop("selected",!1),i.prop("selected",!0),b.$menuInner.find(".selected").removeClass("selected"),b.setSelected(e,!0);b.multiple?b.options.liveSearch&&b.$searchbox.focus():b.$button.focus(),(f!=b.$element.val()&&b.multiple||g!=b.$element.prop("selectedIndex")&&!b.multiple)&&b.$element.trigger("changed.bs.select",[e,i.prop("selected"),j]).triggerNative("change")}}),this.$menu.on("click","li.disabled a, .popover-title, .popover-title :not(.close)",function(c){c.currentTarget==this&&(c.preventDefault(),c.stopPropagation(),b.options.liveSearch&&!a(c.target).hasClass("close")?b.$searchbox.focus():b.$button.focus())}),this.$menuInner.on("click",".divider, .dropdown-header",function(a){a.preventDefault(),a.stopPropagation(),b.options.liveSearch?b.$searchbox.focus():b.$button.focus()}),this.$menu.on("click",".popover-title .close",function(){b.$button.click()}),this.$searchbox.on("click",function(a){a.stopPropagation()}),this.$menu.on("click",".actions-btn",function(c){b.options.liveSearch?b.$searchbox.focus():b.$button.focus(),c.preventDefault(),c.stopPropagation(),a(this).hasClass("bs-select-all")?b.selectAll():b.deselectAll()}),this.$element.change(function(){b.render(!1)})},liveSearchListener:function(){var d=this,e=a('<li class="no-results"></li>');this.$button.on("click.dropdown.data-api touchstart.dropdown.data-api",function(){d.$menuInner.find(".active").removeClass("active"),d.$searchbox.val()&&(d.$searchbox.val(""),d.$lis.not(".is-hidden").removeClass("hidden"),e.parent().length&&e.remove()),d.multiple||d.$menuInner.find(".selected").addClass("active"),setTimeout(function(){d.$searchbox.focus()},10)}),this.$searchbox.on("click.dropdown.data-api focus.dropdown.data-api touchend.dropdown.data-api",function(a){a.stopPropagation()}),this.$searchbox.on("input propertychange",function(){if(d.$searchbox.val()){var f=d.$lis.not(".is-hidden").removeClass("hidden").children("a");f=d.options.liveSearchNormalize?f.not(":a"+d._searchStyle()+'("'+b(d.$searchbox.val())+'")'):f.not(":"+d._searchStyle()+'("'+d.$searchbox.val()+'")'),f.parent().addClass("hidden"),d.$lis.filter(".dropdown-header").each(function(){var b=a(this),c=b.data("optgroup");0===d.$lis.filter("[data-optgroup="+c+"]").not(b).not(".hidden").length&&(b.addClass("hidden"),d.$lis.filter("[data-optgroup="+c+"div]").addClass("hidden"))});var g=d.$lis.not(".hidden");g.each(function(b){var c=a(this);c.hasClass("divider")&&(c.index()===g.first().index()||c.index()===g.last().index()||g.eq(b+1).hasClass("divider"))&&c.addClass("hidden")}),d.$lis.not(".hidden, .no-results").length?e.parent().length&&e.remove():(e.parent().length&&e.remove(),e.html(d.options.noneResultsText.replace("{0}",'"'+c(d.$searchbox.val())+'"')).show(),d.$menuInner.append(e))}else d.$lis.not(".is-hidden").removeClass("hidden"),e.parent().length&&e.remove();d.$lis.filter(".active").removeClass("active"),d.$searchbox.val()&&d.$lis.not(".hidden, .divider, .dropdown-header").eq(0).addClass("active").children("a").focus(),a(this).focus()})},_searchStyle:function(){var a={begins:"ibegins",startsWith:"ibegins"};return a[this.options.liveSearchStyle]||"icontains"},val:function(a){return"undefined"!=typeof a?(this.$element.val(a),this.render(),this.$element):this.$element.val()},changeAll:function(b){"undefined"==typeof b&&(b=!0),this.findLis();for(var c=this.$element.find("option"),d=this.$lis.not(".divider, .dropdown-header, .disabled, .hidden").toggleClass("selected",b),e=d.length,f=[],g=0;e>g;g++){var h=d[g].getAttribute("data-original-index");f[f.length]=c.eq(h)[0]}a(f).prop("selected",b),this.render(!1),this.$element.trigger("changed.bs.select").triggerNative("change")},selectAll:function(){return this.changeAll(!0)},deselectAll:function(){return this.changeAll(!1)},toggle:function(a){a=a||window.event,a&&a.stopPropagation(),this.$button.trigger("click")},keydown:function(c){var d,e,f,g,h,i,j,k,l,m=a(this),n=m.is("input")?m.parent().parent():m.parent(),o=n.data("this"),p=":not(.disabled, .hidden, .dropdown-header, .divider)",q={32:" ",48:"0",49:"1",50:"2",51:"3",52:"4",53:"5",54:"6",55:"7",56:"8",57:"9",59:";",65:"a",66:"b",67:"c",68:"d",69:"e",70:"f",71:"g",72:"h",73:"i",74:"j",75:"k",76:"l",77:"m",78:"n",79:"o",80:"p",81:"q",82:"r",83:"s",84:"t",85:"u",86:"v",87:"w",88:"x",89:"y",90:"z",96:"0",97:"1",98:"2",99:"3",100:"4",101:"5",102:"6",103:"7",104:"8",105:"9"};if(o.options.liveSearch&&(n=m.parent().parent()),o.options.container&&(n=o.$menu),d=a("[role=menu] li",n),l=o.$newElement.hasClass("open"),!l&&(c.keyCode>=48&&c.keyCode<=57||c.keyCode>=96&&c.keyCode<=105||c.keyCode>=65&&c.keyCode<=90)&&(o.options.container?o.$button.trigger("click"):(o.setSize(),o.$menu.parent().addClass("open"),l=!0),o.$searchbox.focus()),o.options.liveSearch&&(/(^9$|27)/.test(c.keyCode.toString(10))&&l&&0===o.$menu.find(".active").length&&(c.preventDefault(),o.$menu.parent().removeClass("open"),o.options.container&&o.$newElement.removeClass("open"),o.$button.focus()),d=a("[role=menu] li"+p,n),m.val()||/(38|40)/.test(c.keyCode.toString(10))||0===d.filter(".active").length&&(d=o.$menuInner.find("li"),d=o.options.liveSearchNormalize?d.filter(":a"+o._searchStyle()+"("+b(q[c.keyCode])+")"):d.filter(":"+o._searchStyle()+"("+q[c.keyCode]+")"))),d.length){if(/(38|40)/.test(c.keyCode.toString(10)))e=d.index(d.find("a").filter(":focus").parent()),g=d.filter(p).first().index(),h=d.filter(p).last().index(),f=d.eq(e).nextAll(p).eq(0).index(),i=d.eq(e).prevAll(p).eq(0).index(),j=d.eq(f).prevAll(p).eq(0).index(),o.options.liveSearch&&(d.each(function(b){a(this).hasClass("disabled")||a(this).data("index",b)}),e=d.index(d.filter(".active")),g=d.first().data("index"),h=d.last().data("index"),f=d.eq(e).nextAll().eq(0).data("index"),i=d.eq(e).prevAll().eq(0).data("index"),j=d.eq(f).prevAll().eq(0).data("index")),k=m.data("prevIndex"),38==c.keyCode?(o.options.liveSearch&&e--,e!=j&&e>i&&(e=i),g>e&&(e=g),e==k&&(e=h)):40==c.keyCode&&(o.options.liveSearch&&e++,-1==e&&(e=0),e!=j&&f>e&&(e=f),e>h&&(e=h),e==k&&(e=g)),m.data("prevIndex",e),o.options.liveSearch?(c.preventDefault(),m.hasClass("dropdown-toggle")||(d.removeClass("active").eq(e).addClass("active").children("a").focus(),m.focus())):d.eq(e).children("a").focus();else if(!m.is("input")){var r,s,t=[];d.each(function(){a(this).hasClass("disabled")||a.trim(a(this).children("a").text().toLowerCase()).substring(0,1)==q[c.keyCode]&&t.push(a(this).index())}),r=a(document).data("keycount"),r++,a(document).data("keycount",r),s=a.trim(a(":focus").text().toLowerCase()).substring(0,1),s!=q[c.keyCode]?(r=1,a(document).data("keycount",r)):r>=t.length&&(a(document).data("keycount",0),r>t.length&&(r=1)),d.eq(t[r-1]).children("a").focus()}if((/(13|32)/.test(c.keyCode.toString(10))||/(^9$)/.test(c.keyCode.toString(10))&&o.options.selectOnTab)&&l){if(/(32)/.test(c.keyCode.toString(10))||c.preventDefault(),o.options.liveSearch)/(32)/.test(c.keyCode.toString(10))||(o.$menuInner.find(".active a").click(),m.focus());else{var u=a(":focus");u.click(),u.focus(),c.preventDefault(),a(document).data("spaceSelect",!0)}a(document).data("keycount",0)}(/(^9$|27)/.test(c.keyCode.toString(10))&&l&&(o.multiple||o.options.liveSearch)||/(27)/.test(c.keyCode.toString(10))&&!l)&&(o.$menu.parent().removeClass("open"),o.options.container&&o.$newElement.removeClass("open"),o.$button.focus())}},mobile:function(){this.$element.addClass("mobile-device")},refresh:function(){this.$lis=null,this.liObj={},this.reloadLi(),this.render(),this.checkDisabled(),this.liHeight(!0),this.setStyle(),this.setWidth(),this.$lis&&this.$searchbox.trigger("propertychange"),this.$element.trigger("refreshed.bs.select")},hide:function(){this.$newElement.hide()},show:function(){this.$newElement.show()},remove:function(){this.$newElement.remove(),this.$element.remove()},destroy:function(){this.$newElement.before(this.$element).remove(),this.$bsContainer?this.$bsContainer.remove():this.$menu.remove(),this.$element.off(".bs.select").removeData("selectpicker").removeClass("bs-select-hidden selectpicker")}};var f=a.fn.selectpicker;a.fn.selectpicker=d,a.fn.selectpicker.Constructor=e,a.fn.selectpicker.noConflict=function(){return a.fn.selectpicker=f,this},a(document).data("keycount",0).on("keydown.bs.select",'.bootstrap-select [data-toggle=dropdown], .bootstrap-select [role="menu"], .bs-searchbox input',e.prototype.keydown).on("focusin.modal",'.bootstrap-select [data-toggle=dropdown], .bootstrap-select [role="menu"], .bs-searchbox input',function(a){a.stopPropagation()}),a(window).on("load.bs.select.data-api",function(){a(".selectpicker").each(function(){var b=a(this);d.call(b,b.data())})})}(a)});
//# sourceMappingURL=bootstrap-select.js.map;
!function ($) {

    "use strict";

    // TABCOLLAPSE CLASS DEFINITION
    // ======================

    var TabCollapse = function (el, options) {
        this.options   = options;
        this.$tabs  = $(el);

        this._accordionVisible = false; //content is attached to tabs at first
        this._initAccordion();
        this._checkStateOnResize();


        // checkState() has gone to setTimeout for making it possible to attach listeners to
        // shown-accordion.bs.tabcollapse event on page load.
        // See https://github.com/flatlogic/bootstrap-tabcollapse/issues/23
        var that = this;
        setTimeout(function() {
          that.checkState();
        }, 0);
    };

    TabCollapse.DEFAULTS = {
        accordionClass: 'visible-xs',
        tabsClass: 'hidden-xs',
        accordionTemplate: function(heading, groupId, parentId, active) {
            return  '<div class="panel panel-default">' +
                    '   <div class="panel-heading">' +
                    '      <h4 class="panel-title">' +
                    '      </h4>' +
                    '   </div>' +
                    '   <div id="' + groupId + '" class="panel-collapse collapse ' + (active ? 'in' : '') + '">' +
                    '       <div class="panel-body js-tabcollapse-panel-body">' +
                    '       </div>' +
                    '   </div>' +
                    '</div>'

        }
    };

    TabCollapse.prototype.checkState = function(){
        if (this.$tabs.is(':visible') && this._accordionVisible){
            this.showTabs();
            this._accordionVisible = false;
        } else if (this.$accordion.is(':visible') && !this._accordionVisible){
            this.showAccordion();
            this._accordionVisible = true;
        }
    };

    TabCollapse.prototype.showTabs = function(){
        var view = this;
        this.$tabs.trigger($.Event('show-tabs.bs.tabcollapse'));

        var $panelHeadings = this.$accordion.find('.js-tabcollapse-panel-heading').detach();

        $panelHeadings.each(function() {
            var $panelHeading = $(this),
            $parentLi = $panelHeading.data('bs.tabcollapse.parentLi');

            var $oldHeading = view._panelHeadingToTabHeading($panelHeading);

            $parentLi.removeClass('active');
            if ($parentLi.parent().hasClass('dropdown-menu') && !$parentLi.siblings('li').hasClass('active')) {
                $parentLi.parent().parent().removeClass('active');
            }

            if (!$oldHeading.hasClass('collapsed')) {
                $parentLi.addClass('active');
                if ($parentLi.parent().hasClass('dropdown-menu')) {
                    $parentLi.parent().parent().addClass('active');
                }
            } else {
                $oldHeading.removeClass('collapsed');
            }

            $parentLi.append($panelHeading);
        });

        if (!$('li').hasClass('active')) {
            $('li').first().addClass('active')
        }

        var $panelBodies = this.$accordion.find('.js-tabcollapse-panel-body');
        $panelBodies.each(function(){
            var $panelBody = $(this),
                $tabPane = $panelBody.data('bs.tabcollapse.tabpane');
            $tabPane.append($panelBody.contents().detach());
        });
        this.$accordion.html('');

        if(this.options.updateLinks) {
            var $tabContents = this.getTabContentElement();
            $tabContents.find('[data-toggle-was="tab"], [data-toggle-was="pill"]').each(function() {
                var $el = $(this);
                var href = $el.attr('href').replace(/-collapse$/g, '');
                $el.attr({
                    'data-toggle': $el.attr('data-toggle-was'),
                    'data-toggle-was': '',
                    'data-parent': '',
                    href: href
                });
            });
        }

        this.$tabs.trigger($.Event('shown-tabs.bs.tabcollapse'));
    };

    TabCollapse.prototype.getTabContentElement = function(){
        var $tabContents = $(this.options.tabContentSelector);
        if($tabContents.length === 0) {
            $tabContents = this.$tabs.siblings('.tab-content');
        }
        return $tabContents;
    };

    TabCollapse.prototype.showAccordion = function(){
        this.$tabs.trigger($.Event('show-accordion.bs.tabcollapse'));

        var $headings = this.$tabs.find('li:not(.dropdown) [data-toggle="tab"], li:not(.dropdown) [data-toggle="pill"]'),
            view = this;
        $headings.each(function(){
            var $heading = $(this),
                $parentLi = $heading.parent();
            $heading.data('bs.tabcollapse.parentLi', $parentLi);
            view.$accordion.append(view._createAccordionGroup(view.$accordion.attr('id'), $heading.detach()));
        });

        if(this.options.updateLinks) {
            var parentId = this.$accordion.attr('id');
            var $selector = this.$accordion.find('.js-tabcollapse-panel-body');
            $selector.find('[data-toggle="tab"], [data-toggle="pill"]').each(function() {
                var $el = $(this);
                var href = $el.attr('href') + '-collapse';
                $el.attr({
                    'data-toggle-was': $el.attr('data-toggle'),
                    'data-toggle': 'collapse',
                    'data-parent': '#' + parentId,
                    href: href
                });
            });
        }

        this.$tabs.trigger($.Event('shown-accordion.bs.tabcollapse'));
    };

    TabCollapse.prototype._panelHeadingToTabHeading = function($heading) {
        var href = $heading.attr('href').replace(/-collapse$/g, '');
        $heading.attr({
            'data-toggle': 'tab',
            'href': href,
            'data-parent': ''
        });
        return $heading;
    };

    TabCollapse.prototype._tabHeadingToPanelHeading = function($heading, groupId, parentId, active) {
        $heading.addClass('js-tabcollapse-panel-heading ' + (active ? '' : 'collapsed'));
        $heading.attr({
            'data-toggle': 'collapse',
            'data-parent': '#' + parentId,
            'href': '#' + groupId
        });
        return $heading;
    };

    TabCollapse.prototype._checkStateOnResize = function(){
        var view = this;
        $(window).resize(function(){
            clearTimeout(view._resizeTimeout);
            view._resizeTimeout = setTimeout(function(){
                view.checkState();
            }, 100);
        });
    };


    TabCollapse.prototype._initAccordion = function(){
        var randomString = function() {
            var result = "",
                possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
            for( var i=0; i < 5; i++ ) {
                result += possible.charAt(Math.floor(Math.random() * possible.length));
            }
            return result;
        };

        var srcId = this.$tabs.attr('id'),
            accordionId = (srcId ? srcId : randomString()) + '-accordion';

        this.$accordion = $('<div class="panel-group ' + this.options.accordionClass + '" id="' + accordionId +'"></div>');
        this.$tabs.after(this.$accordion);
        this.$tabs.addClass(this.options.tabsClass);
        this.getTabContentElement().addClass(this.options.tabsClass);
    };

    TabCollapse.prototype._createAccordionGroup = function(parentId, $heading){
        var tabSelector = $heading.attr('data-target'),
            active = $heading.data('bs.tabcollapse.parentLi').is('.active');

        if (!tabSelector) {
            tabSelector = $heading.attr('href');
            tabSelector = tabSelector && tabSelector.replace(/.*(?=#[^\s]*$)/, ''); //strip for ie7
        }

        var $tabPane = $(tabSelector),
            groupId = $tabPane.attr('id') + '-collapse',
            $panel = $(this.options.accordionTemplate($heading, groupId, parentId, active));
        $panel.find('.panel-heading > .panel-title').append(this._tabHeadingToPanelHeading($heading, groupId, parentId, active));
        $panel.find('.panel-body').append($tabPane.contents().detach())
            .data('bs.tabcollapse.tabpane', $tabPane);

        return $panel;
    };



    // TABCOLLAPSE PLUGIN DEFINITION
    // =======================

    $.fn.tabCollapse = function (option) {
        return this.each(function () {
            var $this   = $(this);
            var data    = $this.data('bs.tabcollapse');
            var options = $.extend({}, TabCollapse.DEFAULTS, $this.data(), typeof option === 'object' && option);

            if (!data) $this.data('bs.tabcollapse', new TabCollapse(this, options));
        });
    };

    $.fn.tabCollapse.Constructor = TabCollapse;


}(window.jQuery);

define("bootstrap-tabcollapse", ["bootstrap"], function(){});

/*!
 * Datepicker for Bootstrap v1.6.0 (https://github.com/eternicode/bootstrap-datepicker)
 *
 * Copyright 2012 Stefan Petre
 * Improvements by Andrew Rowls
 * Licensed under the Apache License v2.0 (http://www.apache.org/licenses/LICENSE-2.0)
 */
!function(a){"function"==typeof define&&define.amd?define('bootstrap-datepicker',["jquery"],a):a("object"==typeof exports?require("jquery"):jQuery)}(function(a,b){function c(){return new Date(Date.UTC.apply(Date,arguments))}function d(){var a=new Date;return c(a.getFullYear(),a.getMonth(),a.getDate())}function e(a,b){return a.getUTCFullYear()===b.getUTCFullYear()&&a.getUTCMonth()===b.getUTCMonth()&&a.getUTCDate()===b.getUTCDate()}function f(a){return function(){return this[a].apply(this,arguments)}}function g(a){return a&&!isNaN(a.getTime())}function h(b,c){function d(a,b){return b.toLowerCase()}var e,f=a(b).data(),g={},h=new RegExp("^"+c.toLowerCase()+"([A-Z])");c=new RegExp("^"+c.toLowerCase());for(var i in f)c.test(i)&&(e=i.replace(h,d),g[e]=f[i]);return g}function i(b){var c={};if(q[b]||(b=b.split("-")[0],q[b])){var d=q[b];return a.each(p,function(a,b){b in d&&(c[b]=d[b])}),c}}var j=function(){var b={get:function(a){return this.slice(a)[0]},contains:function(a){for(var b=a&&a.valueOf(),c=0,d=this.length;d>c;c++)if(this[c].valueOf()===b)return c;return-1},remove:function(a){this.splice(a,1)},replace:function(b){b&&(a.isArray(b)||(b=[b]),this.clear(),this.push.apply(this,b))},clear:function(){this.length=0},copy:function(){var a=new j;return a.replace(this),a}};return function(){var c=[];return c.push.apply(c,arguments),a.extend(c,b),c}}(),k=function(b,c){a(b).data("datepicker",this),this._process_options(c),this.dates=new j,this.viewDate=this.o.defaultViewDate,this.focusDate=null,this.element=a(b),this.isInline=!1,this.isInput=this.element.is("input"),this.component=this.element.hasClass("date")?this.element.find(".add-on, .input-group-addon, .btn"):!1,this.hasInput=this.component&&this.element.find("input").length,this.component&&0===this.component.length&&(this.component=!1),this.picker=a(r.template),this._check_template(this.o.templates.leftArrow)&&this.picker.find(".prev").html(this.o.templates.leftArrow),this._check_template(this.o.templates.rightArrow)&&this.picker.find(".next").html(this.o.templates.rightArrow),this._buildEvents(),this._attachEvents(),this.isInline?this.picker.addClass("datepicker-inline").appendTo(this.element):this.picker.addClass("datepicker-dropdown dropdown-menu"),this.o.rtl&&this.picker.addClass("datepicker-rtl"),this.viewMode=this.o.startView,this.o.calendarWeeks&&this.picker.find("thead .datepicker-title, tfoot .today, tfoot .clear").attr("colspan",function(a,b){return parseInt(b)+1}),this._allow_update=!1,this.setStartDate(this._o.startDate),this.setEndDate(this._o.endDate),this.setDaysOfWeekDisabled(this.o.daysOfWeekDisabled),this.setDaysOfWeekHighlighted(this.o.daysOfWeekHighlighted),this.setDatesDisabled(this.o.datesDisabled),this.fillDow(),this.fillMonths(),this._allow_update=!0,this.update(),this.showMode(),this.isInline&&this.show()};k.prototype={constructor:k,_resolveViewName:function(a,c){return 0===a||"days"===a||"month"===a?0:1===a||"months"===a||"year"===a?1:2===a||"years"===a||"decade"===a?2:3===a||"decades"===a||"century"===a?3:4===a||"centuries"===a||"millennium"===a?4:c===b?!1:c},_check_template:function(c){try{if(c===b||""===c)return!1;if((c.match(/[<>]/g)||[]).length<=0)return!0;var d=a(c);return d.length>0}catch(e){return!1}},_process_options:function(b){this._o=a.extend({},this._o,b);var e=this.o=a.extend({},this._o),f=e.language;q[f]||(f=f.split("-")[0],q[f]||(f=o.language)),e.language=f,e.startView=this._resolveViewName(e.startView,0),e.minViewMode=this._resolveViewName(e.minViewMode,0),e.maxViewMode=this._resolveViewName(e.maxViewMode,4),e.startView=Math.min(e.startView,e.maxViewMode),e.startView=Math.max(e.startView,e.minViewMode),e.multidate!==!0&&(e.multidate=Number(e.multidate)||!1,e.multidate!==!1&&(e.multidate=Math.max(0,e.multidate))),e.multidateSeparator=String(e.multidateSeparator),e.weekStart%=7,e.weekEnd=(e.weekStart+6)%7;var g=r.parseFormat(e.format);if(e.startDate!==-(1/0)&&(e.startDate?e.startDate instanceof Date?e.startDate=this._local_to_utc(this._zero_time(e.startDate)):e.startDate=r.parseDate(e.startDate,g,e.language,e.assumeNearbyYear):e.startDate=-(1/0)),e.endDate!==1/0&&(e.endDate?e.endDate instanceof Date?e.endDate=this._local_to_utc(this._zero_time(e.endDate)):e.endDate=r.parseDate(e.endDate,g,e.language,e.assumeNearbyYear):e.endDate=1/0),e.daysOfWeekDisabled=e.daysOfWeekDisabled||[],a.isArray(e.daysOfWeekDisabled)||(e.daysOfWeekDisabled=e.daysOfWeekDisabled.split(/[,\s]*/)),e.daysOfWeekDisabled=a.map(e.daysOfWeekDisabled,function(a){return parseInt(a,10)}),e.daysOfWeekHighlighted=e.daysOfWeekHighlighted||[],a.isArray(e.daysOfWeekHighlighted)||(e.daysOfWeekHighlighted=e.daysOfWeekHighlighted.split(/[,\s]*/)),e.daysOfWeekHighlighted=a.map(e.daysOfWeekHighlighted,function(a){return parseInt(a,10)}),e.datesDisabled=e.datesDisabled||[],!a.isArray(e.datesDisabled)){var h=[];h.push(r.parseDate(e.datesDisabled,g,e.language,e.assumeNearbyYear)),e.datesDisabled=h}e.datesDisabled=a.map(e.datesDisabled,function(a){return r.parseDate(a,g,e.language,e.assumeNearbyYear)});var i=String(e.orientation).toLowerCase().split(/\s+/g),j=e.orientation.toLowerCase();if(i=a.grep(i,function(a){return/^auto|left|right|top|bottom$/.test(a)}),e.orientation={x:"auto",y:"auto"},j&&"auto"!==j)if(1===i.length)switch(i[0]){case"top":case"bottom":e.orientation.y=i[0];break;case"left":case"right":e.orientation.x=i[0]}else j=a.grep(i,function(a){return/^left|right$/.test(a)}),e.orientation.x=j[0]||"auto",j=a.grep(i,function(a){return/^top|bottom$/.test(a)}),e.orientation.y=j[0]||"auto";else;if(e.defaultViewDate){var k=e.defaultViewDate.year||(new Date).getFullYear(),l=e.defaultViewDate.month||0,m=e.defaultViewDate.day||1;e.defaultViewDate=c(k,l,m)}else e.defaultViewDate=d()},_events:[],_secondaryEvents:[],_applyEvents:function(a){for(var c,d,e,f=0;f<a.length;f++)c=a[f][0],2===a[f].length?(d=b,e=a[f][1]):3===a[f].length&&(d=a[f][1],e=a[f][2]),c.on(e,d)},_unapplyEvents:function(a){for(var c,d,e,f=0;f<a.length;f++)c=a[f][0],2===a[f].length?(e=b,d=a[f][1]):3===a[f].length&&(e=a[f][1],d=a[f][2]),c.off(d,e)},_buildEvents:function(){var b={keyup:a.proxy(function(b){-1===a.inArray(b.keyCode,[27,37,39,38,40,32,13,9])&&this.update()},this),keydown:a.proxy(this.keydown,this),paste:a.proxy(this.paste,this)};this.o.showOnFocus===!0&&(b.focus=a.proxy(this.show,this)),this.isInput?this._events=[[this.element,b]]:this.component&&this.hasInput?this._events=[[this.element.find("input"),b],[this.component,{click:a.proxy(this.show,this)}]]:this.element.is("div")?this.isInline=!0:this._events=[[this.element,{click:a.proxy(this.show,this)}]],this._events.push([this.element,"*",{blur:a.proxy(function(a){this._focused_from=a.target},this)}],[this.element,{blur:a.proxy(function(a){this._focused_from=a.target},this)}]),this.o.immediateUpdates&&this._events.push([this.element,{"changeYear changeMonth":a.proxy(function(a){this.update(a.date)},this)}]),this._secondaryEvents=[[this.picker,{click:a.proxy(this.click,this)}],[a(window),{resize:a.proxy(this.place,this)}],[a(document),{mousedown:a.proxy(function(a){this.element.is(a.target)||this.element.find(a.target).length||this.picker.is(a.target)||this.picker.find(a.target).length||this.picker.hasClass("datepicker-inline")||this.hide()},this)}]]},_attachEvents:function(){this._detachEvents(),this._applyEvents(this._events)},_detachEvents:function(){this._unapplyEvents(this._events)},_attachSecondaryEvents:function(){this._detachSecondaryEvents(),this._applyEvents(this._secondaryEvents)},_detachSecondaryEvents:function(){this._unapplyEvents(this._secondaryEvents)},_trigger:function(b,c){var d=c||this.dates.get(-1),e=this._utc_to_local(d);this.element.trigger({type:b,date:e,dates:a.map(this.dates,this._utc_to_local),format:a.proxy(function(a,b){0===arguments.length?(a=this.dates.length-1,b=this.o.format):"string"==typeof a&&(b=a,a=this.dates.length-1),b=b||this.o.format;var c=this.dates.get(a);return r.formatDate(c,b,this.o.language)},this)})},show:function(){var b=this.component?this.element.find("input"):this.element;if(!b.attr("readonly")||this.o.enableOnReadonly!==!1)return this.isInline||this.picker.appendTo(this.o.container),this.place(),this.picker.show(),this._attachSecondaryEvents(),this._trigger("show"),(window.navigator.msMaxTouchPoints||"ontouchstart"in document)&&this.o.disableTouchKeyboard&&a(this.element).blur(),this},hide:function(){return this.isInline?this:this.picker.is(":visible")?(this.focusDate=null,this.picker.hide().detach(),this._detachSecondaryEvents(),this.viewMode=this.o.startView,this.showMode(),this.o.forceParse&&(this.isInput&&this.element.val()||this.hasInput&&this.element.find("input").val())&&this.setValue(),this._trigger("hide"),this):this},destroy:function(){return this.hide(),this._detachEvents(),this._detachSecondaryEvents(),this.picker.remove(),delete this.element.data().datepicker,this.isInput||delete this.element.data().date,this},paste:function(b){var c;if(b.originalEvent.clipboardData&&b.originalEvent.clipboardData.types&&-1!==a.inArray("text/plain",b.originalEvent.clipboardData.types))c=b.originalEvent.clipboardData.getData("text/plain");else{if(!window.clipboardData)return;c=window.clipboardData.getData("Text")}this.setDate(c),this.update(),b.preventDefault()},_utc_to_local:function(a){return a&&new Date(a.getTime()+6e4*a.getTimezoneOffset())},_local_to_utc:function(a){return a&&new Date(a.getTime()-6e4*a.getTimezoneOffset())},_zero_time:function(a){return a&&new Date(a.getFullYear(),a.getMonth(),a.getDate())},_zero_utc_time:function(a){return a&&new Date(Date.UTC(a.getUTCFullYear(),a.getUTCMonth(),a.getUTCDate()))},getDates:function(){return a.map(this.dates,this._utc_to_local)},getUTCDates:function(){return a.map(this.dates,function(a){return new Date(a)})},getDate:function(){return this._utc_to_local(this.getUTCDate())},getUTCDate:function(){var a=this.dates.get(-1);return"undefined"!=typeof a?new Date(a):null},clearDates:function(){var a;this.isInput?a=this.element:this.component&&(a=this.element.find("input")),a&&a.val(""),this.update(),this._trigger("changeDate"),this.o.autoclose&&this.hide()},setDates:function(){var b=a.isArray(arguments[0])?arguments[0]:arguments;return this.update.apply(this,b),this._trigger("changeDate"),this.setValue(),this},setUTCDates:function(){var b=a.isArray(arguments[0])?arguments[0]:arguments;return this.update.apply(this,a.map(b,this._utc_to_local)),this._trigger("changeDate"),this.setValue(),this},setDate:f("setDates"),setUTCDate:f("setUTCDates"),remove:f("destroy"),setValue:function(){var a=this.getFormattedDate();return this.isInput?this.element.val(a):this.component&&this.element.find("input").val(a),this},getFormattedDate:function(c){c===b&&(c=this.o.format);var d=this.o.language;return a.map(this.dates,function(a){return r.formatDate(a,c,d)}).join(this.o.multidateSeparator)},getStartDate:function(){return this.o.startDate},setStartDate:function(a){return this._process_options({startDate:a}),this.update(),this.updateNavArrows(),this},getEndDate:function(){return this.o.endDate},setEndDate:function(a){return this._process_options({endDate:a}),this.update(),this.updateNavArrows(),this},setDaysOfWeekDisabled:function(a){return this._process_options({daysOfWeekDisabled:a}),this.update(),this.updateNavArrows(),this},setDaysOfWeekHighlighted:function(a){return this._process_options({daysOfWeekHighlighted:a}),this.update(),this},setDatesDisabled:function(a){this._process_options({datesDisabled:a}),this.update(),this.updateNavArrows()},place:function(){if(this.isInline)return this;var b=this.picker.outerWidth(),c=this.picker.outerHeight(),d=10,e=a(this.o.container),f=e.width(),g="body"===this.o.container?a(document).scrollTop():e.scrollTop(),h=e.offset(),i=[];this.element.parents().each(function(){var b=a(this).css("z-index");"auto"!==b&&0!==b&&i.push(parseInt(b))});var j=Math.max.apply(Math,i)+this.o.zIndexOffset,k=this.component?this.component.parent().offset():this.element.offset(),l=this.component?this.component.outerHeight(!0):this.element.outerHeight(!1),m=this.component?this.component.outerWidth(!0):this.element.outerWidth(!1),n=k.left-h.left,o=k.top-h.top;"body"!==this.o.container&&(o+=g),this.picker.removeClass("datepicker-orient-top datepicker-orient-bottom datepicker-orient-right datepicker-orient-left"),"auto"!==this.o.orientation.x?(this.picker.addClass("datepicker-orient-"+this.o.orientation.x),"right"===this.o.orientation.x&&(n-=b-m)):k.left<0?(this.picker.addClass("datepicker-orient-left"),n-=k.left-d):n+b>f?(this.picker.addClass("datepicker-orient-right"),n+=m-b):this.picker.addClass("datepicker-orient-left");var p,q=this.o.orientation.y;if("auto"===q&&(p=-g+o-c,q=0>p?"bottom":"top"),this.picker.addClass("datepicker-orient-"+q),"top"===q?o-=c+parseInt(this.picker.css("padding-top")):o+=l,this.o.rtl){var r=f-(n+m);this.picker.css({top:o,right:r,zIndex:j})}else this.picker.css({top:o,left:n,zIndex:j});return this},_allow_update:!0,update:function(){if(!this._allow_update)return this;var b=this.dates.copy(),c=[],d=!1;return arguments.length?(a.each(arguments,a.proxy(function(a,b){b instanceof Date&&(b=this._local_to_utc(b)),c.push(b)},this)),d=!0):(c=this.isInput?this.element.val():this.element.data("date")||this.element.find("input").val(),c=c&&this.o.multidate?c.split(this.o.multidateSeparator):[c],delete this.element.data().date),c=a.map(c,a.proxy(function(a){return r.parseDate(a,this.o.format,this.o.language,this.o.assumeNearbyYear)},this)),c=a.grep(c,a.proxy(function(a){return!this.dateWithinRange(a)||!a},this),!0),this.dates.replace(c),this.dates.length?this.viewDate=new Date(this.dates.get(-1)):this.viewDate<this.o.startDate?this.viewDate=new Date(this.o.startDate):this.viewDate>this.o.endDate?this.viewDate=new Date(this.o.endDate):this.viewDate=this.o.defaultViewDate,d?this.setValue():c.length&&String(b)!==String(this.dates)&&this._trigger("changeDate"),!this.dates.length&&b.length&&this._trigger("clearDate"),this.fill(),this.element.change(),this},fillDow:function(){var b=this.o.weekStart,c="<tr>";for(this.o.calendarWeeks&&(this.picker.find(".datepicker-days .datepicker-switch").attr("colspan",function(a,b){return parseInt(b)+1}),c+='<th class="cw">&#160;</th>');b<this.o.weekStart+7;)c+='<th class="dow',a.inArray(b,this.o.daysOfWeekDisabled)>-1&&(c+=" disabled"),c+='">'+q[this.o.language].daysMin[b++%7]+"</th>";c+="</tr>",this.picker.find(".datepicker-days thead").append(c)},fillMonths:function(){for(var a=this._utc_to_local(this.viewDate),b="",c=0;12>c;){var d=a&&a.getMonth()===c?" focused":"";b+='<span class="month'+d+'">'+q[this.o.language].monthsShort[c++]+"</span>"}this.picker.find(".datepicker-months td").html(b)},setRange:function(b){b&&b.length?this.range=a.map(b,function(a){return a.valueOf()}):delete this.range,this.fill()},getClassNames:function(b){var c=[],d=this.viewDate.getUTCFullYear(),e=this.viewDate.getUTCMonth(),f=new Date;return b.getUTCFullYear()<d||b.getUTCFullYear()===d&&b.getUTCMonth()<e?c.push("old"):(b.getUTCFullYear()>d||b.getUTCFullYear()===d&&b.getUTCMonth()>e)&&c.push("new"),this.focusDate&&b.valueOf()===this.focusDate.valueOf()&&c.push("focused"),this.o.todayHighlight&&b.getUTCFullYear()===f.getFullYear()&&b.getUTCMonth()===f.getMonth()&&b.getUTCDate()===f.getDate()&&c.push("today"),-1!==this.dates.contains(b)&&c.push("active"),(!this.dateWithinRange(b)||this.dateIsDisabled(b))&&c.push("disabled"),-1!==a.inArray(b.getUTCDay(),this.o.daysOfWeekHighlighted)&&c.push("highlighted"),this.range&&(b>this.range[0]&&b<this.range[this.range.length-1]&&c.push("range"),-1!==a.inArray(b.valueOf(),this.range)&&c.push("selected"),b.valueOf()===this.range[0]&&c.push("range-start"),b.valueOf()===this.range[this.range.length-1]&&c.push("range-end")),c},_fill_yearsView:function(c,d,e,f,g,h,i,j){var k,l,m,n,o,p,q,r,s,t,u;for(k="",l=this.picker.find(c),m=parseInt(g/e,10)*e,o=parseInt(h/f,10)*f,p=parseInt(i/f,10)*f,n=a.map(this.dates,function(a){return parseInt(a.getUTCFullYear()/f,10)*f}),l.find(".datepicker-switch").text(m+"-"+(m+9*f)),q=m-f,r=-1;11>r;r+=1)s=[d],t=null,-1===r?s.push("old"):10===r&&s.push("new"),-1!==a.inArray(q,n)&&s.push("active"),(o>q||q>p)&&s.push("disabled"),q===this.viewDate.getFullYear()&&s.push("focused"),j!==a.noop&&(u=j(new Date(q,0,1)),u===b?u={}:"boolean"==typeof u?u={enabled:u}:"string"==typeof u&&(u={classes:u}),u.enabled===!1&&s.push("disabled"),u.classes&&(s=s.concat(u.classes.split(/\s+/))),u.tooltip&&(t=u.tooltip)),k+='<span class="'+s.join(" ")+'"'+(t?' title="'+t+'"':"")+">"+q+"</span>",q+=f;l.find("td").html(k)},fill:function(){var d,e,f=new Date(this.viewDate),g=f.getUTCFullYear(),h=f.getUTCMonth(),i=this.o.startDate!==-(1/0)?this.o.startDate.getUTCFullYear():-(1/0),j=this.o.startDate!==-(1/0)?this.o.startDate.getUTCMonth():-(1/0),k=this.o.endDate!==1/0?this.o.endDate.getUTCFullYear():1/0,l=this.o.endDate!==1/0?this.o.endDate.getUTCMonth():1/0,m=q[this.o.language].today||q.en.today||"",n=q[this.o.language].clear||q.en.clear||"",o=q[this.o.language].titleFormat||q.en.titleFormat;if(!isNaN(g)&&!isNaN(h)){this.picker.find(".datepicker-days .datepicker-switch").text(r.formatDate(f,o,this.o.language)),this.picker.find("tfoot .today").text(m).toggle(this.o.todayBtn!==!1),this.picker.find("tfoot .clear").text(n).toggle(this.o.clearBtn!==!1),this.picker.find("thead .datepicker-title").text(this.o.title).toggle(""!==this.o.title),this.updateNavArrows(),this.fillMonths();var p=c(g,h-1,28),s=r.getDaysInMonth(p.getUTCFullYear(),p.getUTCMonth());p.setUTCDate(s),p.setUTCDate(s-(p.getUTCDay()-this.o.weekStart+7)%7);var t=new Date(p);p.getUTCFullYear()<100&&t.setUTCFullYear(p.getUTCFullYear()),t.setUTCDate(t.getUTCDate()+42),t=t.valueOf();for(var u,v=[];p.valueOf()<t;){if(p.getUTCDay()===this.o.weekStart&&(v.push("<tr>"),this.o.calendarWeeks)){var w=new Date(+p+(this.o.weekStart-p.getUTCDay()-7)%7*864e5),x=new Date(Number(w)+(11-w.getUTCDay())%7*864e5),y=new Date(Number(y=c(x.getUTCFullYear(),0,1))+(11-y.getUTCDay())%7*864e5),z=(x-y)/864e5/7+1;v.push('<td class="cw">'+z+"</td>")}u=this.getClassNames(p),u.push("day"),this.o.beforeShowDay!==a.noop&&(e=this.o.beforeShowDay(this._utc_to_local(p)),e===b?e={}:"boolean"==typeof e?e={enabled:e}:"string"==typeof e&&(e={classes:e}),e.enabled===!1&&u.push("disabled"),e.classes&&(u=u.concat(e.classes.split(/\s+/))),e.tooltip&&(d=e.tooltip)),u=a.unique(u),v.push('<td class="'+u.join(" ")+'"'+(d?' title="'+d+'"':"")+">"+p.getUTCDate()+"</td>"),d=null,p.getUTCDay()===this.o.weekEnd&&v.push("</tr>"),p.setUTCDate(p.getUTCDate()+1)}this.picker.find(".datepicker-days tbody").empty().append(v.join(""));var A=q[this.o.language].monthsTitle||q.en.monthsTitle||"Months",B=this.picker.find(".datepicker-months").find(".datepicker-switch").text(this.o.maxViewMode<2?A:g).end().find("span").removeClass("active");if(a.each(this.dates,function(a,b){b.getUTCFullYear()===g&&B.eq(b.getUTCMonth()).addClass("active")}),(i>g||g>k)&&B.addClass("disabled"),g===i&&B.slice(0,j).addClass("disabled"),g===k&&B.slice(l+1).addClass("disabled"),this.o.beforeShowMonth!==a.noop){var C=this;a.each(B,function(c,d){var e=new Date(g,c,1),f=C.o.beforeShowMonth(e);f===b?f={}:"boolean"==typeof f?f={enabled:f}:"string"==typeof f&&(f={classes:f}),f.enabled!==!1||a(d).hasClass("disabled")||a(d).addClass("disabled"),f.classes&&a(d).addClass(f.classes),f.tooltip&&a(d).prop("title",f.tooltip)})}this._fill_yearsView(".datepicker-years","year",10,1,g,i,k,this.o.beforeShowYear),this._fill_yearsView(".datepicker-decades","decade",100,10,g,i,k,this.o.beforeShowDecade),this._fill_yearsView(".datepicker-centuries","century",1e3,100,g,i,k,this.o.beforeShowCentury)}},updateNavArrows:function(){if(this._allow_update){var a=new Date(this.viewDate),b=a.getUTCFullYear(),c=a.getUTCMonth();switch(this.viewMode){case 0:this.o.startDate!==-(1/0)&&b<=this.o.startDate.getUTCFullYear()&&c<=this.o.startDate.getUTCMonth()?this.picker.find(".prev").css({visibility:"hidden"}):this.picker.find(".prev").css({visibility:"visible"}),this.o.endDate!==1/0&&b>=this.o.endDate.getUTCFullYear()&&c>=this.o.endDate.getUTCMonth()?this.picker.find(".next").css({visibility:"hidden"}):this.picker.find(".next").css({visibility:"visible"});break;case 1:case 2:case 3:case 4:this.o.startDate!==-(1/0)&&b<=this.o.startDate.getUTCFullYear()||this.o.maxViewMode<2?this.picker.find(".prev").css({visibility:"hidden"}):this.picker.find(".prev").css({visibility:"visible"}),this.o.endDate!==1/0&&b>=this.o.endDate.getUTCFullYear()||this.o.maxViewMode<2?this.picker.find(".next").css({visibility:"hidden"}):this.picker.find(".next").css({visibility:"visible"})}}},click:function(b){b.preventDefault(),b.stopPropagation();var e,f,g,h,i,j,k;e=a(b.target),e.hasClass("datepicker-switch")&&this.showMode(1);var l=e.closest(".prev, .next");l.length>0&&(f=r.modes[this.viewMode].navStep*(l.hasClass("prev")?-1:1),0===this.viewMode?(this.viewDate=this.moveMonth(this.viewDate,f),this._trigger("changeMonth",this.viewDate)):(this.viewDate=this.moveYear(this.viewDate,f),1===this.viewMode&&this._trigger("changeYear",this.viewDate)),this.fill()),e.hasClass("today")&&(this.showMode(-2),this._setDate(d(),"linked"===this.o.todayBtn?null:"view")),e.hasClass("clear")&&this.clearDates(),e.hasClass("disabled")||(e.hasClass("day")&&(g=parseInt(e.text(),10)||1,h=this.viewDate.getUTCFullYear(),i=this.viewDate.getUTCMonth(),e.hasClass("old")&&(0===i?(i=11,h-=1,j=!0,k=!0):(i-=1,j=!0)),e.hasClass("new")&&(11===i?(i=0,h+=1,j=!0,k=!0):(i+=1,j=!0)),this._setDate(c(h,i,g)),k&&this._trigger("changeYear",this.viewDate),j&&this._trigger("changeMonth",this.viewDate)),e.hasClass("month")&&(this.viewDate.setUTCDate(1),g=1,i=e.parent().find("span").index(e),h=this.viewDate.getUTCFullYear(),this.viewDate.setUTCMonth(i),this._trigger("changeMonth",this.viewDate),1===this.o.minViewMode?(this._setDate(c(h,i,g)),this.showMode()):this.showMode(-1),this.fill()),(e.hasClass("year")||e.hasClass("decade")||e.hasClass("century"))&&(this.viewDate.setUTCDate(1),g=1,i=0,h=parseInt(e.text(),10)||0,this.viewDate.setUTCFullYear(h),e.hasClass("year")&&(this._trigger("changeYear",this.viewDate),2===this.o.minViewMode&&this._setDate(c(h,i,g))),e.hasClass("decade")&&(this._trigger("changeDecade",this.viewDate),3===this.o.minViewMode&&this._setDate(c(h,i,g))),e.hasClass("century")&&(this._trigger("changeCentury",this.viewDate),4===this.o.minViewMode&&this._setDate(c(h,i,g))),this.showMode(-1),this.fill())),this.picker.is(":visible")&&this._focused_from&&a(this._focused_from).focus(),delete this._focused_from},_toggle_multidate:function(a){var b=this.dates.contains(a);if(a||this.dates.clear(),-1!==b?(this.o.multidate===!0||this.o.multidate>1||this.o.toggleActive)&&this.dates.remove(b):this.o.multidate===!1?(this.dates.clear(),this.dates.push(a)):this.dates.push(a),"number"==typeof this.o.multidate)for(;this.dates.length>this.o.multidate;)this.dates.remove(0)},_setDate:function(a,b){b&&"date"!==b||this._toggle_multidate(a&&new Date(a)),b&&"view"!==b||(this.viewDate=a&&new Date(a)),this.fill(),this.setValue(),b&&"view"===b||this._trigger("changeDate");var c;this.isInput?c=this.element:this.component&&(c=this.element.find("input")),c&&c.change(),!this.o.autoclose||b&&"date"!==b||this.hide()},moveDay:function(a,b){var c=new Date(a);return c.setUTCDate(a.getUTCDate()+b),c},moveWeek:function(a,b){return this.moveDay(a,7*b)},moveMonth:function(a,b){if(!g(a))return this.o.defaultViewDate;if(!b)return a;var c,d,e=new Date(a.valueOf()),f=e.getUTCDate(),h=e.getUTCMonth(),i=Math.abs(b);if(b=b>0?1:-1,1===i)d=-1===b?function(){return e.getUTCMonth()===h}:function(){return e.getUTCMonth()!==c},c=h+b,e.setUTCMonth(c),(0>c||c>11)&&(c=(c+12)%12);else{for(var j=0;i>j;j++)e=this.moveMonth(e,b);c=e.getUTCMonth(),e.setUTCDate(f),d=function(){return c!==e.getUTCMonth()}}for(;d();)e.setUTCDate(--f),e.setUTCMonth(c);return e},moveYear:function(a,b){return this.moveMonth(a,12*b)},moveAvailableDate:function(a,b,c){do{if(a=this[c](a,b),!this.dateWithinRange(a))return!1;c="moveDay"}while(this.dateIsDisabled(a));return a},weekOfDateIsDisabled:function(b){return-1!==a.inArray(b.getUTCDay(),this.o.daysOfWeekDisabled)},dateIsDisabled:function(b){return this.weekOfDateIsDisabled(b)||a.grep(this.o.datesDisabled,function(a){return e(b,a)}).length>0},dateWithinRange:function(a){return a>=this.o.startDate&&a<=this.o.endDate},keydown:function(a){if(!this.picker.is(":visible"))return void((40===a.keyCode||27===a.keyCode)&&(this.show(),a.stopPropagation()));var b,c,d=!1,e=this.focusDate||this.viewDate;switch(a.keyCode){case 27:this.focusDate?(this.focusDate=null,this.viewDate=this.dates.get(-1)||this.viewDate,this.fill()):this.hide(),a.preventDefault(),a.stopPropagation();break;case 37:case 38:case 39:case 40:if(!this.o.keyboardNavigation||7===this.o.daysOfWeekDisabled.length)break;b=37===a.keyCode||38===a.keyCode?-1:1,0===this.viewMode?a.ctrlKey?(c=this.moveAvailableDate(e,b,"moveYear"),c&&this._trigger("changeYear",this.viewDate)):a.shiftKey?(c=this.moveAvailableDate(e,b,"moveMonth"),c&&this._trigger("changeMonth",this.viewDate)):37===a.keyCode||39===a.keyCode?c=this.moveAvailableDate(e,b,"moveDay"):this.weekOfDateIsDisabled(e)||(c=this.moveAvailableDate(e,b,"moveWeek")):1===this.viewMode?((38===a.keyCode||40===a.keyCode)&&(b=4*b),c=this.moveAvailableDate(e,b,"moveMonth")):2===this.viewMode&&((38===a.keyCode||40===a.keyCode)&&(b=4*b),c=this.moveAvailableDate(e,b,"moveYear")),c&&(this.focusDate=this.viewDate=c,this.setValue(),this.fill(),a.preventDefault());break;case 13:if(!this.o.forceParse)break;e=this.focusDate||this.dates.get(-1)||this.viewDate,this.o.keyboardNavigation&&(this._toggle_multidate(e),d=!0),this.focusDate=null,this.viewDate=this.dates.get(-1)||this.viewDate,this.setValue(),this.fill(),this.picker.is(":visible")&&(a.preventDefault(),a.stopPropagation(),this.o.autoclose&&this.hide());break;case 9:this.focusDate=null,this.viewDate=this.dates.get(-1)||this.viewDate,this.fill(),this.hide()}if(d){this.dates.length?this._trigger("changeDate"):this._trigger("clearDate");var f;this.isInput?f=this.element:this.component&&(f=this.element.find("input")),f&&f.change()}},showMode:function(a){a&&(this.viewMode=Math.max(this.o.minViewMode,Math.min(this.o.maxViewMode,this.viewMode+a))),this.picker.children("div").hide().filter(".datepicker-"+r.modes[this.viewMode].clsName).show(),this.updateNavArrows()}};var l=function(b,c){a(b).data("datepicker",this),this.element=a(b),this.inputs=a.map(c.inputs,function(a){return a.jquery?a[0]:a}),delete c.inputs,n.call(a(this.inputs),c).on("changeDate",a.proxy(this.dateUpdated,this)),this.pickers=a.map(this.inputs,function(b){return a(b).data("datepicker")}),this.updateDates()};l.prototype={updateDates:function(){this.dates=a.map(this.pickers,function(a){return a.getUTCDate()}),this.updateRanges()},updateRanges:function(){var b=a.map(this.dates,function(a){return a.valueOf()});a.each(this.pickers,function(a,c){c.setRange(b)})},dateUpdated:function(b){if(!this.updating){this.updating=!0;var c=a(b.target).data("datepicker");if("undefined"!=typeof c){var d=c.getUTCDate(),e=a.inArray(b.target,this.inputs),f=e-1,g=e+1,h=this.inputs.length;if(-1!==e){if(a.each(this.pickers,function(a,b){b.getUTCDate()||b.setUTCDate(d)}),d<this.dates[f])for(;f>=0&&d<this.dates[f];)this.pickers[f--].setUTCDate(d);else if(d>this.dates[g])for(;h>g&&d>this.dates[g];)this.pickers[g++].setUTCDate(d);this.updateDates(),delete this.updating}}}},remove:function(){a.map(this.pickers,function(a){a.remove()}),delete this.element.data().datepicker}};var m=a.fn.datepicker,n=function(c){var d=Array.apply(null,arguments);d.shift();var e;if(this.each(function(){var b=a(this),f=b.data("datepicker"),g="object"==typeof c&&c;if(!f){var j=h(this,"date"),m=a.extend({},o,j,g),n=i(m.language),p=a.extend({},o,n,j,g);b.hasClass("input-daterange")||p.inputs?(a.extend(p,{inputs:p.inputs||b.find("input").toArray()}),f=new l(this,p)):f=new k(this,p),b.data("datepicker",f)}"string"==typeof c&&"function"==typeof f[c]&&(e=f[c].apply(f,d))}),e===b||e instanceof k||e instanceof l)return this;if(this.length>1)throw new Error("Using only allowed for the collection of a single element ("+c+" function)");return e};a.fn.datepicker=n;var o=a.fn.datepicker.defaults={assumeNearbyYear:!1,autoclose:!1,beforeShowDay:a.noop,beforeShowMonth:a.noop,beforeShowYear:a.noop,beforeShowDecade:a.noop,beforeShowCentury:a.noop,calendarWeeks:!1,clearBtn:!1,toggleActive:!1,daysOfWeekDisabled:[],daysOfWeekHighlighted:[],datesDisabled:[],endDate:1/0,forceParse:!0,format:"mm/dd/yyyy",keyboardNavigation:!0,language:"en",minViewMode:0,maxViewMode:4,multidate:!1,multidateSeparator:",",orientation:"auto",rtl:!1,startDate:-(1/0),startView:0,todayBtn:!1,todayHighlight:!1,weekStart:0,disableTouchKeyboard:!1,enableOnReadonly:!0,showOnFocus:!0,zIndexOffset:10,container:"body",immediateUpdates:!1,title:"",templates:{leftArrow:"&laquo;",rightArrow:"&raquo;"}},p=a.fn.datepicker.locale_opts=["format","rtl","weekStart"];a.fn.datepicker.Constructor=k;var q=a.fn.datepicker.dates={en:{days:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],daysShort:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],daysMin:["Su","Mo","Tu","We","Th","Fr","Sa"],months:["January","February","March","April","May","June","July","August","September","October","November","December"],monthsShort:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],today:"Today",clear:"Clear",titleFormat:"MM yyyy"}},r={modes:[{clsName:"days",navFnc:"Month",navStep:1},{clsName:"months",navFnc:"FullYear",navStep:1},{clsName:"years",navFnc:"FullYear",navStep:10},{clsName:"decades",navFnc:"FullDecade",navStep:100},{clsName:"centuries",navFnc:"FullCentury",navStep:1e3}],isLeapYear:function(a){return a%4===0&&a%100!==0||a%400===0},getDaysInMonth:function(a,b){return[31,r.isLeapYear(a)?29:28,31,30,31,30,31,31,30,31,30,31][b]},validParts:/dd?|DD?|mm?|MM?|yy(?:yy)?/g,nonpunctuation:/[^ -\/:-@\u5e74\u6708\u65e5\[-`{-~\t\n\r]+/g,parseFormat:function(a){if("function"==typeof a.toValue&&"function"==typeof a.toDisplay)return a;var b=a.replace(this.validParts,"\x00").split("\x00"),c=a.match(this.validParts);if(!b||!b.length||!c||0===c.length)throw new Error("Invalid date format.");return{separators:b,parts:c}},parseDate:function(e,f,g,h){function i(a,b){return b===!0&&(b=10),100>a&&(a+=2e3,a>(new Date).getFullYear()+b&&(a-=100)),a}function j(){var a=this.slice(0,s[n].length),b=s[n].slice(0,a.length);return a.toLowerCase()===b.toLowerCase()}if(!e)return b;if(e instanceof Date)return e;if("string"==typeof f&&(f=r.parseFormat(f)),f.toValue)return f.toValue(e,f,g);var l,m,n,o,p=/([\-+]\d+)([dmwy])/,s=e.match(/([\-+]\d+)([dmwy])/g),t={d:"moveDay",m:"moveMonth",w:"moveWeek",y:"moveYear"},u={yesterday:"-1d",today:"+0d",tomorrow:"+1d"};if(/^[\-+]\d+[dmwy]([\s,]+[\-+]\d+[dmwy])*$/.test(e)){for(e=new Date,n=0;n<s.length;n++)l=p.exec(s[n]),m=parseInt(l[1]),o=t[l[2]],e=k.prototype[o](e,m);return c(e.getUTCFullYear(),e.getUTCMonth(),e.getUTCDate())}if("undefined"!=typeof u[e]&&(e=u[e],s=e.match(/([\-+]\d+)([dmwy])/g),/^[\-+]\d+[dmwy]([\s,]+[\-+]\d+[dmwy])*$/.test(e))){for(e=new Date,n=0;n<s.length;n++)l=p.exec(s[n]),m=parseInt(l[1]),o=t[l[2]],e=k.prototype[o](e,m);return c(e.getUTCFullYear(),e.getUTCMonth(),e.getUTCDate())}s=e&&e.match(this.nonpunctuation)||[],e=new Date;var v,w,x={},y=["yyyy","yy","M","MM","m","mm","d","dd"],z={yyyy:function(a,b){return a.setUTCFullYear(h?i(b,h):b)},yy:function(a,b){return a.setUTCFullYear(h?i(b,h):b)},m:function(a,b){if(isNaN(a))return a;for(b-=1;0>b;)b+=12;for(b%=12,a.setUTCMonth(b);a.getUTCMonth()!==b;)a.setUTCDate(a.getUTCDate()-1);return a},d:function(a,b){return a.setUTCDate(b)}};z.M=z.MM=z.mm=z.m,z.dd=z.d,e=d();var A=f.parts.slice();if(s.length!==A.length&&(A=a(A).filter(function(b,c){return-1!==a.inArray(c,y)}).toArray()),s.length===A.length){var B;for(n=0,B=A.length;B>n;n++){if(v=parseInt(s[n],10),l=A[n],isNaN(v))switch(l){case"MM":w=a(q[g].months).filter(j),v=a.inArray(w[0],q[g].months)+1;break;case"M":w=a(q[g].monthsShort).filter(j),v=a.inArray(w[0],q[g].monthsShort)+1;
}x[l]=v}var C,D;for(n=0;n<y.length;n++)D=y[n],D in x&&!isNaN(x[D])&&(C=new Date(e),z[D](C,x[D]),isNaN(C)||(e=C))}return e},formatDate:function(b,c,d){if(!b)return"";if("string"==typeof c&&(c=r.parseFormat(c)),c.toDisplay)return c.toDisplay(b,c,d);var e={d:b.getUTCDate(),D:q[d].daysShort[b.getUTCDay()],DD:q[d].days[b.getUTCDay()],m:b.getUTCMonth()+1,M:q[d].monthsShort[b.getUTCMonth()],MM:q[d].months[b.getUTCMonth()],yy:b.getUTCFullYear().toString().substring(2),yyyy:b.getUTCFullYear()};e.dd=(e.d<10?"0":"")+e.d,e.mm=(e.m<10?"0":"")+e.m,b=[];for(var f=a.extend([],c.separators),g=0,h=c.parts.length;h>=g;g++)f.length&&b.push(f.shift()),b.push(e[c.parts[g]]);return b.join("")},headTemplate:'<thead><tr><th colspan="7" class="datepicker-title"></th></tr><tr><th class="prev">&laquo;</th><th colspan="5" class="datepicker-switch"></th><th class="next">&raquo;</th></tr></thead>',contTemplate:'<tbody><tr><td colspan="7"></td></tr></tbody>',footTemplate:'<tfoot><tr><th colspan="7" class="today"></th></tr><tr><th colspan="7" class="clear"></th></tr></tfoot>'};r.template='<div class="datepicker"><div class="datepicker-days"><table class=" table-condensed">'+r.headTemplate+"<tbody></tbody>"+r.footTemplate+'</table></div><div class="datepicker-months"><table class="table-condensed">'+r.headTemplate+r.contTemplate+r.footTemplate+'</table></div><div class="datepicker-years"><table class="table-condensed">'+r.headTemplate+r.contTemplate+r.footTemplate+'</table></div><div class="datepicker-decades"><table class="table-condensed">'+r.headTemplate+r.contTemplate+r.footTemplate+'</table></div><div class="datepicker-centuries"><table class="table-condensed">'+r.headTemplate+r.contTemplate+r.footTemplate+"</table></div></div>",a.fn.datepicker.DPGlobal=r,a.fn.datepicker.noConflict=function(){return a.fn.datepicker=m,this},a.fn.datepicker.version="1.6.0",a(document).on("focus.datepicker.data-api click.datepicker.data-api",'[data-provide="datepicker"]',function(b){var c=a(this);c.data("datepicker")||(b.preventDefault(),n.call(c,"show"))}),a(function(){n.call(a('[data-provide="datepicker-inline"]'))})});
define('bootstrap-datepicker-languages-AMD',['require','exports','module'],function (require, exports, module) {
    "use strict";

    if (!$.fn.datepicker) return;

    $.fn.datepicker.dates.cs = {
        days: ["Neděle", "Pondělí", "Úterý", "Středa", "Čtvrtek", "Pátek", "Sobota"],
        daysShort: ["Ned", "Pon", "Úte", "Stř", "Čtv", "Pát", "Sob"],
        daysMin: ["Ne", "Po", "Út", "St", "Čt", "Pá", "So"],
        months: ["Leden", "Únor", "Březen", "Duben", "Květen", "Červen", "Červenec", "Srpen", "Září", "Říjen", "Listopad", "Prosinec"],
        monthsShort: ["Led", "Úno", "Bře", "Dub", "Kvě", "Čer", "Čnc", "Srp", "Zář", "Říj", "Lis", "Pro"],
        today: "Dnes",
        clear: "Vymazat",
        weekStart: 1,
        format: "dd.m.yyyy"
    };

    $.fn.datepicker.dates.de = {
        days: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"],
        daysShort: ["Son", "Mon", "Die", "Mit", "Don", "Fre", "Sam"],
        daysMin: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
        months: ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"],
        monthsShort: ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
        today: "Heute",
        monthsTitle: "Monate",
        clear: "Löschen",
        weekStart: 1,
        format: "dd.mm.yyyy"
    };

    $.fn.datepicker.dates.es = {
        days: ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"],
        daysShort: ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"],
        daysMin: ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sa"],
        months: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
        monthsShort: ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
        today: "Hoy",
        monthsTitle: "Meses",
        clear: "Borrar",
        weekStart: 1,
        format: "dd/mm/yyyy"
    };

    $.fn.datepicker.dates.fr = {
        days: ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"],
        daysShort: ["dim.", "lun.", "mar.", "mer.", "jeu.", "ven.", "sam."],
        daysMin: ["d", "l", "ma", "me", "j", "v", "s"],
        months: ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"],
        monthsShort: ["janv.", "févr.", "mars", "avril", "mai", "juin", "juil.", "août", "sept.", "oct.", "nov.", "déc."],
        today: "Aujourd'hui",
        monthsTitle: "Mois",
        clear: "Effacer",
        weekStart: 1,
        format: "dd/mm/yyyy"
    };

    $.fn.datepicker.dates.it = {
        days: ["Domenica", "Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato"],
        daysShort: ["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"],
        daysMin: ["Do", "Lu", "Ma", "Me", "Gi", "Ve", "Sa"],
        months: ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"],
        monthsShort: ["Gen", "Feb", "Mar", "Apr", "Mag", "Giu", "Lug", "Ago", "Set", "Ott", "Nov", "Dic"],
        today: "Oggi",
        monthsTitle: "Mesi",
        clear: "Cancella",
        weekStart: 1,
        format: "dd/mm/yyyy"
    };

    $.fn.datepicker.dates.ro = {
        days: ["Duminică", "Luni", "Marţi", "Miercuri", "Joi", "Vineri", "Sâmbătă"],
        daysShort: ["Dum", "Lun", "Mar", "Mie", "Joi", "Vin", "Sâm"],
        daysMin: ["Du", "Lu", "Ma", "Mi", "Jo", "Vi", "Sâ"],
        months: ["Ianuarie", "Februarie", "Martie", "Aprilie", "Mai", "Iunie", "Iulie", "August", "Septembrie", "Octombrie", "Noiembrie", "Decembrie"],
        monthsShort: ["Ian", "Feb", "Mar", "Apr", "Mai", "Iun", "Iul", "Aug", "Sep", "Oct", "Nov", "Dec"],
        today: "Astăzi",
        clear: "Șterge",
        weekStart: 1
    };

    $.fn.datepicker.dates.pl = {
        days: ["niedziela", "poniedziałek", "wtorek", "środa", "czwartek", "piątek", "sobota"],
        daysShort: ["niedz.", "pon.", "wt.", "śr.", "czw.", "piąt.", "sob."],
        daysMin: ["ndz.", "pn.", "wt.", "śr.", "czw.", "pt.", "sob."],
        months: ["styczeń", "luty", "marzec", "kwiecień", "maj", "czerwiec", "lipiec", "sierpień", "wrzesień", "październik", "listopad", "grudzień"],
        monthsShort: ["sty.", "lut.", "mar.", "kwi.", "maj", "cze.", "lip.", "sie.", "wrz.", "paź.", "lis.", "gru."],
        today: "dzisiaj",
        weekStart: 1,
        clear: "wyczyść",
        format: "dd.mm.yyyy"
    };

});
/*----------------------------------------
 * objectFitPolyfill 2.1.1
 *
 * Made by Constance Chen
 * Released under the MIT license
 *
 * https://github.com/constancecchen/object-fit-polyfill
 *--------------------------------------*/

(function(){
  "use strict";

  // if the page is being rendered on the server, don't continue
  if (typeof window === "undefined") {
      return;
  }

  // Workaround for Edge 16+, which only implemented object-fit for <img> tags
  // TODO: Keep an eye on Edge to determine which version has full final support
  var edgeVersion = window.navigator.userAgent.match(/Edge\/(\d{2})\./);
  var edgePartialSupport = (edgeVersion) ? (parseInt(edgeVersion[1], 10) >= 16) : false;

  // If the browser does support object-fit, we don't need to continue
  if ("objectFit" in document.documentElement.style !== false && !edgePartialSupport) {
    window.objectFitPolyfill = function() { return false };
    return;
  }

  /**
   * Check the container's parent element to make sure it will
   * correctly handle and clip absolutely positioned children
   *
   * @param {node} $container - parent element
   */
  var checkParentContainer = function($container) {
    var styles = window.getComputedStyle($container, null);
    var position = styles.getPropertyValue("position");
    var overflow = styles.getPropertyValue("overflow");
    var display = styles.getPropertyValue("display");

    if (!position || position === "static") {
      $container.style.position = "relative";
    }
    if (overflow !== "hidden") {
      $container.style.overflow = "hidden";
    }
    // Guesstimating that people want the parent to act like full width/height wrapper here.
    // Mostly attempts to target <picture> elements, which default to inline.
    if (!display || display === "inline") {
      $container.style.display = "block";
    }
    if ($container.clientHeight === 0) {
      $container.style.height = "100%";
    }

    // Add a CSS class hook, in case people need to override styles for any reason.
    if ($container.className.indexOf("object-fit-polyfill") === -1) {
      $container.className = $container.className + " object-fit-polyfill";
    }
  };

  /**
   * Check for pre-set max-width/height, min-width/height,
   * positioning, or margins, which can mess up image calculations
   *
   * @param {node} $media - img/video element
   */
  var checkMediaProperties = function($media) {
    var styles = window.getComputedStyle($media, null);
    var constraints = {
      "max-width":  "none",
      "max-height": "none",
      "min-width":  "0px",
      "min-height": "0px",
      "top": "auto",
      "right": "auto",
      "bottom": "auto",
      "left": "auto",
      "margin-top": "0px",
      "margin-right": "0px",
      "margin-bottom": "0px",
      "margin-left": "0px",
    };

    for (var property in constraints) {
      var constraint = styles.getPropertyValue(property);

      if (constraint !== constraints[property]) {
        $media.style[property] = constraints[property];
      }
    }
  };

  /**
   * Calculate & set object-position
   *
   * @param {string} axis - either "x" or "y"
   * @param {node} $media - img or video element
   * @param {string} objectPosition - e.g. "50% 50%", "top bottom"
   */
  var setPosition = function(axis, $media, objectPosition) {
    var position, other, start, end, side;
    objectPosition = objectPosition.split(" ");

    if (objectPosition.length < 2) {
      objectPosition[1] = objectPosition[0];
    }

    if (axis === "x") {
      position = objectPosition[0];
      other = objectPosition[1];
      start = "left";
      end = "right";
      side = $media.clientWidth;
    }
    else if (axis === "y") {
      position = objectPosition[1];
      other = objectPosition[0];
      start = "top";
      end = "bottom";
      side = $media.clientHeight;
    }
    else {
      return; // Neither x or y axis specified
    }

    if (position === start || other === start) {
      $media.style[start] = "0";
      return;
    }

    if (position === end || other === end) {
      $media.style[end] = "0";
      return;
    }

    if (position === "center" || position === "50%") {
      $media.style[start] = "50%";
      $media.style["margin-" + start] = (side / -2) + "px";
      return;
    }

    // Percentage values (e.g., 30% 10%)
    if (position.indexOf("%") >= 0) {
      position = parseInt(position);

      if (position < 50) {
        $media.style[start] = position + "%";
        $media.style["margin-" + start] = side * (position / -100) + "px";
      }
      else {
        position = 100 - position;
        $media.style[end] = position + "%";
        $media.style["margin-" + end] = side * (position / -100) + "px";
      }

      return;
    }
    // Length-based values (e.g. 10px / 10em)
    else {
      $media.style[start] = position;
    }

  };

  /**
   * Calculate & set object-fit
   *
   * @param {node} $media - img/video/picture element
   */
  var objectFit = function($media) {
    // Fallbacks, IE 10- data
    var fit = ($media.dataset) ? $media.dataset.objectFit : $media.getAttribute("data-object-fit");
    var position = ($media.dataset) ? $media.dataset.objectPosition : $media.getAttribute("data-object-position");
    fit = fit || "cover";
    position = position || "50% 50%";

    // If necessary, make the parent container work with absolutely positioned elements
    var $container = $media.parentNode;
    checkParentContainer($container);

    // Check for any pre-set CSS which could mess up image calculations
    checkMediaProperties($media);

    // Mathematically figure out which side needs covering, and add CSS positioning & centering
    $media.style.position = "absolute";
    $media.style.height = "100%";
    $media.style.width = "auto";

    if (fit === "scale-down") {
      $media.style.height = "auto";

      if (
        $media.clientWidth < $container.clientWidth &&
        $media.clientHeight < $container.clientHeight
      ) {
        setPosition("x", $media, position);
        setPosition("y", $media, position);
      }
      else {
        fit = "contain";
        $media.style.height = "100%";
      }
    }

    if (fit === "none") {
      $media.style.width = "auto";
      $media.style.height = "auto";
      setPosition("x", $media, position);
      setPosition("y", $media, position);
    }
    else if (
      fit === "cover"   && $media.clientWidth > $container.clientWidth ||
      fit === "contain" && $media.clientWidth < $container.clientWidth
    ) {
      $media.style.top = "0";
      $media.style.marginTop = "0";
      setPosition("x", $media, position);
    }
    else if (fit !== "scale-down") {
      $media.style.width = "100%";
      $media.style.height = "auto";
      $media.style.left = "0";
      $media.style.marginLeft = "0";
      setPosition("y", $media, position);
    }
  };

  /**
   * Initialize plugin
   *
   * @param {node} media - Optional specific DOM node(s) to be polyfilled
   */
  var objectFitPolyfill = function(media) {
    if (typeof media === "undefined") {
      // If left blank, all media on the page will be polyfilled.
      media = document.querySelectorAll("[data-object-fit]");
    } else if (media && media.nodeName) {
      // If it's a single node, wrap it in an array so it works.
      media = [media];
    } else if (typeof media === "object" && media.length && media[0].nodeName) {
      // If it's an array of DOM nodes (e.g. a jQuery selector), it's fine as-is.
      media = media;
    } else {
      // Otherwise, if it's invalid or an incorrect type, return false to let people know.
      return false;
    }

    for (var i = 0; i < media.length; i++) {
      if (!media[i].nodeName) { continue; }

      var mediaType = media[i].nodeName.toLowerCase();

      if (mediaType === "img" && !edgePartialSupport) {
        if (media[i].complete) {
          objectFit(media[i]);
        }
        else {
          media[i].addEventListener("load", function() {
            objectFit(this);
          });
        }
      }
      else if (mediaType === "video") {
        if (media[i].readyState > 0) {
          objectFit(media[i]);
        }
        else {
          media[i].addEventListener("loadedmetadata", function() {
            objectFit(this);
          });
        }
      }
    }

    return true;
  };

  document.addEventListener("DOMContentLoaded", function() {
    objectFitPolyfill();
  });
  window.addEventListener("resize", function() {
    objectFitPolyfill();
  });

  window.objectFitPolyfill = objectFitPolyfill;

})();

define("object-fit-polyfill", function(){});

/**
 * @version 1.0.2
 *
 * Provide a copy to clipboard function.
 */
(function (root, factory) {
  // Set up Constructor appropriately for the environment.
  if (typeof define === 'function' && define.amd) {
    // Start with AMD.
    define(
      'libs/copyToClipboard',['exports'],
      function (exports) {
        return factory(root, exports);
      }
    );
  } else if (typeof exports !== 'undefined') {
    // Next for Node.js or CommonJS.
    factory(root, exports);
  } else {
    // Finally, as a browser global.
    root.copyToClipboard = factory(root, {});
  }
}(this, function (root, exports) {
  'use strict';

  function fallbackCopyToClipboard(text) {
    var result = false;
    var textArea = document.createElement("textarea");
    textArea.value = text;

    // Avoid scrolling to bottom
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      var successful = document.execCommand('copy');
      var msg = successful ? 'successful' : 'unsuccessful';
      result = true;
      console.log('Fallback: Copying text command was ' + msg);
    } catch (err) {
      console.error('Fallback: Oops, unable to copy', err);
    }

    document.body.removeChild(textArea);
    return result;
  }

  function copyToClipboard(text) {
    var result = false;

    if (!navigator.clipboard) {
      return fallbackCopyToClipboard(text);
    } else {
        result = true;
    }

    navigator.clipboard.writeText(text).then(function () {
      console.log('Async: Copying to clipboard was successful!');
    }, function (err) {
      console.error('Async: Could not copy text: ', err);
    });

    return result;
  }

  return copyToClipboard;
}));

/*! store2 - v2.5.1 - 2017-03-28
* Copyright (c) 2017 Nathan Bubna; Licensed ,  */
(function (root, factory) {
    // Set up Constructor appropriately for the environment.
    if (typeof define === 'function' && define.amd) {
        // Start with AMD.
        define(
            'store2',['exports'],
            function (exports) {
                return factory(root, exports);
            }
        );
    } else if (typeof exports !== 'undefined') {
        // Next for Node.js or CommonJS.
        factory(root, exports);
    } else {
        // Finally, as a browser global.
        root.store = factory(root, {});
    }
}(this, function (root, exports) {
    var _ = {
        version: "2.5.1",
        areas: {},
        apis: {},

        // utilities
        inherit: function(api, o) {
            for (var p in api) {
                if (!o.hasOwnProperty(p)) {
                    o[p] = api[p];
                }
            }
            return o;
        },
        stringify: function(d) {
            return d === undefined || typeof d === "function" ? d+'' : JSON.stringify(d);
        },
        parse: function(s) {
            // if it doesn't parse, return as is
            try{ return JSON.parse(s); }catch(e){ return s; }
        },

        // extension hooks
        fn: function(name, fn) {
            _.storeAPI[name] = fn;
            for (var api in _.apis) {
                _.apis[api][name] = fn;
            }
        },
        get: function(area, key){ return area.getItem(key); },
        set: function(area, key, string){ area.setItem(key, string); },
        remove: function(area, key){ area.removeItem(key); },
        key: function(area, i){ return area.key(i); },
        length: function(area){ return area.length; },
        clear: function(area){ area.clear(); },

        // core functions
        Store: function(id, area, namespace) {
            var store = _.inherit(_.storeAPI, function(key, data, overwrite) {
                if (arguments.length === 0){ return store.getAll(); }
                if (typeof data === "function"){ return store.transact(key, data, overwrite); }// fn=data, alt=overwrite
                if (data !== undefined){ return store.set(key, data, overwrite); }
                if (typeof key === "string" || typeof key === "number"){ return store.get(key); }
                if (!key){ return store.clear(); }
                return store.setAll(key, data);// overwrite=data, data=key
            });
            store._id = id;
            try {
                var testKey = '_safariPrivate_';
                area.setItem(testKey, 'sucks');
                store._area = area;
                area.removeItem(testKey);
            } catch (e) {}
            if (!store._area) {
                store._area = _.inherit(_.storageAPI, { items: {}, name: 'fake' });
            }
            store._ns = namespace || '';
            if (!_.areas[id]) {
                _.areas[id] = store._area;
            }
            if (!_.apis[store._ns+store._id]) {
                _.apis[store._ns+store._id] = store;
            }
            return store;
        },
        storeAPI: {
            // admin functions
            area: function(id, area) {
                var store = this[id];
                if (!store || !store.area) {
                    store = _.Store(id, area, this._ns);//new area-specific api in this namespace
                    if (!this[id]){ this[id] = store; }
                }
                return store;
            },
            namespace: function(namespace, noSession) {
                if (!namespace){
                    return this._ns ? this._ns.substring(0,this._ns.length-1) : '';
                }
                var ns = namespace, store = this[ns];
                if (!store || !store.namespace) {
                    store = _.Store(this._id, this._area, this._ns+ns+'.');//new namespaced api
                    if (!this[ns]){ this[ns] = store; }
                    if (!noSession){ store.area('session', _.areas.session); }
                }
                return store;
            },
            isFake: function(){ return this._area.name === 'fake'; },
            toString: function() {
                return 'store'+(this._ns?'.'+this.namespace():'')+'['+this._id+']';
            },

            // storage functions
            has: function(key) {
                if (this._area.has) {
                    return this._area.has(this._in(key));//extension hook
                }
                return !!(this._in(key) in this._area);
            },
            size: function(){ return this.keys().length; },
            each: function(fn, and) {
                for (var i=0, m=_.length(this._area); i<m; i++) {
                    var key = this._out(_.key(this._area, i));
                    if (key !== undefined) {
                        if (fn.call(this, key, and || this.get(key)) === false) {
                            break;
                        }
                    }
                    if (m > _.length(this._area)) { m--; i--; }// in case of removeItem
                }
                return and || this;
            },
            keys: function() {
                return this.each(function(k, list){ list.push(k); }, []);
            },
            get: function(key, alt) {
                var s = _.get(this._area, this._in(key));
                return s !== null ? _.parse(s) : alt || s;// support alt for easy default mgmt
            },
            getAll: function() {
                return this.each(function(k, all){ all[k] = this.get(k); }, {});
            },
            transact: function(key, fn, alt) {
                var val = this.get(key, alt),
                    ret = fn(val);
                this.set(key, ret === undefined ? val : ret);
                return this;
            },
            set: function(key, data, overwrite) {
                var d = this.get(key);
                if (d != null && overwrite === false) {
                    return data;
                }
                return _.set(this._area, this._in(key), _.stringify(data), overwrite) || d;
            },
            setAll: function(data, overwrite) {
                var changed, val;
                for (var key in data) {
                    val = data[key];
                    if (this.set(key, val, overwrite) !== val) {
                        changed = true;
                    }
                }
                return changed;
            },
            remove: function(key) {
                var d = this.get(key);
                _.remove(this._area, this._in(key));
                return d;
            },
            clear: function() {
                if (!this._ns) {
                    _.clear(this._area);
                } else {
                    this.each(function(k){ _.remove(this._area, this._in(k)); }, 1);
                }
                return this;
            },
            clearAll: function() {
                var area = this._area;
                for (var id in _.areas) {
                    if (_.areas.hasOwnProperty(id)) {
                        this._area = _.areas[id];
                        this.clear();
                    }
                }
                this._area = area;
                return this;
            },

            // internal use functions
            _in: function(k) {
                if (typeof k !== "string"){ k = _.stringify(k); }
                return this._ns ? this._ns + k : k;
            },
            _out: function(k) {
                return this._ns ?
                    k && k.indexOf(this._ns) === 0 ?
                        k.substring(this._ns.length) :
                        undefined : // so each() knows to skip it
                    k;
            }
        },// end _.storeAPI
        storageAPI: {
            length: 0,
            has: function(k){ return this.items.hasOwnProperty(k); },
            key: function(i) {
                var c = 0;
                for (var k in this.items){
                    if (this.has(k) && i === c++) {
                        return k;
                    }
                }
            },
            setItem: function(k, v) {
                if (!this.has(k)) {
                    this.length++;
                }
                this.items[k] = v;
            },
            removeItem: function(k) {
                if (this.has(k)) {
                    delete this.items[k];
                    this.length--;
                }
            },
            getItem: function(k){ return this.has(k) ? this.items[k] : null; },
            clear: function(){ for (var k in this.list){ this.removeItem(k); } },
            toString: function(){ return this.length+' items in '+this.name+'Storage'; }
        }// end _.storageAPI
    };

    var store =
        // safely set this up (throws error in IE10/32bit mode for local files)
        _.Store("local", (function(){try{ return localStorage; }catch(e){}})());
    store.local = store;// for completeness
    store._ = _;// for extenders and debuggers...
    // safely setup store.session (throws exception in FF for file:/// urls)
    store.area("session", (function(){try{ return sessionStorage; }catch(e){}})());

    return store;
}));
!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define('moment',t):e.moment=t()}(this,function(){"use strict";var H;function _(){return H.apply(null,arguments)}function y(e){return e instanceof Array||"[object Array]"===Object.prototype.toString.call(e)}function F(e){return null!=e&&"[object Object]"===Object.prototype.toString.call(e)}function c(e,t){return Object.prototype.hasOwnProperty.call(e,t)}function L(e){if(Object.getOwnPropertyNames)return 0===Object.getOwnPropertyNames(e).length;for(var t in e)if(c(e,t))return;return 1}function g(e){return void 0===e}function w(e){return"number"==typeof e||"[object Number]"===Object.prototype.toString.call(e)}function V(e){return e instanceof Date||"[object Date]"===Object.prototype.toString.call(e)}function G(e,t){for(var n=[],s=e.length,i=0;i<s;++i)n.push(t(e[i],i));return n}function E(e,t){for(var n in t)c(t,n)&&(e[n]=t[n]);return c(t,"toString")&&(e.toString=t.toString),c(t,"valueOf")&&(e.valueOf=t.valueOf),e}function l(e,t,n,s){return Wt(e,t,n,s,!0).utc()}function p(e){return null==e._pf&&(e._pf={empty:!1,unusedTokens:[],unusedInput:[],overflow:-2,charsLeftOver:0,nullInput:!1,invalidEra:null,invalidMonth:null,invalidFormat:!1,userInvalidated:!1,iso:!1,parsedDateParts:[],era:null,meridiem:null,rfc2822:!1,weekdayMismatch:!1}),e._pf}function A(e){var t,n,s=e._d&&!isNaN(e._d.getTime());return s&&(t=p(e),n=j.call(t.parsedDateParts,function(e){return null!=e}),s=t.overflow<0&&!t.empty&&!t.invalidEra&&!t.invalidMonth&&!t.invalidWeekday&&!t.weekdayMismatch&&!t.nullInput&&!t.invalidFormat&&!t.userInvalidated&&(!t.meridiem||t.meridiem&&n),e._strict)&&(s=s&&0===t.charsLeftOver&&0===t.unusedTokens.length&&void 0===t.bigHour),null!=Object.isFrozen&&Object.isFrozen(e)?s:(e._isValid=s,e._isValid)}function I(e){var t=l(NaN);return null!=e?E(p(t),e):p(t).userInvalidated=!0,t}var j=Array.prototype.some||function(e){for(var t=Object(this),n=t.length>>>0,s=0;s<n;s++)if(s in t&&e.call(this,t[s],s,t))return!0;return!1},Z=_.momentProperties=[],z=!1;function q(e,t){var n,s,i,r=Z.length;if(g(t._isAMomentObject)||(e._isAMomentObject=t._isAMomentObject),g(t._i)||(e._i=t._i),g(t._f)||(e._f=t._f),g(t._l)||(e._l=t._l),g(t._strict)||(e._strict=t._strict),g(t._tzm)||(e._tzm=t._tzm),g(t._isUTC)||(e._isUTC=t._isUTC),g(t._offset)||(e._offset=t._offset),g(t._pf)||(e._pf=p(t)),g(t._locale)||(e._locale=t._locale),0<r)for(n=0;n<r;n++)g(i=t[s=Z[n]])||(e[s]=i);return e}function $(e){q(this,e),this._d=new Date(null!=e._d?e._d.getTime():NaN),this.isValid()||(this._d=new Date(NaN)),!1===z&&(z=!0,_.updateOffset(this),z=!1)}function k(e){return e instanceof $||null!=e&&null!=e._isAMomentObject}function B(e){!1===_.suppressDeprecationWarnings&&"undefined"!=typeof console&&console.warn&&console.warn("Deprecation warning: "+e)}function e(r,a){var o=!0;return E(function(){if(null!=_.deprecationHandler&&_.deprecationHandler(null,r),o){for(var e,t,n=[],s=arguments.length,i=0;i<s;i++){if(e="","object"==typeof arguments[i]){for(t in e+="\n["+i+"] ",arguments[0])c(arguments[0],t)&&(e+=t+": "+arguments[0][t]+", ");e=e.slice(0,-2)}else e=arguments[i];n.push(e)}B(r+"\nArguments: "+Array.prototype.slice.call(n).join("")+"\n"+(new Error).stack),o=!1}return a.apply(this,arguments)},a)}var J={};function Q(e,t){null!=_.deprecationHandler&&_.deprecationHandler(e,t),J[e]||(B(t),J[e]=!0)}function a(e){return"undefined"!=typeof Function&&e instanceof Function||"[object Function]"===Object.prototype.toString.call(e)}function X(e,t){var n,s=E({},e);for(n in t)c(t,n)&&(F(e[n])&&F(t[n])?(s[n]={},E(s[n],e[n]),E(s[n],t[n])):null!=t[n]?s[n]=t[n]:delete s[n]);for(n in e)c(e,n)&&!c(t,n)&&F(e[n])&&(s[n]=E({},s[n]));return s}function K(e){null!=e&&this.set(e)}_.suppressDeprecationWarnings=!1,_.deprecationHandler=null;var ee=Object.keys||function(e){var t,n=[];for(t in e)c(e,t)&&n.push(t);return n};function r(e,t,n){var s=""+Math.abs(e);return(0<=e?n?"+":"":"-")+Math.pow(10,Math.max(0,t-s.length)).toString().substr(1)+s}var te=/(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,ne=/(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,se={},ie={};function s(e,t,n,s){var i="string"==typeof s?function(){return this[s]()}:s;e&&(ie[e]=i),t&&(ie[t[0]]=function(){return r(i.apply(this,arguments),t[1],t[2])}),n&&(ie[n]=function(){return this.localeData().ordinal(i.apply(this,arguments),e)})}function re(e,t){return e.isValid()?(t=ae(t,e.localeData()),se[t]=se[t]||function(s){for(var e,i=s.match(te),t=0,r=i.length;t<r;t++)ie[i[t]]?i[t]=ie[i[t]]:i[t]=(e=i[t]).match(/\[[\s\S]/)?e.replace(/^\[|\]$/g,""):e.replace(/\\/g,"");return function(e){for(var t="",n=0;n<r;n++)t+=a(i[n])?i[n].call(e,s):i[n];return t}}(t),se[t](e)):e.localeData().invalidDate()}function ae(e,t){var n=5;function s(e){return t.longDateFormat(e)||e}for(ne.lastIndex=0;0<=n&&ne.test(e);)e=e.replace(ne,s),ne.lastIndex=0,--n;return e}var oe={D:"date",dates:"date",date:"date",d:"day",days:"day",day:"day",e:"weekday",weekdays:"weekday",weekday:"weekday",E:"isoWeekday",isoweekdays:"isoWeekday",isoweekday:"isoWeekday",DDD:"dayOfYear",dayofyears:"dayOfYear",dayofyear:"dayOfYear",h:"hour",hours:"hour",hour:"hour",ms:"millisecond",milliseconds:"millisecond",millisecond:"millisecond",m:"minute",minutes:"minute",minute:"minute",M:"month",months:"month",month:"month",Q:"quarter",quarters:"quarter",quarter:"quarter",s:"second",seconds:"second",second:"second",gg:"weekYear",weekyears:"weekYear",weekyear:"weekYear",GG:"isoWeekYear",isoweekyears:"isoWeekYear",isoweekyear:"isoWeekYear",w:"week",weeks:"week",week:"week",W:"isoWeek",isoweeks:"isoWeek",isoweek:"isoWeek",y:"year",years:"year",year:"year"};function o(e){return"string"==typeof e?oe[e]||oe[e.toLowerCase()]:void 0}function ue(e){var t,n,s={};for(n in e)c(e,n)&&(t=o(n))&&(s[t]=e[n]);return s}var le={date:9,day:11,weekday:11,isoWeekday:11,dayOfYear:4,hour:13,millisecond:16,minute:14,month:8,quarter:7,second:15,weekYear:1,isoWeekYear:1,week:5,isoWeek:5,year:1};var de=/\d/,t=/\d\d/,he=/\d{3}/,ce=/\d{4}/,fe=/[+-]?\d{6}/,n=/\d\d?/,me=/\d\d\d\d?/,_e=/\d\d\d\d\d\d?/,ye=/\d{1,3}/,ge=/\d{1,4}/,we=/[+-]?\d{1,6}/,pe=/\d+/,ke=/[+-]?\d+/,Me=/Z|[+-]\d\d:?\d\d/gi,ve=/Z|[+-]\d\d(?::?\d\d)?/gi,i=/[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,u=/^[1-9]\d?/,d=/^([1-9]\d|\d)/;function h(e,n,s){Ye[e]=a(n)?n:function(e,t){return e&&s?s:n}}function De(e,t){return c(Ye,e)?Ye[e](t._strict,t._locale):new RegExp(f(e.replace("\\","").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,function(e,t,n,s,i){return t||n||s||i})))}function f(e){return e.replace(/[-\/\\^$*+?.()|[\]{}]/g,"\\$&")}function m(e){return e<0?Math.ceil(e)||0:Math.floor(e)}function M(e){var e=+e,t=0;return t=0!=e&&isFinite(e)?m(e):t}var Ye={},Se={};function v(e,n){var t,s,i=n;for("string"==typeof e&&(e=[e]),w(n)&&(i=function(e,t){t[n]=M(e)}),s=e.length,t=0;t<s;t++)Se[e[t]]=i}function Oe(e,i){v(e,function(e,t,n,s){n._w=n._w||{},i(e,n._w,n,s)})}function be(e){return e%4==0&&e%100!=0||e%400==0}var D=0,Y=1,S=2,O=3,b=4,T=5,Te=6,xe=7,Ne=8;function We(e){return be(e)?366:365}s("Y",0,0,function(){var e=this.year();return e<=9999?r(e,4):"+"+e}),s(0,["YY",2],0,function(){return this.year()%100}),s(0,["YYYY",4],0,"year"),s(0,["YYYYY",5],0,"year"),s(0,["YYYYYY",6,!0],0,"year"),h("Y",ke),h("YY",n,t),h("YYYY",ge,ce),h("YYYYY",we,fe),h("YYYYYY",we,fe),v(["YYYYY","YYYYYY"],D),v("YYYY",function(e,t){t[D]=2===e.length?_.parseTwoDigitYear(e):M(e)}),v("YY",function(e,t){t[D]=_.parseTwoDigitYear(e)}),v("Y",function(e,t){t[D]=parseInt(e,10)}),_.parseTwoDigitYear=function(e){return M(e)+(68<M(e)?1900:2e3)};var x,Pe=Re("FullYear",!0);function Re(t,n){return function(e){return null!=e?(Ue(this,t,e),_.updateOffset(this,n),this):Ce(this,t)}}function Ce(e,t){if(!e.isValid())return NaN;var n=e._d,s=e._isUTC;switch(t){case"Milliseconds":return s?n.getUTCMilliseconds():n.getMilliseconds();case"Seconds":return s?n.getUTCSeconds():n.getSeconds();case"Minutes":return s?n.getUTCMinutes():n.getMinutes();case"Hours":return s?n.getUTCHours():n.getHours();case"Date":return s?n.getUTCDate():n.getDate();case"Day":return s?n.getUTCDay():n.getDay();case"Month":return s?n.getUTCMonth():n.getMonth();case"FullYear":return s?n.getUTCFullYear():n.getFullYear();default:return NaN}}function Ue(e,t,n){var s,i,r;if(e.isValid()&&!isNaN(n)){switch(s=e._d,i=e._isUTC,t){case"Milliseconds":return i?s.setUTCMilliseconds(n):s.setMilliseconds(n);case"Seconds":return i?s.setUTCSeconds(n):s.setSeconds(n);case"Minutes":return i?s.setUTCMinutes(n):s.setMinutes(n);case"Hours":return i?s.setUTCHours(n):s.setHours(n);case"Date":return i?s.setUTCDate(n):s.setDate(n);case"FullYear":break;default:return}t=n,r=e.month(),e=29!==(e=e.date())||1!==r||be(t)?e:28,i?s.setUTCFullYear(t,r,e):s.setFullYear(t,r,e)}}function He(e,t){var n;return isNaN(e)||isNaN(t)?NaN:(n=(t%(n=12)+n)%n,e+=(t-n)/12,1==n?be(e)?29:28:31-n%7%2)}x=Array.prototype.indexOf||function(e){for(var t=0;t<this.length;++t)if(this[t]===e)return t;return-1},s("M",["MM",2],"Mo",function(){return this.month()+1}),s("MMM",0,0,function(e){return this.localeData().monthsShort(this,e)}),s("MMMM",0,0,function(e){return this.localeData().months(this,e)}),h("M",n,u),h("MM",n,t),h("MMM",function(e,t){return t.monthsShortRegex(e)}),h("MMMM",function(e,t){return t.monthsRegex(e)}),v(["M","MM"],function(e,t){t[Y]=M(e)-1}),v(["MMM","MMMM"],function(e,t,n,s){s=n._locale.monthsParse(e,s,n._strict);null!=s?t[Y]=s:p(n).invalidMonth=e});var Fe="January_February_March_April_May_June_July_August_September_October_November_December".split("_"),Le="Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),Ve=/D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,Ge=i,Ee=i;function Ae(e,t){if(e.isValid()){if("string"==typeof t)if(/^\d+$/.test(t))t=M(t);else if(!w(t=e.localeData().monthsParse(t)))return;var n=(n=e.date())<29?n:Math.min(n,He(e.year(),t));e._isUTC?e._d.setUTCMonth(t,n):e._d.setMonth(t,n)}}function Ie(e){return null!=e?(Ae(this,e),_.updateOffset(this,!0),this):Ce(this,"Month")}function je(){function e(e,t){return t.length-e.length}for(var t,n,s=[],i=[],r=[],a=0;a<12;a++)n=l([2e3,a]),t=f(this.monthsShort(n,"")),n=f(this.months(n,"")),s.push(t),i.push(n),r.push(n),r.push(t);s.sort(e),i.sort(e),r.sort(e),this._monthsRegex=new RegExp("^("+r.join("|")+")","i"),this._monthsShortRegex=this._monthsRegex,this._monthsStrictRegex=new RegExp("^("+i.join("|")+")","i"),this._monthsShortStrictRegex=new RegExp("^("+s.join("|")+")","i")}function Ze(e,t,n,s,i,r,a){var o;return e<100&&0<=e?(o=new Date(e+400,t,n,s,i,r,a),isFinite(o.getFullYear())&&o.setFullYear(e)):o=new Date(e,t,n,s,i,r,a),o}function ze(e){var t;return e<100&&0<=e?((t=Array.prototype.slice.call(arguments))[0]=e+400,t=new Date(Date.UTC.apply(null,t)),isFinite(t.getUTCFullYear())&&t.setUTCFullYear(e)):t=new Date(Date.UTC.apply(null,arguments)),t}function qe(e,t,n){n=7+t-n;return n-(7+ze(e,0,n).getUTCDay()-t)%7-1}function $e(e,t,n,s,i){var r,t=1+7*(t-1)+(7+n-s)%7+qe(e,s,i),n=t<=0?We(r=e-1)+t:t>We(e)?(r=e+1,t-We(e)):(r=e,t);return{year:r,dayOfYear:n}}function Be(e,t,n){var s,i,r=qe(e.year(),t,n),r=Math.floor((e.dayOfYear()-r-1)/7)+1;return r<1?s=r+N(i=e.year()-1,t,n):r>N(e.year(),t,n)?(s=r-N(e.year(),t,n),i=e.year()+1):(i=e.year(),s=r),{week:s,year:i}}function N(e,t,n){var s=qe(e,t,n),t=qe(e+1,t,n);return(We(e)-s+t)/7}s("w",["ww",2],"wo","week"),s("W",["WW",2],"Wo","isoWeek"),h("w",n,u),h("ww",n,t),h("W",n,u),h("WW",n,t),Oe(["w","ww","W","WW"],function(e,t,n,s){t[s.substr(0,1)]=M(e)});function Je(e,t){return e.slice(t,7).concat(e.slice(0,t))}s("d",0,"do","day"),s("dd",0,0,function(e){return this.localeData().weekdaysMin(this,e)}),s("ddd",0,0,function(e){return this.localeData().weekdaysShort(this,e)}),s("dddd",0,0,function(e){return this.localeData().weekdays(this,e)}),s("e",0,0,"weekday"),s("E",0,0,"isoWeekday"),h("d",n),h("e",n),h("E",n),h("dd",function(e,t){return t.weekdaysMinRegex(e)}),h("ddd",function(e,t){return t.weekdaysShortRegex(e)}),h("dddd",function(e,t){return t.weekdaysRegex(e)}),Oe(["dd","ddd","dddd"],function(e,t,n,s){s=n._locale.weekdaysParse(e,s,n._strict);null!=s?t.d=s:p(n).invalidWeekday=e}),Oe(["d","e","E"],function(e,t,n,s){t[s]=M(e)});var Qe="Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),Xe="Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),Ke="Su_Mo_Tu_We_Th_Fr_Sa".split("_"),et=i,tt=i,nt=i;function st(){function e(e,t){return t.length-e.length}for(var t,n,s,i=[],r=[],a=[],o=[],u=0;u<7;u++)s=l([2e3,1]).day(u),t=f(this.weekdaysMin(s,"")),n=f(this.weekdaysShort(s,"")),s=f(this.weekdays(s,"")),i.push(t),r.push(n),a.push(s),o.push(t),o.push(n),o.push(s);i.sort(e),r.sort(e),a.sort(e),o.sort(e),this._weekdaysRegex=new RegExp("^("+o.join("|")+")","i"),this._weekdaysShortRegex=this._weekdaysRegex,this._weekdaysMinRegex=this._weekdaysRegex,this._weekdaysStrictRegex=new RegExp("^("+a.join("|")+")","i"),this._weekdaysShortStrictRegex=new RegExp("^("+r.join("|")+")","i"),this._weekdaysMinStrictRegex=new RegExp("^("+i.join("|")+")","i")}function it(){return this.hours()%12||12}function rt(e,t){s(e,0,0,function(){return this.localeData().meridiem(this.hours(),this.minutes(),t)})}function at(e,t){return t._meridiemParse}s("H",["HH",2],0,"hour"),s("h",["hh",2],0,it),s("k",["kk",2],0,function(){return this.hours()||24}),s("hmm",0,0,function(){return""+it.apply(this)+r(this.minutes(),2)}),s("hmmss",0,0,function(){return""+it.apply(this)+r(this.minutes(),2)+r(this.seconds(),2)}),s("Hmm",0,0,function(){return""+this.hours()+r(this.minutes(),2)}),s("Hmmss",0,0,function(){return""+this.hours()+r(this.minutes(),2)+r(this.seconds(),2)}),rt("a",!0),rt("A",!1),h("a",at),h("A",at),h("H",n,d),h("h",n,u),h("k",n,u),h("HH",n,t),h("hh",n,t),h("kk",n,t),h("hmm",me),h("hmmss",_e),h("Hmm",me),h("Hmmss",_e),v(["H","HH"],O),v(["k","kk"],function(e,t,n){e=M(e);t[O]=24===e?0:e}),v(["a","A"],function(e,t,n){n._isPm=n._locale.isPM(e),n._meridiem=e}),v(["h","hh"],function(e,t,n){t[O]=M(e),p(n).bigHour=!0}),v("hmm",function(e,t,n){var s=e.length-2;t[O]=M(e.substr(0,s)),t[b]=M(e.substr(s)),p(n).bigHour=!0}),v("hmmss",function(e,t,n){var s=e.length-4,i=e.length-2;t[O]=M(e.substr(0,s)),t[b]=M(e.substr(s,2)),t[T]=M(e.substr(i)),p(n).bigHour=!0}),v("Hmm",function(e,t,n){var s=e.length-2;t[O]=M(e.substr(0,s)),t[b]=M(e.substr(s))}),v("Hmmss",function(e,t,n){var s=e.length-4,i=e.length-2;t[O]=M(e.substr(0,s)),t[b]=M(e.substr(s,2)),t[T]=M(e.substr(i))});i=Re("Hours",!0);var ot,ut={calendar:{sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},longDateFormat:{LTS:"h:mm:ss A",LT:"h:mm A",L:"MM/DD/YYYY",LL:"MMMM D, YYYY",LLL:"MMMM D, YYYY h:mm A",LLLL:"dddd, MMMM D, YYYY h:mm A"},invalidDate:"Invalid date",ordinal:"%d",dayOfMonthOrdinalParse:/\d{1,2}/,relativeTime:{future:"in %s",past:"%s ago",s:"a few seconds",ss:"%d seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",w:"a week",ww:"%d weeks",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},months:Fe,monthsShort:Le,week:{dow:0,doy:6},weekdays:Qe,weekdaysMin:Ke,weekdaysShort:Xe,meridiemParse:/[ap]\.?m?\.?/i},W={},lt={};function dt(e){return e&&e.toLowerCase().replace("_","-")}function ht(e){for(var t,n,s,i,r=0;r<e.length;){for(t=(i=dt(e[r]).split("-")).length,n=(n=dt(e[r+1]))?n.split("-"):null;0<t;){if(s=ct(i.slice(0,t).join("-")))return s;if(n&&n.length>=t&&function(e,t){for(var n=Math.min(e.length,t.length),s=0;s<n;s+=1)if(e[s]!==t[s])return s;return n}(i,n)>=t-1)break;t--}r++}return ot}function ct(t){var e,n;if(void 0===W[t]&&"undefined"!=typeof module&&module&&module.exports&&(n=t)&&n.match("^[^/\\\\]*$"))try{e=ot._abbr,require("./locale/"+t),ft(e)}catch(e){W[t]=null}return W[t]}function ft(e,t){return e&&((t=g(t)?P(e):mt(e,t))?ot=t:"undefined"!=typeof console&&console.warn&&console.warn("Locale "+e+" not found. Did you forget to load it?")),ot._abbr}function mt(e,t){if(null===t)return delete W[e],null;var n,s=ut;if(t.abbr=e,null!=W[e])Q("defineLocaleOverride","use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."),s=W[e]._config;else if(null!=t.parentLocale)if(null!=W[t.parentLocale])s=W[t.parentLocale]._config;else{if(null==(n=ct(t.parentLocale)))return lt[t.parentLocale]||(lt[t.parentLocale]=[]),lt[t.parentLocale].push({name:e,config:t}),null;s=n._config}return W[e]=new K(X(s,t)),lt[e]&&lt[e].forEach(function(e){mt(e.name,e.config)}),ft(e),W[e]}function P(e){var t;if(!(e=e&&e._locale&&e._locale._abbr?e._locale._abbr:e))return ot;if(!y(e)){if(t=ct(e))return t;e=[e]}return ht(e)}function _t(e){var t=e._a;return t&&-2===p(e).overflow&&(t=t[Y]<0||11<t[Y]?Y:t[S]<1||t[S]>He(t[D],t[Y])?S:t[O]<0||24<t[O]||24===t[O]&&(0!==t[b]||0!==t[T]||0!==t[Te])?O:t[b]<0||59<t[b]?b:t[T]<0||59<t[T]?T:t[Te]<0||999<t[Te]?Te:-1,p(e)._overflowDayOfYear&&(t<D||S<t)&&(t=S),p(e)._overflowWeeks&&-1===t&&(t=xe),p(e)._overflowWeekday&&-1===t&&(t=Ne),p(e).overflow=t),e}var yt=/^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,gt=/^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,wt=/Z|[+-]\d\d(?::?\d\d)?/,pt=[["YYYYYY-MM-DD",/[+-]\d{6}-\d\d-\d\d/],["YYYY-MM-DD",/\d{4}-\d\d-\d\d/],["GGGG-[W]WW-E",/\d{4}-W\d\d-\d/],["GGGG-[W]WW",/\d{4}-W\d\d/,!1],["YYYY-DDD",/\d{4}-\d{3}/],["YYYY-MM",/\d{4}-\d\d/,!1],["YYYYYYMMDD",/[+-]\d{10}/],["YYYYMMDD",/\d{8}/],["GGGG[W]WWE",/\d{4}W\d{3}/],["GGGG[W]WW",/\d{4}W\d{2}/,!1],["YYYYDDD",/\d{7}/],["YYYYMM",/\d{6}/,!1],["YYYY",/\d{4}/,!1]],kt=[["HH:mm:ss.SSSS",/\d\d:\d\d:\d\d\.\d+/],["HH:mm:ss,SSSS",/\d\d:\d\d:\d\d,\d+/],["HH:mm:ss",/\d\d:\d\d:\d\d/],["HH:mm",/\d\d:\d\d/],["HHmmss.SSSS",/\d\d\d\d\d\d\.\d+/],["HHmmss,SSSS",/\d\d\d\d\d\d,\d+/],["HHmmss",/\d\d\d\d\d\d/],["HHmm",/\d\d\d\d/],["HH",/\d\d/]],Mt=/^\/?Date\((-?\d+)/i,vt=/^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,Dt={UT:0,GMT:0,EDT:-240,EST:-300,CDT:-300,CST:-360,MDT:-360,MST:-420,PDT:-420,PST:-480};function Yt(e){var t,n,s,i,r,a,o=e._i,u=yt.exec(o)||gt.exec(o),o=pt.length,l=kt.length;if(u){for(p(e).iso=!0,t=0,n=o;t<n;t++)if(pt[t][1].exec(u[1])){i=pt[t][0],s=!1!==pt[t][2];break}if(null==i)e._isValid=!1;else{if(u[3]){for(t=0,n=l;t<n;t++)if(kt[t][1].exec(u[3])){r=(u[2]||" ")+kt[t][0];break}if(null==r)return void(e._isValid=!1)}if(s||null==r){if(u[4]){if(!wt.exec(u[4]))return void(e._isValid=!1);a="Z"}e._f=i+(r||"")+(a||""),xt(e)}else e._isValid=!1}}else e._isValid=!1}function St(e,t,n,s,i,r){e=[function(e){e=parseInt(e,10);{if(e<=49)return 2e3+e;if(e<=999)return 1900+e}return e}(e),Le.indexOf(t),parseInt(n,10),parseInt(s,10),parseInt(i,10)];return r&&e.push(parseInt(r,10)),e}function Ot(e){var t,n,s=vt.exec(e._i.replace(/\([^()]*\)|[\n\t]/g," ").replace(/(\s\s+)/g," ").replace(/^\s\s*/,"").replace(/\s\s*$/,""));s?(t=St(s[4],s[3],s[2],s[5],s[6],s[7]),function(e,t,n){if(!e||Xe.indexOf(e)===new Date(t[0],t[1],t[2]).getDay())return 1;p(n).weekdayMismatch=!0,n._isValid=!1}(s[1],t,e)&&(e._a=t,e._tzm=(t=s[8],n=s[9],s=s[10],t?Dt[t]:n?0:60*(((t=parseInt(s,10))-(n=t%100))/100)+n),e._d=ze.apply(null,e._a),e._d.setUTCMinutes(e._d.getUTCMinutes()-e._tzm),p(e).rfc2822=!0)):e._isValid=!1}function bt(e,t,n){return null!=e?e:null!=t?t:n}function Tt(e){var t,n,s,i,r,a,o,u,l,d,h,c=[];if(!e._d){for(s=e,i=new Date(_.now()),n=s._useUTC?[i.getUTCFullYear(),i.getUTCMonth(),i.getUTCDate()]:[i.getFullYear(),i.getMonth(),i.getDate()],e._w&&null==e._a[S]&&null==e._a[Y]&&(null!=(i=(s=e)._w).GG||null!=i.W||null!=i.E?(u=1,l=4,r=bt(i.GG,s._a[D],Be(R(),1,4).year),a=bt(i.W,1),((o=bt(i.E,1))<1||7<o)&&(d=!0)):(u=s._locale._week.dow,l=s._locale._week.doy,h=Be(R(),u,l),r=bt(i.gg,s._a[D],h.year),a=bt(i.w,h.week),null!=i.d?((o=i.d)<0||6<o)&&(d=!0):null!=i.e?(o=i.e+u,(i.e<0||6<i.e)&&(d=!0)):o=u),a<1||a>N(r,u,l)?p(s)._overflowWeeks=!0:null!=d?p(s)._overflowWeekday=!0:(h=$e(r,a,o,u,l),s._a[D]=h.year,s._dayOfYear=h.dayOfYear)),null!=e._dayOfYear&&(i=bt(e._a[D],n[D]),(e._dayOfYear>We(i)||0===e._dayOfYear)&&(p(e)._overflowDayOfYear=!0),d=ze(i,0,e._dayOfYear),e._a[Y]=d.getUTCMonth(),e._a[S]=d.getUTCDate()),t=0;t<3&&null==e._a[t];++t)e._a[t]=c[t]=n[t];for(;t<7;t++)e._a[t]=c[t]=null==e._a[t]?2===t?1:0:e._a[t];24===e._a[O]&&0===e._a[b]&&0===e._a[T]&&0===e._a[Te]&&(e._nextDay=!0,e._a[O]=0),e._d=(e._useUTC?ze:Ze).apply(null,c),r=e._useUTC?e._d.getUTCDay():e._d.getDay(),null!=e._tzm&&e._d.setUTCMinutes(e._d.getUTCMinutes()-e._tzm),e._nextDay&&(e._a[O]=24),e._w&&void 0!==e._w.d&&e._w.d!==r&&(p(e).weekdayMismatch=!0)}}function xt(e){if(e._f===_.ISO_8601)Yt(e);else if(e._f===_.RFC_2822)Ot(e);else{e._a=[],p(e).empty=!0;for(var t,n,s,i,r,a=""+e._i,o=a.length,u=0,l=ae(e._f,e._locale).match(te)||[],d=l.length,h=0;h<d;h++)n=l[h],(t=(a.match(De(n,e))||[])[0])&&(0<(s=a.substr(0,a.indexOf(t))).length&&p(e).unusedInput.push(s),a=a.slice(a.indexOf(t)+t.length),u+=t.length),ie[n]?(t?p(e).empty=!1:p(e).unusedTokens.push(n),s=n,r=e,null!=(i=t)&&c(Se,s)&&Se[s](i,r._a,r,s)):e._strict&&!t&&p(e).unusedTokens.push(n);p(e).charsLeftOver=o-u,0<a.length&&p(e).unusedInput.push(a),e._a[O]<=12&&!0===p(e).bigHour&&0<e._a[O]&&(p(e).bigHour=void 0),p(e).parsedDateParts=e._a.slice(0),p(e).meridiem=e._meridiem,e._a[O]=function(e,t,n){if(null==n)return t;return null!=e.meridiemHour?e.meridiemHour(t,n):null!=e.isPM?((e=e.isPM(n))&&t<12&&(t+=12),t=e||12!==t?t:0):t}(e._locale,e._a[O],e._meridiem),null!==(o=p(e).era)&&(e._a[D]=e._locale.erasConvertYear(o,e._a[D])),Tt(e),_t(e)}}function Nt(e){var t,n,s,i=e._i,r=e._f;if(e._locale=e._locale||P(e._l),null===i||void 0===r&&""===i)return I({nullInput:!0});if("string"==typeof i&&(e._i=i=e._locale.preparse(i)),k(i))return new $(_t(i));if(V(i))e._d=i;else if(y(r)){var a,o,u,l,d,h,c=e,f=!1,m=c._f.length;if(0===m)p(c).invalidFormat=!0,c._d=new Date(NaN);else{for(l=0;l<m;l++)d=0,h=!1,a=q({},c),null!=c._useUTC&&(a._useUTC=c._useUTC),a._f=c._f[l],xt(a),A(a)&&(h=!0),d=(d+=p(a).charsLeftOver)+10*p(a).unusedTokens.length,p(a).score=d,f?d<u&&(u=d,o=a):(null==u||d<u||h)&&(u=d,o=a,h)&&(f=!0);E(c,o||a)}}else if(r)xt(e);else if(g(r=(i=e)._i))i._d=new Date(_.now());else V(r)?i._d=new Date(r.valueOf()):"string"==typeof r?(n=i,null!==(t=Mt.exec(n._i))?n._d=new Date(+t[1]):(Yt(n),!1===n._isValid&&(delete n._isValid,Ot(n),!1===n._isValid)&&(delete n._isValid,n._strict?n._isValid=!1:_.createFromInputFallback(n)))):y(r)?(i._a=G(r.slice(0),function(e){return parseInt(e,10)}),Tt(i)):F(r)?(t=i)._d||(s=void 0===(n=ue(t._i)).day?n.date:n.day,t._a=G([n.year,n.month,s,n.hour,n.minute,n.second,n.millisecond],function(e){return e&&parseInt(e,10)}),Tt(t)):w(r)?i._d=new Date(r):_.createFromInputFallback(i);return A(e)||(e._d=null),e}function Wt(e,t,n,s,i){var r={};return!0!==t&&!1!==t||(s=t,t=void 0),!0!==n&&!1!==n||(s=n,n=void 0),(F(e)&&L(e)||y(e)&&0===e.length)&&(e=void 0),r._isAMomentObject=!0,r._useUTC=r._isUTC=i,r._l=n,r._i=e,r._f=t,r._strict=s,(i=new $(_t(Nt(i=r))))._nextDay&&(i.add(1,"d"),i._nextDay=void 0),i}function R(e,t,n,s){return Wt(e,t,n,s,!1)}_.createFromInputFallback=e("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",function(e){e._d=new Date(e._i+(e._useUTC?" UTC":""))}),_.ISO_8601=function(){},_.RFC_2822=function(){};me=e("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",function(){var e=R.apply(null,arguments);return this.isValid()&&e.isValid()?e<this?this:e:I()}),_e=e("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",function(){var e=R.apply(null,arguments);return this.isValid()&&e.isValid()?this<e?this:e:I()});function Pt(e,t){var n,s;if(!(t=1===t.length&&y(t[0])?t[0]:t).length)return R();for(n=t[0],s=1;s<t.length;++s)t[s].isValid()&&!t[s][e](n)||(n=t[s]);return n}var Rt=["year","quarter","month","week","day","hour","minute","second","millisecond"];function Ct(e){var e=ue(e),t=e.year||0,n=e.quarter||0,s=e.month||0,i=e.week||e.isoWeek||0,r=e.day||0,a=e.hour||0,o=e.minute||0,u=e.second||0,l=e.millisecond||0;this._isValid=function(e){var t,n,s=!1,i=Rt.length;for(t in e)if(c(e,t)&&(-1===x.call(Rt,t)||null!=e[t]&&isNaN(e[t])))return!1;for(n=0;n<i;++n)if(e[Rt[n]]){if(s)return!1;parseFloat(e[Rt[n]])!==M(e[Rt[n]])&&(s=!0)}return!0}(e),this._milliseconds=+l+1e3*u+6e4*o+1e3*a*60*60,this._days=+r+7*i,this._months=+s+3*n+12*t,this._data={},this._locale=P(),this._bubble()}function Ut(e){return e instanceof Ct}function Ht(e){return e<0?-1*Math.round(-1*e):Math.round(e)}function Ft(e,n){s(e,0,0,function(){var e=this.utcOffset(),t="+";return e<0&&(e=-e,t="-"),t+r(~~(e/60),2)+n+r(~~e%60,2)})}Ft("Z",":"),Ft("ZZ",""),h("Z",ve),h("ZZ",ve),v(["Z","ZZ"],function(e,t,n){n._useUTC=!0,n._tzm=Vt(ve,e)});var Lt=/([\+\-]|\d\d)/gi;function Vt(e,t){var t=(t||"").match(e);return null===t?null:0===(t=60*(e=((t[t.length-1]||[])+"").match(Lt)||["-",0,0])[1]+M(e[2]))?0:"+"===e[0]?t:-t}function Gt(e,t){var n;return t._isUTC?(t=t.clone(),n=(k(e)||V(e)?e:R(e)).valueOf()-t.valueOf(),t._d.setTime(t._d.valueOf()+n),_.updateOffset(t,!1),t):R(e).local()}function Et(e){return-Math.round(e._d.getTimezoneOffset())}function At(){return!!this.isValid()&&this._isUTC&&0===this._offset}_.updateOffset=function(){};var It=/^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,jt=/^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;function C(e,t){var n,s=e;return Ut(e)?s={ms:e._milliseconds,d:e._days,M:e._months}:w(e)||!isNaN(+e)?(s={},t?s[t]=+e:s.milliseconds=+e):(t=It.exec(e))?(n="-"===t[1]?-1:1,s={y:0,d:M(t[S])*n,h:M(t[O])*n,m:M(t[b])*n,s:M(t[T])*n,ms:M(Ht(1e3*t[Te]))*n}):(t=jt.exec(e))?(n="-"===t[1]?-1:1,s={y:Zt(t[2],n),M:Zt(t[3],n),w:Zt(t[4],n),d:Zt(t[5],n),h:Zt(t[6],n),m:Zt(t[7],n),s:Zt(t[8],n)}):null==s?s={}:"object"==typeof s&&("from"in s||"to"in s)&&(t=function(e,t){var n;if(!e.isValid()||!t.isValid())return{milliseconds:0,months:0};t=Gt(t,e),e.isBefore(t)?n=zt(e,t):((n=zt(t,e)).milliseconds=-n.milliseconds,n.months=-n.months);return n}(R(s.from),R(s.to)),(s={}).ms=t.milliseconds,s.M=t.months),n=new Ct(s),Ut(e)&&c(e,"_locale")&&(n._locale=e._locale),Ut(e)&&c(e,"_isValid")&&(n._isValid=e._isValid),n}function Zt(e,t){e=e&&parseFloat(e.replace(",","."));return(isNaN(e)?0:e)*t}function zt(e,t){var n={};return n.months=t.month()-e.month()+12*(t.year()-e.year()),e.clone().add(n.months,"M").isAfter(t)&&--n.months,n.milliseconds=+t-+e.clone().add(n.months,"M"),n}function qt(s,i){return function(e,t){var n;return null===t||isNaN(+t)||(Q(i,"moment()."+i+"(period, number) is deprecated. Please use moment()."+i+"(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."),n=e,e=t,t=n),$t(this,C(e,t),s),this}}function $t(e,t,n,s){var i=t._milliseconds,r=Ht(t._days),t=Ht(t._months);e.isValid()&&(s=null==s||s,t&&Ae(e,Ce(e,"Month")+t*n),r&&Ue(e,"Date",Ce(e,"Date")+r*n),i&&e._d.setTime(e._d.valueOf()+i*n),s)&&_.updateOffset(e,r||t)}C.fn=Ct.prototype,C.invalid=function(){return C(NaN)};Fe=qt(1,"add"),Qe=qt(-1,"subtract");function Bt(e){return"string"==typeof e||e instanceof String}function Jt(e){return k(e)||V(e)||Bt(e)||w(e)||function(t){var e=y(t),n=!1;e&&(n=0===t.filter(function(e){return!w(e)&&Bt(t)}).length);return e&&n}(e)||function(e){var t,n,s=F(e)&&!L(e),i=!1,r=["years","year","y","months","month","M","days","day","d","dates","date","D","hours","hour","h","minutes","minute","m","seconds","second","s","milliseconds","millisecond","ms"],a=r.length;for(t=0;t<a;t+=1)n=r[t],i=i||c(e,n);return s&&i}(e)||null==e}function Qt(e,t){var n,s;return e.date()<t.date()?-Qt(t,e):-((n=12*(t.year()-e.year())+(t.month()-e.month()))+(t-(s=e.clone().add(n,"months"))<0?(t-s)/(s-e.clone().add(n-1,"months")):(t-s)/(e.clone().add(1+n,"months")-s)))||0}function Xt(e){return void 0===e?this._locale._abbr:(null!=(e=P(e))&&(this._locale=e),this)}_.defaultFormat="YYYY-MM-DDTHH:mm:ssZ",_.defaultFormatUtc="YYYY-MM-DDTHH:mm:ss[Z]";Ke=e("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",function(e){return void 0===e?this.localeData():this.locale(e)});function Kt(){return this._locale}var en=126227808e5;function tn(e,t){return(e%t+t)%t}function nn(e,t,n){return e<100&&0<=e?new Date(e+400,t,n)-en:new Date(e,t,n).valueOf()}function sn(e,t,n){return e<100&&0<=e?Date.UTC(e+400,t,n)-en:Date.UTC(e,t,n)}function rn(e,t){return t.erasAbbrRegex(e)}function an(){for(var e,t,n,s=[],i=[],r=[],a=[],o=this.eras(),u=0,l=o.length;u<l;++u)e=f(o[u].name),t=f(o[u].abbr),n=f(o[u].narrow),i.push(e),s.push(t),r.push(n),a.push(e),a.push(t),a.push(n);this._erasRegex=new RegExp("^("+a.join("|")+")","i"),this._erasNameRegex=new RegExp("^("+i.join("|")+")","i"),this._erasAbbrRegex=new RegExp("^("+s.join("|")+")","i"),this._erasNarrowRegex=new RegExp("^("+r.join("|")+")","i")}function on(e,t){s(0,[e,e.length],0,t)}function un(e,t,n,s,i){var r;return null==e?Be(this,s,i).year:(r=N(e,s,i),function(e,t,n,s,i){e=$e(e,t,n,s,i),t=ze(e.year,0,e.dayOfYear);return this.year(t.getUTCFullYear()),this.month(t.getUTCMonth()),this.date(t.getUTCDate()),this}.call(this,e,t=r<t?r:t,n,s,i))}s("N",0,0,"eraAbbr"),s("NN",0,0,"eraAbbr"),s("NNN",0,0,"eraAbbr"),s("NNNN",0,0,"eraName"),s("NNNNN",0,0,"eraNarrow"),s("y",["y",1],"yo","eraYear"),s("y",["yy",2],0,"eraYear"),s("y",["yyy",3],0,"eraYear"),s("y",["yyyy",4],0,"eraYear"),h("N",rn),h("NN",rn),h("NNN",rn),h("NNNN",function(e,t){return t.erasNameRegex(e)}),h("NNNNN",function(e,t){return t.erasNarrowRegex(e)}),v(["N","NN","NNN","NNNN","NNNNN"],function(e,t,n,s){s=n._locale.erasParse(e,s,n._strict);s?p(n).era=s:p(n).invalidEra=e}),h("y",pe),h("yy",pe),h("yyy",pe),h("yyyy",pe),h("yo",function(e,t){return t._eraYearOrdinalRegex||pe}),v(["y","yy","yyy","yyyy"],D),v(["yo"],function(e,t,n,s){var i;n._locale._eraYearOrdinalRegex&&(i=e.match(n._locale._eraYearOrdinalRegex)),n._locale.eraYearOrdinalParse?t[D]=n._locale.eraYearOrdinalParse(e,i):t[D]=parseInt(e,10)}),s(0,["gg",2],0,function(){return this.weekYear()%100}),s(0,["GG",2],0,function(){return this.isoWeekYear()%100}),on("gggg","weekYear"),on("ggggg","weekYear"),on("GGGG","isoWeekYear"),on("GGGGG","isoWeekYear"),h("G",ke),h("g",ke),h("GG",n,t),h("gg",n,t),h("GGGG",ge,ce),h("gggg",ge,ce),h("GGGGG",we,fe),h("ggggg",we,fe),Oe(["gggg","ggggg","GGGG","GGGGG"],function(e,t,n,s){t[s.substr(0,2)]=M(e)}),Oe(["gg","GG"],function(e,t,n,s){t[s]=_.parseTwoDigitYear(e)}),s("Q",0,"Qo","quarter"),h("Q",de),v("Q",function(e,t){t[Y]=3*(M(e)-1)}),s("D",["DD",2],"Do","date"),h("D",n,u),h("DD",n,t),h("Do",function(e,t){return e?t._dayOfMonthOrdinalParse||t._ordinalParse:t._dayOfMonthOrdinalParseLenient}),v(["D","DD"],S),v("Do",function(e,t){t[S]=M(e.match(n)[0])});ge=Re("Date",!0);s("DDD",["DDDD",3],"DDDo","dayOfYear"),h("DDD",ye),h("DDDD",he),v(["DDD","DDDD"],function(e,t,n){n._dayOfYear=M(e)}),s("m",["mm",2],0,"minute"),h("m",n,d),h("mm",n,t),v(["m","mm"],b);var ln,ce=Re("Minutes",!1),we=(s("s",["ss",2],0,"second"),h("s",n,d),h("ss",n,t),v(["s","ss"],T),Re("Seconds",!1));for(s("S",0,0,function(){return~~(this.millisecond()/100)}),s(0,["SS",2],0,function(){return~~(this.millisecond()/10)}),s(0,["SSS",3],0,"millisecond"),s(0,["SSSS",4],0,function(){return 10*this.millisecond()}),s(0,["SSSSS",5],0,function(){return 100*this.millisecond()}),s(0,["SSSSSS",6],0,function(){return 1e3*this.millisecond()}),s(0,["SSSSSSS",7],0,function(){return 1e4*this.millisecond()}),s(0,["SSSSSSSS",8],0,function(){return 1e5*this.millisecond()}),s(0,["SSSSSSSSS",9],0,function(){return 1e6*this.millisecond()}),h("S",ye,de),h("SS",ye,t),h("SSS",ye,he),ln="SSSS";ln.length<=9;ln+="S")h(ln,pe);function dn(e,t){t[Te]=M(1e3*("0."+e))}for(ln="S";ln.length<=9;ln+="S")v(ln,dn);fe=Re("Milliseconds",!1),s("z",0,0,"zoneAbbr"),s("zz",0,0,"zoneName");u=$.prototype;function hn(e){return e}u.add=Fe,u.calendar=function(e,t){1===arguments.length&&(arguments[0]?Jt(arguments[0])?(e=arguments[0],t=void 0):function(e){for(var t=F(e)&&!L(e),n=!1,s=["sameDay","nextDay","lastDay","nextWeek","lastWeek","sameElse"],i=0;i<s.length;i+=1)n=n||c(e,s[i]);return t&&n}(arguments[0])&&(t=arguments[0],e=void 0):t=e=void 0);var e=e||R(),n=Gt(e,this).startOf("day"),n=_.calendarFormat(this,n)||"sameElse",t=t&&(a(t[n])?t[n].call(this,e):t[n]);return this.format(t||this.localeData().calendar(n,this,R(e)))},u.clone=function(){return new $(this)},u.diff=function(e,t,n){var s,i,r;if(!this.isValid())return NaN;if(!(s=Gt(e,this)).isValid())return NaN;switch(i=6e4*(s.utcOffset()-this.utcOffset()),t=o(t)){case"year":r=Qt(this,s)/12;break;case"month":r=Qt(this,s);break;case"quarter":r=Qt(this,s)/3;break;case"second":r=(this-s)/1e3;break;case"minute":r=(this-s)/6e4;break;case"hour":r=(this-s)/36e5;break;case"day":r=(this-s-i)/864e5;break;case"week":r=(this-s-i)/6048e5;break;default:r=this-s}return n?r:m(r)},u.endOf=function(e){var t,n;if(void 0!==(e=o(e))&&"millisecond"!==e&&this.isValid()){switch(n=this._isUTC?sn:nn,e){case"year":t=n(this.year()+1,0,1)-1;break;case"quarter":t=n(this.year(),this.month()-this.month()%3+3,1)-1;break;case"month":t=n(this.year(),this.month()+1,1)-1;break;case"week":t=n(this.year(),this.month(),this.date()-this.weekday()+7)-1;break;case"isoWeek":t=n(this.year(),this.month(),this.date()-(this.isoWeekday()-1)+7)-1;break;case"day":case"date":t=n(this.year(),this.month(),this.date()+1)-1;break;case"hour":t=this._d.valueOf(),t+=36e5-tn(t+(this._isUTC?0:6e4*this.utcOffset()),36e5)-1;break;case"minute":t=this._d.valueOf(),t+=6e4-tn(t,6e4)-1;break;case"second":t=this._d.valueOf(),t+=1e3-tn(t,1e3)-1;break}this._d.setTime(t),_.updateOffset(this,!0)}return this},u.format=function(e){return e=e||(this.isUtc()?_.defaultFormatUtc:_.defaultFormat),e=re(this,e),this.localeData().postformat(e)},u.from=function(e,t){return this.isValid()&&(k(e)&&e.isValid()||R(e).isValid())?C({to:this,from:e}).locale(this.locale()).humanize(!t):this.localeData().invalidDate()},u.fromNow=function(e){return this.from(R(),e)},u.to=function(e,t){return this.isValid()&&(k(e)&&e.isValid()||R(e).isValid())?C({from:this,to:e}).locale(this.locale()).humanize(!t):this.localeData().invalidDate()},u.toNow=function(e){return this.to(R(),e)},u.get=function(e){return a(this[e=o(e)])?this[e]():this},u.invalidAt=function(){return p(this).overflow},u.isAfter=function(e,t){return e=k(e)?e:R(e),!(!this.isValid()||!e.isValid())&&("millisecond"===(t=o(t)||"millisecond")?this.valueOf()>e.valueOf():e.valueOf()<this.clone().startOf(t).valueOf())},u.isBefore=function(e,t){return e=k(e)?e:R(e),!(!this.isValid()||!e.isValid())&&("millisecond"===(t=o(t)||"millisecond")?this.valueOf()<e.valueOf():this.clone().endOf(t).valueOf()<e.valueOf())},u.isBetween=function(e,t,n,s){return e=k(e)?e:R(e),t=k(t)?t:R(t),!!(this.isValid()&&e.isValid()&&t.isValid())&&("("===(s=s||"()")[0]?this.isAfter(e,n):!this.isBefore(e,n))&&(")"===s[1]?this.isBefore(t,n):!this.isAfter(t,n))},u.isSame=function(e,t){var e=k(e)?e:R(e);return!(!this.isValid()||!e.isValid())&&("millisecond"===(t=o(t)||"millisecond")?this.valueOf()===e.valueOf():(e=e.valueOf(),this.clone().startOf(t).valueOf()<=e&&e<=this.clone().endOf(t).valueOf()))},u.isSameOrAfter=function(e,t){return this.isSame(e,t)||this.isAfter(e,t)},u.isSameOrBefore=function(e,t){return this.isSame(e,t)||this.isBefore(e,t)},u.isValid=function(){return A(this)},u.lang=Ke,u.locale=Xt,u.localeData=Kt,u.max=_e,u.min=me,u.parsingFlags=function(){return E({},p(this))},u.set=function(e,t){if("object"==typeof e)for(var n=function(e){var t,n=[];for(t in e)c(e,t)&&n.push({unit:t,priority:le[t]});return n.sort(function(e,t){return e.priority-t.priority}),n}(e=ue(e)),s=n.length,i=0;i<s;i++)this[n[i].unit](e[n[i].unit]);else if(a(this[e=o(e)]))return this[e](t);return this},u.startOf=function(e){var t,n;if(void 0!==(e=o(e))&&"millisecond"!==e&&this.isValid()){switch(n=this._isUTC?sn:nn,e){case"year":t=n(this.year(),0,1);break;case"quarter":t=n(this.year(),this.month()-this.month()%3,1);break;case"month":t=n(this.year(),this.month(),1);break;case"week":t=n(this.year(),this.month(),this.date()-this.weekday());break;case"isoWeek":t=n(this.year(),this.month(),this.date()-(this.isoWeekday()-1));break;case"day":case"date":t=n(this.year(),this.month(),this.date());break;case"hour":t=this._d.valueOf(),t-=tn(t+(this._isUTC?0:6e4*this.utcOffset()),36e5);break;case"minute":t=this._d.valueOf(),t-=tn(t,6e4);break;case"second":t=this._d.valueOf(),t-=tn(t,1e3);break}this._d.setTime(t),_.updateOffset(this,!0)}return this},u.subtract=Qe,u.toArray=function(){var e=this;return[e.year(),e.month(),e.date(),e.hour(),e.minute(),e.second(),e.millisecond()]},u.toObject=function(){var e=this;return{years:e.year(),months:e.month(),date:e.date(),hours:e.hours(),minutes:e.minutes(),seconds:e.seconds(),milliseconds:e.milliseconds()}},u.toDate=function(){return new Date(this.valueOf())},u.toISOString=function(e){var t;return this.isValid()?(t=(e=!0!==e)?this.clone().utc():this).year()<0||9999<t.year()?re(t,e?"YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]":"YYYYYY-MM-DD[T]HH:mm:ss.SSSZ"):a(Date.prototype.toISOString)?e?this.toDate().toISOString():new Date(this.valueOf()+60*this.utcOffset()*1e3).toISOString().replace("Z",re(t,"Z")):re(t,e?"YYYY-MM-DD[T]HH:mm:ss.SSS[Z]":"YYYY-MM-DD[T]HH:mm:ss.SSSZ"):null},u.inspect=function(){var e,t,n;return this.isValid()?(t="moment",e="",this.isLocal()||(t=0===this.utcOffset()?"moment.utc":"moment.parseZone",e="Z"),t="["+t+'("]',n=0<=this.year()&&this.year()<=9999?"YYYY":"YYYYYY",this.format(t+n+"-MM-DD[T]HH:mm:ss.SSS"+(e+'[")]'))):"moment.invalid(/* "+this._i+" */)"},"undefined"!=typeof Symbol&&null!=Symbol.for&&(u[Symbol.for("nodejs.util.inspect.custom")]=function(){return"Moment<"+this.format()+">"}),u.toJSON=function(){return this.isValid()?this.toISOString():null},u.toString=function(){return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ")},u.unix=function(){return Math.floor(this.valueOf()/1e3)},u.valueOf=function(){return this._d.valueOf()-6e4*(this._offset||0)},u.creationData=function(){return{input:this._i,format:this._f,locale:this._locale,isUTC:this._isUTC,strict:this._strict}},u.eraName=function(){for(var e,t=this.localeData().eras(),n=0,s=t.length;n<s;++n){if(e=this.clone().startOf("day").valueOf(),t[n].since<=e&&e<=t[n].until)return t[n].name;if(t[n].until<=e&&e<=t[n].since)return t[n].name}return""},u.eraNarrow=function(){for(var e,t=this.localeData().eras(),n=0,s=t.length;n<s;++n){if(e=this.clone().startOf("day").valueOf(),t[n].since<=e&&e<=t[n].until)return t[n].narrow;if(t[n].until<=e&&e<=t[n].since)return t[n].narrow}return""},u.eraAbbr=function(){for(var e,t=this.localeData().eras(),n=0,s=t.length;n<s;++n){if(e=this.clone().startOf("day").valueOf(),t[n].since<=e&&e<=t[n].until)return t[n].abbr;if(t[n].until<=e&&e<=t[n].since)return t[n].abbr}return""},u.eraYear=function(){for(var e,t,n=this.localeData().eras(),s=0,i=n.length;s<i;++s)if(e=n[s].since<=n[s].until?1:-1,t=this.clone().startOf("day").valueOf(),n[s].since<=t&&t<=n[s].until||n[s].until<=t&&t<=n[s].since)return(this.year()-_(n[s].since).year())*e+n[s].offset;return this.year()},u.year=Pe,u.isLeapYear=function(){return be(this.year())},u.weekYear=function(e){return un.call(this,e,this.week(),this.weekday()+this.localeData()._week.dow,this.localeData()._week.dow,this.localeData()._week.doy)},u.isoWeekYear=function(e){return un.call(this,e,this.isoWeek(),this.isoWeekday(),1,4)},u.quarter=u.quarters=function(e){return null==e?Math.ceil((this.month()+1)/3):this.month(3*(e-1)+this.month()%3)},u.month=Ie,u.daysInMonth=function(){return He(this.year(),this.month())},u.week=u.weeks=function(e){var t=this.localeData().week(this);return null==e?t:this.add(7*(e-t),"d")},u.isoWeek=u.isoWeeks=function(e){var t=Be(this,1,4).week;return null==e?t:this.add(7*(e-t),"d")},u.weeksInYear=function(){var e=this.localeData()._week;return N(this.year(),e.dow,e.doy)},u.weeksInWeekYear=function(){var e=this.localeData()._week;return N(this.weekYear(),e.dow,e.doy)},u.isoWeeksInYear=function(){return N(this.year(),1,4)},u.isoWeeksInISOWeekYear=function(){return N(this.isoWeekYear(),1,4)},u.date=ge,u.day=u.days=function(e){var t,n,s;return this.isValid()?(t=Ce(this,"Day"),null!=e?(n=e,s=this.localeData(),e="string"!=typeof n?n:isNaN(n)?"number"==typeof(n=s.weekdaysParse(n))?n:null:parseInt(n,10),this.add(e-t,"d")):t):null!=e?this:NaN},u.weekday=function(e){var t;return this.isValid()?(t=(this.day()+7-this.localeData()._week.dow)%7,null==e?t:this.add(e-t,"d")):null!=e?this:NaN},u.isoWeekday=function(e){var t,n;return this.isValid()?null!=e?(t=e,n=this.localeData(),n="string"==typeof t?n.weekdaysParse(t)%7||7:isNaN(t)?null:t,this.day(this.day()%7?n:n-7)):this.day()||7:null!=e?this:NaN},u.dayOfYear=function(e){var t=Math.round((this.clone().startOf("day")-this.clone().startOf("year"))/864e5)+1;return null==e?t:this.add(e-t,"d")},u.hour=u.hours=i,u.minute=u.minutes=ce,u.second=u.seconds=we,u.millisecond=u.milliseconds=fe,u.utcOffset=function(e,t,n){var s,i=this._offset||0;if(!this.isValid())return null!=e?this:NaN;if(null==e)return this._isUTC?i:Et(this);if("string"==typeof e){if(null===(e=Vt(ve,e)))return this}else Math.abs(e)<16&&!n&&(e*=60);return!this._isUTC&&t&&(s=Et(this)),this._offset=e,this._isUTC=!0,null!=s&&this.add(s,"m"),i!==e&&(!t||this._changeInProgress?$t(this,C(e-i,"m"),1,!1):this._changeInProgress||(this._changeInProgress=!0,_.updateOffset(this,!0),this._changeInProgress=null)),this},u.utc=function(e){return this.utcOffset(0,e)},u.local=function(e){return this._isUTC&&(this.utcOffset(0,e),this._isUTC=!1,e)&&this.subtract(Et(this),"m"),this},u.parseZone=function(){var e;return null!=this._tzm?this.utcOffset(this._tzm,!1,!0):"string"==typeof this._i&&(null!=(e=Vt(Me,this._i))?this.utcOffset(e):this.utcOffset(0,!0)),this},u.hasAlignedHourOffset=function(e){return!!this.isValid()&&(e=e?R(e).utcOffset():0,(this.utcOffset()-e)%60==0)},u.isDST=function(){return this.utcOffset()>this.clone().month(0).utcOffset()||this.utcOffset()>this.clone().month(5).utcOffset()},u.isLocal=function(){return!!this.isValid()&&!this._isUTC},u.isUtcOffset=function(){return!!this.isValid()&&this._isUTC},u.isUtc=At,u.isUTC=At,u.zoneAbbr=function(){return this._isUTC?"UTC":""},u.zoneName=function(){return this._isUTC?"Coordinated Universal Time":""},u.dates=e("dates accessor is deprecated. Use date instead.",ge),u.months=e("months accessor is deprecated. Use month instead",Ie),u.years=e("years accessor is deprecated. Use year instead",Pe),u.zone=e("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",function(e,t){return null!=e?(this.utcOffset(e="string"!=typeof e?-e:e,t),this):-this.utcOffset()}),u.isDSTShifted=e("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",function(){var e,t;return g(this._isDSTShifted)&&(q(e={},this),(e=Nt(e))._a?(t=(e._isUTC?l:R)(e._a),this._isDSTShifted=this.isValid()&&0<function(e,t,n){for(var s=Math.min(e.length,t.length),i=Math.abs(e.length-t.length),r=0,a=0;a<s;a++)(n&&e[a]!==t[a]||!n&&M(e[a])!==M(t[a]))&&r++;return r+i}(e._a,t.toArray())):this._isDSTShifted=!1),this._isDSTShifted});d=K.prototype;function cn(e,t,n,s){var i=P(),s=l().set(s,t);return i[n](s,e)}function fn(e,t,n){if(w(e)&&(t=e,e=void 0),e=e||"",null!=t)return cn(e,t,n,"month");for(var s=[],i=0;i<12;i++)s[i]=cn(e,i,n,"month");return s}function mn(e,t,n,s){t=("boolean"==typeof e?w(t)&&(n=t,t=void 0):(t=e,e=!1,w(n=t)&&(n=t,t=void 0)),t||"");var i,r=P(),a=e?r._week.dow:0,o=[];if(null!=n)return cn(t,(n+a)%7,s,"day");for(i=0;i<7;i++)o[i]=cn(t,(i+a)%7,s,"day");return o}d.calendar=function(e,t,n){return a(e=this._calendar[e]||this._calendar.sameElse)?e.call(t,n):e},d.longDateFormat=function(e){var t=this._longDateFormat[e],n=this._longDateFormat[e.toUpperCase()];return t||!n?t:(this._longDateFormat[e]=n.match(te).map(function(e){return"MMMM"===e||"MM"===e||"DD"===e||"dddd"===e?e.slice(1):e}).join(""),this._longDateFormat[e])},d.invalidDate=function(){return this._invalidDate},d.ordinal=function(e){return this._ordinal.replace("%d",e)},d.preparse=hn,d.postformat=hn,d.relativeTime=function(e,t,n,s){var i=this._relativeTime[n];return a(i)?i(e,t,n,s):i.replace(/%d/i,e)},d.pastFuture=function(e,t){return a(e=this._relativeTime[0<e?"future":"past"])?e(t):e.replace(/%s/i,t)},d.set=function(e){var t,n;for(n in e)c(e,n)&&(a(t=e[n])?this[n]=t:this["_"+n]=t);this._config=e,this._dayOfMonthOrdinalParseLenient=new RegExp((this._dayOfMonthOrdinalParse.source||this._ordinalParse.source)+"|"+/\d{1,2}/.source)},d.eras=function(e,t){for(var n,s=this._eras||P("en")._eras,i=0,r=s.length;i<r;++i){switch(typeof s[i].since){case"string":n=_(s[i].since).startOf("day"),s[i].since=n.valueOf();break}switch(typeof s[i].until){case"undefined":s[i].until=1/0;break;case"string":n=_(s[i].until).startOf("day").valueOf(),s[i].until=n.valueOf();break}}return s},d.erasParse=function(e,t,n){var s,i,r,a,o,u=this.eras();for(e=e.toUpperCase(),s=0,i=u.length;s<i;++s)if(r=u[s].name.toUpperCase(),a=u[s].abbr.toUpperCase(),o=u[s].narrow.toUpperCase(),n)switch(t){case"N":case"NN":case"NNN":if(a===e)return u[s];break;case"NNNN":if(r===e)return u[s];break;case"NNNNN":if(o===e)return u[s];break}else if(0<=[r,a,o].indexOf(e))return u[s]},d.erasConvertYear=function(e,t){var n=e.since<=e.until?1:-1;return void 0===t?_(e.since).year():_(e.since).year()+(t-e.offset)*n},d.erasAbbrRegex=function(e){return c(this,"_erasAbbrRegex")||an.call(this),e?this._erasAbbrRegex:this._erasRegex},d.erasNameRegex=function(e){return c(this,"_erasNameRegex")||an.call(this),e?this._erasNameRegex:this._erasRegex},d.erasNarrowRegex=function(e){return c(this,"_erasNarrowRegex")||an.call(this),e?this._erasNarrowRegex:this._erasRegex},d.months=function(e,t){return e?(y(this._months)?this._months:this._months[(this._months.isFormat||Ve).test(t)?"format":"standalone"])[e.month()]:y(this._months)?this._months:this._months.standalone},d.monthsShort=function(e,t){return e?(y(this._monthsShort)?this._monthsShort:this._monthsShort[Ve.test(t)?"format":"standalone"])[e.month()]:y(this._monthsShort)?this._monthsShort:this._monthsShort.standalone},d.monthsParse=function(e,t,n){var s,i;if(this._monthsParseExact)return function(e,t,n){var s,i,r,e=e.toLocaleLowerCase();if(!this._monthsParse)for(this._monthsParse=[],this._longMonthsParse=[],this._shortMonthsParse=[],s=0;s<12;++s)r=l([2e3,s]),this._shortMonthsParse[s]=this.monthsShort(r,"").toLocaleLowerCase(),this._longMonthsParse[s]=this.months(r,"").toLocaleLowerCase();return n?"MMM"===t?-1!==(i=x.call(this._shortMonthsParse,e))?i:null:-1!==(i=x.call(this._longMonthsParse,e))?i:null:"MMM"===t?-1!==(i=x.call(this._shortMonthsParse,e))||-1!==(i=x.call(this._longMonthsParse,e))?i:null:-1!==(i=x.call(this._longMonthsParse,e))||-1!==(i=x.call(this._shortMonthsParse,e))?i:null}.call(this,e,t,n);for(this._monthsParse||(this._monthsParse=[],this._longMonthsParse=[],this._shortMonthsParse=[]),s=0;s<12;s++){if(i=l([2e3,s]),n&&!this._longMonthsParse[s]&&(this._longMonthsParse[s]=new RegExp("^"+this.months(i,"").replace(".","")+"$","i"),this._shortMonthsParse[s]=new RegExp("^"+this.monthsShort(i,"").replace(".","")+"$","i")),n||this._monthsParse[s]||(i="^"+this.months(i,"")+"|^"+this.monthsShort(i,""),this._monthsParse[s]=new RegExp(i.replace(".",""),"i")),n&&"MMMM"===t&&this._longMonthsParse[s].test(e))return s;if(n&&"MMM"===t&&this._shortMonthsParse[s].test(e))return s;if(!n&&this._monthsParse[s].test(e))return s}},d.monthsRegex=function(e){return this._monthsParseExact?(c(this,"_monthsRegex")||je.call(this),e?this._monthsStrictRegex:this._monthsRegex):(c(this,"_monthsRegex")||(this._monthsRegex=Ee),this._monthsStrictRegex&&e?this._monthsStrictRegex:this._monthsRegex)},d.monthsShortRegex=function(e){return this._monthsParseExact?(c(this,"_monthsRegex")||je.call(this),e?this._monthsShortStrictRegex:this._monthsShortRegex):(c(this,"_monthsShortRegex")||(this._monthsShortRegex=Ge),this._monthsShortStrictRegex&&e?this._monthsShortStrictRegex:this._monthsShortRegex)},d.week=function(e){return Be(e,this._week.dow,this._week.doy).week},d.firstDayOfYear=function(){return this._week.doy},d.firstDayOfWeek=function(){return this._week.dow},d.weekdays=function(e,t){return t=y(this._weekdays)?this._weekdays:this._weekdays[e&&!0!==e&&this._weekdays.isFormat.test(t)?"format":"standalone"],!0===e?Je(t,this._week.dow):e?t[e.day()]:t},d.weekdaysMin=function(e){return!0===e?Je(this._weekdaysMin,this._week.dow):e?this._weekdaysMin[e.day()]:this._weekdaysMin},d.weekdaysShort=function(e){return!0===e?Je(this._weekdaysShort,this._week.dow):e?this._weekdaysShort[e.day()]:this._weekdaysShort},d.weekdaysParse=function(e,t,n){var s,i;if(this._weekdaysParseExact)return function(e,t,n){var s,i,r,e=e.toLocaleLowerCase();if(!this._weekdaysParse)for(this._weekdaysParse=[],this._shortWeekdaysParse=[],this._minWeekdaysParse=[],s=0;s<7;++s)r=l([2e3,1]).day(s),this._minWeekdaysParse[s]=this.weekdaysMin(r,"").toLocaleLowerCase(),this._shortWeekdaysParse[s]=this.weekdaysShort(r,"").toLocaleLowerCase(),this._weekdaysParse[s]=this.weekdays(r,"").toLocaleLowerCase();return n?"dddd"===t?-1!==(i=x.call(this._weekdaysParse,e))?i:null:"ddd"===t?-1!==(i=x.call(this._shortWeekdaysParse,e))?i:null:-1!==(i=x.call(this._minWeekdaysParse,e))?i:null:"dddd"===t?-1!==(i=x.call(this._weekdaysParse,e))||-1!==(i=x.call(this._shortWeekdaysParse,e))||-1!==(i=x.call(this._minWeekdaysParse,e))?i:null:"ddd"===t?-1!==(i=x.call(this._shortWeekdaysParse,e))||-1!==(i=x.call(this._weekdaysParse,e))||-1!==(i=x.call(this._minWeekdaysParse,e))?i:null:-1!==(i=x.call(this._minWeekdaysParse,e))||-1!==(i=x.call(this._weekdaysParse,e))||-1!==(i=x.call(this._shortWeekdaysParse,e))?i:null}.call(this,e,t,n);for(this._weekdaysParse||(this._weekdaysParse=[],this._minWeekdaysParse=[],this._shortWeekdaysParse=[],this._fullWeekdaysParse=[]),s=0;s<7;s++){if(i=l([2e3,1]).day(s),n&&!this._fullWeekdaysParse[s]&&(this._fullWeekdaysParse[s]=new RegExp("^"+this.weekdays(i,"").replace(".","\\.?")+"$","i"),this._shortWeekdaysParse[s]=new RegExp("^"+this.weekdaysShort(i,"").replace(".","\\.?")+"$","i"),this._minWeekdaysParse[s]=new RegExp("^"+this.weekdaysMin(i,"").replace(".","\\.?")+"$","i")),this._weekdaysParse[s]||(i="^"+this.weekdays(i,"")+"|^"+this.weekdaysShort(i,"")+"|^"+this.weekdaysMin(i,""),this._weekdaysParse[s]=new RegExp(i.replace(".",""),"i")),n&&"dddd"===t&&this._fullWeekdaysParse[s].test(e))return s;if(n&&"ddd"===t&&this._shortWeekdaysParse[s].test(e))return s;if(n&&"dd"===t&&this._minWeekdaysParse[s].test(e))return s;if(!n&&this._weekdaysParse[s].test(e))return s}},d.weekdaysRegex=function(e){return this._weekdaysParseExact?(c(this,"_weekdaysRegex")||st.call(this),e?this._weekdaysStrictRegex:this._weekdaysRegex):(c(this,"_weekdaysRegex")||(this._weekdaysRegex=et),this._weekdaysStrictRegex&&e?this._weekdaysStrictRegex:this._weekdaysRegex)},d.weekdaysShortRegex=function(e){return this._weekdaysParseExact?(c(this,"_weekdaysRegex")||st.call(this),e?this._weekdaysShortStrictRegex:this._weekdaysShortRegex):(c(this,"_weekdaysShortRegex")||(this._weekdaysShortRegex=tt),this._weekdaysShortStrictRegex&&e?this._weekdaysShortStrictRegex:this._weekdaysShortRegex)},d.weekdaysMinRegex=function(e){return this._weekdaysParseExact?(c(this,"_weekdaysRegex")||st.call(this),e?this._weekdaysMinStrictRegex:this._weekdaysMinRegex):(c(this,"_weekdaysMinRegex")||(this._weekdaysMinRegex=nt),this._weekdaysMinStrictRegex&&e?this._weekdaysMinStrictRegex:this._weekdaysMinRegex)},d.isPM=function(e){return"p"===(e+"").toLowerCase().charAt(0)},d.meridiem=function(e,t,n){return 11<e?n?"pm":"PM":n?"am":"AM"},ft("en",{eras:[{since:"0001-01-01",until:1/0,offset:1,name:"Anno Domini",narrow:"AD",abbr:"AD"},{since:"0000-12-31",until:-1/0,offset:1,name:"Before Christ",narrow:"BC",abbr:"BC"}],dayOfMonthOrdinalParse:/\d{1,2}(th|st|nd|rd)/,ordinal:function(e){var t=e%10;return e+(1===M(e%100/10)?"th":1==t?"st":2==t?"nd":3==t?"rd":"th")}}),_.lang=e("moment.lang is deprecated. Use moment.locale instead.",ft),_.langData=e("moment.langData is deprecated. Use moment.localeData instead.",P);var _n=Math.abs;function yn(e,t,n,s){t=C(t,n);return e._milliseconds+=s*t._milliseconds,e._days+=s*t._days,e._months+=s*t._months,e._bubble()}function gn(e){return e<0?Math.floor(e):Math.ceil(e)}function wn(e){return 4800*e/146097}function pn(e){return 146097*e/4800}function kn(e){return function(){return this.as(e)}}de=kn("ms"),t=kn("s"),ye=kn("m"),he=kn("h"),Fe=kn("d"),_e=kn("w"),me=kn("M"),Qe=kn("Q"),i=kn("y"),ce=de;function Mn(e){return function(){return this.isValid()?this._data[e]:NaN}}var we=Mn("milliseconds"),fe=Mn("seconds"),ge=Mn("minutes"),Pe=Mn("hours"),d=Mn("days"),vn=Mn("months"),Dn=Mn("years");var Yn=Math.round,Sn={ss:44,s:45,m:45,h:22,d:26,w:null,M:11};function On(e,t,n,s){var i=C(e).abs(),r=Yn(i.as("s")),a=Yn(i.as("m")),o=Yn(i.as("h")),u=Yn(i.as("d")),l=Yn(i.as("M")),d=Yn(i.as("w")),i=Yn(i.as("y")),r=(r<=n.ss?["s",r]:r<n.s&&["ss",r])||(a<=1?["m"]:a<n.m&&["mm",a])||(o<=1?["h"]:o<n.h&&["hh",o])||(u<=1?["d"]:u<n.d&&["dd",u]);return(r=(r=null!=n.w?r||(d<=1?["w"]:d<n.w&&["ww",d]):r)||(l<=1?["M"]:l<n.M&&["MM",l])||(i<=1?["y"]:["yy",i]))[2]=t,r[3]=0<+e,r[4]=s,function(e,t,n,s,i){return i.relativeTime(t||1,!!n,e,s)}.apply(null,r)}var bn=Math.abs;function Tn(e){return(0<e)-(e<0)||+e}function xn(){var e,t,n,s,i,r,a,o,u,l,d;return this.isValid()?(e=bn(this._milliseconds)/1e3,t=bn(this._days),n=bn(this._months),(o=this.asSeconds())?(s=m(e/60),i=m(s/60),e%=60,s%=60,r=m(n/12),n%=12,a=e?e.toFixed(3).replace(/\.?0+$/,""):"",u=Tn(this._months)!==Tn(o)?"-":"",l=Tn(this._days)!==Tn(o)?"-":"",d=Tn(this._milliseconds)!==Tn(o)?"-":"",(o<0?"-":"")+"P"+(r?u+r+"Y":"")+(n?u+n+"M":"")+(t?l+t+"D":"")+(i||s||e?"T":"")+(i?d+i+"H":"")+(s?d+s+"M":"")+(e?d+a+"S":"")):"P0D"):this.localeData().invalidDate()}var U=Ct.prototype;return U.isValid=function(){return this._isValid},U.abs=function(){var e=this._data;return this._milliseconds=_n(this._milliseconds),this._days=_n(this._days),this._months=_n(this._months),e.milliseconds=_n(e.milliseconds),e.seconds=_n(e.seconds),e.minutes=_n(e.minutes),e.hours=_n(e.hours),e.months=_n(e.months),e.years=_n(e.years),this},U.add=function(e,t){return yn(this,e,t,1)},U.subtract=function(e,t){return yn(this,e,t,-1)},U.as=function(e){if(!this.isValid())return NaN;var t,n,s=this._milliseconds;if("month"===(e=o(e))||"quarter"===e||"year"===e)switch(t=this._days+s/864e5,n=this._months+wn(t),e){case"month":return n;case"quarter":return n/3;case"year":return n/12}else switch(t=this._days+Math.round(pn(this._months)),e){case"week":return t/7+s/6048e5;case"day":return t+s/864e5;case"hour":return 24*t+s/36e5;case"minute":return 1440*t+s/6e4;case"second":return 86400*t+s/1e3;case"millisecond":return Math.floor(864e5*t)+s;default:throw new Error("Unknown unit "+e)}},U.asMilliseconds=de,U.asSeconds=t,U.asMinutes=ye,U.asHours=he,U.asDays=Fe,U.asWeeks=_e,U.asMonths=me,U.asQuarters=Qe,U.asYears=i,U.valueOf=ce,U._bubble=function(){var e=this._milliseconds,t=this._days,n=this._months,s=this._data;return 0<=e&&0<=t&&0<=n||e<=0&&t<=0&&n<=0||(e+=864e5*gn(pn(n)+t),n=t=0),s.milliseconds=e%1e3,e=m(e/1e3),s.seconds=e%60,e=m(e/60),s.minutes=e%60,e=m(e/60),s.hours=e%24,t+=m(e/24),n+=e=m(wn(t)),t-=gn(pn(e)),e=m(n/12),n%=12,s.days=t,s.months=n,s.years=e,this},U.clone=function(){return C(this)},U.get=function(e){return e=o(e),this.isValid()?this[e+"s"]():NaN},U.milliseconds=we,U.seconds=fe,U.minutes=ge,U.hours=Pe,U.days=d,U.weeks=function(){return m(this.days()/7)},U.months=vn,U.years=Dn,U.humanize=function(e,t){var n,s;return this.isValid()?(n=!1,s=Sn,"object"==typeof e&&(t=e,e=!1),"boolean"==typeof e&&(n=e),"object"==typeof t&&(s=Object.assign({},Sn,t),null!=t.s)&&null==t.ss&&(s.ss=t.s-1),e=this.localeData(),t=On(this,!n,s,e),n&&(t=e.pastFuture(+this,t)),e.postformat(t)):this.localeData().invalidDate()},U.toISOString=xn,U.toString=xn,U.toJSON=xn,U.locale=Xt,U.localeData=Kt,U.toIsoString=e("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",xn),U.lang=Ke,s("X",0,0,"unix"),s("x",0,0,"valueOf"),h("x",ke),h("X",/[+-]?\d+(\.\d{1,3})?/),v("X",function(e,t,n){n._d=new Date(1e3*parseFloat(e))}),v("x",function(e,t,n){n._d=new Date(M(e))}),_.version="2.30.1",H=R,_.fn=u,_.min=function(){return Pt("isBefore",[].slice.call(arguments,0))},_.max=function(){return Pt("isAfter",[].slice.call(arguments,0))},_.now=function(){return Date.now?Date.now():+new Date},_.utc=l,_.unix=function(e){return R(1e3*e)},_.months=function(e,t){return fn(e,t,"months")},_.isDate=V,_.locale=ft,_.invalid=I,_.duration=C,_.isMoment=k,_.weekdays=function(e,t,n){return mn(e,t,n,"weekdays")},_.parseZone=function(){return R.apply(null,arguments).parseZone()},_.localeData=P,_.isDuration=Ut,_.monthsShort=function(e,t){return fn(e,t,"monthsShort")},_.weekdaysMin=function(e,t,n){return mn(e,t,n,"weekdaysMin")},_.defineLocale=mt,_.updateLocale=function(e,t){var n,s;return null!=t?(s=ut,null!=W[e]&&null!=W[e].parentLocale?W[e].set(X(W[e]._config,t)):(t=X(s=null!=(n=ct(e))?n._config:s,t),null==n&&(t.abbr=e),(s=new K(t)).parentLocale=W[e],W[e]=s),ft(e)):null!=W[e]&&(null!=W[e].parentLocale?(W[e]=W[e].parentLocale,e===ft()&&ft(e)):null!=W[e]&&delete W[e]),W[e]},_.locales=function(){return ee(W)},_.weekdaysShort=function(e,t,n){return mn(e,t,n,"weekdaysShort")},_.normalizeUnits=o,_.relativeTimeRounding=function(e){return void 0===e?Yn:"function"==typeof e&&(Yn=e,!0)},_.relativeTimeThreshold=function(e,t){return void 0!==Sn[e]&&(void 0===t?Sn[e]:(Sn[e]=t,"s"===e&&(Sn.ss=t-1),!0))},_.calendarFormat=function(e,t){return(e=e.diff(t,"days",!0))<-6?"sameElse":e<-1?"lastWeek":e<0?"lastDay":e<1?"sameDay":e<2?"nextDay":e<7?"nextWeek":"sameElse"},_.prototype=u,_.HTML5_FMT={DATETIME_LOCAL:"YYYY-MM-DDTHH:mm",DATETIME_LOCAL_SECONDS:"YYYY-MM-DDTHH:mm:ss",DATETIME_LOCAL_MS:"YYYY-MM-DDTHH:mm:ss.SSS",DATE:"YYYY-MM-DD",TIME:"HH:mm",TIME_SECONDS:"HH:mm:ss",TIME_MS:"HH:mm:ss.SSS",WEEK:"GGGG-[W]WW",MONTH:"YYYY-MM"},_});
//# sourceMappingURL=moment.min.js.map;
define('events/ThemeEvent',['require','exports','module'],function (require, exports, module) {
    'use strict';

    /**
     * ThemeEvent definitions.
     */
    var ThemeEvent = {};

    ThemeEvent.ERROR_UNKNOWN = 'error-unknown';
    ThemeEvent.ERROR_ZIP_NOT_FOUND = 'error-zip-not-found';
    ThemeEvent.ERROR_ADD_TO_CART = 'error-add-to-cart';
    ThemeEvent.ERROR_ADD_TO_FAVORITES = 'error-add-to-favorites';
    ThemeEvent.ERROR_FETCH_USER = 'error-fetch-user';
    ThemeEvent.ERROR_FETCH_DELIVERY_DATES = 'error-fetch-delivery-dates';
    ThemeEvent.ERROR_SAVE_DELIVERY_DATES = 'error-save-delivery-dates';
    ThemeEvent.ERROR_CHECK_TOKEN = 'error-check-token';
    ThemeEvent.ERROR_UNAUTHORIZED = 'error-unauthorized';
    ThemeEvent.ERROR_FETCH_FAVORITES = 'error-fetch-favorites';


    ThemeEvent.LOGIN_COMPLETE = 'login-complete'; // global
    ThemeEvent.LOGIN_1ST_STEP_COMPLETE = 'login-1st-step-complete';
    ThemeEvent.LOGIN_2ND_STEP_COMPLETE = 'login-2nd-step-complete';
    ThemeEvent.FORGOT_PASSWORD_COMPLETE = 'forgot-password-complete';
    ThemeEvent.CHECK_ZIP_COMPLETE = 'check-zip-complete';
    ThemeEvent.FETCH_CART_COMPLETE = 'fech-cart-complete';
    ThemeEvent.ADD_TO_CART_COMPLETE = 'add-to-cart-complete';
    ThemeEvent.ADD_TO_FAVORITES_COMPLETE = 'add-to-favorites-complete';
    ThemeEvent.FETCH_RECOMMENDED_PRODUCTS_COMPLETE = 'fetch-recommended-products-complete';
    ThemeEvent.FETCH_DELIVERY_DATES_COMPLETE = 'fetch-delivery-dates-complete';
    ThemeEvent.FETCH_PRODUCTS_COMPLETE = 'fetch-products-complete';
    ThemeEvent.FETCH_FAVORITES_COMPLETE = 'fetch-favorites-complete';
    ThemeEvent.SAVE_DELIVERY_DATES_COMPLETE = 'save-delivery-dates-complete';
    ThemeEvent.FETCH_USER_COMPLETE = 'fetch-user-complete';
    ThemeEvent.CHECK_TOKEN_COMPLETE = 'check-token-complete';

    ThemeEvent.CHECK_ZIP_UNVERIFYED = 'check-zip-unverifyed';

    ThemeEvent.LOGIN_CANCELLED = 'login-cancelled'; // global

    ThemeEvent.MODULE_LOGIN_RESIZE = 'module-login-resize'; // global
    ThemeEvent.MODULE_LOGIN_RESIZE_WRAPPER = 'module-login-resize-wrapper'; // global

    ThemeEvent.SHOW_AUTH_TOKEN_EXPIRED = 'show-auth-token-expired'; // global

    ThemeEvent.REFRESH_CART = 'refresh-cart'; // global
    ThemeEvent.REFRESH_COUNTDOWN = 'refresh-countdown'; // global
    ThemeEvent.ADD_TO_CART = 'add-to-cart'; // global
    ThemeEvent.ADD_TO_FAVORITES = 'add-to-favorites'; // global
    ThemeEvent.THEME_RENDERED = 'theme-rendered'; // global
    ThemeEvent.RESTRICTED_ACCESS = 'restricted-access';
    ThemeEvent.RESTRICTED_ACCESS_COMPLETE = 'restricted-access-complete';
    ThemeEvent.APPEND_CONFIRMATION_CODE = 'append-confirmation-code';
    ThemeEvent.APPEND_CONFIRMATION_CODE_COMPLETE = 'append-confirmation-code-complete';

    ThemeEvent.getTransitionEvent = function() {
        if (ThemeEvent.transitionEvent) {
            return ThemeEvent.transitionEvent;
        }

        var t,
            el = document.createElement('element'),
            transitions = {
            'transition'      : 'transitionend',
            'OTransition'     : 'oTransitionEnd',
            'MozTransition'   : 'transitionend',
            'WebkitTransition': 'webkitTransitionEnd',
        };

        for (t in transitions) {
            if (el.style[t] !== undefined) {
                return transitions[t];
            }
        }
    };

    module.exports = ThemeEvent;
});

/**
 * @version 1.0.2
 *
 * Provide a Authentication object with several functions.
 */
(function (root, factory) {
    // Set up Constructor appropriately for the environment.
    if (typeof define === 'function' && define.amd) {
        // Start with AMD.
        define(
            'libs/Authentication',['exports'],
            function (exports) {
                return factory(root, exports);
            }
        );
    } else if (typeof exports !== 'undefined') {
        // Next for Node.js or CommonJS.
        factory(root, exports);
    } else {
        // Finally, as a browser global.
        root.Authentication = factory(root, {});
    }
}(this, function (root, exports) {
    'use strict';

    var Authentication = {};

    Authentication.parseWwwAuthenticate = function(jqXHR) {
        var response = jqXHR.getResponseHeader('www-authenticate');
        var result = null;
        var credentials = {};

        credentials.realm = '';
        credentials.nonce = '';
        credentials.opaque = '';

        if (result = (new RegExp('realm="([^\"]*\)"')).exec(response)) {
            credentials.realm = result[1];
        }

        if (result = (new RegExp('nonce="([^\"]*\)"')).exec(response)) {
            credentials.nonce = result[1];
        }

        if (result = (new RegExp('opaque="([^\"]*\)"')).exec(response)) {
            credentials.opaque = result[1];
        }

        return credentials;
    };

    Authentication.getNc = function(nc) {
        var nc = nc ? parseInt(nc) : 0;

        var input = String(nc + 1);
        var length = 8,
            fill = '0';

        if (input.length <= length) {
            // Create a string with fill.
            var block = '';
            while (block.length < length) {
                block = fill + block;
            }

            // Slice the string. E.g.: for input = 65, length = 3, input will be 065.
            input = (block + input).slice(-length);
        }

        nc = input;

        return nc;
    };

    Authentication.getAuthorization = function(nc, credentials, method, uri) {
        var username = 'typo';
        var password = 'v-?HvcG6R_jvhM97';
        var realm = credentials.realm;
        var nc = nc;
        var nonce = credentials.nonce;
        var cnonce = Authentication.generateCnonce();
        var opaque = credentials.opaque;
        var qop = 'auth';

        var ha1 = CryptoJS.MD5(username + ':' + realm + ':' + password);
        var ha2 = CryptoJS.MD5(method + ':' + uri);
        var response = CryptoJS.MD5(ha1 + ':' + nonce + ':' + nc + ':' + cnonce + ':' + qop + ':' + ha2);

        var authorization = 'Digest username="' + username + '",'
            + ' realm="' + realm + '",'
            + ' nonce="' + nonce + '",'
            + ' uri="' + uri + '",'
            + ' qop=' + qop + ','
            + ' nc=' + nc + ','
            + ' cnonce="' + cnonce + '",'
            + ' response="' + response + '",'
            + ' opaque="' + opaque + '"';

        return authorization;
    };

    Authentication.generateCnonce = function() {
        var cnonceChars = 'abcdef0123456789';
        var cnonce = '';
        for (var i = 0; i < 8; i++) {
            var randNum = Math.floor(Math.random() * cnonceChars.length);
            cnonce += cnonceChars.substr(randNum, 1);
        }
        return cnonce;
    };

    return Authentication;
}));
/*
CryptoJS v3.1.2
code.google.com/p/crypto-js
(c) 2009-2013 by Jeff Mott. All rights reserved.
code.google.com/p/crypto-js/wiki/License
*/
/**
 * CryptoJS core components.
 */
var CryptoJS = CryptoJS || (function (Math, undefined) {
    /**
     * CryptoJS namespace.
     */
    var C = {};

    /**
     * Library namespace.
     */
    var C_lib = C.lib = {};

    /**
     * Base object for prototypal inheritance.
     */
    var Base = C_lib.Base = (function () {
        function F() {}

        return {
            /**
             * Creates a new object that inherits from this object.
             *
             * @param {Object} overrides Properties to copy into the new object.
             *
             * @return {Object} The new object.
             *
             * @static
             *
             * @example
             *
             *     var MyType = CryptoJS.lib.Base.extend({
             *         field: 'value',
             *
             *         method: function () {
             *         }
             *     });
             */
            extend: function (overrides) {
                // Spawn
                F.prototype = this;
                var subtype = new F();

                // Augment
                if (overrides) {
                    subtype.mixIn(overrides);
                }

                // Create default initializer
                if (!subtype.hasOwnProperty('init')) {
                    subtype.init = function () {
                        subtype.$super.init.apply(this, arguments);
                    };
                }

                // Initializer's prototype is the subtype object
                subtype.init.prototype = subtype;

                // Reference supertype
                subtype.$super = this;

                return subtype;
            },

            /**
             * Extends this object and runs the init method.
             * Arguments to create() will be passed to init().
             *
             * @return {Object} The new object.
             *
             * @static
             *
             * @example
             *
             *     var instance = MyType.create();
             */
            create: function () {
                var instance = this.extend();
                instance.init.apply(instance, arguments);

                return instance;
            },

            /**
             * Initializes a newly created object.
             * Override this method to add some logic when your objects are created.
             *
             * @example
             *
             *     var MyType = CryptoJS.lib.Base.extend({
             *         init: function () {
             *             // ...
             *         }
             *     });
             */
            init: function () {
            },

            /**
             * Copies properties into this object.
             *
             * @param {Object} properties The properties to mix in.
             *
             * @example
             *
             *     MyType.mixIn({
             *         field: 'value'
             *     });
             */
            mixIn: function (properties) {
                for (var propertyName in properties) {
                    if (properties.hasOwnProperty(propertyName)) {
                        this[propertyName] = properties[propertyName];
                    }
                }

                // IE won't copy toString using the loop above
                if (properties.hasOwnProperty('toString')) {
                    this.toString = properties.toString;
                }
            },

            /**
             * Creates a copy of this object.
             *
             * @return {Object} The clone.
             *
             * @example
             *
             *     var clone = instance.clone();
             */
            clone: function () {
                return this.init.prototype.extend(this);
            }
        };
    }());

    /**
     * An array of 32-bit words.
     *
     * @property {Array} words The array of 32-bit words.
     * @property {number} sigBytes The number of significant bytes in this word array.
     */
    var WordArray = C_lib.WordArray = Base.extend({
        /**
         * Initializes a newly created word array.
         *
         * @param {Array} words (Optional) An array of 32-bit words.
         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
         *
         * @example
         *
         *     var wordArray = CryptoJS.lib.WordArray.create();
         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
         */
        init: function (words, sigBytes) {
            words = this.words = words || [];

            if (sigBytes != undefined) {
                this.sigBytes = sigBytes;
            } else {
                this.sigBytes = words.length * 4;
            }
        },

        /**
         * Converts this word array to a string.
         *
         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
         *
         * @return {string} The stringified word array.
         *
         * @example
         *
         *     var string = wordArray + '';
         *     var string = wordArray.toString();
         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
         */
        toString: function (encoder) {
            return (encoder || Hex).stringify(this);
        },

        /**
         * Concatenates a word array to this word array.
         *
         * @param {WordArray} wordArray The word array to append.
         *
         * @return {WordArray} This word array.
         *
         * @example
         *
         *     wordArray1.concat(wordArray2);
         */
        concat: function (wordArray) {
            // Shortcuts
            var thisWords = this.words;
            var thatWords = wordArray.words;
            var thisSigBytes = this.sigBytes;
            var thatSigBytes = wordArray.sigBytes;

            // Clamp excess bits
            this.clamp();

            // Concat
            if (thisSigBytes % 4) {
                // Copy one byte at a time
                for (var i = 0; i < thatSigBytes; i++) {
                    var thatByte = (thatWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
                    thisWords[(thisSigBytes + i) >>> 2] |= thatByte << (24 - ((thisSigBytes + i) % 4) * 8);
                }
            } else if (thatWords.length > 0xffff) {
                // Copy one word at a time
                for (var i = 0; i < thatSigBytes; i += 4) {
                    thisWords[(thisSigBytes + i) >>> 2] = thatWords[i >>> 2];
                }
            } else {
                // Copy all words at once
                thisWords.push.apply(thisWords, thatWords);
            }
            this.sigBytes += thatSigBytes;

            // Chainable
            return this;
        },

        /**
         * Removes insignificant bits.
         *
         * @example
         *
         *     wordArray.clamp();
         */
        clamp: function () {
            // Shortcuts
            var words = this.words;
            var sigBytes = this.sigBytes;

            // Clamp
            words[sigBytes >>> 2] &= 0xffffffff << (32 - (sigBytes % 4) * 8);
            words.length = Math.ceil(sigBytes / 4);
        },

        /**
         * Creates a copy of this word array.
         *
         * @return {WordArray} The clone.
         *
         * @example
         *
         *     var clone = wordArray.clone();
         */
        clone: function () {
            var clone = Base.clone.call(this);
            clone.words = this.words.slice(0);

            return clone;
        },

        /**
         * Creates a word array filled with random bytes.
         *
         * @param {number} nBytes The number of random bytes to generate.
         *
         * @return {WordArray} The random word array.
         *
         * @static
         *
         * @example
         *
         *     var wordArray = CryptoJS.lib.WordArray.random(16);
         */
        random: function (nBytes) {
            var words = [];
            for (var i = 0; i < nBytes; i += 4) {
                words.push((Math.random() * 0x100000000) | 0);
            }

            return new WordArray.init(words, nBytes);
        }
    });

    /**
     * Encoder namespace.
     */
    var C_enc = C.enc = {};

    /**
     * Hex encoding strategy.
     */
    var Hex = C_enc.Hex = {
        /**
         * Converts a word array to a hex string.
         *
         * @param {WordArray} wordArray The word array.
         *
         * @return {string} The hex string.
         *
         * @static
         *
         * @example
         *
         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
         */
        stringify: function (wordArray) {
            // Shortcuts
            var words = wordArray.words;
            var sigBytes = wordArray.sigBytes;

            // Convert
            var hexChars = [];
            for (var i = 0; i < sigBytes; i++) {
                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
                hexChars.push((bite >>> 4).toString(16));
                hexChars.push((bite & 0x0f).toString(16));
            }

            return hexChars.join('');
        },

        /**
         * Converts a hex string to a word array.
         *
         * @param {string} hexStr The hex string.
         *
         * @return {WordArray} The word array.
         *
         * @static
         *
         * @example
         *
         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
         */
        parse: function (hexStr) {
            // Shortcut
            var hexStrLength = hexStr.length;

            // Convert
            var words = [];
            for (var i = 0; i < hexStrLength; i += 2) {
                words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << (24 - (i % 8) * 4);
            }

            return new WordArray.init(words, hexStrLength / 2);
        }
    };

    /**
     * Latin1 encoding strategy.
     */
    var Latin1 = C_enc.Latin1 = {
        /**
         * Converts a word array to a Latin1 string.
         *
         * @param {WordArray} wordArray The word array.
         *
         * @return {string} The Latin1 string.
         *
         * @static
         *
         * @example
         *
         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
         */
        stringify: function (wordArray) {
            // Shortcuts
            var words = wordArray.words;
            var sigBytes = wordArray.sigBytes;

            // Convert
            var latin1Chars = [];
            for (var i = 0; i < sigBytes; i++) {
                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
                latin1Chars.push(String.fromCharCode(bite));
            }

            return latin1Chars.join('');
        },

        /**
         * Converts a Latin1 string to a word array.
         *
         * @param {string} latin1Str The Latin1 string.
         *
         * @return {WordArray} The word array.
         *
         * @static
         *
         * @example
         *
         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
         */
        parse: function (latin1Str) {
            // Shortcut
            var latin1StrLength = latin1Str.length;

            // Convert
            var words = [];
            for (var i = 0; i < latin1StrLength; i++) {
                words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << (24 - (i % 4) * 8);
            }

            return new WordArray.init(words, latin1StrLength);
        }
    };

    /**
     * UTF-8 encoding strategy.
     */
    var Utf8 = C_enc.Utf8 = {
        /**
         * Converts a word array to a UTF-8 string.
         *
         * @param {WordArray} wordArray The word array.
         *
         * @return {string} The UTF-8 string.
         *
         * @static
         *
         * @example
         *
         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
         */
        stringify: function (wordArray) {
            try {
                return decodeURIComponent(escape(Latin1.stringify(wordArray)));
            } catch (e) {
                throw new Error('Malformed UTF-8 data');
            }
        },

        /**
         * Converts a UTF-8 string to a word array.
         *
         * @param {string} utf8Str The UTF-8 string.
         *
         * @return {WordArray} The word array.
         *
         * @static
         *
         * @example
         *
         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
         */
        parse: function (utf8Str) {
            return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
        }
    };

    /**
     * Abstract buffered block algorithm template.
     *
     * The property blockSize must be implemented in a concrete subtype.
     *
     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
     */
    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
        /**
         * Resets this block algorithm's data buffer to its initial state.
         *
         * @example
         *
         *     bufferedBlockAlgorithm.reset();
         */
        reset: function () {
            // Initial values
            this._data = new WordArray.init();
            this._nDataBytes = 0;
        },

        /**
         * Adds new data to this block algorithm's buffer.
         *
         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
         *
         * @example
         *
         *     bufferedBlockAlgorithm._append('data');
         *     bufferedBlockAlgorithm._append(wordArray);
         */
        _append: function (data) {
            // Convert string to WordArray, else assume WordArray already
            if (typeof data == 'string') {
                data = Utf8.parse(data);
            }

            // Append
            this._data.concat(data);
            this._nDataBytes += data.sigBytes;
        },

        /**
         * Processes available data blocks.
         *
         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
         *
         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
         *
         * @return {WordArray} The processed data.
         *
         * @example
         *
         *     var processedData = bufferedBlockAlgorithm._process();
         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
         */
        _process: function (doFlush) {
            // Shortcuts
            var data = this._data;
            var dataWords = data.words;
            var dataSigBytes = data.sigBytes;
            var blockSize = this.blockSize;
            var blockSizeBytes = blockSize * 4;

            // Count blocks ready
            var nBlocksReady = dataSigBytes / blockSizeBytes;
            if (doFlush) {
                // Round up to include partial blocks
                nBlocksReady = Math.ceil(nBlocksReady);
            } else {
                // Round down to include only full blocks,
                // less the number of blocks that must remain in the buffer
                nBlocksReady = Math.max((nBlocksReady | 0) - this._minBufferSize, 0);
            }

            // Count words ready
            var nWordsReady = nBlocksReady * blockSize;

            // Count bytes ready
            var nBytesReady = Math.min(nWordsReady * 4, dataSigBytes);

            // Process blocks
            if (nWordsReady) {
                for (var offset = 0; offset < nWordsReady; offset += blockSize) {
                    // Perform concrete-algorithm logic
                    this._doProcessBlock(dataWords, offset);
                }

                // Remove processed words
                var processedWords = dataWords.splice(0, nWordsReady);
                data.sigBytes -= nBytesReady;
            }

            // Return processed words
            return new WordArray.init(processedWords, nBytesReady);
        },

        /**
         * Creates a copy of this object.
         *
         * @return {Object} The clone.
         *
         * @example
         *
         *     var clone = bufferedBlockAlgorithm.clone();
         */
        clone: function () {
            var clone = Base.clone.call(this);
            clone._data = this._data.clone();

            return clone;
        },

        _minBufferSize: 0
    });

    /**
     * Abstract hasher template.
     *
     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
     */
    var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
        /**
         * Configuration options.
         */
        cfg: Base.extend(),

        /**
         * Initializes a newly created hasher.
         *
         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
         *
         * @example
         *
         *     var hasher = CryptoJS.algo.SHA256.create();
         */
        init: function (cfg) {
            // Apply config defaults
            this.cfg = this.cfg.extend(cfg);

            // Set initial values
            this.reset();
        },

        /**
         * Resets this hasher to its initial state.
         *
         * @example
         *
         *     hasher.reset();
         */
        reset: function () {
            // Reset data buffer
            BufferedBlockAlgorithm.reset.call(this);

            // Perform concrete-hasher logic
            this._doReset();
        },

        /**
         * Updates this hasher with a message.
         *
         * @param {WordArray|string} messageUpdate The message to append.
         *
         * @return {Hasher} This hasher.
         *
         * @example
         *
         *     hasher.update('message');
         *     hasher.update(wordArray);
         */
        update: function (messageUpdate) {
            // Append
            this._append(messageUpdate);

            // Update the hash
            this._process();

            // Chainable
            return this;
        },

        /**
         * Finalizes the hash computation.
         * Note that the finalize operation is effectively a destructive, read-once operation.
         *
         * @param {WordArray|string} messageUpdate (Optional) A final message update.
         *
         * @return {WordArray} The hash.
         *
         * @example
         *
         *     var hash = hasher.finalize();
         *     var hash = hasher.finalize('message');
         *     var hash = hasher.finalize(wordArray);
         */
        finalize: function (messageUpdate) {
            // Final message update
            if (messageUpdate) {
                this._append(messageUpdate);
            }

            // Perform concrete-hasher logic
            var hash = this._doFinalize();

            return hash;
        },

        blockSize: 512/32,

        /**
         * Creates a shortcut function to a hasher's object interface.
         *
         * @param {Hasher} hasher The hasher to create a helper for.
         *
         * @return {Function} The shortcut function.
         *
         * @static
         *
         * @example
         *
         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
         */
        _createHelper: function (hasher) {
            return function (message, cfg) {
                return new hasher.init(cfg).finalize(message);
            };
        },

        /**
         * Creates a shortcut function to the HMAC's object interface.
         *
         * @param {Hasher} hasher The hasher to use in this HMAC helper.
         *
         * @return {Function} The shortcut function.
         *
         * @static
         *
         * @example
         *
         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
         */
        _createHmacHelper: function (hasher) {
            return function (message, key) {
                return new C_algo.HMAC.init(hasher, key).finalize(message);
            };
        }
    });

    /**
     * Algorithm namespace.
     */
    var C_algo = C.algo = {};

    return C;
}(Math));

define("cryptojs-core", (function (global) {
    return function () {
        var ret, fn;
        return ret || global.CryptoJS;
    };
}(this)));

/*
CryptoJS v3.1.2
code.google.com/p/crypto-js
(c) 2009-2013 by Jeff Mott. All rights reserved.
code.google.com/p/crypto-js/wiki/License
*/
(function (Math) {
    // Shortcuts
    var C = CryptoJS;
    var C_lib = C.lib;
    var WordArray = C_lib.WordArray;
    var Hasher = C_lib.Hasher;
    var C_algo = C.algo;

    // Constants table
    var T = [];

    // Compute constants
    (function () {
        for (var i = 0; i < 64; i++) {
            T[i] = (Math.abs(Math.sin(i + 1)) * 0x100000000) | 0;
        }
    }());

    /**
     * MD5 hash algorithm.
     */
    var MD5 = C_algo.MD5 = Hasher.extend({
        _doReset: function () {
            this._hash = new WordArray.init([
                0x67452301, 0xefcdab89,
                0x98badcfe, 0x10325476
            ]);
        },

        _doProcessBlock: function (M, offset) {
            // Swap endian
            for (var i = 0; i < 16; i++) {
                // Shortcuts
                var offset_i = offset + i;
                var M_offset_i = M[offset_i];

                M[offset_i] = (
                    (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
                    (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
                );
            }

            // Shortcuts
            var H = this._hash.words;

            var M_offset_0  = M[offset + 0];
            var M_offset_1  = M[offset + 1];
            var M_offset_2  = M[offset + 2];
            var M_offset_3  = M[offset + 3];
            var M_offset_4  = M[offset + 4];
            var M_offset_5  = M[offset + 5];
            var M_offset_6  = M[offset + 6];
            var M_offset_7  = M[offset + 7];
            var M_offset_8  = M[offset + 8];
            var M_offset_9  = M[offset + 9];
            var M_offset_10 = M[offset + 10];
            var M_offset_11 = M[offset + 11];
            var M_offset_12 = M[offset + 12];
            var M_offset_13 = M[offset + 13];
            var M_offset_14 = M[offset + 14];
            var M_offset_15 = M[offset + 15];

            // Working varialbes
            var a = H[0];
            var b = H[1];
            var c = H[2];
            var d = H[3];

            // Computation
            a = FF(a, b, c, d, M_offset_0,  7,  T[0]);
            d = FF(d, a, b, c, M_offset_1,  12, T[1]);
            c = FF(c, d, a, b, M_offset_2,  17, T[2]);
            b = FF(b, c, d, a, M_offset_3,  22, T[3]);
            a = FF(a, b, c, d, M_offset_4,  7,  T[4]);
            d = FF(d, a, b, c, M_offset_5,  12, T[5]);
            c = FF(c, d, a, b, M_offset_6,  17, T[6]);
            b = FF(b, c, d, a, M_offset_7,  22, T[7]);
            a = FF(a, b, c, d, M_offset_8,  7,  T[8]);
            d = FF(d, a, b, c, M_offset_9,  12, T[9]);
            c = FF(c, d, a, b, M_offset_10, 17, T[10]);
            b = FF(b, c, d, a, M_offset_11, 22, T[11]);
            a = FF(a, b, c, d, M_offset_12, 7,  T[12]);
            d = FF(d, a, b, c, M_offset_13, 12, T[13]);
            c = FF(c, d, a, b, M_offset_14, 17, T[14]);
            b = FF(b, c, d, a, M_offset_15, 22, T[15]);

            a = GG(a, b, c, d, M_offset_1,  5,  T[16]);
            d = GG(d, a, b, c, M_offset_6,  9,  T[17]);
            c = GG(c, d, a, b, M_offset_11, 14, T[18]);
            b = GG(b, c, d, a, M_offset_0,  20, T[19]);
            a = GG(a, b, c, d, M_offset_5,  5,  T[20]);
            d = GG(d, a, b, c, M_offset_10, 9,  T[21]);
            c = GG(c, d, a, b, M_offset_15, 14, T[22]);
            b = GG(b, c, d, a, M_offset_4,  20, T[23]);
            a = GG(a, b, c, d, M_offset_9,  5,  T[24]);
            d = GG(d, a, b, c, M_offset_14, 9,  T[25]);
            c = GG(c, d, a, b, M_offset_3,  14, T[26]);
            b = GG(b, c, d, a, M_offset_8,  20, T[27]);
            a = GG(a, b, c, d, M_offset_13, 5,  T[28]);
            d = GG(d, a, b, c, M_offset_2,  9,  T[29]);
            c = GG(c, d, a, b, M_offset_7,  14, T[30]);
            b = GG(b, c, d, a, M_offset_12, 20, T[31]);

            a = HH(a, b, c, d, M_offset_5,  4,  T[32]);
            d = HH(d, a, b, c, M_offset_8,  11, T[33]);
            c = HH(c, d, a, b, M_offset_11, 16, T[34]);
            b = HH(b, c, d, a, M_offset_14, 23, T[35]);
            a = HH(a, b, c, d, M_offset_1,  4,  T[36]);
            d = HH(d, a, b, c, M_offset_4,  11, T[37]);
            c = HH(c, d, a, b, M_offset_7,  16, T[38]);
            b = HH(b, c, d, a, M_offset_10, 23, T[39]);
            a = HH(a, b, c, d, M_offset_13, 4,  T[40]);
            d = HH(d, a, b, c, M_offset_0,  11, T[41]);
            c = HH(c, d, a, b, M_offset_3,  16, T[42]);
            b = HH(b, c, d, a, M_offset_6,  23, T[43]);
            a = HH(a, b, c, d, M_offset_9,  4,  T[44]);
            d = HH(d, a, b, c, M_offset_12, 11, T[45]);
            c = HH(c, d, a, b, M_offset_15, 16, T[46]);
            b = HH(b, c, d, a, M_offset_2,  23, T[47]);

            a = II(a, b, c, d, M_offset_0,  6,  T[48]);
            d = II(d, a, b, c, M_offset_7,  10, T[49]);
            c = II(c, d, a, b, M_offset_14, 15, T[50]);
            b = II(b, c, d, a, M_offset_5,  21, T[51]);
            a = II(a, b, c, d, M_offset_12, 6,  T[52]);
            d = II(d, a, b, c, M_offset_3,  10, T[53]);
            c = II(c, d, a, b, M_offset_10, 15, T[54]);
            b = II(b, c, d, a, M_offset_1,  21, T[55]);
            a = II(a, b, c, d, M_offset_8,  6,  T[56]);
            d = II(d, a, b, c, M_offset_15, 10, T[57]);
            c = II(c, d, a, b, M_offset_6,  15, T[58]);
            b = II(b, c, d, a, M_offset_13, 21, T[59]);
            a = II(a, b, c, d, M_offset_4,  6,  T[60]);
            d = II(d, a, b, c, M_offset_11, 10, T[61]);
            c = II(c, d, a, b, M_offset_2,  15, T[62]);
            b = II(b, c, d, a, M_offset_9,  21, T[63]);

            // Intermediate hash value
            H[0] = (H[0] + a) | 0;
            H[1] = (H[1] + b) | 0;
            H[2] = (H[2] + c) | 0;
            H[3] = (H[3] + d) | 0;
        },

        _doFinalize: function () {
            // Shortcuts
            var data = this._data;
            var dataWords = data.words;

            var nBitsTotal = this._nDataBytes * 8;
            var nBitsLeft = data.sigBytes * 8;

            // Add padding
            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);

            var nBitsTotalH = Math.floor(nBitsTotal / 0x100000000);
            var nBitsTotalL = nBitsTotal;
            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = (
                (((nBitsTotalH << 8)  | (nBitsTotalH >>> 24)) & 0x00ff00ff) |
                (((nBitsTotalH << 24) | (nBitsTotalH >>> 8))  & 0xff00ff00)
            );
            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
                (((nBitsTotalL << 8)  | (nBitsTotalL >>> 24)) & 0x00ff00ff) |
                (((nBitsTotalL << 24) | (nBitsTotalL >>> 8))  & 0xff00ff00)
            );

            data.sigBytes = (dataWords.length + 1) * 4;

            // Hash final blocks
            this._process();

            // Shortcuts
            var hash = this._hash;
            var H = hash.words;

            // Swap endian
            for (var i = 0; i < 4; i++) {
                // Shortcut
                var H_i = H[i];

                H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
                       (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
            }

            // Return final computed hash
            return hash;
        },

        clone: function () {
            var clone = Hasher.clone.call(this);
            clone._hash = this._hash.clone();

            return clone;
        }
    });

    function FF(a, b, c, d, x, s, t) {
        var n = a + ((b & c) | (~b & d)) + x + t;
        return ((n << s) | (n >>> (32 - s))) + b;
    }

    function GG(a, b, c, d, x, s, t) {
        var n = a + ((b & d) | (c & ~d)) + x + t;
        return ((n << s) | (n >>> (32 - s))) + b;
    }

    function HH(a, b, c, d, x, s, t) {
        var n = a + (b ^ c ^ d) + x + t;
        return ((n << s) | (n >>> (32 - s))) + b;
    }

    function II(a, b, c, d, x, s, t) {
        var n = a + (c ^ (b | ~d)) + x + t;
        return ((n << s) | (n >>> (32 - s))) + b;
    }

    /**
     * Shortcut function to the hasher's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     *
     * @return {WordArray} The hash.
     *
     * @static
     *
     * @example
     *
     *     var hash = CryptoJS.MD5('message');
     *     var hash = CryptoJS.MD5(wordArray);
     */
    C.MD5 = Hasher._createHelper(MD5);

    /**
     * Shortcut function to the HMAC's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     * @param {WordArray|string} key The secret key.
     *
     * @return {WordArray} The HMAC.
     *
     * @static
     *
     * @example
     *
     *     var hmac = CryptoJS.HmacMD5(message, key);
     */
    C.HmacMD5 = Hasher._createHmacHelper(MD5);
}(Math));

define("cryptojs-md5", ["cryptojs-core"], (function (global) {
    return function () {
        var ret, fn;
        return ret || global.CryptoJS;
    };
}(this)));

define('models/UserModel',['require','exports','module','backbone','store2','moment','events/ThemeEvent','libs/Authentication','cryptojs-md5'],function (require, exports, module) {
    'use strict';

    // External dependencies.
    var Backbone = require('backbone');
    var store = require('store2');
    var moment = require('moment');
    var ThemeEvent = require('events/ThemeEvent');
    var Authentication = require('libs/Authentication');
    require('cryptojs-md5');

    /**
     * User model
     * @type {Backbone.Model}
     */
    var UserModel = Backbone.Model.extend({

        /**
         * true if loading zip.
         */
        loadingZip: false,

        /**
         * true if loading login (step 1, 2 or 3).
         */
        loadingLogin: false,

        /**
         * true if loading delivery datetime.
         */
        loadingDeliveryDatetime: false,

        /**
         * Store the previous checkZipAjax request allowing to abort it.
         */
        checkZipAjax: null,

        defaults: {
            // ModuleCart
            products: {}, // products in the cart fetched from api.

            // Module AddToCart
            // Module AddToFavorites.
            target: null, // the element - if any - that triggered the add to card event.
            origin: null, // the origin for add2cart API (typo, shop).
            productsToCart: null, // products to be added in the cart.
            productsToFavorites: null, // products to be added in the cart.
            productsRecommended : null, // products related to products added to cart or to favorites.

            // ModuleLogin / ModuleGuestLogin
            user: null, // retrieved user data.

            // ModuleLogin
            moduleLoginActive: null, // because more then one module-login is listening to model changes, we have to track which one the user is interacting with.

            // ModuleGuestLogin
            zip: '', // zipcode used in guest-login.
            zipVerified: false, // true if the zip was checked throught the api and it is valid.
            checkingZip: [], // has the zip codes that must be checked, using array here to handle request delay.
            moduleGuestLoginActive: null, // because more then one module-guest-login is listening to model changes, we have to track which one the user is interacting with.

            // ModuleDeliveryDatetime
            customerGroup: '',
            deliveryDatetime: null,

            confirmationStatus: false,
            login: '',

            // Custom event to be triggered after the user has logged in.
            event: '',
            params: '',

            // True if the user has been fetch at only one time
            fetchUserComplete: false,
        },

        initialize: function (options) {
            this.addEventListeners();
        },

        addEventListeners: function () {
            $(window).on(ThemeEvent.REFRESH_CART, _.bind(this.fetchCart, this));
            $(window).on(ThemeEvent.FETCH_USER_COMPLETE, _.bind(this.checkStorage, this));

            this.listenTo(this, 'change:zip', this.zipChanged);
        },

        /**
         * Check if the action is in the actions list.
         *
         * @param {Array} actions The list containing all actions.
         * @param {String} action The action to be checked.
         *
         * @return {Boolean}
         */
        hasAction: function (actions, action) {
            return actions.indexOf(action) !== -1;
        },

        triggerEvent: function () {
            var event = this.get('event'),
                params = this.get('params');

            if (!_.isEmpty(event)) {
                this.set('event', '');
                this.set('params', '');

                this.trigger(ThemeEvent.RESTRICTED_ACCESS_COMPLETE);
                $(window).trigger(event, [this.get('user'), params]);
            }
        },

        timestamp: function () {
            return isapi.timestamp;
        },

        /**
         * True if authToken is valid.
         */
        isLoggedIn: function () {
            return !_.isEmpty(this.getAuthToken());
        },

        hasCustomerGroup: function (customerGroup) {
            if (!this.get('user')) {
                return false;
            } else if (customerGroup) {
                return this.get('user').customergroup === customerGroup;
            } else {
                return !_.isEmpty(this.get('user').customergroup)
            }
        },

        hasEmail: function () {
            if (this.get('user') && !_.isEmpty(this.get('user').email)) {
                return true;
            }

            return false;
        },

        /**
         * Add token to data.
         * ATTENTION: This is NOT the authToken!!!
         *
         * @param {Array} data
         */
        addToken: function (data) {
            data.push({
                name: 'token',
                value: isapi.token,
            });
        },

        getAuthToken: function () {
            if ('isapi' in window) {
                return this.readCookie(isapi.cookie.name);
            }

            return null;
        },

        readCookie: function (name) {
            var regexp = new RegExp(name + '=([^;]+)'),
                match = document.cookie.match(regexp);

            return match ? decodeURIComponent(match[1]) : null;
        },

        saveCookie: function (name, value, duration, path, domain, secure) {
            name = name || isapi.cookie.name;
            duration = duration || isapi.cookie.duration;
            path = path || isapi.cookie.path;
            domain = domain || isapi.cookie.domain;
            secure = secure || isapi.cookie.secure;
            var cookie = '',
                date;

            cookie += name + '=' + encodeURIComponent(value) + '; ';

            if (duration) {
                duration = Date.now() + parseInt(duration, 10);
                date = new Date();
                date.setTime(duration * 1000);
                cookie += 'expires=' + (date.toUTCString()) + '; ';
            }

            cookie += 'path=' + path + '; ';
            cookie += 'domain=' + domain + '; ';

            if (secure) {
                cookie += 'secure=' + isapi.cookie.secure + '; ';
            }

            cookie += 'SameSite=Lax; ';

            document.cookie = cookie;
        },

        clearCookie: function (name, value) {
            name = name || isapi.cookie.name;
            value = value || '';

            var cookie = '';

            cookie += name + '=' + encodeURIComponent(value) + '; ';
            cookie += 'expires=Thu, 01 Jan 1970 00:00:00 GMT; ';
            cookie += 'path=' + isapi.cookie.path + '; ';
            cookie += 'domain=' + isapi.cookie.domain + '; ';

            if (isapi.cookie.secure) {
                cookie += 'secure=' + isapi.cookie.secure;
            }

            document.cookie = cookie;
        },

        /**
         * Store login in session storage to handle them after page reload.
         */
        storeLogin: function () {
            store.session({'login': true});
        },

        /**
         * Store guest login in session storage to handle them after page reload.
         */
        storeGuestLogin: function () {
            store.session({'guest-login': true});
        },

        /**
         * Store products in session storage to handle them after page reload.
         */
        storeProducts: function () {
            var session = {};

            if (this.get('productsToCart')) {
                session.products = this.get('productsToCart');

                if (!_.isEmpty(this.get('origin'))) {
                    session.origin = this.get('origin');
                }

                store.session(session);
            }
        },

        /**
         * Store favorites in session storage to handle them after page reload.
         */
        storeFavorites: function () {
            if (this.get('productsToFavorites')) {
                store.session({favorites: this.get('productsToFavorites')});
            }
        },

        /**
         * Store shoprules for modal in session storage to handle them after page reload.
         */
        storeShoprulesModal: function () {
            var redirect = this.get('user').shoprulesRedirectProcess;

            if (redirect) {
                if (redirect.shoprulesUseModal && !_.isEmpty(redirect.shoprulesModal)) {
                    store.session({shoprules: redirect.shoprulesModal});
                }
            }
        },

        checkStorage: function () {
            var login = store.session.get('login'),
                guestLogin = store.session.get('guest-login'),
                origin = store.session.get('origin'),
                products = store.session.get('products'),
                favorites = store.session.get('favorites'),
                shoprules = store.session.get('shoprules'),
                delivery = (this.get('user') && this.get('user').delivery) ? this.get('user').delivery : null;

            if (login) {
                store.session.remove('login');

                _.delay(function () {
                    $('#modal-login-registration').modal('show');
                }, 10);
            }

            if (guestLogin) {
                store.session.remove('guest-login');

                if (!login && !products && !favorites) {
                    if (delivery === 'homedelivery') {
                        $('#modal-guest-login-homedelivery').modal('show');
                    } else if (delivery === 'package') {
                        $('#modal-guest-login-package').modal('show');
                    } else {
                        $('#modal-guest-login').modal('show');
                    }
                }
            }

            if (products) {
                store.session.remove('origin');
                store.session.remove('products');

                if (!login) {
                    $(window).trigger(ThemeEvent.ADD_TO_CART, [products, origin, delivery]);
                }
            } else if (favorites) {
                store.session.remove('favorites');

                if (!login) {
                    $(window).trigger(ThemeEvent.ADD_TO_FAVORITES, [favorites, delivery]);
                }
            }

            if (shoprules) {
                store.session.remove('shoprules');
                $('#modal-ajax-html').attr('src', shoprules);
                $('#modal-ajax-html').modal('show');
            }

            if (!products) {
                // If there is no products to add, we must fetch them.
                this.fetchCart();
            }
        },

        getErrorCode: function(response) {
            var code = null;

            if (response && 'code' in response) {
                code = response.code;
            } else if (response && response.error && response.error.length && 'code' in response.error[0]) {
                code = response.error[0].code;
            }

            return code;
        },

        getErrorMessage: function(response) {
            var message = null;

            if (response && response.message) {
                message = response.message;
            } else if (response && response.error && response.error.length && response.error[0].message) {
                message = response.error[0].message;
            }

            return message;
        },

        triggerError: function(e, action, themeEventType) {
            var response = e && e.responseJSON ? e.responseJSON : null,
                code = this.getErrorCode(response),
                message = this.getErrorMessage(response);

            if (themeEventType) {
                this.trigger(themeEventType, {type: themeEventType, action: action, code: code, message: message});
            } else {
                this.trigger(ThemeEvent.ERROR_UNKNOWN, {type: ThemeEvent.ERROR_UNKNOWN, action: action, code: code, message: message});
            }
        },

        zipChanged: function() {
            this.set('zipVerified', false);
        },

        checkZip: function (data) {
            var action = 'check-zip';

            this.get('checkingZip').push(this.get('zip'));
            this.trigger('change:checkingZip', this, this.get('checkingZip'));

            this.addToken(data);

            // Abort previous ajax request.
            if (this.checkZipAjax) {
                this.checkZipAjax.abort();
            }

            this.checkZipAjax = $.ajax({
                url: isapi.urls.zipCheck,
                method: 'POST',
                data: data,
                success: $.proxy(function (response) {
                    this.get('checkingZip').shift();
                    this.trigger('change:checkingZip', this, this.get('checkingZip'));

                    if (this.get('checkingZip').length) return;

                    if (response && response.status && response.status === 'success' && response.content && response.content.status === 'success' && response.content.zip && String(response.content.zip) === String(this.get('zip')) && String(this.get('zip'))) {
                        this.set('zipVerified', true);
                        this.trigger(ThemeEvent.CHECK_ZIP_COMPLETE, {type: ThemeEvent.CHECK_ZIP_COMPLETE, action: action});
                    } else if (response && response.status && response.status === 'success' && response.content && response.content.status === 'error') {
                        this.trigger(ThemeEvent.ERROR_ZIP_NOT_FOUND, {type: ThemeEvent.ERROR_ZIP_NOT_FOUND, action: action});
                    }
                }, this),
                error: $.proxy(function(jqXHR, textStatus, errorThrown) {
                    this.get('checkingZip').shift();

                    if (textStatus === 'abort') {
                        // Ignore error if a new request must abort the previous one.
                        return;
                    }

                    console.log('ERROR!');
                    this.trigger('change:checkingZip', this, this.get('checkingZip'));
                    this.trigger(ThemeEvent.ERROR_UNKNOWN, {type: ThemeEvent.ERROR_UNKNOWN, action: action});
                }, this),
            });
        },

        loginAsGuest: function (data) {
            var action = 'login-as-guest';

            this.loadingZip = true;

            $.ajax({
                url: isapi.urls.guestLogin,
                method: 'POST',
                data: data,
                success: $.proxy(function(response) {
                    this.loadingZip = false;

                    if (response && response.status && response.status === 'success' && response.user && response.user.authToken) {
                        this.completeLogin(response.user, true);
                        this.trigger(ThemeEvent.LOGIN_COMPLETE, {type: ThemeEvent.LOGIN_COMPLETE, action: action});
                    } else if (response && response.status && response.status === 'success' && response.content && response.content.message && response.content.message && response.content.message === 'eisApiZipNotFound') {
                        this.trigger(ThemeEvent.ERROR_ZIP_NOT_FOUND, {type: ThemeEvent.ERROR_ZIP_NOT_FOUND, action: action});
                    } else {
                        this.triggerError({responseJSON: response}, action, ThemeEvent.ERROR_UNKNOWN);
                    }
                }, this),
                error: $.proxy(function(e) {
                    this.loadingZip = false;
                    this.triggerError(e, action, ThemeEvent.ERROR_UNKNOWN);
                }, this),
            });
        },

        login1stStep: function (data) {
            var action = 'login-1st-step';
            var url = isapi.urls.login1stStep;

            this.loadingLogin = true;
            this.set('user', null);

            $.ajax({
                url: url,
                method: 'POST',
                data: data,
                complete: $.proxy(function (jqXHR, textStatus) {
                    var credentials = Authentication.parseWwwAuthenticate(jqXHR);
                    this.nc = Authentication.getNc(this.nc);

                    $.ajax({
                        url: url,
                        method: 'POST',
                        data: data,
                        beforeSend: $.proxy(function(xhr) {
                            xhr.setRequestHeader('Authorization', Authentication.getAuthorization(this.nc, credentials, 'POST', url));
                        }, this),
                        success: $.proxy(function(response) {
                            this.loadingLogin = false;

                            if (response && response.status && response.status === 'success' && response.user) {
                                // Set user - or null if no user in response.
                                this.set('user', response.user);
                                this.trigger(ThemeEvent.LOGIN_1ST_STEP_COMPLETE, {type: ThemeEvent.LOGIN_1ST_STEP_COMPLETE, action: action, response: response});
                            } else {
                                this.trigger(ThemeEvent.ERROR_UNKNOWN, {type: ThemeEvent.ERROR_UNKNOWN, action: action, response: response});
                            }
                        }, this),
                        error: $.proxy(function(jqXHR, ajaxSettings, thrownError) {
                            this.loadingLogin = false;

                            if (jqXHR.status === 401) {
                                this.trigger(ThemeEvent.ERROR_UNAUTHORIZED, {type: ThemeEvent.ERROR_UNAUTHORIZED, action: action, response: {code: 401}});
                            } else {
                                this.trigger(ThemeEvent.ERROR_UNKNOWN, {type: ThemeEvent.ERROR_UNKNOWN, action: action});
                            }
                        }, this),
                    });
                }, this)
            });
        },

        login2ndStep: function (data) {
            var action = 'login-2nd-step';
            var url = isapi.urls.login2ndStep;

            this.loadingLogin = true;

            $.ajax({
                url: url,
                method: 'POST',
                data: data,
                complete: $.proxy(function (jqXHR, textStatus) {
                    var credentials = Authentication.parseWwwAuthenticate(jqXHR);
                    this.nc = Authentication.getNc(this.nc);

                    $.ajax({
                        url: url,
                        method: 'POST',
                        data: data,
                        beforeSend: $.proxy(function(xhr) {
                            xhr.setRequestHeader('Authorization', Authentication.getAuthorization(this.nc, credentials, 'POST', url));
                        }, this),
                        success: $.proxy(function(response) {
                            this.loadingLogin = false;

                            if (response && response.status && response.status === 'success' && response.user && response.user.authToken) {
                                this.completeLogin(response.user);
                                this.trigger(ThemeEvent.LOGIN_2ND_STEP_COMPLETE, {type: ThemeEvent.LOGIN_2ND_STEP_COMPLETE, action: action});
                                this.trigger(ThemeEvent.LOGIN_COMPLETE, {type: ThemeEvent.LOGIN_COMPLETE, action: action});
                            } else {
                                this.trigger(ThemeEvent.ERROR_UNKNOWN, {type: ThemeEvent.ERROR_UNKNOWN, action: action, response: response});
                            }
                        }, this),
                        error: $.proxy(function(jqXHR, ajaxSettings, thrownError) {
                            this.loadingLogin = false;

                            if (jqXHR.status === 401) {
                                this.trigger(ThemeEvent.ERROR_UNAUTHORIZED, {type: ThemeEvent.ERROR_UNAUTHORIZED, action: action, response: {code: 401}});
                            } else {
                                this.trigger(ThemeEvent.ERROR_UNKNOWN, {type: ThemeEvent.ERROR_UNKNOWN, action: action});
                            }
                        }, this),
                    });
                }, this)
            });
        },

        completeLogin: function (user, guest) {
            this.set('user', user);

            if (_.isEmpty(this.get('event'))) {
                if (guest) {
                    this.storeGuestLogin();
                }

                this.storeProducts();
                this.storeFavorites();
            }

            this.storeShoprulesModal();

            this.saveCookie(isapi.cookie.name, user.authToken);
            $(window).trigger(ThemeEvent.LOGIN_COMPLETE);
        },

        forgotPassword: function (data) {
            var action = 'forgot-password';

            this.loadingLogin = true;

            $.ajax({
                url: isapi.urls.forgotPassword,
                method: 'POST',
                data: data,
                success: $.proxy(function(response) {
                    this.loadingLogin = false;

                    if (response && response.status && response.status === 'success') {
                        this.trigger(ThemeEvent.FORGOT_PASSWORD_COMPLETE, {type: ThemeEvent.ERROR_UNKNOWN, action: action});
                    } else {
                        this.trigger(ThemeEvent.ERROR_UNKNOWN, {type: ThemeEvent.ERROR_UNKNOWN, action: action, response: response});
                    }
                }, this),
                error: $.proxy(function() {
                    this.loadingLogin = false;
                    this.trigger(ThemeEvent.ERROR_UNKNOWN, {type: ThemeEvent.ERROR_UNKNOWN, action: action});
                }, this),
            });
        },

        /**
         * Fetch user.
         */
        fetchUser: function () {
            var action = 'fetch-user';

            // If the user is not logged in, reset products in the cart.
            if (!this.isLoggedIn()) {
                this.set('fetchUserComplete', true);
                this.trigger(ThemeEvent.FETCH_USER_COMPLETE, {type: ThemeEvent.FETCH_USER_COMPLETE, action: action});
                $(window).trigger(ThemeEvent.FETCH_USER_COMPLETE, {user: null});
                return;
            }

            $.ajax({
                url: isapi.urls.userFetch,
                method: 'GET',
                beforeSend: $.proxy(function(xhr) {
                    this.addAuthToken(xhr);
                }, this),
                success: $.proxy(function(response) {
                    this.set('fetchUserComplete', true);

                    if (response && response.status && response.status === 'success' && response.user) {
                        this.set('user', response.user);
                        this.trigger(ThemeEvent.FETCH_USER_COMPLETE, {type: ThemeEvent.FETCH_USER_COMPLETE, action: action});
                        $(window).trigger(ThemeEvent.FETCH_USER_COMPLETE, {user: response.user});
                    } else {
                        this.triggerError({responseJSON: response}, action, ThemeEvent.ERROR_FETCH_USER);
                    }
                }, this),
                error: $.proxy(function(e) {
                    this.set('fetchUserComplete', true);
                    this.triggerError(e, action, ThemeEvent.ERROR_FETCH_USER);
                }, this),
            });
        },

        /**
         * Fetch favorites.
         */
        fetchFavorites: function () {
            var action = 'fetch-favorites';

            // If the user is not logged in, reset products in the cart.
            if (!this.isLoggedIn()) {
                this.trigger(ThemeEvent.FETCH_FAVORITES_COMPLETE, {type: ThemeEvent.FETCH_FAVORITES_COMPLETE, action: action, favorites: null});
                $(window).trigger(ThemeEvent.FETCH_FAVORITES_COMPLETE, {favorites: null});
                return;
            }

            $.ajax({
                url: isapi.urls.favorites,
                method: 'GET',
                beforeSend: $.proxy(function(xhr) {
                    this.addAuthToken(xhr);
                }, this),
                success: $.proxy(function(response) {
                    if (response && response.status && response.status === 'success' && response.favorites) {
                        this.trigger(ThemeEvent.FETCH_FAVORITES_COMPLETE, {type: ThemeEvent.FETCH_FAVORITES_COMPLETE, action: action, favorites: response.favorites});
                        $(window).trigger(ThemeEvent.FETCH_FAVORITES_COMPLETE, {favorites: response.favorites});
                    } else {
                        this.triggerError({responseJSON: response}, action, ThemeEvent.ERROR_FETCH_FAVORITES);
                    }
                }, this),
                error: $.proxy(function(e) {
                    this.triggerError(e, action, ThemeEvent.ERROR_FETCH_FAVORITES);
                }, this),
            });
        },

        /**
         * Check token.
         */
        checkToken: function () {
            var action = 'check-token';

            if (!this.isLoggedIn()) {
                this.trigger(ThemeEvent.CHECK_TOKEN_COMPLETE, {type: ThemeEvent.CHECK_TOKEN_COMPLETE, action: action, valid: false});
                return;
            }

            $.ajax({
                url: isapi.urls.userFetch,
                method: 'GET',
                beforeSend: $.proxy(function(xhr) {
                    this.addAuthToken(xhr);
                }, this),
                success: $.proxy(function(response) {
                    if (response && response.status && response.status === 'success' && response.user) {
                        this.trigger(ThemeEvent.CHECK_TOKEN_COMPLETE, {type: ThemeEvent.CHECK_TOKEN_COMPLETE, action: action, valid: true});
                    } else {
                        this.triggerError({responseJSON: response}, action, ThemeEvent.ERROR_CHECK_TOKEN);
                    }
                }, this),
                error: $.proxy(function(e) {
                    this.triggerError(e, action, ThemeEvent.ERROR_CHECK_TOKEN);
                }, this),
            });
        },

        /**
         * Fetch products in the shop cart.
         */
        fetchCart: function () {
            var action = 'fetch-cart';

            // If the user is not logged in, reset products in the cart.
            if (!this.isLoggedIn()) {
                this.set('products', null);
                return;
            }

            $.ajax({
                url: isapi.urls.cart,
                method: 'GET',
                beforeSend: $.proxy(function(xhr) {
                    this.addAuthToken(xhr);
                }, this),
                success: $.proxy(function(response) {
                    if (response && response.status && response.status === 'success' && response.products && response.products.length) {
                        this.set('products', response.products);
                    } else {
                        this.set('products', null);
                    }

                    this.trigger(ThemeEvent.FETCH_CART_COMPLETE, {type: ThemeEvent.FETCH_CART_COMPLETE, action: action}, response.products);
                }, this),
            });
        },

        addToCart: function () {
            var action = 'add-to-cart',
                data = _.extend({origin: this.get('origin')}, this.get('productsToCart'));

            $.ajax({
                url: isapi.urls.cart,
                method: 'POST',
                data: data,
                beforeSend: $.proxy(function(xhr) {
                    this.addAuthToken(xhr);
                }, this),
                success: $.proxy(function(response) {
                    var code = null;
                    var target = this.get('target');

                    this.set(target, null);

                    if (response && response.status && response.status === 'success' && response.products && response.products.length) {
                        this.set('products', response.products);
                        this.trigger(ThemeEvent.ADD_TO_CART_COMPLETE, {
                            type: ThemeEvent.ADD_TO_CART_COMPLETE,
                            action: action,
                            target: target,
                            cart: response,
                        });

                        $(window).trigger(ThemeEvent.ADD_TO_CART_COMPLETE, {
                            type: ThemeEvent.ADD_TO_CART_COMPLETE,
                            target: target,
                            cart: response,
                        });
                    } else {
                        this.triggerError({responseJSON: response}, action, ThemeEvent.ERROR_ADD_TO_CART);
                        $(window).trigger(ThemeEvent.ERROR_ADD_TO_CART, {
                            type: ThemeEvent.ERROR_ADD_TO_CART,
                            target: target,
                            cart: response,
                        });
                    }
                }, this),
                error: $.proxy(function(e) {
                    this.triggerError(e, action, ThemeEvent.ERROR_ADD_TO_CART);
                    $(window).trigger(ThemeEvent.ERROR_ADD_TO_CART, {
                        type: ThemeEvent.ERROR_ADD_TO_CART,
                        target: target,
                        cart: response,
                    });
                }, this),
            });
        },

        addToFavorites: function () {
            var action = 'add-to-favorites';

            $.ajax({
                url: isapi.urls.favorites,
                method: 'POST',
                data: this.get('productsToFavorites'),
                beforeSend: $.proxy(function(xhr) {
                    this.addAuthToken(xhr);
                }, this),
                success: $.proxy(function(response) {
                    if (response && response.status && response.status === 'success' && response.favorites && response.favorites.length) {
                        this.trigger(ThemeEvent.ADD_TO_FAVORITES_COMPLETE, {type: ThemeEvent.ADD_TO_FAVORITES_COMPLETE, action: action});
                    } else {
                        this.triggerError({responseJSON: response}, action, ThemeEvent.ERROR_ADD_TO_FAVORITES);
                    }
                }, this),
                error: $.proxy(function(e) {
                    this.triggerError(e, action, ThemeEvent.ERROR_ADD_TO_FAVORITES);
                }, this),
            });
        },

        fetchRecommendedProducts: function (trigger) {
            var action = 'fetch-recommended-products',
                data = [{
                    name: 'trigger',
                    value: trigger,
                }];

            $.ajax({
                url: isapi.urls.crossselling,
                method: 'POST',
                data: data,
                beforeSend: $.proxy(function(xhr) {
                    this.addAuthToken(xhr);
                }, this),
                success: $.proxy(function(response) {
                    if (response && response.status && response.status === 'success' && response.products && response.products.length) {
                        this.set('productsRecommended', response.products);
                        this.trigger(ThemeEvent.FETCH_RECOMMENDED_PRODUCTS_COMPLETE, {type: ThemeEvent.FETCH_RECOMMENDED_PRODUCTS_COMPLETE, action: action});
                    } else {
                        this.trigger(ThemeEvent.ERROR_UNKNOWN, {type: ThemeEvent.ERROR_UNKNOWN, action: action});
                    }
                }, this),
                error: $.proxy(function() {
                    this.trigger(ThemeEvent.ERROR_UNKNOWN, {type: ThemeEvent.ERROR_UNKNOWN, action: action});
                }, this),
            });
        },

        fetchDeliveryDates: function (data) {
            var action = 'fetch-delivery-dates';

            $.ajax({
                url: isapi.urls.userDates,
                method: 'GET',
                data: data,
                beforeSend: $.proxy(function(xhr) {
                    this.addAuthToken(xhr);
                }, this),
                success: $.proxy(function(response) {
                    this.loadingDeliveryDatetime = false;

                    if (response && response.status && response.status === 'success' && response.user) {
                        if (response.user.customergroup === 'JO' && response.user.dates && response.user.dates.dates && response.user.dates.dates.length) {
                            this.set('customerGroup', response.user.customergroup.toLowerCase());
                            this.set('deliveryDatetime', response.user.dates.dates);
                            this.trigger(ThemeEvent.FETCH_DELIVERY_DATES_COMPLETE, {type: ThemeEvent.FETCH_DELIVERY_DATES_COMPLETE, action: action});
                        } else if (response.user.customergroup === 'HD' && response.user.dates && response.user.dates.length) {
                            this.set('customerGroup', response.user.customergroup.toLowerCase());
                            this.set('deliveryDatetime', response.user.dates);
                            this.trigger(ThemeEvent.FETCH_DELIVERY_DATES_COMPLETE, {type: ThemeEvent.FETCH_DELIVERY_DATES_COMPLETE, action: action});
                        } else {
                            this.triggerError({responseJSON: response}, action, ThemeEvent.ERROR_FETCH_DELIVERY_DATES);
                        }
                    } else {
                        this.triggerError({responseJSON: response}, action, ThemeEvent.ERROR_FETCH_DELIVERY_DATES);
                    }
                }, this),
                error: $.proxy(function(e) {
                    this.loadingDeliveryDatetime = false;
                    this.triggerError(e, action, ThemeEvent.ERROR_FETCH_DELIVERY_DATES);
                }, this),
            });
        },

        saveDeliveryDates: function (data) {
            var action = 'save-delivery-dates';

            $.ajax({
                url: isapi.urls.userDates,
                method: 'POST',
                data: data,
                beforeSend: $.proxy(function(xhr) {
                    this.addAuthToken(xhr);
                }, this),
                success: $.proxy(function(response) {
                    if (response && response.status && response.status === 'success') {
                        this.trigger(ThemeEvent.SAVE_DELIVERY_DATES_COMPLETE, {type: ThemeEvent.SAVE_DELIVERY_DATES_COMPLETE, action: action});
                    } else {
                        this.loadingDeliveryDatetime = false;
                        this.triggerError({responseJSON: response}, action, ThemeEvent.ERROR_SAVE_DELIVERY_DATES);
                    }
                }, this),
                error: $.proxy(function(e) {
                    this.loadingDeliveryDatetime = false;
                    this.triggerError(e, action, ThemeEvent.ERROR_SAVE_DELIVERY_DATES);
                }, this),
            });
        },

        addAuthToken: function(xhr) {
            var authToken = this.getAuthToken();

            if (!_.isEmpty(authToken)) {
                xhr.setRequestHeader('authorization', 'Bearer ' + authToken);
            }
        },

    });

    // Returns a singleton of UserModel.
    var instance;
    module.exports = function() {
        if (!instance) {
            instance = new UserModel();
        }
        return instance;
    }
});

define('views/ShareContentView',['require','exports','module','theme','backbone'],function (require, exports, module) {
    'use strict';

    // External dependencies.
    var theme = require('theme');
    var Backbone = require('backbone');


    var ModuleShareContentView = Backbone.View.extend({

        initialize: function (options) {
            this.options = _.extend({}, this.$el.data(), options);

            this.onSocialLinkClick = _.bind(this.onSocialLinkClick, this);

            this.render();
            this.addEventListeners();
        },

        render: function () {
            this.$shareButton = this.$('.share-button');
            this.$shareDialog = this.$('.share-dialog');
            this.$closeButton = this.$('.close-button');

            if (navigator.share) {
                this.$el.addClass('share-native');
            }

            return this;
        },

        addEventListeners: function () {
            this.$shareButton.on('click', _.bind(this.onShareClick, this));

            if (!this.$el.hasClass('share-native')) {
                this.$el.on('mouseenter', _.bind(this.onEnter, this));
                this.$el.on('mouseleave', _.bind(this.onLeave, this));
            }

            $('.popup').on('click', this.onSocialLinkClick);
        },

        onEnter: function (e) {
            this.$el.addClass('show-icons');
        },

        onLeave: function (e) {
            this.$el.removeClass('show-icons');
        },

        onShareClick: function (e) {
            // Works only under https!
            if (navigator.share) {
                navigator.share({
                    title: this.options.shareTitle,
                    url: this.options.shareUrl,
                }).then(function() {
                    console.log('Thanks for sharing!');
                }).catch(console.error);
            }
        },

        onCloseClick: function (e) {
            this.$shareDialog.removeClass('is-open');
        },

        onSocialLinkClick: function (e) {
            if (e && e.preventDefault) e.preventDefault();

            var $el = $(e.currentTarget),
                href = $el.attr('href'),
                channel = $el.data('channel');

                console.log($el, href, channel);

            if (!_.isEmpty(channel) && !_.isEmpty(href) && href !== '#') {
                this.openSocialMediaUrl(href, channel);
            }
        },

        openSocialMediaUrl: function (href, channel) {
            var w = 800,
                h = 600,
                x = screen.width / 2 - w / 2,
                y = screen.height / 2 - h / 2;

            window.open(href, 'socialWindow', 'width=' + w + ',height=' + h + ',left=' + x + ',top=' + y);
        },

    });

    module.exports = ModuleShareContentView;
});

define('views/ContainerView',['require','exports','module','theme','backbone'],function (require, exports, module) {
    "use strict";

    // External dependencies.
    var theme = require("theme");
    var Backbone = require("backbone");

    var ModuleContainerView = Backbone.View.extend({

        views: null,
        isCenter: null,
        origin: null,
        $body: null,
        $modal: null,
        $menuContent: null,

        initialize: function (options) {
            this.views = [];

            options = _.extend({}, this.$el.data(), options);
            this.resize = _.bind(this.resize, this);
            this.onModalOpen = _.bind(this.onModalOpen, this);
            this.onMenuFlyoutOpen = _.bind(this.onMenuFlyoutOpen, this);

            this.el.moduleContainerView = this;

            this.render();
        },

        events: {},

        enableEvents: function () {
            //Remove previous events
            this.disableEvents();

            this.$el.on('carousel-resize', this.resize);

            return this;
        },

        disableEvents: function () {
            this.$el.off('carousel-resize', this.resize);
            return this;
        },

        render: function (e) {
            this.$body = $("body:first");
            this.$modal = this.$el.closest(".modal");
            this.$menuContent = this.$el.closest("li.has-content");

            this.isCenter = this.$el.hasClass("center");

            var $img = this.$el.children("img:first");

            this.origin = $img.attr("data-this.origin");

            if (this.origin) {
                this.origin = $.parseJSON(this.origin);

                this.origin.x = this.origin.x || 0;
                this.origin.y = this.origin.y || 0;
            } else {
                this.origin = {
                    x: 0,
                    y: 0
                };
            }

            $img.on("load", _.bind(this.onModuleContainerLoaded, this));

            $img.css({
                position: "absolute"
            });

            this.enableEvents();

            if (this.$el.is(":visible")) {
                this.$el.addClass("rendered");
            } else {
                if (this.$modal.length) {
                    this.$modal.on("shown.bs.modal", this.onModalOpen);
                }


                if (this.$menuContent.length) {
                    this.$body.on("menu-flyout-open", this.onMenuFlyoutOpen);
                }
            }

            this.resize();
        },

        onModalOpen: function (e) {
            var $modal = $(e.currentTarget);

            $modal.off("shown.bs.modal", this.onModalOpen);

            this.resize();

            this.$el.addClass("rendered");
        },

        onMenuFlyoutOpen: function (e) {
            var $target = e.$target;
            if(!$target || !$target.length || !this.$menuContent || !this.$menuContent.length) return;

            if ($target.get(0) === this.$menuContent.get(0)) {
                this.$body.off("menu-flyout-open", this.onMenuFlyoutOpen);

                this.resize();

                this.$el.addClass("rendered");
            }
        },

        onModuleContainerLoaded: function (e) {

            this.resize();
        },

        resize: function () {
            if (this.isCenter) {
                this.resizeCenter();
            } else {
                this.resizeCrop();
            }
        },

        resizeCenter: function () {
            var containerWidth = this.$el.width();
            var containerHeight = this.$el.height();

            var $img = this.$el.children("img");

            var w = $img.width();
            var h = $img.height();

            var dest = {
                left: "50%",
                top: "50%",
                transform: "translate(-50%, -50%)"
            };

            if (h > containerHeight) {
                w = w * containerHeight / h;
                h = containerHeight;
            }

            if (w > containerWidth) {
                h = h * containerWidth / w;
                w = containerWidth;
            }

            dest.width = w;
            dest.height = h;

            $img.css(dest);
        },

        resizeCrop: function () {
            var containerWidth = this.$el.width();
            var containerHeight = this.$el.height();
            var containerAspect = containerWidth / containerHeight;

            var $img = this.$el.children("img");

            var w = $img.width();
            var h = $img.height();
            var aspect = w / h;

            var left = 0;
            var top = 0;

            var dest;
            if (containerAspect > aspect) {
                h = containerWidth * h / w;
                w = containerWidth;
                top = ((containerHeight - h) / 2) + (h * -this.origin.y);

                if (top > 0) {
                    top = 0;
                } else if (top < containerHeight - h) {
                    top = containerHeight - h;
                }

                dest = {
                    width: w + "px",
                    height: "auto",
                    left: left + "px",
                    top: top + "px"
                };
            } else {
                w = containerHeight * w / h;
                h = containerHeight;
                left = ((containerWidth - w) / 2) + (w * -this.origin.x);

                if (left > 0) {
                    left = 0;
                } else if (left < containerWidth - w) {
                    left = containerWidth - w;
                }

                dest = {
                    width: "auto",
                    height: h + "px",
                    left: left + "px",
                    top: top + "px"
                };
            }

            $img.css(dest);
        },
    });

    module.exports = ModuleContainerView;
});

define('views/AddToCartComplete',['require','exports','module','backbone','events/ThemeEvent','models/UserModel'],function (require, exports, module) {
    'use strict';

    // External dependencies.
    var Backbone = require('backbone');

    var ThemeEvent = require('events/ThemeEvent');
    var UserModel = require('models/UserModel');
    var userModel = new UserModel();

    var AddToCartComplete = Backbone.View.extend({

        initialize: function () {
            this.listenTo(userModel, ThemeEvent.ADD_TO_CART_COMPLETE, this.addToCartComplete);
            this.listenTo(userModel, ThemeEvent.FETCH_CART_COMPLETE, _.bind(this.fetchProductsComplete, this));
            $(window).on(ThemeEvent.FETCH_PRODUCTS_COMPLETE, _.bind(this.fetchProductsComplete, this));
        },

        addToCartComplete: function (e) {
            if (e.cart && e.cart.products) {
                if (e.target && !$(e.target).closest('.james-search-box').length) {
                    this.updateTarget(e.target, e.cart.products);
                }

                this.updateModuleProducts(e.cart.products);
            }
        },

        fetchProductsComplete: function (e, products) {
            if (products) {
                this.updateModuleProducts(products);
            }
        },

        updateTarget: function (target, products) {
            var $target = $(target);
            var dataProducts = $target.data('products');

            if (dataProducts && dataProducts.products && dataProducts.products.length === 1) {
                _.forEach(dataProducts.products, function (buttonItem, p) {
                    _.forEach(products, function (cartItem, c) {
                        if (buttonItem.number === cartItem.number) {
                            $target.text(cartItem.buttonText);
                        }
                    });
                });
            }
        },

        updateModuleProducts: function (products) {
            var $targets = $('.module-products-infinite .btn, .module-product-detail .btn');

            _.forEach($targets, function (el, index) {
                var $el = $(el);
                var dataProducts = $el.data('products');

                if (dataProducts) {
                    _.forEach(dataProducts.products, function (product, p) {
                        _.forEach(products, function (cartItem, c) {
                            if (product.number === cartItem.number) {
                                $el.text(cartItem.buttonText);
                            }
                        })
                    });
                }
            });
        },
    });

    module.exports = AddToCartComplete;
});

define('views/HeaderLoginView',['require','exports','module','backbone','moment','events/ThemeEvent','models/UserModel'],function (require, exports, module) {
    'use strict';

    // External dependencies.
    var Backbone = require('backbone');
    var moment = require('moment');

    var ThemeEvent = require('events/ThemeEvent');
    var UserModel = require('models/UserModel');
    var userModel = new UserModel();

    var DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss';
    var DAY_FORMAT_INPUT = 'YYYY-MM-DD';
    var DAY_FORMAT_OUTPUT = 'DD.MM.YYYY';

    var ModuleHeaderLoginView = Backbone.View.extend({

        /**
         * The payload params given through the constructor.
         */
        options: null,

        /**
         * The templates.
         */
        templateVisitor: null,
        templateGuest: null,
        templateJo: null,
        templateHdNoDate: null,
        templateHdPreOrder: null,
        templateHdPreOrderExpired: null,
        templateHdCountdown: null,

        /**
         * The actions this view is interested in.
         */
        actions: [
            'fetch-user',
        ],

        initialize: function (options) {
            this.options = _.extend({}, this.$el.data(), options);

            this.render();
            this.enableEvents();
        },

        render: function () {
            this.templateVisitor = _.template($('#module-header-login-visitor').text());
            this.templateGuest = _.template($('#module-header-login-guest').text());
            this.templateJo = _.template($('#module-header-login-jo').text());
            this.templateHdNoDate = _.template($('#module-header-login-hd-no-date').text());
            this.templateHdPreOrder = _.template($('#module-header-login-hd-pre-order').text());
            this.templateHdPreOrderExpired = _.template($('#module-header-login-hd-pre-order-expired').text());
            this.templateHdCountdown = _.template($('#module-header-login-hd-countdown').text());

            this.$el.addClass('rendered');

            return this;
        },

        enableEvents: function () {
            this.listenTo(userModel, ThemeEvent.FETCH_USER_COMPLETE, this.onFetchUserComplete);
            this.listenTo(userModel, ThemeEvent.ERROR_FETCH_USER, this.onError);
            this.listenTo(userModel, ThemeEvent.ERROR_UNKNOWN, this.onError);
        },

        onFetchUserComplete: function (e) {
            this.renderTemplate();
        },

        /**
         * Render the correct template.
         *
         * @param {Boolean} handleAsVisitor Handle user as visitor in case some error has occurred.
         */
        renderTemplate: function (handleAsVisitor) {
            var date = null,
                user = userModel.get('user'),
                template = null,
                refreshTheme = false;

            if (!userModel.isLoggedIn() || handleAsVisitor) {
                template = this.templateVisitor({ payload: null });
                this.$el.closest('header').addClass('visitor');
            } else if (!userModel.hasCustomerGroup()) {
                template = this.templateGuest({ payload: null });
                this.$el.closest('header').addClass('guest');

            } else if (userModel.hasCustomerGroup('JO')) {
                if (!userModel.hasEmail()) {
                    // Attribute email is empty. User must be a guest.
                    template = this.templateGuest({ payload: null });
                } else {
                    template = this.compileJoTemplate(user);
                    this.$el.closest('header').addClass('logged');
                }
            } else if (userModel.hasCustomerGroup('HD')) {
                refreshTheme = true;

                if (!user.dates || !user.dates.length) {
                    template = this.templateHdNoDate({ payload: _.extend(user) });
                } else {
                    template = this.compileHdTemplate(user);
                }

                this.$el.closest('header').addClass('logged');
            }

            this.renderContent(template);

            if (refreshTheme) {
                $('body').trigger('refresh.theme');
                $('body').trigger(ThemeEvent.REFRESH_COUNTDOWN);
            }
        },

        compileJoTemplate: function (user) {
            var i,
                date,
                deliveryDate;

            for (i = 0; i < user.dates.dates.length; i++) {
                date = user.dates.dates[i];

                if (date.current === 1 || user.dates.dates.length === 1) {
                    deliveryDate = moment(date.date, DAY_FORMAT_INPUT).format(DAY_FORMAT_OUTPUT);
                    return this.templateJo({ payload: _.extend(user, { deliveryDate: deliveryDate }) });
                }
            }

            // Falback for no dates.
            return this.templateJo({ payload: _.extend(user, { deliveryDate: null }) });
        },

        compileHdTemplate: function (user) {
            var i,
                date,
                now = null,
                preOrder = null,
                preOrderThreeDaysEarlier = null,
                deliveryDate = null,
                deliveryDateFirst = null,
                deliveryDateNext = null,
                formatedDates = null,
                selectableDatesTotal = 0;

            for (i = 0; i < user.dates.length; i++) {
                date = user.dates[i];
                if (date.selectable === 1) {
                    selectableDatesTotal++;
                }
            }

            for (i = 0; i < user.dates.length; i++) {
                date = user.dates[i];
                if (date.current === 1 || user.dates.length === 1) {
                    now = moment(userModel.timestamp(), 'X');
                    preOrder = moment(date.aufdattr + ' ' + date.ordertime, DATE_FORMAT);
                    preOrderThreeDaysEarlier = preOrder.clone().subtract(3, 'day');
                    deliveryDate = moment(date.bdat, DAY_FORMAT_INPUT);
                    deliveryDateFirst = moment(user.dates[0].bdat, DAY_FORMAT_INPUT);
                    deliveryDateNext = null;

                    formatedDates = {
                        deliveryDate: deliveryDate.format(DAY_FORMAT_OUTPUT),
                        countdownTimestamp: moment(date.aufdattr + ' ' + date.ordertime, DATE_FORMAT).format('X'),
                        deliveryDateFirst: deliveryDateFirst.format(DAY_FORMAT_OUTPUT),
                        deliveryDateNext: null,
                        selectableDatesTotal: selectableDatesTotal,
                    }

                    if (user.dates[i + 1]) {
                        deliveryDateNext = moment(user.dates[i + 1].bdat, DAY_FORMAT_INPUT);
                        formatedDates.deliveryDateNext = deliveryDateNext.format(DAY_FORMAT_OUTPUT);
                    }

                    if (formatedDates.countdownTimestamp) {
                        $('.module-countdown[data-wait-header="true"]')
                            .attr('data-countdown-timestamp', formatedDates.countdownTimestamp)
                            .data('countdown-timestamp', formatedDates.countdownTimestamp);
                    }

                    if (preOrderThreeDaysEarlier < now && now < preOrder) {
                        return this.templateHdCountdown({ payload: _.extend(user, formatedDates) });
                    } else if (now < preOrderThreeDaysEarlier) {
                        return this.templateHdPreOrder({ payload: _.extend(user, formatedDates) });
                    } else if (preOrder <= now) {
                        return this.templateHdPreOrderExpired({ payload: _.extend(user, formatedDates) });
                    }
                }
            }
        },

        renderContent: function (template) {
            var $headerContent = this.$el.closest('.header-content');

            $headerContent.find('.module-header-top .header-login-tmpl-content').empty().append(template);
            $headerContent.find('.header-top-welcome-wrapper .media-text').clone().addClass('header-top-copy').prependTo($headerContent.find('.module-header-center'));
        },

        onError: function (e) {
            if (!userModel.hasAction(this.actions, e.action)) return;

            if (e.code === 400) {
                $('#modal-messages').modal('show');
                $(window).trigger(ThemeEvent.SHOW_AUTH_TOKEN_EXPIRED);
            } else {
                this.renderTemplate(true);
            }
        },

    });

    module.exports = ModuleHeaderLoginView;
});

define('views/HeaderCartView',['require','exports','module','theme','backbone','bowser','models/UserModel'],function (require, exports, module) {
    'use strict';

    // External dependencies.
    var theme = require('theme');
    var Backbone = require('backbone');
    var bowser = require('bowser');

    var UserModel = require('models/UserModel');
    var userModel = new UserModel();

    var ModuleHeaderCartView = Backbone.View.extend({

        /**
         * The payload params given through the constructor.
         */
        options: null,

        /**
         * The template for the empty.
         */
        templateEmpty: null,

        /**
         * The template for the details.
         */
        templateDetails: null,

        /**
         * Mobile cart
         */
        $mobileCart: null,

        initialize: function (options) {
            if (this.$el.hasClass('static')) {
                return;
            }

            this.options = _.extend({}, this.$el.data(), options);

            this.render();
            this.enableEvents();
        },

        render: function () {
            this.templateEmpty = _.template($(this.options.templateEmpty).text());
            this.templateDetails = _.template($(this.options.templateDetails).text());
            this.$mobileCart = $('.module-mobile-cart-button');

            this.$el.addClass('rendered');

            return this;
        },

        enableEvents: function () {
            this.$mobileCart.on('click', _.bind(this.onMobileCartClick, this));
            this.listenTo(userModel, 'change:products', this.renderCart);
        },

        renderCart: function (model, products) {
            var quantity = 0,
                price = 0,
                html = '',
                cssClass = '',
                $details = this.$('.details'),
                $el = this.$el,
                $mobileCart = this.$mobileCart;

            if (products && products.length) {
                quantity = products.length,
                    _.each(products, function (product, index) {
                        if (!isNaN(product.total)) {
                            price += product.total;
                        }
                    });

                html = this.templateDetails({
                    quantity: quantity,
                    price: price,
                });

                this.$('.quantity.number').text(quantity).removeClass('invisible grey');
                $mobileCart.find('.quantity.number').text(quantity).removeClass('invisible grey');
                cssClass = 'has-items';
            } else {
                quantity = 0;
                this.$('.quantity.number').text(quantity).removeClass('invisible').addClass('grey');
                $mobileCart.find('.quantity.number').text(quantity).removeClass('invisible').addClass('grey');
                html = this.templateEmpty();
                cssClass = 'empty';
            }

            $details.empty()
                .append(html)
                .removeClass('hidden');

            // Needed for animation.
            _.delay(function () {
                $el.removeClass('empty has-items').addClass(cssClass).removeClass('invisible');
                $mobileCart.removeClass('empty has-items').addClass(cssClass);
            }, 10);
        },

        onMobileCartClick: function (e) {
            if (this.$mobileCart.hasClass('empty')) {
                e.preventDefault();
            }
        },

    });

    module.exports = ModuleHeaderCartView;
});

define('views/LoginView',['require','exports','module','backbone','events/ThemeEvent','models/UserModel'],function (require, exports, module) {
    'use strict';

    // External dependencies.
    var Backbone = require('backbone');

    var ThemeEvent = require('events/ThemeEvent');
    var UserModel = require('models/UserModel');
    var userModel = new UserModel();

    var ModuleLoginView = Backbone.View.extend({

        /**
         * The payload params given through the constructor.
         */
        options: null,

        /**
         * true if loading submit form data.
         */
        loading: false,

        /**
         * The template for the pw form.
         */
        templatePw: null,

        /**
         * The template for the zip form.
         */
        templateZip: null,

        /**
         * The template for the forgot pw form.
         */
        templateForgotPw: null,

        /**
         * The template for override error messages.
         */
        msgErrorOverride: null,

        /**
         * The text for forgot pw success.
         */
        msgForgotPwSuccess: '',

        /**
         * The text for unauthorized access.
         */
        msgUnauthorized: '',

        /**
         * The text for an unknown error.
         */
        msgUnknownError: '',

        /**
         * The container for all steps.
         */
        $wrapper: null,

        /**
         * The container for step 1.
         */
        $step1: null,

        /**
         * The container for step 2.
         */
        $step2: null,

        /**
         * The container for step 3.
         */
        $step3: null,

        /**
         * The identifier form.
         */
        $formIdentifier: null,

        /**
         * The password form.
         */
        $formPw: null,

        /**
         * Feedback container.
         */
        $feedback: null,

        /**
         * The current step in the login proccess.
         */
        stepActive: 0,

        /**
         * The current step in the login proccess.
         */
        $formActive: null,

        $body: null,
        animationTime: 0.2,

        /**
         * The actions this view is interested in.
         */
        actions: [
            'login-1st-step',
            'login-2nd-step',
            'forgot-password',
        ],

        initialize: function (options) {
            this.views = [];

            this.options = _.extend({}, this.$el.data(), options);

            this.submitForm = _.bind(this.submitForm, this);

            this.resize = _.bind(this.resize, this);
            this.resizeWrapper = _.bind(this.resizeWrapper, this);

            this.render();
        },

        render: function () {
            this.$body = $('body');

            this.templatePw = _.template($(this.options.templatePw).text());
            this.templateZip = _.template($(this.options.templateZip).text());
            this.templateForgotPw = _.template($(this.options.templateForgotPw).text());

            this.msgForgotPwSuccess = $(this.options.templateMsgForgotPwSuccess).text();
            this.msgUnauthorized = $(this.options.templateMsgUnknownError).text();
            this.msgUnknownError = $(this.options.templateMsgUnknownError).text();

            this.msgErrorOverride = this.options.templateMsgErrorOverride;

            this.$wrapper = this.$el.closest('.module-login-registration-wrapper');
            this.$step1 = this.$wrapper.find('> .step-1');
            this.$step2 = this.$wrapper.find('> .step-2');
            this.$step3 = this.$wrapper.find('> .step-3');
            this.$formIdentifier = this.$('form');

            this.swapForm(ModuleLoginView.FORM_STEP_ONE);

            this.addEventListeners();

            this.$el.addClass('rendered');

            return this;
        },

        /**
         * Enable events
         */
        addEventListeners: function () {
            this.$formIdentifier.on('submit', this.submitForm);

            this.$el.closest('.modal').on('shown.bs.modal show.bs.modal loaded.bs.modal', this.resize);

            this.$body.on('mobile-account-menu-open', _.bind(function(e) {
                this.resize();
            }, this));

            // Expose method 'resizeWrapper' to be trigger from everywhere.
            $(window).on(ThemeEvent.MODULE_LOGIN_RESIZE_WRAPPER, _.bind(function(e) {
                this.resizeWrapper(true);
            }, this));

            this.listenTo(userModel, 'change:user', this.onUserChange);
            this.listenTo(userModel, ThemeEvent.LOGIN_1ST_STEP_COMPLETE, this.onLogin1stStepComplete);
            this.listenTo(userModel, ThemeEvent.LOGIN_2ND_STEP_COMPLETE, this.onLogin2ndStepComplete);
            this.listenTo(userModel, ThemeEvent.FORGOT_PASSWORD_COMPLETE, this.onForgotPasswordComplete);
            this.listenTo(userModel, ThemeEvent.ERROR_UNKNOWN, this.onError);
            this.listenTo(userModel, ThemeEvent.ERROR_UNAUTHORIZED, this.onError);
        },

        emptyStep: function (step) {
            if (step === ModuleLoginView.FORM_STEP_TWO) {
                if (this.$step2.find('> .module-checkout-panel').length) {
                    this.$step2.find('> .module-checkout-panel').addClass('hidden').empty();
                } else {
                    this.$step2.empty();
                }
            } else {
                if (this.$step3.find('> .module-checkout-panel').length) {
                    this.$step3.find('> .module-checkout-panel').addClass('hidden').empty();
                } else {
                    this.$step3.empty();
                }
            }
        },

        renderFormPw: function (formName) {
            var html = '';

            if (formName === ModuleLoginView.FORM_PW) {
                html = this.templatePw(userModel.get('user'));
            } else if (formName === ModuleLoginView.FORM_ZIP) {
                html = this.templateZip(userModel.get('user'));
            }

            if (this.$step2.find('> .module-checkout-panel').length) {
                this.$step2.find('> .module-checkout-panel').removeClass('hidden').append(html);
            } else {
                this.$step2.append(html);
            }

            this.$formPw = this.$step2.find('form');

            this.addEventListenersPw();

            return this;
        },

        addEventListenersPw: function () {
            this.$formPw.on('submit.module-login', this.submitForm);
            this.$step2.find('[data-action="back"]').on('click.module-login', _.bind(this.onBackBtnClick, this));
            this.$step2.find('[data-action="forgot-pw"]').on('click.module-login', _.bind(this.onForgotPwBtnClick, this));
        },

        removeEventListenersPw: function () {
            if (this.$formPw) {
                this.$formPw.off('submit.module-login');
                this.$step2.find('[data-action="back"]').off('click.module-login');
                this.$formPw.find('[data-action="forgot-pw"]').off('click.module-login');
            }
        },

        onBackBtnClick: function (e) {
            e.preventDefault();

            if (this.stepActive === ModuleLoginView.FORM_STEP_TWO) {
                this.swapForm(ModuleLoginView.FORM_STEP_ONE);
            } else if (this.stepActive === ModuleLoginView.FORM_STEP_THREE) {
                this.swapForm(ModuleLoginView.FORM_STEP_TWO);
            }
        },

        onForgotPwBtnClick: function (e) {
            e.preventDefault();
            this.swapForm(ModuleLoginView.FORM_STEP_THREE);
        },

        renderFormForgotPw: function () {
            var payload = {
                    identifier: userModel.get('user').email ? userModel.get('user').email : '',
                },
                html = this.templateForgotPw(payload);

            if (this.$step3.find('> .module-checkout-panel').length) {
                this.$step3.find('> .module-checkout-panel').removeClass('hidden').append(html);
            } else {
                this.$step3.append(html);
            }

            this.$formForgotPw = this.$step3.find('form');

            this.addEventListenersForgotPw();

            return this;
        },

        addEventListenersForgotPw: function () {
            this.$formForgotPw.on('submit.module-login', this.submitForm);
            this.$step3.find('[data-action="back"]').on('click.module-login', _.bind(this.onBackBtnClick, this));
        },

        removeEventListenersForgotPw: function () {
            if (this.$formForgotPw) {
                this.$formForgotPw.off('submit.module-login');
                this.$step3.find('[data-action="back"]').off('click.module-login');
            }
        },

        swapForm: function (stepActive) {
            var selector = '',
                formName = '';

            if (stepActive === ModuleLoginView.FORM_STEP_ONE) {
                // Show step ONE
                this.$formActive = this.$formIdentifier;
                this.removeEventListenersPw();
            } else if (this.stepActive === ModuleLoginView.FORM_STEP_ONE && stepActive === ModuleLoginView.FORM_STEP_TWO) {
                // Show step TWO coming from step ONE
                this.removeEventListenersPw();
                this.emptyStep(ModuleLoginView.FORM_STEP_TWO);
                selector = 'input[name="password"]';

                if (userModel.get('user').login && userModel.get('user').login.toLowerCase() === 'plz') {
                    formName = ModuleLoginView.FORM_ZIP;
                } else {
                    formName = ModuleLoginView.FORM_PW;
                }

                this.renderFormPw(formName);
                this.$formActive = this.$formPw;
            } else if (this.stepActive === ModuleLoginView.FORM_STEP_TWO && stepActive === ModuleLoginView.FORM_STEP_THREE) {
                // Show step THREE coming from step TWO
                this.renderFormForgotPw();
                this.$formActive = this.$formForgotPw;
             } else if (this.stepActive === ModuleLoginView.FORM_STEP_THREE && stepActive === ModuleLoginView.FORM_STEP_TWO) {
                // Show step TWO coming from step THREE
                this.removeEventListenersForgotPw();
                this.emptyStep(ModuleLoginView.FORM_STEP_THREE);
                selector = 'input[name="password"]';
                this.$formActive = this.$formPw;
                this.emptyFeedback();

                this.$formActive.find(selector).val('');
            }

            // Update form step and swap forms
            this.stepActive = stepActive;
            this.$wrapper.attr('data-step-active', stepActive);
            this.setFocus(selector);
            this.resizeWrapper();
            $(window).trigger('refresh-form');
        },

        setFocus: function (selector) {
            var $formActive = this.$formActive;

            _.delay(function () {
                $formActive.find(selector).focus();
            }, 250);
        },

        submitForm: function (e) {
            var data = null;

            if (e && e.preventDefault) e.preventDefault();
            if (userModel.loadingLogin) return;

            this.emptyFeedback();

            userModel.set('moduleLoginActive', this);

            data = this.$formActive.serializeArray();

            if (this.stepActive === ModuleLoginView.FORM_STEP_ONE) {
                userModel.login1stStep(data);
            } else if (this.stepActive === ModuleLoginView.FORM_STEP_TWO) {
                var $submitButton = this.$step2.find('.btn-loader');
                if ($submitButton.length) {
                    $submitButton.addClass('loading');
                    $submitButton.addClass('disabled');
                    $submitButton.prop('disabled', true);
                }

                // If an authToken already exists and the user is submiting the form in step2,
                // we must also submit the guest token if it exists.
                data.push({
                    name: 'guesttoken',
                    value: userModel.getAuthToken(),
                });

                var $permaLogin = this.$formActive.find('[name="permalogin"]');
                if ($permaLogin.length && !($permaLogin.is(':checked'))) {
                    data.push({
                        name: 'permalogin',
                        value: 0,
                    });
                }

                userModel.login2ndStep(data);
            } else if (this.stepActive === ModuleLoginView.FORM_STEP_THREE) {
                userModel.forgotPassword(data);
            }
        },

        onUserChange: function (model, user) {
            if (userModel.get('moduleLoginActive') !== this) {
                // Check if the user has filled out another form.
                // Avoid combining different forms (e.g.: Header + Modal).
                if (this.stepActive !== ModuleLoginView.FORM_STEP_ONE) {
                    this.swapForm(ModuleLoginView.FORM_STEP_ONE);
                }

                return;
            };
        },

        onLogin1stStepComplete: function (e) {
            if (!userModel.hasAction(this.actions, e.action)) return;
            if (!userModel.get('user')) return;

            if (this.stepActive === ModuleLoginView.FORM_STEP_ONE) {
                this.swapForm(ModuleLoginView.FORM_STEP_TWO);
            }
        },

        onLogin2ndStepComplete: function (e) {
            if (!userModel.hasAction(this.actions, e.action)) return;
            if (!userModel.get('user')) return;

            if (this.stepActive === ModuleLoginView.FORM_STEP_TWO && userModel.get('user').authToken) {
                this.completeLogin();
            }
        },

        onForgotPasswordComplete: function (e) {
            if (userModel.get('moduleLoginActive') !== this) return;
            if (!userModel.hasAction(this.actions, e.action)) return;

            if (this.stepActive === ModuleLoginView.FORM_STEP_THREE) {
                this.$step3.find('button[type="submit"]').addClass('hidden');
                this.renderFeedback(this.msgForgotPwSuccess, 'success');
            }
        },

        onError: function (e) {
            var msg = '';

            if (userModel.get('moduleLoginActive') !== this) return;
            if (!userModel.hasAction(this.actions, e.action)) return;

            var $submitButton = this.$step2.find('.btn-loader.loading');
            if ($submitButton.length) {
                $submitButton.removeClass('loading');
                $submitButton.removeClass('disabled');
                $submitButton.prop('disabled', false);
            }

            switch (e.type) {
                case ThemeEvent.ERROR_ZIP_NOT_FOUND:
                    msg = this.msgZipNotFound;
                    break;

                default:
                    msg = this.fetchMsgError(e.response);
            }

            this.renderFeedback(msg, 'error');
        },

        fetchMsgError: function (response) {
            var msg = '',
                msgOverride = this.msgErrorOverride;

            if (response && response.code && msgOverride && msgOverride[String(response.code)] && $(msgOverride[String(response.code)]).length) {
                msg = $(msgOverride[response.code]).text();
            } else if (response && response.message) {
                msg = response.message;
            } else {
                msg = this.msgUnknownError;
            }

            return msg;
        },

        emptyFeedback: function () {
            var $feedback = this.$formActive.find('.feedback');
            $feedback.empty().removeClass('success error');
            this.resizeWrapper();
        },

        renderFeedback: function (msg, type) {
            var $feedback = this.$formActive.find('.feedback');

            this.emptyFeedback();
            $feedback.append(msg).addClass(type);
            this.resizeWrapper();
        },

        completeLogin: function () {
            var redirect = userModel.get('user').shoprulesRedirectProcess;

            if (redirect) {
                if (redirect.shoprulesRedirectStatus && !_.isEmpty(redirect.shoprulesRedirectTarget)) {
                    document.location.href = redirect.shoprulesRedirectTarget;
                } else {
                    window.location.reload(true);
                }
            } else {
                if (!_.isEmpty(userModel.get('event'))) {
                    $(document.activeElement).blur();
                    userModel.triggerEvent();
                } else {
                    window.location.reload(true);
                }
            }
        },

        resize: function (e) {
            this.resizeWrapper();
            return this;
        },

        resizeWrapper: function (immediately) {
            var animationTime = immediately ? 0 : this.animationTime;
            var $stepActiveContent = this.$wrapper.find('.module-login-registration-content.step-' + this.stepActive);
            var height = $stepActiveContent.height();

            if (!height) {
                return;
            }

            this.$body.trigger(ThemeEvent.MODULE_LOGIN_RESIZE);

            TweenMax.to(this.$wrapper, animationTime, {
                ease: Strong.easeOut,
                height: height,
                onCompleteScope: this,
                onComplete: function () {
                    this.$body.trigger(ThemeEvent.MODULE_LOGIN_RESIZE);
                }
            });

            return this;
        },

    });

    ModuleLoginView.FORM_STEP_ONE = 1;
    ModuleLoginView.FORM_STEP_TWO = 2;
    ModuleLoginView.FORM_STEP_THREE = 3;
    ModuleLoginView.FORM_IDENTIFIER = 'identifier';
    ModuleLoginView.FORM_PW = 'pw';
    ModuleLoginView.FORM_ZIP = 'zip';
    ModuleLoginView.FORM_FORGOT_PW = 'form-forgot-pw';

    module.exports = ModuleLoginView;
});

define('views/GuestLoginView',['require','exports','module','theme','backbone','bowser','events/ThemeEvent','models/UserModel'],function (require, exports, module) {
    'use strict';

    // External dependencies.
    var theme = require('theme');
    var Backbone = require('backbone');
    var bowser = require('bowser');

    var ThemeEvent = require('events/ThemeEvent');
    var UserModel = require('models/UserModel');
    var userModel = new UserModel();

    var ModuleGuestLoginView = Backbone.View.extend({

        /**
         * The payload params given through the constructor.
         */
        options: null,

        /**
         * Submit form automatically if true.
         */
        submitOnCheckZipComplete: false,

        /**
         * True if input has changed after submit.
         */
        inputChanged: false,

        /**
         * The text for zip not found.
         */
        msgZipNotFound: '',

        /**
         * The text for an unknown error.
         */
        msgUnknownError: '',

        /**
         * The container for all login steps (if this module exists in header).
         */
        $wrapper: null,

        /**
         * The form.
         */
        $form: null,

        /**
         * The input zip.
         */
        $inputZip: null,

        /**
         * The submit button.
         */
        $submitBtn: null,

        /**
         * Feedback container.
         */
        $feedback: null,

        $body: null,
        animationTime: 0.2,

        /**
         * The actions this view is interested in.
         */
        actions: [
            'check-zip',
            'login-as-guest',
        ],

        initialize: function (options) {
            this.views = [];

            this.options = _.extend({}, this.$el.data(), options);

            this.submitForm = _.bind(this.submitForm, this);

            this.inputZipChange = _.bind(this.inputZipChange, this);
            this.resize = _.bind(this.resize, this);
            this.resizeWrapper = _.bind(this.resizeWrapper, this);

            this.render();
            this.addEventListeners();
        },

        render: function () {
            this.msgZipNotFound = $(this.options.templateMsgZipNotFound).text();
            this.msgUnknownError = $(this.options.templateMsgUnknownError).text();

            this.$wrapper = this.$el.closest('.module-login-registration-wrapper');
            this.$form = this.$('form');
            this.$inputZip = this.$('input[name="zip"]');
            this.$submitBtn = this.$('button[type="submit"]');
            this.$feedback = this.$('.feedback');
            this.$body = $('body');

            this.$el.addClass('rendered');

            return this;
        },

        addEventListeners: function () {
            this.$form.on('submit', this.submitForm);
            this.$inputZip.on('input', this.inputZipChange);

            this.listenTo(userModel, ThemeEvent.CHECK_ZIP_COMPLETE, this.onCheckZipComplete);
            this.listenTo(userModel, ThemeEvent.LOGIN_COMPLETE, this.onLoginComplete);
            this.listenTo(userModel, ThemeEvent.ERROR_ZIP_NOT_FOUND, this.onError);
            this.listenTo(userModel, ThemeEvent.ERROR_UNKNOWN, this.onError);
        },

        inputZipChange: function (e) {
            this.inputChanged = true;
            this.submitOnCheckZipComplete = false;

            userModel.set('moduleGuestLoginActive', this);
            userModel.set('zip', this.$inputZip.val());

            this.showPreloader(false);
            this.showSubmitBtn(true);

            if (userModel.get('zip').length >= 4) {
                this.showSubmitBtn(true);
                this.emptyFeedback();
                userModel.checkZip(this.$form.serializeArray());
            }
        },

        onCheckZipComplete: function (e) {
            if (userModel.get('moduleGuestLoginActive') !== this) return;
            if (!userModel.hasAction(this.actions, e.action)) return;

            if (userModel.get('zipVerified') && this.submitOnCheckZipComplete && !this.inputChanged) {
                this.submitForm();
            }
        },

        showPreloader: function (show) {
            if (this.$submitBtn.hasClass('btn-loader')) {
                if (show) {
                    this.$submitBtn.addClass('loading');
                    this.$submitBtn.addClass('disabled');
                    this.$submitBtn.prop('disabled', true);
                } else {
                    this.$submitBtn.removeClass('disabled');
                    this.$submitBtn.removeClass('loading');
                    this.$submitBtn.prop('disabled', false);
                }
            }
        },

        submitForm: function (e) {
            if (e && e.preventDefault) e.preventDefault();

            if (userModel.loadingZip) {
                return;
            }

            this.inputChanged = false;
            this.showPreloader(true);

            if (userModel.get('checkingZip').length) {
                this.submitOnCheckZipComplete = true;
                return;
            } else if (!userModel.get('zipVerified')) {
                this.showSubmitBtn(false);
                this.renderFeedback(this.msgZipNotFound);
                return;
            }

            this.submitOnCheckZipComplete = false;
            userModel.loginAsGuest(this.$form.serializeArray());
        },

        onLoginComplete: function (e) {
            if (userModel.get('moduleGuestLoginActive') !== this) return;
            if (!userModel.hasAction(this.actions, e.action)) return;

            if (!this.inputChanged && userModel.get('user')) {
                this.completeLogin();
            }
        },

        onError: function (e) {
            var msg = '';

            if (userModel.get('moduleGuestLoginActive') !== this) return;
            if (!userModel.hasAction(this.actions, e.action)) return;
            if (!this.submitOnCheckZipComplete) return;

            switch (e.type) {
                case ThemeEvent.ERROR_ZIP_NOT_FOUND:
                    msg = this.msgZipNotFound;
                    break;

                default:
                    msg = this.msgUnknownError;
            }

            this.submitOnCheckZipComplete = false;

            this.emptyFeedback();
            this.showSubmitBtn(false);
            this.renderFeedback(msg);
        },

        showSubmitBtn: function (value) {
            if (value) {
                this.$submitBtn.removeClass('hidden');
            } else {
                this.$submitBtn.addClass('hidden');
            }
        },

        emptyFeedback: function () {
            this.$feedback.empty();
            this.resizeWrapper();
        },

        renderFeedback: function (msg) {
            this.emptyFeedback();
            this.$feedback.append(msg);
            this.resizeWrapper();
        },

        completeLogin: function () {
            if (!_.isEmpty(userModel.get('event'))) {
                $(document.activeElement).blur();
                userModel.triggerEvent();
            } else {
                window.location.reload(true);
            }
        },

        resize: function (e) {
            return this;
        },

        resizeWrapper: function (e) {
            var $stepActiveContent = this.$wrapper.find('.module-login-registration-content.step-1');
            var h = $stepActiveContent.height();

            this.$body.trigger(ThemeEvent.MODULE_LOGIN_RESIZE);

            TweenMax.to(this.$wrapper, this.animationTime, {
                ease: Strong.easeOut,
                height: h,
                onCompleteScope: this,
                onComplete: function () {
                    this.$body.trigger(ThemeEvent.MODULE_LOGIN_RESIZE);
                }
            });

            return this;
        },

    });

    module.exports = ModuleGuestLoginView;
});

define('views/GridView',['require','exports','module','backbone'],function (require, exports, module) {
    "use strict";

    // External dependencies.
    var Backbone = require("backbone");

    var ModuleGridView = Backbone.View.extend({

        views: null,

        resizeHeightGroupsDebounced: null,

        initialize: function (options) {
            this.views = [];

            options = _.extend({}, this.$el.data(), options);

            this.resizeHeightGroupsDebounced = _.debounce(this.resizeHeightGroups, 250);

            this.render();
        },

        events: {
            "resize": "resize"
        },

        render: function (e) {
            this.resize();

            this.enableEvents();

            this.$el.addClass("rendered");
        },

        preventDefaultEvent: function (e) {
            e.preventDefault();
        },

        enableEvents: function () {
            //Remove previous events
            this.disableEvents();

            return this;
        },

        disableEvents: function () {

            return this;
        },


        resize: function (e) {
            this.resizeHeightGroupsDebounced();
        },

        resizeHeightGroups: function () {
            var size = $("body").attr("data-size") || "xs";
            var $items = this.$el.find(".module-grid-item");
            var forceXxsTwoColumns = true;
            var forceXsTwoColumns = true;
            var slider = false;

            if (this.$el.closest('.module-products-infinite-slider').length || this.$el.hasClass('module-products-infinite-slider')) {
                forceXxsTwoColumns = false;
            }

            if (this.$el.hasClass('module-products-infinite-slider')) {
                slider = true;
            }

            // Reset
            $items.find("[data-height-group]").height("");

            var i;
            var imax = $items.length;
            var $item;

            var totalColumns = 12;
            var columnsAvailable;
            var columns;

            var className;
            var match;

            var j = 0;
            var count = 0;
            var rows = [];
            var regexp = /col-(xs|sm|md|lg)-(\d{1,2})/gmi;

            rows[0] = [];

            for (i = 0; i < imax; i++) {
                $item = $items.eq(i);

                className = $item.attr("class") || "";

                columnsAvailable = [];

                match = regexp.exec(className);

                while (match) {
                    columnsAvailable[match[1]] = Number(match[2]);

                    match = regexp.exec(className);
                }


                if (slider) {
                    count = 0;
                    columns = $items.length;
                    totalColumns = $items.length;
                } else if (size == "lg" && columnsAvailable.lg) {
                    columns = columnsAvailable.lg;
                } else if ((size == "lg" || size == "md") && columnsAvailable.md) {
                    columns = columnsAvailable.md;
                } else if ((size == "lg" || size == "md" || size == "sm") && columnsAvailable.sm) {
                    columns = columnsAvailable.sm;
                } else {
                    //force 2 columns in .module-products-force-columns
                    if (size == "xs" && window.innerWidth >= 320 && this.$el.hasClass("module-products-force-columns") && ($item.hasClass("col-xs-6") || forceXxsTwoColumns)) {
                        columns = 6;
                    } else if (size == "xs" && window.innerWidth >= 320 && this.$el.hasClass("module-products") && ($item.hasClass("col-xs-6") || forceXsTwoColumns)) {
                        columns = 6;
                    } else {
                        columns = columnsAvailable.xs;
                    }
                }

                if (count + columns > totalColumns) {
                    count = columns;
                    j++;
                    rows[j] = [];
                } else {
                    count += columns;
                }

                rows[j].push($item);
            }

            imax = rows.length;

            for (i = 0; i < imax; i++) {
                this.resizeHeightGroup(rows[i]);
            }

            this.$el.trigger("module-grid-view-resized");

            return this;
        },

        toJQueryObject: function (array) {
            return $($.map(array, function (el) {
                return el.get();
            }));
        },

        resizeHeightGroup: function (group) {
            var $group = this.toJQueryObject(group);

            var array = [];

            var $elements = $group.find("[data-height-group]");

            var ids = [];

            var i;
            var imax = $elements.length;
            var $items;
            var $item;

            var id;

            var j;
            var jmax;
            var h;
            var hMax;

            for (i = 0; i < imax; i++) {
                $item = $elements.eq(i);

                ids.push($item.data("height-group"));
            }

            ids = _.unique(ids);

            imax = ids.length;

            for (i = imax - 1; i >= 0; i--) {
                id = ids[i];

                $items = $elements.filter('[data-height-group="' + id + '"]');

                if ($items.length > 1) {
                    jmax = $items.length;
                    hMax = 0;

                    for (j = 0; j < jmax; j++) {
                        $item = $items.eq(j);

                        h = $item.height();

                        if (h > hMax) {
                            hMax = h;
                        }
                    }
                } else {
                    hMax = "";
                }

                $items.height(hMax);
            }

            return this;
        },
    });

    module.exports = ModuleGridView;
});

define('views/ProductsInfiniteView',['require','exports','module','backbone','models/UserModel','events/ThemeEvent'],function (require, exports, module) {
    'use strict';

    // External dependencies.
    var Backbone = require('backbone');
    var UserModel = require('models/UserModel');

    var ThemeEvent = require('events/ThemeEvent');
    var userModel = new UserModel();


    var ModuleProductsInfinite = Backbone.View.extend({

        views: null,
        $wrapper: null,
        $formWrapper: null,
        $limit: null,
        $page: null,
        step: 0,
        template: null,
        columns: [1, 2, 3, 4],
        animationTime: 600,
        currentIndex: 0,
        currentColumn: 4,
        totalProducts: 0,
        productIds: [],
        favorites: 0,

        /**
         * The actions this view is interested in.
         */
         actions: [
            'fetch-user',
            'fetch-favorites',
        ],

        initialize: function (options) {
            this.views = [];

            options = _.extend({}, this.$el.data(), options);

            if (options.columns) {
                if (_.isArray(options.columns)) {
                    this.columns = options.columns;
                }
            }

            this.options = options;
            this.setIndex = _.bind(this.setIndex, this);
            this.prev = _.bind(_.throttle(this.prev, this.animationTime), this);
            this.next = _.bind(_.throttle(this.next, this.animationTime), this);
            this.resizeSlider = _.bind(this.resizeSlider, this);

            this.onSubmit = _.bind(this.onSubmit, this);
            this.onSuccess = _.bind(this.onSuccess, this);
            this.onError = _.bind(this.onError, this);
            this.debouncedResize = _.bind(_.debounce(this.debouncedResize, 50), this);
            this.resizeForm = _.bind(this.resizeForm, this);

            this.resize = _.bind(this.resize, this);

            this.el.moduleProductsInfinite = this;
            this.addEventListeners();

            this.render();
        },

        events: {
            'click .module-products-infinite-slider-prev': 'onPrevClick',
            'click .module-products-infinite-slider-next': 'onNextClick',
            'swipeleft': "onSwipeLeft",
            'swiperight': "onSwipeRight"
        },

        render: function (e) {
            this.$wrapper = this.$('.module-products-infinite-wrapper:first');
            this.$formWrapper = this.$('.module-products-infinite-form:first');
            this.$form = this.$formWrapper.find('> form:first');
            this.$limit = this.$form.find('input[name="limit"]');
            this.$page = this.$form.find('input[name="page"]');

            this.$prev = this.$el.find(".module-products-infinite-slider-prev");
            this.$next = this.$el.find(".module-products-infinite-slider-next");

            this.$btnAddToCart = $('[data-ref="' + this.options.btnAddToCart + '"]');

            this.step = parseInt(this.$form.find('input[name="step"]').val(), 10);

            this.template = _.template($(this.$el.data('template')).text());

            this.enableEvents();
            this.$el.addClass('rendered');
            this.resizeSlider();

            return this;
        },

        addEventListeners: function () {
            this.listenToOnce(userModel, ThemeEvent.FETCH_USER_COMPLETE, this.onFetchUserComplete);
            this.listenToOnce(userModel, ThemeEvent.ERROR_FETCH_USER, this.onFetchUserError);
            this.listenToOnce(userModel, ThemeEvent.ERROR_UNKNOWN, this.onFetchUserError);
            this.listenToOnce(userModel, ThemeEvent.FETCH_FAVORITES_COMPLETE, this.onFetchFavoritesComplete);
            this.listenToOnce(userModel, ThemeEvent.ERROR_FETCH_FAVORITES, this.onFetchFavoritesError);
        },

        enableEvents: function () {
            this.$form.on('submit', this.onSubmit);
            this.$el.on('module-grid-view-resized', this.resizeForm);

            return this;
        },

        disableEvents: function () {
            this.$form.off('submit', this.onSubmit);
            this.$el.off('module-grid-view-resized', this.resizeForm);

            return this;
        },

        onFetchUserComplete: function (e) {
            if (userModel.isLoggedIn()) {
                userModel.fetchFavorites();
            } else {
                this.submit();
            }
        },

        onFetchUserError: function (e) {
            if (!userModel.hasAction(this.actions, e.action)) return;

            this.submit();
        },

        onFetchFavoritesComplete: function (e) {
            this.favorites = e.favorites;
            this.submit();
        },

        onFetchFavoritesError: function (e) {
            if (!userModel.hasAction(this.actions, e.action)) return;

            this.submit();
        },

        submit: function () {
            if (this.$form.length) {
                this.onSubmit();
            }
        },

        onSubmit: function (e) {
            if (e && e.preventDefault) e.preventDefault();
            if (this.$el.hasClass('loading')) return;

            var data = this.$form.serialize();

            this.$el.addClass('loading');

            $.ajax({
                url: isapi.urls.productsFetch,
                method: 'GET',
                data: data,
                beforeSend: $.proxy(function(xhr) {
                    userModel.addAuthToken(xhr);
                }, this),
                success: this.onSuccess,
                error: this.onError,
            });
        },

        onSuccess: function (data) {
            var hasProducts = (data && data.products && data.products.length);
            var totalProducts = hasProducts ? data.products.length : 0;

            if (hasProducts) {
                this.productIds = this.productIds.concat(_.pluck(data.products, 'id'));
                data = this.sortProducts(data);
                data = this.setFavorites(data);
                this.renderProducts(data);

                _.delay(function() {
                    if (userModel.get('products') && userModel.get('products')) {
                        $(window).trigger(ThemeEvent.FETCH_PRODUCTS_COMPLETE, [userModel.get('products')]);
                    }
                }, 100);
            }

            this.handleTotalProducts(totalProducts);

            if (hasProducts && this.step) {
                this.prepareToLoadMore();
            } else {
                this.loadAllComplete();
            }

            // Update recipe links
            $('.module-recipe-ingredients span[data-product-id]').each(function(index, el) {
                var id = String($(el).data('product-id'));
                var result = _.where( data.products, {id: id} );
                if (result.length) {
                    $(el).wrapInner('<a href="' + result[0].url_product_view + '" target="_self"></a>');
                }
            });

            this.$el.removeClass('empty loading');
        },

        onError: function (e) {
            this.$el.removeClass('loading');
        },

        sortProducts: function (data) {
            var i, j, id,
                product = null,
                products = [],
                productsSequence = null,
                requestParams = this.$form.serializeArray();

            for (i = 0; i < requestParams.length; i++) {
                if (requestParams[i].name === 'product') {
                    productsSequence = requestParams[i].value;
                    break;
                }
            }

            if (productsSequence) {
                productsSequence = productsSequence.split(',');

                for (i = 0; i < productsSequence.length; i++) {
                    id = productsSequence[i];

                    for (j = 0; j < data.products.length; j++) {
                        product = data.products[j];
                        if (id === product.id) {
                            products.push(product);
                        }
                    }
                }

                data.products = products;
            }

            return data;
        },

        setFavorites: function (data) {
            if (this.favorites && this.favorites.length) {
                for (var i = 0; i < data.products.length; i++) {
                    data.products[i].favorite = this.favorites.indexOf(data.products[i].id) >= 0 ? true : false;
                }
            }

            return data;
        },

        handleTotalProducts: function (totalProducts) {
            if (!this.totalProducts) {
                this.totalProducts += totalProducts;

                if (!totalProducts) {
                    this.$el.addClass('hidden');
                }

                this.updateBtnAddToCart(totalProducts);
            }
        },

        updateBtnAddToCart: function (totalProducts) {
            if (this.options.btnAddToCart && this.$btnAddToCart.length) {
                this.$btnAddToCart.removeAttr('data-ref');

                if (totalProducts < 2) {
                    this.$btnAddToCart.addClass('hidden');
                } else {
                    var data = {
                        products: _.map(this.productIds, function(id) {
                            return {
                                action: 'add',
                                number: id,
                                amount: 1,
                            };
                        }),
                    };

                    this.$btnAddToCart.attr('data-products', JSON.stringify(data));
                }
            }
        },

        renderProducts: function (data) {
            var html = this.template(data);
            this.$wrapper.append(html);
            this.debouncedResize();
        },

        debouncedResize: function () {
            $(window).trigger('resize');
        },

        prepareToLoadMore: function () {
            var limit = parseInt(this.$limit.val(), 10),
                page = parseInt(this.$page.val(), 10);

            if (this.step) {
                this.$page.val(page + 1);
                this.$limit.val(this.step);
            } else {
                this.loadAllComplete();
            }
        },

        loadAllComplete: function () {
            this.$formWrapper.addClass('hidden');
        },

        onPrevClick: function (e) {
            if (e && e.preventDefault) e.preventDefault();

            this.prev();
        },

        onNextClick: function (e) {
            if (e && e.preventDefault) e.preventDefault();

            this.next();
        },

        onSwipeRight: function (e) {
            if (e && e.preventDefault) e.preventDefault();

            if ($('body').width() <= 768) {
                return;
            }

            this.prev();
        },

        onSwipeLeft: function (e) {
            if (e && e.preventDefault) e.preventDefault();

            if ($('body').width() <= 768) {
                return;
            }

            this.next();
        },

        prev: function (e) {
            if (this.$prev.hasClass('deactivate')) {
                return;
            }

            this.setIndex(-1, true);
        },

        next: function (e) {
            if (this.$next.hasClass('deactivate')) {
                return;
            }

            this.setIndex(1, true);
        },

        setIndex: function (index, relative) {
            var $items = this.$wrapper.children(),
                total = $items.length;

            if (!total) return;

            if (relative) {
                index = this.currentIndex + (index * this.currentColumn);
            }

            if (index < 0) {
                index = 0;

                if (index === this.currentIndex || index < 0) {
                    index = total - this.currentColumn;
                }
            } else if (index > total - this.currentColumn) {
                index = total - this.currentColumn;

                if (index === this.currentIndex || index < 0) {
                    index = 0;
                }
            }

            if (total < this.currentColumn) {
                index = 0;
            }

            this.currentIndex = index;

            var x = Math.floor(-100 * this.currentIndex);

            if (this.$el.hasClass("module-products-infinite-slider")) {
                TweenMax.to($items, this.animationTime / 1000, {
                    ease: Strong.easeInOut,
                    x: x + "%",
                    scale: 1.001,
                });
            }

            this.updateNav();
        },

        updateNav: function () {
            var $items = this.$wrapper.children(),
                total = $items.length;

            if (this.currentIndex === 0) {
                this.$prev.addClass('deactivate');
            } else {
                this.$prev.removeClass('deactivate');
            }

            if (this.currentIndex === total - this.currentColumn) {
                this.$next.addClass('deactivate');
            } else {
                this.$next.removeClass('deactivate');
            }
        },


        resize: function () {
            this.resizeSlider();
        },

        resizeForm: function () {
            var $lastItem = this.$wrapper.find('.module-products-item:last').parent();

            if (!$lastItem.length) {
                this.$formWrapper.height('');
                return;
            }

            //Taken from custom.css
            // .module-products-infinite:not(.empty) .module-products-infinite-form:before
            var beforeHeight = 190;
            var lastItemHeight = $lastItem.outerHeight(true);

            var h = lastItemHeight - beforeHeight;

            this.$formWrapper.height(h);

            this.resizeSlider();
        },

        resizeSlider: function () {
            if (!this.$el.hasClass('module-products-infinite-slider')) return;

            // Remove class to calculate inner width.
            this.$wrapper.removeClass('disabled');

            var widthAvailable = this.$wrapper.innerWidth();
            var widthTotal = this.$wrapper.children().width() * this.$wrapper.children().length;
            var $body = $('body');
            var size = $body.attr('data-size') || 'xs';
            var index = 0;

            switch (size) {
                case 'lg':
                    index = 3;
                    break;
                case 'md':
                    index = 2;
                    break;
                case 'sm':
                    index = 1;
                    break;
                default:
                    index = 0;
            }

            //force 2 columns in .module-products
            if (!index && window.innerWidth >= 320 && this.$el.hasClass("module-products-force-columns")) {
                this.currentColumn = 2;
            } else if (!index && window.innerWidth >= 320) {
                this.currentColumn = 2;
            } else {
                this.currentColumn = this.columns[index];
            }

            this.$('.module-products-infinite-wrapper').scrollLeft(0);

            if (widthTotal > widthAvailable) {
                this.$prev.addClass('visible');
                this.$next.addClass('visible');
                this.$wrapper.removeClass('disabled');
            } else {
                this.$prev.removeClass('visible');
                this.$next.removeClass('visible');
                this.$wrapper.addClass('disabled');
            }

            this.setIndex(0);
        }

    });

    module.exports = ModuleProductsInfinite;
});

define('views/RecipesInfiniteView',['require','exports','module','backbone','models/UserModel','events/ThemeEvent'],function (require, exports, module) {
    'use strict';

    // External dependencies.
    var Backbone = require('backbone');
    var UserModel = require('models/UserModel');

    var ThemeEvent = require('events/ThemeEvent');
    var userModel = new UserModel();


    var ModuleRecipesInfinite = Backbone.View.extend({

        views: null,
        $wrapper: null,
        $formWrapper: null,
        $limit: null,
        $page: null,
        step: 0,
        template: null,
        columns: [1, 2, 3, 4],
        animationTime: 600,
        currentIndex: 0,
        currentColumn: 4,

        initialize: function (options) {
            this.views = [];

            options = _.extend({}, this.$el.data(), options);

            if (options.columns) {
                if (_.isArray(options.columns)) {
                    this.columns = options.columns;
                }
            }

            this.options = options;
            this.setIndex = _.bind(this.setIndex, this);
            this.prev = _.bind(_.throttle(this.prev, this.animationTime), this);
            this.next = _.bind(_.throttle(this.next, this.animationTime), this);
            this.resizeSlider = _.bind(this.resizeSlider, this);

            this.onSubmit = _.bind(this.onSubmit, this);
            this.onSuccess = _.bind(this.onSuccess, this);
            this.onError = _.bind(this.onError, this);
            this.debouncedResize = _.bind(_.debounce(this.debouncedResize, 50), this);
            this.resizeForm = _.bind(this.resizeForm, this);

            this.resize = _.bind(this.resize, this);

            this.el.moduleRecipesInfinite = this;

            this.render();
            this.submit();
        },

        events: {
            'click .module-products-infinite-slider-prev': 'onPrevClick',
            'click .module-products-infinite-slider-next': 'onNextClick',
            'swipeleft': "onSwipeLeft",
            'swiperight': "onSwipeRight"
        },

        render: function (e) {
            this.$wrapper = this.$('.module-products-infinite-wrapper:first');
            this.$formWrapper = this.$('.module-products-infinite-form:first');
            this.$form = this.$formWrapper.find('> form:first');
            this.$limit = this.$form.find('input[name="limit"]');
            this.$page = this.$form.find('input[name="page"]');

            this.$prev = this.$el.find(".module-products-infinite-slider-prev");
            this.$next = this.$el.find(".module-products-infinite-slider-next");

            this.step = parseInt(this.$form.find('input[name="step"]').val(), 10);

            this.template = _.template($(this.$el.data('template')).text());

            this.enableEvents();
            this.$el.addClass('rendered');
            this.resizeSlider();

            return this;
        },

        enableEvents: function () {
            this.$form.on('submit', this.onSubmit);
            this.$el.on('module-grid-view-resized', this.resizeForm);

            return this;
        },

        disableEvents: function () {
            this.$form.off('submit', this.onSubmit);
            this.$el.off('module-grid-view-resized', this.resizeForm);

            return this;
        },

        submit: function () {
            if (this.$form.length) {
                this.onSubmit();
            }
        },

        onSubmit: function (e) {
            if (e && e.preventDefault) e.preventDefault();
            if (this.$el.hasClass('loading')) return;

            var params = this.$form.find('[name="params"]').val();

            this.$el.addClass('loading');

            $.ajax({
                url: isapi.urls.recipesFetch + params,
                method: 'GET',
                beforeSend: $.proxy(function(xhr) {
                    userModel.addAuthToken(xhr);
                }, this),
                success: this.onSuccess,
                error: this.onError,
            });
        },

        onSuccess: function (data) {
            var formattedData = []
            var recipes = data.parts.recipes
            for (var i = 0; i < recipes.length; ++i) {
                var recipe = {};
                recipe.id = recipes[i].id;
                recipe.title = recipes[i].title;
                recipe.url = recipes[i].url;
                recipe.image = recipes[i].image;
                recipe.thumbs = recipes[i].thumbs;
                recipe.content = recipes[i].text;
                recipe.duration = recipes[i].duration;
                recipe.difficulty = recipes[i].difficulty;
                formattedData.push(recipe);
            }

            data.items = formattedData;
            var hasRecipes = (data && data.items && data.items.length);

            if (hasRecipes) {
                data = this.sortItems(data);
                this.renderRecipes(data);
            }

            if (hasRecipes && this.step) {
                this.prepareToLoadMore();
            } else {
                this.loadAllComplete();
            }

            this.$el.removeClass('empty loading');
        },

        onError: function (e) {
            this.$el.removeClass('loading');
        },

        sortItems: function (data) {
            var i, j, id,
                item = null,
                items = [],
                itemsSequence = null,
                requestParams = this.$form.serializeArray();

            for (i = 0; i < requestParams.length; i++) {
                if (requestParams[i].name === 'product') {
                    itemsSequence = requestParams[i].value;
                    break;
                }
            }

            if (itemsSequence) {
                itemsSequence = itemsSequence.split(',');

                for (i = 0; i < itemsSequence.length; i++) {
                    id = itemsSequence[i];

                    for (j = 0; j < data.items.length; j++) {
                        item = data.items[j];
                        if (id === item.id) {
                            items.push(item);
                        }
                    }
                }

                data.items = item;
            }

            return data;
        },

        renderRecipes: function (data) {
            var html = this.template(data);
            this.$wrapper.append(html);
            this.debouncedResize();
        },

        debouncedResize: function () {
            $(window).trigger('resize');
        },

        prepareToLoadMore: function () {
            var limit = parseInt(this.$limit.val(), 10),
                page = parseInt(this.$page.val(), 10);

            if (this.step) {
                this.$page.val(page + 1);
                this.$limit.val(this.step);
            } else {
                this.loadAllComplete();
            }
        },

        loadAllComplete: function () {
            this.$formWrapper.addClass('hidden');
        },

        onPrevClick: function (e) {
            if (e && e.preventDefault) e.preventDefault();

            this.prev();
        },

        onNextClick: function (e) {
            if (e && e.preventDefault) e.preventDefault();

            this.next();
        },

        onSwipeRight: function (e) {
            if (e && e.preventDefault) e.preventDefault();

            if ($('body').width() <= 768) {
                return;
            }

            this.prev();
        },

        onSwipeLeft: function (e) {
            if (e && e.preventDefault) e.preventDefault();

            if ($('body').width() <= 768) {
                return;
            }

            this.next();
        },

        prev: function (e) {
            if (this.$prev.hasClass('deactivate')) {
                return;
            }

            this.setIndex(-1, true);
        },

        next: function (e) {
            if (this.$next.hasClass('deactivate')) {
                return;
            }

            this.setIndex(1, true);
        },

        setIndex: function (index, relative) {
            var $items = this.$wrapper.children(),
                total = $items.length;

            if (!total) return;

            if (relative) {
                index = this.currentIndex + (index * this.currentColumn);
            }

            if (index < 0) {
                index = 0;

                if (index === this.currentIndex || index < 0) {
                    index = total - this.currentColumn;
                }
            } else if (index > total - this.currentColumn) {
                index = total - this.currentColumn;

                if (index === this.currentIndex || index < 0) {
                    index = 0;
                }
            }

            if (total < this.currentColumn) {
                index = 0;
            }

            this.currentIndex = index;

            var x = Math.floor(-100 * this.currentIndex);

            if (this.$el.hasClass("module-products-infinite-slider")) {
                TweenMax.to($items, this.animationTime / 1000, {
                    ease: Strong.easeInOut,
                    x: x + "%",
                    scale: 1.001,
                });
            }

            this.updateNav();
        },

        updateNav: function () {
            var $items = this.$wrapper.children(),
                total = $items.length;

            if (this.currentIndex === 0) {
                this.$prev.addClass('deactivate');
            } else {
                this.$prev.removeClass('deactivate');
            }

            if (this.currentIndex === total - this.currentColumn) {
                this.$next.addClass('deactivate');
            } else {
                this.$next.removeClass('deactivate');
            }
        },


        resize: function () {
            this.resizeSlider();
        },

        resizeForm: function () {
            var $lastItem = this.$wrapper.find('.module-products-item:last').parent();

            if (!$lastItem.length) {
                this.$formWrapper.height('');
                return;
            }

            //Taken from custom.css
            // .module-products-infinite:not(.empty) .module-products-infinite-form:before
            var beforeHeight = 190;
            var lastItemHeight = $lastItem.outerHeight(true);

            var h = lastItemHeight - beforeHeight;

            this.$formWrapper.height(h);

            this.resizeSlider();
        },

        resizeSlider: function () {
            if (!this.$el.hasClass('module-products-infinite-slider')) return;

            // Remove class to calculate inner width.
            this.$wrapper.removeClass('disabled');

            var widthAvailable = this.$wrapper.innerWidth();
            var widthTotal = this.$wrapper.children().width() * this.$wrapper.children().length;
            var $body = $('body');
            var size = $body.attr('data-size') || 'xs';
            var index = 0;

            switch (size) {
                case 'lg':
                    index = 3;
                    break;
                case 'md':
                    index = 2;
                    break;
                case 'sm':
                    index = 1;
                    break;
                default:
                    index = 0;
            }

            //force 2 columns in .module-products
            if (!index && window.innerWidth >= 320 && this.$el.hasClass("module-products-force-columns")) {
                this.currentColumn = 2;
            } else if (!index && window.innerWidth >= 320) {
                this.currentColumn = 2;
            } else {
                this.currentColumn = this.columns[index];
            }

            this.$('.module-products-infinite-wrapper').scrollLeft(0);

            if (widthTotal > widthAvailable) {
                this.$prev.addClass('visible');
                this.$next.addClass('visible');
                this.$wrapper.removeClass('disabled');
            } else {
                this.$prev.removeClass('visible');
                this.$next.removeClass('visible');
                this.$wrapper.addClass('disabled');
            }

            this.setIndex(0);
        }

    });

    module.exports = ModuleRecipesInfinite;
});

define('views/mixins/MixinModalView',['require','exports','module','theme','backbone','bowser','events/ThemeEvent','models/UserModel'],function (require, exports, module) {
    'use strict';

    // External dependencies.
    var theme = require('theme');
    var Backbone = require('backbone');
    var bowser = require('bowser');

    var ThemeEvent = require('events/ThemeEvent');
    var UserModel = require('models/UserModel');
    var userModel = new UserModel();


    var MixinModalView = Backbone.View.extend({

        /**
         * The payload params given through the constructor.
         */
        options: null,

        /**
         * The token retrieven from api.
         */
        token: null,

        /**
         * True if modal is active.
         */
        isActive: false,

        /**
         * True if the page must be reloaded after the modal has been hidden.
         */
        reloadOnHide: false,

        /**
         * The last product added to card.
         */
        lastProductAdded: null,

        initialize: function (options) {
            this.options = _.extend({}, this.$el.data(), options);

            this.render();
            this.addEventListeners();
        },

        render: function () {
            return this;
        },

        addEventListeners: function () {
            this.onInvokeModal = _.bind(this.onInvokeModal, this);
            this.onShowModal = _.bind(this.onShowModal, this);
            this.onShownModal = _.bind(this.onShownModal, this);
            this.onHideModal = _.bind(this.onHideModal, this);
            this.onHiddenModal = _.bind(this.onHiddenModal, this);

            this.$el.on('show.bs.modal', this.onShowModal);
            this.$el.on('hide.bs.modal', this.onHideModal);
            this.$el.on('shown.bs.modal', this.onShownModal);
            this.$el.on('hidden.bs.modal', this.onHiddenModal);
        },

        loading: function(value) {
            if (value) {
                this.$modalContent.empty();
                this.$modalContent.addClass('module-loading loading').removeClass('hidden');
            } else {
                this.$modalContent.removeClass('module-loading loading');
            }
        },

        renderRecommendedProducts: function () {
            var templateRecommendedProducts = _.template($('#modal-recommended-products').html()),
                html = templateRecommendedProducts({
                    trigger: this.trigger,
                    products: userModel.get('productsRecommended'),
                });

            this.$modalContent.append(html);
            $('body').trigger('refresh.theme');
        },

        handleAuthTokenExpired: function () {
            this.loading(false);
            this.reloadOnHide = true;
            userModel.clearCookie();
            this.renderAuthTokenExpired();
        },

        renderAuthTokenExpired: function (message) {
            var templateAuthTokenExpired = _.template($('#auth-token-expired').html()),
                html = templateAuthTokenExpired(),
                $loginButton = null;

            this.$modalContent.empty().html(html);

            $loginButton = this.$modalContent.find('a[data-trigger="login"]');
            $loginButton.on('click', $.proxy(function(e) {
                e.preventDefault();
                userModel.storeLogin();
                this.$el.modal('hide');
            }, this));

            $('body').trigger('refresh.theme');
        },

        onInvokeModal: function (e) {

        },

        onShowModal: function (e) {
            this.isActive = true;
            $(document).on('click', '.module-modal-recommended-item-button .btn', _.bind(this.onAdd2CardClick, this));
        },

        onShownModal: function (e) {

        },

        onHideModal: function () {
            $(document).off('click', '.module-modal-recommended-item-button .btn');
        },

        onHiddenModal: function () {
            this.isActive = false;

            if (!userModel.isLoggedIn()) {
                $(window).trigger(ThemeEvent.LOGIN_CANCELLED);
            }

            if (this.reloadOnHide) {
                _.delay(function () {
                    document.location.reload(true);
                }, 500);
            }
        },

        onError: function(e) {
            if (!this.isActive) return;

            this.lastProductAdded = null;
        },

        showErrorMessage: function(message) {
            var html = this.$errorMessage.html();

            this.loading(false);
            this.$modalContent.empty().html(html);

            if (message) {
                this.$modalContent.find('.message').text(message);
            }
        },

        showSuccessMessage: function(message) {
            var html = this.$successMessage.html();

            this.loading(false);
            this.$modalContent.empty().html(html);

            if (message) {
                this.$modalContent.find('.message').text(message);
            }
        },

        getOrigin: function() {
            var hostname = document.location.hostname,
                regex = /^(kombi)?shop/,
                origin = regex.test(hostname) ? 'Shop' : 'CMS-Default';

            return origin;
        },

        onAdd2CardClick: function(e) {
            var $invoker = $(e.currentTarget),
                origin = this.getOrigin(),
                products = $invoker.data('products'),
                productName = '';

            e.preventDefault();

            // Prevent previous request to be overwritten.
            if (this.lastProductAdded) {
                return;
            }

            productName = $invoker
                .closest('.module-modal-recommended-item')
                .find('.module-modal-recommended-item-text .title')
                .text();

            productName = productName.trim();

            this.loadRecommended = false;
            this.lastProductAdded = {
                id: products.products[0].number,
                name: productName,
            };

            userModel.set('origin', origin);
            userModel.set('productsToCart', products);
            userModel.addToCart();
        },

        updateSuccessMessage: function() {
            var $recommendedItem = this.$('.module-modal-recommended-item[data-product-id="' + this.lastProductAdded.id + '"]');
            var tmpl = _.template($('#modal-recommended-add-to-cart-success').html());

            $recommendedItem.find('.icon-einkaufswagen').addClass('hidden');
            $recommendedItem.find('.icon-haken').removeClass('hidden');

            this.$('.modal-header .modal-title').remove();
            this.$('.modal-header .modal-subtitle').remove();
            this.$('.modal-header')
                .append($(
                  tmpl({
                      product: this.lastProductAdded,
                      total: userModel.get('products').length,
                  })
                ));

            _.delay(_.bind(function() {
                $recommendedItem.find('.icon-haken').addClass('hidden');
                $recommendedItem.find('.icon-einkaufswagen').removeClass('hidden');

                this.lastProductAdded = null;
            }, this), 500);
        },
    });

    module.exports = MixinModalView;
});

define('views/RatingView',['require','exports','module','theme','backbone','bowser','store2','views/mixins/MixinModalView','events/ThemeEvent','models/UserModel'],function (require, exports, module) {
    'use strict';

    // External dependencies.
    var theme = require('theme');
    var Backbone = require('backbone');
    var bowser = require('bowser');
    var store = require('store2');

    var MixinModalView = require('views/mixins/MixinModalView');

    var ThemeEvent = require('events/ThemeEvent');
    var UserModel = require('models/UserModel');
    var userModel = new UserModel();


    var ModuleRattingView = Backbone.View.extend({

        /**
        * The actions this view is interested in.
        */
        actions: [
            '',
        ],

        initialize: function (options) {
            this.options = _.extend({}, this.$el.data(), options);

            this.initialRating = this.options.initialRating;
            this.ratingType = this.options.type;

            this.onLoginComplete = _.bind(this.onLoginComplete, this);
            this.onLoginCancelled = _.bind(this.onLoginCancelled, this);

            this.render();
            this.addEventListeners();

            // Wake up module aftetr a minimum delay
            // to allow it be rendered from other Modules.
            _.delay(_.bind(this.wakeUp, this), 1);
        },

        render: function () {
            this.$form = this.$('form');
            this.$stars = this.$('li.star');

            this.$legendTexts = this.$('.rating-legend .text');

            return this;
        },

        addEventListeners: function () {
            this.$stars.on('click', _.bind(this.onStarClick, this));
            this.$stars.on('mouseenter', _.bind(this.onStarMouseEnter, this));
            this.$('ul').on('mouseleave', _.bind(this.onStarsMouseLeave, this));
            this.$el.on('show-rating-success', _.bind(this.onRatingSuccess, this));

            var $collapseReviewProduct = $('.collapse-review-product:not(.rendered)').on('click', _.bind(this.collapseReviewProduct, this));
            $collapseReviewProduct.addClass('rendered');
        },

        wakeUp: function () {
            this.checkRatingInStorage();
        },

        checkRatingInStorage: function () {
            var rating = store.session.get(this.ratingType);

            if (rating && rating.id === this.getId()) {
                store.session.remove(this.ratingType);

                if (userModel.isLoggedIn()) {
                    this.setRating(rating.value);
                    if (this.ratingType === ModuleRattingView.TYPE_RECIPE) {
                        this.updateStars(rating.value);
                        this.doRating();
                    } else if (this.ratingType === ModuleRattingView.TYPE_PRODUCT) {
                        this.triggerRatingProduct();
                    }
                }
            }
        },

        getId: function () {
            if (this.ratingType === ModuleRattingView.TYPE_RECIPE) {
                return this.$form.find('input[name="context_id"]').val();
            } else if (this.ratingType === ModuleRattingView.TYPE_PRODUCT) {
                return this.$form.find('input[name="product-id"]').val();
            }
        },

        /**
         * Get rating.
         *
         * @return  {Number | undefined}
         */
        getRating: function () {
            return this.$form.find('input[name="rating"]').val();
        },

        /**
         * Set rating.
         *
         * @param  {Number} value
         */
        setRating: function (value) {
            this.$form.find('input[name="rating"]').val(value);
        },

        /**
         * Pass rating to be stored to login/resgistration modal.
         *
         * @param  {Object} rating
         */
        storeRating: function (id, value) {
            var rating = null;

            rating = {};
            rating[this.ratingType] = {
                'id': id,
                'value': value,
            };

            store.session(rating);
        },

        onStarClick: function (e) {
            var $el = $(e.currentTarget),
                rating = $el.index() + 1;

            if (!this.$el.hasClass('enabled')) return;

            this.setRating(rating);

            if (userModel.isLoggedIn()) {
                if (this.ratingType === ModuleRattingView.TYPE_RECIPE) {
                    this.doRating();
                } else if (this.ratingType === ModuleRattingView.TYPE_PRODUCT) {
                    this.triggerRatingProduct();
                    this.$el.addClass('effect rating-success');
                }
            } else {
                $(window).on(ThemeEvent.LOGIN_COMPLETE, this.onLoginComplete);
                $(window).on(ThemeEvent.LOGIN_CANCELLED, this.onLoginCancelled);
                $('#modal-add-to-cart').modal({show: true});
            }
        },

        triggerRatingProduct: function () {
            $(window).trigger('rating-product', [this.getId(), this.getRating()]);
        },

        onLoginComplete: function () {
            $(window).off(ThemeEvent.LOGIN_COMPLETE, this.onLoginComplete);
            $(window).off(ThemeEvent.LOGIN_CANCELLED, this.onLoginCancelled);

            if (this.getId() && this.getRating()) {
                this.storeRating(this.getId(), this.getRating());
            }
        },

        onLoginCancelled: function () {
            $(window).off(ThemeEvent.LOGIN_COMPLETE, this.onLoginComplete);
            $(window).off(ThemeEvent.LOGIN_CANCELLED, this.onLoginCancelled);
        },

        onStarMouseEnter: function (e) {
            var $el = $(e.currentTarget),
                rating = $el.index() + 1;

            if (rating !== this.getRating()) {
                this.updateStars(rating);
                this.updateLegend(rating);
            }
        },

        onStarsMouseLeave: function (e) {
            if (this.$el.hasClass('rating-success')) {
                this.updateStars(this.getRating());
                this.updateLegend(this.getRating());
            } else if (!this.$el.hasClass('rating-success') && !this.$el.hasClass('effect')) {
                this.updateStars(this.initialRating);
                this.updateLegend(-1);
            }
        },

        updateStars: function (rating, force) {
            if (!this.$el.hasClass('enabled') && force !== true) {
                return;
            }

            this.$stars.slice(0, rating).find('.icon-stern_gefuellt').addClass('active').removeClass('no-active');
            this.$stars.slice(0, rating).find('.icon-stern').addClass('no-active').removeClass('active');

            this.$stars.slice(rating, this.$stars.length).find('.icon-stern').addClass('active').removeClass('no-active');
            this.$stars.slice(rating, this.$stars.length).find('.icon-stern_gefuellt').addClass('no-active').removeClass('active');
        },

        updateLegend: function (rating, force) {
            if (this.$legendTexts.length === 0) {
                return;
            }

            if (!this.$el.hasClass('enabled') && force !== true) {
                return;
            }

            this.$legendTexts.addClass('hidden');

            if (rating >= 0) {
                this.$legendTexts.eq(rating - 1).removeClass('hidden');
            }
        },

        doRating: function () {
            var data = this.$form.serialize();

            if (!this.$el.hasClass('enabled')) return;

            if (this.ratingType === ModuleRattingView.TYPE_RECIPE) {
                this.$el.removeClass('enabled');
            }

            $.ajax({
                url: this.$form.attr('action'),
                method: 'POST',
                data: data,
                success: _.bind(this.onRatingSuccess, this),
                error: _.bind(this.onRatingError, this),
            });
        },

        onRatingSuccess: function(response) {
            var $activeIcons = null,
                $inactiveIcons = null,
                $clones = null,
                thiz = this;

            this.updateStars(this.getRating(), true);

            if (this.ratingType === ModuleRattingView.TYPE_PRODUCT) {
                this.$legendTexts.find('.icon-haken').removeClass('visible').addClass('invisible');
                this.$legendTexts.eq(this.getRating() - 1).find('.icon-haken').removeClass('invisible').addClass('visible');
            }

            if (!this.$el.hasClass('effect')) {
                $activeIcons = this.$stars.find('.icon-stern_gefuellt')
                    .slice(0, this.getRating())
                    .addClass('active')
                    .removeClass('no-active');

                if (!$activeIcons.length) {
                    return;
                }

                $activeIcons.each(function(index, el) {
                    var $el = $(el),
                        $clone = $el
                            .clone()
                            .addClass('effect');

                    $el.parent().prepend($clone);
                });

                $clones = this.$stars.find('.icon.effect');

                TweenMax.staggerTo($clones, 0.5, {y: -1, opacity: 0, scale: 2, ease: Power1.easeOut}, 0.15, function() {
                    $clones.remove();
                    thiz.$el.removeClass('effect');
                });
            }
        },

        onRatingError: function(e) {
            this.$el.removeClass('enabled');
        },

        collapseReviewProduct: function(e) {
            var $el = $(e.currentTarget),
                $collapsable = $('#' + $el.attr('aria-controls')),
                $collapsableToggle = $collapsable.parent(),
                size = $('body').attr('data-size'),
                y = 0,
                marginTop = 0;

            if (size === 'xs' || size === 'sm') {
                marginTop = -80;
            } else {
                marginTop = -232;
            }

            if ($collapsable.length) {
                y = $collapsableToggle.offset().top + marginTop;

                TweenMax.to(window, 0.5, {
                    ease: Strong.easeOut,
                    scrollTo: {
                        y: y
                    }
                });

                if (!$collapsable.is(':visible')) {
                    $collapsable.collapse('show');
                }
            }
        },
    });

    ModuleRattingView.TYPE_RECIPE = 'rating-recipe';
    ModuleRattingView.TYPE_PRODUCT = 'rating-product';

    module.exports = ModuleRattingView;
});

define('views/ProductsCarouselView',['require','exports','module','theme','backbone'],function (require, exports, module) {
    "use strict";

    // External dependencies.
    var theme = require("theme");
    var Backbone = require("backbone");

    var ModuleProductsCarouselView = Backbone.View.extend({

        views: null,
        columns: [1, 2, 3, 3],
        animationTime: 600,
        currentIndex: 0,
        currentColumn: 3,

        initialize: function (options) {
            this.views = [];

            options = _.extend({}, this.$el.data(), options);

            if (options.columns) {
                if (_.isArray(options.columns)) {
                    this.columns = options.columns;
                }
            }

            this.setIndex = _.bind(this.setIndex, this);
            this.prev = _.bind(_.throttle(this.prev, this.animationTime), this);
            this.next = _.bind(_.throttle(this.next, this.animationTime), this);

            this.el.moduleProductsCarouselView = this;

            this.render();
        },

        events: {
            'click .module-products-carousel-navigation-prev': "onPrevClick",
            'click .module-products-carousel-navigation-next': "onNextClick",
            'swipeleft': "onSwipeLeft",
            'swiperight': "onSwipeRight"
        },

        render: function (e) {
            this.$wrapper = this.$el.find(".module-products-carousel-items:first");
            this.$prev = this.$el.find(".module-products-carousel-navigation-prev");
            this.$next = this.$el.find(".module-products-carousel-navigation-next");
            this.$lis = this.$el.find(".module-products-carousel-items > li");

            this.enableEvents();

            this.$el.addClass("rendered");

            this.resize();
        },

        onPrevClick: function (e) {
            if (e && e.preventDefault) e.preventDefault();

            this.prev();
        },

        onNextClick: function (e) {
            if (e && e.preventDefault) e.preventDefault();

            this.next();
        },

        onSwipeRight: function (e) {
            if (e && e.preventDefault) e.preventDefault();

            this.prev();
        },

        onSwipeLeft: function (e) {
            if (e && e.preventDefault) e.preventDefault();

            this.next();
        },

        prev: function (e) {
            if (this.$prev.hasClass('deactivate')) {
                return;
            }

            this.setIndex(-1, true);
        },

        next: function (e) {
            if (this.$next.hasClass('deactivate')) {
                return;
            }

            this.setIndex(1, true);
        },

        setIndex: function (index, relative) {
            var total = this.$lis.length;

            if (relative) {
                index = this.currentIndex + (index * this.currentColumn);
            }

            if (index < 0) {
                index = 0;
            }

            if (index > total - this.currentColumn) {
                index = total - this.currentColumn;
            }

            this.currentIndex = index;

            var x = Math.floor(-100 * this.currentIndex);

            TweenMax.to(this.$lis, this.animationTime / 1000, {
                ease: Strong.easeInOut,
                x: x + "%"
            });

            this.updateNav();
        },

        updateNav: function () {
            var $items = this.$wrapper.children(),
                total = $items.length;

            if (this.currentIndex === 0) {
                this.$prev.addClass('deactivate');
            } else {
                this.$prev.removeClass('deactivate');
            }

            if (this.currentIndex === total - this.currentColumn) {
                this.$next.addClass('deactivate');
            } else {
                this.$next.removeClass('deactivate');
            }
        },

        enableEvents: function () {
            //Remove previous events
            this.disableEvents();

            return this;
        },

        disableEvents: function () {
            return this;
        },

        resize: function (e) {
            var widthTotal = this.$wrapper.children().width() * this.$wrapper.children().length;
            var widthAvailable = this.$wrapper.innerWidth();
            var size = $("body").attr("data-size") || "xs";
            var index = 0;

            switch (size) {
            case "lg":
                index = 3;
                break;
            case "md":
                index = 2;
                break;
            case "sm":
                index = 1;
                break;
            default:
                index = 0;
            }

            this.currentColumn = this.columns[index];

            if ($('body').width() > 768) {
                this.$('.wrapper').scrollLeft(0);
            }

            if (widthTotal > widthAvailable) {
                this.$prev.addClass('visible');
                this.$next.addClass('visible');
            } else {
                this.$prev.removeClass('visible');
                this.$next.removeClass('visible');
            }

            this.setIndex(0);
        },
    });

    module.exports = ModuleProductsCarouselView;
});

define('views/BannerCarouselView',['require','exports','module','theme','backbone'],function (require, exports, module) {
    "use strict";

    // External dependencies.
    var theme = require("theme");
    var Backbone = require("backbone");

    var ModuleBannerCarouselView = Backbone.View.extend({

        views: null,
        columns: [1, 2, 3, 3],
        animationTime: 600,
        currentIndex: 0,
        currentColumn: 3,

        defaults: {
            loop: true,
            paused: false,
            time: 4,
            stopOnFocus: true,
            infiniteLoop: true,
        },

        initialize: function (options) {
            this.views = [];

            options = _.extend({}, this.defaults, this.$el.data(), options);

            if (options.columns) {
                if (_.isArray(options.columns)) {
                    this.columns = options.columns;
                }
            }

            this.loop = options.loop;
            this.paused = options.paused;
            this.time = options.time;
            this.stopOnFocus = options.stopOnFocus;
            this.infiniteLoop = options.infiniteLoop;

            this.setIndex = _.bind(this.setIndex, this);
            this.prev = _.bind(_.throttle(this.prev, this.animationTime), this);
            this.next = _.bind(_.throttle(this.next, this.animationTime), this);

            this.el.ModuleBannerCarouselView = this;

            this.render();
        },

        events: {
            'click .module-banner-carousel-navigation-prev': "onPrevClick",
            'click .module-banner-carousel-navigation-next': "onNextClick",
            'swipeleft': "onSwipeLeft",
            'swiperight': "onSwipeRight"
        },

        render: function (e) {
            this.$wrapper = this.$el.find(".module-banner-carousel-wrapper:first");
            this.$prev = this.$el.find(".module-banner-carousel-navigation-prev");
            this.$next = this.$el.find(".module-banner-carousel-navigation-next");
            this.$items = this.$el.find(".module-banner-carousel-item");

            this.enableEvents();

            this.$el.addClass("rendered");
            this.setPauseOff();

            this.resize();
        },

        onPrevClick: function (e) {
            if (e && e.preventDefault) e.preventDefault();

            this.prev();
        },

        onNextClick: function (e) {
            if (e && e.preventDefault) e.preventDefault();

            this.next();
        },

        onSwipeRight: function (e) {
            if (e && e.preventDefault) e.preventDefault();

            this.prev();
        },

        onSwipeLeft: function (e) {
            if (e && e.preventDefault) e.preventDefault();

            this.next();
        },

        clearLoop: function (e) {
            TweenMax.clearTimeout(this.loopingTween);
        },

        setLoop: function (e) {
            this.clearLoop();

            if (!this.loop) return;
            if (this.paused) return;

            this.loopingTween = TweenMax.setTimeout(_.bind(this.doLoop, this), this.time, this, [1, true]);
        },

        doLoop: function (direction, relative) {
            if (!this.loop) return;
            if (this.paused) return;

            if (direction > 0) {
                this.next();
            } else if (direction < 0) {
                this.prev();
            }

            this.setLoop();
        },

        setPauseOn: function () {
            this.paused = true;
            this.clearLoop();
        },

        setPauseOff: function () {
            this.paused = false;
            this.setLoop();
        },

        onPlay: function (e) {
            this.loop = true;
        },

        onPause: function (e) {
            this.setPauseOn();
        },

        onResume: function (e) {
            this.setPauseOff();
        },

        onStop: function (e) {
            this.loop = false;
        },

        prev: function (e) {
            if (this.$prev.hasClass('deactivate')) {
                return;
            }

            this.setIndex(-1, true);
        },

        next: function (e) {
            if (this.$next.hasClass('deactivate')) {
                return;
            }

            this.setIndex(1, true);
        },

        setIndex: function (index, relative) {
            var total = this.$items.length;

            if (relative) {
                index = this.currentIndex + (index * this.currentColumn);
            }

            this.currentIndex = index;

            if (!this.infiniteLoop) {
                if (this.currentIndex < 0) {
                    this.currentIndex = 0;
                } else if (this.currentIndex >= total) {
                    this.currentIndex = total - 1;
                }
            } else {
                if (this.currentIndex < 0) {
                    this.currentIndex = total - 1;
                } else if (this.currentIndex >= total) {
                    this.currentIndex = 0;
                }
            }

            var x = Math.floor(-100 * this.currentIndex);

            TweenMax.to(this.$items, this.animationTime / 1000, {
                ease: Strong.easeInOut,
                x: x + "%",
                onCompleteScope: this,
                onComplete: function () {
                    this.moving = false;
                }
            });

            this.updateNav();
        },

        updateNav: function () {
            var $items = this.$wrapper.children(),
                total = $items.length;

            if (this.currentIndex === 0) {
                this.$prev.addClass('deactivate');
            } else {
                this.$prev.removeClass('deactivate');
            }

            if (this.currentIndex === total - this.currentColumn) {
                this.$next.addClass('deactivate');
            } else {
                this.$next.removeClass('deactivate');
            }
        },

        enableEvents: function () {
            //Remove previous events
            this.disableEvents();

            if (this.stopOnFocus) {
                this.$el.on("mouseenter", _.bind(this.setPauseOn, this));
                this.$el.on("mouseleave", _.bind(this.setPauseOff, this));
            }

            this.$el.on(ModuleBannerCarouselView.PLAY, _.bind(this.onPlay, this));
            this.$el.on(ModuleBannerCarouselView.PAUSE, _.bind(this.onPause, this));
            this.$el.on(ModuleBannerCarouselView.RESUME, _.bind(this.onResume, this));
            this.$el.on(ModuleBannerCarouselView.STOP, _.bind(this.onStop, this));

            return this;
        },

        disableEvents: function () {

            return this;
        },

        resize: function (e) {
            var widthTotal = this.$wrapper.children().width() * this.$wrapper.children().length;
            var widthAvailable = this.$wrapper.innerWidth();
            var size = $("body").attr("data-size") || "xs";
            var index = 0;

            switch (size) {
            case "lg":
                index = 3;
                break;
            case "md":
                index = 2;
                break;
            case "sm":
                index = 1;
                break;
            default:
                index = 0;
            }

            this.currentColumn = this.columns[index];

            if ($('body').width() > 768) {
                this.$('.wrapper').scrollLeft(0);
            }

            if (widthTotal > widthAvailable) {
                this.$prev.addClass('visible');
                this.$next.addClass('visible');
            } else {
                this.$prev.removeClass('visible');
                this.$next.removeClass('visible');
            }

            this.setIndex(0);
        },
    });

    // Static events
    ModuleBannerCarouselView.READY = 'module-carousel.ready';

    ModuleBannerCarouselView.CHANGE = 'module-carousel.change';
    ModuleBannerCarouselView.PLAY = 'module-carousel.play';
    ModuleBannerCarouselView.PAUSE = 'module-carousel.pause';
    ModuleBannerCarouselView.RESUME = 'module-carousel.resume';
    ModuleBannerCarouselView.STOP = 'module-carousel.stop';

    module.exports = ModuleBannerCarouselView;
});

/**
 * Swiper 4.5.3
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://www.idangero.us/swiper/
 *
 * Copyright 2014-2019 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: October 16, 2019
 */

(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define('swiper',factory) :
  (global = global || self, global.Swiper = factory());
}(this, function () { 'use strict';

  /**
   * SSR Window 1.0.1
   * Better handling for window object in SSR environment
   * https://github.com/nolimits4web/ssr-window
   *
   * Copyright 2018, Vladimir Kharlampidi
   *
   * Licensed under MIT
   *
   * Released on: July 18, 2018
   */
  var doc = (typeof document === 'undefined') ? {
    body: {},
    addEventListener: function addEventListener() {},
    removeEventListener: function removeEventListener() {},
    activeElement: {
      blur: function blur() {},
      nodeName: '',
    },
    querySelector: function querySelector() {
      return null;
    },
    querySelectorAll: function querySelectorAll() {
      return [];
    },
    getElementById: function getElementById() {
      return null;
    },
    createEvent: function createEvent() {
      return {
        initEvent: function initEvent() {},
      };
    },
    createElement: function createElement() {
      return {
        children: [],
        childNodes: [],
        style: {},
        setAttribute: function setAttribute() {},
        getElementsByTagName: function getElementsByTagName() {
          return [];
        },
      };
    },
    location: { hash: '' },
  } : document; // eslint-disable-line

  var win = (typeof window === 'undefined') ? {
    document: doc,
    navigator: {
      userAgent: '',
    },
    location: {},
    history: {},
    CustomEvent: function CustomEvent() {
      return this;
    },
    addEventListener: function addEventListener() {},
    removeEventListener: function removeEventListener() {},
    getComputedStyle: function getComputedStyle() {
      return {
        getPropertyValue: function getPropertyValue() {
          return '';
        },
      };
    },
    Image: function Image() {},
    Date: function Date() {},
    screen: {},
    setTimeout: function setTimeout() {},
    clearTimeout: function clearTimeout() {},
  } : window; // eslint-disable-line

  /**
   * Dom7 2.1.3
   * Minimalistic JavaScript library for DOM manipulation, with a jQuery-compatible API
   * http://framework7.io/docs/dom.html
   *
   * Copyright 2019, Vladimir Kharlampidi
   * The iDangero.us
   * http://www.idangero.us/
   *
   * Licensed under MIT
   *
   * Released on: February 11, 2019
   */

  var Dom7 = function Dom7(arr) {
    var self = this;
    // Create array-like object
    for (var i = 0; i < arr.length; i += 1) {
      self[i] = arr[i];
    }
    self.length = arr.length;
    // Return collection with methods
    return this;
  };

  function $(selector, context) {
    var arr = [];
    var i = 0;
    if (selector && !context) {
      if (selector instanceof Dom7) {
        return selector;
      }
    }
    if (selector) {
        // String
      if (typeof selector === 'string') {
        var els;
        var tempParent;
        var html = selector.trim();
        if (html.indexOf('<') >= 0 && html.indexOf('>') >= 0) {
          var toCreate = 'div';
          if (html.indexOf('<li') === 0) { toCreate = 'ul'; }
          if (html.indexOf('<tr') === 0) { toCreate = 'tbody'; }
          if (html.indexOf('<td') === 0 || html.indexOf('<th') === 0) { toCreate = 'tr'; }
          if (html.indexOf('<tbody') === 0) { toCreate = 'table'; }
          if (html.indexOf('<option') === 0) { toCreate = 'select'; }
          tempParent = doc.createElement(toCreate);
          tempParent.innerHTML = html;
          for (i = 0; i < tempParent.childNodes.length; i += 1) {
            arr.push(tempParent.childNodes[i]);
          }
        } else {
          if (!context && selector[0] === '#' && !selector.match(/[ .<>:~]/)) {
            // Pure ID selector
            els = [doc.getElementById(selector.trim().split('#')[1])];
          } else {
            // Other selectors
            els = (context || doc).querySelectorAll(selector.trim());
          }
          for (i = 0; i < els.length; i += 1) {
            if (els[i]) { arr.push(els[i]); }
          }
        }
      } else if (selector.nodeType || selector === win || selector === doc) {
        // Node/element
        arr.push(selector);
      } else if (selector.length > 0 && selector[0].nodeType) {
        // Array of elements or instance of Dom
        for (i = 0; i < selector.length; i += 1) {
          arr.push(selector[i]);
        }
      }
    }
    return new Dom7(arr);
  }

  $.fn = Dom7.prototype;
  $.Class = Dom7;
  $.Dom7 = Dom7;

  function unique(arr) {
    var uniqueArray = [];
    for (var i = 0; i < arr.length; i += 1) {
      if (uniqueArray.indexOf(arr[i]) === -1) { uniqueArray.push(arr[i]); }
    }
    return uniqueArray;
  }

  // Classes and attributes
  function addClass(className) {
    if (typeof className === 'undefined') {
      return this;
    }
    var classes = className.split(' ');
    for (var i = 0; i < classes.length; i += 1) {
      for (var j = 0; j < this.length; j += 1) {
        if (typeof this[j] !== 'undefined' && typeof this[j].classList !== 'undefined') { this[j].classList.add(classes[i]); }
      }
    }
    return this;
  }
  function removeClass(className) {
    var classes = className.split(' ');
    for (var i = 0; i < classes.length; i += 1) {
      for (var j = 0; j < this.length; j += 1) {
        if (typeof this[j] !== 'undefined' && typeof this[j].classList !== 'undefined') { this[j].classList.remove(classes[i]); }
      }
    }
    return this;
  }
  function hasClass(className) {
    if (!this[0]) { return false; }
    return this[0].classList.contains(className);
  }
  function toggleClass(className) {
    var classes = className.split(' ');
    for (var i = 0; i < classes.length; i += 1) {
      for (var j = 0; j < this.length; j += 1) {
        if (typeof this[j] !== 'undefined' && typeof this[j].classList !== 'undefined') { this[j].classList.toggle(classes[i]); }
      }
    }
    return this;
  }
  function attr(attrs, value) {
    var arguments$1 = arguments;

    if (arguments.length === 1 && typeof attrs === 'string') {
      // Get attr
      if (this[0]) { return this[0].getAttribute(attrs); }
      return undefined;
    }

    // Set attrs
    for (var i = 0; i < this.length; i += 1) {
      if (arguments$1.length === 2) {
        // String
        this[i].setAttribute(attrs, value);
      } else {
        // Object
        // eslint-disable-next-line
        for (var attrName in attrs) {
          this[i][attrName] = attrs[attrName];
          this[i].setAttribute(attrName, attrs[attrName]);
        }
      }
    }
    return this;
  }
  // eslint-disable-next-line
  function removeAttr(attr) {
    for (var i = 0; i < this.length; i += 1) {
      this[i].removeAttribute(attr);
    }
    return this;
  }
  function data(key, value) {
    var el;
    if (typeof value === 'undefined') {
      el = this[0];
      // Get value
      if (el) {
        if (el.dom7ElementDataStorage && (key in el.dom7ElementDataStorage)) {
          return el.dom7ElementDataStorage[key];
        }

        var dataKey = el.getAttribute(("data-" + key));
        if (dataKey) {
          return dataKey;
        }
        return undefined;
      }
      return undefined;
    }

    // Set value
    for (var i = 0; i < this.length; i += 1) {
      el = this[i];
      if (!el.dom7ElementDataStorage) { el.dom7ElementDataStorage = {}; }
      el.dom7ElementDataStorage[key] = value;
    }
    return this;
  }
  // Transforms
  // eslint-disable-next-line
  function transform(transform) {
    for (var i = 0; i < this.length; i += 1) {
      var elStyle = this[i].style;
      elStyle.webkitTransform = transform;
      elStyle.transform = transform;
    }
    return this;
  }
  function transition(duration) {
    if (typeof duration !== 'string') {
      duration = duration + "ms"; // eslint-disable-line
    }
    for (var i = 0; i < this.length; i += 1) {
      var elStyle = this[i].style;
      elStyle.webkitTransitionDuration = duration;
      elStyle.transitionDuration = duration;
    }
    return this;
  }
  // Events
  function on() {
    var assign;

    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];
    var eventType = args[0];
    var targetSelector = args[1];
    var listener = args[2];
    var capture = args[3];
    if (typeof args[1] === 'function') {
      (assign = args, eventType = assign[0], listener = assign[1], capture = assign[2]);
      targetSelector = undefined;
    }
    if (!capture) { capture = false; }

    function handleLiveEvent(e) {
      var target = e.target;
      if (!target) { return; }
      var eventData = e.target.dom7EventData || [];
      if (eventData.indexOf(e) < 0) {
        eventData.unshift(e);
      }
      if ($(target).is(targetSelector)) { listener.apply(target, eventData); }
      else {
        var parents = $(target).parents(); // eslint-disable-line
        for (var k = 0; k < parents.length; k += 1) {
          if ($(parents[k]).is(targetSelector)) { listener.apply(parents[k], eventData); }
        }
      }
    }
    function handleEvent(e) {
      var eventData = e && e.target ? e.target.dom7EventData || [] : [];
      if (eventData.indexOf(e) < 0) {
        eventData.unshift(e);
      }
      listener.apply(this, eventData);
    }
    var events = eventType.split(' ');
    var j;
    for (var i = 0; i < this.length; i += 1) {
      var el = this[i];
      if (!targetSelector) {
        for (j = 0; j < events.length; j += 1) {
          var event = events[j];
          if (!el.dom7Listeners) { el.dom7Listeners = {}; }
          if (!el.dom7Listeners[event]) { el.dom7Listeners[event] = []; }
          el.dom7Listeners[event].push({
            listener: listener,
            proxyListener: handleEvent,
          });
          el.addEventListener(event, handleEvent, capture);
        }
      } else {
        // Live events
        for (j = 0; j < events.length; j += 1) {
          var event$1 = events[j];
          if (!el.dom7LiveListeners) { el.dom7LiveListeners = {}; }
          if (!el.dom7LiveListeners[event$1]) { el.dom7LiveListeners[event$1] = []; }
          el.dom7LiveListeners[event$1].push({
            listener: listener,
            proxyListener: handleLiveEvent,
          });
          el.addEventListener(event$1, handleLiveEvent, capture);
        }
      }
    }
    return this;
  }
  function off() {
    var assign;

    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];
    var eventType = args[0];
    var targetSelector = args[1];
    var listener = args[2];
    var capture = args[3];
    if (typeof args[1] === 'function') {
      (assign = args, eventType = assign[0], listener = assign[1], capture = assign[2]);
      targetSelector = undefined;
    }
    if (!capture) { capture = false; }

    var events = eventType.split(' ');
    for (var i = 0; i < events.length; i += 1) {
      var event = events[i];
      for (var j = 0; j < this.length; j += 1) {
        var el = this[j];
        var handlers = (void 0);
        if (!targetSelector && el.dom7Listeners) {
          handlers = el.dom7Listeners[event];
        } else if (targetSelector && el.dom7LiveListeners) {
          handlers = el.dom7LiveListeners[event];
        }
        if (handlers && handlers.length) {
          for (var k = handlers.length - 1; k >= 0; k -= 1) {
            var handler = handlers[k];
            if (listener && handler.listener === listener) {
              el.removeEventListener(event, handler.proxyListener, capture);
              handlers.splice(k, 1);
            } else if (listener && handler.listener && handler.listener.dom7proxy && handler.listener.dom7proxy === listener) {
              el.removeEventListener(event, handler.proxyListener, capture);
              handlers.splice(k, 1);
            } else if (!listener) {
              el.removeEventListener(event, handler.proxyListener, capture);
              handlers.splice(k, 1);
            }
          }
        }
      }
    }
    return this;
  }
  function trigger() {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var events = args[0].split(' ');
    var eventData = args[1];
    for (var i = 0; i < events.length; i += 1) {
      var event = events[i];
      for (var j = 0; j < this.length; j += 1) {
        var el = this[j];
        var evt = (void 0);
        try {
          evt = new win.CustomEvent(event, {
            detail: eventData,
            bubbles: true,
            cancelable: true,
          });
        } catch (e) {
          evt = doc.createEvent('Event');
          evt.initEvent(event, true, true);
          evt.detail = eventData;
        }
        // eslint-disable-next-line
        el.dom7EventData = args.filter(function (data, dataIndex) { return dataIndex > 0; });
        el.dispatchEvent(evt);
        el.dom7EventData = [];
        delete el.dom7EventData;
      }
    }
    return this;
  }
  function transitionEnd(callback) {
    var events = ['webkitTransitionEnd', 'transitionend'];
    var dom = this;
    var i;
    function fireCallBack(e) {
      /* jshint validthis:true */
      if (e.target !== this) { return; }
      callback.call(this, e);
      for (i = 0; i < events.length; i += 1) {
        dom.off(events[i], fireCallBack);
      }
    }
    if (callback) {
      for (i = 0; i < events.length; i += 1) {
        dom.on(events[i], fireCallBack);
      }
    }
    return this;
  }
  function outerWidth(includeMargins) {
    if (this.length > 0) {
      if (includeMargins) {
        // eslint-disable-next-line
        var styles = this.styles();
        return this[0].offsetWidth + parseFloat(styles.getPropertyValue('margin-right')) + parseFloat(styles.getPropertyValue('margin-left'));
      }
      return this[0].offsetWidth;
    }
    return null;
  }
  function outerHeight(includeMargins) {
    if (this.length > 0) {
      if (includeMargins) {
        // eslint-disable-next-line
        var styles = this.styles();
        return this[0].offsetHeight + parseFloat(styles.getPropertyValue('margin-top')) + parseFloat(styles.getPropertyValue('margin-bottom'));
      }
      return this[0].offsetHeight;
    }
    return null;
  }
  function offset() {
    if (this.length > 0) {
      var el = this[0];
      var box = el.getBoundingClientRect();
      var body = doc.body;
      var clientTop = el.clientTop || body.clientTop || 0;
      var clientLeft = el.clientLeft || body.clientLeft || 0;
      var scrollTop = el === win ? win.scrollY : el.scrollTop;
      var scrollLeft = el === win ? win.scrollX : el.scrollLeft;
      return {
        top: (box.top + scrollTop) - clientTop,
        left: (box.left + scrollLeft) - clientLeft,
      };
    }

    return null;
  }
  function styles() {
    if (this[0]) { return win.getComputedStyle(this[0], null); }
    return {};
  }
  function css(props, value) {
    var i;
    if (arguments.length === 1) {
      if (typeof props === 'string') {
        if (this[0]) { return win.getComputedStyle(this[0], null).getPropertyValue(props); }
      } else {
        for (i = 0; i < this.length; i += 1) {
          // eslint-disable-next-line
          for (var prop in props) {
            this[i].style[prop] = props[prop];
          }
        }
        return this;
      }
    }
    if (arguments.length === 2 && typeof props === 'string') {
      for (i = 0; i < this.length; i += 1) {
        this[i].style[props] = value;
      }
      return this;
    }
    return this;
  }
  // Iterate over the collection passing elements to `callback`
  function each(callback) {
    // Don't bother continuing without a callback
    if (!callback) { return this; }
    // Iterate over the current collection
    for (var i = 0; i < this.length; i += 1) {
      // If the callback returns false
      if (callback.call(this[i], i, this[i]) === false) {
        // End the loop early
        return this;
      }
    }
    // Return `this` to allow chained DOM operations
    return this;
  }
  // eslint-disable-next-line
  function html(html) {
    if (typeof html === 'undefined') {
      return this[0] ? this[0].innerHTML : undefined;
    }

    for (var i = 0; i < this.length; i += 1) {
      this[i].innerHTML = html;
    }
    return this;
  }
  // eslint-disable-next-line
  function text(text) {
    if (typeof text === 'undefined') {
      if (this[0]) {
        return this[0].textContent.trim();
      }
      return null;
    }

    for (var i = 0; i < this.length; i += 1) {
      this[i].textContent = text;
    }
    return this;
  }
  function is(selector) {
    var el = this[0];
    var compareWith;
    var i;
    if (!el || typeof selector === 'undefined') { return false; }
    if (typeof selector === 'string') {
      if (el.matches) { return el.matches(selector); }
      else if (el.webkitMatchesSelector) { return el.webkitMatchesSelector(selector); }
      else if (el.msMatchesSelector) { return el.msMatchesSelector(selector); }

      compareWith = $(selector);
      for (i = 0; i < compareWith.length; i += 1) {
        if (compareWith[i] === el) { return true; }
      }
      return false;
    } else if (selector === doc) { return el === doc; }
    else if (selector === win) { return el === win; }

    if (selector.nodeType || selector instanceof Dom7) {
      compareWith = selector.nodeType ? [selector] : selector;
      for (i = 0; i < compareWith.length; i += 1) {
        if (compareWith[i] === el) { return true; }
      }
      return false;
    }
    return false;
  }
  function index() {
    var child = this[0];
    var i;
    if (child) {
      i = 0;
      // eslint-disable-next-line
      while ((child = child.previousSibling) !== null) {
        if (child.nodeType === 1) { i += 1; }
      }
      return i;
    }
    return undefined;
  }
  // eslint-disable-next-line
  function eq(index) {
    if (typeof index === 'undefined') { return this; }
    var length = this.length;
    var returnIndex;
    if (index > length - 1) {
      return new Dom7([]);
    }
    if (index < 0) {
      returnIndex = length + index;
      if (returnIndex < 0) { return new Dom7([]); }
      return new Dom7([this[returnIndex]]);
    }
    return new Dom7([this[index]]);
  }
  function append() {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var newChild;

    for (var k = 0; k < args.length; k += 1) {
      newChild = args[k];
      for (var i = 0; i < this.length; i += 1) {
        if (typeof newChild === 'string') {
          var tempDiv = doc.createElement('div');
          tempDiv.innerHTML = newChild;
          while (tempDiv.firstChild) {
            this[i].appendChild(tempDiv.firstChild);
          }
        } else if (newChild instanceof Dom7) {
          for (var j = 0; j < newChild.length; j += 1) {
            this[i].appendChild(newChild[j]);
          }
        } else {
          this[i].appendChild(newChild);
        }
      }
    }

    return this;
  }
  function prepend(newChild) {
    var i;
    var j;
    for (i = 0; i < this.length; i += 1) {
      if (typeof newChild === 'string') {
        var tempDiv = doc.createElement('div');
        tempDiv.innerHTML = newChild;
        for (j = tempDiv.childNodes.length - 1; j >= 0; j -= 1) {
          this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
        }
      } else if (newChild instanceof Dom7) {
        for (j = 0; j < newChild.length; j += 1) {
          this[i].insertBefore(newChild[j], this[i].childNodes[0]);
        }
      } else {
        this[i].insertBefore(newChild, this[i].childNodes[0]);
      }
    }
    return this;
  }
  function next(selector) {
    if (this.length > 0) {
      if (selector) {
        if (this[0].nextElementSibling && $(this[0].nextElementSibling).is(selector)) {
          return new Dom7([this[0].nextElementSibling]);
        }
        return new Dom7([]);
      }

      if (this[0].nextElementSibling) { return new Dom7([this[0].nextElementSibling]); }
      return new Dom7([]);
    }
    return new Dom7([]);
  }
  function nextAll(selector) {
    var nextEls = [];
    var el = this[0];
    if (!el) { return new Dom7([]); }
    while (el.nextElementSibling) {
      var next = el.nextElementSibling; // eslint-disable-line
      if (selector) {
        if ($(next).is(selector)) { nextEls.push(next); }
      } else { nextEls.push(next); }
      el = next;
    }
    return new Dom7(nextEls);
  }
  function prev(selector) {
    if (this.length > 0) {
      var el = this[0];
      if (selector) {
        if (el.previousElementSibling && $(el.previousElementSibling).is(selector)) {
          return new Dom7([el.previousElementSibling]);
        }
        return new Dom7([]);
      }

      if (el.previousElementSibling) { return new Dom7([el.previousElementSibling]); }
      return new Dom7([]);
    }
    return new Dom7([]);
  }
  function prevAll(selector) {
    var prevEls = [];
    var el = this[0];
    if (!el) { return new Dom7([]); }
    while (el.previousElementSibling) {
      var prev = el.previousElementSibling; // eslint-disable-line
      if (selector) {
        if ($(prev).is(selector)) { prevEls.push(prev); }
      } else { prevEls.push(prev); }
      el = prev;
    }
    return new Dom7(prevEls);
  }
  function parent(selector) {
    var parents = []; // eslint-disable-line
    for (var i = 0; i < this.length; i += 1) {
      if (this[i].parentNode !== null) {
        if (selector) {
          if ($(this[i].parentNode).is(selector)) { parents.push(this[i].parentNode); }
        } else {
          parents.push(this[i].parentNode);
        }
      }
    }
    return $(unique(parents));
  }
  function parents(selector) {
    var parents = []; // eslint-disable-line
    for (var i = 0; i < this.length; i += 1) {
      var parent = this[i].parentNode; // eslint-disable-line
      while (parent) {
        if (selector) {
          if ($(parent).is(selector)) { parents.push(parent); }
        } else {
          parents.push(parent);
        }
        parent = parent.parentNode;
      }
    }
    return $(unique(parents));
  }
  function closest(selector) {
    var closest = this; // eslint-disable-line
    if (typeof selector === 'undefined') {
      return new Dom7([]);
    }
    if (!closest.is(selector)) {
      closest = closest.parents(selector).eq(0);
    }
    return closest;
  }
  function find(selector) {
    var foundElements = [];
    for (var i = 0; i < this.length; i += 1) {
      var found = this[i].querySelectorAll(selector);
      for (var j = 0; j < found.length; j += 1) {
        foundElements.push(found[j]);
      }
    }
    return new Dom7(foundElements);
  }
  function children(selector) {
    var children = []; // eslint-disable-line
    for (var i = 0; i < this.length; i += 1) {
      var childNodes = this[i].childNodes;

      for (var j = 0; j < childNodes.length; j += 1) {
        if (!selector) {
          if (childNodes[j].nodeType === 1) { children.push(childNodes[j]); }
        } else if (childNodes[j].nodeType === 1 && $(childNodes[j]).is(selector)) {
          children.push(childNodes[j]);
        }
      }
    }
    return new Dom7(unique(children));
  }
  function remove() {
    for (var i = 0; i < this.length; i += 1) {
      if (this[i].parentNode) { this[i].parentNode.removeChild(this[i]); }
    }
    return this;
  }
  function add() {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var dom = this;
    var i;
    var j;
    for (i = 0; i < args.length; i += 1) {
      var toAdd = $(args[i]);
      for (j = 0; j < toAdd.length; j += 1) {
        dom[dom.length] = toAdd[j];
        dom.length += 1;
      }
    }
    return dom;
  }

  var Methods = {
    addClass: addClass,
    removeClass: removeClass,
    hasClass: hasClass,
    toggleClass: toggleClass,
    attr: attr,
    removeAttr: removeAttr,
    data: data,
    transform: transform,
    transition: transition,
    on: on,
    off: off,
    trigger: trigger,
    transitionEnd: transitionEnd,
    outerWidth: outerWidth,
    outerHeight: outerHeight,
    offset: offset,
    css: css,
    each: each,
    html: html,
    text: text,
    is: is,
    index: index,
    eq: eq,
    append: append,
    prepend: prepend,
    next: next,
    nextAll: nextAll,
    prev: prev,
    prevAll: prevAll,
    parent: parent,
    parents: parents,
    closest: closest,
    find: find,
    children: children,
    remove: remove,
    add: add,
    styles: styles,
  };

  Object.keys(Methods).forEach(function (methodName) {
    $.fn[methodName] = $.fn[methodName] || Methods[methodName];
  });

  var Utils = {
    deleteProps: function deleteProps(obj) {
      var object = obj;
      Object.keys(object).forEach(function (key) {
        try {
          object[key] = null;
        } catch (e) {
          // no getter for object
        }
        try {
          delete object[key];
        } catch (e) {
          // something got wrong
        }
      });
    },
    nextTick: function nextTick(callback, delay) {
      if ( delay === void 0 ) delay = 0;

      return setTimeout(callback, delay);
    },
    now: function now() {
      return Date.now();
    },
    getTranslate: function getTranslate(el, axis) {
      if ( axis === void 0 ) axis = 'x';

      var matrix;
      var curTransform;
      var transformMatrix;

      var curStyle = win.getComputedStyle(el, null);

      if (win.WebKitCSSMatrix) {
        curTransform = curStyle.transform || curStyle.webkitTransform;
        if (curTransform.split(',').length > 6) {
          curTransform = curTransform.split(', ').map(function (a) { return a.replace(',', '.'); }).join(', ');
        }
        // Some old versions of Webkit choke when 'none' is passed; pass
        // empty string instead in this case
        transformMatrix = new win.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
      } else {
        transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
        matrix = transformMatrix.toString().split(',');
      }

      if (axis === 'x') {
        // Latest Chrome and webkits Fix
        if (win.WebKitCSSMatrix) { curTransform = transformMatrix.m41; }
        // Crazy IE10 Matrix
        else if (matrix.length === 16) { curTransform = parseFloat(matrix[12]); }
        // Normal Browsers
        else { curTransform = parseFloat(matrix[4]); }
      }
      if (axis === 'y') {
        // Latest Chrome and webkits Fix
        if (win.WebKitCSSMatrix) { curTransform = transformMatrix.m42; }
        // Crazy IE10 Matrix
        else if (matrix.length === 16) { curTransform = parseFloat(matrix[13]); }
        // Normal Browsers
        else { curTransform = parseFloat(matrix[5]); }
      }
      return curTransform || 0;
    },
    parseUrlQuery: function parseUrlQuery(url) {
      var query = {};
      var urlToParse = url || win.location.href;
      var i;
      var params;
      var param;
      var length;
      if (typeof urlToParse === 'string' && urlToParse.length) {
        urlToParse = urlToParse.indexOf('?') > -1 ? urlToParse.replace(/\S*\?/, '') : '';
        params = urlToParse.split('&').filter(function (paramsPart) { return paramsPart !== ''; });
        length = params.length;

        for (i = 0; i < length; i += 1) {
          param = params[i].replace(/#\S+/g, '').split('=');
          query[decodeURIComponent(param[0])] = typeof param[1] === 'undefined' ? undefined : decodeURIComponent(param[1]) || '';
        }
      }
      return query;
    },
    isObject: function isObject(o) {
      return typeof o === 'object' && o !== null && o.constructor && o.constructor === Object;
    },
    extend: function extend() {
      var args = [], len$1 = arguments.length;
      while ( len$1-- ) args[ len$1 ] = arguments[ len$1 ];

      var to = Object(args[0]);
      for (var i = 1; i < args.length; i += 1) {
        var nextSource = args[i];
        if (nextSource !== undefined && nextSource !== null) {
          var keysArray = Object.keys(Object(nextSource));
          for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
            var nextKey = keysArray[nextIndex];
            var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
            if (desc !== undefined && desc.enumerable) {
              if (Utils.isObject(to[nextKey]) && Utils.isObject(nextSource[nextKey])) {
                Utils.extend(to[nextKey], nextSource[nextKey]);
              } else if (!Utils.isObject(to[nextKey]) && Utils.isObject(nextSource[nextKey])) {
                to[nextKey] = {};
                Utils.extend(to[nextKey], nextSource[nextKey]);
              } else {
                to[nextKey] = nextSource[nextKey];
              }
            }
          }
        }
      }
      return to;
    },
  };

  var Support = (function Support() {
    var testDiv = doc.createElement('div');
    return {
      touch: (win.Modernizr && win.Modernizr.touch === true) || (function checkTouch() {
        return !!((win.navigator.maxTouchPoints > 0) || ('ontouchstart' in win) || (win.DocumentTouch && doc instanceof win.DocumentTouch));
      }()),

      pointerEvents: !!(win.navigator.pointerEnabled || win.PointerEvent || ('maxTouchPoints' in win.navigator && win.navigator.maxTouchPoints > 0)),
      prefixedPointerEvents: !!win.navigator.msPointerEnabled,

      transition: (function checkTransition() {
        var style = testDiv.style;
        return ('transition' in style || 'webkitTransition' in style || 'MozTransition' in style);
      }()),
      transforms3d: (win.Modernizr && win.Modernizr.csstransforms3d === true) || (function checkTransforms3d() {
        var style = testDiv.style;
        return ('webkitPerspective' in style || 'MozPerspective' in style || 'OPerspective' in style || 'MsPerspective' in style || 'perspective' in style);
      }()),

      flexbox: (function checkFlexbox() {
        var style = testDiv.style;
        var styles = ('alignItems webkitAlignItems webkitBoxAlign msFlexAlign mozBoxAlign webkitFlexDirection msFlexDirection mozBoxDirection mozBoxOrient webkitBoxDirection webkitBoxOrient').split(' ');
        for (var i = 0; i < styles.length; i += 1) {
          if (styles[i] in style) { return true; }
        }
        return false;
      }()),

      observer: (function checkObserver() {
        return ('MutationObserver' in win || 'WebkitMutationObserver' in win);
      }()),

      passiveListener: (function checkPassiveListener() {
        var supportsPassive = false;
        try {
          var opts = Object.defineProperty({}, 'passive', {
            // eslint-disable-next-line
            get: function get() {
              supportsPassive = true;
            },
          });
          win.addEventListener('testPassiveListener', null, opts);
        } catch (e) {
          // No support
        }
        return supportsPassive;
      }()),

      gestures: (function checkGestures() {
        return 'ongesturestart' in win;
      }()),
    };
  }());

  var Browser = (function Browser() {
    function isSafari() {
      var ua = win.navigator.userAgent.toLowerCase();
      return (ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0);
    }
    return {
      isIE: !!win.navigator.userAgent.match(/Trident/g) || !!win.navigator.userAgent.match(/MSIE/g),
      isEdge: !!win.navigator.userAgent.match(/Edge/g),
      isSafari: isSafari(),
      isUiWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(win.navigator.userAgent),
    };
  }());

  var SwiperClass = function SwiperClass(params) {
    if ( params === void 0 ) params = {};

    var self = this;
    self.params = params;

    // Events
    self.eventsListeners = {};

    if (self.params && self.params.on) {
      Object.keys(self.params.on).forEach(function (eventName) {
        self.on(eventName, self.params.on[eventName]);
      });
    }
  };

  var staticAccessors = { components: { configurable: true } };

  SwiperClass.prototype.on = function on (events, handler, priority) {
    var self = this;
    if (typeof handler !== 'function') { return self; }
    var method = priority ? 'unshift' : 'push';
    events.split(' ').forEach(function (event) {
      if (!self.eventsListeners[event]) { self.eventsListeners[event] = []; }
      self.eventsListeners[event][method](handler);
    });
    return self;
  };

  SwiperClass.prototype.once = function once (events, handler, priority) {
    var self = this;
    if (typeof handler !== 'function') { return self; }
    function onceHandler() {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

      handler.apply(self, args);
      self.off(events, onceHandler);
      if (onceHandler.f7proxy) {
        delete onceHandler.f7proxy;
      }
    }
    onceHandler.f7proxy = handler;
    return self.on(events, onceHandler, priority);
  };

  SwiperClass.prototype.off = function off (events, handler) {
    var self = this;
    if (!self.eventsListeners) { return self; }
    events.split(' ').forEach(function (event) {
      if (typeof handler === 'undefined') {
        self.eventsListeners[event] = [];
      } else if (self.eventsListeners[event] && self.eventsListeners[event].length) {
        self.eventsListeners[event].forEach(function (eventHandler, index) {
          if (eventHandler === handler || (eventHandler.f7proxy && eventHandler.f7proxy === handler)) {
            self.eventsListeners[event].splice(index, 1);
          }
        });
      }
    });
    return self;
  };

  SwiperClass.prototype.emit = function emit () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

    var self = this;
    if (!self.eventsListeners) { return self; }
    var events;
    var data;
    var context;
    if (typeof args[0] === 'string' || Array.isArray(args[0])) {
      events = args[0];
      data = args.slice(1, args.length);
      context = self;
    } else {
      events = args[0].events;
      data = args[0].data;
      context = args[0].context || self;
    }
    var eventsArray = Array.isArray(events) ? events : events.split(' ');
    eventsArray.forEach(function (event) {
      if (self.eventsListeners && self.eventsListeners[event]) {
        var handlers = [];
        self.eventsListeners[event].forEach(function (eventHandler) {
          handlers.push(eventHandler);
        });
        handlers.forEach(function (eventHandler) {
          eventHandler.apply(context, data);
        });
      }
    });
    return self;
  };

  SwiperClass.prototype.useModulesParams = function useModulesParams (instanceParams) {
    var instance = this;
    if (!instance.modules) { return; }
    Object.keys(instance.modules).forEach(function (moduleName) {
      var module = instance.modules[moduleName];
      // Extend params
      if (module.params) {
        Utils.extend(instanceParams, module.params);
      }
    });
  };

  SwiperClass.prototype.useModules = function useModules (modulesParams) {
      if ( modulesParams === void 0 ) modulesParams = {};

    var instance = this;
    if (!instance.modules) { return; }
    Object.keys(instance.modules).forEach(function (moduleName) {
      var module = instance.modules[moduleName];
      var moduleParams = modulesParams[moduleName] || {};
      // Extend instance methods and props
      if (module.instance) {
        Object.keys(module.instance).forEach(function (modulePropName) {
          var moduleProp = module.instance[modulePropName];
          if (typeof moduleProp === 'function') {
            instance[modulePropName] = moduleProp.bind(instance);
          } else {
            instance[modulePropName] = moduleProp;
          }
        });
      }
      // Add event listeners
      if (module.on && instance.on) {
        Object.keys(module.on).forEach(function (moduleEventName) {
          instance.on(moduleEventName, module.on[moduleEventName]);
        });
      }

      // Module create callback
      if (module.create) {
        module.create.bind(instance)(moduleParams);
      }
    });
  };

  staticAccessors.components.set = function (components) {
    var Class = this;
    if (!Class.use) { return; }
    Class.use(components);
  };

  SwiperClass.installModule = function installModule (module) {
      var params = [], len = arguments.length - 1;
      while ( len-- > 0 ) params[ len ] = arguments[ len + 1 ];

    var Class = this;
    if (!Class.prototype.modules) { Class.prototype.modules = {}; }
    var name = module.name || (((Object.keys(Class.prototype.modules).length) + "_" + (Utils.now())));
    Class.prototype.modules[name] = module;
    // Prototype
    if (module.proto) {
      Object.keys(module.proto).forEach(function (key) {
        Class.prototype[key] = module.proto[key];
      });
    }
    // Class
    if (module.static) {
      Object.keys(module.static).forEach(function (key) {
        Class[key] = module.static[key];
      });
    }
    // Callback
    if (module.install) {
      module.install.apply(Class, params);
    }
    return Class;
  };

  SwiperClass.use = function use (module) {
      var params = [], len = arguments.length - 1;
      while ( len-- > 0 ) params[ len ] = arguments[ len + 1 ];

    var Class = this;
    if (Array.isArray(module)) {
      module.forEach(function (m) { return Class.installModule(m); });
      return Class;
    }
    return Class.installModule.apply(Class, [ module ].concat( params ));
  };

  Object.defineProperties( SwiperClass, staticAccessors );

  function updateSize () {
    var swiper = this;
    var width;
    var height;
    var $el = swiper.$el;
    if (typeof swiper.params.width !== 'undefined') {
      width = swiper.params.width;
    } else {
      width = $el[0].clientWidth;
    }
    if (typeof swiper.params.height !== 'undefined') {
      height = swiper.params.height;
    } else {
      height = $el[0].clientHeight;
    }
    if ((width === 0 && swiper.isHorizontal()) || (height === 0 && swiper.isVertical())) {
      return;
    }

    // Subtract paddings
    width = width - parseInt($el.css('padding-left'), 10) - parseInt($el.css('padding-right'), 10);
    height = height - parseInt($el.css('padding-top'), 10) - parseInt($el.css('padding-bottom'), 10);

    Utils.extend(swiper, {
      width: width,
      height: height,
      size: swiper.isHorizontal() ? width : height,
    });
  }

  function updateSlides () {
    var swiper = this;
    var params = swiper.params;

    var $wrapperEl = swiper.$wrapperEl;
    var swiperSize = swiper.size;
    var rtl = swiper.rtlTranslate;
    var wrongRTL = swiper.wrongRTL;
    var isVirtual = swiper.virtual && params.virtual.enabled;
    var previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
    var slides = $wrapperEl.children(("." + (swiper.params.slideClass)));
    var slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
    var snapGrid = [];
    var slidesGrid = [];
    var slidesSizesGrid = [];

    var offsetBefore = params.slidesOffsetBefore;
    if (typeof offsetBefore === 'function') {
      offsetBefore = params.slidesOffsetBefore.call(swiper);
    }

    var offsetAfter = params.slidesOffsetAfter;
    if (typeof offsetAfter === 'function') {
      offsetAfter = params.slidesOffsetAfter.call(swiper);
    }

    var previousSnapGridLength = swiper.snapGrid.length;
    var previousSlidesGridLength = swiper.snapGrid.length;

    var spaceBetween = params.spaceBetween;
    var slidePosition = -offsetBefore;
    var prevSlideSize = 0;
    var index = 0;
    if (typeof swiperSize === 'undefined') {
      return;
    }
    if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
      spaceBetween = (parseFloat(spaceBetween.replace('%', '')) / 100) * swiperSize;
    }

    swiper.virtualSize = -spaceBetween;

    // reset margins
    if (rtl) { slides.css({ marginLeft: '', marginTop: '' }); }
    else { slides.css({ marginRight: '', marginBottom: '' }); }

    var slidesNumberEvenToRows;
    if (params.slidesPerColumn > 1) {
      if (Math.floor(slidesLength / params.slidesPerColumn) === slidesLength / swiper.params.slidesPerColumn) {
        slidesNumberEvenToRows = slidesLength;
      } else {
        slidesNumberEvenToRows = Math.ceil(slidesLength / params.slidesPerColumn) * params.slidesPerColumn;
      }
      if (params.slidesPerView !== 'auto' && params.slidesPerColumnFill === 'row') {
        slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, params.slidesPerView * params.slidesPerColumn);
      }
    }

    // Calc slides
    var slideSize;
    var slidesPerColumn = params.slidesPerColumn;
    var slidesPerRow = slidesNumberEvenToRows / slidesPerColumn;
    var numFullColumns = Math.floor(slidesLength / params.slidesPerColumn);
    for (var i = 0; i < slidesLength; i += 1) {
      slideSize = 0;
      var slide = slides.eq(i);
      if (params.slidesPerColumn > 1) {
        // Set slides order
        var newSlideOrderIndex = (void 0);
        var column = (void 0);
        var row = (void 0);
        if (
          (params.slidesPerColumnFill === 'column')
          || (params.slidesPerColumnFill === 'row' && params.slidesPerGroup > 1)
        ) {
          if (params.slidesPerColumnFill === 'column') {
            column = Math.floor(i / slidesPerColumn);
            row = i - (column * slidesPerColumn);
            if (column > numFullColumns || (column === numFullColumns && row === slidesPerColumn - 1)) {
              row += 1;
              if (row >= slidesPerColumn) {
                row = 0;
                column += 1;
              }
            }
          } else {
            var groupIndex = Math.floor(i / params.slidesPerGroup);
            row = Math.floor(i / params.slidesPerView) - groupIndex * params.slidesPerColumn;
            column = i - row * params.slidesPerView - groupIndex * params.slidesPerView;
          }
          newSlideOrderIndex = column + ((row * slidesNumberEvenToRows) / slidesPerColumn);
          slide
            .css({
              '-webkit-box-ordinal-group': newSlideOrderIndex,
              '-moz-box-ordinal-group': newSlideOrderIndex,
              '-ms-flex-order': newSlideOrderIndex,
              '-webkit-order': newSlideOrderIndex,
              order: newSlideOrderIndex,
            });
        } else {
          row = Math.floor(i / slidesPerRow);
          column = i - (row * slidesPerRow);
        }
        slide
          .css(
            ("margin-" + (swiper.isHorizontal() ? 'top' : 'left')),
            (row !== 0 && params.spaceBetween) && (((params.spaceBetween) + "px"))
          )
          .attr('data-swiper-column', column)
          .attr('data-swiper-row', row);
      }
      if (slide.css('display') === 'none') { continue; } // eslint-disable-line

      if (params.slidesPerView === 'auto') {
        var slideStyles = win.getComputedStyle(slide[0], null);
        var currentTransform = slide[0].style.transform;
        var currentWebKitTransform = slide[0].style.webkitTransform;
        if (currentTransform) {
          slide[0].style.transform = 'none';
        }
        if (currentWebKitTransform) {
          slide[0].style.webkitTransform = 'none';
        }
        if (params.roundLengths) {
          slideSize = swiper.isHorizontal()
            ? slide.outerWidth(true)
            : slide.outerHeight(true);
        } else {
          // eslint-disable-next-line
          if (swiper.isHorizontal()) {
            var width = parseFloat(slideStyles.getPropertyValue('width'));
            var paddingLeft = parseFloat(slideStyles.getPropertyValue('padding-left'));
            var paddingRight = parseFloat(slideStyles.getPropertyValue('padding-right'));
            var marginLeft = parseFloat(slideStyles.getPropertyValue('margin-left'));
            var marginRight = parseFloat(slideStyles.getPropertyValue('margin-right'));
            var boxSizing = slideStyles.getPropertyValue('box-sizing');
            if (boxSizing && boxSizing === 'border-box' && !Browser.isIE) {
              slideSize = width + marginLeft + marginRight;
            } else {
              slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight;
            }
          } else {
            var height = parseFloat(slideStyles.getPropertyValue('height'));
            var paddingTop = parseFloat(slideStyles.getPropertyValue('padding-top'));
            var paddingBottom = parseFloat(slideStyles.getPropertyValue('padding-bottom'));
            var marginTop = parseFloat(slideStyles.getPropertyValue('margin-top'));
            var marginBottom = parseFloat(slideStyles.getPropertyValue('margin-bottom'));
            var boxSizing$1 = slideStyles.getPropertyValue('box-sizing');
            if (boxSizing$1 && boxSizing$1 === 'border-box' && !Browser.isIE) {
              slideSize = height + marginTop + marginBottom;
            } else {
              slideSize = height + paddingTop + paddingBottom + marginTop + marginBottom;
            }
          }
        }
        if (currentTransform) {
          slide[0].style.transform = currentTransform;
        }
        if (currentWebKitTransform) {
          slide[0].style.webkitTransform = currentWebKitTransform;
        }
        if (params.roundLengths) { slideSize = Math.floor(slideSize); }
      } else {
        slideSize = (swiperSize - ((params.slidesPerView - 1) * spaceBetween)) / params.slidesPerView;
        if (params.roundLengths) { slideSize = Math.floor(slideSize); }

        if (slides[i]) {
          if (swiper.isHorizontal()) {
            slides[i].style.width = slideSize + "px";
          } else {
            slides[i].style.height = slideSize + "px";
          }
        }
      }
      if (slides[i]) {
        slides[i].swiperSlideSize = slideSize;
      }
      slidesSizesGrid.push(slideSize);


      if (params.centeredSlides) {
        slidePosition = slidePosition + (slideSize / 2) + (prevSlideSize / 2) + spaceBetween;
        if (prevSlideSize === 0 && i !== 0) { slidePosition = slidePosition - (swiperSize / 2) - spaceBetween; }
        if (i === 0) { slidePosition = slidePosition - (swiperSize / 2) - spaceBetween; }
        if (Math.abs(slidePosition) < 1 / 1000) { slidePosition = 0; }
        if (params.roundLengths) { slidePosition = Math.floor(slidePosition); }
        if ((index) % params.slidesPerGroup === 0) { snapGrid.push(slidePosition); }
        slidesGrid.push(slidePosition);
      } else {
        if (params.roundLengths) { slidePosition = Math.floor(slidePosition); }
        if ((index) % params.slidesPerGroup === 0) { snapGrid.push(slidePosition); }
        slidesGrid.push(slidePosition);
        slidePosition = slidePosition + slideSize + spaceBetween;
      }

      swiper.virtualSize += slideSize + spaceBetween;

      prevSlideSize = slideSize;

      index += 1;
    }
    swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
    var newSlidesGrid;

    if (
      rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) {
      $wrapperEl.css({ width: ((swiper.virtualSize + params.spaceBetween) + "px") });
    }
    if (!Support.flexbox || params.setWrapperSize) {
      if (swiper.isHorizontal()) { $wrapperEl.css({ width: ((swiper.virtualSize + params.spaceBetween) + "px") }); }
      else { $wrapperEl.css({ height: ((swiper.virtualSize + params.spaceBetween) + "px") }); }
    }

    if (params.slidesPerColumn > 1) {
      swiper.virtualSize = (slideSize + params.spaceBetween) * slidesNumberEvenToRows;
      swiper.virtualSize = Math.ceil(swiper.virtualSize / params.slidesPerColumn) - params.spaceBetween;
      if (swiper.isHorizontal()) { $wrapperEl.css({ width: ((swiper.virtualSize + params.spaceBetween) + "px") }); }
      else { $wrapperEl.css({ height: ((swiper.virtualSize + params.spaceBetween) + "px") }); }
      if (params.centeredSlides) {
        newSlidesGrid = [];
        for (var i$1 = 0; i$1 < snapGrid.length; i$1 += 1) {
          var slidesGridItem = snapGrid[i$1];
          if (params.roundLengths) { slidesGridItem = Math.floor(slidesGridItem); }
          if (snapGrid[i$1] < swiper.virtualSize + snapGrid[0]) { newSlidesGrid.push(slidesGridItem); }
        }
        snapGrid = newSlidesGrid;
      }
    }

    // Remove last grid elements depending on width
    if (!params.centeredSlides) {
      newSlidesGrid = [];
      for (var i$2 = 0; i$2 < snapGrid.length; i$2 += 1) {
        var slidesGridItem$1 = snapGrid[i$2];
        if (params.roundLengths) { slidesGridItem$1 = Math.floor(slidesGridItem$1); }
        if (snapGrid[i$2] <= swiper.virtualSize - swiperSize) {
          newSlidesGrid.push(slidesGridItem$1);
        }
      }
      snapGrid = newSlidesGrid;
      if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) {
        snapGrid.push(swiper.virtualSize - swiperSize);
      }
    }
    if (snapGrid.length === 0) { snapGrid = [0]; }

    if (params.spaceBetween !== 0) {
      if (swiper.isHorizontal()) {
        if (rtl) { slides.css({ marginLeft: (spaceBetween + "px") }); }
        else { slides.css({ marginRight: (spaceBetween + "px") }); }
      } else { slides.css({ marginBottom: (spaceBetween + "px") }); }
    }

    if (params.centerInsufficientSlides) {
      var allSlidesSize = 0;
      slidesSizesGrid.forEach(function (slideSizeValue) {
        allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
      });
      allSlidesSize -= params.spaceBetween;
      if (allSlidesSize < swiperSize) {
        var allSlidesOffset = (swiperSize - allSlidesSize) / 2;
        snapGrid.forEach(function (snap, snapIndex) {
          snapGrid[snapIndex] = snap - allSlidesOffset;
        });
        slidesGrid.forEach(function (snap, snapIndex) {
          slidesGrid[snapIndex] = snap + allSlidesOffset;
        });
      }
    }

    Utils.extend(swiper, {
      slides: slides,
      snapGrid: snapGrid,
      slidesGrid: slidesGrid,
      slidesSizesGrid: slidesSizesGrid,
    });

    if (slidesLength !== previousSlidesLength) {
      swiper.emit('slidesLengthChange');
    }
    if (snapGrid.length !== previousSnapGridLength) {
      if (swiper.params.watchOverflow) { swiper.checkOverflow(); }
      swiper.emit('snapGridLengthChange');
    }
    if (slidesGrid.length !== previousSlidesGridLength) {
      swiper.emit('slidesGridLengthChange');
    }

    if (params.watchSlidesProgress || params.watchSlidesVisibility) {
      swiper.updateSlidesOffset();
    }
  }

  function updateAutoHeight (speed) {
    var swiper = this;
    var activeSlides = [];
    var newHeight = 0;
    var i;
    if (typeof speed === 'number') {
      swiper.setTransition(speed);
    } else if (speed === true) {
      swiper.setTransition(swiper.params.speed);
    }
    // Find slides currently in view
    if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
      for (i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1) {
        var index = swiper.activeIndex + i;
        if (index > swiper.slides.length) { break; }
        activeSlides.push(swiper.slides.eq(index)[0]);
      }
    } else {
      activeSlides.push(swiper.slides.eq(swiper.activeIndex)[0]);
    }

    // Find new height from highest slide in view
    for (i = 0; i < activeSlides.length; i += 1) {
      if (typeof activeSlides[i] !== 'undefined') {
        var height = activeSlides[i].offsetHeight;
        newHeight = height > newHeight ? height : newHeight;
      }
    }

    // Update Height
    if (newHeight) { swiper.$wrapperEl.css('height', (newHeight + "px")); }
  }

  function updateSlidesOffset () {
    var swiper = this;
    var slides = swiper.slides;
    for (var i = 0; i < slides.length; i += 1) {
      slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
    }
  }

  function updateSlidesProgress (translate) {
    var swiper = this;
    var params = swiper.params;
    if (typeof translate === 'undefined') {
      // eslint-disable-next-line
      translate = (swiper && swiper.translate) || 0;
    }

    var slides = swiper.slides;
    var rtl = swiper.rtlTranslate;

    if (slides.length === 0) { return; }
    if (typeof slides[0].swiperSlideOffset === 'undefined') { swiper.updateSlidesOffset(); }

    var offsetCenter = -translate;
    if (rtl) { offsetCenter = translate; }

    // Visible Slides
    slides.removeClass(params.slideVisibleClass);

    swiper.visibleSlidesIndexes = [];
    swiper.visibleSlides = [];

    for (var i = 0; i < slides.length; i += 1) {
      var slide = slides[i];
      var slideProgress = (
        (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0)) - slide.swiperSlideOffset
      ) / (slide.swiperSlideSize + params.spaceBetween);
      if (params.watchSlidesVisibility) {
        var slideBefore = -(offsetCenter - slide.swiperSlideOffset);
        var slideAfter = slideBefore + swiper.slidesSizesGrid[i];
        var isVisible = (slideBefore >= 0 && slideBefore < swiper.size - 1)
                  || (slideAfter > 1 && slideAfter <= swiper.size)
                  || (slideBefore <= 0 && slideAfter >= swiper.size);
        if (isVisible) {
          swiper.visibleSlides.push(slide);
          swiper.visibleSlidesIndexes.push(i);
          slides.eq(i).addClass(params.slideVisibleClass);
        }
      }
      slide.progress = rtl ? -slideProgress : slideProgress;
    }
    swiper.visibleSlides = $(swiper.visibleSlides);
  }

  function updateProgress (translate) {
    var swiper = this;
    var params = swiper.params;

    if (typeof translate === 'undefined') {
      var multiplier = swiper.rtlTranslate ? -1 : 1;
      // eslint-disable-next-line
      translate = (swiper && swiper.translate && (swiper.translate * multiplier)) || 0;
    }

    var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    var progress = swiper.progress;
    var isBeginning = swiper.isBeginning;
    var isEnd = swiper.isEnd;
    var wasBeginning = isBeginning;
    var wasEnd = isEnd;
    if (translatesDiff === 0) {
      progress = 0;
      isBeginning = true;
      isEnd = true;
    } else {
      progress = (translate - swiper.minTranslate()) / (translatesDiff);
      isBeginning = progress <= 0;
      isEnd = progress >= 1;
    }
    Utils.extend(swiper, {
      progress: progress,
      isBeginning: isBeginning,
      isEnd: isEnd,
    });

    if (params.watchSlidesProgress || params.watchSlidesVisibility) { swiper.updateSlidesProgress(translate); }

    if (isBeginning && !wasBeginning) {
      swiper.emit('reachBeginning toEdge');
    }
    if (isEnd && !wasEnd) {
      swiper.emit('reachEnd toEdge');
    }
    if ((wasBeginning && !isBeginning) || (wasEnd && !isEnd)) {
      swiper.emit('fromEdge');
    }

    swiper.emit('progress', progress);
  }

  function updateSlidesClasses () {
    var swiper = this;

    var slides = swiper.slides;
    var params = swiper.params;
    var $wrapperEl = swiper.$wrapperEl;
    var activeIndex = swiper.activeIndex;
    var realIndex = swiper.realIndex;
    var isVirtual = swiper.virtual && params.virtual.enabled;

    slides.removeClass(((params.slideActiveClass) + " " + (params.slideNextClass) + " " + (params.slidePrevClass) + " " + (params.slideDuplicateActiveClass) + " " + (params.slideDuplicateNextClass) + " " + (params.slideDuplicatePrevClass)));

    var activeSlide;
    if (isVirtual) {
      activeSlide = swiper.$wrapperEl.find(("." + (params.slideClass) + "[data-swiper-slide-index=\"" + activeIndex + "\"]"));
    } else {
      activeSlide = slides.eq(activeIndex);
    }

    // Active classes
    activeSlide.addClass(params.slideActiveClass);

    if (params.loop) {
      // Duplicate to all looped slides
      if (activeSlide.hasClass(params.slideDuplicateClass)) {
        $wrapperEl
          .children(("." + (params.slideClass) + ":not(." + (params.slideDuplicateClass) + ")[data-swiper-slide-index=\"" + realIndex + "\"]"))
          .addClass(params.slideDuplicateActiveClass);
      } else {
        $wrapperEl
          .children(("." + (params.slideClass) + "." + (params.slideDuplicateClass) + "[data-swiper-slide-index=\"" + realIndex + "\"]"))
          .addClass(params.slideDuplicateActiveClass);
      }
    }
    // Next Slide
    var nextSlide = activeSlide.nextAll(("." + (params.slideClass))).eq(0).addClass(params.slideNextClass);
    if (params.loop && nextSlide.length === 0) {
      nextSlide = slides.eq(0);
      nextSlide.addClass(params.slideNextClass);
    }
    // Prev Slide
    var prevSlide = activeSlide.prevAll(("." + (params.slideClass))).eq(0).addClass(params.slidePrevClass);
    if (params.loop && prevSlide.length === 0) {
      prevSlide = slides.eq(-1);
      prevSlide.addClass(params.slidePrevClass);
    }
    if (params.loop) {
      // Duplicate to all looped slides
      if (nextSlide.hasClass(params.slideDuplicateClass)) {
        $wrapperEl
          .children(("." + (params.slideClass) + ":not(." + (params.slideDuplicateClass) + ")[data-swiper-slide-index=\"" + (nextSlide.attr('data-swiper-slide-index')) + "\"]"))
          .addClass(params.slideDuplicateNextClass);
      } else {
        $wrapperEl
          .children(("." + (params.slideClass) + "." + (params.slideDuplicateClass) + "[data-swiper-slide-index=\"" + (nextSlide.attr('data-swiper-slide-index')) + "\"]"))
          .addClass(params.slideDuplicateNextClass);
      }
      if (prevSlide.hasClass(params.slideDuplicateClass)) {
        $wrapperEl
          .children(("." + (params.slideClass) + ":not(." + (params.slideDuplicateClass) + ")[data-swiper-slide-index=\"" + (prevSlide.attr('data-swiper-slide-index')) + "\"]"))
          .addClass(params.slideDuplicatePrevClass);
      } else {
        $wrapperEl
          .children(("." + (params.slideClass) + "." + (params.slideDuplicateClass) + "[data-swiper-slide-index=\"" + (prevSlide.attr('data-swiper-slide-index')) + "\"]"))
          .addClass(params.slideDuplicatePrevClass);
      }
    }
  }

  function updateActiveIndex (newActiveIndex) {
    var swiper = this;
    var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    var slidesGrid = swiper.slidesGrid;
    var snapGrid = swiper.snapGrid;
    var params = swiper.params;
    var previousIndex = swiper.activeIndex;
    var previousRealIndex = swiper.realIndex;
    var previousSnapIndex = swiper.snapIndex;
    var activeIndex = newActiveIndex;
    var snapIndex;
    if (typeof activeIndex === 'undefined') {
      for (var i = 0; i < slidesGrid.length; i += 1) {
        if (typeof slidesGrid[i + 1] !== 'undefined') {
          if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - ((slidesGrid[i + 1] - slidesGrid[i]) / 2)) {
            activeIndex = i;
          } else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) {
            activeIndex = i + 1;
          }
        } else if (translate >= slidesGrid[i]) {
          activeIndex = i;
        }
      }
      // Normalize slideIndex
      if (params.normalizeSlideIndex) {
        if (activeIndex < 0 || typeof activeIndex === 'undefined') { activeIndex = 0; }
      }
    }
    if (snapGrid.indexOf(translate) >= 0) {
      snapIndex = snapGrid.indexOf(translate);
    } else {
      snapIndex = Math.floor(activeIndex / params.slidesPerGroup);
    }
    if (snapIndex >= snapGrid.length) { snapIndex = snapGrid.length - 1; }
    if (activeIndex === previousIndex) {
      if (snapIndex !== previousSnapIndex) {
        swiper.snapIndex = snapIndex;
        swiper.emit('snapIndexChange');
      }
      return;
    }

    // Get real index
    var realIndex = parseInt(swiper.slides.eq(activeIndex).attr('data-swiper-slide-index') || activeIndex, 10);

    Utils.extend(swiper, {
      snapIndex: snapIndex,
      realIndex: realIndex,
      previousIndex: previousIndex,
      activeIndex: activeIndex,
    });
    swiper.emit('activeIndexChange');
    swiper.emit('snapIndexChange');
    if (previousRealIndex !== realIndex) {
      swiper.emit('realIndexChange');
    }
    if (swiper.initialized || swiper.runCallbacksOnInit) {
      swiper.emit('slideChange');
    }
  }

  function updateClickedSlide (e) {
    var swiper = this;
    var params = swiper.params;
    var slide = $(e.target).closest(("." + (params.slideClass)))[0];
    var slideFound = false;
    if (slide) {
      for (var i = 0; i < swiper.slides.length; i += 1) {
        if (swiper.slides[i] === slide) { slideFound = true; }
      }
    }

    if (slide && slideFound) {
      swiper.clickedSlide = slide;
      if (swiper.virtual && swiper.params.virtual.enabled) {
        swiper.clickedIndex = parseInt($(slide).attr('data-swiper-slide-index'), 10);
      } else {
        swiper.clickedIndex = $(slide).index();
      }
    } else {
      swiper.clickedSlide = undefined;
      swiper.clickedIndex = undefined;
      return;
    }
    if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) {
      swiper.slideToClickedSlide();
    }
  }

  var update = {
    updateSize: updateSize,
    updateSlides: updateSlides,
    updateAutoHeight: updateAutoHeight,
    updateSlidesOffset: updateSlidesOffset,
    updateSlidesProgress: updateSlidesProgress,
    updateProgress: updateProgress,
    updateSlidesClasses: updateSlidesClasses,
    updateActiveIndex: updateActiveIndex,
    updateClickedSlide: updateClickedSlide,
  };

  function getTranslate (axis) {
    if ( axis === void 0 ) axis = this.isHorizontal() ? 'x' : 'y';

    var swiper = this;

    var params = swiper.params;
    var rtl = swiper.rtlTranslate;
    var translate = swiper.translate;
    var $wrapperEl = swiper.$wrapperEl;

    if (params.virtualTranslate) {
      return rtl ? -translate : translate;
    }

    var currentTranslate = Utils.getTranslate($wrapperEl[0], axis);
    if (rtl) { currentTranslate = -currentTranslate; }

    return currentTranslate || 0;
  }

  function setTranslate (translate, byController) {
    var swiper = this;
    var rtl = swiper.rtlTranslate;
    var params = swiper.params;
    var $wrapperEl = swiper.$wrapperEl;
    var progress = swiper.progress;
    var x = 0;
    var y = 0;
    var z = 0;

    if (swiper.isHorizontal()) {
      x = rtl ? -translate : translate;
    } else {
      y = translate;
    }

    if (params.roundLengths) {
      x = Math.floor(x);
      y = Math.floor(y);
    }

    if (!params.virtualTranslate) {
      if (Support.transforms3d) { $wrapperEl.transform(("translate3d(" + x + "px, " + y + "px, " + z + "px)")); }
      else { $wrapperEl.transform(("translate(" + x + "px, " + y + "px)")); }
    }
    swiper.previousTranslate = swiper.translate;
    swiper.translate = swiper.isHorizontal() ? x : y;

    // Check if we need to update progress
    var newProgress;
    var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) {
      newProgress = 0;
    } else {
      newProgress = (translate - swiper.minTranslate()) / (translatesDiff);
    }
    if (newProgress !== progress) {
      swiper.updateProgress(translate);
    }

    swiper.emit('setTranslate', swiper.translate, byController);
  }

  function minTranslate () {
    return (-this.snapGrid[0]);
  }

  function maxTranslate () {
    return (-this.snapGrid[this.snapGrid.length - 1]);
  }

  var translate = {
    getTranslate: getTranslate,
    setTranslate: setTranslate,
    minTranslate: minTranslate,
    maxTranslate: maxTranslate,
  };

  function setTransition (duration, byController) {
    var swiper = this;

    swiper.$wrapperEl.transition(duration);

    swiper.emit('setTransition', duration, byController);
  }

  function transitionStart (runCallbacks, direction) {
    if ( runCallbacks === void 0 ) runCallbacks = true;

    var swiper = this;
    var activeIndex = swiper.activeIndex;
    var params = swiper.params;
    var previousIndex = swiper.previousIndex;
    if (params.autoHeight) {
      swiper.updateAutoHeight();
    }

    var dir = direction;
    if (!dir) {
      if (activeIndex > previousIndex) { dir = 'next'; }
      else if (activeIndex < previousIndex) { dir = 'prev'; }
      else { dir = 'reset'; }
    }

    swiper.emit('transitionStart');

    if (runCallbacks && activeIndex !== previousIndex) {
      if (dir === 'reset') {
        swiper.emit('slideResetTransitionStart');
        return;
      }
      swiper.emit('slideChangeTransitionStart');
      if (dir === 'next') {
        swiper.emit('slideNextTransitionStart');
      } else {
        swiper.emit('slidePrevTransitionStart');
      }
    }
  }

  function transitionEnd$1 (runCallbacks, direction) {
    if ( runCallbacks === void 0 ) runCallbacks = true;

    var swiper = this;
    var activeIndex = swiper.activeIndex;
    var previousIndex = swiper.previousIndex;
    swiper.animating = false;
    swiper.setTransition(0);

    var dir = direction;
    if (!dir) {
      if (activeIndex > previousIndex) { dir = 'next'; }
      else if (activeIndex < previousIndex) { dir = 'prev'; }
      else { dir = 'reset'; }
    }

    swiper.emit('transitionEnd');

    if (runCallbacks && activeIndex !== previousIndex) {
      if (dir === 'reset') {
        swiper.emit('slideResetTransitionEnd');
        return;
      }
      swiper.emit('slideChangeTransitionEnd');
      if (dir === 'next') {
        swiper.emit('slideNextTransitionEnd');
      } else {
        swiper.emit('slidePrevTransitionEnd');
      }
    }
  }

  var transition$1 = {
    setTransition: setTransition,
    transitionStart: transitionStart,
    transitionEnd: transitionEnd$1,
  };

  function slideTo (index, speed, runCallbacks, internal) {
    if ( index === void 0 ) index = 0;
    if ( speed === void 0 ) speed = this.params.speed;
    if ( runCallbacks === void 0 ) runCallbacks = true;

    var swiper = this;
    var slideIndex = index;
    if (slideIndex < 0) { slideIndex = 0; }

    var params = swiper.params;
    var snapGrid = swiper.snapGrid;
    var slidesGrid = swiper.slidesGrid;
    var previousIndex = swiper.previousIndex;
    var activeIndex = swiper.activeIndex;
    var rtl = swiper.rtlTranslate;
    if (swiper.animating && params.preventInteractionOnTransition) {
      return false;
    }

    var snapIndex = Math.floor(slideIndex / params.slidesPerGroup);
    if (snapIndex >= snapGrid.length) { snapIndex = snapGrid.length - 1; }

    if ((activeIndex || params.initialSlide || 0) === (previousIndex || 0) && runCallbacks) {
      swiper.emit('beforeSlideChangeStart');
    }

    var translate = -snapGrid[snapIndex];

    // Update progress
    swiper.updateProgress(translate);

    // Normalize slideIndex
    if (params.normalizeSlideIndex) {
      for (var i = 0; i < slidesGrid.length; i += 1) {
        if (-Math.floor(translate * 100) >= Math.floor(slidesGrid[i] * 100)) {
          slideIndex = i;
        }
      }
    }
    // Directions locks
    if (swiper.initialized && slideIndex !== activeIndex) {
      if (!swiper.allowSlideNext && translate < swiper.translate && translate < swiper.minTranslate()) {
        return false;
      }
      if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
        if ((activeIndex || 0) !== slideIndex) { return false; }
      }
    }

    var direction;
    if (slideIndex > activeIndex) { direction = 'next'; }
    else if (slideIndex < activeIndex) { direction = 'prev'; }
    else { direction = 'reset'; }


    // Update Index
    if ((rtl && -translate === swiper.translate) || (!rtl && translate === swiper.translate)) {
      swiper.updateActiveIndex(slideIndex);
      // Update Height
      if (params.autoHeight) {
        swiper.updateAutoHeight();
      }
      swiper.updateSlidesClasses();
      if (params.effect !== 'slide') {
        swiper.setTranslate(translate);
      }
      if (direction !== 'reset') {
        swiper.transitionStart(runCallbacks, direction);
        swiper.transitionEnd(runCallbacks, direction);
      }
      return false;
    }

    if (speed === 0 || !Support.transition) {
      swiper.setTransition(0);
      swiper.setTranslate(translate);
      swiper.updateActiveIndex(slideIndex);
      swiper.updateSlidesClasses();
      swiper.emit('beforeTransitionStart', speed, internal);
      swiper.transitionStart(runCallbacks, direction);
      swiper.transitionEnd(runCallbacks, direction);
    } else {
      swiper.setTransition(speed);
      swiper.setTranslate(translate);
      swiper.updateActiveIndex(slideIndex);
      swiper.updateSlidesClasses();
      swiper.emit('beforeTransitionStart', speed, internal);
      swiper.transitionStart(runCallbacks, direction);
      if (!swiper.animating) {
        swiper.animating = true;
        if (!swiper.onSlideToWrapperTransitionEnd) {
          swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
            if (!swiper || swiper.destroyed) { return; }
            if (e.target !== this) { return; }
            swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
            swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
            swiper.onSlideToWrapperTransitionEnd = null;
            delete swiper.onSlideToWrapperTransitionEnd;
            swiper.transitionEnd(runCallbacks, direction);
          };
        }
        swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
        swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
      }
    }

    return true;
  }

  function slideToLoop (index, speed, runCallbacks, internal) {
    if ( index === void 0 ) index = 0;
    if ( speed === void 0 ) speed = this.params.speed;
    if ( runCallbacks === void 0 ) runCallbacks = true;

    var swiper = this;
    var newIndex = index;
    if (swiper.params.loop) {
      newIndex += swiper.loopedSlides;
    }

    return swiper.slideTo(newIndex, speed, runCallbacks, internal);
  }

  /* eslint no-unused-vars: "off" */
  function slideNext (speed, runCallbacks, internal) {
    if ( speed === void 0 ) speed = this.params.speed;
    if ( runCallbacks === void 0 ) runCallbacks = true;

    var swiper = this;
    var params = swiper.params;
    var animating = swiper.animating;
    if (params.loop) {
      if (animating) { return false; }
      swiper.loopFix();
      // eslint-disable-next-line
      swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
      return swiper.slideTo(swiper.activeIndex + params.slidesPerGroup, speed, runCallbacks, internal);
    }
    return swiper.slideTo(swiper.activeIndex + params.slidesPerGroup, speed, runCallbacks, internal);
  }

  /* eslint no-unused-vars: "off" */
  function slidePrev (speed, runCallbacks, internal) {
    if ( speed === void 0 ) speed = this.params.speed;
    if ( runCallbacks === void 0 ) runCallbacks = true;

    var swiper = this;
    var params = swiper.params;
    var animating = swiper.animating;
    var snapGrid = swiper.snapGrid;
    var slidesGrid = swiper.slidesGrid;
    var rtlTranslate = swiper.rtlTranslate;

    if (params.loop) {
      if (animating) { return false; }
      swiper.loopFix();
      // eslint-disable-next-line
      swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
    }
    var translate = rtlTranslate ? swiper.translate : -swiper.translate;
    function normalize(val) {
      if (val < 0) { return -Math.floor(Math.abs(val)); }
      return Math.floor(val);
    }
    var normalizedTranslate = normalize(translate);
    var normalizedSnapGrid = snapGrid.map(function (val) { return normalize(val); });
    var normalizedSlidesGrid = slidesGrid.map(function (val) { return normalize(val); });

    var currentSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate)];
    var prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
    var prevIndex;
    if (typeof prevSnap !== 'undefined') {
      prevIndex = slidesGrid.indexOf(prevSnap);
      if (prevIndex < 0) { prevIndex = swiper.activeIndex - 1; }
    }
    return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
  }

  /* eslint no-unused-vars: "off" */
  function slideReset (speed, runCallbacks, internal) {
    if ( speed === void 0 ) speed = this.params.speed;
    if ( runCallbacks === void 0 ) runCallbacks = true;

    var swiper = this;
    return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
  }

  /* eslint no-unused-vars: "off" */
  function slideToClosest (speed, runCallbacks, internal) {
    if ( speed === void 0 ) speed = this.params.speed;
    if ( runCallbacks === void 0 ) runCallbacks = true;

    var swiper = this;
    var index = swiper.activeIndex;
    var snapIndex = Math.floor(index / swiper.params.slidesPerGroup);

    if (snapIndex < swiper.snapGrid.length - 1) {
      var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;

      var currentSnap = swiper.snapGrid[snapIndex];
      var nextSnap = swiper.snapGrid[snapIndex + 1];

      if ((translate - currentSnap) > (nextSnap - currentSnap) / 2) {
        index = swiper.params.slidesPerGroup;
      }
    }

    return swiper.slideTo(index, speed, runCallbacks, internal);
  }

  function slideToClickedSlide () {
    var swiper = this;
    var params = swiper.params;
    var $wrapperEl = swiper.$wrapperEl;

    var slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
    var slideToIndex = swiper.clickedIndex;
    var realIndex;
    if (params.loop) {
      if (swiper.animating) { return; }
      realIndex = parseInt($(swiper.clickedSlide).attr('data-swiper-slide-index'), 10);
      if (params.centeredSlides) {
        if (
          (slideToIndex < swiper.loopedSlides - (slidesPerView / 2))
          || (slideToIndex > (swiper.slides.length - swiper.loopedSlides) + (slidesPerView / 2))
        ) {
          swiper.loopFix();
          slideToIndex = $wrapperEl
            .children(("." + (params.slideClass) + "[data-swiper-slide-index=\"" + realIndex + "\"]:not(." + (params.slideDuplicateClass) + ")"))
            .eq(0)
            .index();

          Utils.nextTick(function () {
            swiper.slideTo(slideToIndex);
          });
        } else {
          swiper.slideTo(slideToIndex);
        }
      } else if (slideToIndex > swiper.slides.length - slidesPerView) {
        swiper.loopFix();
        slideToIndex = $wrapperEl
          .children(("." + (params.slideClass) + "[data-swiper-slide-index=\"" + realIndex + "\"]:not(." + (params.slideDuplicateClass) + ")"))
          .eq(0)
          .index();

        Utils.nextTick(function () {
          swiper.slideTo(slideToIndex);
        });
      } else {
        swiper.slideTo(slideToIndex);
      }
    } else {
      swiper.slideTo(slideToIndex);
    }
  }

  var slide = {
    slideTo: slideTo,
    slideToLoop: slideToLoop,
    slideNext: slideNext,
    slidePrev: slidePrev,
    slideReset: slideReset,
    slideToClosest: slideToClosest,
    slideToClickedSlide: slideToClickedSlide,
  };

  function loopCreate () {
    var swiper = this;
    var params = swiper.params;
    var $wrapperEl = swiper.$wrapperEl;
    // Remove duplicated slides
    $wrapperEl.children(("." + (params.slideClass) + "." + (params.slideDuplicateClass))).remove();

    var slides = $wrapperEl.children(("." + (params.slideClass)));

    if (params.loopFillGroupWithBlank) {
      var blankSlidesNum = params.slidesPerGroup - (slides.length % params.slidesPerGroup);
      if (blankSlidesNum !== params.slidesPerGroup) {
        for (var i = 0; i < blankSlidesNum; i += 1) {
          var blankNode = $(doc.createElement('div')).addClass(((params.slideClass) + " " + (params.slideBlankClass)));
          $wrapperEl.append(blankNode);
        }
        slides = $wrapperEl.children(("." + (params.slideClass)));
      }
    }

    if (params.slidesPerView === 'auto' && !params.loopedSlides) { params.loopedSlides = slides.length; }

    swiper.loopedSlides = parseInt(params.loopedSlides || params.slidesPerView, 10);
    swiper.loopedSlides += params.loopAdditionalSlides;
    if (swiper.loopedSlides > slides.length) {
      swiper.loopedSlides = slides.length;
    }

    var prependSlides = [];
    var appendSlides = [];
    slides.each(function (index, el) {
      var slide = $(el);
      if (index < swiper.loopedSlides) { appendSlides.push(el); }
      if (index < slides.length && index >= slides.length - swiper.loopedSlides) { prependSlides.push(el); }
      slide.attr('data-swiper-slide-index', index);
    });
    for (var i$1 = 0; i$1 < appendSlides.length; i$1 += 1) {
      $wrapperEl.append($(appendSlides[i$1].cloneNode(true)).addClass(params.slideDuplicateClass));
    }
    for (var i$2 = prependSlides.length - 1; i$2 >= 0; i$2 -= 1) {
      $wrapperEl.prepend($(prependSlides[i$2].cloneNode(true)).addClass(params.slideDuplicateClass));
    }
  }

  function loopFix () {
    var swiper = this;
    var params = swiper.params;
    var activeIndex = swiper.activeIndex;
    var slides = swiper.slides;
    var loopedSlides = swiper.loopedSlides;
    var allowSlidePrev = swiper.allowSlidePrev;
    var allowSlideNext = swiper.allowSlideNext;
    var snapGrid = swiper.snapGrid;
    var rtl = swiper.rtlTranslate;
    var newIndex;
    swiper.allowSlidePrev = true;
    swiper.allowSlideNext = true;

    var snapTranslate = -snapGrid[activeIndex];
    var diff = snapTranslate - swiper.getTranslate();


    // Fix For Negative Oversliding
    if (activeIndex < loopedSlides) {
      newIndex = (slides.length - (loopedSlides * 3)) + activeIndex;
      newIndex += loopedSlides;
      var slideChanged = swiper.slideTo(newIndex, 0, false, true);
      if (slideChanged && diff !== 0) {
        swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
      }
    } else if ((params.slidesPerView === 'auto' && activeIndex >= loopedSlides * 2) || (activeIndex >= slides.length - loopedSlides)) {
      // Fix For Positive Oversliding
      newIndex = -slides.length + activeIndex + loopedSlides;
      newIndex += loopedSlides;
      var slideChanged$1 = swiper.slideTo(newIndex, 0, false, true);
      if (slideChanged$1 && diff !== 0) {
        swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
      }
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
  }

  function loopDestroy () {
    var swiper = this;
    var $wrapperEl = swiper.$wrapperEl;
    var params = swiper.params;
    var slides = swiper.slides;
    $wrapperEl.children(("." + (params.slideClass) + "." + (params.slideDuplicateClass) + ",." + (params.slideClass) + "." + (params.slideBlankClass))).remove();
    slides.removeAttr('data-swiper-slide-index');
  }

  var loop = {
    loopCreate: loopCreate,
    loopFix: loopFix,
    loopDestroy: loopDestroy,
  };

  function setGrabCursor (moving) {
    var swiper = this;
    if (Support.touch || !swiper.params.simulateTouch || (swiper.params.watchOverflow && swiper.isLocked)) { return; }
    var el = swiper.el;
    el.style.cursor = 'move';
    el.style.cursor = moving ? '-webkit-grabbing' : '-webkit-grab';
    el.style.cursor = moving ? '-moz-grabbin' : '-moz-grab';
    el.style.cursor = moving ? 'grabbing' : 'grab';
  }

  function unsetGrabCursor () {
    var swiper = this;
    if (Support.touch || (swiper.params.watchOverflow && swiper.isLocked)) { return; }
    swiper.el.style.cursor = '';
  }

  var grabCursor = {
    setGrabCursor: setGrabCursor,
    unsetGrabCursor: unsetGrabCursor,
  };

  function appendSlide (slides) {
    var swiper = this;
    var $wrapperEl = swiper.$wrapperEl;
    var params = swiper.params;
    if (params.loop) {
      swiper.loopDestroy();
    }
    if (typeof slides === 'object' && 'length' in slides) {
      for (var i = 0; i < slides.length; i += 1) {
        if (slides[i]) { $wrapperEl.append(slides[i]); }
      }
    } else {
      $wrapperEl.append(slides);
    }
    if (params.loop) {
      swiper.loopCreate();
    }
    if (!(params.observer && Support.observer)) {
      swiper.update();
    }
  }

  function prependSlide (slides) {
    var swiper = this;
    var params = swiper.params;
    var $wrapperEl = swiper.$wrapperEl;
    var activeIndex = swiper.activeIndex;

    if (params.loop) {
      swiper.loopDestroy();
    }
    var newActiveIndex = activeIndex + 1;
    if (typeof slides === 'object' && 'length' in slides) {
      for (var i = 0; i < slides.length; i += 1) {
        if (slides[i]) { $wrapperEl.prepend(slides[i]); }
      }
      newActiveIndex = activeIndex + slides.length;
    } else {
      $wrapperEl.prepend(slides);
    }
    if (params.loop) {
      swiper.loopCreate();
    }
    if (!(params.observer && Support.observer)) {
      swiper.update();
    }
    swiper.slideTo(newActiveIndex, 0, false);
  }

  function addSlide (index, slides) {
    var swiper = this;
    var $wrapperEl = swiper.$wrapperEl;
    var params = swiper.params;
    var activeIndex = swiper.activeIndex;
    var activeIndexBuffer = activeIndex;
    if (params.loop) {
      activeIndexBuffer -= swiper.loopedSlides;
      swiper.loopDestroy();
      swiper.slides = $wrapperEl.children(("." + (params.slideClass)));
    }
    var baseLength = swiper.slides.length;
    if (index <= 0) {
      swiper.prependSlide(slides);
      return;
    }
    if (index >= baseLength) {
      swiper.appendSlide(slides);
      return;
    }
    var newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;

    var slidesBuffer = [];
    for (var i = baseLength - 1; i >= index; i -= 1) {
      var currentSlide = swiper.slides.eq(i);
      currentSlide.remove();
      slidesBuffer.unshift(currentSlide);
    }

    if (typeof slides === 'object' && 'length' in slides) {
      for (var i$1 = 0; i$1 < slides.length; i$1 += 1) {
        if (slides[i$1]) { $wrapperEl.append(slides[i$1]); }
      }
      newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
    } else {
      $wrapperEl.append(slides);
    }

    for (var i$2 = 0; i$2 < slidesBuffer.length; i$2 += 1) {
      $wrapperEl.append(slidesBuffer[i$2]);
    }

    if (params.loop) {
      swiper.loopCreate();
    }
    if (!(params.observer && Support.observer)) {
      swiper.update();
    }
    if (params.loop) {
      swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    } else {
      swiper.slideTo(newActiveIndex, 0, false);
    }
  }

  function removeSlide (slidesIndexes) {
    var swiper = this;
    var params = swiper.params;
    var $wrapperEl = swiper.$wrapperEl;
    var activeIndex = swiper.activeIndex;

    var activeIndexBuffer = activeIndex;
    if (params.loop) {
      activeIndexBuffer -= swiper.loopedSlides;
      swiper.loopDestroy();
      swiper.slides = $wrapperEl.children(("." + (params.slideClass)));
    }
    var newActiveIndex = activeIndexBuffer;
    var indexToRemove;

    if (typeof slidesIndexes === 'object' && 'length' in slidesIndexes) {
      for (var i = 0; i < slidesIndexes.length; i += 1) {
        indexToRemove = slidesIndexes[i];
        if (swiper.slides[indexToRemove]) { swiper.slides.eq(indexToRemove).remove(); }
        if (indexToRemove < newActiveIndex) { newActiveIndex -= 1; }
      }
      newActiveIndex = Math.max(newActiveIndex, 0);
    } else {
      indexToRemove = slidesIndexes;
      if (swiper.slides[indexToRemove]) { swiper.slides.eq(indexToRemove).remove(); }
      if (indexToRemove < newActiveIndex) { newActiveIndex -= 1; }
      newActiveIndex = Math.max(newActiveIndex, 0);
    }

    if (params.loop) {
      swiper.loopCreate();
    }

    if (!(params.observer && Support.observer)) {
      swiper.update();
    }
    if (params.loop) {
      swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    } else {
      swiper.slideTo(newActiveIndex, 0, false);
    }
  }

  function removeAllSlides () {
    var swiper = this;

    var slidesIndexes = [];
    for (var i = 0; i < swiper.slides.length; i += 1) {
      slidesIndexes.push(i);
    }
    swiper.removeSlide(slidesIndexes);
  }

  var manipulation = {
    appendSlide: appendSlide,
    prependSlide: prependSlide,
    addSlide: addSlide,
    removeSlide: removeSlide,
    removeAllSlides: removeAllSlides,
  };

  var Device = (function Device() {
    var ua = win.navigator.userAgent;

    var device = {
      ios: false,
      android: false,
      androidChrome: false,
      desktop: false,
      windows: false,
      iphone: false,
      ipod: false,
      ipad: false,
      cordova: win.cordova || win.phonegap,
      phonegap: win.cordova || win.phonegap,
    };

    var windows = ua.match(/(Windows Phone);?[\s\/]+([\d.]+)?/); // eslint-disable-line
    var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
    var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
    var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
    var iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);


    // Windows
    if (windows) {
      device.os = 'windows';
      device.osVersion = windows[2];
      device.windows = true;
    }
    // Android
    if (android && !windows) {
      device.os = 'android';
      device.osVersion = android[2];
      device.android = true;
      device.androidChrome = ua.toLowerCase().indexOf('chrome') >= 0;
    }
    if (ipad || iphone || ipod) {
      device.os = 'ios';
      device.ios = true;
    }
    // iOS
    if (iphone && !ipod) {
      device.osVersion = iphone[2].replace(/_/g, '.');
      device.iphone = true;
    }
    if (ipad) {
      device.osVersion = ipad[2].replace(/_/g, '.');
      device.ipad = true;
    }
    if (ipod) {
      device.osVersion = ipod[3] ? ipod[3].replace(/_/g, '.') : null;
      device.iphone = true;
    }
    // iOS 8+ changed UA
    if (device.ios && device.osVersion && ua.indexOf('Version/') >= 0) {
      if (device.osVersion.split('.')[0] === '10') {
        device.osVersion = ua.toLowerCase().split('version/')[1].split(' ')[0];
      }
    }

    // Desktop
    device.desktop = !(device.os || device.android || device.webView);

    // Webview
    device.webView = (iphone || ipad || ipod) && ua.match(/.*AppleWebKit(?!.*Safari)/i);

    // Minimal UI
    if (device.os && device.os === 'ios') {
      var osVersionArr = device.osVersion.split('.');
      var metaViewport = doc.querySelector('meta[name="viewport"]');
      device.minimalUi = !device.webView
        && (ipod || iphone)
        && (osVersionArr[0] * 1 === 7 ? osVersionArr[1] * 1 >= 1 : osVersionArr[0] * 1 > 7)
        && metaViewport && metaViewport.getAttribute('content').indexOf('minimal-ui') >= 0;
    }

    // Pixel Ratio
    device.pixelRatio = win.devicePixelRatio || 1;

    // Export object
    return device;
  }());

  function onTouchStart (event) {
    var swiper = this;
    var data = swiper.touchEventsData;
    var params = swiper.params;
    var touches = swiper.touches;
    if (swiper.animating && params.preventInteractionOnTransition) {
      return;
    }
    var e = event;
    if (e.originalEvent) { e = e.originalEvent; }
    data.isTouchEvent = e.type === 'touchstart';
    if (!data.isTouchEvent && 'which' in e && e.which === 3) { return; }
    if (!data.isTouchEvent && 'button' in e && e.button > 0) { return; }
    if (data.isTouched && data.isMoved) { return; }
    if (params.noSwiping && $(e.target).closest(params.noSwipingSelector ? params.noSwipingSelector : ("." + (params.noSwipingClass)))[0]) {
      swiper.allowClick = true;
      return;
    }
    if (params.swipeHandler) {
      if (!$(e).closest(params.swipeHandler)[0]) { return; }
    }

    touches.currentX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
    touches.currentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
    var startX = touches.currentX;
    var startY = touches.currentY;

    // Do NOT start if iOS edge swipe is detected. Otherwise iOS app (UIWebView) cannot swipe-to-go-back anymore

    var edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
    var edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;
    if (
      edgeSwipeDetection
      && ((startX <= edgeSwipeThreshold)
      || (startX >= win.screen.width - edgeSwipeThreshold))
    ) {
      return;
    }

    Utils.extend(data, {
      isTouched: true,
      isMoved: false,
      allowTouchCallbacks: true,
      isScrolling: undefined,
      startMoving: undefined,
    });

    touches.startX = startX;
    touches.startY = startY;
    data.touchStartTime = Utils.now();
    swiper.allowClick = true;
    swiper.updateSize();
    swiper.swipeDirection = undefined;
    if (params.threshold > 0) { data.allowThresholdMove = false; }
    if (e.type !== 'touchstart') {
      var preventDefault = true;
      if ($(e.target).is(data.formElements)) { preventDefault = false; }
      if (
        doc.activeElement
        && $(doc.activeElement).is(data.formElements)
        && doc.activeElement !== e.target
      ) {
        doc.activeElement.blur();
      }

      var shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
      if (params.touchStartForcePreventDefault || shouldPreventDefault) {
        e.preventDefault();
      }
    }
    swiper.emit('touchStart', e);
  }

  function onTouchMove (event) {
    var swiper = this;
    var data = swiper.touchEventsData;
    var params = swiper.params;
    var touches = swiper.touches;
    var rtl = swiper.rtlTranslate;
    var e = event;
    if (e.originalEvent) { e = e.originalEvent; }
    if (!data.isTouched) {
      if (data.startMoving && data.isScrolling) {
        swiper.emit('touchMoveOpposite', e);
      }
      return;
    }
    if (data.isTouchEvent && e.type === 'mousemove') { return; }
    var targetTouch = e.type === 'touchmove' && e.targetTouches && (e.targetTouches[0] || e.changedTouches[0]);
    var pageX = e.type === 'touchmove' ? targetTouch.pageX : e.pageX;
    var pageY = e.type === 'touchmove' ? targetTouch.pageY : e.pageY;
    if (e.preventedByNestedSwiper) {
      touches.startX = pageX;
      touches.startY = pageY;
      return;
    }
    if (!swiper.allowTouchMove) {
      // isMoved = true;
      swiper.allowClick = false;
      if (data.isTouched) {
        Utils.extend(touches, {
          startX: pageX,
          startY: pageY,
          currentX: pageX,
          currentY: pageY,
        });
        data.touchStartTime = Utils.now();
      }
      return;
    }
    if (data.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
      if (swiper.isVertical()) {
        // Vertical
        if (
          (pageY < touches.startY && swiper.translate <= swiper.maxTranslate())
          || (pageY > touches.startY && swiper.translate >= swiper.minTranslate())
        ) {
          data.isTouched = false;
          data.isMoved = false;
          return;
        }
      } else if (
        (pageX < touches.startX && swiper.translate <= swiper.maxTranslate())
        || (pageX > touches.startX && swiper.translate >= swiper.minTranslate())
      ) {
        return;
      }
    }
    if (data.isTouchEvent && doc.activeElement) {
      if (e.target === doc.activeElement && $(e.target).is(data.formElements)) {
        data.isMoved = true;
        swiper.allowClick = false;
        return;
      }
    }
    if (data.allowTouchCallbacks) {
      swiper.emit('touchMove', e);
    }
    if (e.targetTouches && e.targetTouches.length > 1) { return; }

    touches.currentX = pageX;
    touches.currentY = pageY;

    var diffX = touches.currentX - touches.startX;
    var diffY = touches.currentY - touches.startY;
    if (swiper.params.threshold && Math.sqrt((Math.pow( diffX, 2 )) + (Math.pow( diffY, 2 ))) < swiper.params.threshold) { return; }

    if (typeof data.isScrolling === 'undefined') {
      var touchAngle;
      if ((swiper.isHorizontal() && touches.currentY === touches.startY) || (swiper.isVertical() && touches.currentX === touches.startX)) {
        data.isScrolling = false;
      } else {
        // eslint-disable-next-line
        if ((diffX * diffX) + (diffY * diffY) >= 25) {
          touchAngle = (Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180) / Math.PI;
          data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : (90 - touchAngle > params.touchAngle);
        }
      }
    }
    if (data.isScrolling) {
      swiper.emit('touchMoveOpposite', e);
    }
    if (typeof data.startMoving === 'undefined') {
      if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) {
        data.startMoving = true;
      }
    }
    if (data.isScrolling) {
      data.isTouched = false;
      return;
    }
    if (!data.startMoving) {
      return;
    }
    swiper.allowClick = false;
    e.preventDefault();
    if (params.touchMoveStopPropagation && !params.nested) {
      e.stopPropagation();
    }

    if (!data.isMoved) {
      if (params.loop) {
        swiper.loopFix();
      }
      data.startTranslate = swiper.getTranslate();
      swiper.setTransition(0);
      if (swiper.animating) {
        swiper.$wrapperEl.trigger('webkitTransitionEnd transitionend');
      }
      data.allowMomentumBounce = false;
      // Grab Cursor
      if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
        swiper.setGrabCursor(true);
      }
      swiper.emit('sliderFirstMove', e);
    }
    swiper.emit('sliderMove', e);
    data.isMoved = true;

    var diff = swiper.isHorizontal() ? diffX : diffY;
    touches.diff = diff;

    diff *= params.touchRatio;
    if (rtl) { diff = -diff; }

    swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
    data.currentTranslate = diff + data.startTranslate;

    var disableParentSwiper = true;
    var resistanceRatio = params.resistanceRatio;
    if (params.touchReleaseOnEdges) {
      resistanceRatio = 0;
    }
    if ((diff > 0 && data.currentTranslate > swiper.minTranslate())) {
      disableParentSwiper = false;
      if (params.resistance) { data.currentTranslate = (swiper.minTranslate() - 1) + (Math.pow( (-swiper.minTranslate() + data.startTranslate + diff), resistanceRatio )); }
    } else if (diff < 0 && data.currentTranslate < swiper.maxTranslate()) {
      disableParentSwiper = false;
      if (params.resistance) { data.currentTranslate = (swiper.maxTranslate() + 1) - (Math.pow( (swiper.maxTranslate() - data.startTranslate - diff), resistanceRatio )); }
    }

    if (disableParentSwiper) {
      e.preventedByNestedSwiper = true;
    }

    // Directions locks
    if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) {
      data.currentTranslate = data.startTranslate;
    }
    if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) {
      data.currentTranslate = data.startTranslate;
    }


    // Threshold
    if (params.threshold > 0) {
      if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
        if (!data.allowThresholdMove) {
          data.allowThresholdMove = true;
          touches.startX = touches.currentX;
          touches.startY = touches.currentY;
          data.currentTranslate = data.startTranslate;
          touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
          return;
        }
      } else {
        data.currentTranslate = data.startTranslate;
        return;
      }
    }

    if (!params.followFinger) { return; }

    // Update active index in free mode
    if (params.freeMode || params.watchSlidesProgress || params.watchSlidesVisibility) {
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }
    if (params.freeMode) {
      // Velocity
      if (data.velocities.length === 0) {
        data.velocities.push({
          position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
          time: data.touchStartTime,
        });
      }
      data.velocities.push({
        position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
        time: Utils.now(),
      });
    }
    // Update progress
    swiper.updateProgress(data.currentTranslate);
    // Update translate
    swiper.setTranslate(data.currentTranslate);
  }

  function onTouchEnd (event) {
    var swiper = this;
    var data = swiper.touchEventsData;

    var params = swiper.params;
    var touches = swiper.touches;
    var rtl = swiper.rtlTranslate;
    var $wrapperEl = swiper.$wrapperEl;
    var slidesGrid = swiper.slidesGrid;
    var snapGrid = swiper.snapGrid;
    var e = event;
    if (e.originalEvent) { e = e.originalEvent; }
    if (data.allowTouchCallbacks) {
      swiper.emit('touchEnd', e);
    }
    data.allowTouchCallbacks = false;
    if (!data.isTouched) {
      if (data.isMoved && params.grabCursor) {
        swiper.setGrabCursor(false);
      }
      data.isMoved = false;
      data.startMoving = false;
      return;
    }
    // Return Grab Cursor
    if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
      swiper.setGrabCursor(false);
    }

    // Time diff
    var touchEndTime = Utils.now();
    var timeDiff = touchEndTime - data.touchStartTime;

    // Tap, doubleTap, Click
    if (swiper.allowClick) {
      swiper.updateClickedSlide(e);
      swiper.emit('tap', e);
      if (timeDiff < 300 && (touchEndTime - data.lastClickTime) > 300) {
        if (data.clickTimeout) { clearTimeout(data.clickTimeout); }
        data.clickTimeout = Utils.nextTick(function () {
          if (!swiper || swiper.destroyed) { return; }
          swiper.emit('click', e);
        }, 300);
      }
      if (timeDiff < 300 && (touchEndTime - data.lastClickTime) < 300) {
        if (data.clickTimeout) { clearTimeout(data.clickTimeout); }
        swiper.emit('doubleTap', e);
      }
    }

    data.lastClickTime = Utils.now();
    Utils.nextTick(function () {
      if (!swiper.destroyed) { swiper.allowClick = true; }
    });

    if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
      data.isTouched = false;
      data.isMoved = false;
      data.startMoving = false;
      return;
    }
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;

    var currentPos;
    if (params.followFinger) {
      currentPos = rtl ? swiper.translate : -swiper.translate;
    } else {
      currentPos = -data.currentTranslate;
    }

    if (params.freeMode) {
      if (currentPos < -swiper.minTranslate()) {
        swiper.slideTo(swiper.activeIndex);
        return;
      }
      if (currentPos > -swiper.maxTranslate()) {
        if (swiper.slides.length < snapGrid.length) {
          swiper.slideTo(snapGrid.length - 1);
        } else {
          swiper.slideTo(swiper.slides.length - 1);
        }
        return;
      }

      if (params.freeModeMomentum) {
        if (data.velocities.length > 1) {
          var lastMoveEvent = data.velocities.pop();
          var velocityEvent = data.velocities.pop();

          var distance = lastMoveEvent.position - velocityEvent.position;
          var time = lastMoveEvent.time - velocityEvent.time;
          swiper.velocity = distance / time;
          swiper.velocity /= 2;
          if (Math.abs(swiper.velocity) < params.freeModeMinimumVelocity) {
            swiper.velocity = 0;
          }
          // this implies that the user stopped moving a finger then released.
          // There would be no events with distance zero, so the last event is stale.
          if (time > 150 || (Utils.now() - lastMoveEvent.time) > 300) {
            swiper.velocity = 0;
          }
        } else {
          swiper.velocity = 0;
        }
        swiper.velocity *= params.freeModeMomentumVelocityRatio;

        data.velocities.length = 0;
        var momentumDuration = 1000 * params.freeModeMomentumRatio;
        var momentumDistance = swiper.velocity * momentumDuration;

        var newPosition = swiper.translate + momentumDistance;
        if (rtl) { newPosition = -newPosition; }

        var doBounce = false;
        var afterBouncePosition;
        var bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeModeMomentumBounceRatio;
        var needsLoopFix;
        if (newPosition < swiper.maxTranslate()) {
          if (params.freeModeMomentumBounce) {
            if (newPosition + swiper.maxTranslate() < -bounceAmount) {
              newPosition = swiper.maxTranslate() - bounceAmount;
            }
            afterBouncePosition = swiper.maxTranslate();
            doBounce = true;
            data.allowMomentumBounce = true;
          } else {
            newPosition = swiper.maxTranslate();
          }
          if (params.loop && params.centeredSlides) { needsLoopFix = true; }
        } else if (newPosition > swiper.minTranslate()) {
          if (params.freeModeMomentumBounce) {
            if (newPosition - swiper.minTranslate() > bounceAmount) {
              newPosition = swiper.minTranslate() + bounceAmount;
            }
            afterBouncePosition = swiper.minTranslate();
            doBounce = true;
            data.allowMomentumBounce = true;
          } else {
            newPosition = swiper.minTranslate();
          }
          if (params.loop && params.centeredSlides) { needsLoopFix = true; }
        } else if (params.freeModeSticky) {
          var nextSlide;
          for (var j = 0; j < snapGrid.length; j += 1) {
            if (snapGrid[j] > -newPosition) {
              nextSlide = j;
              break;
            }
          }

          if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') {
            newPosition = snapGrid[nextSlide];
          } else {
            newPosition = snapGrid[nextSlide - 1];
          }
          newPosition = -newPosition;
        }
        if (needsLoopFix) {
          swiper.once('transitionEnd', function () {
            swiper.loopFix();
          });
        }
        // Fix duration
        if (swiper.velocity !== 0) {
          if (rtl) {
            momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
          } else {
            momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
          }
        } else if (params.freeModeSticky) {
          swiper.slideToClosest();
          return;
        }

        if (params.freeModeMomentumBounce && doBounce) {
          swiper.updateProgress(afterBouncePosition);
          swiper.setTransition(momentumDuration);
          swiper.setTranslate(newPosition);
          swiper.transitionStart(true, swiper.swipeDirection);
          swiper.animating = true;
          $wrapperEl.transitionEnd(function () {
            if (!swiper || swiper.destroyed || !data.allowMomentumBounce) { return; }
            swiper.emit('momentumBounce');

            swiper.setTransition(params.speed);
            swiper.setTranslate(afterBouncePosition);
            $wrapperEl.transitionEnd(function () {
              if (!swiper || swiper.destroyed) { return; }
              swiper.transitionEnd();
            });
          });
        } else if (swiper.velocity) {
          swiper.updateProgress(newPosition);
          swiper.setTransition(momentumDuration);
          swiper.setTranslate(newPosition);
          swiper.transitionStart(true, swiper.swipeDirection);
          if (!swiper.animating) {
            swiper.animating = true;
            $wrapperEl.transitionEnd(function () {
              if (!swiper || swiper.destroyed) { return; }
              swiper.transitionEnd();
            });
          }
        } else {
          swiper.updateProgress(newPosition);
        }

        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
      } else if (params.freeModeSticky) {
        swiper.slideToClosest();
        return;
      }

      if (!params.freeModeMomentum || timeDiff >= params.longSwipesMs) {
        swiper.updateProgress();
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
      }
      return;
    }

    // Find current slide
    var stopIndex = 0;
    var groupSize = swiper.slidesSizesGrid[0];
    for (var i = 0; i < slidesGrid.length; i += params.slidesPerGroup) {
      if (typeof slidesGrid[i + params.slidesPerGroup] !== 'undefined') {
        if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + params.slidesPerGroup]) {
          stopIndex = i;
          groupSize = slidesGrid[i + params.slidesPerGroup] - slidesGrid[i];
        }
      } else if (currentPos >= slidesGrid[i]) {
        stopIndex = i;
        groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
      }
    }

    // Find current slide size
    var ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;

    if (timeDiff > params.longSwipesMs) {
      // Long touches
      if (!params.longSwipes) {
        swiper.slideTo(swiper.activeIndex);
        return;
      }
      if (swiper.swipeDirection === 'next') {
        if (ratio >= params.longSwipesRatio) { swiper.slideTo(stopIndex + params.slidesPerGroup); }
        else { swiper.slideTo(stopIndex); }
      }
      if (swiper.swipeDirection === 'prev') {
        if (ratio > (1 - params.longSwipesRatio)) { swiper.slideTo(stopIndex + params.slidesPerGroup); }
        else { swiper.slideTo(stopIndex); }
      }
    } else {
      // Short swipes
      if (!params.shortSwipes) {
        swiper.slideTo(swiper.activeIndex);
        return;
      }
      if (swiper.swipeDirection === 'next') {
        swiper.slideTo(stopIndex + params.slidesPerGroup);
      }
      if (swiper.swipeDirection === 'prev') {
        swiper.slideTo(stopIndex);
      }
    }
  }

  function onResize () {
    var swiper = this;

    var params = swiper.params;
    var el = swiper.el;

    if (el && el.offsetWidth === 0) { return; }

    // Breakpoints
    if (params.breakpoints) {
      swiper.setBreakpoint();
    }

    // Save locks
    var allowSlideNext = swiper.allowSlideNext;
    var allowSlidePrev = swiper.allowSlidePrev;
    var snapGrid = swiper.snapGrid;

    // Disable locks on resize
    swiper.allowSlideNext = true;
    swiper.allowSlidePrev = true;

    swiper.updateSize();
    swiper.updateSlides();

    if (params.freeMode) {
      var newTranslate = Math.min(Math.max(swiper.translate, swiper.maxTranslate()), swiper.minTranslate());
      swiper.setTranslate(newTranslate);
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();

      if (params.autoHeight) {
        swiper.updateAutoHeight();
      }
    } else {
      swiper.updateSlidesClasses();
      if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
        swiper.slideTo(swiper.slides.length - 1, 0, false, true);
      } else {
        swiper.slideTo(swiper.activeIndex, 0, false, true);
      }
    }
    if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
      swiper.autoplay.run();
    }
    // Return locks after resize
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;

    if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) {
      swiper.checkOverflow();
    }
  }

  function onClick (e) {
    var swiper = this;
    if (!swiper.allowClick) {
      if (swiper.params.preventClicks) { e.preventDefault(); }
      if (swiper.params.preventClicksPropagation && swiper.animating) {
        e.stopPropagation();
        e.stopImmediatePropagation();
      }
    }
  }

  var dummyEventAttached = false;
  function dummyEventListener() {}

  function attachEvents() {
    var swiper = this;
    var params = swiper.params;
    var touchEvents = swiper.touchEvents;
    var el = swiper.el;
    var wrapperEl = swiper.wrapperEl;

    {
      swiper.onTouchStart = onTouchStart.bind(swiper);
      swiper.onTouchMove = onTouchMove.bind(swiper);
      swiper.onTouchEnd = onTouchEnd.bind(swiper);
    }

    swiper.onClick = onClick.bind(swiper);

    var target = params.touchEventsTarget === 'container' ? el : wrapperEl;
    var capture = !!params.nested;

    // Touch Events
    {
      if (!Support.touch && (Support.pointerEvents || Support.prefixedPointerEvents)) {
        target.addEventListener(touchEvents.start, swiper.onTouchStart, false);
        doc.addEventListener(touchEvents.move, swiper.onTouchMove, capture);
        doc.addEventListener(touchEvents.end, swiper.onTouchEnd, false);
      } else {
        if (Support.touch) {
          var passiveListener = touchEvents.start === 'touchstart' && Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
          target.addEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
          target.addEventListener(touchEvents.move, swiper.onTouchMove, Support.passiveListener ? { passive: false, capture: capture } : capture);
          target.addEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);

          if (!dummyEventAttached) {
            doc.addEventListener('touchstart', dummyEventListener);
            dummyEventAttached = true;
          }
        }
        if ((params.simulateTouch && !Device.ios && !Device.android) || (params.simulateTouch && !Support.touch && Device.ios)) {
          target.addEventListener('mousedown', swiper.onTouchStart, false);
          doc.addEventListener('mousemove', swiper.onTouchMove, capture);
          doc.addEventListener('mouseup', swiper.onTouchEnd, false);
        }
      }
      // Prevent Links Clicks
      if (params.preventClicks || params.preventClicksPropagation) {
        target.addEventListener('click', swiper.onClick, true);
      }
    }

    // Resize handler
    swiper.on((Device.ios || Device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate'), onResize, true);
  }

  function detachEvents() {
    var swiper = this;

    var params = swiper.params;
    var touchEvents = swiper.touchEvents;
    var el = swiper.el;
    var wrapperEl = swiper.wrapperEl;

    var target = params.touchEventsTarget === 'container' ? el : wrapperEl;
    var capture = !!params.nested;

    // Touch Events
    {
      if (!Support.touch && (Support.pointerEvents || Support.prefixedPointerEvents)) {
        target.removeEventListener(touchEvents.start, swiper.onTouchStart, false);
        doc.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
        doc.removeEventListener(touchEvents.end, swiper.onTouchEnd, false);
      } else {
        if (Support.touch) {
          var passiveListener = touchEvents.start === 'onTouchStart' && Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
          target.removeEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
          target.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
          target.removeEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);
        }
        if ((params.simulateTouch && !Device.ios && !Device.android) || (params.simulateTouch && !Support.touch && Device.ios)) {
          target.removeEventListener('mousedown', swiper.onTouchStart, false);
          doc.removeEventListener('mousemove', swiper.onTouchMove, capture);
          doc.removeEventListener('mouseup', swiper.onTouchEnd, false);
        }
      }
      // Prevent Links Clicks
      if (params.preventClicks || params.preventClicksPropagation) {
        target.removeEventListener('click', swiper.onClick, true);
      }
    }

    // Resize handler
    swiper.off((Device.ios || Device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate'), onResize);
  }

  var events = {
    attachEvents: attachEvents,
    detachEvents: detachEvents,
  };

  function setBreakpoint () {
    var swiper = this;
    var activeIndex = swiper.activeIndex;
    var initialized = swiper.initialized;
    var loopedSlides = swiper.loopedSlides; if ( loopedSlides === void 0 ) loopedSlides = 0;
    var params = swiper.params;
    var breakpoints = params.breakpoints;
    if (!breakpoints || (breakpoints && Object.keys(breakpoints).length === 0)) { return; }

    // Set breakpoint for window width and update parameters
    var breakpoint = swiper.getBreakpoint(breakpoints);

    if (breakpoint && swiper.currentBreakpoint !== breakpoint) {
      var breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
      if (breakpointOnlyParams) {
        ['slidesPerView', 'spaceBetween', 'slidesPerGroup'].forEach(function (param) {
          var paramValue = breakpointOnlyParams[param];
          if (typeof paramValue === 'undefined') { return; }
          if (param === 'slidesPerView' && (paramValue === 'AUTO' || paramValue === 'auto')) {
            breakpointOnlyParams[param] = 'auto';
          } else if (param === 'slidesPerView') {
            breakpointOnlyParams[param] = parseFloat(paramValue);
          } else {
            breakpointOnlyParams[param] = parseInt(paramValue, 10);
          }
        });
      }

      var breakpointParams = breakpointOnlyParams || swiper.originalParams;
      var directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
      var needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);

      if (directionChanged && initialized) {
        swiper.changeDirection();
      }

      Utils.extend(swiper.params, breakpointParams);

      Utils.extend(swiper, {
        allowTouchMove: swiper.params.allowTouchMove,
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev,
      });

      swiper.currentBreakpoint = breakpoint;

      if (needsReLoop && initialized) {
        swiper.loopDestroy();
        swiper.loopCreate();
        swiper.updateSlides();
        swiper.slideTo((activeIndex - loopedSlides) + swiper.loopedSlides, 0, false);
      }

      swiper.emit('breakpoint', breakpointParams);
    }
  }

  function getBreakpoint (breakpoints) {
    var swiper = this;
    // Get breakpoint for window width
    if (!breakpoints) { return undefined; }
    var breakpoint = false;
    var points = [];
    Object.keys(breakpoints).forEach(function (point) {
      points.push(point);
    });
    points.sort(function (a, b) { return parseInt(a, 10) - parseInt(b, 10); });
    for (var i = 0; i < points.length; i += 1) {
      var point = points[i];
      if (swiper.params.breakpointsInverse) {
        if (point <= win.innerWidth) {
          breakpoint = point;
        }
      } else if (point >= win.innerWidth && !breakpoint) {
        breakpoint = point;
      }
    }
    return breakpoint || 'max';
  }

  var breakpoints = { setBreakpoint: setBreakpoint, getBreakpoint: getBreakpoint };

  function addClasses () {
    var swiper = this;
    var classNames = swiper.classNames;
    var params = swiper.params;
    var rtl = swiper.rtl;
    var $el = swiper.$el;
    var suffixes = [];

    suffixes.push('initialized');
    suffixes.push(params.direction);

    if (params.freeMode) {
      suffixes.push('free-mode');
    }
    if (!Support.flexbox) {
      suffixes.push('no-flexbox');
    }
    if (params.autoHeight) {
      suffixes.push('autoheight');
    }
    if (rtl) {
      suffixes.push('rtl');
    }
    if (params.slidesPerColumn > 1) {
      suffixes.push('multirow');
    }
    if (Device.android) {
      suffixes.push('android');
    }
    if (Device.ios) {
      suffixes.push('ios');
    }
    // WP8 Touch Events Fix
    if ((Browser.isIE || Browser.isEdge) && (Support.pointerEvents || Support.prefixedPointerEvents)) {
      suffixes.push(("wp8-" + (params.direction)));
    }

    suffixes.forEach(function (suffix) {
      classNames.push(params.containerModifierClass + suffix);
    });

    $el.addClass(classNames.join(' '));
  }

  function removeClasses () {
    var swiper = this;
    var $el = swiper.$el;
    var classNames = swiper.classNames;

    $el.removeClass(classNames.join(' '));
  }

  var classes = { addClasses: addClasses, removeClasses: removeClasses };

  function loadImage (imageEl, src, srcset, sizes, checkForComplete, callback) {
    var image;
    function onReady() {
      if (callback) { callback(); }
    }
    if (!imageEl.complete || !checkForComplete) {
      if (src) {
        image = new win.Image();
        image.onload = onReady;
        image.onerror = onReady;
        if (sizes) {
          image.sizes = sizes;
        }
        if (srcset) {
          image.srcset = srcset;
        }
        if (src) {
          image.src = src;
        }
      } else {
        onReady();
      }
    } else {
      // image already loaded...
      onReady();
    }
  }

  function preloadImages () {
    var swiper = this;
    swiper.imagesToLoad = swiper.$el.find('img');
    function onReady() {
      if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper.destroyed) { return; }
      if (swiper.imagesLoaded !== undefined) { swiper.imagesLoaded += 1; }
      if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
        if (swiper.params.updateOnImagesReady) { swiper.update(); }
        swiper.emit('imagesReady');
      }
    }
    for (var i = 0; i < swiper.imagesToLoad.length; i += 1) {
      var imageEl = swiper.imagesToLoad[i];
      swiper.loadImage(
        imageEl,
        imageEl.currentSrc || imageEl.getAttribute('src'),
        imageEl.srcset || imageEl.getAttribute('srcset'),
        imageEl.sizes || imageEl.getAttribute('sizes'),
        true,
        onReady
      );
    }
  }

  var images = {
    loadImage: loadImage,
    preloadImages: preloadImages,
  };

  function checkOverflow() {
    var swiper = this;
    var wasLocked = swiper.isLocked;

    swiper.isLocked = swiper.snapGrid.length === 1;
    swiper.allowSlideNext = !swiper.isLocked;
    swiper.allowSlidePrev = !swiper.isLocked;

    // events
    if (wasLocked !== swiper.isLocked) { swiper.emit(swiper.isLocked ? 'lock' : 'unlock'); }

    if (wasLocked && wasLocked !== swiper.isLocked) {
      swiper.isEnd = false;
      swiper.navigation.update();
    }
  }

  var checkOverflow$1 = { checkOverflow: checkOverflow };

  var defaults = {
    init: true,
    direction: 'horizontal',
    touchEventsTarget: 'container',
    initialSlide: 0,
    speed: 300,
    //
    preventInteractionOnTransition: false,

    // To support iOS's swipe-to-go-back gesture (when being used in-app, with UIWebView).
    edgeSwipeDetection: false,
    edgeSwipeThreshold: 20,

    // Free mode
    freeMode: false,
    freeModeMomentum: true,
    freeModeMomentumRatio: 1,
    freeModeMomentumBounce: true,
    freeModeMomentumBounceRatio: 1,
    freeModeMomentumVelocityRatio: 1,
    freeModeSticky: false,
    freeModeMinimumVelocity: 0.02,

    // Autoheight
    autoHeight: false,

    // Set wrapper width
    setWrapperSize: false,

    // Virtual Translate
    virtualTranslate: false,

    // Effects
    effect: 'slide', // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'

    // Breakpoints
    breakpoints: undefined,
    breakpointsInverse: false,

    // Slides grid
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerColumn: 1,
    slidesPerColumnFill: 'column',
    slidesPerGroup: 1,
    centeredSlides: false,
    slidesOffsetBefore: 0, // in px
    slidesOffsetAfter: 0, // in px
    normalizeSlideIndex: true,
    centerInsufficientSlides: false,

    // Disable swiper and hide navigation when container not overflow
    watchOverflow: false,

    // Round length
    roundLengths: false,

    // Touches
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: true,
    shortSwipes: true,
    longSwipes: true,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: true,
    allowTouchMove: true,
    threshold: 0,
    touchMoveStopPropagation: true,
    touchStartPreventDefault: true,
    touchStartForcePreventDefault: false,
    touchReleaseOnEdges: false,

    // Unique Navigation Elements
    uniqueNavElements: true,

    // Resistance
    resistance: true,
    resistanceRatio: 0.85,

    // Progress
    watchSlidesProgress: false,
    watchSlidesVisibility: false,

    // Cursor
    grabCursor: false,

    // Clicks
    preventClicks: true,
    preventClicksPropagation: true,
    slideToClickedSlide: false,

    // Images
    preloadImages: true,
    updateOnImagesReady: true,

    // loop
    loop: false,
    loopAdditionalSlides: 0,
    loopedSlides: null,
    loopFillGroupWithBlank: false,

    // Swiping/no swiping
    allowSlidePrev: true,
    allowSlideNext: true,
    swipeHandler: null, // '.swipe-handler',
    noSwiping: true,
    noSwipingClass: 'swiper-no-swiping',
    noSwipingSelector: null,

    // Passive Listeners
    passiveListeners: true,

    // NS
    containerModifierClass: 'swiper-container-', // NEW
    slideClass: 'swiper-slide',
    slideBlankClass: 'swiper-slide-invisible-blank',
    slideActiveClass: 'swiper-slide-active',
    slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
    slideVisibleClass: 'swiper-slide-visible',
    slideDuplicateClass: 'swiper-slide-duplicate',
    slideNextClass: 'swiper-slide-next',
    slideDuplicateNextClass: 'swiper-slide-duplicate-next',
    slidePrevClass: 'swiper-slide-prev',
    slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
    wrapperClass: 'swiper-wrapper',

    // Callbacks
    runCallbacksOnInit: true,
  };

  /* eslint no-param-reassign: "off" */

  var prototypes = {
    update: update,
    translate: translate,
    transition: transition$1,
    slide: slide,
    loop: loop,
    grabCursor: grabCursor,
    manipulation: manipulation,
    events: events,
    breakpoints: breakpoints,
    checkOverflow: checkOverflow$1,
    classes: classes,
    images: images,
  };

  var extendedDefaults = {};

  var Swiper = /*@__PURE__*/(function (SwiperClass) {
    function Swiper() {
      var assign;

      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];
      var el;
      var params;
      if (args.length === 1 && args[0].constructor && args[0].constructor === Object) {
        params = args[0];
      } else {
        (assign = args, el = assign[0], params = assign[1]);
      }
      if (!params) { params = {}; }

      params = Utils.extend({}, params);
      if (el && !params.el) { params.el = el; }

      SwiperClass.call(this, params);

      Object.keys(prototypes).forEach(function (prototypeGroup) {
        Object.keys(prototypes[prototypeGroup]).forEach(function (protoMethod) {
          if (!Swiper.prototype[protoMethod]) {
            Swiper.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
          }
        });
      });

      // Swiper Instance
      var swiper = this;
      if (typeof swiper.modules === 'undefined') {
        swiper.modules = {};
      }
      Object.keys(swiper.modules).forEach(function (moduleName) {
        var module = swiper.modules[moduleName];
        if (module.params) {
          var moduleParamName = Object.keys(module.params)[0];
          var moduleParams = module.params[moduleParamName];
          if (typeof moduleParams !== 'object' || moduleParams === null) { return; }
          if (!(moduleParamName in params && 'enabled' in moduleParams)) { return; }
          if (params[moduleParamName] === true) {
            params[moduleParamName] = { enabled: true };
          }
          if (
            typeof params[moduleParamName] === 'object'
            && !('enabled' in params[moduleParamName])
          ) {
            params[moduleParamName].enabled = true;
          }
          if (!params[moduleParamName]) { params[moduleParamName] = { enabled: false }; }
        }
      });

      // Extend defaults with modules params
      var swiperParams = Utils.extend({}, defaults);
      swiper.useModulesParams(swiperParams);

      // Extend defaults with passed params
      swiper.params = Utils.extend({}, swiperParams, extendedDefaults, params);
      swiper.originalParams = Utils.extend({}, swiper.params);
      swiper.passedParams = Utils.extend({}, params);

      // Save Dom lib
      swiper.$ = $;

      // Find el
      var $el = $(swiper.params.el);
      el = $el[0];

      if (!el) {
        return undefined;
      }

      if ($el.length > 1) {
        var swipers = [];
        $el.each(function (index, containerEl) {
          var newParams = Utils.extend({}, params, { el: containerEl });
          swipers.push(new Swiper(newParams));
        });
        return swipers;
      }

      el.swiper = swiper;
      $el.data('swiper', swiper);

      // Find Wrapper
      var $wrapperEl = $el.children(("." + (swiper.params.wrapperClass)));

      // Extend Swiper
      Utils.extend(swiper, {
        $el: $el,
        el: el,
        $wrapperEl: $wrapperEl,
        wrapperEl: $wrapperEl[0],

        // Classes
        classNames: [],

        // Slides
        slides: $(),
        slidesGrid: [],
        snapGrid: [],
        slidesSizesGrid: [],

        // isDirection
        isHorizontal: function isHorizontal() {
          return swiper.params.direction === 'horizontal';
        },
        isVertical: function isVertical() {
          return swiper.params.direction === 'vertical';
        },
        // RTL
        rtl: (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
        rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
        wrongRTL: $wrapperEl.css('display') === '-webkit-box',

        // Indexes
        activeIndex: 0,
        realIndex: 0,

        //
        isBeginning: true,
        isEnd: false,

        // Props
        translate: 0,
        previousTranslate: 0,
        progress: 0,
        velocity: 0,
        animating: false,

        // Locks
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev,

        // Touch Events
        touchEvents: (function touchEvents() {
          var touch = ['touchstart', 'touchmove', 'touchend'];
          var desktop = ['mousedown', 'mousemove', 'mouseup'];
          if (Support.pointerEvents) {
            desktop = ['pointerdown', 'pointermove', 'pointerup'];
          } else if (Support.prefixedPointerEvents) {
            desktop = ['MSPointerDown', 'MSPointerMove', 'MSPointerUp'];
          }
          swiper.touchEventsTouch = {
            start: touch[0],
            move: touch[1],
            end: touch[2],
          };
          swiper.touchEventsDesktop = {
            start: desktop[0],
            move: desktop[1],
            end: desktop[2],
          };
          return Support.touch || !swiper.params.simulateTouch ? swiper.touchEventsTouch : swiper.touchEventsDesktop;
        }()),
        touchEventsData: {
          isTouched: undefined,
          isMoved: undefined,
          allowTouchCallbacks: undefined,
          touchStartTime: undefined,
          isScrolling: undefined,
          currentTranslate: undefined,
          startTranslate: undefined,
          allowThresholdMove: undefined,
          // Form elements to match
          formElements: 'input, select, option, textarea, button, video',
          // Last click time
          lastClickTime: Utils.now(),
          clickTimeout: undefined,
          // Velocities
          velocities: [],
          allowMomentumBounce: undefined,
          isTouchEvent: undefined,
          startMoving: undefined,
        },

        // Clicks
        allowClick: true,

        // Touches
        allowTouchMove: swiper.params.allowTouchMove,

        touches: {
          startX: 0,
          startY: 0,
          currentX: 0,
          currentY: 0,
          diff: 0,
        },

        // Images
        imagesToLoad: [],
        imagesLoaded: 0,

      });

      // Install Modules
      swiper.useModules();

      // Init
      if (swiper.params.init) {
        swiper.init();
      }

      // Return app instance
      return swiper;
    }

    if ( SwiperClass ) Swiper.__proto__ = SwiperClass;
    Swiper.prototype = Object.create( SwiperClass && SwiperClass.prototype );
    Swiper.prototype.constructor = Swiper;

    var staticAccessors = { extendedDefaults: { configurable: true },defaults: { configurable: true },Class: { configurable: true },$: { configurable: true } };

    Swiper.prototype.slidesPerViewDynamic = function slidesPerViewDynamic () {
      var swiper = this;
      var params = swiper.params;
      var slides = swiper.slides;
      var slidesGrid = swiper.slidesGrid;
      var swiperSize = swiper.size;
      var activeIndex = swiper.activeIndex;
      var spv = 1;
      if (params.centeredSlides) {
        var slideSize = slides[activeIndex].swiperSlideSize;
        var breakLoop;
        for (var i = activeIndex + 1; i < slides.length; i += 1) {
          if (slides[i] && !breakLoop) {
            slideSize += slides[i].swiperSlideSize;
            spv += 1;
            if (slideSize > swiperSize) { breakLoop = true; }
          }
        }
        for (var i$1 = activeIndex - 1; i$1 >= 0; i$1 -= 1) {
          if (slides[i$1] && !breakLoop) {
            slideSize += slides[i$1].swiperSlideSize;
            spv += 1;
            if (slideSize > swiperSize) { breakLoop = true; }
          }
        }
      } else {
        for (var i$2 = activeIndex + 1; i$2 < slides.length; i$2 += 1) {
          if (slidesGrid[i$2] - slidesGrid[activeIndex] < swiperSize) {
            spv += 1;
          }
        }
      }
      return spv;
    };

    Swiper.prototype.update = function update () {
      var swiper = this;
      if (!swiper || swiper.destroyed) { return; }
      var snapGrid = swiper.snapGrid;
      var params = swiper.params;
      // Breakpoints
      if (params.breakpoints) {
        swiper.setBreakpoint();
      }
      swiper.updateSize();
      swiper.updateSlides();
      swiper.updateProgress();
      swiper.updateSlidesClasses();

      function setTranslate() {
        var translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
        var newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
        swiper.setTranslate(newTranslate);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
      }
      var translated;
      if (swiper.params.freeMode) {
        setTranslate();
        if (swiper.params.autoHeight) {
          swiper.updateAutoHeight();
        }
      } else {
        if ((swiper.params.slidesPerView === 'auto' || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
          translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
        } else {
          translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
        }
        if (!translated) {
          setTranslate();
        }
      }
      if (params.watchOverflow && snapGrid !== swiper.snapGrid) {
        swiper.checkOverflow();
      }
      swiper.emit('update');
    };

    Swiper.prototype.changeDirection = function changeDirection (newDirection, needUpdate) {
      if ( needUpdate === void 0 ) needUpdate = true;

      var swiper = this;
      var currentDirection = swiper.params.direction;
      if (!newDirection) {
        // eslint-disable-next-line
        newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
      }
      if ((newDirection === currentDirection) || (newDirection !== 'horizontal' && newDirection !== 'vertical')) {
        return swiper;
      }

      swiper.$el
        .removeClass(("" + (swiper.params.containerModifierClass) + currentDirection + " wp8-" + currentDirection))
        .addClass(("" + (swiper.params.containerModifierClass) + newDirection));

      if ((Browser.isIE || Browser.isEdge) && (Support.pointerEvents || Support.prefixedPointerEvents)) {
        swiper.$el.addClass(((swiper.params.containerModifierClass) + "wp8-" + newDirection));
      }

      swiper.params.direction = newDirection;

      swiper.slides.each(function (slideIndex, slideEl) {
        if (newDirection === 'vertical') {
          slideEl.style.width = '';
        } else {
          slideEl.style.height = '';
        }
      });

      swiper.emit('changeDirection');
      if (needUpdate) { swiper.update(); }

      return swiper;
    };

    Swiper.prototype.init = function init () {
      var swiper = this;
      if (swiper.initialized) { return; }

      swiper.emit('beforeInit');

      // Set breakpoint
      if (swiper.params.breakpoints) {
        swiper.setBreakpoint();
      }

      // Add Classes
      swiper.addClasses();

      // Create loop
      if (swiper.params.loop) {
        swiper.loopCreate();
      }

      // Update size
      swiper.updateSize();

      // Update slides
      swiper.updateSlides();

      if (swiper.params.watchOverflow) {
        swiper.checkOverflow();
      }

      // Set Grab Cursor
      if (swiper.params.grabCursor) {
        swiper.setGrabCursor();
      }

      if (swiper.params.preloadImages) {
        swiper.preloadImages();
      }

      // Slide To Initial Slide
      if (swiper.params.loop) {
        swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit);
      } else {
        swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit);
      }

      // Attach events
      swiper.attachEvents();

      // Init Flag
      swiper.initialized = true;

      // Emit
      swiper.emit('init');
    };

    Swiper.prototype.destroy = function destroy (deleteInstance, cleanStyles) {
      if ( deleteInstance === void 0 ) deleteInstance = true;
      if ( cleanStyles === void 0 ) cleanStyles = true;

      var swiper = this;
      var params = swiper.params;
      var $el = swiper.$el;
      var $wrapperEl = swiper.$wrapperEl;
      var slides = swiper.slides;

      if (typeof swiper.params === 'undefined' || swiper.destroyed) {
        return null;
      }

      swiper.emit('beforeDestroy');

      // Init Flag
      swiper.initialized = false;

      // Detach events
      swiper.detachEvents();

      // Destroy loop
      if (params.loop) {
        swiper.loopDestroy();
      }

      // Cleanup styles
      if (cleanStyles) {
        swiper.removeClasses();
        $el.removeAttr('style');
        $wrapperEl.removeAttr('style');
        if (slides && slides.length) {
          slides
            .removeClass([
              params.slideVisibleClass,
              params.slideActiveClass,
              params.slideNextClass,
              params.slidePrevClass ].join(' '))
            .removeAttr('style')
            .removeAttr('data-swiper-slide-index')
            .removeAttr('data-swiper-column')
            .removeAttr('data-swiper-row');
        }
      }

      swiper.emit('destroy');

      // Detach emitter events
      Object.keys(swiper.eventsListeners).forEach(function (eventName) {
        swiper.off(eventName);
      });

      if (deleteInstance !== false) {
        swiper.$el[0].swiper = null;
        swiper.$el.data('swiper', null);
        Utils.deleteProps(swiper);
      }
      swiper.destroyed = true;

      return null;
    };

    Swiper.extendDefaults = function extendDefaults (newDefaults) {
      Utils.extend(extendedDefaults, newDefaults);
    };

    staticAccessors.extendedDefaults.get = function () {
      return extendedDefaults;
    };

    staticAccessors.defaults.get = function () {
      return defaults;
    };

    staticAccessors.Class.get = function () {
      return SwiperClass;
    };

    staticAccessors.$.get = function () {
      return $;
    };

    Object.defineProperties( Swiper, staticAccessors );

    return Swiper;
  }(SwiperClass));

  var Device$1 = {
    name: 'device',
    proto: {
      device: Device,
    },
    static: {
      device: Device,
    },
  };

  var Support$1 = {
    name: 'support',
    proto: {
      support: Support,
    },
    static: {
      support: Support,
    },
  };

  var Browser$1 = {
    name: 'browser',
    proto: {
      browser: Browser,
    },
    static: {
      browser: Browser,
    },
  };

  var Resize = {
    name: 'resize',
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        resize: {
          resizeHandler: function resizeHandler() {
            if (!swiper || swiper.destroyed || !swiper.initialized) { return; }
            swiper.emit('beforeResize');
            swiper.emit('resize');
          },
          orientationChangeHandler: function orientationChangeHandler() {
            if (!swiper || swiper.destroyed || !swiper.initialized) { return; }
            swiper.emit('orientationchange');
          },
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        // Emit resize
        win.addEventListener('resize', swiper.resize.resizeHandler);

        // Emit orientationchange
        win.addEventListener('orientationchange', swiper.resize.orientationChangeHandler);
      },
      destroy: function destroy() {
        var swiper = this;
        win.removeEventListener('resize', swiper.resize.resizeHandler);
        win.removeEventListener('orientationchange', swiper.resize.orientationChangeHandler);
      },
    },
  };

  var Observer = {
    func: win.MutationObserver || win.WebkitMutationObserver,
    attach: function attach(target, options) {
      if ( options === void 0 ) options = {};

      var swiper = this;

      var ObserverFunc = Observer.func;
      var observer = new ObserverFunc(function (mutations) {
        // The observerUpdate event should only be triggered
        // once despite the number of mutations.  Additional
        // triggers are redundant and are very costly
        if (mutations.length === 1) {
          swiper.emit('observerUpdate', mutations[0]);
          return;
        }
        var observerUpdate = function observerUpdate() {
          swiper.emit('observerUpdate', mutations[0]);
        };

        if (win.requestAnimationFrame) {
          win.requestAnimationFrame(observerUpdate);
        } else {
          win.setTimeout(observerUpdate, 0);
        }
      });

      observer.observe(target, {
        attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
        childList: typeof options.childList === 'undefined' ? true : options.childList,
        characterData: typeof options.characterData === 'undefined' ? true : options.characterData,
      });

      swiper.observer.observers.push(observer);
    },
    init: function init() {
      var swiper = this;
      if (!Support.observer || !swiper.params.observer) { return; }
      if (swiper.params.observeParents) {
        var containerParents = swiper.$el.parents();
        for (var i = 0; i < containerParents.length; i += 1) {
          swiper.observer.attach(containerParents[i]);
        }
      }
      // Observe container
      swiper.observer.attach(swiper.$el[0], { childList: swiper.params.observeSlideChildren });

      // Observe wrapper
      swiper.observer.attach(swiper.$wrapperEl[0], { attributes: false });
    },
    destroy: function destroy() {
      var swiper = this;
      swiper.observer.observers.forEach(function (observer) {
        observer.disconnect();
      });
      swiper.observer.observers = [];
    },
  };

  var Observer$1 = {
    name: 'observer',
    params: {
      observer: false,
      observeParents: false,
      observeSlideChildren: false,
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        observer: {
          init: Observer.init.bind(swiper),
          attach: Observer.attach.bind(swiper),
          destroy: Observer.destroy.bind(swiper),
          observers: [],
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        swiper.observer.init();
      },
      destroy: function destroy() {
        var swiper = this;
        swiper.observer.destroy();
      },
    },
  };

  var Virtual = {
    update: function update(force) {
      var swiper = this;
      var ref = swiper.params;
      var slidesPerView = ref.slidesPerView;
      var slidesPerGroup = ref.slidesPerGroup;
      var centeredSlides = ref.centeredSlides;
      var ref$1 = swiper.params.virtual;
      var addSlidesBefore = ref$1.addSlidesBefore;
      var addSlidesAfter = ref$1.addSlidesAfter;
      var ref$2 = swiper.virtual;
      var previousFrom = ref$2.from;
      var previousTo = ref$2.to;
      var slides = ref$2.slides;
      var previousSlidesGrid = ref$2.slidesGrid;
      var renderSlide = ref$2.renderSlide;
      var previousOffset = ref$2.offset;
      swiper.updateActiveIndex();
      var activeIndex = swiper.activeIndex || 0;

      var offsetProp;
      if (swiper.rtlTranslate) { offsetProp = 'right'; }
      else { offsetProp = swiper.isHorizontal() ? 'left' : 'top'; }

      var slidesAfter;
      var slidesBefore;
      if (centeredSlides) {
        slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesBefore;
        slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
      } else {
        slidesAfter = slidesPerView + (slidesPerGroup - 1) + addSlidesBefore;
        slidesBefore = slidesPerGroup + addSlidesAfter;
      }
      var from = Math.max((activeIndex || 0) - slidesBefore, 0);
      var to = Math.min((activeIndex || 0) + slidesAfter, slides.length - 1);
      var offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);

      Utils.extend(swiper.virtual, {
        from: from,
        to: to,
        offset: offset,
        slidesGrid: swiper.slidesGrid,
      });

      function onRendered() {
        swiper.updateSlides();
        swiper.updateProgress();
        swiper.updateSlidesClasses();
        if (swiper.lazy && swiper.params.lazy.enabled) {
          swiper.lazy.load();
        }
      }

      if (previousFrom === from && previousTo === to && !force) {
        if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) {
          swiper.slides.css(offsetProp, (offset + "px"));
        }
        swiper.updateProgress();
        return;
      }
      if (swiper.params.virtual.renderExternal) {
        swiper.params.virtual.renderExternal.call(swiper, {
          offset: offset,
          from: from,
          to: to,
          slides: (function getSlides() {
            var slidesToRender = [];
            for (var i = from; i <= to; i += 1) {
              slidesToRender.push(slides[i]);
            }
            return slidesToRender;
          }()),
        });
        onRendered();
        return;
      }
      var prependIndexes = [];
      var appendIndexes = [];
      if (force) {
        swiper.$wrapperEl.find(("." + (swiper.params.slideClass))).remove();
      } else {
        for (var i = previousFrom; i <= previousTo; i += 1) {
          if (i < from || i > to) {
            swiper.$wrapperEl.find(("." + (swiper.params.slideClass) + "[data-swiper-slide-index=\"" + i + "\"]")).remove();
          }
        }
      }
      for (var i$1 = 0; i$1 < slides.length; i$1 += 1) {
        if (i$1 >= from && i$1 <= to) {
          if (typeof previousTo === 'undefined' || force) {
            appendIndexes.push(i$1);
          } else {
            if (i$1 > previousTo) { appendIndexes.push(i$1); }
            if (i$1 < previousFrom) { prependIndexes.push(i$1); }
          }
        }
      }
      appendIndexes.forEach(function (index) {
        swiper.$wrapperEl.append(renderSlide(slides[index], index));
      });
      prependIndexes.sort(function (a, b) { return b - a; }).forEach(function (index) {
        swiper.$wrapperEl.prepend(renderSlide(slides[index], index));
      });
      swiper.$wrapperEl.children('.swiper-slide').css(offsetProp, (offset + "px"));
      onRendered();
    },
    renderSlide: function renderSlide(slide, index) {
      var swiper = this;
      var params = swiper.params.virtual;
      if (params.cache && swiper.virtual.cache[index]) {
        return swiper.virtual.cache[index];
      }
      var $slideEl = params.renderSlide
        ? $(params.renderSlide.call(swiper, slide, index))
        : $(("<div class=\"" + (swiper.params.slideClass) + "\" data-swiper-slide-index=\"" + index + "\">" + slide + "</div>"));
      if (!$slideEl.attr('data-swiper-slide-index')) { $slideEl.attr('data-swiper-slide-index', index); }
      if (params.cache) { swiper.virtual.cache[index] = $slideEl; }
      return $slideEl;
    },
    appendSlide: function appendSlide(slides) {
      var swiper = this;
      if (typeof slides === 'object' && 'length' in slides) {
        for (var i = 0; i < slides.length; i += 1) {
          if (slides[i]) { swiper.virtual.slides.push(slides[i]); }
        }
      } else {
        swiper.virtual.slides.push(slides);
      }
      swiper.virtual.update(true);
    },
    prependSlide: function prependSlide(slides) {
      var swiper = this;
      var activeIndex = swiper.activeIndex;
      var newActiveIndex = activeIndex + 1;
      var numberOfNewSlides = 1;

      if (Array.isArray(slides)) {
        for (var i = 0; i < slides.length; i += 1) {
          if (slides[i]) { swiper.virtual.slides.unshift(slides[i]); }
        }
        newActiveIndex = activeIndex + slides.length;
        numberOfNewSlides = slides.length;
      } else {
        swiper.virtual.slides.unshift(slides);
      }
      if (swiper.params.virtual.cache) {
        var cache = swiper.virtual.cache;
        var newCache = {};
        Object.keys(cache).forEach(function (cachedIndex) {
          newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = cache[cachedIndex];
        });
        swiper.virtual.cache = newCache;
      }
      swiper.virtual.update(true);
      swiper.slideTo(newActiveIndex, 0);
    },
    removeSlide: function removeSlide(slidesIndexes) {
      var swiper = this;
      if (typeof slidesIndexes === 'undefined' || slidesIndexes === null) { return; }
      var activeIndex = swiper.activeIndex;
      if (Array.isArray(slidesIndexes)) {
        for (var i = slidesIndexes.length - 1; i >= 0; i -= 1) {
          swiper.virtual.slides.splice(slidesIndexes[i], 1);
          if (swiper.params.virtual.cache) {
            delete swiper.virtual.cache[slidesIndexes[i]];
          }
          if (slidesIndexes[i] < activeIndex) { activeIndex -= 1; }
          activeIndex = Math.max(activeIndex, 0);
        }
      } else {
        swiper.virtual.slides.splice(slidesIndexes, 1);
        if (swiper.params.virtual.cache) {
          delete swiper.virtual.cache[slidesIndexes];
        }
        if (slidesIndexes < activeIndex) { activeIndex -= 1; }
        activeIndex = Math.max(activeIndex, 0);
      }
      swiper.virtual.update(true);
      swiper.slideTo(activeIndex, 0);
    },
    removeAllSlides: function removeAllSlides() {
      var swiper = this;
      swiper.virtual.slides = [];
      if (swiper.params.virtual.cache) {
        swiper.virtual.cache = {};
      }
      swiper.virtual.update(true);
      swiper.slideTo(0, 0);
    },
  };

  var Virtual$1 = {
    name: 'virtual',
    params: {
      virtual: {
        enabled: false,
        slides: [],
        cache: true,
        renderSlide: null,
        renderExternal: null,
        addSlidesBefore: 0,
        addSlidesAfter: 0,
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        virtual: {
          update: Virtual.update.bind(swiper),
          appendSlide: Virtual.appendSlide.bind(swiper),
          prependSlide: Virtual.prependSlide.bind(swiper),
          removeSlide: Virtual.removeSlide.bind(swiper),
          removeAllSlides: Virtual.removeAllSlides.bind(swiper),
          renderSlide: Virtual.renderSlide.bind(swiper),
          slides: swiper.params.virtual.slides,
          cache: {},
        },
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var swiper = this;
        if (!swiper.params.virtual.enabled) { return; }
        swiper.classNames.push(((swiper.params.containerModifierClass) + "virtual"));
        var overwriteParams = {
          watchSlidesProgress: true,
        };
        Utils.extend(swiper.params, overwriteParams);
        Utils.extend(swiper.originalParams, overwriteParams);

        if (!swiper.params.initialSlide) {
          swiper.virtual.update();
        }
      },
      setTranslate: function setTranslate() {
        var swiper = this;
        if (!swiper.params.virtual.enabled) { return; }
        swiper.virtual.update();
      },
    },
  };

  var Keyboard = {
    handle: function handle(event) {
      var swiper = this;
      var rtl = swiper.rtlTranslate;
      var e = event;
      if (e.originalEvent) { e = e.originalEvent; } // jquery fix
      var kc = e.keyCode || e.charCode;
      // Directions locks
      if (!swiper.allowSlideNext && ((swiper.isHorizontal() && kc === 39) || (swiper.isVertical() && kc === 40) || kc === 34)) {
        return false;
      }
      if (!swiper.allowSlidePrev && ((swiper.isHorizontal() && kc === 37) || (swiper.isVertical() && kc === 38) || kc === 33)) {
        return false;
      }
      if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) {
        return undefined;
      }
      if (doc.activeElement && doc.activeElement.nodeName && (doc.activeElement.nodeName.toLowerCase() === 'input' || doc.activeElement.nodeName.toLowerCase() === 'textarea')) {
        return undefined;
      }
      if (swiper.params.keyboard.onlyInViewport && (kc === 33 || kc === 34 || kc === 37 || kc === 39 || kc === 38 || kc === 40)) {
        var inView = false;
        // Check that swiper should be inside of visible area of window
        if (swiper.$el.parents(("." + (swiper.params.slideClass))).length > 0 && swiper.$el.parents(("." + (swiper.params.slideActiveClass))).length === 0) {
          return undefined;
        }
        var windowWidth = win.innerWidth;
        var windowHeight = win.innerHeight;
        var swiperOffset = swiper.$el.offset();
        if (rtl) { swiperOffset.left -= swiper.$el[0].scrollLeft; }
        var swiperCoord = [
          [swiperOffset.left, swiperOffset.top],
          [swiperOffset.left + swiper.width, swiperOffset.top],
          [swiperOffset.left, swiperOffset.top + swiper.height],
          [swiperOffset.left + swiper.width, swiperOffset.top + swiper.height] ];
        for (var i = 0; i < swiperCoord.length; i += 1) {
          var point = swiperCoord[i];
          if (
            point[0] >= 0 && point[0] <= windowWidth
            && point[1] >= 0 && point[1] <= windowHeight
          ) {
            inView = true;
          }
        }
        if (!inView) { return undefined; }
      }
      if (swiper.isHorizontal()) {
        if (kc === 33 || kc === 34 || kc === 37 || kc === 39) {
          if (e.preventDefault) { e.preventDefault(); }
          else { e.returnValue = false; }
        }
        if (((kc === 34 || kc === 39) && !rtl) || ((kc === 33 || kc === 37) && rtl)) { swiper.slideNext(); }
        if (((kc === 33 || kc === 37) && !rtl) || ((kc === 34 || kc === 39) && rtl)) { swiper.slidePrev(); }
      } else {
        if (kc === 33 || kc === 34 || kc === 38 || kc === 40) {
          if (e.preventDefault) { e.preventDefault(); }
          else { e.returnValue = false; }
        }
        if (kc === 34 || kc === 40) { swiper.slideNext(); }
        if (kc === 33 || kc === 38) { swiper.slidePrev(); }
      }
      swiper.emit('keyPress', kc);
      return undefined;
    },
    enable: function enable() {
      var swiper = this;
      if (swiper.keyboard.enabled) { return; }
      $(doc).on('keydown', swiper.keyboard.handle);
      swiper.keyboard.enabled = true;
    },
    disable: function disable() {
      var swiper = this;
      if (!swiper.keyboard.enabled) { return; }
      $(doc).off('keydown', swiper.keyboard.handle);
      swiper.keyboard.enabled = false;
    },
  };

  var Keyboard$1 = {
    name: 'keyboard',
    params: {
      keyboard: {
        enabled: false,
        onlyInViewport: true,
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        keyboard: {
          enabled: false,
          enable: Keyboard.enable.bind(swiper),
          disable: Keyboard.disable.bind(swiper),
          handle: Keyboard.handle.bind(swiper),
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        if (swiper.params.keyboard.enabled) {
          swiper.keyboard.enable();
        }
      },
      destroy: function destroy() {
        var swiper = this;
        if (swiper.keyboard.enabled) {
          swiper.keyboard.disable();
        }
      },
    },
  };

  function isEventSupported() {
    var eventName = 'onwheel';
    var isSupported = eventName in doc;

    if (!isSupported) {
      var element = doc.createElement('div');
      element.setAttribute(eventName, 'return;');
      isSupported = typeof element[eventName] === 'function';
    }

    if (!isSupported
      && doc.implementation
      && doc.implementation.hasFeature
      // always returns true in newer browsers as per the standard.
      // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
      && doc.implementation.hasFeature('', '') !== true
    ) {
      // This is the only way to test support for the `wheel` event in IE9+.
      isSupported = doc.implementation.hasFeature('Events.wheel', '3.0');
    }

    return isSupported;
  }
  var Mousewheel = {
    lastScrollTime: Utils.now(),
    event: (function getEvent() {
      if (win.navigator.userAgent.indexOf('firefox') > -1) { return 'DOMMouseScroll'; }
      return isEventSupported() ? 'wheel' : 'mousewheel';
    }()),
    normalize: function normalize(e) {
      // Reasonable defaults
      var PIXEL_STEP = 10;
      var LINE_HEIGHT = 40;
      var PAGE_HEIGHT = 800;

      var sX = 0;
      var sY = 0; // spinX, spinY
      var pX = 0;
      var pY = 0; // pixelX, pixelY

      // Legacy
      if ('detail' in e) {
        sY = e.detail;
      }
      if ('wheelDelta' in e) {
        sY = -e.wheelDelta / 120;
      }
      if ('wheelDeltaY' in e) {
        sY = -e.wheelDeltaY / 120;
      }
      if ('wheelDeltaX' in e) {
        sX = -e.wheelDeltaX / 120;
      }

      // side scrolling on FF with DOMMouseScroll
      if ('axis' in e && e.axis === e.HORIZONTAL_AXIS) {
        sX = sY;
        sY = 0;
      }

      pX = sX * PIXEL_STEP;
      pY = sY * PIXEL_STEP;

      if ('deltaY' in e) {
        pY = e.deltaY;
      }
      if ('deltaX' in e) {
        pX = e.deltaX;
      }

      if ((pX || pY) && e.deltaMode) {
        if (e.deltaMode === 1) { // delta in LINE units
          pX *= LINE_HEIGHT;
          pY *= LINE_HEIGHT;
        } else { // delta in PAGE units
          pX *= PAGE_HEIGHT;
          pY *= PAGE_HEIGHT;
        }
      }

      // Fall-back if spin cannot be determined
      if (pX && !sX) {
        sX = (pX < 1) ? -1 : 1;
      }
      if (pY && !sY) {
        sY = (pY < 1) ? -1 : 1;
      }

      return {
        spinX: sX,
        spinY: sY,
        pixelX: pX,
        pixelY: pY,
      };
    },
    handleMouseEnter: function handleMouseEnter() {
      var swiper = this;
      swiper.mouseEntered = true;
    },
    handleMouseLeave: function handleMouseLeave() {
      var swiper = this;
      swiper.mouseEntered = false;
    },
    handle: function handle(event) {
      var e = event;
      var swiper = this;
      var params = swiper.params.mousewheel;

      if (!swiper.mouseEntered && !params.releaseOnEdges) { return true; }

      if (e.originalEvent) { e = e.originalEvent; } // jquery fix
      var delta = 0;
      var rtlFactor = swiper.rtlTranslate ? -1 : 1;

      var data = Mousewheel.normalize(e);

      if (params.forceToAxis) {
        if (swiper.isHorizontal()) {
          if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) { delta = data.pixelX * rtlFactor; }
          else { return true; }
        } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) { delta = data.pixelY; }
        else { return true; }
      } else {
        delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
      }

      if (delta === 0) { return true; }

      if (params.invert) { delta = -delta; }

      if (!swiper.params.freeMode) {
        if (Utils.now() - swiper.mousewheel.lastScrollTime > 60) {
          if (delta < 0) {
            if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
              swiper.slideNext();
              swiper.emit('scroll', e);
            } else if (params.releaseOnEdges) { return true; }
          } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
            swiper.slidePrev();
            swiper.emit('scroll', e);
          } else if (params.releaseOnEdges) { return true; }
        }
        swiper.mousewheel.lastScrollTime = (new win.Date()).getTime();
      } else {
        // Freemode or scrollContainer:
        if (swiper.params.loop) {
          swiper.loopFix();
        }
        var position = swiper.getTranslate() + (delta * params.sensitivity);
        var wasBeginning = swiper.isBeginning;
        var wasEnd = swiper.isEnd;

        if (position >= swiper.minTranslate()) { position = swiper.minTranslate(); }
        if (position <= swiper.maxTranslate()) { position = swiper.maxTranslate(); }

        swiper.setTransition(0);
        swiper.setTranslate(position);
        swiper.updateProgress();
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();

        if ((!wasBeginning && swiper.isBeginning) || (!wasEnd && swiper.isEnd)) {
          swiper.updateSlidesClasses();
        }

        if (swiper.params.freeModeSticky) {
          clearTimeout(swiper.mousewheel.timeout);
          swiper.mousewheel.timeout = Utils.nextTick(function () {
            swiper.slideToClosest();
          }, 300);
        }
        // Emit event
        swiper.emit('scroll', e);

        // Stop autoplay
        if (swiper.params.autoplay && swiper.params.autoplayDisableOnInteraction) { swiper.autoplay.stop(); }
        // Return page scroll on edge positions
        if (position === swiper.minTranslate() || position === swiper.maxTranslate()) { return true; }
      }

      if (e.preventDefault) { e.preventDefault(); }
      else { e.returnValue = false; }
      return false;
    },
    enable: function enable() {
      var swiper = this;
      if (!Mousewheel.event) { return false; }
      if (swiper.mousewheel.enabled) { return false; }
      var target = swiper.$el;
      if (swiper.params.mousewheel.eventsTarged !== 'container') {
        target = $(swiper.params.mousewheel.eventsTarged);
      }
      target.on('mouseenter', swiper.mousewheel.handleMouseEnter);
      target.on('mouseleave', swiper.mousewheel.handleMouseLeave);
      target.on(Mousewheel.event, swiper.mousewheel.handle);
      swiper.mousewheel.enabled = true;
      return true;
    },
    disable: function disable() {
      var swiper = this;
      if (!Mousewheel.event) { return false; }
      if (!swiper.mousewheel.enabled) { return false; }
      var target = swiper.$el;
      if (swiper.params.mousewheel.eventsTarged !== 'container') {
        target = $(swiper.params.mousewheel.eventsTarged);
      }
      target.off(Mousewheel.event, swiper.mousewheel.handle);
      swiper.mousewheel.enabled = false;
      return true;
    },
  };

  var Mousewheel$1 = {
    name: 'mousewheel',
    params: {
      mousewheel: {
        enabled: false,
        releaseOnEdges: false,
        invert: false,
        forceToAxis: false,
        sensitivity: 1,
        eventsTarged: 'container',
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        mousewheel: {
          enabled: false,
          enable: Mousewheel.enable.bind(swiper),
          disable: Mousewheel.disable.bind(swiper),
          handle: Mousewheel.handle.bind(swiper),
          handleMouseEnter: Mousewheel.handleMouseEnter.bind(swiper),
          handleMouseLeave: Mousewheel.handleMouseLeave.bind(swiper),
          lastScrollTime: Utils.now(),
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        if (swiper.params.mousewheel.enabled) { swiper.mousewheel.enable(); }
      },
      destroy: function destroy() {
        var swiper = this;
        if (swiper.mousewheel.enabled) { swiper.mousewheel.disable(); }
      },
    },
  };

  var Navigation = {
    update: function update() {
      // Update Navigation Buttons
      var swiper = this;
      var params = swiper.params.navigation;

      if (swiper.params.loop) { return; }
      var ref = swiper.navigation;
      var $nextEl = ref.$nextEl;
      var $prevEl = ref.$prevEl;

      if ($prevEl && $prevEl.length > 0) {
        if (swiper.isBeginning) {
          $prevEl.addClass(params.disabledClass);
        } else {
          $prevEl.removeClass(params.disabledClass);
        }
        $prevEl[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
      }
      if ($nextEl && $nextEl.length > 0) {
        if (swiper.isEnd) {
          $nextEl.addClass(params.disabledClass);
        } else {
          $nextEl.removeClass(params.disabledClass);
        }
        $nextEl[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
      }
    },
    onPrevClick: function onPrevClick(e) {
      var swiper = this;
      e.preventDefault();
      if (swiper.isBeginning && !swiper.params.loop) { return; }
      swiper.slidePrev();
    },
    onNextClick: function onNextClick(e) {
      var swiper = this;
      e.preventDefault();
      if (swiper.isEnd && !swiper.params.loop) { return; }
      swiper.slideNext();
    },
    init: function init() {
      var swiper = this;
      var params = swiper.params.navigation;
      if (!(params.nextEl || params.prevEl)) { return; }

      var $nextEl;
      var $prevEl;
      if (params.nextEl) {
        $nextEl = $(params.nextEl);
        if (
          swiper.params.uniqueNavElements
          && typeof params.nextEl === 'string'
          && $nextEl.length > 1
          && swiper.$el.find(params.nextEl).length === 1
        ) {
          $nextEl = swiper.$el.find(params.nextEl);
        }
      }
      if (params.prevEl) {
        $prevEl = $(params.prevEl);
        if (
          swiper.params.uniqueNavElements
          && typeof params.prevEl === 'string'
          && $prevEl.length > 1
          && swiper.$el.find(params.prevEl).length === 1
        ) {
          $prevEl = swiper.$el.find(params.prevEl);
        }
      }

      if ($nextEl && $nextEl.length > 0) {
        $nextEl.on('click', swiper.navigation.onNextClick);
      }
      if ($prevEl && $prevEl.length > 0) {
        $prevEl.on('click', swiper.navigation.onPrevClick);
      }

      Utils.extend(swiper.navigation, {
        $nextEl: $nextEl,
        nextEl: $nextEl && $nextEl[0],
        $prevEl: $prevEl,
        prevEl: $prevEl && $prevEl[0],
      });
    },
    destroy: function destroy() {
      var swiper = this;
      var ref = swiper.navigation;
      var $nextEl = ref.$nextEl;
      var $prevEl = ref.$prevEl;
      if ($nextEl && $nextEl.length) {
        $nextEl.off('click', swiper.navigation.onNextClick);
        $nextEl.removeClass(swiper.params.navigation.disabledClass);
      }
      if ($prevEl && $prevEl.length) {
        $prevEl.off('click', swiper.navigation.onPrevClick);
        $prevEl.removeClass(swiper.params.navigation.disabledClass);
      }
    },
  };

  var Navigation$1 = {
    name: 'navigation',
    params: {
      navigation: {
        nextEl: null,
        prevEl: null,

        hideOnClick: false,
        disabledClass: 'swiper-button-disabled',
        hiddenClass: 'swiper-button-hidden',
        lockClass: 'swiper-button-lock',
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        navigation: {
          init: Navigation.init.bind(swiper),
          update: Navigation.update.bind(swiper),
          destroy: Navigation.destroy.bind(swiper),
          onNextClick: Navigation.onNextClick.bind(swiper),
          onPrevClick: Navigation.onPrevClick.bind(swiper),
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        swiper.navigation.init();
        swiper.navigation.update();
      },
      toEdge: function toEdge() {
        var swiper = this;
        swiper.navigation.update();
      },
      fromEdge: function fromEdge() {
        var swiper = this;
        swiper.navigation.update();
      },
      destroy: function destroy() {
        var swiper = this;
        swiper.navigation.destroy();
      },
      click: function click(e) {
        var swiper = this;
        var ref = swiper.navigation;
        var $nextEl = ref.$nextEl;
        var $prevEl = ref.$prevEl;
        if (
          swiper.params.navigation.hideOnClick
          && !$(e.target).is($prevEl)
          && !$(e.target).is($nextEl)
        ) {
          var isHidden;
          if ($nextEl) {
            isHidden = $nextEl.hasClass(swiper.params.navigation.hiddenClass);
          } else if ($prevEl) {
            isHidden = $prevEl.hasClass(swiper.params.navigation.hiddenClass);
          }
          if (isHidden === true) {
            swiper.emit('navigationShow', swiper);
          } else {
            swiper.emit('navigationHide', swiper);
          }
          if ($nextEl) {
            $nextEl.toggleClass(swiper.params.navigation.hiddenClass);
          }
          if ($prevEl) {
            $prevEl.toggleClass(swiper.params.navigation.hiddenClass);
          }
        }
      },
    },
  };

  var Pagination = {
    update: function update() {
      // Render || Update Pagination bullets/items
      var swiper = this;
      var rtl = swiper.rtl;
      var params = swiper.params.pagination;
      if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) { return; }
      var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
      var $el = swiper.pagination.$el;
      // Current/Total
      var current;
      var total = swiper.params.loop ? Math.ceil((slidesLength - (swiper.loopedSlides * 2)) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
      if (swiper.params.loop) {
        current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup);
        if (current > slidesLength - 1 - (swiper.loopedSlides * 2)) {
          current -= (slidesLength - (swiper.loopedSlides * 2));
        }
        if (current > total - 1) { current -= total; }
        if (current < 0 && swiper.params.paginationType !== 'bullets') { current = total + current; }
      } else if (typeof swiper.snapIndex !== 'undefined') {
        current = swiper.snapIndex;
      } else {
        current = swiper.activeIndex || 0;
      }
      // Types
      if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
        var bullets = swiper.pagination.bullets;
        var firstIndex;
        var lastIndex;
        var midIndex;
        if (params.dynamicBullets) {
          swiper.pagination.bulletSize = bullets.eq(0)[swiper.isHorizontal() ? 'outerWidth' : 'outerHeight'](true);
          $el.css(swiper.isHorizontal() ? 'width' : 'height', ((swiper.pagination.bulletSize * (params.dynamicMainBullets + 4)) + "px"));
          if (params.dynamicMainBullets > 1 && swiper.previousIndex !== undefined) {
            swiper.pagination.dynamicBulletIndex += (current - swiper.previousIndex);
            if (swiper.pagination.dynamicBulletIndex > (params.dynamicMainBullets - 1)) {
              swiper.pagination.dynamicBulletIndex = params.dynamicMainBullets - 1;
            } else if (swiper.pagination.dynamicBulletIndex < 0) {
              swiper.pagination.dynamicBulletIndex = 0;
            }
          }
          firstIndex = current - swiper.pagination.dynamicBulletIndex;
          lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
          midIndex = (lastIndex + firstIndex) / 2;
        }
        bullets.removeClass(((params.bulletActiveClass) + " " + (params.bulletActiveClass) + "-next " + (params.bulletActiveClass) + "-next-next " + (params.bulletActiveClass) + "-prev " + (params.bulletActiveClass) + "-prev-prev " + (params.bulletActiveClass) + "-main"));
        if ($el.length > 1) {
          bullets.each(function (index, bullet) {
            var $bullet = $(bullet);
            var bulletIndex = $bullet.index();
            if (bulletIndex === current) {
              $bullet.addClass(params.bulletActiveClass);
            }
            if (params.dynamicBullets) {
              if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) {
                $bullet.addClass(((params.bulletActiveClass) + "-main"));
              }
              if (bulletIndex === firstIndex) {
                $bullet
                  .prev()
                  .addClass(((params.bulletActiveClass) + "-prev"))
                  .prev()
                  .addClass(((params.bulletActiveClass) + "-prev-prev"));
              }
              if (bulletIndex === lastIndex) {
                $bullet
                  .next()
                  .addClass(((params.bulletActiveClass) + "-next"))
                  .next()
                  .addClass(((params.bulletActiveClass) + "-next-next"));
              }
            }
          });
        } else {
          var $bullet = bullets.eq(current);
          $bullet.addClass(params.bulletActiveClass);
          if (params.dynamicBullets) {
            var $firstDisplayedBullet = bullets.eq(firstIndex);
            var $lastDisplayedBullet = bullets.eq(lastIndex);
            for (var i = firstIndex; i <= lastIndex; i += 1) {
              bullets.eq(i).addClass(((params.bulletActiveClass) + "-main"));
            }
            $firstDisplayedBullet
              .prev()
              .addClass(((params.bulletActiveClass) + "-prev"))
              .prev()
              .addClass(((params.bulletActiveClass) + "-prev-prev"));
            $lastDisplayedBullet
              .next()
              .addClass(((params.bulletActiveClass) + "-next"))
              .next()
              .addClass(((params.bulletActiveClass) + "-next-next"));
          }
        }
        if (params.dynamicBullets) {
          var dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
          var bulletsOffset = (((swiper.pagination.bulletSize * dynamicBulletsLength) - (swiper.pagination.bulletSize)) / 2) - (midIndex * swiper.pagination.bulletSize);
          var offsetProp = rtl ? 'right' : 'left';
          bullets.css(swiper.isHorizontal() ? offsetProp : 'top', (bulletsOffset + "px"));
        }
      }
      if (params.type === 'fraction') {
        $el.find(("." + (params.currentClass))).text(params.formatFractionCurrent(current + 1));
        $el.find(("." + (params.totalClass))).text(params.formatFractionTotal(total));
      }
      if (params.type === 'progressbar') {
        var progressbarDirection;
        if (params.progressbarOpposite) {
          progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
        } else {
          progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
        }
        var scale = (current + 1) / total;
        var scaleX = 1;
        var scaleY = 1;
        if (progressbarDirection === 'horizontal') {
          scaleX = scale;
        } else {
          scaleY = scale;
        }
        $el.find(("." + (params.progressbarFillClass))).transform(("translate3d(0,0,0) scaleX(" + scaleX + ") scaleY(" + scaleY + ")")).transition(swiper.params.speed);
      }
      if (params.type === 'custom' && params.renderCustom) {
        $el.html(params.renderCustom(swiper, current + 1, total));
        swiper.emit('paginationRender', swiper, $el[0]);
      } else {
        swiper.emit('paginationUpdate', swiper, $el[0]);
      }
      $el[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
    },
    render: function render() {
      // Render Container
      var swiper = this;
      var params = swiper.params.pagination;
      if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) { return; }
      var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;

      var $el = swiper.pagination.$el;
      var paginationHTML = '';
      if (params.type === 'bullets') {
        var numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - (swiper.loopedSlides * 2)) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
        for (var i = 0; i < numberOfBullets; i += 1) {
          if (params.renderBullet) {
            paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
          } else {
            paginationHTML += "<" + (params.bulletElement) + " class=\"" + (params.bulletClass) + "\"></" + (params.bulletElement) + ">";
          }
        }
        $el.html(paginationHTML);
        swiper.pagination.bullets = $el.find(("." + (params.bulletClass)));
      }
      if (params.type === 'fraction') {
        if (params.renderFraction) {
          paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
        } else {
          paginationHTML = "<span class=\"" + (params.currentClass) + "\"></span>"
          + ' / '
          + "<span class=\"" + (params.totalClass) + "\"></span>";
        }
        $el.html(paginationHTML);
      }
      if (params.type === 'progressbar') {
        if (params.renderProgressbar) {
          paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
        } else {
          paginationHTML = "<span class=\"" + (params.progressbarFillClass) + "\"></span>";
        }
        $el.html(paginationHTML);
      }
      if (params.type !== 'custom') {
        swiper.emit('paginationRender', swiper.pagination.$el[0]);
      }
    },
    init: function init() {
      var swiper = this;
      var params = swiper.params.pagination;
      if (!params.el) { return; }

      var $el = $(params.el);
      if ($el.length === 0) { return; }

      if (
        swiper.params.uniqueNavElements
        && typeof params.el === 'string'
        && $el.length > 1
        && swiper.$el.find(params.el).length === 1
      ) {
        $el = swiper.$el.find(params.el);
      }

      if (params.type === 'bullets' && params.clickable) {
        $el.addClass(params.clickableClass);
      }

      $el.addClass(params.modifierClass + params.type);

      if (params.type === 'bullets' && params.dynamicBullets) {
        $el.addClass(("" + (params.modifierClass) + (params.type) + "-dynamic"));
        swiper.pagination.dynamicBulletIndex = 0;
        if (params.dynamicMainBullets < 1) {
          params.dynamicMainBullets = 1;
        }
      }
      if (params.type === 'progressbar' && params.progressbarOpposite) {
        $el.addClass(params.progressbarOppositeClass);
      }

      if (params.clickable) {
        $el.on('click', ("." + (params.bulletClass)), function onClick(e) {
          e.preventDefault();
          var index = $(this).index() * swiper.params.slidesPerGroup;
          if (swiper.params.loop) { index += swiper.loopedSlides; }
          swiper.slideTo(index);
        });
      }

      Utils.extend(swiper.pagination, {
        $el: $el,
        el: $el[0],
      });
    },
    destroy: function destroy() {
      var swiper = this;
      var params = swiper.params.pagination;
      if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) { return; }
      var $el = swiper.pagination.$el;

      $el.removeClass(params.hiddenClass);
      $el.removeClass(params.modifierClass + params.type);
      if (swiper.pagination.bullets) { swiper.pagination.bullets.removeClass(params.bulletActiveClass); }
      if (params.clickable) {
        $el.off('click', ("." + (params.bulletClass)));
      }
    },
  };

  var Pagination$1 = {
    name: 'pagination',
    params: {
      pagination: {
        el: null,
        bulletElement: 'span',
        clickable: false,
        hideOnClick: false,
        renderBullet: null,
        renderProgressbar: null,
        renderFraction: null,
        renderCustom: null,
        progressbarOpposite: false,
        type: 'bullets', // 'bullets' or 'progressbar' or 'fraction' or 'custom'
        dynamicBullets: false,
        dynamicMainBullets: 1,
        formatFractionCurrent: function (number) { return number; },
        formatFractionTotal: function (number) { return number; },
        bulletClass: 'swiper-pagination-bullet',
        bulletActiveClass: 'swiper-pagination-bullet-active',
        modifierClass: 'swiper-pagination-', // NEW
        currentClass: 'swiper-pagination-current',
        totalClass: 'swiper-pagination-total',
        hiddenClass: 'swiper-pagination-hidden',
        progressbarFillClass: 'swiper-pagination-progressbar-fill',
        progressbarOppositeClass: 'swiper-pagination-progressbar-opposite',
        clickableClass: 'swiper-pagination-clickable', // NEW
        lockClass: 'swiper-pagination-lock',
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        pagination: {
          init: Pagination.init.bind(swiper),
          render: Pagination.render.bind(swiper),
          update: Pagination.update.bind(swiper),
          destroy: Pagination.destroy.bind(swiper),
          dynamicBulletIndex: 0,
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        swiper.pagination.init();
        swiper.pagination.render();
        swiper.pagination.update();
      },
      activeIndexChange: function activeIndexChange() {
        var swiper = this;
        if (swiper.params.loop) {
          swiper.pagination.update();
        } else if (typeof swiper.snapIndex === 'undefined') {
          swiper.pagination.update();
        }
      },
      snapIndexChange: function snapIndexChange() {
        var swiper = this;
        if (!swiper.params.loop) {
          swiper.pagination.update();
        }
      },
      slidesLengthChange: function slidesLengthChange() {
        var swiper = this;
        if (swiper.params.loop) {
          swiper.pagination.render();
          swiper.pagination.update();
        }
      },
      snapGridLengthChange: function snapGridLengthChange() {
        var swiper = this;
        if (!swiper.params.loop) {
          swiper.pagination.render();
          swiper.pagination.update();
        }
      },
      destroy: function destroy() {
        var swiper = this;
        swiper.pagination.destroy();
      },
      click: function click(e) {
        var swiper = this;
        if (
          swiper.params.pagination.el
          && swiper.params.pagination.hideOnClick
          && swiper.pagination.$el.length > 0
          && !$(e.target).hasClass(swiper.params.pagination.bulletClass)
        ) {
          var isHidden = swiper.pagination.$el.hasClass(swiper.params.pagination.hiddenClass);
          if (isHidden === true) {
            swiper.emit('paginationShow', swiper);
          } else {
            swiper.emit('paginationHide', swiper);
          }
          swiper.pagination.$el.toggleClass(swiper.params.pagination.hiddenClass);
        }
      },
    },
  };

  var Scrollbar = {
    setTranslate: function setTranslate() {
      var swiper = this;
      if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) { return; }
      var scrollbar = swiper.scrollbar;
      var rtl = swiper.rtlTranslate;
      var progress = swiper.progress;
      var dragSize = scrollbar.dragSize;
      var trackSize = scrollbar.trackSize;
      var $dragEl = scrollbar.$dragEl;
      var $el = scrollbar.$el;
      var params = swiper.params.scrollbar;

      var newSize = dragSize;
      var newPos = (trackSize - dragSize) * progress;
      if (rtl) {
        newPos = -newPos;
        if (newPos > 0) {
          newSize = dragSize - newPos;
          newPos = 0;
        } else if (-newPos + dragSize > trackSize) {
          newSize = trackSize + newPos;
        }
      } else if (newPos < 0) {
        newSize = dragSize + newPos;
        newPos = 0;
      } else if (newPos + dragSize > trackSize) {
        newSize = trackSize - newPos;
      }
      if (swiper.isHorizontal()) {
        if (Support.transforms3d) {
          $dragEl.transform(("translate3d(" + newPos + "px, 0, 0)"));
        } else {
          $dragEl.transform(("translateX(" + newPos + "px)"));
        }
        $dragEl[0].style.width = newSize + "px";
      } else {
        if (Support.transforms3d) {
          $dragEl.transform(("translate3d(0px, " + newPos + "px, 0)"));
        } else {
          $dragEl.transform(("translateY(" + newPos + "px)"));
        }
        $dragEl[0].style.height = newSize + "px";
      }
      if (params.hide) {
        clearTimeout(swiper.scrollbar.timeout);
        $el[0].style.opacity = 1;
        swiper.scrollbar.timeout = setTimeout(function () {
          $el[0].style.opacity = 0;
          $el.transition(400);
        }, 1000);
      }
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) { return; }
      swiper.scrollbar.$dragEl.transition(duration);
    },
    updateSize: function updateSize() {
      var swiper = this;
      if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) { return; }

      var scrollbar = swiper.scrollbar;
      var $dragEl = scrollbar.$dragEl;
      var $el = scrollbar.$el;

      $dragEl[0].style.width = '';
      $dragEl[0].style.height = '';
      var trackSize = swiper.isHorizontal() ? $el[0].offsetWidth : $el[0].offsetHeight;

      var divider = swiper.size / swiper.virtualSize;
      var moveDivider = divider * (trackSize / swiper.size);
      var dragSize;
      if (swiper.params.scrollbar.dragSize === 'auto') {
        dragSize = trackSize * divider;
      } else {
        dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
      }

      if (swiper.isHorizontal()) {
        $dragEl[0].style.width = dragSize + "px";
      } else {
        $dragEl[0].style.height = dragSize + "px";
      }

      if (divider >= 1) {
        $el[0].style.display = 'none';
      } else {
        $el[0].style.display = '';
      }
      if (swiper.params.scrollbar.hide) {
        $el[0].style.opacity = 0;
      }
      Utils.extend(scrollbar, {
        trackSize: trackSize,
        divider: divider,
        moveDivider: moveDivider,
        dragSize: dragSize,
      });
      scrollbar.$el[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](swiper.params.scrollbar.lockClass);
    },
    getPointerPosition: function getPointerPosition(e) {
      var swiper = this;
      if (swiper.isHorizontal()) {
        return ((e.type === 'touchstart' || e.type === 'touchmove') ? e.targetTouches[0].pageX : e.pageX || e.clientX);
      }
      return ((e.type === 'touchstart' || e.type === 'touchmove') ? e.targetTouches[0].pageY : e.pageY || e.clientY);
    },
    setDragPosition: function setDragPosition(e) {
      var swiper = this;
      var scrollbar = swiper.scrollbar;
      var rtl = swiper.rtlTranslate;
      var $el = scrollbar.$el;
      var dragSize = scrollbar.dragSize;
      var trackSize = scrollbar.trackSize;
      var dragStartPos = scrollbar.dragStartPos;

      var positionRatio;
      positionRatio = ((scrollbar.getPointerPosition(e)) - $el.offset()[swiper.isHorizontal() ? 'left' : 'top']
        - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
      positionRatio = Math.max(Math.min(positionRatio, 1), 0);
      if (rtl) {
        positionRatio = 1 - positionRatio;
      }

      var position = swiper.minTranslate() + ((swiper.maxTranslate() - swiper.minTranslate()) * positionRatio);

      swiper.updateProgress(position);
      swiper.setTranslate(position);
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    },
    onDragStart: function onDragStart(e) {
      var swiper = this;
      var params = swiper.params.scrollbar;
      var scrollbar = swiper.scrollbar;
      var $wrapperEl = swiper.$wrapperEl;
      var $el = scrollbar.$el;
      var $dragEl = scrollbar.$dragEl;
      swiper.scrollbar.isTouched = true;
      swiper.scrollbar.dragStartPos = (e.target === $dragEl[0] || e.target === $dragEl)
        ? scrollbar.getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? 'left' : 'top'] : null;
      e.preventDefault();
      e.stopPropagation();

      $wrapperEl.transition(100);
      $dragEl.transition(100);
      scrollbar.setDragPosition(e);

      clearTimeout(swiper.scrollbar.dragTimeout);

      $el.transition(0);
      if (params.hide) {
        $el.css('opacity', 1);
      }
      swiper.emit('scrollbarDragStart', e);
    },
    onDragMove: function onDragMove(e) {
      var swiper = this;
      var scrollbar = swiper.scrollbar;
      var $wrapperEl = swiper.$wrapperEl;
      var $el = scrollbar.$el;
      var $dragEl = scrollbar.$dragEl;

      if (!swiper.scrollbar.isTouched) { return; }
      if (e.preventDefault) { e.preventDefault(); }
      else { e.returnValue = false; }
      scrollbar.setDragPosition(e);
      $wrapperEl.transition(0);
      $el.transition(0);
      $dragEl.transition(0);
      swiper.emit('scrollbarDragMove', e);
    },
    onDragEnd: function onDragEnd(e) {
      var swiper = this;

      var params = swiper.params.scrollbar;
      var scrollbar = swiper.scrollbar;
      var $el = scrollbar.$el;

      if (!swiper.scrollbar.isTouched) { return; }
      swiper.scrollbar.isTouched = false;
      if (params.hide) {
        clearTimeout(swiper.scrollbar.dragTimeout);
        swiper.scrollbar.dragTimeout = Utils.nextTick(function () {
          $el.css('opacity', 0);
          $el.transition(400);
        }, 1000);
      }
      swiper.emit('scrollbarDragEnd', e);
      if (params.snapOnRelease) {
        swiper.slideToClosest();
      }
    },
    enableDraggable: function enableDraggable() {
      var swiper = this;
      if (!swiper.params.scrollbar.el) { return; }
      var scrollbar = swiper.scrollbar;
      var touchEventsTouch = swiper.touchEventsTouch;
      var touchEventsDesktop = swiper.touchEventsDesktop;
      var params = swiper.params;
      var $el = scrollbar.$el;
      var target = $el[0];
      var activeListener = Support.passiveListener && params.passiveListeners ? { passive: false, capture: false } : false;
      var passiveListener = Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
      if (!Support.touch) {
        target.addEventListener(touchEventsDesktop.start, swiper.scrollbar.onDragStart, activeListener);
        doc.addEventListener(touchEventsDesktop.move, swiper.scrollbar.onDragMove, activeListener);
        doc.addEventListener(touchEventsDesktop.end, swiper.scrollbar.onDragEnd, passiveListener);
      } else {
        target.addEventListener(touchEventsTouch.start, swiper.scrollbar.onDragStart, activeListener);
        target.addEventListener(touchEventsTouch.move, swiper.scrollbar.onDragMove, activeListener);
        target.addEventListener(touchEventsTouch.end, swiper.scrollbar.onDragEnd, passiveListener);
      }
    },
    disableDraggable: function disableDraggable() {
      var swiper = this;
      if (!swiper.params.scrollbar.el) { return; }
      var scrollbar = swiper.scrollbar;
      var touchEventsTouch = swiper.touchEventsTouch;
      var touchEventsDesktop = swiper.touchEventsDesktop;
      var params = swiper.params;
      var $el = scrollbar.$el;
      var target = $el[0];
      var activeListener = Support.passiveListener && params.passiveListeners ? { passive: false, capture: false } : false;
      var passiveListener = Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
      if (!Support.touch) {
        target.removeEventListener(touchEventsDesktop.start, swiper.scrollbar.onDragStart, activeListener);
        doc.removeEventListener(touchEventsDesktop.move, swiper.scrollbar.onDragMove, activeListener);
        doc.removeEventListener(touchEventsDesktop.end, swiper.scrollbar.onDragEnd, passiveListener);
      } else {
        target.removeEventListener(touchEventsTouch.start, swiper.scrollbar.onDragStart, activeListener);
        target.removeEventListener(touchEventsTouch.move, swiper.scrollbar.onDragMove, activeListener);
        target.removeEventListener(touchEventsTouch.end, swiper.scrollbar.onDragEnd, passiveListener);
      }
    },
    init: function init() {
      var swiper = this;
      if (!swiper.params.scrollbar.el) { return; }
      var scrollbar = swiper.scrollbar;
      var $swiperEl = swiper.$el;
      var params = swiper.params.scrollbar;

      var $el = $(params.el);
      if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1 && $swiperEl.find(params.el).length === 1) {
        $el = $swiperEl.find(params.el);
      }

      var $dragEl = $el.find(("." + (swiper.params.scrollbar.dragClass)));
      if ($dragEl.length === 0) {
        $dragEl = $(("<div class=\"" + (swiper.params.scrollbar.dragClass) + "\"></div>"));
        $el.append($dragEl);
      }

      Utils.extend(scrollbar, {
        $el: $el,
        el: $el[0],
        $dragEl: $dragEl,
        dragEl: $dragEl[0],
      });

      if (params.draggable) {
        scrollbar.enableDraggable();
      }
    },
    destroy: function destroy() {
      var swiper = this;
      swiper.scrollbar.disableDraggable();
    },
  };

  var Scrollbar$1 = {
    name: 'scrollbar',
    params: {
      scrollbar: {
        el: null,
        dragSize: 'auto',
        hide: false,
        draggable: false,
        snapOnRelease: true,
        lockClass: 'swiper-scrollbar-lock',
        dragClass: 'swiper-scrollbar-drag',
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        scrollbar: {
          init: Scrollbar.init.bind(swiper),
          destroy: Scrollbar.destroy.bind(swiper),
          updateSize: Scrollbar.updateSize.bind(swiper),
          setTranslate: Scrollbar.setTranslate.bind(swiper),
          setTransition: Scrollbar.setTransition.bind(swiper),
          enableDraggable: Scrollbar.enableDraggable.bind(swiper),
          disableDraggable: Scrollbar.disableDraggable.bind(swiper),
          setDragPosition: Scrollbar.setDragPosition.bind(swiper),
          getPointerPosition: Scrollbar.getPointerPosition.bind(swiper),
          onDragStart: Scrollbar.onDragStart.bind(swiper),
          onDragMove: Scrollbar.onDragMove.bind(swiper),
          onDragEnd: Scrollbar.onDragEnd.bind(swiper),
          isTouched: false,
          timeout: null,
          dragTimeout: null,
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        swiper.scrollbar.init();
        swiper.scrollbar.updateSize();
        swiper.scrollbar.setTranslate();
      },
      update: function update() {
        var swiper = this;
        swiper.scrollbar.updateSize();
      },
      resize: function resize() {
        var swiper = this;
        swiper.scrollbar.updateSize();
      },
      observerUpdate: function observerUpdate() {
        var swiper = this;
        swiper.scrollbar.updateSize();
      },
      setTranslate: function setTranslate() {
        var swiper = this;
        swiper.scrollbar.setTranslate();
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        swiper.scrollbar.setTransition(duration);
      },
      destroy: function destroy() {
        var swiper = this;
        swiper.scrollbar.destroy();
      },
    },
  };

  var Parallax = {
    setTransform: function setTransform(el, progress) {
      var swiper = this;
      var rtl = swiper.rtl;

      var $el = $(el);
      var rtlFactor = rtl ? -1 : 1;

      var p = $el.attr('data-swiper-parallax') || '0';
      var x = $el.attr('data-swiper-parallax-x');
      var y = $el.attr('data-swiper-parallax-y');
      var scale = $el.attr('data-swiper-parallax-scale');
      var opacity = $el.attr('data-swiper-parallax-opacity');

      if (x || y) {
        x = x || '0';
        y = y || '0';
      } else if (swiper.isHorizontal()) {
        x = p;
        y = '0';
      } else {
        y = p;
        x = '0';
      }

      if ((x).indexOf('%') >= 0) {
        x = (parseInt(x, 10) * progress * rtlFactor) + "%";
      } else {
        x = (x * progress * rtlFactor) + "px";
      }
      if ((y).indexOf('%') >= 0) {
        y = (parseInt(y, 10) * progress) + "%";
      } else {
        y = (y * progress) + "px";
      }

      if (typeof opacity !== 'undefined' && opacity !== null) {
        var currentOpacity = opacity - ((opacity - 1) * (1 - Math.abs(progress)));
        $el[0].style.opacity = currentOpacity;
      }
      if (typeof scale === 'undefined' || scale === null) {
        $el.transform(("translate3d(" + x + ", " + y + ", 0px)"));
      } else {
        var currentScale = scale - ((scale - 1) * (1 - Math.abs(progress)));
        $el.transform(("translate3d(" + x + ", " + y + ", 0px) scale(" + currentScale + ")"));
      }
    },
    setTranslate: function setTranslate() {
      var swiper = this;
      var $el = swiper.$el;
      var slides = swiper.slides;
      var progress = swiper.progress;
      var snapGrid = swiper.snapGrid;
      $el.children('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]')
        .each(function (index, el) {
          swiper.parallax.setTransform(el, progress);
        });
      slides.each(function (slideIndex, slideEl) {
        var slideProgress = slideEl.progress;
        if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== 'auto') {
          slideProgress += Math.ceil(slideIndex / 2) - (progress * (snapGrid.length - 1));
        }
        slideProgress = Math.min(Math.max(slideProgress, -1), 1);
        $(slideEl).find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]')
          .each(function (index, el) {
            swiper.parallax.setTransform(el, slideProgress);
          });
      });
    },
    setTransition: function setTransition(duration) {
      if ( duration === void 0 ) duration = this.params.speed;

      var swiper = this;
      var $el = swiper.$el;
      $el.find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]')
        .each(function (index, parallaxEl) {
          var $parallaxEl = $(parallaxEl);
          var parallaxDuration = parseInt($parallaxEl.attr('data-swiper-parallax-duration'), 10) || duration;
          if (duration === 0) { parallaxDuration = 0; }
          $parallaxEl.transition(parallaxDuration);
        });
    },
  };

  var Parallax$1 = {
    name: 'parallax',
    params: {
      parallax: {
        enabled: false,
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        parallax: {
          setTransform: Parallax.setTransform.bind(swiper),
          setTranslate: Parallax.setTranslate.bind(swiper),
          setTransition: Parallax.setTransition.bind(swiper),
        },
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var swiper = this;
        if (!swiper.params.parallax.enabled) { return; }
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
      },
      init: function init() {
        var swiper = this;
        if (!swiper.params.parallax.enabled) { return; }
        swiper.parallax.setTranslate();
      },
      setTranslate: function setTranslate() {
        var swiper = this;
        if (!swiper.params.parallax.enabled) { return; }
        swiper.parallax.setTranslate();
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        if (!swiper.params.parallax.enabled) { return; }
        swiper.parallax.setTransition(duration);
      },
    },
  };

  var Zoom = {
    // Calc Scale From Multi-touches
    getDistanceBetweenTouches: function getDistanceBetweenTouches(e) {
      if (e.targetTouches.length < 2) { return 1; }
      var x1 = e.targetTouches[0].pageX;
      var y1 = e.targetTouches[0].pageY;
      var x2 = e.targetTouches[1].pageX;
      var y2 = e.targetTouches[1].pageY;
      var distance = Math.sqrt((Math.pow( (x2 - x1), 2 )) + (Math.pow( (y2 - y1), 2 )));
      return distance;
    },
    // Events
    onGestureStart: function onGestureStart(e) {
      var swiper = this;
      var params = swiper.params.zoom;
      var zoom = swiper.zoom;
      var gesture = zoom.gesture;
      zoom.fakeGestureTouched = false;
      zoom.fakeGestureMoved = false;
      if (!Support.gestures) {
        if (e.type !== 'touchstart' || (e.type === 'touchstart' && e.targetTouches.length < 2)) {
          return;
        }
        zoom.fakeGestureTouched = true;
        gesture.scaleStart = Zoom.getDistanceBetweenTouches(e);
      }
      if (!gesture.$slideEl || !gesture.$slideEl.length) {
        gesture.$slideEl = $(e.target).closest('.swiper-slide');
        if (gesture.$slideEl.length === 0) { gesture.$slideEl = swiper.slides.eq(swiper.activeIndex); }
        gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas');
        gesture.$imageWrapEl = gesture.$imageEl.parent(("." + (params.containerClass)));
        gesture.maxRatio = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
        if (gesture.$imageWrapEl.length === 0) {
          gesture.$imageEl = undefined;
          return;
        }
      }
      gesture.$imageEl.transition(0);
      swiper.zoom.isScaling = true;
    },
    onGestureChange: function onGestureChange(e) {
      var swiper = this;
      var params = swiper.params.zoom;
      var zoom = swiper.zoom;
      var gesture = zoom.gesture;
      if (!Support.gestures) {
        if (e.type !== 'touchmove' || (e.type === 'touchmove' && e.targetTouches.length < 2)) {
          return;
        }
        zoom.fakeGestureMoved = true;
        gesture.scaleMove = Zoom.getDistanceBetweenTouches(e);
      }
      if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
      if (Support.gestures) {
        zoom.scale = e.scale * zoom.currentScale;
      } else {
        zoom.scale = (gesture.scaleMove / gesture.scaleStart) * zoom.currentScale;
      }
      if (zoom.scale > gesture.maxRatio) {
        zoom.scale = (gesture.maxRatio - 1) + (Math.pow( ((zoom.scale - gesture.maxRatio) + 1), 0.5 ));
      }
      if (zoom.scale < params.minRatio) {
        zoom.scale = (params.minRatio + 1) - (Math.pow( ((params.minRatio - zoom.scale) + 1), 0.5 ));
      }
      gesture.$imageEl.transform(("translate3d(0,0,0) scale(" + (zoom.scale) + ")"));
    },
    onGestureEnd: function onGestureEnd(e) {
      var swiper = this;
      var params = swiper.params.zoom;
      var zoom = swiper.zoom;
      var gesture = zoom.gesture;
      if (!Support.gestures) {
        if (!zoom.fakeGestureTouched || !zoom.fakeGestureMoved) {
          return;
        }
        if (e.type !== 'touchend' || (e.type === 'touchend' && e.changedTouches.length < 2 && !Device.android)) {
          return;
        }
        zoom.fakeGestureTouched = false;
        zoom.fakeGestureMoved = false;
      }
      if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
      zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
      gesture.$imageEl.transition(swiper.params.speed).transform(("translate3d(0,0,0) scale(" + (zoom.scale) + ")"));
      zoom.currentScale = zoom.scale;
      zoom.isScaling = false;
      if (zoom.scale === 1) { gesture.$slideEl = undefined; }
    },
    onTouchStart: function onTouchStart(e) {
      var swiper = this;
      var zoom = swiper.zoom;
      var gesture = zoom.gesture;
      var image = zoom.image;
      if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
      if (image.isTouched) { return; }
      if (Device.android) { e.preventDefault(); }
      image.isTouched = true;
      image.touchesStart.x = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
      image.touchesStart.y = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
    },
    onTouchMove: function onTouchMove(e) {
      var swiper = this;
      var zoom = swiper.zoom;
      var gesture = zoom.gesture;
      var image = zoom.image;
      var velocity = zoom.velocity;
      if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
      swiper.allowClick = false;
      if (!image.isTouched || !gesture.$slideEl) { return; }

      if (!image.isMoved) {
        image.width = gesture.$imageEl[0].offsetWidth;
        image.height = gesture.$imageEl[0].offsetHeight;
        image.startX = Utils.getTranslate(gesture.$imageWrapEl[0], 'x') || 0;
        image.startY = Utils.getTranslate(gesture.$imageWrapEl[0], 'y') || 0;
        gesture.slideWidth = gesture.$slideEl[0].offsetWidth;
        gesture.slideHeight = gesture.$slideEl[0].offsetHeight;
        gesture.$imageWrapEl.transition(0);
        if (swiper.rtl) {
          image.startX = -image.startX;
          image.startY = -image.startY;
        }
      }
      // Define if we need image drag
      var scaledWidth = image.width * zoom.scale;
      var scaledHeight = image.height * zoom.scale;

      if (scaledWidth < gesture.slideWidth && scaledHeight < gesture.slideHeight) { return; }

      image.minX = Math.min(((gesture.slideWidth / 2) - (scaledWidth / 2)), 0);
      image.maxX = -image.minX;
      image.minY = Math.min(((gesture.slideHeight / 2) - (scaledHeight / 2)), 0);
      image.maxY = -image.minY;

      image.touchesCurrent.x = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
      image.touchesCurrent.y = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;

      if (!image.isMoved && !zoom.isScaling) {
        if (
          swiper.isHorizontal()
          && (
            (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x)
            || (Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)
          )
        ) {
          image.isTouched = false;
          return;
        } if (
          !swiper.isHorizontal()
          && (
            (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y)
            || (Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)
          )
        ) {
          image.isTouched = false;
          return;
        }
      }
      e.preventDefault();
      e.stopPropagation();

      image.isMoved = true;
      image.currentX = (image.touchesCurrent.x - image.touchesStart.x) + image.startX;
      image.currentY = (image.touchesCurrent.y - image.touchesStart.y) + image.startY;

      if (image.currentX < image.minX) {
        image.currentX = (image.minX + 1) - (Math.pow( ((image.minX - image.currentX) + 1), 0.8 ));
      }
      if (image.currentX > image.maxX) {
        image.currentX = (image.maxX - 1) + (Math.pow( ((image.currentX - image.maxX) + 1), 0.8 ));
      }

      if (image.currentY < image.minY) {
        image.currentY = (image.minY + 1) - (Math.pow( ((image.minY - image.currentY) + 1), 0.8 ));
      }
      if (image.currentY > image.maxY) {
        image.currentY = (image.maxY - 1) + (Math.pow( ((image.currentY - image.maxY) + 1), 0.8 ));
      }

      // Velocity
      if (!velocity.prevPositionX) { velocity.prevPositionX = image.touchesCurrent.x; }
      if (!velocity.prevPositionY) { velocity.prevPositionY = image.touchesCurrent.y; }
      if (!velocity.prevTime) { velocity.prevTime = Date.now(); }
      velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
      velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
      if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) { velocity.x = 0; }
      if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) { velocity.y = 0; }
      velocity.prevPositionX = image.touchesCurrent.x;
      velocity.prevPositionY = image.touchesCurrent.y;
      velocity.prevTime = Date.now();

      gesture.$imageWrapEl.transform(("translate3d(" + (image.currentX) + "px, " + (image.currentY) + "px,0)"));
    },
    onTouchEnd: function onTouchEnd() {
      var swiper = this;
      var zoom = swiper.zoom;
      var gesture = zoom.gesture;
      var image = zoom.image;
      var velocity = zoom.velocity;
      if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
      if (!image.isTouched || !image.isMoved) {
        image.isTouched = false;
        image.isMoved = false;
        return;
      }
      image.isTouched = false;
      image.isMoved = false;
      var momentumDurationX = 300;
      var momentumDurationY = 300;
      var momentumDistanceX = velocity.x * momentumDurationX;
      var newPositionX = image.currentX + momentumDistanceX;
      var momentumDistanceY = velocity.y * momentumDurationY;
      var newPositionY = image.currentY + momentumDistanceY;

      // Fix duration
      if (velocity.x !== 0) { momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x); }
      if (velocity.y !== 0) { momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y); }
      var momentumDuration = Math.max(momentumDurationX, momentumDurationY);

      image.currentX = newPositionX;
      image.currentY = newPositionY;

      // Define if we need image drag
      var scaledWidth = image.width * zoom.scale;
      var scaledHeight = image.height * zoom.scale;
      image.minX = Math.min(((gesture.slideWidth / 2) - (scaledWidth / 2)), 0);
      image.maxX = -image.minX;
      image.minY = Math.min(((gesture.slideHeight / 2) - (scaledHeight / 2)), 0);
      image.maxY = -image.minY;
      image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
      image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);

      gesture.$imageWrapEl.transition(momentumDuration).transform(("translate3d(" + (image.currentX) + "px, " + (image.currentY) + "px,0)"));
    },
    onTransitionEnd: function onTransitionEnd() {
      var swiper = this;
      var zoom = swiper.zoom;
      var gesture = zoom.gesture;
      if (gesture.$slideEl && swiper.previousIndex !== swiper.activeIndex) {
        gesture.$imageEl.transform('translate3d(0,0,0) scale(1)');
        gesture.$imageWrapEl.transform('translate3d(0,0,0)');

        zoom.scale = 1;
        zoom.currentScale = 1;

        gesture.$slideEl = undefined;
        gesture.$imageEl = undefined;
        gesture.$imageWrapEl = undefined;
      }
    },
    // Toggle Zoom
    toggle: function toggle(e) {
      var swiper = this;
      var zoom = swiper.zoom;

      if (zoom.scale && zoom.scale !== 1) {
        // Zoom Out
        zoom.out();
      } else {
        // Zoom In
        zoom.in(e);
      }
    },
    in: function in$1(e) {
      var swiper = this;

      var zoom = swiper.zoom;
      var params = swiper.params.zoom;
      var gesture = zoom.gesture;
      var image = zoom.image;

      if (!gesture.$slideEl) {
        gesture.$slideEl = swiper.clickedSlide ? $(swiper.clickedSlide) : swiper.slides.eq(swiper.activeIndex);
        gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas');
        gesture.$imageWrapEl = gesture.$imageEl.parent(("." + (params.containerClass)));
      }
      if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }

      gesture.$slideEl.addClass(("" + (params.zoomedSlideClass)));

      var touchX;
      var touchY;
      var offsetX;
      var offsetY;
      var diffX;
      var diffY;
      var translateX;
      var translateY;
      var imageWidth;
      var imageHeight;
      var scaledWidth;
      var scaledHeight;
      var translateMinX;
      var translateMinY;
      var translateMaxX;
      var translateMaxY;
      var slideWidth;
      var slideHeight;

      if (typeof image.touchesStart.x === 'undefined' && e) {
        touchX = e.type === 'touchend' ? e.changedTouches[0].pageX : e.pageX;
        touchY = e.type === 'touchend' ? e.changedTouches[0].pageY : e.pageY;
      } else {
        touchX = image.touchesStart.x;
        touchY = image.touchesStart.y;
      }

      zoom.scale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
      zoom.currentScale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
      if (e) {
        slideWidth = gesture.$slideEl[0].offsetWidth;
        slideHeight = gesture.$slideEl[0].offsetHeight;
        offsetX = gesture.$slideEl.offset().left;
        offsetY = gesture.$slideEl.offset().top;
        diffX = (offsetX + (slideWidth / 2)) - touchX;
        diffY = (offsetY + (slideHeight / 2)) - touchY;

        imageWidth = gesture.$imageEl[0].offsetWidth;
        imageHeight = gesture.$imageEl[0].offsetHeight;
        scaledWidth = imageWidth * zoom.scale;
        scaledHeight = imageHeight * zoom.scale;

        translateMinX = Math.min(((slideWidth / 2) - (scaledWidth / 2)), 0);
        translateMinY = Math.min(((slideHeight / 2) - (scaledHeight / 2)), 0);
        translateMaxX = -translateMinX;
        translateMaxY = -translateMinY;

        translateX = diffX * zoom.scale;
        translateY = diffY * zoom.scale;

        if (translateX < translateMinX) {
          translateX = translateMinX;
        }
        if (translateX > translateMaxX) {
          translateX = translateMaxX;
        }

        if (translateY < translateMinY) {
          translateY = translateMinY;
        }
        if (translateY > translateMaxY) {
          translateY = translateMaxY;
        }
      } else {
        translateX = 0;
        translateY = 0;
      }
      gesture.$imageWrapEl.transition(300).transform(("translate3d(" + translateX + "px, " + translateY + "px,0)"));
      gesture.$imageEl.transition(300).transform(("translate3d(0,0,0) scale(" + (zoom.scale) + ")"));
    },
    out: function out() {
      var swiper = this;

      var zoom = swiper.zoom;
      var params = swiper.params.zoom;
      var gesture = zoom.gesture;

      if (!gesture.$slideEl) {
        gesture.$slideEl = swiper.clickedSlide ? $(swiper.clickedSlide) : swiper.slides.eq(swiper.activeIndex);
        gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas');
        gesture.$imageWrapEl = gesture.$imageEl.parent(("." + (params.containerClass)));
      }
      if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }

      zoom.scale = 1;
      zoom.currentScale = 1;
      gesture.$imageWrapEl.transition(300).transform('translate3d(0,0,0)');
      gesture.$imageEl.transition(300).transform('translate3d(0,0,0) scale(1)');
      gesture.$slideEl.removeClass(("" + (params.zoomedSlideClass)));
      gesture.$slideEl = undefined;
    },
    // Attach/Detach Events
    enable: function enable() {
      var swiper = this;
      var zoom = swiper.zoom;
      if (zoom.enabled) { return; }
      zoom.enabled = true;

      var passiveListener = swiper.touchEvents.start === 'touchstart' && Support.passiveListener && swiper.params.passiveListeners ? { passive: true, capture: false } : false;

      // Scale image
      if (Support.gestures) {
        swiper.$wrapperEl.on('gesturestart', '.swiper-slide', zoom.onGestureStart, passiveListener);
        swiper.$wrapperEl.on('gesturechange', '.swiper-slide', zoom.onGestureChange, passiveListener);
        swiper.$wrapperEl.on('gestureend', '.swiper-slide', zoom.onGestureEnd, passiveListener);
      } else if (swiper.touchEvents.start === 'touchstart') {
        swiper.$wrapperEl.on(swiper.touchEvents.start, '.swiper-slide', zoom.onGestureStart, passiveListener);
        swiper.$wrapperEl.on(swiper.touchEvents.move, '.swiper-slide', zoom.onGestureChange, passiveListener);
        swiper.$wrapperEl.on(swiper.touchEvents.end, '.swiper-slide', zoom.onGestureEnd, passiveListener);
      }

      // Move image
      swiper.$wrapperEl.on(swiper.touchEvents.move, ("." + (swiper.params.zoom.containerClass)), zoom.onTouchMove);
    },
    disable: function disable() {
      var swiper = this;
      var zoom = swiper.zoom;
      if (!zoom.enabled) { return; }

      swiper.zoom.enabled = false;

      var passiveListener = swiper.touchEvents.start === 'touchstart' && Support.passiveListener && swiper.params.passiveListeners ? { passive: true, capture: false } : false;

      // Scale image
      if (Support.gestures) {
        swiper.$wrapperEl.off('gesturestart', '.swiper-slide', zoom.onGestureStart, passiveListener);
        swiper.$wrapperEl.off('gesturechange', '.swiper-slide', zoom.onGestureChange, passiveListener);
        swiper.$wrapperEl.off('gestureend', '.swiper-slide', zoom.onGestureEnd, passiveListener);
      } else if (swiper.touchEvents.start === 'touchstart') {
        swiper.$wrapperEl.off(swiper.touchEvents.start, '.swiper-slide', zoom.onGestureStart, passiveListener);
        swiper.$wrapperEl.off(swiper.touchEvents.move, '.swiper-slide', zoom.onGestureChange, passiveListener);
        swiper.$wrapperEl.off(swiper.touchEvents.end, '.swiper-slide', zoom.onGestureEnd, passiveListener);
      }

      // Move image
      swiper.$wrapperEl.off(swiper.touchEvents.move, ("." + (swiper.params.zoom.containerClass)), zoom.onTouchMove);
    },
  };

  var Zoom$1 = {
    name: 'zoom',
    params: {
      zoom: {
        enabled: false,
        maxRatio: 3,
        minRatio: 1,
        toggle: true,
        containerClass: 'swiper-zoom-container',
        zoomedSlideClass: 'swiper-slide-zoomed',
      },
    },
    create: function create() {
      var swiper = this;
      var zoom = {
        enabled: false,
        scale: 1,
        currentScale: 1,
        isScaling: false,
        gesture: {
          $slideEl: undefined,
          slideWidth: undefined,
          slideHeight: undefined,
          $imageEl: undefined,
          $imageWrapEl: undefined,
          maxRatio: 3,
        },
        image: {
          isTouched: undefined,
          isMoved: undefined,
          currentX: undefined,
          currentY: undefined,
          minX: undefined,
          minY: undefined,
          maxX: undefined,
          maxY: undefined,
          width: undefined,
          height: undefined,
          startX: undefined,
          startY: undefined,
          touchesStart: {},
          touchesCurrent: {},
        },
        velocity: {
          x: undefined,
          y: undefined,
          prevPositionX: undefined,
          prevPositionY: undefined,
          prevTime: undefined,
        },
      };

      ('onGestureStart onGestureChange onGestureEnd onTouchStart onTouchMove onTouchEnd onTransitionEnd toggle enable disable in out').split(' ').forEach(function (methodName) {
        zoom[methodName] = Zoom[methodName].bind(swiper);
      });
      Utils.extend(swiper, {
        zoom: zoom,
      });

      var scale = 1;
      Object.defineProperty(swiper.zoom, 'scale', {
        get: function get() {
          return scale;
        },
        set: function set(value) {
          if (scale !== value) {
            var imageEl = swiper.zoom.gesture.$imageEl ? swiper.zoom.gesture.$imageEl[0] : undefined;
            var slideEl = swiper.zoom.gesture.$slideEl ? swiper.zoom.gesture.$slideEl[0] : undefined;
            swiper.emit('zoomChange', value, imageEl, slideEl);
          }
          scale = value;
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        if (swiper.params.zoom.enabled) {
          swiper.zoom.enable();
        }
      },
      destroy: function destroy() {
        var swiper = this;
        swiper.zoom.disable();
      },
      touchStart: function touchStart(e) {
        var swiper = this;
        if (!swiper.zoom.enabled) { return; }
        swiper.zoom.onTouchStart(e);
      },
      touchEnd: function touchEnd(e) {
        var swiper = this;
        if (!swiper.zoom.enabled) { return; }
        swiper.zoom.onTouchEnd(e);
      },
      doubleTap: function doubleTap(e) {
        var swiper = this;
        if (swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) {
          swiper.zoom.toggle(e);
        }
      },
      transitionEnd: function transitionEnd() {
        var swiper = this;
        if (swiper.zoom.enabled && swiper.params.zoom.enabled) {
          swiper.zoom.onTransitionEnd();
        }
      },
    },
  };

  var Lazy = {
    loadInSlide: function loadInSlide(index, loadInDuplicate) {
      if ( loadInDuplicate === void 0 ) loadInDuplicate = true;

      var swiper = this;
      var params = swiper.params.lazy;
      if (typeof index === 'undefined') { return; }
      if (swiper.slides.length === 0) { return; }
      var isVirtual = swiper.virtual && swiper.params.virtual.enabled;

      var $slideEl = isVirtual
        ? swiper.$wrapperEl.children(("." + (swiper.params.slideClass) + "[data-swiper-slide-index=\"" + index + "\"]"))
        : swiper.slides.eq(index);

      var $images = $slideEl.find(("." + (params.elementClass) + ":not(." + (params.loadedClass) + "):not(." + (params.loadingClass) + ")"));
      if ($slideEl.hasClass(params.elementClass) && !$slideEl.hasClass(params.loadedClass) && !$slideEl.hasClass(params.loadingClass)) {
        $images = $images.add($slideEl[0]);
      }
      if ($images.length === 0) { return; }

      $images.each(function (imageIndex, imageEl) {
        var $imageEl = $(imageEl);
        $imageEl.addClass(params.loadingClass);

        var background = $imageEl.attr('data-background');
        var src = $imageEl.attr('data-src');
        var srcset = $imageEl.attr('data-srcset');
        var sizes = $imageEl.attr('data-sizes');

        swiper.loadImage($imageEl[0], (src || background), srcset, sizes, false, function () {
          if (typeof swiper === 'undefined' || swiper === null || !swiper || (swiper && !swiper.params) || swiper.destroyed) { return; }
          if (background) {
            $imageEl.css('background-image', ("url(\"" + background + "\")"));
            $imageEl.removeAttr('data-background');
          } else {
            if (srcset) {
              $imageEl.attr('srcset', srcset);
              $imageEl.removeAttr('data-srcset');
            }
            if (sizes) {
              $imageEl.attr('sizes', sizes);
              $imageEl.removeAttr('data-sizes');
            }
            if (src) {
              $imageEl.attr('src', src);
              $imageEl.removeAttr('data-src');
            }
          }

          $imageEl.addClass(params.loadedClass).removeClass(params.loadingClass);
          $slideEl.find(("." + (params.preloaderClass))).remove();
          if (swiper.params.loop && loadInDuplicate) {
            var slideOriginalIndex = $slideEl.attr('data-swiper-slide-index');
            if ($slideEl.hasClass(swiper.params.slideDuplicateClass)) {
              var originalSlide = swiper.$wrapperEl.children(("[data-swiper-slide-index=\"" + slideOriginalIndex + "\"]:not(." + (swiper.params.slideDuplicateClass) + ")"));
              swiper.lazy.loadInSlide(originalSlide.index(), false);
            } else {
              var duplicatedSlide = swiper.$wrapperEl.children(("." + (swiper.params.slideDuplicateClass) + "[data-swiper-slide-index=\"" + slideOriginalIndex + "\"]"));
              swiper.lazy.loadInSlide(duplicatedSlide.index(), false);
            }
          }
          swiper.emit('lazyImageReady', $slideEl[0], $imageEl[0]);
        });

        swiper.emit('lazyImageLoad', $slideEl[0], $imageEl[0]);
      });
    },
    load: function load() {
      var swiper = this;
      var $wrapperEl = swiper.$wrapperEl;
      var swiperParams = swiper.params;
      var slides = swiper.slides;
      var activeIndex = swiper.activeIndex;
      var isVirtual = swiper.virtual && swiperParams.virtual.enabled;
      var params = swiperParams.lazy;

      var slidesPerView = swiperParams.slidesPerView;
      if (slidesPerView === 'auto') {
        slidesPerView = 0;
      }

      function slideExist(index) {
        if (isVirtual) {
          if ($wrapperEl.children(("." + (swiperParams.slideClass) + "[data-swiper-slide-index=\"" + index + "\"]")).length) {
            return true;
          }
        } else if (slides[index]) { return true; }
        return false;
      }
      function slideIndex(slideEl) {
        if (isVirtual) {
          return $(slideEl).attr('data-swiper-slide-index');
        }
        return $(slideEl).index();
      }

      if (!swiper.lazy.initialImageLoaded) { swiper.lazy.initialImageLoaded = true; }
      if (swiper.params.watchSlidesVisibility) {
        $wrapperEl.children(("." + (swiperParams.slideVisibleClass))).each(function (elIndex, slideEl) {
          var index = isVirtual ? $(slideEl).attr('data-swiper-slide-index') : $(slideEl).index();
          swiper.lazy.loadInSlide(index);
        });
      } else if (slidesPerView > 1) {
        for (var i = activeIndex; i < activeIndex + slidesPerView; i += 1) {
          if (slideExist(i)) { swiper.lazy.loadInSlide(i); }
        }
      } else {
        swiper.lazy.loadInSlide(activeIndex);
      }
      if (params.loadPrevNext) {
        if (slidesPerView > 1 || (params.loadPrevNextAmount && params.loadPrevNextAmount > 1)) {
          var amount = params.loadPrevNextAmount;
          var spv = slidesPerView;
          var maxIndex = Math.min(activeIndex + spv + Math.max(amount, spv), slides.length);
          var minIndex = Math.max(activeIndex - Math.max(spv, amount), 0);
          // Next Slides
          for (var i$1 = activeIndex + slidesPerView; i$1 < maxIndex; i$1 += 1) {
            if (slideExist(i$1)) { swiper.lazy.loadInSlide(i$1); }
          }
          // Prev Slides
          for (var i$2 = minIndex; i$2 < activeIndex; i$2 += 1) {
            if (slideExist(i$2)) { swiper.lazy.loadInSlide(i$2); }
          }
        } else {
          var nextSlide = $wrapperEl.children(("." + (swiperParams.slideNextClass)));
          if (nextSlide.length > 0) { swiper.lazy.loadInSlide(slideIndex(nextSlide)); }

          var prevSlide = $wrapperEl.children(("." + (swiperParams.slidePrevClass)));
          if (prevSlide.length > 0) { swiper.lazy.loadInSlide(slideIndex(prevSlide)); }
        }
      }
    },
  };

  var Lazy$1 = {
    name: 'lazy',
    params: {
      lazy: {
        enabled: false,
        loadPrevNext: false,
        loadPrevNextAmount: 1,
        loadOnTransitionStart: false,

        elementClass: 'swiper-lazy',
        loadingClass: 'swiper-lazy-loading',
        loadedClass: 'swiper-lazy-loaded',
        preloaderClass: 'swiper-lazy-preloader',
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        lazy: {
          initialImageLoaded: false,
          load: Lazy.load.bind(swiper),
          loadInSlide: Lazy.loadInSlide.bind(swiper),
        },
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var swiper = this;
        if (swiper.params.lazy.enabled && swiper.params.preloadImages) {
          swiper.params.preloadImages = false;
        }
      },
      init: function init() {
        var swiper = this;
        if (swiper.params.lazy.enabled && !swiper.params.loop && swiper.params.initialSlide === 0) {
          swiper.lazy.load();
        }
      },
      scroll: function scroll() {
        var swiper = this;
        if (swiper.params.freeMode && !swiper.params.freeModeSticky) {
          swiper.lazy.load();
        }
      },
      resize: function resize() {
        var swiper = this;
        if (swiper.params.lazy.enabled) {
          swiper.lazy.load();
        }
      },
      scrollbarDragMove: function scrollbarDragMove() {
        var swiper = this;
        if (swiper.params.lazy.enabled) {
          swiper.lazy.load();
        }
      },
      transitionStart: function transitionStart() {
        var swiper = this;
        if (swiper.params.lazy.enabled) {
          if (swiper.params.lazy.loadOnTransitionStart || (!swiper.params.lazy.loadOnTransitionStart && !swiper.lazy.initialImageLoaded)) {
            swiper.lazy.load();
          }
        }
      },
      transitionEnd: function transitionEnd() {
        var swiper = this;
        if (swiper.params.lazy.enabled && !swiper.params.lazy.loadOnTransitionStart) {
          swiper.lazy.load();
        }
      },
    },
  };

  /* eslint no-bitwise: ["error", { "allow": [">>"] }] */

  var Controller = {
    LinearSpline: function LinearSpline(x, y) {
      var binarySearch = (function search() {
        var maxIndex;
        var minIndex;
        var guess;
        return function (array, val) {
          minIndex = -1;
          maxIndex = array.length;
          while (maxIndex - minIndex > 1) {
            guess = maxIndex + minIndex >> 1;
            if (array[guess] <= val) {
              minIndex = guess;
            } else {
              maxIndex = guess;
            }
          }
          return maxIndex;
        };
      }());
      this.x = x;
      this.y = y;
      this.lastIndex = x.length - 1;
      // Given an x value (x2), return the expected y2 value:
      // (x1,y1) is the known point before given value,
      // (x3,y3) is the known point after given value.
      var i1;
      var i3;

      this.interpolate = function interpolate(x2) {
        if (!x2) { return 0; }

        // Get the indexes of x1 and x3 (the array indexes before and after given x2):
        i3 = binarySearch(this.x, x2);
        i1 = i3 - 1;

        // We have our indexes i1 & i3, so we can calculate already:
        // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
        return (((x2 - this.x[i1]) * (this.y[i3] - this.y[i1])) / (this.x[i3] - this.x[i1])) + this.y[i1];
      };
      return this;
    },
    // xxx: for now i will just save one spline function to to
    getInterpolateFunction: function getInterpolateFunction(c) {
      var swiper = this;
      if (!swiper.controller.spline) {
        swiper.controller.spline = swiper.params.loop
          ? new Controller.LinearSpline(swiper.slidesGrid, c.slidesGrid)
          : new Controller.LinearSpline(swiper.snapGrid, c.snapGrid);
      }
    },
    setTranslate: function setTranslate(setTranslate$1, byController) {
      var swiper = this;
      var controlled = swiper.controller.control;
      var multiplier;
      var controlledTranslate;
      function setControlledTranslate(c) {
        // this will create an Interpolate function based on the snapGrids
        // x is the Grid of the scrolled scroller and y will be the controlled scroller
        // it makes sense to create this only once and recall it for the interpolation
        // the function does a lot of value caching for performance
        var translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
        if (swiper.params.controller.by === 'slide') {
          swiper.controller.getInterpolateFunction(c);
          // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
          // but it did not work out
          controlledTranslate = -swiper.controller.spline.interpolate(-translate);
        }

        if (!controlledTranslate || swiper.params.controller.by === 'container') {
          multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
          controlledTranslate = ((translate - swiper.minTranslate()) * multiplier) + c.minTranslate();
        }

        if (swiper.params.controller.inverse) {
          controlledTranslate = c.maxTranslate() - controlledTranslate;
        }
        c.updateProgress(controlledTranslate);
        c.setTranslate(controlledTranslate, swiper);
        c.updateActiveIndex();
        c.updateSlidesClasses();
      }
      if (Array.isArray(controlled)) {
        for (var i = 0; i < controlled.length; i += 1) {
          if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
            setControlledTranslate(controlled[i]);
          }
        }
      } else if (controlled instanceof Swiper && byController !== controlled) {
        setControlledTranslate(controlled);
      }
    },
    setTransition: function setTransition(duration, byController) {
      var swiper = this;
      var controlled = swiper.controller.control;
      var i;
      function setControlledTransition(c) {
        c.setTransition(duration, swiper);
        if (duration !== 0) {
          c.transitionStart();
          if (c.params.autoHeight) {
            Utils.nextTick(function () {
              c.updateAutoHeight();
            });
          }
          c.$wrapperEl.transitionEnd(function () {
            if (!controlled) { return; }
            if (c.params.loop && swiper.params.controller.by === 'slide') {
              c.loopFix();
            }
            c.transitionEnd();
          });
        }
      }
      if (Array.isArray(controlled)) {
        for (i = 0; i < controlled.length; i += 1) {
          if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
            setControlledTransition(controlled[i]);
          }
        }
      } else if (controlled instanceof Swiper && byController !== controlled) {
        setControlledTransition(controlled);
      }
    },
  };
  var Controller$1 = {
    name: 'controller',
    params: {
      controller: {
        control: undefined,
        inverse: false,
        by: 'slide', // or 'container'
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        controller: {
          control: swiper.params.controller.control,
          getInterpolateFunction: Controller.getInterpolateFunction.bind(swiper),
          setTranslate: Controller.setTranslate.bind(swiper),
          setTransition: Controller.setTransition.bind(swiper),
        },
      });
    },
    on: {
      update: function update() {
        var swiper = this;
        if (!swiper.controller.control) { return; }
        if (swiper.controller.spline) {
          swiper.controller.spline = undefined;
          delete swiper.controller.spline;
        }
      },
      resize: function resize() {
        var swiper = this;
        if (!swiper.controller.control) { return; }
        if (swiper.controller.spline) {
          swiper.controller.spline = undefined;
          delete swiper.controller.spline;
        }
      },
      observerUpdate: function observerUpdate() {
        var swiper = this;
        if (!swiper.controller.control) { return; }
        if (swiper.controller.spline) {
          swiper.controller.spline = undefined;
          delete swiper.controller.spline;
        }
      },
      setTranslate: function setTranslate(translate, byController) {
        var swiper = this;
        if (!swiper.controller.control) { return; }
        swiper.controller.setTranslate(translate, byController);
      },
      setTransition: function setTransition(duration, byController) {
        var swiper = this;
        if (!swiper.controller.control) { return; }
        swiper.controller.setTransition(duration, byController);
      },
    },
  };

  var a11y = {
    makeElFocusable: function makeElFocusable($el) {
      $el.attr('tabIndex', '0');
      return $el;
    },
    addElRole: function addElRole($el, role) {
      $el.attr('role', role);
      return $el;
    },
    addElLabel: function addElLabel($el, label) {
      $el.attr('aria-label', label);
      return $el;
    },
    disableEl: function disableEl($el) {
      $el.attr('aria-disabled', true);
      return $el;
    },
    enableEl: function enableEl($el) {
      $el.attr('aria-disabled', false);
      return $el;
    },
    onEnterKey: function onEnterKey(e) {
      var swiper = this;
      var params = swiper.params.a11y;
      if (e.keyCode !== 13) { return; }
      var $targetEl = $(e.target);
      if (swiper.navigation && swiper.navigation.$nextEl && $targetEl.is(swiper.navigation.$nextEl)) {
        if (!(swiper.isEnd && !swiper.params.loop)) {
          swiper.slideNext();
        }
        if (swiper.isEnd) {
          swiper.a11y.notify(params.lastSlideMessage);
        } else {
          swiper.a11y.notify(params.nextSlideMessage);
        }
      }
      if (swiper.navigation && swiper.navigation.$prevEl && $targetEl.is(swiper.navigation.$prevEl)) {
        if (!(swiper.isBeginning && !swiper.params.loop)) {
          swiper.slidePrev();
        }
        if (swiper.isBeginning) {
          swiper.a11y.notify(params.firstSlideMessage);
        } else {
          swiper.a11y.notify(params.prevSlideMessage);
        }
      }
      if (swiper.pagination && $targetEl.is(("." + (swiper.params.pagination.bulletClass)))) {
        $targetEl[0].click();
      }
    },
    notify: function notify(message) {
      var swiper = this;
      var notification = swiper.a11y.liveRegion;
      if (notification.length === 0) { return; }
      notification.html('');
      notification.html(message);
    },
    updateNavigation: function updateNavigation() {
      var swiper = this;

      if (swiper.params.loop) { return; }
      var ref = swiper.navigation;
      var $nextEl = ref.$nextEl;
      var $prevEl = ref.$prevEl;

      if ($prevEl && $prevEl.length > 0) {
        if (swiper.isBeginning) {
          swiper.a11y.disableEl($prevEl);
        } else {
          swiper.a11y.enableEl($prevEl);
        }
      }
      if ($nextEl && $nextEl.length > 0) {
        if (swiper.isEnd) {
          swiper.a11y.disableEl($nextEl);
        } else {
          swiper.a11y.enableEl($nextEl);
        }
      }
    },
    updatePagination: function updatePagination() {
      var swiper = this;
      var params = swiper.params.a11y;
      if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
        swiper.pagination.bullets.each(function (bulletIndex, bulletEl) {
          var $bulletEl = $(bulletEl);
          swiper.a11y.makeElFocusable($bulletEl);
          swiper.a11y.addElRole($bulletEl, 'button');
          swiper.a11y.addElLabel($bulletEl, params.paginationBulletMessage.replace(/{{index}}/, $bulletEl.index() + 1));
        });
      }
    },
    init: function init() {
      var swiper = this;

      swiper.$el.append(swiper.a11y.liveRegion);

      // Navigation
      var params = swiper.params.a11y;
      var $nextEl;
      var $prevEl;
      if (swiper.navigation && swiper.navigation.$nextEl) {
        $nextEl = swiper.navigation.$nextEl;
      }
      if (swiper.navigation && swiper.navigation.$prevEl) {
        $prevEl = swiper.navigation.$prevEl;
      }
      if ($nextEl) {
        swiper.a11y.makeElFocusable($nextEl);
        swiper.a11y.addElRole($nextEl, 'button');
        swiper.a11y.addElLabel($nextEl, params.nextSlideMessage);
        $nextEl.on('keydown', swiper.a11y.onEnterKey);
      }
      if ($prevEl) {
        swiper.a11y.makeElFocusable($prevEl);
        swiper.a11y.addElRole($prevEl, 'button');
        swiper.a11y.addElLabel($prevEl, params.prevSlideMessage);
        $prevEl.on('keydown', swiper.a11y.onEnterKey);
      }

      // Pagination
      if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
        swiper.pagination.$el.on('keydown', ("." + (swiper.params.pagination.bulletClass)), swiper.a11y.onEnterKey);
      }
    },
    destroy: function destroy() {
      var swiper = this;
      if (swiper.a11y.liveRegion && swiper.a11y.liveRegion.length > 0) { swiper.a11y.liveRegion.remove(); }

      var $nextEl;
      var $prevEl;
      if (swiper.navigation && swiper.navigation.$nextEl) {
        $nextEl = swiper.navigation.$nextEl;
      }
      if (swiper.navigation && swiper.navigation.$prevEl) {
        $prevEl = swiper.navigation.$prevEl;
      }
      if ($nextEl) {
        $nextEl.off('keydown', swiper.a11y.onEnterKey);
      }
      if ($prevEl) {
        $prevEl.off('keydown', swiper.a11y.onEnterKey);
      }

      // Pagination
      if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
        swiper.pagination.$el.off('keydown', ("." + (swiper.params.pagination.bulletClass)), swiper.a11y.onEnterKey);
      }
    },
  };
  var A11y = {
    name: 'a11y',
    params: {
      a11y: {
        enabled: true,
        notificationClass: 'swiper-notification',
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide',
        firstSlideMessage: 'This is the first slide',
        lastSlideMessage: 'This is the last slide',
        paginationBulletMessage: 'Go to slide {{index}}',
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        a11y: {
          liveRegion: $(("<span class=\"" + (swiper.params.a11y.notificationClass) + "\" aria-live=\"assertive\" aria-atomic=\"true\"></span>")),
        },
      });
      Object.keys(a11y).forEach(function (methodName) {
        swiper.a11y[methodName] = a11y[methodName].bind(swiper);
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        if (!swiper.params.a11y.enabled) { return; }
        swiper.a11y.init();
        swiper.a11y.updateNavigation();
      },
      toEdge: function toEdge() {
        var swiper = this;
        if (!swiper.params.a11y.enabled) { return; }
        swiper.a11y.updateNavigation();
      },
      fromEdge: function fromEdge() {
        var swiper = this;
        if (!swiper.params.a11y.enabled) { return; }
        swiper.a11y.updateNavigation();
      },
      paginationUpdate: function paginationUpdate() {
        var swiper = this;
        if (!swiper.params.a11y.enabled) { return; }
        swiper.a11y.updatePagination();
      },
      destroy: function destroy() {
        var swiper = this;
        if (!swiper.params.a11y.enabled) { return; }
        swiper.a11y.destroy();
      },
    },
  };

  var History = {
    init: function init() {
      var swiper = this;
      if (!swiper.params.history) { return; }
      if (!win.history || !win.history.pushState) {
        swiper.params.history.enabled = false;
        swiper.params.hashNavigation.enabled = true;
        return;
      }
      var history = swiper.history;
      history.initialized = true;
      history.paths = History.getPathValues();
      if (!history.paths.key && !history.paths.value) { return; }
      history.scrollToSlide(0, history.paths.value, swiper.params.runCallbacksOnInit);
      if (!swiper.params.history.replaceState) {
        win.addEventListener('popstate', swiper.history.setHistoryPopState);
      }
    },
    destroy: function destroy() {
      var swiper = this;
      if (!swiper.params.history.replaceState) {
        win.removeEventListener('popstate', swiper.history.setHistoryPopState);
      }
    },
    setHistoryPopState: function setHistoryPopState() {
      var swiper = this;
      swiper.history.paths = History.getPathValues();
      swiper.history.scrollToSlide(swiper.params.speed, swiper.history.paths.value, false);
    },
    getPathValues: function getPathValues() {
      var pathArray = win.location.pathname.slice(1).split('/').filter(function (part) { return part !== ''; });
      var total = pathArray.length;
      var key = pathArray[total - 2];
      var value = pathArray[total - 1];
      return { key: key, value: value };
    },
    setHistory: function setHistory(key, index) {
      var swiper = this;
      if (!swiper.history.initialized || !swiper.params.history.enabled) { return; }
      var slide = swiper.slides.eq(index);
      var value = History.slugify(slide.attr('data-history'));
      if (!win.location.pathname.includes(key)) {
        value = key + "/" + value;
      }
      var currentState = win.history.state;
      if (currentState && currentState.value === value) {
        return;
      }
      if (swiper.params.history.replaceState) {
        win.history.replaceState({ value: value }, null, value);
      } else {
        win.history.pushState({ value: value }, null, value);
      }
    },
    slugify: function slugify(text) {
      return text.toString()
        .replace(/\s+/g, '-')
        .replace(/[^\w-]+/g, '')
        .replace(/--+/g, '-')
        .replace(/^-+/, '')
        .replace(/-+$/, '');
    },
    scrollToSlide: function scrollToSlide(speed, value, runCallbacks) {
      var swiper = this;
      if (value) {
        for (var i = 0, length = swiper.slides.length; i < length; i += 1) {
          var slide = swiper.slides.eq(i);
          var slideHistory = History.slugify(slide.attr('data-history'));
          if (slideHistory === value && !slide.hasClass(swiper.params.slideDuplicateClass)) {
            var index = slide.index();
            swiper.slideTo(index, speed, runCallbacks);
          }
        }
      } else {
        swiper.slideTo(0, speed, runCallbacks);
      }
    },
  };

  var History$1 = {
    name: 'history',
    params: {
      history: {
        enabled: false,
        replaceState: false,
        key: 'slides',
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        history: {
          init: History.init.bind(swiper),
          setHistory: History.setHistory.bind(swiper),
          setHistoryPopState: History.setHistoryPopState.bind(swiper),
          scrollToSlide: History.scrollToSlide.bind(swiper),
          destroy: History.destroy.bind(swiper),
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        if (swiper.params.history.enabled) {
          swiper.history.init();
        }
      },
      destroy: function destroy() {
        var swiper = this;
        if (swiper.params.history.enabled) {
          swiper.history.destroy();
        }
      },
      transitionEnd: function transitionEnd() {
        var swiper = this;
        if (swiper.history.initialized) {
          swiper.history.setHistory(swiper.params.history.key, swiper.activeIndex);
        }
      },
    },
  };

  var HashNavigation = {
    onHashCange: function onHashCange() {
      var swiper = this;
      var newHash = doc.location.hash.replace('#', '');
      var activeSlideHash = swiper.slides.eq(swiper.activeIndex).attr('data-hash');
      if (newHash !== activeSlideHash) {
        var newIndex = swiper.$wrapperEl.children(("." + (swiper.params.slideClass) + "[data-hash=\"" + newHash + "\"]")).index();
        if (typeof newIndex === 'undefined') { return; }
        swiper.slideTo(newIndex);
      }
    },
    setHash: function setHash() {
      var swiper = this;
      if (!swiper.hashNavigation.initialized || !swiper.params.hashNavigation.enabled) { return; }
      if (swiper.params.hashNavigation.replaceState && win.history && win.history.replaceState) {
        win.history.replaceState(null, null, (("#" + (swiper.slides.eq(swiper.activeIndex).attr('data-hash'))) || ''));
      } else {
        var slide = swiper.slides.eq(swiper.activeIndex);
        var hash = slide.attr('data-hash') || slide.attr('data-history');
        doc.location.hash = hash || '';
      }
    },
    init: function init() {
      var swiper = this;
      if (!swiper.params.hashNavigation.enabled || (swiper.params.history && swiper.params.history.enabled)) { return; }
      swiper.hashNavigation.initialized = true;
      var hash = doc.location.hash.replace('#', '');
      if (hash) {
        var speed = 0;
        for (var i = 0, length = swiper.slides.length; i < length; i += 1) {
          var slide = swiper.slides.eq(i);
          var slideHash = slide.attr('data-hash') || slide.attr('data-history');
          if (slideHash === hash && !slide.hasClass(swiper.params.slideDuplicateClass)) {
            var index = slide.index();
            swiper.slideTo(index, speed, swiper.params.runCallbacksOnInit, true);
          }
        }
      }
      if (swiper.params.hashNavigation.watchState) {
        $(win).on('hashchange', swiper.hashNavigation.onHashCange);
      }
    },
    destroy: function destroy() {
      var swiper = this;
      if (swiper.params.hashNavigation.watchState) {
        $(win).off('hashchange', swiper.hashNavigation.onHashCange);
      }
    },
  };
  var HashNavigation$1 = {
    name: 'hash-navigation',
    params: {
      hashNavigation: {
        enabled: false,
        replaceState: false,
        watchState: false,
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        hashNavigation: {
          initialized: false,
          init: HashNavigation.init.bind(swiper),
          destroy: HashNavigation.destroy.bind(swiper),
          setHash: HashNavigation.setHash.bind(swiper),
          onHashCange: HashNavigation.onHashCange.bind(swiper),
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        if (swiper.params.hashNavigation.enabled) {
          swiper.hashNavigation.init();
        }
      },
      destroy: function destroy() {
        var swiper = this;
        if (swiper.params.hashNavigation.enabled) {
          swiper.hashNavigation.destroy();
        }
      },
      transitionEnd: function transitionEnd() {
        var swiper = this;
        if (swiper.hashNavigation.initialized) {
          swiper.hashNavigation.setHash();
        }
      },
    },
  };

  /* eslint no-underscore-dangle: "off" */

  var Autoplay = {
    run: function run() {
      var swiper = this;
      var $activeSlideEl = swiper.slides.eq(swiper.activeIndex);
      var delay = swiper.params.autoplay.delay;
      if ($activeSlideEl.attr('data-swiper-autoplay')) {
        delay = $activeSlideEl.attr('data-swiper-autoplay') || swiper.params.autoplay.delay;
      }
      clearTimeout(swiper.autoplay.timeout);
      swiper.autoplay.timeout = Utils.nextTick(function () {
        if (swiper.params.autoplay.reverseDirection) {
          if (swiper.params.loop) {
            swiper.loopFix();
            swiper.slidePrev(swiper.params.speed, true, true);
            swiper.emit('autoplay');
          } else if (!swiper.isBeginning) {
            swiper.slidePrev(swiper.params.speed, true, true);
            swiper.emit('autoplay');
          } else if (!swiper.params.autoplay.stopOnLastSlide) {
            swiper.slideTo(swiper.slides.length - 1, swiper.params.speed, true, true);
            swiper.emit('autoplay');
          } else {
            swiper.autoplay.stop();
          }
        } else if (swiper.params.loop) {
          swiper.loopFix();
          swiper.slideNext(swiper.params.speed, true, true);
          swiper.emit('autoplay');
        } else if (!swiper.isEnd) {
          swiper.slideNext(swiper.params.speed, true, true);
          swiper.emit('autoplay');
        } else if (!swiper.params.autoplay.stopOnLastSlide) {
          swiper.slideTo(0, swiper.params.speed, true, true);
          swiper.emit('autoplay');
        } else {
          swiper.autoplay.stop();
        }
      }, delay);
    },
    start: function start() {
      var swiper = this;
      if (typeof swiper.autoplay.timeout !== 'undefined') { return false; }
      if (swiper.autoplay.running) { return false; }
      swiper.autoplay.running = true;
      swiper.emit('autoplayStart');
      swiper.autoplay.run();
      return true;
    },
    stop: function stop() {
      var swiper = this;
      if (!swiper.autoplay.running) { return false; }
      if (typeof swiper.autoplay.timeout === 'undefined') { return false; }

      if (swiper.autoplay.timeout) {
        clearTimeout(swiper.autoplay.timeout);
        swiper.autoplay.timeout = undefined;
      }
      swiper.autoplay.running = false;
      swiper.emit('autoplayStop');
      return true;
    },
    pause: function pause(speed) {
      var swiper = this;
      if (!swiper.autoplay.running) { return; }
      if (swiper.autoplay.paused) { return; }
      if (swiper.autoplay.timeout) { clearTimeout(swiper.autoplay.timeout); }
      swiper.autoplay.paused = true;
      if (speed === 0 || !swiper.params.autoplay.waitForTransition) {
        swiper.autoplay.paused = false;
        swiper.autoplay.run();
      } else {
        swiper.$wrapperEl[0].addEventListener('transitionend', swiper.autoplay.onTransitionEnd);
        swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.autoplay.onTransitionEnd);
      }
    },
  };

  var Autoplay$1 = {
    name: 'autoplay',
    params: {
      autoplay: {
        enabled: false,
        delay: 3000,
        waitForTransition: true,
        disableOnInteraction: true,
        stopOnLastSlide: false,
        reverseDirection: false,
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        autoplay: {
          running: false,
          paused: false,
          run: Autoplay.run.bind(swiper),
          start: Autoplay.start.bind(swiper),
          stop: Autoplay.stop.bind(swiper),
          pause: Autoplay.pause.bind(swiper),
          onTransitionEnd: function onTransitionEnd(e) {
            if (!swiper || swiper.destroyed || !swiper.$wrapperEl) { return; }
            if (e.target !== this) { return; }
            swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.autoplay.onTransitionEnd);
            swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.autoplay.onTransitionEnd);
            swiper.autoplay.paused = false;
            if (!swiper.autoplay.running) {
              swiper.autoplay.stop();
            } else {
              swiper.autoplay.run();
            }
          },
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        if (swiper.params.autoplay.enabled) {
          swiper.autoplay.start();
        }
      },
      beforeTransitionStart: function beforeTransitionStart(speed, internal) {
        var swiper = this;
        if (swiper.autoplay.running) {
          if (internal || !swiper.params.autoplay.disableOnInteraction) {
            swiper.autoplay.pause(speed);
          } else {
            swiper.autoplay.stop();
          }
        }
      },
      sliderFirstMove: function sliderFirstMove() {
        var swiper = this;
        if (swiper.autoplay.running) {
          if (swiper.params.autoplay.disableOnInteraction) {
            swiper.autoplay.stop();
          } else {
            swiper.autoplay.pause();
          }
        }
      },
      destroy: function destroy() {
        var swiper = this;
        if (swiper.autoplay.running) {
          swiper.autoplay.stop();
        }
      },
    },
  };

  var Fade = {
    setTranslate: function setTranslate() {
      var swiper = this;
      var slides = swiper.slides;
      for (var i = 0; i < slides.length; i += 1) {
        var $slideEl = swiper.slides.eq(i);
        var offset = $slideEl[0].swiperSlideOffset;
        var tx = -offset;
        if (!swiper.params.virtualTranslate) { tx -= swiper.translate; }
        var ty = 0;
        if (!swiper.isHorizontal()) {
          ty = tx;
          tx = 0;
        }
        var slideOpacity = swiper.params.fadeEffect.crossFade
          ? Math.max(1 - Math.abs($slideEl[0].progress), 0)
          : 1 + Math.min(Math.max($slideEl[0].progress, -1), 0);
        $slideEl
          .css({
            opacity: slideOpacity,
          })
          .transform(("translate3d(" + tx + "px, " + ty + "px, 0px)"));
      }
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      var slides = swiper.slides;
      var $wrapperEl = swiper.$wrapperEl;
      slides.transition(duration);
      if (swiper.params.virtualTranslate && duration !== 0) {
        var eventTriggered = false;
        slides.transitionEnd(function () {
          if (eventTriggered) { return; }
          if (!swiper || swiper.destroyed) { return; }
          eventTriggered = true;
          swiper.animating = false;
          var triggerEvents = ['webkitTransitionEnd', 'transitionend'];
          for (var i = 0; i < triggerEvents.length; i += 1) {
            $wrapperEl.trigger(triggerEvents[i]);
          }
        });
      }
    },
  };

  var EffectFade = {
    name: 'effect-fade',
    params: {
      fadeEffect: {
        crossFade: false,
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        fadeEffect: {
          setTranslate: Fade.setTranslate.bind(swiper),
          setTransition: Fade.setTransition.bind(swiper),
        },
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var swiper = this;
        if (swiper.params.effect !== 'fade') { return; }
        swiper.classNames.push(((swiper.params.containerModifierClass) + "fade"));
        var overwriteParams = {
          slidesPerView: 1,
          slidesPerColumn: 1,
          slidesPerGroup: 1,
          watchSlidesProgress: true,
          spaceBetween: 0,
          virtualTranslate: true,
        };
        Utils.extend(swiper.params, overwriteParams);
        Utils.extend(swiper.originalParams, overwriteParams);
      },
      setTranslate: function setTranslate() {
        var swiper = this;
        if (swiper.params.effect !== 'fade') { return; }
        swiper.fadeEffect.setTranslate();
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        if (swiper.params.effect !== 'fade') { return; }
        swiper.fadeEffect.setTransition(duration);
      },
    },
  };

  var Cube = {
    setTranslate: function setTranslate() {
      var swiper = this;
      var $el = swiper.$el;
      var $wrapperEl = swiper.$wrapperEl;
      var slides = swiper.slides;
      var swiperWidth = swiper.width;
      var swiperHeight = swiper.height;
      var rtl = swiper.rtlTranslate;
      var swiperSize = swiper.size;
      var params = swiper.params.cubeEffect;
      var isHorizontal = swiper.isHorizontal();
      var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
      var wrapperRotate = 0;
      var $cubeShadowEl;
      if (params.shadow) {
        if (isHorizontal) {
          $cubeShadowEl = $wrapperEl.find('.swiper-cube-shadow');
          if ($cubeShadowEl.length === 0) {
            $cubeShadowEl = $('<div class="swiper-cube-shadow"></div>');
            $wrapperEl.append($cubeShadowEl);
          }
          $cubeShadowEl.css({ height: (swiperWidth + "px") });
        } else {
          $cubeShadowEl = $el.find('.swiper-cube-shadow');
          if ($cubeShadowEl.length === 0) {
            $cubeShadowEl = $('<div class="swiper-cube-shadow"></div>');
            $el.append($cubeShadowEl);
          }
        }
      }
      for (var i = 0; i < slides.length; i += 1) {
        var $slideEl = slides.eq(i);
        var slideIndex = i;
        if (isVirtual) {
          slideIndex = parseInt($slideEl.attr('data-swiper-slide-index'), 10);
        }
        var slideAngle = slideIndex * 90;
        var round = Math.floor(slideAngle / 360);
        if (rtl) {
          slideAngle = -slideAngle;
          round = Math.floor(-slideAngle / 360);
        }
        var progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
        var tx = 0;
        var ty = 0;
        var tz = 0;
        if (slideIndex % 4 === 0) {
          tx = -round * 4 * swiperSize;
          tz = 0;
        } else if ((slideIndex - 1) % 4 === 0) {
          tx = 0;
          tz = -round * 4 * swiperSize;
        } else if ((slideIndex - 2) % 4 === 0) {
          tx = swiperSize + (round * 4 * swiperSize);
          tz = swiperSize;
        } else if ((slideIndex - 3) % 4 === 0) {
          tx = -swiperSize;
          tz = (3 * swiperSize) + (swiperSize * 4 * round);
        }
        if (rtl) {
          tx = -tx;
        }

        if (!isHorizontal) {
          ty = tx;
          tx = 0;
        }

        var transform = "rotateX(" + (isHorizontal ? 0 : -slideAngle) + "deg) rotateY(" + (isHorizontal ? slideAngle : 0) + "deg) translate3d(" + tx + "px, " + ty + "px, " + tz + "px)";
        if (progress <= 1 && progress > -1) {
          wrapperRotate = (slideIndex * 90) + (progress * 90);
          if (rtl) { wrapperRotate = (-slideIndex * 90) - (progress * 90); }
        }
        $slideEl.transform(transform);
        if (params.slideShadows) {
          // Set shadows
          var shadowBefore = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
          var shadowAfter = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
          if (shadowBefore.length === 0) {
            shadowBefore = $(("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'left' : 'top') + "\"></div>"));
            $slideEl.append(shadowBefore);
          }
          if (shadowAfter.length === 0) {
            shadowAfter = $(("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'right' : 'bottom') + "\"></div>"));
            $slideEl.append(shadowAfter);
          }
          if (shadowBefore.length) { shadowBefore[0].style.opacity = Math.max(-progress, 0); }
          if (shadowAfter.length) { shadowAfter[0].style.opacity = Math.max(progress, 0); }
        }
      }
      $wrapperEl.css({
        '-webkit-transform-origin': ("50% 50% -" + (swiperSize / 2) + "px"),
        '-moz-transform-origin': ("50% 50% -" + (swiperSize / 2) + "px"),
        '-ms-transform-origin': ("50% 50% -" + (swiperSize / 2) + "px"),
        'transform-origin': ("50% 50% -" + (swiperSize / 2) + "px"),
      });

      if (params.shadow) {
        if (isHorizontal) {
          $cubeShadowEl.transform(("translate3d(0px, " + ((swiperWidth / 2) + params.shadowOffset) + "px, " + (-swiperWidth / 2) + "px) rotateX(90deg) rotateZ(0deg) scale(" + (params.shadowScale) + ")"));
        } else {
          var shadowAngle = Math.abs(wrapperRotate) - (Math.floor(Math.abs(wrapperRotate) / 90) * 90);
          var multiplier = 1.5 - (
            (Math.sin((shadowAngle * 2 * Math.PI) / 360) / 2)
            + (Math.cos((shadowAngle * 2 * Math.PI) / 360) / 2)
          );
          var scale1 = params.shadowScale;
          var scale2 = params.shadowScale / multiplier;
          var offset = params.shadowOffset;
          $cubeShadowEl.transform(("scale3d(" + scale1 + ", 1, " + scale2 + ") translate3d(0px, " + ((swiperHeight / 2) + offset) + "px, " + (-swiperHeight / 2 / scale2) + "px) rotateX(-90deg)"));
        }
      }
      var zFactor = (Browser.isSafari || Browser.isUiWebView) ? (-swiperSize / 2) : 0;
      $wrapperEl
        .transform(("translate3d(0px,0," + zFactor + "px) rotateX(" + (swiper.isHorizontal() ? 0 : wrapperRotate) + "deg) rotateY(" + (swiper.isHorizontal() ? -wrapperRotate : 0) + "deg)"));
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      var $el = swiper.$el;
      var slides = swiper.slides;
      slides
        .transition(duration)
        .find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left')
        .transition(duration);
      if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) {
        $el.find('.swiper-cube-shadow').transition(duration);
      }
    },
  };

  var EffectCube = {
    name: 'effect-cube',
    params: {
      cubeEffect: {
        slideShadows: true,
        shadow: true,
        shadowOffset: 20,
        shadowScale: 0.94,
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        cubeEffect: {
          setTranslate: Cube.setTranslate.bind(swiper),
          setTransition: Cube.setTransition.bind(swiper),
        },
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var swiper = this;
        if (swiper.params.effect !== 'cube') { return; }
        swiper.classNames.push(((swiper.params.containerModifierClass) + "cube"));
        swiper.classNames.push(((swiper.params.containerModifierClass) + "3d"));
        var overwriteParams = {
          slidesPerView: 1,
          slidesPerColumn: 1,
          slidesPerGroup: 1,
          watchSlidesProgress: true,
          resistanceRatio: 0,
          spaceBetween: 0,
          centeredSlides: false,
          virtualTranslate: true,
        };
        Utils.extend(swiper.params, overwriteParams);
        Utils.extend(swiper.originalParams, overwriteParams);
      },
      setTranslate: function setTranslate() {
        var swiper = this;
        if (swiper.params.effect !== 'cube') { return; }
        swiper.cubeEffect.setTranslate();
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        if (swiper.params.effect !== 'cube') { return; }
        swiper.cubeEffect.setTransition(duration);
      },
    },
  };

  var Flip = {
    setTranslate: function setTranslate() {
      var swiper = this;
      var slides = swiper.slides;
      var rtl = swiper.rtlTranslate;
      for (var i = 0; i < slides.length; i += 1) {
        var $slideEl = slides.eq(i);
        var progress = $slideEl[0].progress;
        if (swiper.params.flipEffect.limitRotation) {
          progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
        }
        var offset = $slideEl[0].swiperSlideOffset;
        var rotate = -180 * progress;
        var rotateY = rotate;
        var rotateX = 0;
        var tx = -offset;
        var ty = 0;
        if (!swiper.isHorizontal()) {
          ty = tx;
          tx = 0;
          rotateX = -rotateY;
          rotateY = 0;
        } else if (rtl) {
          rotateY = -rotateY;
        }

        $slideEl[0].style.zIndex = -Math.abs(Math.round(progress)) + slides.length;

        if (swiper.params.flipEffect.slideShadows) {
          // Set shadows
          var shadowBefore = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
          var shadowAfter = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
          if (shadowBefore.length === 0) {
            shadowBefore = $(("<div class=\"swiper-slide-shadow-" + (swiper.isHorizontal() ? 'left' : 'top') + "\"></div>"));
            $slideEl.append(shadowBefore);
          }
          if (shadowAfter.length === 0) {
            shadowAfter = $(("<div class=\"swiper-slide-shadow-" + (swiper.isHorizontal() ? 'right' : 'bottom') + "\"></div>"));
            $slideEl.append(shadowAfter);
          }
          if (shadowBefore.length) { shadowBefore[0].style.opacity = Math.max(-progress, 0); }
          if (shadowAfter.length) { shadowAfter[0].style.opacity = Math.max(progress, 0); }
        }
        $slideEl
          .transform(("translate3d(" + tx + "px, " + ty + "px, 0px) rotateX(" + rotateX + "deg) rotateY(" + rotateY + "deg)"));
      }
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      var slides = swiper.slides;
      var activeIndex = swiper.activeIndex;
      var $wrapperEl = swiper.$wrapperEl;
      slides
        .transition(duration)
        .find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left')
        .transition(duration);
      if (swiper.params.virtualTranslate && duration !== 0) {
        var eventTriggered = false;
        // eslint-disable-next-line
        slides.eq(activeIndex).transitionEnd(function onTransitionEnd() {
          if (eventTriggered) { return; }
          if (!swiper || swiper.destroyed) { return; }
          // if (!$(this).hasClass(swiper.params.slideActiveClass)) return;
          eventTriggered = true;
          swiper.animating = false;
          var triggerEvents = ['webkitTransitionEnd', 'transitionend'];
          for (var i = 0; i < triggerEvents.length; i += 1) {
            $wrapperEl.trigger(triggerEvents[i]);
          }
        });
      }
    },
  };

  var EffectFlip = {
    name: 'effect-flip',
    params: {
      flipEffect: {
        slideShadows: true,
        limitRotation: true,
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        flipEffect: {
          setTranslate: Flip.setTranslate.bind(swiper),
          setTransition: Flip.setTransition.bind(swiper),
        },
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var swiper = this;
        if (swiper.params.effect !== 'flip') { return; }
        swiper.classNames.push(((swiper.params.containerModifierClass) + "flip"));
        swiper.classNames.push(((swiper.params.containerModifierClass) + "3d"));
        var overwriteParams = {
          slidesPerView: 1,
          slidesPerColumn: 1,
          slidesPerGroup: 1,
          watchSlidesProgress: true,
          spaceBetween: 0,
          virtualTranslate: true,
        };
        Utils.extend(swiper.params, overwriteParams);
        Utils.extend(swiper.originalParams, overwriteParams);
      },
      setTranslate: function setTranslate() {
        var swiper = this;
        if (swiper.params.effect !== 'flip') { return; }
        swiper.flipEffect.setTranslate();
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        if (swiper.params.effect !== 'flip') { return; }
        swiper.flipEffect.setTransition(duration);
      },
    },
  };

  var Coverflow = {
    setTranslate: function setTranslate() {
      var swiper = this;
      var swiperWidth = swiper.width;
      var swiperHeight = swiper.height;
      var slides = swiper.slides;
      var $wrapperEl = swiper.$wrapperEl;
      var slidesSizesGrid = swiper.slidesSizesGrid;
      var params = swiper.params.coverflowEffect;
      var isHorizontal = swiper.isHorizontal();
      var transform = swiper.translate;
      var center = isHorizontal ? -transform + (swiperWidth / 2) : -transform + (swiperHeight / 2);
      var rotate = isHorizontal ? params.rotate : -params.rotate;
      var translate = params.depth;
      // Each slide offset from center
      for (var i = 0, length = slides.length; i < length; i += 1) {
        var $slideEl = slides.eq(i);
        var slideSize = slidesSizesGrid[i];
        var slideOffset = $slideEl[0].swiperSlideOffset;
        var offsetMultiplier = ((center - slideOffset - (slideSize / 2)) / slideSize) * params.modifier;

        var rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
        var rotateX = isHorizontal ? 0 : rotate * offsetMultiplier;
        // var rotateZ = 0
        var translateZ = -translate * Math.abs(offsetMultiplier);

        var translateY = isHorizontal ? 0 : params.stretch * (offsetMultiplier);
        var translateX = isHorizontal ? params.stretch * (offsetMultiplier) : 0;

        // Fix for ultra small values
        if (Math.abs(translateX) < 0.001) { translateX = 0; }
        if (Math.abs(translateY) < 0.001) { translateY = 0; }
        if (Math.abs(translateZ) < 0.001) { translateZ = 0; }
        if (Math.abs(rotateY) < 0.001) { rotateY = 0; }
        if (Math.abs(rotateX) < 0.001) { rotateX = 0; }

        var slideTransform = "translate3d(" + translateX + "px," + translateY + "px," + translateZ + "px)  rotateX(" + rotateX + "deg) rotateY(" + rotateY + "deg)";

        $slideEl.transform(slideTransform);
        $slideEl[0].style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
        if (params.slideShadows) {
          // Set shadows
          var $shadowBeforeEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
          var $shadowAfterEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
          if ($shadowBeforeEl.length === 0) {
            $shadowBeforeEl = $(("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'left' : 'top') + "\"></div>"));
            $slideEl.append($shadowBeforeEl);
          }
          if ($shadowAfterEl.length === 0) {
            $shadowAfterEl = $(("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'right' : 'bottom') + "\"></div>"));
            $slideEl.append($shadowAfterEl);
          }
          if ($shadowBeforeEl.length) { $shadowBeforeEl[0].style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0; }
          if ($shadowAfterEl.length) { $shadowAfterEl[0].style.opacity = (-offsetMultiplier) > 0 ? -offsetMultiplier : 0; }
        }
      }

      // Set correct perspective for IE10
      if (Support.pointerEvents || Support.prefixedPointerEvents) {
        var ws = $wrapperEl[0].style;
        ws.perspectiveOrigin = center + "px 50%";
      }
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      swiper.slides
        .transition(duration)
        .find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left')
        .transition(duration);
    },
  };

  var EffectCoverflow = {
    name: 'effect-coverflow',
    params: {
      coverflowEffect: {
        rotate: 50,
        stretch: 0,
        depth: 100,
        modifier: 1,
        slideShadows: true,
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        coverflowEffect: {
          setTranslate: Coverflow.setTranslate.bind(swiper),
          setTransition: Coverflow.setTransition.bind(swiper),
        },
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var swiper = this;
        if (swiper.params.effect !== 'coverflow') { return; }

        swiper.classNames.push(((swiper.params.containerModifierClass) + "coverflow"));
        swiper.classNames.push(((swiper.params.containerModifierClass) + "3d"));

        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
      },
      setTranslate: function setTranslate() {
        var swiper = this;
        if (swiper.params.effect !== 'coverflow') { return; }
        swiper.coverflowEffect.setTranslate();
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        if (swiper.params.effect !== 'coverflow') { return; }
        swiper.coverflowEffect.setTransition(duration);
      },
    },
  };

  var Thumbs = {
    init: function init() {
      var swiper = this;
      var ref = swiper.params;
      var thumbsParams = ref.thumbs;
      var SwiperClass = swiper.constructor;
      if (thumbsParams.swiper instanceof SwiperClass) {
        swiper.thumbs.swiper = thumbsParams.swiper;
        Utils.extend(swiper.thumbs.swiper.originalParams, {
          watchSlidesProgress: true,
          slideToClickedSlide: false,
        });
        Utils.extend(swiper.thumbs.swiper.params, {
          watchSlidesProgress: true,
          slideToClickedSlide: false,
        });
      } else if (Utils.isObject(thumbsParams.swiper)) {
        swiper.thumbs.swiper = new SwiperClass(Utils.extend({}, thumbsParams.swiper, {
          watchSlidesVisibility: true,
          watchSlidesProgress: true,
          slideToClickedSlide: false,
        }));
        swiper.thumbs.swiperCreated = true;
      }
      swiper.thumbs.swiper.$el.addClass(swiper.params.thumbs.thumbsContainerClass);
      swiper.thumbs.swiper.on('tap', swiper.thumbs.onThumbClick);
    },
    onThumbClick: function onThumbClick() {
      var swiper = this;
      var thumbsSwiper = swiper.thumbs.swiper;
      if (!thumbsSwiper) { return; }
      var clickedIndex = thumbsSwiper.clickedIndex;
      var clickedSlide = thumbsSwiper.clickedSlide;
      if (clickedSlide && $(clickedSlide).hasClass(swiper.params.thumbs.slideThumbActiveClass)) { return; }
      if (typeof clickedIndex === 'undefined' || clickedIndex === null) { return; }
      var slideToIndex;
      if (thumbsSwiper.params.loop) {
        slideToIndex = parseInt($(thumbsSwiper.clickedSlide).attr('data-swiper-slide-index'), 10);
      } else {
        slideToIndex = clickedIndex;
      }
      if (swiper.params.loop) {
        var currentIndex = swiper.activeIndex;
        if (swiper.slides.eq(currentIndex).hasClass(swiper.params.slideDuplicateClass)) {
          swiper.loopFix();
          // eslint-disable-next-line
          swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
          currentIndex = swiper.activeIndex;
        }
        var prevIndex = swiper.slides.eq(currentIndex).prevAll(("[data-swiper-slide-index=\"" + slideToIndex + "\"]")).eq(0).index();
        var nextIndex = swiper.slides.eq(currentIndex).nextAll(("[data-swiper-slide-index=\"" + slideToIndex + "\"]")).eq(0).index();
        if (typeof prevIndex === 'undefined') { slideToIndex = nextIndex; }
        else if (typeof nextIndex === 'undefined') { slideToIndex = prevIndex; }
        else if (nextIndex - currentIndex < currentIndex - prevIndex) { slideToIndex = nextIndex; }
        else { slideToIndex = prevIndex; }
      }
      swiper.slideTo(slideToIndex);
    },
    update: function update(initial) {
      var swiper = this;
      var thumbsSwiper = swiper.thumbs.swiper;
      if (!thumbsSwiper) { return; }

      var slidesPerView = thumbsSwiper.params.slidesPerView === 'auto'
        ? thumbsSwiper.slidesPerViewDynamic()
        : thumbsSwiper.params.slidesPerView;

      if (swiper.realIndex !== thumbsSwiper.realIndex) {
        var currentThumbsIndex = thumbsSwiper.activeIndex;
        var newThumbsIndex;
        if (thumbsSwiper.params.loop) {
          if (thumbsSwiper.slides.eq(currentThumbsIndex).hasClass(thumbsSwiper.params.slideDuplicateClass)) {
            thumbsSwiper.loopFix();
            // eslint-disable-next-line
            thumbsSwiper._clientLeft = thumbsSwiper.$wrapperEl[0].clientLeft;
            currentThumbsIndex = thumbsSwiper.activeIndex;
          }
          // Find actual thumbs index to slide to
          var prevThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).prevAll(("[data-swiper-slide-index=\"" + (swiper.realIndex) + "\"]")).eq(0).index();
          var nextThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).nextAll(("[data-swiper-slide-index=\"" + (swiper.realIndex) + "\"]")).eq(0).index();
          if (typeof prevThumbsIndex === 'undefined') { newThumbsIndex = nextThumbsIndex; }
          else if (typeof nextThumbsIndex === 'undefined') { newThumbsIndex = prevThumbsIndex; }
          else if (nextThumbsIndex - currentThumbsIndex === currentThumbsIndex - prevThumbsIndex) { newThumbsIndex = currentThumbsIndex; }
          else if (nextThumbsIndex - currentThumbsIndex < currentThumbsIndex - prevThumbsIndex) { newThumbsIndex = nextThumbsIndex; }
          else { newThumbsIndex = prevThumbsIndex; }
        } else {
          newThumbsIndex = swiper.realIndex;
        }
        if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
          if (thumbsSwiper.params.centeredSlides) {
            if (newThumbsIndex > currentThumbsIndex) {
              newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
            } else {
              newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
            }
          } else if (newThumbsIndex > currentThumbsIndex) {
            newThumbsIndex = newThumbsIndex - slidesPerView + 1;
          }
          thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
        }
      }

      // Activate thumbs
      var thumbsToActivate = 1;
      var thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;

      if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) {
        thumbsToActivate = swiper.params.slidesPerView;
      }

      thumbsSwiper.slides.removeClass(thumbActiveClass);
      if (thumbsSwiper.params.loop || thumbsSwiper.params.virtual) {
        for (var i = 0; i < thumbsToActivate; i += 1) {
          thumbsSwiper.$wrapperEl.children(("[data-swiper-slide-index=\"" + (swiper.realIndex + i) + "\"]")).addClass(thumbActiveClass);
        }
      } else {
        for (var i$1 = 0; i$1 < thumbsToActivate; i$1 += 1) {
          thumbsSwiper.slides.eq(swiper.realIndex + i$1).addClass(thumbActiveClass);
        }
      }
    },
  };
  var Thumbs$1 = {
    name: 'thumbs',
    params: {
      thumbs: {
        swiper: null,
        slideThumbActiveClass: 'swiper-slide-thumb-active',
        thumbsContainerClass: 'swiper-container-thumbs',
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        thumbs: {
          swiper: null,
          init: Thumbs.init.bind(swiper),
          update: Thumbs.update.bind(swiper),
          onThumbClick: Thumbs.onThumbClick.bind(swiper),
        },
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var swiper = this;
        var ref = swiper.params;
        var thumbs = ref.thumbs;
        if (!thumbs || !thumbs.swiper) { return; }
        swiper.thumbs.init();
        swiper.thumbs.update(true);
      },
      slideChange: function slideChange() {
        var swiper = this;
        if (!swiper.thumbs.swiper) { return; }
        swiper.thumbs.update();
      },
      update: function update() {
        var swiper = this;
        if (!swiper.thumbs.swiper) { return; }
        swiper.thumbs.update();
      },
      resize: function resize() {
        var swiper = this;
        if (!swiper.thumbs.swiper) { return; }
        swiper.thumbs.update();
      },
      observerUpdate: function observerUpdate() {
        var swiper = this;
        if (!swiper.thumbs.swiper) { return; }
        swiper.thumbs.update();
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        var thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper) { return; }
        thumbsSwiper.setTransition(duration);
      },
      beforeDestroy: function beforeDestroy() {
        var swiper = this;
        var thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper) { return; }
        if (swiper.thumbs.swiperCreated && thumbsSwiper) {
          thumbsSwiper.destroy();
        }
      },
    },
  };

  // Swiper Class

  var components = [
    Device$1,
    Support$1,
    Browser$1,
    Resize,
    Observer$1,
    Virtual$1,
    Keyboard$1,
    Mousewheel$1,
    Navigation$1,
    Pagination$1,
    Scrollbar$1,
    Parallax$1,
    Zoom$1,
    Lazy$1,
    Controller$1,
    A11y,
    History$1,
    HashNavigation$1,
    Autoplay$1,
    EffectFade,
    EffectCube,
    EffectFlip,
    EffectCoverflow,
    Thumbs$1
  ];

  if (typeof Swiper.use === 'undefined') {
    Swiper.use = Swiper.Class.use;
    Swiper.installModule = Swiper.Class.installModule;
  }

  Swiper.use(components);

  return Swiper;

}));

define('views/ProductDetailGalleryView',['require','exports','module','theme','backbone','swiper'],function (require, exports, module) {
    "use strict";

    // External dependencies.
    var theme = require('theme');
    var Backbone = require('backbone');
    var Swiper = require('swiper');

    var ModuleProductDetailGalleryView = Backbone.View.extend({

        templateBullet: null,

        initialize: function (options) {
            this.templateBullet = _.template(this.$('script.template-bullet').text());
            this.render();
        },

        render: function (e) {
            this.swiper();
            return this;
        },

        swiper: function () {
            var $imgs = this.$('.swiper-slide img');
            var swiper = new Swiper(this.$('.swiper-container'), {
                slidesPerView: 1,
                spaceBetween: 30,
                loop: true,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                    renderBullet: _.bind(function (index, className) {
                        var img = $($imgs[index]).data('thumb');
                        var srcset = $($imgs[index]).data('thumb-src-media');
                        srcset = srcset ? srcset : "";
                        return this.templateBullet({img: img, srcset: srcset});
                    }, this),
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
            });
        },
    });

    module.exports = ModuleProductDetailGalleryView;
});

define('views/HeaderSearchView',['require','exports','module','theme','backbone','james-search'],function (require, exports, module) {
    "use strict";

    // External dependencies.
    var theme = require("theme");
    var Backbone = require("backbone");
    var JamesSearch = require("james-search");

    var isMobile = $('body').hasClass('xs') || $('body').hasClass('sm');
    var timeoutHover = undefined;
    var timeoutTime = 600;
    var jamesSearchQueryCookie = 'james-search-query';

    var ModuleHeaderSearchView = Backbone.View.extend({

        initialize: function (options) {
            this.views = [];

            this.options = _.extend({}, this.$el.data(), options);

            this.createJamesSearch();
            this.render();
            this.enableEvents();
        },

        cookieQueryExists: function (name) {
            return document.cookie.split(';').some(function (cookie) {
                return cookie.trim().startsWith(name);
            });
        },

        readCookieQuery: function (name) {
            var regexp = new RegExp(name + '=([^;]+)'),
                match = document.cookie.match(regexp);
            var value = match ? match[1] : null;

            return decodeURIComponent(value);
        },

        saveCookieQuery: function (name, value) {
            var cookie = '';

            cookie += name + '=' + encodeURIComponent(value) + '; ';
            cookie += 'path=' + isapi.cookie.path + '; ';
            cookie += 'domain=' + isapi.cookie.domain + '; ';
            cookie += 'expires=0; ';

            document.cookie = cookie;
        },

        removeCookieQuery: function (name) {
            var cookie = '';

            cookie += name + '=;';
            cookie += 'path=' + isapi.cookie.path + '; ';
            cookie += 'domain=' + isapi.cookie.domain + '; ';
            cookie += 'expires=Thu, 01 Jan 1970 00:00:00 UTC; ';

            document.cookie = cookie;
        },

        createJamesSearch: function () {
            this.jamesSearch = new JamesSearch({
                suggest: window.jamesSearchSettings.suggest
            });
        },

        render: function () {
            this.$cleanSearchButton = this.$el.find('#clean-search-input');
            this.$searchField = this.$el.find('.james-search-input');
            this.$body = $('body');

            $('.popular-terms .terms-item a').each(function (index, value) {
                if (value.dataset.url !== null && value.dataset.url !== '') {
                    value.href = value.dataset.url + value.innerText.trim();
                } else {
                    value.href = value.href + value.innerText.trim();
                }
            });

            if (this.cookieQueryExists(jamesSearchQueryCookie)) {
                this.$searchField.val(this.readCookieQuery(jamesSearchQueryCookie));
                this.jamesSearch.suggest();
                this.$cleanSearchButton.removeClass('hidden');
            }
        },

        cleanSuggestBox: function (e) {
            $(e.currentTarget).addClass('hidden');
            this.$searchField.val('');
            this.jamesSearch.removeBox();

            if (isMobile) {
                $('.popular-terms').addClass('show');
            }
        },

        onInputUpdate: function (e) {
            if (e.currentTarget.value.length === 0) {
                $('.popular-terms').addClass('show');

                if (!this.$cleanSearchButton.hasClass('hidden')) {
                    this.$cleanSearchButton.addClass('hidden');
                }
            } else {
                if (this.$cleanSearchButton.hasClass('hidden')) {
                    this.$cleanSearchButton.removeClass('hidden');
                }
            }

            this.checkInput();
        },

        checkInput: function () {
            if (this.$searchField.val().trim().length >= 3 && this.$searchField.val().trim() !== '') {
                this.saveCookieQuery(jamesSearchQueryCookie, this.$searchField.val());
            } else {
                if (this.cookieQueryExists(jamesSearchQueryCookie)) {
                    this.removeCookieQuery(jamesSearchQueryCookie);
                }
            }
        },

        enableEvents: function () {
            this.$cleanSearchButton.on('click', _.bind(function (e) {
                this.cleanSuggestBox(e);

                if (this.cookieQueryExists(jamesSearchQueryCookie)) {
                    this.removeCookieQuery(jamesSearchQueryCookie);
                }
            }, this));

            this.$searchField.on('input', _.bind(function (e) {
                this.onInputUpdate(e);
            }, this));

            $(document).on('mouseleave', '.module-header-search-wrapper', function () {
                clearTimeout(timeoutHover);

                timeoutHover = setTimeout(function () {
                    $('.popular-terms').removeClass('hover');
                }, timeoutTime);
            });

            $(document).on('focus', '.james-search-input', function (e) {
                $('.popular-terms').addClass('hover');
                $('.popular-terms').addClass('show');

                if (($('body').hasClass('xs') || $('body').hasClass('sm')) && !$('body').hasClass('module-mobile-open')) {
                    $('body').addClass('overflow-hidden');
                }
            });

            $(document).on('blur', '.james-search-input', function (e) {
                $(e.currentTarget).closest('.input-group').removeClass('focus');
                $('.popular-terms').removeClass('show');
            });

            this.jamesSearch.addEventListener(JamesSearch.EVENTS.inputUpdate, _.bind(function (e) {
                this.checkInput();
            }, this));
        },
    });

    module.exports = ModuleHeaderSearchView;
});

define('views/ProductCollapseView',['require','exports','module','theme','backbone'],function (require, exports, module) {
    "use strict";

    // External dependencies.
    var theme = require("theme");
    var Backbone = require("backbone");

    var ModuleProductCollapseView = Backbone.View.extend({

        views: null,

        initialize: function (options) {
            this.views = [];

            options = _.extend({}, this.$el.data(), options);

            this.el.moduleProductCollapseView = this;

            this.render();
        },

        events: {
            "show.bs.collapse .collapse": "onCollapse"
        },

        onCollapse: function (e) {
            $(window).trigger("resize");
        },

        render: function (e) {

            this.enableEvents();

            this.$el.addClass("rendered");
        },

        enableEvents: function () {
            //Remove previous events
            this.disableEvents();

            return this;
        },

        disableEvents: function () {
            return this;
        },
    });

    module.exports = ModuleProductCollapseView;
});

define('views/CheckoutDeliveryView',['require','exports','module','theme','backbone'],function (require, exports, module) {
    "use strict";

    // External dependencies.
    var theme = require("theme");
    var Backbone = require("backbone");

    var ModuleCheckoutDeliveryView = Backbone.View.extend({

        views: null,
        $inputs: null,

        initialize: function (options) {
            this.views = [];

            options = _.extend({}, this.$el.data(), options);

            this.el.moduleCheckoutDeliveryView = this;

            this.render();
        },

        events: {
            'change label input': "onChange"
        },

        render: function (e) {
            this.$inputs = this.$el.find("label input");

            this.enableEvents();

            this.checkActiveLabels();

            this.$el.addClass("rendered");
        },

        enableEvents: function () {
            //Remove previous events
            this.disableEvents();


            return this;
        },

        disableEvents: function () {

            return this;
        },

        onChange: function (e) {
            this.checkActiveLabels();
        },

        checkActiveLabels: function (e) {
            var i;
            var imax = this.$inputs.length;
            var $input;
            var $label;

            for (i = 0; i < imax; i++) {
                $input = this.$inputs.eq(i);
                $label = $input.closest("label")

                if ($input.prop("checked")) {
                    $label.addClass("active");
                } else {
                    $label.removeClass("active");
                }
            }
        },
    });

    module.exports = ModuleCheckoutDeliveryView;
});

define('views/CheckoutTimepickerView',['require','exports','module','theme','backbone'],function (require, exports, module) {
    "use strict";

    // External dependencies.
    var theme = require("theme");
    var Backbone = require("backbone");

    var ModuleCheckoutTimepickerView = Backbone.View.extend({

        views: null,
        $inputs: null,

        initialize: function (options) {
            this.views = [];

            options = _.extend({}, this.$el.data(), options);

            this.el.moduleCheckoutTimepickerView = this;

            this.render();
        },

        events: {
            'change label input': "onChange"
        },

        render: function (e) {
            this.$inputs = this.$el.find("label input");

            this.enableEvents();

            this.checkActiveLabels();

            this.$el.addClass("rendered");
        },

        enableEvents: function () {
            //Remove previous events
            this.disableEvents();

            return this;
        },

        disableEvents: function () {
            return this;
        },

        onChange: function (e) {
            this.checkActiveLabels();
        },

        checkActiveLabels: function (e) {
            var i;
            var imax = this.$inputs.length;
            var $input;
            var $label;

            for (i = 0; i < imax; i++) {
                $input = this.$inputs.eq(i);
                $label = $input.closest("label")

                if ($input.prop("checked")) {
                    $label.addClass("active");
                } else {
                    $label.removeClass("active");
                }
            }
        },
    });

    module.exports = ModuleCheckoutTimepickerView;
});

define('views/CheckoutTableTotalAlertView',['require','exports','module','theme','backbone'],function (require, exports, module) {
    "use strict";

    // External dependencies.
    var theme = require("theme");
    var Backbone = require("backbone");

    var ModuleCheckoutTableTotalAlertView = Backbone.View.extend({

        views: null,

        initialize: function (options) {
            this.views = [];

            options = _.extend({}, this.$el.data(), options);

            this.el.moduleCheckoutTableTotalAlertView = this;

            this.render();
        },

        events: {
            'click .module-checkout-table-total-alert-close': "onCloseClick"
        },

        render: function (e) {

            this.enableEvents();

            this.$el.addClass("rendered");
        },

        enableEvents: function () {
            //Remove previous events
            this.disableEvents();

            return this;
        },

        disableEvents: function () {
            return this;
        },

        onCloseClick: function (e) {
            if(e && e.preventDefault) e.preventDefault();

            this.$el.remove();

            return this;
        },
    });

    module.exports = ModuleCheckoutTableTotalAlertView;
});

define('views/PaymentMethodView',['require','exports','module','theme','backbone'],function (require, exports, module) {
    "use strict";

    // External dependencies.
    var theme = require("theme");
    var Backbone = require("backbone");

    var ModulePaymentMethodView = Backbone.View.extend({

        views: null,
        $inputs: null,
        $panels: null,
        initialize: function (options) {
            this.views = [];

            options = _.extend({}, this.$el.data(), options);

            this.el.modulePaymentMethodView = this;

            this.render();
        },

        events: {
            'change label input': "onChange"
        },

        render: function (e) {
            this.$inputs = this.$el.find("label input");
            this.$panels = $(".module-payment-method-panel");

            this.enableEvents();

            this.checkActiveLabels();

            this.$el.addClass("rendered");
        },

        enableEvents: function () {
            //Remove previous events
            this.disableEvents();

            return this;
        },

        disableEvents: function () {
            return this;
        },

        onChange: function (e) {
            this.checkActiveLabels();
        },

        checkActiveLabels: function (e) {
            var i;
            var imax = this.$inputs.length;
            var $input;
            var $label;
            var values = [];
            var value;
            var $panel;

            for (i = 0; i < imax; i++) {
                $input = this.$inputs.eq(i);
                $label = $input.closest("label")

                if ($input.prop("checked")) {
                    $label.addClass("active");

                    values.push($input.val() || "");
                } else {
                    $label.removeClass("active");
                }
            }

            this.$panels.removeClass("active");

            imax = values.length;
            for (i = 0; i < imax; i++) {
                value = values[i];

                if (value) {
                    $panel = this.$panels.filter(value);
                    $panel.addClass("active");
                }
            }
        },
    });

    module.exports = ModulePaymentMethodView;
});

define('views/CheckoutPrintItemView',['require','exports','module','theme','backbone'],function (require, exports, module) {
    "use strict";

    // External dependencies.
    var theme = require("theme");
    var Backbone = require("backbone");

    var ModuleCheckoutPrintItemView = Backbone.View.extend({

        views: null,
        $inputs: null,

        initialize: function (options) {
            this.views = [];

            options = _.extend({}, this.$el.data(), options);

            this.onInputChange = _.bind(this.onInputChange, this);
            this.checkChecked = _.bind(this.checkChecked, this);

            this.el.moduleCheckoutPrintItemView = this;

            this.render();
        },

        events: {
            'mouseenter .btn': "onMouseEnter",
            'mouseleave .btn': "onMouseLeave",
            'change .radio input': "onInputChange"
        },

        render: function (e) {
            this.enableEvents();

            this.checkChecked();

            this.$el.addClass("rendered");
        },

        enableEvents: function () {
            //Remove previous events
            this.disableEvents();


            return this;
        },

        disableEvents: function () {
            return this;
        },

        onMouseEnter: function (e) {
            this.activeHover();
        },

        onMouseLeave: function (e) {
            this.deactiveHover();
        },

        activeHover: function (e) {
            this.$el.addClass("hover");
        },

        deactiveHover: function (e) {
            this.$el.removeClass("hover");
        },

        onInputChange: function (e) {
            var $element = $(e.currentTarget);

            if (!$element.length) return;

            if ($element.prop("checked")) {
                this.$el.addClass("hover");

                var name = $element.attr("name");
                var $others = $('input[name="' + name + '"]').not($element);

                $others.trigger("change");
            } else {
                this.$el.removeClass("hover");
            }
        },

        checkChecked: function () {
            var $element = this.$el.find(".radio input");

            if (!$element.length) return;

            if ($element.prop("checked")) {
                this.$el.addClass("hover");

                var name = $element.attr("name");
                var $others = $('input[name="' + name + '"]').not($element);

                $others.trigger("change");
            } else {
                this.$el.removeClass("hover");
            }
        },
    });

    module.exports = ModuleCheckoutPrintItemView;
});

define('views/CheckoutNavigationView',['require','exports','module','theme','backbone'],function (require, exports, module) {
    "use strict";

    // External dependencies.
    var theme = require("theme");
    var Backbone = require("backbone");

    var ModuleCheckoutNavigationView = Backbone.View.extend({

        views: null,

        initialize: function (options) {
            this.views = [];

            options = _.extend({}, this.$el.data(), options);

            this.el.moduleCheckoutNavigationView = this;

            this.render();
        },

        events: {
            'change input': "onInputChange"
        },

        render: function (e) {
            this.enableEvents();

            this.$el.addClass("rendered");
        },

        enableEvents: function () {
            //Remove previous events
            this.disableEvents();


            return this;
        },

        disableEvents: function () {
            return this;
        },

        onInputChange: function (e) {
            var $input = $(e.currentTarget);

            var name = $input.attr("name");

            if (!name) return;

            var $others = $('[name="' + name + '"]').not($input);

            if ($input.prop("checked")) {
                $others.prop("checked", true);
            } else {
                $others.prop("checked", false);
            }
        },
    });

    module.exports = ModuleCheckoutNavigationView;
});

define('views/SelectDateView',['require','exports','module','theme','backbone'],function (require, exports, module) {
    "use strict";

    // External dependencies.
    var theme = require("theme");
    var Backbone = require("backbone");

    var ModuleSelectDateView = Backbone.View.extend({

        views: null,
        $inputs: null,
        initialize: function (options) {
            this.views = [];

            options = _.extend({}, this.$el.data(), options);

            this.el.moduleSelectDateView = this;

            this.render();
        },

        events: {
            'change label input': "onChange"
        },

        render: function (e) {
            this.$inputs = this.$el.find("label input");

            this.enableEvents();

            this.checkActiveLabels();

            this.$el.addClass("rendered");
        },

        enableEvents: function () {
            //Remove previous events
            this.disableEvents();

            return this;
        },

        disableEvents: function () {
            return this;
        },

        onChange: function (e) {
            this.checkActiveLabels();
        },

        checkActiveLabels: function (e) {
            var i;
            var imax = this.$inputs.length;
            var $input;
            var $label;

            for (i = 0; i < imax; i++) {
                $input = this.$inputs.eq(i);
                $label = $input.closest(".module-select-date-item")

                if ($input.prop("checked")) {
                    $label.addClass("active");
                } else {
                    $label.removeClass("active");
                }
            }
        },
    });

    module.exports = ModuleSelectDateView;
});

define('views/ModalMessagesView',['require','exports','module','theme','backbone','bowser','views/mixins/MixinModalView','events/ThemeEvent','models/UserModel'],function (require, exports, module) {
    'use strict';

    // External dependencies.
    var theme = require('theme');
    var Backbone = require('backbone');
    var bowser = require('bowser');

    var MixinModalView = require('views/mixins/MixinModalView');

    var ThemeEvent = require('events/ThemeEvent');
    var UserModel = require('models/UserModel');
    var userModel = new UserModel();


    var ModuleModalMessagesView = MixinModalView.extend({

        initialize: function (options) {
            this.options = _.extend({}, this.$el.data(), options);
            this.dates = null;

            this.render();
            this.addEventListeners();
        },

        render: function () {
            this._super();

            var html = '';

            this.$modalDialog = this.$('.modal-dialog');
            this.$modalContent = this.$('.modal-content');

            return this;
        },

        addEventListeners: function () {
            this._super();

            $(window).on(ThemeEvent.SHOW_AUTH_TOKEN_EXPIRED, _.bind(this.showAuthTokenExpired, this));
            this.listenTo(userModel, ThemeEvent.ERROR_UNKNOWN, this.onError);
        },

        onShowModal: function (e) {
            this._super();
            this.$modalContent.empty();
        },

        onShownModal: function (e) {
            this._super();
        },

        onHiddenModal: function (e) {
            this._super();
        },

        showAuthTokenExpired: function (e) {
            this.handleAuthTokenExpired();
        },

    });

    module.exports = ModuleModalMessagesView;
});

define('views/ModalLoginRegistrationView',['require','exports','module','theme','backbone','bowser','views/mixins/MixinModalView','events/ThemeEvent','models/UserModel'],function (require, exports, module) {
    'use strict';

    // External dependencies.
    var theme = require('theme');
    var Backbone = require('backbone');
    var bowser = require('bowser');

    var MixinModalView = require('views/mixins/MixinModalView');

    var ThemeEvent = require('events/ThemeEvent');
    var UserModel = require('models/UserModel');
    var userModel = new UserModel();


    var ModuleModalLoginRegistrationView = MixinModalView.extend({

        initialize: function (options) {
            this.options = _.extend({}, this.$el.data(), options);

            this.render();
            this.addEventListeners();

            // Wake up module after a minimum delay
            // to allow it be rendered from other Modules.
            _.delay(_.bind(this.wakeUp, this), 1);
        },

        render: function () {
            this._super();

            this.$modalContent = this.$('.modal-content');
            this.$moduleLoginRegistration = $('#module-login-registration');

            return this;
        },

        wakeUp: function () {
            this.detachModuleLoginRegistration();
        },

        detachModuleLoginRegistration: function () {
            this.$moduleLoginRegistration.removeClass('hidden').detach();
        },

        onShowModal: function (e) {
            this._super();

            this.$modalContent
                .empty()
                .append(this.$moduleLoginRegistration);

            // Resize wrapper to when the modal is visible (aprox.)
            _.delay(function() {
                $(window).trigger('module-login-resize-wrapper');
            }, 200);
        },

        onShownModal: function (e) {
            this._super();

            // Resize wrapper again to guarantee it will not be shrink.
            $(window).trigger('resize');
        },

        onHiddenModal: function (e) {
            this._super();
            this.detachModuleLoginRegistration();

            userModel.set('event', '');
            userModel.set('params', '');
        },

    });

    module.exports = ModuleModalLoginRegistrationView;
});

define('views/FeedbackView',['require','exports','module','backbone','events/ThemeEvent','models/UserModel'],function (require, exports, module) {
    'use strict';

    // External dependencies.
    var Backbone = require('backbone');

    var ThemeEvent = require('events/ThemeEvent');
    var UserModel = require('models/UserModel');
    var userModel = new UserModel();

    var ModuleFeedbackView = Backbone.View.extend({
        /**
         * Should be true after first resize.
         * This variable is used to hide the formContent once the website has loaded
         * and the height of the main container has been set.
         */
        formContentSetup: false,

        requiredInputSelector: 'input[required], textarea[required]',

        initialize: function (options) {
            this.resize = _.bind(this.resize, this);

            this.render();
            this.addEventListeners();
        },

        render: function () {
            this.$radios = this.$('.choice input[type="radio"]');
            this.$formContent = this.$('.form-input');
            this.$result = this.$('.result');
            this.$formWrapper = this.$('.form-wrapper');
            this.$form = this.$('.form-wrapper form');
            this.$formSubmitButton = this.$('.form-wrapper form .submit');
            this.$inputRemaining = this.$('.show-remaining');
            return this;
        },

        /**
         * Enable events
         */
        addEventListeners: function () {
            var thiz = this;

            this.$radios.each(function (index, el) {
                $(el).on('click', _.bind(thiz.toggleForms, thiz));
            });

            this.$form.on('submit', _.bind(this.sendForm, this));

            this.$inputRemaining.each(function (index, el) {
                $(el).on('input', _.bind(thiz.updateRemaining, thiz));
            });

            this.$form.find(this.requiredInputSelector).on('input', _.bind(thiz.toggleSubmitButton, thiz));
        },

        toggleSubmitButton: function () {
            if (this.checkRequired()) {
                this.enableButton(this.$formSubmitButton);
            } else {
                this.disableButton(this.$formSubmitButton);
            }
        },

        checkRequired: function () {
            var valid = true;
            this.$form.find(this.requiredInputSelector).each(function (index, el) {
                if ($(el).val() === '') {
                    valid = false;
                }
            });

            return valid;
        },

        enableButton: function ($el) {
            $el.removeClass('disabled');
            $el.removeClass('btn-grey');
            $el.addClass('btn-red');
            $el.prop('disabled', false);
        },
        
        disableButton: function ($el) {
            $el.addClass('disabled');
            $el.addClass('btn-grey');
            $el.removeClass('btn-red');
            $el.prop('disabled', true);
        },

        toggleForms: function (e) {
            if (e.currentTarget.dataset.noInput === 'true') {
                this.hideForm();
                this.enableButton(this.$formSubmitButton);
                this.$form.find(this.requiredInputSelector).each(function (index, el) {
                    if ($(el).val() === '') {
                        $(el).val('   ');
                    }
                });
            } else {
                this.$form.find(this.requiredInputSelector).each(function (index, el) {
                    if ($(el).val() === '   ') {
                        $(el).val('');
                        $(el).trigger('blur');
                    }
                });
                if (!this.checkRequired()) {
                    this.disableButton(this.$formSubmitButton);
                }
                this.expandForm();
            }
        },

        expandForm: function () {
            this.$formContent.addClass('expand');
        },

        hideForm: function () {
            this.$formContent.removeClass('expand');
        },

        updateRemaining: function (event) {
            var maxValue = parseInt($(event.currentTarget).attr('maxlength'));
            var value = $(event.currentTarget).val().length;
            $(event.currentTarget).siblings('.chars-remaining').find('.value').html(maxValue - value);
        },

        sendForm: function (event) {
            event.preventDefault();

            $.ajax({
                url: this.$form.attr('action'),
                method: 'POST',
                data: this.$form.serializeArray(),
                beforeSend: _.bind(function() {
                    this.$formSubmitButton.addClass('preloading');
                    this.disableButton(this.$formSubmitButton);
                }, this),
                success: $.proxy(function(response) {
                    if (response && response.status && response.status === 'success') {
                        this.showFeedback();
                    } else {
                        console.log(response);
                    }
                }, this),
                error: $.proxy(function(response) {
                    console.log(response);
                }, this),
            });
        },

        showFeedback: function () {
          var thiz = this;

          this.$formWrapper.fadeOut({
              done: function () {
                  thiz.$result.fadeIn()
                  thiz.confetti();
              }
          });
        },

        rnd: function (m, n) {
            return Math.floor( Math.random() * (n - m + 1) ) + m;
        },

        // copied from shop/js/gift-card.js
        confetti: function () {
            var thiz = this;
            $.each($('.particle-text.confetti'), function(){
                var count = ($(this).width() / 50) * 10;
                for (var i = 0; i <= count; i++) {
                    $(this).append('<span class="particle c' + thiz.rnd(1, 2) + '" style="top:' + thiz.rnd(10, 50) + '%; left:' + thiz.rnd(0, 100) + '%; width:' + thiz.rnd(6, 8) + 'px; height:' + thiz.rnd(3, 4) + 'px; animation-delay: ' + (thiz.rnd(0, 30) / 10) + 's;"></span>');
                }
            });
        },

        resize: function (e) {
            // load site with form content expanded,
            // so that the main container has the correct height.
            // opacity is 0 by default, so the form doesn't flash on page load,
            // so we set it back to 1 here, to display it later on.
            if (!this.formContentSetup) {
                this.formContentSetup = true;
                this.$formContent.attr('style', '--feedback-max-height: 0px;');
                this.$formContent.css('opacity', '1');
            }

            return this;
        },

    });

    module.exports = ModuleFeedbackView;
});

define('views/CatalogOrderView',['require','exports','module','backbone'],function (require, exports, module) {
    'use strict';

    // External dependencies.
    var Backbone = require('backbone');

    var ModuleCatalogOrderView = Backbone.View.extend({
        initialize: function (options) {
            this.resize = _.bind(this.resize, this);

            this.render();
            this.addEventListeners();
        },

        render: function () {
            this.$catalogOrderForm = this.$('form.catalog-order-form');
            this.$codeForm = this.$('form.code-form');
            this.$result = this.$('.result');
            this.$resendCodeBtn = this.$('.resend-code-btn');
            this.$backBtn = this.$('.back-btn');
            this.$msgFeedback = this.$('.msg-feedback');
            this.ajaxErrorDefaultText = $('#module-catalog-order-ajax-default-error').html();

            return this;
        },

        /**
         * Enable events
         */
        addEventListeners: function () {
            this.$resendCodeBtn.on('click', _.bind(this.resendCodeBtnClick, this));
            this.$backBtn.on('click', _.bind(this.backBtnClick, this));
            this.$catalogOrderForm.on('submit', _.bind(this.submitForm, this));
            this.$codeForm.on('submit', _.bind(this.submitForm, this));
        },

        resendCodeBtnClick: function (e) {
            e.preventDefault();

            if (!this.$resendCodeBtn.hasClass('loading')) {
                this.$resendCodeBtn.removeClass('complete').addClass('loading');
                this.submitForm(null, this.$catalogOrderForm);
            }
        },

        backBtnClick: function (e) {
            e.preventDefault();
            this.toggleForms(this.$catalogOrderForm);
            this.resetFriendlyCaptcha();
        },

        resetFriendlyCaptcha: function (e) {
            // Use this code to reset the captcha if you are sending the form per ajax.
            var elements = document.querySelectorAll('.frc-captcha');

            if (elements.length) {
                elements.forEach(function (el) {
                    el.friendlyChallengeWidget.reset();
                });
            }
        },

        submitForm: function (e, $form) {
            if (e) {
                e.preventDefault();
                $form = $(e.currentTarget);
            }

            $form.find('.was-validated').removeClass('was-validated is-invalid');
            $form.find('.help-msg.error').text('');
            this.$msgFeedback.addClass('hidden').removeClass('help-msg error').text('');

            $.ajax({
                url: $form.attr('action'),
                method: $form.attr('method'),
                data: $form.serializeArray(),
                success: $.proxy(function (response) {
                    if (response && response.status && response.status === 'success') {
                        if ($form.hasClass('catalog-order-form')) {
                            if (this.$resendCodeBtn.hasClass('loading')) {
                                _.delay(_.bind(function () {
                                    this.$resendCodeBtn.removeClass('loading').addClass('complete');
                                }, this), 1000);
                                _.delay(_.bind(function () {
                                    this.$resendCodeBtn.removeClass('complete');
                                }, this), 2000);
                            }
                            this.toggleForms(this.$codeForm, response);

                        } else if ($form.hasClass('code-form')) {
                            this.redirectTo($form.data('href'));
                        }
                    } else {
                        this.showErrors(response);
                    }
                }, this),
                error: $.proxy(function (response) {
                    this.showErrors(response);
                }, this),
            });
        },

        showErrors: function (response) {
            if (response && response.errors && response.errors.length) {
                response.errors.forEach(_.bind(function (field) {
                    this.$('[name="' + field.key + '"]').addClass('was-validated is-invalid');
                    this.$('[name="' + field.key + '"]').siblings('.help-msg.error').text(field.message);
                }, this));
            } else if (response && response.message) {
                this.$msgFeedback
                    .text(response.message)
                    .addClass('help-msg error')
                    .removeClass('hidden');
            } else {
                this.$msgFeedback
                    .text(this.ajaxErrorDefaultText)
                    .addClass('help-msg error')
                    .removeClass('hidden');
            }
        },

        toggleForms: function ($form, data) {
            if ($form.hasClass('code-form')) {
                this.$catalogOrderForm.find('[data-token="true"]').val(data.token);
                this.$catalogOrderForm.fadeOut({
                    done: _.bind(function () {
                        $form.find('input[type!="hidden"]').val('');
                        $form.find('[data-token="true"]').val(data.token);
                        $form.fadeIn();
                        this.scrollIntoView();
                    }, this)
                });
            } else if ($form.hasClass('catalog-order-form')) {
                this.$codeForm.fadeOut({
                    done: _.bind(function () {
                        $form.fadeIn();
                        this.scrollIntoView();
                    }, this)
                });
            }
        },

        showCodeForm: function () {
            this.$catalogOrderForm.fadeOut({
                done: _.bind(function () {
                    this.$result.fadeIn()
                }, this)
            });
        },

        redirectTo: function (url) {
            window.location.href = url;
        },

        scrollIntoView: function () {
            var y = this.el.getBoundingClientRect().top + window.scrollY - 145;

            if (y < window.scrollY) {
                window.scrollTo({
                    top: y,
                    behavior: "smooth",
                });
            }
        },

        resize: function (e) {
            return this;
        },

    });

    module.exports = ModuleCatalogOrderView;
});

/**
 * @version 1.0.2
 *
 * Provide a clock with several functions.
 */
(function (root, factory) {
    // Set up Constructor appropriately for the environment.
    if (typeof define === 'function' && define.amd) {
        // Start with AMD.
        define(
            'Clock',['exports'],
            function (exports) {
                return factory(root, exports);
            }
        );
    } else if (typeof exports !== 'undefined') {
        // Next for Node.js or CommonJS.
        factory(root, exports);
    } else {
        // Finally, as a browser global.
        root.Clock = factory(root, {});
    }
}(this, function (root, exports) {
    'use strict';

    /**
     * From underscore version '1.4.4' and backbone version '0.9.10'.
     * Allow us bind this.
     * Attaches event listeners and triggers.
     * Add possibility to create an instance where the initialize method will be called immediately.
     */
    var each = function (obj, iterator, context) {
        if (obj === null) return;
        if (Array.prototype.forEach && obj.forEach === Array.prototype.forEach) {
            obj.forEach(iterator, context);
        } else if (obj.length === +obj.length) {
            for (var i = 0, l = obj.length; i < l; i++) {
                if (iterator.call(context, obj[i], i, obj) === {}) return;
            }
        } else {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    if (iterator.call(context, obj[key], key, obj) === {}) return;
                }
            }
        }
    };

    function bind(func, context) {
        if (func.bind === Function.prototype.bind && Function.prototype.bind) return Function.prototype.bind.apply(func, Array.prototype.slice.call(arguments, 1));
        var args = Array.prototype.slice.call(arguments, 2);
        return function () {
            return func.apply(context, args.concat(Array.prototype.slice.call(arguments)));
        };
    }

    function bindAll(obj) {
        var funcs = Array.prototype.slice.call(arguments, 1);
        if (funcs.length === 0) funcs = functions(obj);
        each(funcs, function (f) {
            obj[f] = bind(obj[f], obj);
        });
        return obj;
    }

    function functions(obj) {
        var names = [];
        for (var key in obj) {
            if (typeof (obj[key]) === 'function') names.push(key);
        }
        return names.sort();
    }

    function extend(obj) {
        each(Array.prototype.slice.call(arguments, 1), function (source) {
            if (source) {
                for (var prop in source) {
                    obj[prop] = source[prop];
                }
            }
        });
        return obj;
    }

    function keys(obj) {
        if (typeof obj !== 'object') return [];
        if (nativeKeys) return nativeKeys(obj);
        var list = [];
        for (var key in obj)
            if (key in obj) list.push(key);
        return list;
    }

    function delay(func, wait) {
        var args = Array.prototype.slice.call(arguments, 2);
        return setTimeout(function () {
            return func.apply(null, args);
        }, wait);
    }

    var eventSplitter = /\s+/;

    var eventsApi = function (obj, action, name, rest) {
        if (!name) return true;
        if (typeof name === 'object') {
            for (var key in name) {
                obj[action].apply(obj, [key, name[key]].concat(rest));
            }
        } else if (eventSplitter.test(name)) {
            var names = name.split(eventSplitter);
            for (var i = 0, l = names.length; i < l; i++) {
                obj[action].apply(obj, [names[i]].concat(rest));
            }
        } else {
            return true;
        }
    };

    var triggerEvents = function (events, args) {
        var ev, i = -1,
            l = events.length;
        switch (args.length) {
        case 0:
            while (++i < l)(ev = events[i]).callback.call(ev.ctx);
            return;
        case 1:
            while (++i < l)(ev = events[i]).callback.call(ev.ctx, args[0]);
            return;
        case 2:
            while (++i < l)(ev = events[i]).callback.call(ev.ctx, args[0], args[1]);
            return;
        case 3:
            while (++i < l)(ev = events[i]).callback.call(ev.ctx, args[0], args[1], args[2]);
            return;
        default:
            while (++i < l)(ev = events[i]).callback.apply(ev.ctx, args);
        }
    };

    var Events = {
        on: function (name, callback, context) {
            if (!(eventsApi(this, 'on', name, [callback, context]) && callback)) return this;
            this._events = this._events || {};
            var list = this._events[name] || (this._events[name] = []);
            list.push({
                callback: callback,
                context: context,
                ctx: context || this
            });
            return this;
        },

        off: function (name, callback, context) {
            var list, ev, events, names, i, l, j, k;
            if (!this._events || !eventsApi(this, 'off', name, [callback, context])) return this;
            if (!name && !callback && !context) {
                this._events = {};
                return this;
            }

            names = name ? [name] : keys(this._events);
            for (i = 0, l = names.length; i < l; i++) {
                name = names[i];
                list = this._events[name];
                if (list) {
                    //if (list = this._events[name]) {
                    events = [];
                    if (callback || context) {
                        for (j = 0, k = list.length; j < k; j++) {
                            ev = list[j];
                            if ((callback && callback !== ev.callback && callback !== ev.callback._callback) || (context && context !== ev.context)) {
                                events.push(ev);
                            }
                        }
                    }
                    this._events[name] = events;
                }
            }

            return this;
        },

        trigger: function (name) {
            if (!this._events) return this;
            var args = Array.prototype.slice.call(arguments, 1);
            if (!eventsApi(this, 'trigger', name, args)) return this;
            var events = this._events[name];
            var allEvents = this._events.all;
            if (events) triggerEvents(events, args);
            if (allEvents) triggerEvents(allEvents, arguments);
            return this;
        }
    };

    ////////////////////////////////////////////////////////////////////
    // Clock
    ////////////////////////////////////////////////////////////////////

    /**
     * Create the Clock.
     */
    var Clock = function () {
        this.initialize.apply(this, arguments);
    };

    // Constructor.
    Clock.prototype.constructor = Clock;

    Clock.RESET = 'reset';
    Clock.ONE_SECOND_ELAPSED = 'one_second_elapsed';
    Clock.TIME_IS_UP = 'time_is_up';
    Clock.TIME_REMAINING_CONSUMED = 'time_remaining_consumed';

    /**
     * Extend Clock Prototype.
     */
    extend(Clock.prototype, Events, {

        // Clock options.
        _interval: 0, // The delay of setInterval.
        _direction: '', // 'cw' : clockwise | 'ccw' : counterclockwise.
        _format: '', // 'hh:mm:ss' | 'hh:mm' | 'mm:ss' | 's'.

        _timeStampStart: 0,
        _timerMilliseconds: 0,
        _timerMillisecondsRemaining: 0,
        _timerMillisecondsElapsed: 0,

        // Total units of time after setup.
        _totalHours: 0,
        _totalMinutes: 0,
        _totalSeconds: 0,

        // Control variables
        _timerStatus: '', // ('ticking' || 'paused' || 'stopped' || 'penalty' || 'bonus' || 'consuming')
        _timeIsUp: false,

        // Clock units.
        _hours: 0,
        _minutes: 0,
        _seconds: 0,
        _secondsBackup: 0,

        // Timers.
        _timer: -1, // interval
        _penaltyTimer: -1, // interval
        _bonusTimer: -1, // interval
        _consumeTimer: -1, // interval
        _timerPause: null, // Date

        // Bonus or penalties.
        _minusSeconds: 0,
        _plusSeconds: 0,
        _consumeSeconds: 0,
        _minusSecondsTotal: 0,
        _plusSecondsTotal: 0,
        _consumeSecondsTotal: 0,

        // The display.
        _clockDisplay: '',


        // #################################################################
        // #################################################################
        // #################################################################

        /**
         * The function called after a new instance has been created.
         *
         * @param {object} options
         */
        initialize: function (options) {
            bindAll(this);
            this.setup(options);
        },

        /**
         * Setup the clock.
         *
         * @param {object} options
         * @public
         */
        setup: function (options) {
            if (options) {
                this._direction = options.direction;
                this._format = options.format;
                this._interval = options.interval || 50;

                this._totalHours = Math.floor(options.seconds / 60 / 60);
                this._totalMinutes = Math.floor(options.seconds / 60) - (this._totalHours * 60);
                this._totalSeconds = options.seconds - ((this._totalMinutes * 60) + (this._totalHours * 3600));

                this.reset();
            }
        },

        /**
         * Start the clock.
         *
         * @public
         */
        start: function () {
            var date = new Date();
            this._timeStampStart = date.getTime();

            this._timerMilliseconds = date.getTime();
            this._timerMilliseconds += (this._totalHours * 60 * 60 * 1000); // Hours.
            this._timerMilliseconds += (this._totalMinutes * 60 * 1000); // Minutes.
            this._timerMilliseconds += (this._totalSeconds * 1000); // Seconds.

            this._secondsBackup = this._totalSeconds;
            this.startTimer();
        },

        /**
         * Pause the clock.
         *
         * @public
         */
        pause: function () {
            if (this._timerStatus === 'stopped' || this._timerStatus === 'paused') return;

            this._timerStatus = 'paused';
            this.stopAllTimers();
            this._timerPause = new Date();
        },

        /**
         * Resume the clock.
         *
         * @public
         */
        resume: function () {
            if (this._timerStatus !== 'paused') return;

            this.addPauseTime();
            this.startTimer();
        },

        /**
         * Stop the clock.
         *
         * @public
         */
        stop: function () {
            this._timerStatus = 'stopped';
            this.stopAllTimers();
        },

        /**
         * Apply a bonus.
         *
         * @param {Number} seconds The bonus to be applied.
         * @public
         */
        bonus: function (seconds) {
            if (!seconds) return;
            if (this._timeIsUp) return;

            if (this._timer === -1) {
                return;
            }
            if (this._timerStatus === 'paused') {
                return;
            }
            if (this._penaltyTimer !== -1) {
                this.reduceSeconds();
                this.reduceSecondsComplete();
            }
            if (this._bonusTimer !== -1) {
                this.addSeconds();
                this.addSecondsComplete();
            }

            this.pause();
            this._timerStatus = 'bonus';

            this._plusSeconds = 0;
            this._plusSecondsTotal = seconds;
            this._bonusTimer = setInterval(this.addSeconds, 25);
        },

        /**
         * Apply a penalty.
         *
         * @param {Number} seconds The penalty to be applied.
         * @public
         */
        penalty: function (seconds) {
            if (!seconds) return;
            if (this._timeIsUp) return;
            if (this._timer === -1) return;
            if (this._timerStatus === 'paused') return;
            if (this._penaltyTimer !== -1) {
                this.reduceSeconds();
                this.reduceSecondsComplete();
            }
            if (this._bonusTimer !== -1) {
                this.addSeconds();
                this.addSecondsComplete();
            }

            this.pause();
            this._timerStatus = 'penalty';

            this._minusSeconds = 0;
            this._minusSecondsTotal = Math.abs(seconds);
            this._penaltyTimer = setInterval(this.reduceSeconds, 25);
        },

        /**
         * Consume the time remaining.
         *
         * @param {Number} seconds In how many time must the timeRemaining be consumed.
         * @public
         */
        consume: function (seconds) {
            if (this._timeIsUp) return;
            if (this._timerMillisecondsRemaining <= 0) return;
            if (this._timerStatus !== 'stopped') return;
            if (this._timerStatus === 'consuming') return;
            if (this._consumeTimer !== -1) {
                this.consumeSeconds();
                this.consumeSecondsComplete();
            }

            this._timerStatus = 'consuming';

            var secondsTotal = Math.round(this._timerMillisecondsRemaining / 1000);

            seconds = seconds || 1;
            var interval = (seconds * 1000) / secondsTotal;

            this._consumeSeconds = 0;
            this._consumeSecondsTotal = secondsTotal;
            this._consumeTimer = setInterval(this.consumeSeconds, interval);
        },

        /**
         * Reset the clock.
         *
         * @public
         */
        reset: function () {
            this.stop();
            this._timerMillisecondsRemaining = this.getMillisecondsTotal();
            this._timerMillisecondsElapsed = 0;

            this._timeIsUp = false;

            if (this._direction === 'cw') {
                this.updateClockDisplay(0, 0, 0);
            } else {
                this.updateClockDisplay(this._totalHours, this._totalMinutes, this._totalSeconds);
            }

            this.trigger(Clock.RESET, {
                type: Clock.RESET
            });
        },

        /**
         * Get formated time.
         *
         * @return {String}
         * @public
         */
        getClockDisplay: function () {
            return this._clockDisplay;
        },

        /**
         * Get the current status of the timer.
         *
         * @param {Number} seconds The bonus to be applied.
         * @public
         */
        getTimerStatus: function () {
            return this._timerStatus;
        },

        /**
         * Get the milliseconds total.
         *
         * @return {Number}
         * @public
         */
        getMillisecondsTotal: function () {
            var milliseconds = 0;
            milliseconds += (this._totalHours * 60 * 60 * 1000); // Hours.
            milliseconds += (this._totalMinutes * 60 * 1000); // Minutes.
            milliseconds += (this._totalSeconds * 1000); // Seconds.

            return milliseconds;
        },

        /**
         * Get time elapsed.
         *
         * @return {Number}
         * @public
         */
        getTimeElapsed: function () {
            return this._timerMillisecondsElapsed;
        },

        /**
         * Get time remaining.
         *
         * @return {Number}
         * @public
         */
        getTimeRemaining: function () {
            return this._timerMillisecondsRemaining;
        },

        // #################################################################

        /**
         * Add the time paused after penalties or bonus.
         *
         * @private
         */
        addPauseTime: function () {
            var date = new Date();
            this._timeStampStart += date.getTime() - this._timerPause.getTime();
            this._timerMilliseconds += date.getTime() - this._timerPause.getTime();
        },

        /**
         * Add seconds when applying bonus.
         *
         * @private
         */
        addSeconds: function (e) {
            if (this._direction === 'cw') {
                if (this._timerMillisecondsElapsed > 0) {
                    this._plusSeconds++;
                    this._timerMillisecondsRemaining += 1000;
                    this._timerMillisecondsElapsed -= 1000;
                }

                if (this._timerMillisecondsElapsed < 0) {
                    this._timerMillisecondsElapsed = 0;
                }

                this._hours = Math.floor(this._timerMillisecondsElapsed / 1000 / 60 / 60);
                this._minutes = Math.floor(this._timerMillisecondsElapsed / 1000 / 60) - (this._hours * 60);
                this._seconds = Math.round(this._timerMillisecondsElapsed / 1000) - ((this._minutes * 60) + (this._hours * 3600));
            } else if (this._direction === 'ccw') {
                this._plusSeconds++;

                this._timerMillisecondsRemaining += 1000;
                this._timerMillisecondsElapsed -= 1000;

                if (this._timerMillisecondsElapsed < 0) {
                    this._timerMillisecondsElapsed = 0;
                }

                this._hours = Math.floor(this._timerMillisecondsRemaining / 1000 / 60 / 60);
                this._minutes = Math.floor(this._timerMillisecondsRemaining / 1000 / 60) - (this._hours * 60);
                this._seconds = Math.round(this._timerMillisecondsRemaining / 1000) - ((this._minutes * 60) + (this._hours * 3600));
            }

            this.updateUnits();
            this.fixTimer();
            this.tick();

            if ((this._direction === 'cw' && this._timerMillisecondsElapsed === 0) || this._plusSeconds === this._plusSecondsTotal) {
                this.addSecondsComplete();
            }
        },

        /**
         * The seconds were added, the timer must be started again.
         *
         * @private
         */
        addSecondsComplete: function () {
            if (this._bonusTimer) clearInterval(this._bonusTimer, this._bonusTimer = -1);

            this._timeStampStart += (this._plusSeconds * 1000);
            this._timerMilliseconds += (this._plusSeconds * 1000);

            this._plusSeconds = 0;

            this.startTimer();
        },

        /**
         * Reduce seconds when applying penalties.
         *
         * @private
         */
        reduceSeconds: function (e) {
            this._minusSeconds++;

            this._timerMillisecondsRemaining -= 1000;
            this._timerMillisecondsElapsed += 1000;

            this.updateUnits();
            this.fixTimer();
            this.tick();

            if (this._minusSeconds === this._minusSecondsTotal) {
                this.reduceSecondsComplete();
            }
        },

        /**
         * The seconds were reduced, the timer must be started again.
         *
         * @private
         */
        reduceSecondsComplete: function () {
            if (this._penaltyTimer !== -1) clearInterval(this._penaltyTimer, this._penaltyTimer = -1);

            this.addPauseTime();

            this._timeStampStart -= (this._minusSeconds * 1000);
            this._timerMilliseconds -= (this._minusSeconds * 1000);

            this._minusSeconds = 0;

            this.startTimer();
        },


        /**
         * Consume seconds when stopped.
         *
         * @private
         */
        consumeSeconds: function (e) {
            this._consumeSeconds++;

            this._timerMillisecondsRemaining -= 1000;
            this._timerMillisecondsElapsed += 1000;

            this.updateUnits();
            this.fixTimer();
            this.tick();

            if (this._consumeSeconds === this._consumeSecondsTotal) {
                this._timerMillisecondsRemaining = 0;
                this._timerMillisecondsElapsed = this.getMillisecondsTotal();
                this.consumeSecondsComplete();
            }
        },

        /**
         * The seconds were consumed.
         *
         * @private
         */
        consumeSecondsComplete: function () {
            if (this._consumeTimer !== -1) clearInterval(this._consumeTimer, this._consumeTimer = -1);

            this._consumeSeconds = 0;

            this.trigger(Clock.TIME_REMAINING_CONSUMED, {
                type: Clock.TIME_REMAINING_CONSUMED
            });
            this.stop();
        },

        /**
         * The loop that will be called after every `_interval`.
         *
         * @private
         */
        loop: function (e) {
            if (this._timeIsUp) {
                this.stopAllTimers();
                return;
            }

            var date = new Date();
            this._timerMillisecondsRemaining = this._timerMilliseconds - date.getTime();
            this._timerMillisecondsElapsed = date.getTime() - this._timeStampStart;

            if (this._timerMillisecondsElapsed < 0) {
                this._timerMillisecondsElapsed = 0;
            }

            this.updateUnits();
            this.fixTimer();
            this.tick();
        },

        /**
         * Update the time units of the clock.
         *
         * @private
         */
        updateUnits: function () {
            if (this._direction === 'cw') {
                this._hours = Math.floor(this._timerMillisecondsElapsed / 1000 / 60 / 60);
                this._minutes = Math.floor(this._timerMillisecondsElapsed / 1000 / 60) - (this._hours * 60);
                this._seconds = Math.round(this._timerMillisecondsElapsed / 1000) - ((this._minutes * 60) + (this._hours * 3600));
            } else if (this._direction === 'ccw') {
                this._hours = Math.floor(this._timerMillisecondsRemaining / 1000 / 60 / 60);
                this._minutes = Math.floor(this._timerMillisecondsRemaining / 1000 / 60) - (this._hours * 60);
                this._seconds = Math.round(this._timerMillisecondsRemaining / 1000) - ((this._minutes * 60) + (this._hours * 3600));
            }
        },

        /**
         * Fix the time units and update seconds and minutes to avoid values like this: 00:60:60.
         *
         * @private
         */
        fixTimer: function () {
            if (this._format !== 's') {
                if (this._minutes === 60) {
                    this._minutes = 0;
                    this._hours++;
                }

                if (this._seconds === 60) {
                    this._seconds = 0;
                    this._minutes++;
                }
            }

            if (this._hours < 0 || this._minutes < 0 || this._seconds < 0) {
                this._hours = 0;
                this._minutes = 0;
                this._seconds = 0;
            }
        },

        /**
         * The tic-tac of the clock.
         *
         * @private
         */
        tick: function () {
            if (this._timeIsUp) {
                return;
            }

            if (this._timerMillisecondsRemaining <= 0) {
                this._timeIsUp = true;
                this.stop();
                this._timerMillisecondsRemaining = 0;
                this._timerMillisecondsElapsed = this.getMillisecondsTotal();
                
                if (this._direction === 'cw') {
                    this.updateClockDisplay(this._totalHours, this._totalMinutes, this._totalSeconds);
                } else {
                    this.updateClockDisplay(0, 0, 0);
                }

                if (this._timerStatus !== 'consuming') {
                    this.trigger(Clock.TIME_IS_UP, {
                        type: Clock.TIME_IS_UP
                    });
                }
            } else {
                this.updateClockDisplay(this._hours, this._minutes, this._seconds);
            }

            if (this._seconds !== this._secondsBackup) {
                this.trigger(Clock.ONE_SECOND_ELAPSED, {
                    type: Clock.ONE_SECOND_ELAPSED
                });
            }

            this._secondsBackup = this._seconds;
        },

        /**
         * Start the internal timer of the clock.
         *
         * @private
         */
        startTimer: function () {
            if (this._timer !== -1) clearInterval(this._timer, this._timer = -1);

            this._timerStatus = 'ticking';
            this._timer = setInterval(this.loop, this._interval);
        },

        /**
         * Stop all the internal timers of the clock, including the penalty and bonus timers.
         *
         * @private
         */
        stopAllTimers: function () {
            if (this._timer !== -1) clearInterval(this._timer, this._timer = -1);
            if (this._penaltyTimer !== -1) clearInterval(this._penaltyTimer, this._penaltyTimer = -1);
            if (this._bonusTimer !== -1) clearInterval(this._bonusTimer, this._bonusTimer = -1);
            if (this._consumeTimer !== -1) clearInterval(this._consumeTimer, this._consumeTimer = -1);
        },

        /**
         * Update the display of the clock according to `_format`.
         
         * @param {Number} hh Hours.
         * @param {Number} mm Minutes.
         * @param {Number} ss Seconds.
         * @private
         */
        updateClockDisplay: function (hh, mm, ss) {
            var display = '';
            var count;

            if (!/:/.test(this._format)) {
                display = ss + mm * 60 + hh * 3600;
                display = String(display);
                count = this._format.match(/s/g);
                if (count && count.length > display.length) {
                    display = this.fillWithZeros(display, count.length);
                }
            } else {
                if (this._format.indexOf('h') >= 0) {
                    hh = String(hh);
                    count = this._format.match(/h/g);
                    if (count && count.length > hh.length) {
                        hh = this.fillWithZeros(hh, count.length);
                    }

                    display += hh;
                    if (/h:/.test(this._format)) {
                        display += ':';
                    }
                }
                if (this._format.indexOf('m') >= 0) {
                    mm = String(mm);
                    count = this._format.match(/m/g);
                    if (count && count.length > mm.length) {
                        mm = this.fillWithZeros(mm, count.length);
                    }

                    display += mm;
                    if (/m:/.test(this._format)) {
                        display += ':';
                    }
                }
                if (this._format.indexOf('s') >= 0) {
                    ss = String(ss);
                    count = this._format.match(/s/g);
                    if (count && count.length > ss.length) {
                        ss = this.fillWithZeros(ss, count.length);
                    }

                    display += ss;
                }
            }

            this._clockDisplay = display;
        },

        /**
         * Simple formatted time from milliseconds.
         * Caution! Wraps at next unit. (90402, ss:ms) => 30.402
         *
         * @param  {Number} ms
         * @param  {String} timeFormat default: hh:mm:ss
         * @return {String}
         */
        formatTime: function (ms, timeFormat) {
            var format = timeFormat || 'hh:mm:ss';
            var display = '';
            var date = new Date(ms);

            var hours, minutes, seconds, miliseconds;
            
            // Format
            if (format === 'hh:mm:ss.ms' || format === 'hh:mm:ss') {
                hours = ('0' + (date.getUTCHours())).slice(-2);
                minutes = ('0' + date.getUTCMinutes()).slice(-2);
                seconds = ('0' + date.getUTCSeconds()).slice(-2);
                
                display = hours + ':' + minutes + ':' + seconds;
            } else if (format === 'mm:ss.ms' || format === 'mm:ss') {
                hours = date.getUTCHours();
                minutes = hours * 60 + date.getUTCMinutes();
                minutes = (minutes >= 10) ? minutes : '0' + minutes;
                seconds = ('0' + date.getUTCSeconds()).slice(-2);
                
                display = minutes + ':' + seconds;
            } else if (format === 'ss.ms' || format === 'ss' || format === 's.ms' || format === 's') {
                hours = date.getUTCHours();
                minutes = date.getUTCMinutes();
                seconds = hours * 60 * 60 + minutes * 60 + date.getUTCSeconds();
                seconds = (seconds >= 10) ? seconds : '0' + seconds;
                
                display = seconds;
            }
            
            if (/ms/.test(timeFormat)) {
                miliseconds = ('00' + date.getUTCMilliseconds()).slice(-3);
                if (/s\./.test(timeFormat) || ms >= 1000) {
                    display += '.' + miliseconds;
                } else {
                    display += miliseconds;
                }
            }

            return display;
        },


        /**
         * Put zeros on the left, i.e. when the value is smaller the 10.
         *
         * @param {Number} num The input number.
         * @param {Number} zeros The total of zeros to be added.
         * @return {String}
         * @private
         */
        fillWithZeros: function (num, zeros) {
            var str = '';
            for (var i = 0; i < zeros; i++) {
                str += '0';
            }

            str = str + String(num);
            var zeroStr = str.substr(-zeros, str.length);

            return zeroStr;
        },

        // #################################################################
        /**
         * Clear the clock and internal timers.
         *
         * @public
         */
        dispose: function () {
            this.stop();
        }
    });

    // Usage:
    // 
    // Event handler (function to be called when seconds elapse):
    // function clockHandler(e)
    // {
    //    msg = "";
    //    if (e) msg += (e.type + "\n");
    //    msg += ('timerStatus: ' + clock.getTimerStatus() + "\n");
    //    msg += ('millisecondsTotal: ' + clock.getMillisecondsTotal() + "\n");
    //    msg += ('timeRemaining: ' + clock.getTimeRemaining() + "\n");
    //    msg += ('timeElapsed: ' + clock.getTimeElapsed() + "\n");
    //    msg += ('clockDisplay: ' + clock.getClockDisplay() + "\n");
    //    console.log(msg);
    // }
    // 
    // Instantiating:
    // var clock = new Clock({direction:'ccw', format: 's', seconds:120});
    // 
    // Adding listeners:
    // clock.on(Clock.ONE_SECOND_ELAPSED, clockHandler);
    // clock.on(Clock.TIME_IS_UP, clockHandler);
    // clock.on(Clock.TIME_REMAINING_CONSUMED, clockHandler);
    // 
    // Removing listeners:
    // clock.off(Clock.ONE_SECOND_ELAPSED, clockHandler);
    // clock.off(Clock.TIME_IS_UP, clockHandler);
    // clock.off(Clock.TIME_REMAINING_CONSUMED, clockHandler);
    // 
    // Controling the clock:
    // clock.start()
    // clock.bonus(5);
    // clock.penalty(5);
    // clock.pause();
    // clock.resume();
    // clock.stop();
    // clock.consume();
    // clock.reset();
    // clock.dispose();
    // 
    // Manual call of callback function to refresh display.
    // Needed after creating the clock and after calling the `pause` or `reset` methods.
    // clockHandler();
    // 
    // Extending the `Clock` class:
    // clock = _.extend({extendedProperty: 'test', extendedMethod: function (){console.log('works!');}}, Clock);

    return Clock;
}));
define('views/NewBornRegisterView',['require','exports','module','backbone','events/ThemeEvent','Clock'],function (require, exports, module) {
    'use strict';

    // External dependencies.
    var Backbone = require('backbone');
    var ThemeEvent = require('events/ThemeEvent');

    var Clock = require('Clock');

    var ModuleNewBornRegisterView = Backbone.View.extend({

        initialize: function (options) {
            this.zipcodeIsValid = false;
            this.resize = _.bind(this.resize, this);

            this.render();
            this.collectedFormData = {};

            this.addEventListeners();
            this.addZipcodeEventListeners();

            this.countdownVariables();
        },

        countdownVariables: function () {
            this.countdownWrapper = this.$el.find('.countdown-wrapper');
            this.countdownTimer = this.countdownWrapper.find('#countdown-timer');
            this.countdownTimeUp = this.countdownWrapper.find('.countdown-timeup');
        },

        startCountdown: function () {
            var countdownMinutes = parseInt(this.countdownTimer.data('countdown-in-minutes'), 10 || 15);
            var countdownSeconds = countdownMinutes * 60;

            this.initCountdown({
                seconds: countdownSeconds
            });

            this.clock.start();
            this.clock.trigger(Clock.ONE_SECOND_ELAPSED);
        },

        initCountdown: function (options) {
            if (this.clock) {
                this.clock.stop();
            }

            var clock = new Clock({
                direction: 'ccw',
                format: 'mm:ss',
                seconds: options.seconds
            });

            clock.on(Clock.ONE_SECOND_ELAPSED, _.bind(this.updateCountdown, this));
            clock.on(Clock.TIME_IS_UP, _.bind(this.handleTimeUp, this));

            this.clock = clock;
        },

        updateCountdown: function () {
            var clock = this.clock;
            var timeRemaining = clock.getClockDisplay().split(':');
            var minutes = timeRemaining[0];
            var seconds = timeRemaining[1];

            this.$el.find('.minutes').text(minutes);
            this.$el.find('.seconds').text(seconds);
        },

        handleTimeUp: function () {
            this.countdownTimeUp.fadeIn();
            this.clock.stop();
        },

        collectFormData: function (form) {
            var formDataArray = form.serializeArray();

            for (var i = 0; i < formDataArray.length; i++) {
                if (formDataArray[i].value !== '') {
                    this.collectedFormData[formDataArray[i].name] = formDataArray[i].value;
                }
            }
        },

        render: function () {
            this.forms = this.$el.find('form').map(function (i, form) {
                return $(form);
            }).get();

            this.$backBtn = this.$el.find('.back-btn');
            this.$resendCodeBtn = this.$el.find('.resend-code-btn');

            this.initFormChild();
        },

        initFormChild: function () {
            this.$formChild = this.forms.filter(function (form, i) {
                return $(form).data('has-children');
            })[0];

            this.$formChild.find('.child-wrapper').first().find('select.needs-validation').attr('required', 'true');

            this.$addChildBtn = this.$el.find('#add-child-wrapper');
        },

        checkFormValidity: function ($form) {
            return $form[0].checkValidity();
        },

        toggleSubmitButton: function ($form, isValidZip) {
            var $submitButton = $form.find('button[type="submit"]');
            var formIsValid = this.checkFormValidity($form) && (isValidZip !== false);

            if (formIsValid) {
                $submitButton.removeClass('disabled');
                $submitButton.removeClass('btn-grey');
                $submitButton.prop('disabled', false);

            } else {
                $submitButton.addClass('disabled');
                $submitButton.addClass('btn-grey');
                $submitButton.prop('disabled', true);
            }
        },

        handleFormSubmission: function ($form) {
            var currentStep = parseInt($form.data('step'));

            if (currentStep < this.forms.length - 1) {
                this.collectFormData($form);
                this.showForm(currentStep + 1);

            } else {
                this.submitFormWithAjax($form, currentStep);
            }
        },

        submitFormWithAjax: function ($form, step) {
            var formData;
            var $submitButton = $form.find('button[type="submit"]');

            $submitButton.addClass('disabled');
            $submitButton.addClass('btn-grey');
            $submitButton.prop('disabled', true);

            if ($form.data('send-code')) {
                formData = new FormData();

                this.collectFormData($form);

                for (var key in this.collectedFormData) {
                    if (this.collectedFormData.hasOwnProperty(key)) {
                        formData.append(key, this.collectedFormData[key]);
                    }
                }

                this.startCountdown();
            } else {
                formData = new FormData();

                $form.find('input').each(function () {
                    var $this = $(this);
                    if ($this.attr('name')) {
                        formData.append($this.attr('name'), $this.val());
                    }
                });
            }

            $.ajax({
                url: $form.attr('action'),
                method: $form.attr('method'),
                data: formData,
                contentType: false,
                processData: false,
                success: $.proxy(function (response) {
                    if (response && response.status && response.status === 'success') {

                        if ($form.data('send-code') && step === parseInt($form.data('step'))) {
                            this.showForm(step + 1);
                            this.$el.find('[data-token="true"]').val(response.token);

                        } else if (step === this.forms.length) {
                            if ($form.data('href')) {
                                this.redirectTo($form.data('href'));
                            } else {
                                if (this.$resendCodeBtn.hasClass('loading')) {
                                    _.delay(_.bind(function () {
                                        this.$resendCodeBtn.removeClass('loading').addClass('complete');
                                    }, this), 1000);
                                    _.delay(_.bind(function () {
                                        this.$resendCodeBtn.removeClass('complete');
                                    }, this), 2000);
                                }
                            }
                        }
                    } else {
                        this.showErrors(response);
                    }
                }, this),
                error: $.proxy(function (response) {
                    this.showErrors(response);
                }, this),
                complete: $.proxy(function () {
                    _.delay(_.bind(function () {
                        $submitButton.removeClass('disabled');
                        $submitButton.removeClass('btn-grey');
                        $submitButton.prop('disabled', false);
                    }, this), 1000);
                }, this),
            });
        },

        addEventListeners: function () {
            $.each(this.forms, _.bind(function (i, $form) {

                $form.on('input change blur', '[required], [name]', _.bind(function () {
                    var isZipValid = ($form.data('step') == 1) ? this.zipcodeIsValid : undefined;
                    this.toggleSubmitButton($form, isZipValid);
                }, this));

                $form.on('submit', _.bind(function (event) {
                    event.preventDefault();

                    if (this.checkFormValidity($form)) {
                        this.handleFormSubmission($form);
                    }
                }, this));
            }, this));

            this.$resendCodeBtn.on('click', _.bind(this.resendCodeBtnClick, this));
            this.$backBtn.on('click', _.bind(this.backBtnClick, this));

            this.$addChildBtn.on('click', _.bind(this.addChildBtnClick, this));
        },

        addZipcodeEventListeners: function () {
            var $zipcodeCheck = this.$el.find('.module-zipcode-check');
            var $formZipcodeCheck = $zipcodeCheck.closest('form');

            $zipcodeCheck.on(ThemeEvent.CHECK_ZIP_COMPLETE, _.bind(function () {
                this.zipcodeIsValid = true;
                this.toggleSubmitButton($formZipcodeCheck, this.zipcodeIsValid);

                var $zipcode = this.$el.find('[name="zipcode"]');
                $zipcode.val($formZipcodeCheck.find('[name="zipcode"]').val()).parent().addClass('has-focus');

                var country = this.$('[name="country"] :selected').text();
                var $country = this.$el.find('[name="country-text"]');
                $country.val(country).parent().addClass('has-focus');

                _.debounce(function () {
                    $country.trigger('input').parent().removeClass('has-focus');
                }, 10);
            }, this));

            $zipcodeCheck.on(ThemeEvent.CHECK_ZIP_UNVERIFYED, _.bind(function () {
                this.zipcodeIsValid = false;
                this.toggleSubmitButton($formZipcodeCheck, this.zipcodeIsValid);
            }, this));
        },

        showForm: function (step, toBackView) {
            var $formToHide, $formToShow;

            if (toBackView) {
                $formToHide = this.$el.find('form[data-step="' + step + '"]');
                $formToShow = this.$el.find('form[data-step="' + (step - 1) + '"]');
            } else {
                $formToHide = this.$el.find('form[data-step="' + (step - 1) + '"]');
                $formToShow = this.$el.find('form[data-step="' + step + '"]');
            }

            $formToHide.fadeOut({
                done: _.bind(function () {
                    $formToShow.fadeIn();
                }, this)
            });
        },

        resendCodeBtnClick: function (e) {
            e.preventDefault();

            if (!this.$resendCodeBtn.hasClass('loading')) {
                this.$resendCodeBtn.removeClass('complete').addClass('loading');

                var $formSendCode = this.forms.filter(function (form, index) {
                    return $(form).data('send-code') === true;
                })[0];

                this.submitFormWithAjax($formSendCode, parseInt($formSendCode.data('step') + 1));
            }

            this.startCountdown();
            this.countdownTimeUp.fadeOut();
        },

        backBtnClick: function (e) {
            e.preventDefault();

            this.showForm(this.$el.find('form:visible').attr('data-step'), true);
            this.resetFriendlyCaptcha();
        },

        addChildBtnClick: function (e) {
            e.preventDefault();
            var $babyWrapper = this.$formChild.find('.baby-wrapper');

            this.$addChildBtn.fadeOut({
                done: _.bind(function () {
                    $babyWrapper.fadeIn();
                }, this)
            });
        },

        resetFriendlyCaptcha: function (e) {
            // Use this code to reset the captcha if you are sending the form per ajax.
            var elements = document.querySelectorAll('.frc-captcha');

            if (elements.length) {
                elements.forEach(function (el) {
                    el.friendlyChallengeWidget.reset();
                });
            }
        },

        showErrors: function (response) {
            if (response && response.errors && response.errors.length) {
                response.errors.forEach(_.bind(function (field) {
                    this.$('[name="' + field.key + '"]').addClass('was-validated is-invalid');
                    this.$('[name="' + field.key + '"]').siblings('.help-msg.error').text(field.message);
                }, this));
            } else if (response && response.message) {
                this.$msgFeedback
                    .text(response.message)
                    .addClass('help-msg error')
                    .removeClass('hidden');
            } else {
                this.$msgFeedback
                    .text(this.ajaxErrorDefaultText)
                    .addClass('help-msg error')
                    .removeClass('hidden');
            }
        },

        redirectTo: function (url) {
            window.location.href = url;
        },

        resize: function (e) {
            return this;
        },
    });

    module.exports = ModuleNewBornRegisterView;
});

define('views/ForgotPwStandAloneView',['require','exports','module','backbone','events/ThemeEvent','models/UserModel'],function (require, exports, module) {
    'use strict';

    // External dependencies.
    var Backbone = require('backbone');

    var ThemeEvent = require('events/ThemeEvent');
    var UserModel = require('models/UserModel');
    var userModel = new UserModel();

    var ModuleForgotPwStandAloneView = Backbone.View.extend({
        actions: [
            'forgot-password',
        ],

        /**
         * The payload params given through the constructor.
         */
        options: null,

        /**
         * true if loading submit form data.
         */
        loading: false,

        /**
         * The text for forgot pw success.
         */
        msgForgotPwSuccess: '',

        /**
         * The text for unauthorized access.
         */
        msgUnauthorized: '',

        /**
         * The text for an unknown error.
         */
        msgUnknownError: '',

        /**
         * The container for all steps.
         */
        $wrapper: null,

        /**
         * Feedback container.
         */
        $feedback: null,

        /**
         * Recaptcha key.
         */
        recaptchaKey: '',

        initialize: function (options) {
            this.options = _.extend({}, this.$el.data(), options);
            this.submitForm = _.bind(this.submitForm, this);
            this.resize = _.bind(this.resize, this);

            this.render();
            this.addEventListeners();
            this.setFocus();
        },

        render: function () {
            this.msgForgotPwSuccess = $(this.options.templateMsgForgotPwSuccess).text();
            this.msgUnauthorized = $(this.options.templateMsgForgotPwSuccess).text();
            this.msgUnknownError = $(this.options.templateMsgUnknownError).text();
            this.msgErrorOverride = this.options.templateMsgErrorOverride;

            this.$form = this.$('form');
            this.$email = this.$('#email');
            this.$submitBtn = this.$('button[type="submit"]');

            this.recaptchaKey = $('#grecaptcha').data('key') || '';

            this.$el.addClass('rendered');

            return this;
        },

        /**
         * Enable events
         */
        addEventListeners: function () {
            this.$form.on('submit', _.bind(this.submitForm, this));
            this.$email.on('input', _.bind(this.checkEmail, this));

            this.listenTo(userModel, 'change:user', this.onUserChange);
            this.listenTo(userModel, ThemeEvent.FORGOT_PASSWORD_COMPLETE, this.onForgotPasswordComplete);
            this.listenTo(userModel, ThemeEvent.ERROR_UNKNOWN, this.onError);
            this.listenTo(userModel, ThemeEvent.ERROR_UNAUTHORIZED, this.onError);
        },

        setFocus: function (selector) {
            _.delay(_.bind(function () {
                this.$email[0].focus();
            }, this), 250);
        },

        checkEmail: function (e) {
            if (this.$email.is(':valid')) {
                this.$submitBtn.removeClass('disabled').removeProp('disabled');
            } else {
                this.$submitBtn.addClass('disabled').attr('disabled', 'disabled');
            }
        },

        submitForm: function (e) {
            var data = null;

            if (e && e.preventDefault) e.preventDefault();
            if (userModel.loadingLogin) return;

            this.emptyFeedback();

            if (this.recaptchaKey) {
                this.recaptcha();
            } else {
                this.forgotPassword();
            }
        },

        recaptcha: function () {
            grecaptcha.ready(_.bind(function() {
                grecaptcha.execute(this.recaptchaKey, {action: 'submit'}).then(_.bind(function(token) {
                    this.$('input[name="recaptcha-token"]').val(token);
                    this.forgotPassword();
                }, this));
            }, this));
        },

        forgotPassword: function (e) {
            userModel.set('moduleLoginActive', this);

            var data = this.$form.serializeArray();
            userModel.forgotPassword(data);
        },

        onForgotPasswordComplete: function (e) {
            if (userModel.get('moduleLoginActive') !== this) return;

            this.$submitBtn.addClass('hidden');
            this.renderFeedback(this.msgForgotPwSuccess, 'success');
        },

        onError: function (e) {
            if (userModel.get('moduleLoginActive') !== this) return;
            if (!userModel.hasAction(this.actions, e.action)) return;

            var msg = this.fetchMsgError(e.response);

            this.renderFeedback(msg, 'error');
        },

        fetchMsgError: function (response) {
            var msg = '',
                msgOverride = this.msgErrorOverride;

            if (response && response.code && msgOverride && msgOverride[String(response.code)] && $(msgOverride[String(response.code)]).length) {
                msg = $(msgOverride[response.code]).text();
            } else if (response && response.message) {
                msg = response.message;
            } else {
                msg = this.msgUnknownError;
            }

            return msg;
        },

        emptyFeedback: function () {
            var $feedback = this.$('.feedback');
            $feedback.empty().removeClass('success error');
        },

        renderFeedback: function (msg, type) {
            var $feedback = this.$('.feedback');

            this.emptyFeedback();
            $feedback.append(msg).addClass(type);
        },

        resize: function (e) {
            return this;
        },

    });

    module.exports = ModuleForgotPwStandAloneView;
});

define('views/ModalAddToCartView',['require','exports','module','theme','backbone','bowser','views/mixins/MixinModalView','events/ThemeEvent','models/UserModel'],function (require, exports, module) {
    'use strict';

    // External dependencies.
    var theme = require('theme');
    var Backbone = require('backbone');
    var bowser = require('bowser');

    var MixinModalView = require('views/mixins/MixinModalView');

    var ThemeEvent = require('events/ThemeEvent');
    var UserModel = require('models/UserModel');
    var userModel = new UserModel();


    var ModuleModalAddToCartView = MixinModalView.extend({

        /**
         * The tigger to be used when fetching recommended products.
         */
        trigger: 'cart',

        /**
         * The actions this view is interested in.
         */
        actions: [
            'add-to-cart',
            'fetch-recommended-products',
        ],

        /**
         * Load recommended products.
         */
        loadRecommended: true,

        initialize: function (options) {
            this.options = _.extend({}, this.$el.data(), options);

            this.loadCard = false;
            this.render();
            this.addEventListeners();
        },

        render: function () {
            this._super();

            this.$modalContent = this.$('.modal-content');
            this.$moduleLoginRegistration = $('#module-login-registration');

            this.$errorMessage = $('#modal-add-to-cart-error');
            this.$successMessage = $('#modal-add-to-cart-success');

            return this;
        },

        addEventListeners: function () {
            this._super();

            this.onInvokeAddToCart = _.bind(this.onInvokeAddToCart, this);

            $(window).on(ThemeEvent.ADD_TO_CART, this.onInvokeAddToCart);

            // We must attach the following event listener to the body once we add such elements
            // after the body is loaded (e.g.: ModuleProductsInfinite)
            $('body').on('click.add-to-cart-view', '[data-products]', _.bind(this.onAddToCardClick, this));

            this.listenTo(userModel, ThemeEvent.ADD_TO_CART_COMPLETE, this.onAddToCartComplete);
            this.listenTo(userModel, ThemeEvent.FETCH_RECOMMENDED_PRODUCTS_COMPLETE, this.onFetchRecommendedProductsComplete);
            this.listenTo(userModel, ThemeEvent.ERROR_ADD_TO_CART, this.onError);
            this.listenTo(userModel, ThemeEvent.ERROR_UNKNOWN, this.onError);
        },

        detachModuleLoginRegistration: function () {
            this.$moduleLoginRegistration.removeClass('hidden').detach();
        },

        getOrigin: function(e) {
            var hostname = document.location.hostname,
                regex = /^(kombi)?shop/,
                origin = regex.test(hostname) ? 'Shop' : 'CMS-Default',
                $area;

            if (origin === 'CMS-Default' && e) {
                $area = $(e.currentTarget).closest('[data-add-to-cart-origin]');
                if ($area.length) {
                    origin = $area.data('add-to-cart-origin');
                }
            }

            return origin;
        },

        onInvokeAddToCart: function (e, products, origin, delivery) {
            userModel.set('productsToCart', products);

            if (!_.isEmpty(origin)) {
                userModel.set('origin', origin);
            }

            if (delivery === 'homedelivery') {
                this.$successMessage = $('#modal-add-to-cart-success-guest-homedelivery');
            } else if (delivery === 'package') {
                this.$successMessage = $('#modal-add-to-cart-success-guest-package');
            } else {
                this.$successMessage = $('#modal-add-to-cart-success');
            }

            this.$el.modal('show');
        },

        onAddToCardClick: function (e) {
            var $invoker = $(e.currentTarget),
                target = e.currentTarget,
                origin = '';

            if ($invoker.length) {
                origin = $invoker.data('origin');
                if (_.isEmpty(origin)) {
                    origin = this.getOrigin(e);
                }


                userModel.set('target', target);
                userModel.set('origin', origin);
                userModel.set('productsToCart', JSON.parse($invoker.attr('data-products')));
            }
        },

        onShowModal: function (e) {
            this._super();

            if (userModel.isLoggedIn()) {
                this.addToCart();
                this.$el.addClass('logged-in');
            } else {
                this.$el.removeClass('logged-in');

                this.$modalContent
                    .empty()
                    .append(this.$moduleLoginRegistration);

                // Resize wrapper to when the modal is visible (aprox.)
                _.delay(function() {
                    $(window).trigger('module-login-resize-wrapper');
                }, 200)
            }
        },

        onShownModal: function (e) {
            this._super();

            // Resize wrapper again to guarantee it will not be shrink.
            $(window).trigger('resize');
        },

        addToCart: function () {
            this.loading(true);
            this.loadRecommended = true;
            userModel.addToCart();
        },

        fetchRecommendedProducts: function() {
            userModel.fetchRecommendedProducts(this.trigger);
        },

        onAddToCartComplete: function(e) {
            if (!this.isActive) return;
            if (!userModel.hasAction(this.actions, e.action)) return;

            if (this.loadRecommended) {
                this.showSuccessMessage();
                this.fetchRecommendedProducts();
            } else {
                this.updateSuccessMessage();
            }
        },

        onFetchRecommendedProductsComplete: function (e) {
            if (!this.isActive) return;
            if (!userModel.hasAction(this.actions, e.action)) return;

            this.renderRecommendedProducts();
        },

        onError: function(e) {
            this._super();

            if (!this.isActive) return;
            if (!userModel.hasAction(this.actions, e.action)) return;

            if (e.action === 'add-to-cart') {
                if (e.code === 400) {
                    this.handleAuthTokenExpired();
                } else {
                    // Set flag to load card after modal is closed.
                    this.loadCard = true;

                    // Show error message - if any - or the standard one.
                    this.showErrorMessage(e.message);
                }
            }
        },

        onHiddenModal: function (e) {
            this._super();

            userModel.set('origin', null);
            userModel.set('productsToCart', null);
            userModel.set('productsRecommended', null);

            this.$successMessage = $('#modal-add-to-cart-success');

            this.detachModuleLoginRegistration();

            if (this.loadCard) {
                // Reload card after modal is closed.
                this.loadCard = false;
                $(window).trigger(ThemeEvent.REFRESH_CART);
            }
        },

    });

    module.exports = ModuleModalAddToCartView;
});

define('views/ModalAddToFavoritesView',['require','exports','module','theme','backbone','bowser','views/mixins/MixinModalView','events/ThemeEvent','models/UserModel'],function (require, exports, module) {
    'use strict';

    // External dependencies.
    var theme = require('theme');
    var Backbone = require('backbone');
    var bowser = require('bowser');

    var MixinModalView = require('views/mixins/MixinModalView');

    var ThemeEvent = require('events/ThemeEvent');
    var UserModel = require('models/UserModel');
    var userModel = new UserModel();


    var ModuleModalAddToFavoritesView = MixinModalView.extend({

        /**
         * The tigger to be used when fetching recommended products.
         */
        trigger: 'favorites',

        /**
         * The actions this view is interested in.
         */
        actions: [
            'add-to-favorites',
            'fetch-recommended-products',
        ],

        initialize: function (options) {
            this.options = _.extend({}, this.$el.data(), options);

            this.render();
            this.addEventListeners();
        },

        render: function () {
            this._super();

            this.$modalContent = this.$('.modal-content');
            this.$moduleLoginRegistration = $('#module-login-registration');

            this.$errorMessage = $('#modal-add-to-favorites-error');
            this.$successMessage = $('#modal-add-to-favorites-success');

            return this;
        },

        addEventListeners: function () {
            this._super();

            this.onInvokeAddToFavorites = _.bind(this.onInvokeAddToFavorites, this);

            $(window).on(ThemeEvent.ADD_TO_FAVORITES, this.onInvokeAddToFavorites);

            // We must attach the following event listener to the body once we add such elements
            // after the body is loaded (e.g.: ModuleProductsInfinite)
            $('body').on('click.module-modal-add-to-favorites-view', '[data-toggle="modal"][data-target="#modal-add-to-favorites"]', this.onInvokeModal);

            this.listenTo(userModel, ThemeEvent.ADD_TO_CART_COMPLETE, this.onAddToCartComplete);
            this.listenTo(userModel, ThemeEvent.ADD_TO_FAVORITES_COMPLETE, this.onAddToFavoritesComplete);
            this.listenTo(userModel, ThemeEvent.FETCH_RECOMMENDED_PRODUCTS_COMPLETE, this.onFetchRecommendedProductsComplete);
            this.listenTo(userModel, ThemeEvent.ERROR_ADD_TO_FAVORITES, this.onError);
            this.listenTo(userModel, ThemeEvent.ERROR_ADD_TO_CART, this.onError);
            this.listenTo(userModel, ThemeEvent.ERROR_UNKNOWN, this.onError);
        },

        detachModuleLoginRegistration: function () {
            this.$moduleLoginRegistration.removeClass('hidden').detach();
        },

        onInvokeAddToFavorites: function (e, products, guestGroup) {
            userModel.set('productsToFavorites', products);
            this.$el.modal('show');
        },

        onInvokeModal: function (e) {
            var data = null;
            var newData = null;
            var $invoker = $(e.currentTarget);

            if ($invoker.length) {
                var data = $invoker.data('favorites');
                var action = data.favorites[0].action;

                // Add mouseleave listener to avoid bad UX behaviour.
                $invoker.on('mouseleave.favorites', _.bind(this.removeActiveFromInvoker, this));

                // Don't let modal be shown if removing product from favorites.
                if (action === 'remove') {
                    e.preventDefault();
                    e.stopPropagation();
                }

                // Set user model
                userModel.set('productsToFavorites', data);

                // Add favorites or login.
                this.addFavoritesOrLogin();

                // Update invoker.
                newData = JSON.parse(JSON.stringify(data));
                newData.favorites[0].action = action === 'add' ? 'remove' : 'add';
                $invoker.data('favorites', newData);
                $invoker.attr('data-favorites', JSON.stringify(newData));
            }
        },

        removeActiveFromInvoker: function (e) {
            var $el = $(e.currentTarget);
            var data = $el.data('favorites');
            var action = data.favorites[0].action;

            $el.off('mouseleave.favorites');

            if (action === 'add') {
                $el.removeClass('active');
            } else {
                $el.addClass('active');
            }
        },

        onShowModal: function (e) {
            this._super();
        },

        addFavoritesOrLogin: function (e) {
            if (userModel.isLoggedIn()) {
                this.addToFavorites();
                this.$el.addClass('logged-in');
            } else {
                this.$el.removeClass('logged-in');

                this.$modalContent
                    .empty()
                    .append(this.$moduleLoginRegistration);

                // Resize wrapper to when the modal is visible (aprox.)
                _.delay(function() {
                    $(window).trigger('module-login-resize-wrapper');
                }, 200)
            }
        },

        onShownModal: function (e) {
            this._super();

            // Resize wrapper again to guarantee it will not be shrink.
            $(window).trigger('resize');
        },

        addToFavorites: function () {
            this.loading(true);
            userModel.addToFavorites();
        },

        fetchRecommendedProducts: function() {
            userModel.fetchRecommendedProducts(this.trigger);
        },

        onAddToCartComplete: function(e) {
            if (!this.isActive) return;

            this.updateSuccessMessage();
        },

        onAddToFavoritesComplete: function(e) {
            if (!this.isActive) return;
            if (!userModel.hasAction(this.actions, e.action)) return;

            this.showSuccessMessage();
            this.fetchRecommendedProducts();
        },

        onFetchRecommendedProductsComplete: function (e) {
            if (!this.isActive) return;
            if (!userModel.hasAction(this.actions, e.action)) return;

            this.renderRecommendedProducts();
        },

        onError: function(e) {
            this._super();

            if (!this.isActive) return;
            if (!userModel.hasAction(this.actions, e.action)) return;

            if (e.action === 'add-to-favorites') {
                if (e.code === 400) {
                    this.handleAuthTokenExpired();
                } else {
                    // Show error message - if any - or the standard one.
                    this.showErrorMessage(e.message);
                }
            } else if (e.action === 'fetch-recommended-products') {
                this.renderRecommendedProducts();
            }
        },

        onHiddenModal: function (e) {
            this._super();

            userModel.set('productsToFavorites', null);
            userModel.set('productsRecommended', null);

            this.detachModuleLoginRegistration();
        },

    });

    module.exports = ModuleModalAddToFavoritesView;
});

define('views/ModalDeliveryDatetimeSelectView',['require','exports','module','theme','backbone','bowser','views/mixins/MixinModalView','events/ThemeEvent','models/UserModel'],function (require, exports, module) {
    'use strict';

    // External dependencies.
    var theme = require('theme');
    var Backbone = require('backbone');
    var bowser = require('bowser');

    var MixinModalView = require('views/mixins/MixinModalView');

    var ThemeEvent = require('events/ThemeEvent');
    var UserModel = require('models/UserModel');
    var userModel = new UserModel();


    var ModuleModalDeliveryDatetimeSelectView = MixinModalView.extend({

        /**
         * The actions this view is interested in.
         */
        actions: [
            'fetch-delivery-dates',
            'save-delivery-dates',
        ],

        initialize: function (options) {
            this.options = _.extend({}, this.$el.data(), options);
            this.dates = null;

            this.render();
            this.addEventListeners();
        },

        render: function () {
            this._super();

            var html = '';

            this.$modalDialog = this.$('.modal-dialog');
            this.$modalContent = this.$('.modal-content');
            this.$formGetter = this.$('form[data-name="delivery-datetime-getter"]');
            this.$errorMessage = $('#modal-delivery-datetime-select-error');
            this.$successMessage = $('#modal-delivery-datetime-select-success');
            this.$formSetter = null;

            return this;
        },

        addEventListeners: function () {
            this._super();

            this.isDateAvailable = _.bind(this.isDateAvailable, this);
            this.dateChange = _.bind(this.dateChange, this);
            this.onTimeChange = _.bind(this.onTimeChange, this);
            this.onDeliveryDatetimeSubmit = _.bind(this.onDeliveryDatetimeSubmit, this);

            this.listenTo(userModel, ThemeEvent.FETCH_DELIVERY_DATES_COMPLETE, this.onFetchDeliveryDatesComplete);
            this.listenTo(userModel, ThemeEvent.SAVE_DELIVERY_DATES_COMPLETE, this.onSaveDeliveryDatesComplete);
            this.listenTo(userModel, ThemeEvent.ERROR_FETCH_DELIVERY_DATES, this.onError);
            this.listenTo(userModel, ThemeEvent.ERROR_SAVE_DELIVERY_DATES, this.onError);
            this.listenTo(userModel, ThemeEvent.ERROR_UNKNOWN, this.onError);
        },

        onShownModal: function (e) {
            this._super();
            this.fetchDates();
        },

        onHiddenModal: function (e) {
            this._super();
            userModel.loadingDeliveryDatetime = false;
        },

        fetchDates: function () {
            this.loading(true);
            userModel.fetchDeliveryDates(this.$formGetter.serializeArray());
        },

        onError: function (e) {
            if (!this.isActive) return;
            if (!userModel.hasAction(this.actions, e.action)) return;

            if (e.code === 0 || e.code === 400) {
                this.handleAuthTokenExpired();
            } else {
                this.showErrorMessage(e.message);
            }
        },

        onFetchDeliveryDatesComplete: function (e) {
            if (!this.isActive) return;
            if (!userModel.hasAction(this.actions, e.action)) return;

            this.loading(false);

            if (userModel.get('deliveryDatetime') && !_.isEmpty(userModel.get('customerGroup'))) {
                this.setSelectableDates();
                this.renderDeliveryDatetimeSelect();

                if (userModel.get('customerGroup') === CUSTOMER_GROUP_HD) {
                    this.updateSubmitButton(true);
                }
            }
        },

        formatDate: function (date) {
            var year = date.getFullYear(),
                month = date.getMonth() + 1,
                day = date.getDate(),
                formattedDate = '';

            month = month >= 10 ? month : ('0' + String(month));
            day = day >= 10 ? day : ('0' + String(day));

            formattedDate = year + '-' + month + '-' + day;

            return formattedDate;
        },

        isDateAvailable: function (date) {
            var i,
                options,
                enabled = false,
                classes = '';

            for (i = 0; i < this.dates.length; i++) {
                if (this.dates[i].date === this.formatDate(date)) {
                    enabled = true;
                    classes = 'highlighted';
                }
            }

            options = {
                enabled: enabled,
                classes: classes,
            };

            return options;
        },

        getCurrentDate: function () {
            for (var i = 0; i < this.dates.length; i++) {
                if (this.dates[i].current) {
                    return this.dates[i].date;
                }
            }

            return '';
        },

        setSelectableDates: function () {
            var i,
                counter,
                dates = userModel.get('deliveryDatetime'),
                selectableDates;

            if (userModel.get('customerGroup') === CUSTOMER_GROUP_JO) {
                selectableDates = dates;
            } else if (userModel.get('customerGroup') === CUSTOMER_GROUP_HD) {
                counter = 0;
                selectableDates = [];

                for (i = 0; i < dates.length; i++) {
                    if (dates[i].selectable) {
                        selectableDates[counter++] = dates[i];
                    }
                }
            }

            this.dates = selectableDates;
        },

        getSelectedDate: function (formattedDate) {
            for (var i = 0; i < this.dates.length; i++) {
                if (this.dates[i].date === formattedDate) {
                    return this.dates[i];
                }
            }

            return null;
        },

        renderDeliveryDatetimeSelect: function () {
            var html = $('#modal-delivery-datetime-select-content-' + userModel.get('customerGroup')).html(),
                tmpl = _.template(html);

            this.$modalContent.html(tmpl());
            this.$formSetter = this.$('form[data-name="delivery-datetime-setter"]');
            this.$submitButton = this.$('button[type="submit"]');
            this.$datePickerInput = this.$('.input-group.datepicker');

            this.$formSetter.on('submit', this.onDeliveryDatetimeSubmit);

            if (userModel.get('customerGroup') === CUSTOMER_GROUP_JO) {
                this.createDatePicker();
            } else if (userModel.get('customerGroup') === CUSTOMER_GROUP_HD) {
                this.renderDateTimes();
            }
        },

        parseDate: function (date, format) {
            var format = format || 'yyyy-mm-dd',
                parts = date.match(/(\d+)/g),
                i = 0,
                fmt = {};

            // Extract date-part indexes from the format
            format.replace(/(yyyy|dd|mm)/g, function (part) {
                fmt[part] = i++;
            });

            return new Date(parts[fmt['yyyy']], parts[fmt['mm']] - 1, parts[fmt['dd']]);
        },

        getFormattedDate: function () {
            var formattedDate = this.formatDate(this.date);
            return formattedDate;
        },

        createDatePicker: function () {
            var $datepicker = null,
                currentDate = this.getCurrentDate(),
                date = null,
                params = {
                    format: 'dd.mm.yyyy',
                    language: window.datePickerLocale || 'de',
                    autoclose: true,
                    beforeShowDay: this.isDateAvailable,
                };

            //overwrite
            if (window.pickerLabels && window.datePickerLocale) {
                $.fn.datepicker.dates[window.datePickerLocale] = window.pickerLabels;
            }

            if (_.isEmpty(currentDate) && this.dates && this.dates.length) {
                currentDate = this.dates[0].date;
            }

            $datepicker = this.$('.datepicker:not(.custom-datepicker)').datepicker(params);

            $datepicker.on('changeDate', this.dateChange);

            // Check if date is
            if (!_.isEmpty(currentDate)) {
                date = this.parseDate(currentDate);
                this.setDate(date);
                $datepicker.datepicker('update', date);
            }
        },

        setDate: function (date) {
            var formattedDate = this.formatDate(date);

            this.date = date;
            this.$formSetter.find('input[name="date"]').val(formattedDate);

            this.updateDatePickerInput(true);
            this.updateSubmitButton(true);

            if (userModel.get('customerGroup') === CUSTOMER_GROUP_JO) {
                this.renderTimes();
            }
        },

        setTimes: function (from, until) {
            this.$formSetter.find('input[name="timebeg"]').val(from);
            this.$formSetter.find('input[name="timeend"]').val(until);
        },

        dateChange: function (e) {
            var date = e.date,
                available = this.isDateAvailable(date),
                $datepicker = this.$('.datepicker:not(.custom-datepicker)');

            if (available.enabled) {
                this.setDate(date);
            } else {
                this.updateDatePickerInput(false);
                this.updateSubmitButton(false);
            }
        },

        onTimeChange: function (e) {
            var $input = $(e.currentTarget),
                from = $input.siblings('input[name="from"]').val(),
                until = $input.siblings('input[name="until"]').val(),
                formattedDate = $input.siblings('input[name="bdat"]').val(),
                date = null;

            this.setTimes(from, until);

            if (userModel.get('customerGroup') === CUSTOMER_GROUP_HD) {
                date = this.parseDate(formattedDate);
                this.setDate(date);
            }
        },

        renderTimes: function () {
            var formattedDate = this.getFormattedDate(),
                date = _.extend(this.getSelectedDate(formattedDate)),
                regexp = /([0-9]{2}:[0-9]{2}):[0-9]{2}/,
                timeSelected = 0,
                $timesWrapper = this.$('.module-checkout-timepicker > ul'),
                $inputs = null,
                html = $('#modal-delivery-datetime-select-time-' + userModel.get('customerGroup')).html(),
                tmplTime = _.template(html);

            if (date) {
                _.forEach(date.times, function (time, index) {
                    time.from_short = time.from.replace(regexp, '$1');
                    time.until_short = time.until.replace(regexp, '$1');

                    if (time.current) {
                        timeSelected = index;
                    }
                });

                $timesWrapper
                    .empty()
                    .append(tmplTime(date));

                $inputs = $timesWrapper.find('input[name="module-checkout-timepicker"]');
                $inputs.on('change', this.onTimeChange);
                $inputs.eq(timeSelected).trigger('click');
            }
        },

        renderDateTimes: function () {
            var dates = _.extend(this.dates),
                regexpDate = /([0-9]{4})-([0-9]{2})-([0-9]{2})/,
                regexp = /([0-9]{2}:[0-9]{2}):[0-9]{2}/,
                dateSelected = 0,
                $datesWrapper = this.$('.module-checkout-timepicker > ul'),
                weekDays = this.options.days || ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
                $inputs = null,
                html = $('#modal-delivery-datetime-select-time-' + userModel.get('customerGroup')).html(),
                tmplTime = _.template(html);

            if('pickerLabels' in window) {
                if('daysMin' in window.pickerLabels) {
                    weekDays = window.pickerLabels.daysMin;
                }
            }

            _.forEach(dates, function (date, index) {
                var day = this.parseDate(date.bdat);

                date.week_day_short = weekDays[day.getDay()];
                date.formatted_date = date.bdat.replace(regexpDate, '$3.$2.$1');
                date.from = date.vtimebeg;
                date.until = date.vtimeend;
                date.from_short = date.vtimebeg.replace(regexp, '$1');
                date.until_short = date.vtimeend.replace(regexp, '$1');

                if (date.current) {
                    dateSelected = index;
                }
            }, this);



            $datesWrapper
                .empty()
                .append(tmplTime({
                    dates: dates
                }));

            $inputs = $datesWrapper.find('input[name="module-checkout-timepicker"]');
            $inputs.on('change', this.onTimeChange);
            $inputs.eq(dateSelected).trigger('click');
        },

        updateSubmitButton: function (enabled) {
            this.$submitButton.removeClass('btn-red btn-grey enabled');

            if (enabled) {
                this.$submitButton.addClass('btn-red enabled');
            } else {
                this.$submitButton.addClass('btn-grey');
            }
        },

        isSubmitButtonEnabled: function () {
            var enabled = this.$submitButton.hasClass('enabled');

            return enabled;
        },

        updateDatePickerInput: function (enabled) {
            if (userModel.get('customerGroup') === CUSTOMER_GROUP_JO) {
                if (enabled) {
                    this.$datePickerInput.removeClass('has-error');
                } else {
                    this.$datePickerInput.addClass('has-error');
                }
            }
        },

        onDeliveryDatetimeSubmit: function (e) {
            e.preventDefault();

            if (this.isSubmitButtonEnabled()) {
                userModel.saveDeliveryDates(this.$formSetter.serializeArray());
            }
        },

        onSaveDeliveryDatesComplete: function (e) {
            if (!this.isActive) return;
            if (!userModel.hasAction(this.actions, e.action)) return;

            this.showSuccessMessage();
            this.updateDeliveryStatus();
        },

        updateDeliveryStatus: function () {
            var $el = this.$el;

            _.delay(function () {
                $el.modal('hide');
            }, 2500);

            _.delay(function () {
                document.location.reload(true);
            }, 3000);
        }

    });

    var CUSTOMER_GROUP_JO = 'jo';
    var CUSTOMER_GROUP_HD = 'hd';

    module.exports = ModuleModalDeliveryDatetimeSelectView;
});

define('views/ModalAjaxHtmlView',['require','exports','module','backbone'],function (require, exports, module) {
    'use strict';

    // External dependencies.
    var Backbone = require('backbone');

    var ModalAjaxHtmlView = Backbone.View.extend({

        url: '',

        initialize: function (options) {
            this.options = _.extend({}, this.$el.data(), options);

            this.render();
            this.addEventListeners();
        },

        render: function () {
            this.$el = $('#modal-ajax-html');
            this.$modalContent = this.$el.find('.modal-body');

            return this;
        },

        addEventListeners: function () {
            this.$el.on('show.bs.modal', _.bind(this.onModalShow, this));
            this.$el.on('hidden.bs.modal', _.bind(this.onModalHidden, this));

            $(document).on('click', '.open-modal-ajax-html', _.bind(this.openAjaxHtmlModal, this));
        },

        onModalShow: function (e) {
            if (_.isEmpty(this.url)) {
                this.url = this.$el.attr('src');
            }

            this.$el.addClass('loading');
            this.$modalContent.load(this.url, _.bind(this.onLoadComplete, this));
        },

        onLoadComplete: function (e) {
            this.$el.removeClass('loading');
        },

        onModalHidden: function (e) {
            this.url = '';
            this.$el.attr('src', '');
            this.$modalContent.empty();
        },

        openAjaxHtmlModal: function (e) {
            e.preventDefault();

            var $el = $(e.currentTarget);

            this.url = $el.data('src');
            this.$el.modal('show');
        },

    });

    module.exports = ModalAjaxHtmlView;
});

define('views/HeaderTopAccountMenuView',['require','exports','module','theme','backbone'],function (require, exports, module) {
    "use strict";

    // External dependencies.
    var theme = require("theme");
    var Backbone = require("backbone");

    var ModuleHeaderTopAccountMenuView = Backbone.View.extend({

        views: null,
        tw: null,
        animationTime: 0.6,
        $body: null,

        initialize: function (options) {
            this.views = [];

            options = _.extend({}, this.$el.data(), options);

            this.onAnotherMenuOpen = _.bind(this.onAnotherMenuOpen, this);
            this.onBodyClick = _.bind(this.onBodyClick, this);

            this.el.moduleHeaderTopAccountMenuView = this;

            this.render();
        },

        events: {
            'click > a': "onClick",
            // 'mouseleave': "onMouseLeave",
            'focus input': "onFocus"
        },

        render: function (e) {
            this.$body = $("body");

            this.enableEvents();

            this.$el.addClass("rendered");
        },

        enableEvents: function () {
            //Remove previous events
            this.disableEvents();
            this.$body.on("menu-flyout-open", this.onAnotherMenuOpen);
            this.$body.on("click", this.onBodyClick);

            return this;
        },

        disableEvents: function () {
            this.$body.off("menu-flyout-open", this.onAnotherMenuOpen);
            this.$body.off("click", this.onBodyClick);

            return this;
        },

        onClick: function (e) {
            if (e && e.preventDefault) e.preventDefault();

            if (this.$el.hasClass("hover") || this.$el.hasClass("focus")) {
                if (this.tw) this.tw.kill();
                this.$el.removeClass("hover focus");
                $(".module-header-search").removeClass('login-opened');
            } else {
                this.closeOtherMenus();

                if (this.tw) this.tw.kill();
                this.$el.addClass("hover");
                $(".module-header-search").addClass('login-opened');
                
                $(window).trigger("module-login-resize-wrapper");
            }
        },

        onMouseLeave: function (e) {
            this.tw = TweenMax.setTimeout(function () {
                this.$el.removeClass("hover");
            }, this.animationTime, this);

            $(".module-header-search").removeClass('login-opened');
        },

        onFocus: function (e) {
            if (this.tw) this.tw.kill();
            this.$el.addClass("focus");
        },

        onBodyClick: function (e) {
            var $element = $(e.target);

            if ($element.closest(".module-header-top-account").length) return;

            this.$el.removeClass("focus");
            this.onMouseLeave();
        },

        onAnotherMenuOpen: function (e) {
            if (this === e.menuTarget) return;

            if (this.tw) this.tw.kill();

            if (this.$el.hasClass("focus")) {
                this.$el.find(":focus").blur();
            }

            this.$el.removeClass("hover focus");
        },

        closeOtherMenus: function (e) {
            this.$body.trigger({
                type: "menu-flyout-open",
                menuTarget: this
            });
        },
    });

    module.exports = ModuleHeaderTopAccountMenuView;
});

define('views/HeaderTopOrderView',['require','exports','module','theme','backbone'],function (require, exports, module) {
    "use strict";

    // External dependencies.
    var theme = require("theme");
    var Backbone = require("backbone");

    var ModuleHeaderTopOrderView = Backbone.View.extend({

        views: null,
        tw: null,
        animationTime: 0.6,
        $body: null,
        $wrapper: null,
        $form: null,
        inputTemplateTag: null,
        inputTemplate: null,

        initialize: function (options) {
            this.views = [];

            options = _.extend({}, this.$el.data(), options);

            this.inputTemplateTag = options.inputTemplate || "";

            this.onAnotherMenuOpen = _.bind(this.onAnotherMenuOpen, this);
            this.onPlusClick = _.bind(this.onPlusClick, this);
            this.onBodyClick = _.bind(this.onBodyClick, this);

            this.el.moduleHeaderTopOrderView = this;

            this.render();
        },

        events: {
            'click > a': "onClick",
            'mouseenter': "onMouseEnter",
            'mouseleave': "onMouseLeave",
            'focus input': "onFocus",
            'click .btn-plus': "onPlusClick",
            'submit form': "onSubmit"
        },

        render: function (e) {
            this.$body = $("body");
            this.$wrapper = this.$el.find(".module-header-top-order-content-wrapper");
            this.$form = this.$el.find("form");

            this.inputTemplate = _.template($(this.inputTemplateTag).text() || "");

            this.enableEvents();

            this.$el.addClass("rendered");
        },

        enableEvents: function () {
            //Remove previous events
            this.disableEvents();
            this.$body.on("menu-flyout-open", this.onAnotherMenuOpen);
            this.$body.on("click", this.onBodyClick);

            return this;
        },

        disableEvents: function () {
            this.$body.off("menu-flyout-open", this.onAnotherMenuOpen);
            this.$body.off("click", this.onBodyClick);

            return this;
        },

        onClick: function (e) {
            if (e && e.preventDefault) e.preventDefault();

            if (this.$el.hasClass("hover") || this.$el.hasClass("focus")) {
                if (this.tw) this.tw.kill();
                this.$el.removeClass("hover focus");
            } else {
                this.closeOtherMenus();

                if (this.tw) this.tw.kill();
                this.$el.addClass("hover");
            }
        },

        onMouseEnter: function (e) {
            this.closeOtherMenus();

            if (this.tw) this.tw.kill();
            this.$el.addClass("hover");
        },

        onMouseLeave: function (e) {
            this.tw = TweenMax.setTimeout(function () {
                this.$el.removeClass("hover");
            }, this.animationTime, this);
        },

        onFocus: function (e) {
            if (this.tw) this.tw.kill();
            this.$el.addClass("focus");
        },

        onBodyClick: function (e) {
            var $element = $(e.target);
            if ($element.closest(".module-header-top-order").length) return;

            this.$el.removeClass("focus");
        },

        onPlusClick: function (e) {
            if (e && e.preventDefault) e.preventDefault();

            var html = this.inputTemplate({});

            this.$wrapper.append(html);

            this.$wrapper.find("input:last").focus();
        },

        onAnotherMenuOpen: function (e) {
            if (this === e.menuTarget) return;

            if (this.tw) this.tw.kill();

            if (this.$el.hasClass("focus")) {
                this.$el.find(":focus").blur();
            }

            this.$el.removeClass("hover focus");
        },

        closeOtherMenus: function (e) {
            this.$body.trigger({
                type: "menu-flyout-open",
                menuTarget: this
            });
        },

        onSubmit: function (e) {
            if (e && e.preventDefault) e.preventDefault();

            var $inputs = this.$wrapper.find("input");

            var i;
            var imax = $inputs.length;
            var $input;

            var items = [];
            var value;

            for (i = 0; i < imax; i++) {
                $input = $inputs.eq(i);

                value = encodeURIComponent(($input.val() || "").trim());

                if (value) {
                    if (items[value]) {
                        items[value] += 1;
                    } else {
                        items[value] = 1;
                    }
                }
            }

            var strings = [];
            var key;

            for (key in items) {
                value = items[key];

                strings.push(key + "_" + value);
            }

            strings = strings.join(",");

            var action = this.$form.attr("action");

            var url = action + strings;

            document.location = url;
        },
    });

    module.exports = ModuleHeaderTopOrderView;
});

define('views/HeaderMenuView',['require','exports','module','backbone'],function (require, exports, module) {
    "use strict";

    // External dependencies.
    var Backbone = require('backbone');

    var ModuleHeaderMenuView = Backbone.View.extend({

        views: null,
        $body: null,
        $header: null,
        animationTime: 0.3,
        tw: null,

        initialize: function (options) {
            this.views = [];

            options = _.extend({}, this.$el.data(), options);

            this.el.moduleHeaderMenuView = this;

            this.onBodyClick = _.bind(this.onBodyClick, this);
            this.onAnotherMenuOpen = _.bind(this.onAnotherMenuOpen, this);
            this.onModalOpen = _.bind(this.onModalOpen, this);
            this.onModalClose = _.bind(this.onModalClose, this);

            this.$body = $('body');

            this.render();
        },

        render: function () {
            this.$headerContent = $('.header-content');

            this.$buttonOpenMobile = $('.module-mobile-menu-button');
            this.$buttonCloseMobile = $('.module-mobile-menu-close-button');

            this.$headerSearch = $('.module-header-search');
            this.$buttonOpenSearchMobile = $('.module-header-search-button');
            this.$buttonCloseSearchMobile = $('.module-header-search .link-back');

            this.enableEvents();
            this.$el.addClass('rendered');
        },

        events: {
            'touchstart .primary-menu .has-content > a': 'onTap',
            'mouseenter .primary-menu .has-content': 'onMouseEnter',
            'mouseleave .primary-menu .has-content': 'onMouseLeave',
            'click .primary-menu .has-content .link-close-flyout': 'closeFlyout',
            'click .has-content .link-submenu': 'onOpenSubmenuMobile',
            'click .has-content .link-back': 'onCloseSubmenuMobile',
        },

        openViewMobile: function ($view) {
            TweenMax.fromTo($view, this.animationTime, {
                x: '100%',
                autoAlpha: 0,
            }, {
                ease: Strong.easeOut,
                x: '0%',
                autoAlpha: 1,
            });
        },

        closeViewMobile: function ($view) {
            TweenMax.fromTo($view, this.animationTime, {
                x: '0%',
            }, {
                ease: Strong.easeOut,
                x: '100%',
                autoAlpha: 0,
            });
        },

        closeFlyout: function (e) {
            if (e && e.preventDefault) e.preventDefault();
            this.onMouseLeave(e);
        },

        onCloseSubmenuMobile: function (e) {
            if (e && e.preventDefault) e.preventDefault();
            var $secondaryMenuCopy = $(e.target).closest('.secondary-menu-copy');
            this.closeViewMobile($secondaryMenuCopy);

            $(e.target).closest('.has-content').css('z-index', 'inherit');
        },

        onOpenSubmenuMobile: function (e) {
            if (this.$body.hasClass('lg') || this.$body.hasClass('md')) {
                return;
            }

            if (e && e.preventDefault) e.preventDefault();
            var $secondaryMenuCopy = $(e.target).parent().find('.secondary-menu-copy');
            $secondaryMenuCopy.removeClass('hidden');
            this.openViewMobile($secondaryMenuCopy);

            $(e.target).closest('.has-content').css('z-index', 9);
        },

        onOpenSearchMenuMobile: function (e) {
            if (e && e.preventDefault) e.preventDefault();

            var $searchField = $('.james-search-input');

            if ($searchField.val().length === 0) {
                $('.popular-terms').addClass('show');
            } else {
                $('.popular-terms').removeClass('show');
            }

            this.openViewMobile(this.$headerSearch);
            _.delay(function () {
                $searchField.focus();
            }, this.animationTime + 2);
        },

        onCloseSearchMenuMobile: function (e) {
            if (e && e.preventDefault) e.preventDefault();
            this.closeViewMobile(this.$headerSearch);
        },

        onTap: function (e) {
            var $element = $(e.currentTarget);
            var $li = $element.closest('li');

            if (e && e.preventDefault) e.preventDefault();
            if (e && e.stopImmediatePropagation) e.stopImmediatePropagation();

            if ($li.hasClass('hover')) {
                this.removeHover($li);
            } else {
                this.addHover($li);
            }
        },

        onMouseEnter: function (e) {
            var $element = $(e.currentTarget);
            var $li = $element.closest("li");
            this.addHover($li);
        },

        onMouseLeave: function (e) {
            var $element = $(e.currentTarget);
            var $li = $element.closest("li");
            this.removeHover($li);
        },

        addHover: function ($li) {
            this.removeHover($li);
            this.closeOtherMenus($li);
            $li.addClass('hover');
            this.$body.on('click', this.onBodyClick);
            this.$body.trigger('resize');
        },

        removeHover: function ($li) {
            $li.siblings('li.hover').removeClass('hover');
            $li.removeClass('hover');
            this.$body.off('click', this.onBodyClick);
        },

        onBodyClick: function (e) {
            var $target = $(e.target);
            if ($target.closest('.module-header-menu').length) return;
            this.$el.find('.module-header-menu > li.has-content').removeClass('hover');
            this.$body.off('click', this.onBodyClick);
        },

        openMenuMobile: function (e) {
            if (e && e.preventDefault) e.preventDefault();
            this.$body.removeClass('overflow-hidden').addClass('module-mobile-open');
            this.$headerSearch.addClass('full-size');

            if (!$('.secondary-menu-copy').find('.secondary-menu').length) {
                $('.has-content .secondary-menu').each(function (index, value) {

                    var $secondaryMenuCopy = $(value).parent().find('.secondary-menu-copy');

                    $(value).clone().appendTo($secondaryMenuCopy).find('.menu-item').removeClass('mobile-hidden');
                });

                $('#footer').find('.footer-links').clone().appendTo(this.$el.closest('.module-header-center'));
            }
        },

        closeMenuMobile: function (e) {
            if (e && e.preventDefault) e.preventDefault();
            this.$body.removeClass('module-mobile-open');
            this.$headerSearch.removeClass('full-size');
            this.$headerSearch.attr('style', '');
            $('.popular-terms').removeClass('show hover');
        },

        enableEvents: function () {
            //Remove previous events
            this.disableEvents();

            this.$body.on('menu-flyout-open', this.onAnotherMenuOpen);

            var $modal = this.$body.find('.modal');
            $modal.on('show.bs.modal', this.onModalOpen);
            $modal.on('hidden.bs.modal', this.onModalClose);

            this.$buttonOpenMobile.on('click', _.bind(this.openMenuMobile, this));
            this.$buttonCloseMobile.on('click', _.bind(this.closeMenuMobile, this));

            this.$buttonOpenSearchMobile.on('click', _.bind(this.onOpenSearchMenuMobile, this));
            this.$buttonCloseSearchMobile.on('click', _.bind(this.onCloseSearchMenuMobile, this));

            return this;
        },

        disableEvents: function () {
            this.$body.off('menu-flyout-open', this.onAnotherMenuOpen);

            var $modal = this.$body.find('.modal');
            $modal.off('show.bs.modal', this.onModalOpen);
            $modal.off('hidden.bs.modal', this.onModalClose);

            return this;
        },

        onModalOpen: function (e) {
            var padding = this.measureScrollbar();

            this.$headerContent.filter('.active').css('padding-right', padding);
        },

        onModalClose: function (e) {
            this.$headerContent.css('padding-right', '');
        },

        measureScrollbar: function () { // thx walsh
            var scrollDiv = document.createElement('div');
            scrollDiv.className = 'modal-scrollbar-measure';
            this.$body.append(scrollDiv);
            var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
            this.$body[0].removeChild(scrollDiv);
            return scrollbarWidth;
        },

        onAnotherMenuOpen: function (e) {
            if (this === e.menuTarget) return;

            this.$el.find('.hover').removeClass('hover');
        },

        closeOtherMenus: function ($li) {
            this.$body.trigger({
                type: 'menu-flyout-open',
                menuTarget: this,
                $target: $li
            });
        },

        resize: function (e) {
        },
    });

    module.exports = ModuleHeaderMenuView;
});

define('views/HeaderContentView',['require','exports','module','backbone'],function (require, exports, module) {
    "use strict";

    // External dependencies.
    var Backbone = require("backbone");

    var HeaderContentView = Backbone.View.extend({

        views: null,
        $body: null,
        $window: null,
        $top: null,
        $bottom: null,
        $stickyButton: null,
        animationTime: 0.3,
        tw: null,

        initialize: function (options) {
            this.views = [];
            options = _.extend({}, this.$el.data(), options);

            this.el.headerContentView = this;
            this.onScroll = _.bind(this.onScroll, this);
            this.onStickyButtonClick = _.bind(this.onStickyButtonClick, this);
            this.$body = $("body");
            this.render();
        },

        render: function (e) {
            this.$window = $(window);

            this.$top = this.$el.find(".module-header-top");
            this.$bottom = this.$el.find(".module-header-bottom");
            this.$stickyButton = this.$el.find(".sticky-only-button");

            this.enableEvents();
            this.mountVoucherHeader();

            this.$el.addClass("rendered");
        },

        enableEvents: function () {
            //Remove previous events
            this.disableEvents();
            this.$window.on("scroll", this.onScroll);
            this.$stickyButton.on("click", this.onStickyButtonClick);
            this.$('.popular-terms .link-hide').on("click", _.bind(this.hideSearchContent, this));

            return this;
        },

        disableEvents: function () {
            this.$window.off("scroll", this.onScroll);

            this.$stickyButton.off("click", this.onStickyButtonClick);

            return this;
        },

        hideSearchContent: function () {
            $('.popular-terms').removeClass('show hover');

            if ($('body').hasClass('xs') || $('body').hasClass('sm')) {
                $('body').removeClass('overflow-hidden');
            }
        },

        mountVoucherHeader: function () {
            this.$voucherHeader = $('.module-voucher-header');

            if (this.$voucherHeader.length) {
                this.$voucherHeader.find('.close').on('mousedown', _.bind(function () {
                    TweenMax.to(this.$voucherHeader, 0.25, {
                        height: 0,
                        ease: Power1.easeOut,
                        onUpdate: function () {
                            this.updateSticky();
                            this.updateMobileMenu();
                        },
                        onUpdateScope: this,
                        onComplete: function () {
                            this.$voucherHeader.remove();
                        },
                        onCompleteScope: this,
                    });
                }, this));

                $('.module-mobile-menu-button').on('mousedown', _.bind(this.updateMobileMenu, this));
                $('.module-mobile-account-button').on('mousedown', _.bind(this.updateMobileMenu, this));
            }
        },

        updateMobileMenu: function () {
            var $mobileMenu = $('.module-mobile-menu .module-mobile-menu-wrapper');
            var $accountMenu = $('.module-mobile-account-menu .module-mobile-account-menu-content');

            var height = 0;
            var marginTop = '';
            var paddingTop = '';

            $mobileMenu.css('margin-top', marginTop);
            $accountMenu.css('padding-top', paddingTop);

            if ($('.module-voucher-header').length && $accountMenu.length) {
                height = $('.module-voucher-header').outerHeight();
                marginTop = height + 'px';
                paddingTop = (height + parseInt($accountMenu.css('padding-top'), 10)) + 'px';

                $mobileMenu.css('margin-top', marginTop);
                $accountMenu.css('padding-top', paddingTop);
            }
        },

        onScroll: function (e) {
            this.updateSticky();
        },

        updateSticky: function (e) {
            var scroll = this.$window.scrollTop();
            var height = this.$el.height();
            var size = this.$body.attr("data-size") || "xs";
            // var isSticky = (scroll > height) || size === 'sm' || size === 'xs';
            var isSticky = (scroll > height);
            var $placeHolder;
            var $prevItem = this.$el.prev();

            if (isSticky) {
                if (!$prevItem.hasClass("sticky-placeholder")) {
                    $placeHolder = $('<div class="sticky-placeholder"></div>');
                    $placeHolder.css({
                        height: height
                    });

                    this.$el.before($placeHolder);

                    this.$el.addClass("active");
                    this.$stickyButton.removeClass("active");

                    this.tw = TweenMax.fromTo(this.$el, this.animationTime * 2, {
                        y: "-100%",
                    }, {
                        ease: Strong.easeOut,
                        y: "0%",
                    });
                } else if (size === 'sm' || size === 'xs') {
                    if (!$('.module-voucher-header').height()) {
                        height = '';
                    }

                    $placeHolder = $('.sticky-placeholder');
                    $placeHolder.css({
                        height: height,
                    });
                }
            } else {
                if ($prevItem.hasClass("sticky-placeholder")) {
                    if (this.tw) {
                        this.tw.kill();
                        this.tw = null;
                    }

                    $prevItem.remove();
                    this.$bottom.css("display", "");
                    this.$el.removeClass("active");
                    this.$stickyButton.removeClass("active");
                }
            }
        },

        onStickyButtonClick: function (e) {
            if (e && e.preventDefault) e.preventDefault();

            var isActive = this.$bottom.is(":visible");

            if (isActive) {
                this.$stickyButton.removeClass("active");
            } else {
                this.$stickyButton.addClass("active");
            }
        },

        resize: function (e) {
            this.updateSticky();
            this.updateMobileMenu();
        },
    });

    module.exports = HeaderContentView;
});

define('views/MobileAccountMenuView',['require','exports','module','theme','backbone'],function (require, exports, module) {
    "use strict";

    // External dependencies.
    var theme = require("theme");
    var Backbone = require("backbone");

    var ModuleMobileAccountMenuView = Backbone.View.extend({

        views: null,
        $content: null,
        animationTime: 0.3,

        initialize: function (options) {
            this.views = [];

            options = _.extend({}, this.$el.data(), options);

            this.resize = _.bind(_.throttle(this.resize, 20), this);
            this.onLoginResize = _.bind(this.onLoginResize, this);
            this.onButtonClick = _.bind(this.onButtonClick, this);
            this.onAnotherOpen = _.bind(this.onAnotherOpen, this);

            this.el.moduleMobileAccountMenuView = this;

            this.render();
        },

        render: function (e) {
            this.$content = this.$el.find(".module-mobile-account-menu-content:first");
            this.$body = $("body:first");
            this.$button = $(".module-mobile-account-button");

            this.enableEvents();

            this.resize();

            this.$el.addClass("rendered");
        },

        enableEvents: function () {
            //Remove previous events
            this.disableEvents();

            this.$button.on("click", this.onButtonClick);
            this.$body.on("module-mobile-menu-open", this.onAnotherOpen);
            this.$body.on("module-login-resize", this.onLoginResize);

            return this;
        },

        disableEvents: function () {
            this.$button.off("click", this.onButtonClick);
            this.$body.off("module-mobile-menu-open", this.onAnotherOpen);
            this.$body.off("module-login-resize", this.onLoginResize);

            return this;
        },

        onButtonClick: function (e) {
            if (e && e.preventDefault) e.preventDefault();


            if (this.$body.hasClass("mobile-account-menu-open")) {
                this.close();
                this.applyScrollTop();
            } else {
                this.open();
            }
        },

        getScrollTop: function () {
            var scrollTop = parseInt(this.$body.attr('data-scroll-top'), 10);
            scrollTop = isNaN(scrollTop) ? window.scrollY : scrollTop;

            return scrollTop;
        },

        setScrollTop: function (value) {
            this.$body.attr('data-scroll-top', value);
        },

        applyScrollTop: function () {
            var scrollTop = this.getScrollTop();
            this.setScrollTop('');

            _.delay(function () {
                window.scrollTo(0, scrollTop);
            }, 1);
        },

        open: function (e) {
            this.setScrollTop(this.getScrollTop());

            this.$el.addClass("open");
            this.$body.addClass("mobile-account-menu-open");
            this.$button.addClass("open");

            TweenMax.fromTo(this.$el, this.animationTime, {
                x: "100%",
                autoAlpha: 0,
            }, {
                ease: Strong.easeOut,
                x: "0%",
                autoAlpha: 1,
                onCompleteScope: this,
                onComplete: function () {
                    this.resize();
                }
            });

            this.resize();

            this.$body.trigger("mobile-account-menu-open");
        },

        close: function (e) {
            if (!this.$el.hasClass("open")) return;

            this.$body.removeClass("mobile-account-menu-open");

            TweenMax.fromTo(this.$el, this.animationTime - 0.01, {
                x: "0%",
            }, {
                ease: Strong.easeOut,
                x: "100%",
                alpha: 0,
                onCompleteScope: this,
                onComplete: function () {
                    this.$el.removeClass("open");
                }
            });

            this.$button.removeClass("open");

            this.resize();
        },

        onAnotherOpen: function (e) {
            if (this.$body.hasClass("mobile-account-menu-open")) {
                this.close();
            }
        },

        onLoginResize: function (e) {
            this.resize();

            TweenMax.setTimeout(this.resize, 0.5, this);
        },

        resize: function (e) {
            var size = this.$body.hasClass("xs") || this.$body.hasClass("sm");

            if (size) {
                this.checkSize();
            } else {
                this.close();
            }
        },

        checkSize: function (e) {
            var size = this.$body.hasClass("xs") || this.$body.hasClass("sm");
            var isOpen = this.$el.hasClass("open");

            if (!size && isOpen) {
                this.close();
            }
        },
    });

    module.exports = ModuleMobileAccountMenuView;
});

define('views/MobileMenuView',['require','exports','module','theme','backbone'],function (require, exports, module) {
    "use strict";

    // External dependencies.
    var theme = require("theme");
    var Backbone = require("backbone");

    var ModuleMobileMenuView = Backbone.View.extend({

        views: null,
        animationTime: 0.3,
        tw1: null,
        $body: null,
        $window: null,
        $button: null,
        $wrapper: null,

        initialize: function (options) {
            this.views = [];

            options = _.extend({}, this.$el.data(), options);

            this.resize = _.bind(_.throttle(this.resize, 20), this);
            this.onSubmenuButtonClick = _.bind(this.onSubmenuButtonClick, this);
            this.onReturnButtonClick = _.bind(this.onReturnButtonClick, this);
            this.open = _.bind(this.open, this);
            this.close = _.bind(this.close, this);
            this.onButtonClick = _.bind(this.onButtonClick, this);
            this.onAnotherOpen = _.bind(this.onAnotherOpen, this);

            this.el.moduleMobileMenuView = this;

            this.render();

            console.log('mobile-menu JS');
        },

        events: {
            'click': "onClick",
            'click .link-submenu': "onSubmenuButtonClick",
            'click .link-return': "onReturnButtonClick",
            'click .link-collapse': "onCollapseButtonClick",
            'scroll .module-mobile-submenu-content': "onContentScroll"
        },

        render: function (e) {
            console.log(111);

            this.$body = $("body:first");
            this.$window = $(window);
            this.$button = $(".module-mobile-menu-button");
            this.$wrapper = this.$el.find(".module-mobile-menu-wrapper");

            this.enableEvents();

            this.$el.addClass("rendered");
        },

        enableEvents: function () {
            //Remove previous events
            this.disableEvents();

            this.$button.on("click", this.onButtonClick);
            this.$window.on("resize", this.resize);
            this.$body.on("mobile-account-menu-open", this.onAnotherOpen);

            return this;
        },

        disableEvents: function () {
            this.$button.off("click", this.onButtonClick);
            this.$window.off("resize", this.resize);
            this.$body.off("mobile-account-menu-open", this.onAnotherOpen);

            return this;
        },

        onClick: function (e) {
            if (e && e.target === e.currentTarget) {
                if (e.preventDefault) e.preventDefault();

                this.close();
                this.applyScrollTop();
            }
        },

        onButtonClick: function (e) {
            if (e && e.preventDefault) e.preventDefault();
            var scrollTop = this.getScrollTop();

            if (this.$el.hasClass("open")) {
                this.close();
                this.applyScrollTop();
            } else {
                this.open();
            }
        },

        onAnotherOpen: function (e) {
            if (this.$el.hasClass("open")) {
                this.close();
            }
        },

        onSubmenuButtonClick: function (e) {
            if (e && e.preventDefault) e.preventDefault();

            var $element = $(e.currentTarget);

            var $submenu = $element.siblings(".module-mobile-submenu");

            if ($submenu.hasClass("open")) {
                TweenMax.to($submenu, this.animationTime, {
                    ease: Strong.easeOut,
                    x: "100%",
                    onCompleteScope: this,
                    onCompleteParams: [$submenu],
                    onComplete: function ($submenu) {
                        $submenu.removeClass("open");

                        this.checkSize();
                    }
                });
            } else {
                $submenu.addClass("open");

                TweenMax.fromTo($submenu, this.animationTime, {
                    x: "100%",
                }, {
                    ease: Strong.easeOut,
                    x: "0%",
                    onCompleteScope: this,
                    onComplete: function () {
                        this.checkSize();
                    }
                });
            }

            this.checkSize();
        },

        onReturnButtonClick: function (e) {
            if (e && e.preventDefault) e.preventDefault();

            var $element = $(e.currentTarget);

            var $submenu = $element.closest(".module-mobile-submenu");

            TweenMax.to($submenu, this.animationTime, {
                ease: Strong.easeOut,
                x: "100%",
                onCompleteScope: this,
                onCompleteParams: [$submenu],
                onComplete: function ($submenu) {
                    $submenu.removeClass("open");

                    this.checkSize();
                }
            });

            this.checkSize();
        },

        onCollapseButtonClick: function (e) {
            if (e && e.preventDefault) e.preventDefault();

            var $element = $(e.currentTarget);

            var $collapse = $element.siblings(".module-mobile-collapse");
            var $li = $element.closest("li");

            if ($li.hasClass("open")) {
                $collapse.slideUp(this.animationTime * 1000, function () {
                    $li.removeClass("open");
                });
            } else {
                $li.addClass("open");

                $collapse.hide();
                $collapse.slideDown(this.animationTime * 1000);
            }
        },

        getScrollTop: function () {
            var scrollTop = parseInt(this.$body.attr('data-scroll-top'), 10);
            scrollTop = isNaN(scrollTop) ? window.scrollY : scrollTop;

            return scrollTop;
        },

        setScrollTop: function (value) {
            this.$body.attr('data-scroll-top', value);
        },

        applyScrollTop: function () {
            var scrollTop = this.getScrollTop();
            this.setScrollTop('');

            _.delay(function () {
                window.scrollTo(0, scrollTop);
            }, 1);
        },

        open: function () {
            this.setScrollTop(this.getScrollTop());
            this.$el.addClass("open");
            this.$body.addClass("module-mobile-open");
            this.$button.addClass("open");

            if (this.tw1) this.tw1.kill();
            this.tw1 = TweenMax.fromTo(this.$el, this.animationTime, {
                alpha: 0
            }, {
                ease: Strong.easeOut,
                alpha: 1,
                onCompleteScope: this,
                onComplete: function () {
                    this.checkSize();
                }
            });

            var $submenu = this.$el.children(".module-mobile-submenu");
            $submenu.addClass("open");

            TweenMax.fromTo(this.$wrapper, this.animationTime, {
                x: "100%"
            }, {
                ease: Strong.easeOut,
                x: "0%",
                onCompleteScope: this,
                onComplete: function () {
                    this.checkSize();
                }
            });

            this.checkSize();

            this.$body.trigger(ModuleMobileMenuView.OPEN);
        },

        close: function () {
            if (!this.$el.hasClass("open")) return;

            this.$button.removeClass("open");
            this.$body.removeClass("module-mobile-open");

            this.tw1 = TweenMax.to(this.$el, this.animationTime, {
                ease: Strong.easeOut,
                alpha: 0,
                onCompleteScope: this,
                onComplete: function () {
                    this.$el.removeClass("open");
                    this.$el.find(".open").removeClass("open");
                    this.$el.find(".module-mobile-collapse").hide();
                }
            });

            this.checkSize();
        },

        checkSize: function () {
            var size = this.$body.hasClass("xs") || this.$body.hasClass("sm");

            var isOpen = this.$el.hasClass("open");

            if (size && isOpen) {
                var $submenus = this.$el.find(".module-mobile-submenu.open");

                var $submenusWithOpenChildren = $submenus.has(".open");
                var $submenusWithoutOpenChildren = $submenus.not($submenusWithOpenChildren);

                $submenusWithOpenChildren.addClass("has-open-submenu");
                $submenusWithoutOpenChildren.removeClass("has-open-submenu");

            } else if (!size && isOpen) {
                // Hack: give the browser some time to remove "open" and avoid maximum call stack.
                _.delay(_.bind(function () {
                    this.close();
                    this.setScrollTop('');
                }, this), 10);
            }
        },

        onContentScroll: function (e) {
            if (e && e.stopPropagation) e.stopPropagation();
        },

        resize: function (e) {
            var size = this.$body.hasClass("xs") || this.$body.hasClass("sm");
            var scrollTop = this.getScrollTop();

            var $container = $('#header .module-header-login-container'),
                $containerMobile = $('.module-mobile-menu .module-header-login-container');

            if (size) {
                this.checkSize();
                $containerMobile.append($container.children('.module-header-login:first'));
            } else {
                $container.append($containerMobile.children('.module-header-login:first'));
                this.close();
                this.setScrollTop('');
            }
        },
    });

    ModuleMobileMenuView.OPEN = "module-mobile-menu-open";
    ModuleMobileMenuView.CLOSE = "module-mobile-menu-close";

    module.exports = ModuleMobileMenuView;
});

define('views/MenuItemView',['require','exports','module','theme','backbone'],function (require, exports, module) {
    "use strict";

    // External dependencies.
    var theme = require("theme");
    var Backbone = require("backbone");

    var ModuleMenuItemView = Backbone.View.extend({

        initialize: function (options) {
            this.views = [];
            options = _.extend({}, this.$el.data(), options);
            this.render();
        },

        events: {
            'click .show-more-menu-items': "onShowMoreButtonClick",
        },

        render: function (e) {
            var totalItemsMobile = this.$el.data('totalItemsMobile');
            if (totalItemsMobile % 2 === 0) totalItemsMobile++;

            this.$el.find('.item').each(function (index, element) {
                if (index === totalItemsMobile) {
                    $(element).addClass('overlay');
                } else if (index > totalItemsMobile) {
                    $(element).addClass('hidden-xs');
                }
            });
        },

        onShowMoreButtonClick: function (e) {
            e.preventDefault();
            $(e.currentTarget).addClass('hidden');
            this.$el.find('.overlay').removeClass('overlay');

            this.$el.find('.item.hidden-xs').each(function (index, element) {
                setTimeout(function () {
                    $(element).fadeIn().removeClass('hidden-xs');
                }, index * 80);
            });
        },
    });

    module.exports = ModuleMenuItemView;
});

define('views/ProductsSliderView',['require','exports','module','theme','backbone'],function (require, exports, module) {
    "use strict";

    // External dependencies.
    var theme = require("theme");
    var Backbone = require("backbone");

    var ModuleProductsSliderView = Backbone.View.extend({

        views: null,
        columns: [1, 2, 3, 4],
        animationTime: 600,
        currentIndex: 0,
        currentColumn: 4,

        initialize: function (options) {
            this.views = [];

            options = _.extend({}, this.$el.data(), options);

            if (options.columns) {
                if (_.isArray(options.columns)) {
                    this.columns = options.columns;
                }
            }

            this.setIndex = _.bind(this.setIndex, this);
            this.prev = _.bind(_.throttle(this.prev, this.animationTime), this);
            this.next = _.bind(_.throttle(this.next, this.animationTime), this);

            this.resize = _.bind(this.resize, this);

            this.el.ModuleProductsSliderView = this;

            this.render();
        },

        events: {
            'click .module-products-slider-navigation-prev': "onPrevClick",
            'click .module-products-slider-navigation-next': "onNextClick",
            'swipeleft': "onSwipeLeft",
            'swiperight': "onSwipeRight"
        },

        render: function (e) {
            this.$wrapper = this.$('.module-products-slider-wrapper:first');
            this.$prev = this.$el.find(".module-products-slider-navigation-prev");
            this.$next = this.$el.find(".module-products-slider-navigation-next");
            this.$lis = this.$el.find(".module-grid-item");

            this.enableEvents();

            this.$el.addClass("rendered");

            this.resize();
        },

        onPrevClick: function (e) {
            if (e && e.preventDefault) e.preventDefault();

            this.prev();
        },

        onNextClick: function (e) {
            if (e && e.preventDefault) e.preventDefault();

            this.next();
        },

        onSwipeRight: function (e) {
            if (e && e.preventDefault) e.preventDefault();

            if ($('body').width() <= 768) {
                return;
            }

            this.prev();
        },

        onSwipeLeft: function (e) {
            if (e && e.preventDefault) e.preventDefault();

            if ($('body').width() <= 768) {
                return;
            }

            this.next();
        },

        prev: function (e) {
            if (this.$prev.hasClass('deactivate')) {
                return;
            }

            this.setIndex(-1, true);
        },

        next: function (e) {
            if (this.$next.hasClass('deactivate')) {
                return;
            }

            this.setIndex(1, true);
        },

        setIndex: function (index, relative) {
            var total = this.$lis.length;

            if (relative) {
                index = this.currentIndex + (index * (this.currentColumn - 1));
            }

            if (index < 0) {
                index = 0;
            }

            if (index > total - this.currentColumn) {
                index = total - this.currentColumn;
            }

            this.currentIndex = index;

            this.checkNavigation();

            var x = Math.floor(-100 * this.currentIndex);

            TweenMax.to(this.$lis, this.animationTime / 1000, {
                ease: Strong.easeInOut,
                x: x + "%"
            });

            this.updateNav();
        },

        updateNav: function () {
            var $items = this.$wrapper.children(),
                total = $items.length;

            if (this.currentIndex === 0) {
                this.$prev.addClass('deactivate');
            } else {
                this.$prev.removeClass('deactivate');
            }

            if (this.currentIndex === total - this.currentColumn) {
                this.$next.addClass('deactivate');
            } else {
                this.$next.removeClass('deactivate');
            }
        },

        checkNavigation: function () {
            var total = this.$lis.length;

            if (this.currentIndex <= 0) {
                this.$prev.addClass('deactivate');
            } else {
                this.$prev.removeClass('deactivate');
            }

            if (this.currentIndex >= total - this.currentColumn) {
                this.$next.addClass('deactivate');
            } else {
                this.$next.removeClass('deactivate');
            }
        },

        enableEvents: function () {
            this.disableEvents();

            return this;
        },

        disableEvents: function () {
            return this;
        },

        resize: function (e) {
            var widthTotal = this.$wrapper.children().width() * this.$wrapper.children().length;
            var widthAvailable = this.$wrapper.innerWidth();
            var size = $("body").attr("data-size") || "xs";
            var index = 0;

            switch (size) {
                case "lg":
                    index = 3;
                    break;
                case "md":
                    index = 2;
                    break;
                case "sm":
                    index = 1;
                    break;
                default:
                    index = 0;
            }

            //force 2 columns in .module-products
            if (!index && window.innerWidth >= 320 && this.$el.hasClass("module-products-force-columns")) {
                this.currentColumn = 2;
            } else if (!index && window.innerWidth >= 320) {
                this.currentColumn = 2;
            } else {
                this.currentColumn = this.columns[index];
            }

            if ($('body').width() > 768) {
                this.$('.module-products-infinite-wrapper').scrollLeft(0);
                this.$wrapper.scrollLeft(0);
            }

            if (widthTotal > widthAvailable) {
                this.$prev.addClass('visible').removeClass('hidden');
                this.$next.addClass('visible').removeClass('hidden');
                this.$wrapper.removeClass('disabled');
            } else {
                this.$prev.removeClass('visible').addClass('hidden');
                this.$next.removeClass('visible').addClass('hidden');
                this.$wrapper.addClass('disabled');
            }

            this.setIndex(0);
        },
    });

    module.exports = ModuleProductsSliderView;
});

define('views/PromotionCodesView',['require','exports','module','backbone'],function (require, exports, module) {
    'use strict';

    // External dependencies.
    var Backbone = require('backbone');

    var PromotionCodesView = Backbone.View.extend({

        initialize: function (options) {
            options = _.extend({}, this.$el.data(), options);
            this.$promotionCodesGrid = this.$el.find('.promotion-codes-grid');
            // this.onTruncateLongStrings();
        },

        onTruncateLongStrings: function () {
            var $text = this.$promotionCodesGrid.find('.truncate-text');
            $.each($text, function (index, value) {
                while($(value).find('.text').outerHeight() > $text.height()) {
                    $(value).find('.text').text(function (index, text){
                        return text.replace(/\W*\s(\S)*$/, '...');
                    });
                }
            });
        },

        render: function () {
            return this;
        },
    });

    module.exports = PromotionCodesView;
});

define('views/PromotionCodeDetailView',['require','exports','module','backbone'],function (require, exports, module) {
    'use strict';

    // External dependencies.
    var Backbone = require('backbone');

    var PromotionCodeDetailView = Backbone.View.extend({

        initialize: function (options) {
            options = _.extend({}, this.$el.data(), options);
            this.$productCodeWrapperXS = this.$el.find('#promotion-code-wrapper-xs'); 
            this.$productCodeWrapperLG = this.$el.find('#promotion-code-wrapper-lg');
        },

        events: {
            'click .get-code': 'onGetCode',
        },

        render: function () {
            return this;
        },

        onGetCode: function (e) {
            e.preventDefault();

            $.ajax({
                url: $(e.currentTarget).data('getCouponUrl'),
                method: 'POST',
                success: _.bind(this.onGetCodeSuccess, this),
                error: _.bind(this.onGetCodeError, this),
            });
        },

        onGetCodeSuccess: function (response) {
            var $codeWrapper= this.$el.find('.code-wrapper');
            $codeWrapper.find('.coupon').attr('data-payload', response.code);
            $codeWrapper.find('.coupon').text(response.code);

            if (response && response.status === 'success') {
                this.$el.find('.text-wrapper').fadeOut(500, function() {
                    $codeWrapper.fadeIn();
                });
            } else {
                this.$el.find('.text-wrapper .feedback').addClass('active').text(response.message);
                console.log('response error!');
                console.log(response);
            }
        },

        onGetCodeError: function (response) {
            console.log('response error!');
            console.log(response);
        },

        resize: function () {
            this.size = $('body').attr('data-size') || 'xs';

            if (this.size === 'xs' || this.size === 'sm') {
                console.log(111);
                this.$productCodeWrapperXS.append(this.$el.find('.promotion-code-wrapper'));
            } else {
                this.$productCodeWrapperLG.append(this.$el.find('.promotion-code-wrapper'));
            }
        },

    });

    module.exports = PromotionCodeDetailView;
});

define('views/SpotlightSliderView',['require','exports','module','theme','backbone'],function (require, exports, module) {
    'use strict';

    // External dependencies.
    var theme = require('theme');
    var Backbone = require('backbone');

    var ModuleSpotlightSliderView = Backbone.View.extend({

        views: null,
        $wrapper: null,
        columns: [1, 2, 3, 4],
        animationTime: 600,
        currentIndex: 0,
        currentColumn: 4,

        initialize: function (options) {
            this.views = [];

            options = _.extend({}, this.$el.data(), options);

            if (options.columns) {
                if (_.isArray(options.columns)) {
                    this.columns = options.columns;
                }
            }

            this.wrapperSmXs = options.wrapperSmXs;
            this.wrapperLgMd = options.wrapperLgMd;

            this.setIndex = _.bind(this.setIndex, this);
            this.prev = _.bind(_.throttle(this.prev, this.animationTime), this);
            this.next = _.bind(_.throttle(this.next, this.animationTime), this);
            this.resize = _.bind(this.resize, this);
            this.resizeSlider = _.bind(this.resizeSlider, this);
            this.debouncedResize = _.bind(_.debounce(this.debouncedResize, 50), this);
            this.el.ModuleSpotlightSliderView = this;
            this.render();
        },

        events: {
            'click .item-wrapper': 'onSelect',
            'click .prev': 'onPrevClick',
            'click .next': 'onNextClick',
            'swipeleft': "onSwipeLeft",
            'swiperight': "onSwipeRight"
        },

        render: function (e) {
            this.$wrapper = this.$('.wrapper:first');
            this.$prev = this.$el.find('.prev');
            this.$next = this.$el.find('.next');

            this.$el.addClass('rendered');
            this.resizeSlider();

            return this;
        },

        debouncedResize: function () {
            $(window).trigger('resize');
        },

        onSelect: function (e) {
            this.$('.item-wrapper').removeClass('selected');
            $(e.currentTarget).addClass('selected');
        },

        onPrevClick: function (e) {
            if (e && e.preventDefault) e.preventDefault();

            if (!this.$prev.hasClass('deactivate')) {
                this.prev();
            }
        },

        onNextClick: function (e) {
            if (e && e.preventDefault) e.preventDefault();

            if (!this.$next.hasClass('deactivate')) {
                this.next();
            }
        },

        onSwipeRight: function (e) {
            if (e && e.preventDefault) e.preventDefault();

            if ($('body').width() <= 768) {
                return;
            }

            this.prev();
        },

        onSwipeLeft: function (e) {
            if (e && e.preventDefault) e.preventDefault();

            if ($('body').width() <= 768) {
                return;
            }

            this.next();
        },

        prev: function (e) {
            if (this.$prev.hasClass('deactivate')) {
                return;
            }

            this.setIndex(-1, true);
        },

        next: function (e) {
            if (this.$next.hasClass('deactivate')) {
                return;
            }

            this.setIndex(1, true);
        },

        setIndex: function (index, relative) {
            var $items = this.$wrapper.children(),
                total = $items.length;

            if (!total) return;

            if (relative) {
                index = this.currentIndex + (index * this.currentColumn);
            }

            if (index < 0) {
                index = 0;

                if (index === this.currentIndex || index < 0) {
                    index = total - this.currentColumn;
                }
            } else if (index > total - this.currentColumn) {
                index = total - this.currentColumn;

                if (index === this.currentIndex || index < 0) {
                    index = 0;
                }
            }

            if (total < this.currentColumn) {
                index = 0;
            }

            this.currentIndex = index;

            var x = Math.floor(-100 * this.currentIndex);

            TweenMax.to($items, this.animationTime / 1000, {
                ease: Strong.easeInOut,
                x: x + '%',
                scale: 1.001,
            });

            this.updateNav();
        },

        updateNav: function () {
            var $items = this.$wrapper.children(),
                total = $items.length;

            if (this.currentIndex === 0) {
                this.$prev.addClass('deactivate');
            } else {
                this.$prev.removeClass('deactivate');
            }

            if (this.currentIndex === total - this.currentColumn) {
                this.$next.addClass('deactivate');
            } else {
                this.$next.removeClass('deactivate');
            }
        },

        resize: function () {
            this.transposeEl();
            this.resizeSlider();
        },

        transposeEl: function () {
            var $body = $('body');
            var size = $body.attr('data-size');
            var $target = null;

            if (!_.isEmpty(this.wrapperLgMd) && !_.isEmpty(this.wrapperSmXs)) {
                if (size === 'xs' || size === 'sm') {
                    $target = $('#' + this.wrapperSmXs);
                } else {
                    $target = $('#' + this.wrapperLgMd);
                }

                if (!this.$el.closest($target).length) {
                    $target.append(this.$el);
                }
            }
        },

        resizeSlider: function () {
            var widthTotal = this.$wrapper.children().width() * this.$wrapper.children().length;
            // var widthAvailable = this.$wrapper.innerWidth();
            var $body = $('body');
            var widthAvailable = this.$el.innerWidth();
            var $items = this.$wrapper.children();
            var needSlider = false;
            var containerSize = false;

            if ($body.width() > 768) {
                this.$('.wrapper').scrollLeft(0);

                if (widthAvailable >= 1140) {
                    this.currentColumn = 5;
                    if ($items.length > 5) {
                        needSlider = true;
                    }
                } else if (widthAvailable >= 910) {
                    this.currentColumn = 4;
                    if ($items.length > this.currentColumn) {
                        needSlider = true;
                    }
                } else {
                    this.currentColumn = 4;
                    if ($items.length > this.currentColumn) {
                        needSlider = true;
                    }
                }

                if (widthTotal > widthAvailable) {
                    this.$prev.addClass('visible');
                    this.$next.addClass('visible');
                } else {
                    this.$prev.removeClass('visible');
                    this.$next.removeClass('visible');
                }

                this.$el
                    .attr('data-container', containerSize)
                    .attr('data-need-slider', needSlider);
            } else {
                if ($items.outerWidth() * $items.length > widthAvailable) {
                    needSlider = true;
                } else {
                    needSlider = false;
                }

                this.$el.attr('data-need-slider', needSlider);
            }

            this.setIndex(0);
        }

    });

    module.exports = ModuleSpotlightSliderView;
});

define('views/SpotlightIconsView',['require','exports','module','theme','backbone'],function (require, exports, module) {
    'use strict';

    // External dependencies.
    var theme = require('theme');
    var Backbone = require('backbone');

    var ModuleSpotlightIconsView = Backbone.View.extend({

        initialize: function (options) {
            this.render();
        },

        events: {
            'click .item-wrapper': 'onSelect',
        },

        render: function (e) {
            this.$el.addClass('rendered');
            return this;
        },

        onSelect: function (e) {
            this.$('.item-wrapper').removeClass('selected');
            $(e.currentTarget).addClass('selected');
        },

    });

    module.exports = ModuleSpotlightIconsView;
});

define('views/TooltipView',['require','exports','module','theme','backbone'],function (require, exports, module) {
    "use strict";

    // External dependencies.
    var theme = require("theme");
    var Backbone = require("backbone");

    var ModuleTooltipView = Backbone.View.extend({

        views: null,
        $body: null,
        $window: null,
        $content: null,
        $header: null,

        initialize: function (options) {
            this.views = [];

            options = _.extend({}, this.$el.data(), options);

            this.onBodyClick = _.bind(this.onBodyClick, this);
            this.onBodyCloseEvent = _.bind(this.onBodyCloseEvent, this);
            this.onScroll = _.bind(this.onScroll, this);
            this.resize = _.bind(this.resize, this);
            this.openTooltip = _.bind(this.openTooltip, this);
            this.closeTooltip = _.bind(this.closeTooltip, this);
            this.onClick = _.bind(this.onClick, this);

            this.el.moduleTooltipView = this;

            this.render();
            this.setupCustoms();
        },


        setupCustoms: function(){
           //cart
            if($('.module-checkout-navigation .module-tooltip button[disabled]').length && $('.module-checkout-navigation .module-tooltip a.tt-helper').length == 0){
                $('.module-checkout-navigation .module-tooltip').append('<a class="tt-helper" href="#" style="position: absolute; left:0; top:0; width:100%; height: 100%;"></a>')
            }
        },

        events: {
            'mouseenter': "onMouseEnter",
            'mouseleave': "onMouseLeave",
            'click': "onClick",
            'tap': "onClick"
        },

        render: function (e) {
            this.$body = $("body:first");
            this.$window = $(window);
            this.$header = $("#header .header-content:first");

            this.$el.addClass("rendered");
        },

        enableEvents: function () {
            //Remove previous events
            this.disableEvents();

            this.$window.on("scroll", this.onScroll);

            this.$body.on("click", this.onBodyClick);
            this.$body.on(ModuleTooltipView.CLOSE, this.onBodyCloseEvent);

            return this;
        },

        disableEvents: function () {
            this.$window.off("scroll", this.onScroll);

            this.$body.off("click", this.onBodyClick);
            this.$body.off(ModuleTooltipView.CLOSE, this.onBodyCloseEvent);

            return this;
        },

        onMouseEnter: function (e) {
            this.openTooltip();
        },

        onMouseLeave: function (e) {
            this.closeTooltip();
        },

        onClick: function (e) {
            if (e && e.preventDefault) e.preventDefault();
            if (e && e.stopImmediatePropagation) e.stopImmediatePropagation();

            if (this.$content && this.$content.length) {
                this.closeTooltip();
            } else {
                this.openTooltip();
            }
        },

        openTooltip: function () {
            this.$body.trigger(ModuleTooltipView.CLOSE);

            var $content = this.$el.find(".module-tooltip-content");
            $content = $content.clone();
            $content.append('<span class="module-tooltip-content-triangle"></span>');

            this.$content = $content;
            this.$body.append($content);
            this.checkPosition();
            this.enableEvents();
        },

        closeTooltip: function () {
            this.disableEvents();

            if (this.$content) {
                this.$content.remove();
            }

            this.$content = null;
        },

        onBodyClick: function (e) {
            this.closeTooltip();
        },

        onBodyCloseEvent: function (e) {
            this.closeTooltip();
        },

        onScroll: function (e) {
            this.checkPosition();
        },

        resize: function (e) {
            this.checkPosition();
        },

        checkPosition: function (e) {
            if (!this.$content || !this.$content.length) return;

            this.$content.addClass("fixed");

            var windowTop = this.$window.scrollTop();
            var windowWidth = this.$window.width();

            var offset = this.$el.offset();

            var triangleLeft = 33;
            var triangleTop = 12;
            var margin = 15;

            var width = this.$content.outerWidth();
            var height = this.$content.outerHeight() + triangleTop;

            // Check if the size is correct
            if (width > windowWidth - margin * 2) {
                width = windowWidth - margin * 2;
            }

            //Check the top position
            var top = (offset.top - windowTop) - triangleTop;
            var y = "-100%";

            if (top - height < this.$header.outerHeight(true) + margin) {
                top = (offset.top - windowTop) + this.$el.height() + triangleTop;
                y = "0%";

                this.$content.addClass("bottom");
            } else {
                this.$content.removeClass("bottom");
            }

            //Check the left position
            var $triangle = this.$content.find(".module-tooltip-content-triangle:first");

            var left = offset.left - triangleLeft;

            var x = triangleLeft;

            if (left < margin) {
                left = margin;
                x = offset.left - left;

                if (x < 0) x = 0;
            } else if (left + width > windowWidth - margin) {
                left = windowWidth - margin - width;
                x = offset.left - left;
            }

            TweenMax.set(this.$content, {
                width: width,
                left: left,
                top: top,
                y: y
            });

            TweenMax.set($triangle, {
                left: x
            });
        },
    });

    ModuleTooltipView.CLOSE = "module-tooltip-view.close";

    module.exports = ModuleTooltipView;
});

define('views/FilterView',['require','exports','module','theme','backbone'],function (require, exports, module) {
    "use strict";

    // External dependencies.
    var theme = require("theme");
    var Backbone = require("backbone");

    var ModuleFilterView = Backbone.View.extend({

        views: null,
        $body: null,

        initialize: function (options) {
            this.views = [];

            options = _.extend({}, this.$el.data(), options);

            this.resize = _.bind(this.resize, this);
            this.forceCloseAllPanels = _.bind(this.forceCloseAllPanels, this);
            this.onBodyClick = _.bind(this.onBodyClick, this);
            this.onPanelResponsiveClick = _.bind(this.onPanelResponsiveClick, this);

            this.el.moduleFilterView = this;

            this.render(true);
        },

        events: {},

        render: function (forceClose) {
            this.$body = $("body:first");

            if (forceClose === true) {
                var size = this.$body.attr("data-size") || "xs";

                switch (size) {
                    case "xs":
                    case "sm":
                        _.defer(this.forceCloseAllPanels);
                        break;
                }
            }

            this.$el.addClass("rendered");
        },

        enableEvents: function () {
            //Remove previous events
            this.disableEvents();

            this.$body.on("click", this.onBodyClick);

            return this;
        },

        disableEvents: function () {
            this.$body.off("click", this.onBodyClick);

            return this;
        },

        onPanelResponsiveClick: function (e) {
            var size = this.$body.attr("data-size") || "xs";

            if (size == "sm") {
                if (e.preventDefault) e.preventDefault();
                if (e.stopImmediatePropagation) e.stopImmediatePropagation();

                var $element = $(e.currentTarget);

                if ($element.hasClass("collapsed")) {
                    this.showPanelResponsive($element);
                } else {
                    this.hidePanelResponsive();
                }
            }
        },

        showPanelResponsive: function ($element) {
            this.hidePanelResponsive();

            //button
            $element.removeClass("collapsed");
            $element.attr("aria-expanded", "true");

            //element
            var $collapsibles = this.$el.find($element.attr("href"));

            $collapsibles.addClass("in");
            $collapsibles.attr("aria-expanded", "true");

            this.enableEvents();
        },

        hidePanelResponsive: function () {
            var $responsive = this.$el.find(".panel-responsive-sm");

            var $collapsibles = $responsive.find(".collapse");

            $collapsibles.removeClass("in");
            $collapsibles.attr("aria-expanded", "false");

            var $buttons = $responsive.find('[data-toggle="collapse"]');
            $buttons.addClass("collapsed");
            $buttons.attr("aria-expanded", "false");

            this.disableEvents();
        },

        forceCloseAllPanels: function () {
            var $collapsibles = this.$el.find(".collapse");

            $collapsibles.removeClass("in");
            $collapsibles.attr("aria-expanded", "false");

            var $buttons = this.$el.find('.panel-responsive-sm [data-toggle="collapse"]');

            $buttons.addClass("collapsed");
            $buttons.attr("aria-expanded", "false");

            this.disableEvents();
        },

        onBodyClick: function (e) {
            var $element = $(e.target);

            var $parent = $element.closest(".panel-responsive-sm");

            if (!$parent.length) {
                this.hidePanelResponsive();
            }
        },

        resize: function (e) {
            var size = this.$body.attr("data-size") || "xs";

            var $buttons = this.$el.find('.panel-responsive-sm [data-toggle="collapse"]');
            if (size == "sm") {
                $buttons.on("click", this.onPanelResponsiveClick);
            } else {
                $buttons.off("click", this.onPanelResponsiveClick);
            }
        },
    });

    module.exports = ModuleFilterView;
});

define('views/HomeConnectView',['require','exports','module','theme','backbone','events/ThemeEvent','models/UserModel'],function (require, exports, module) {
    'use strict';

    // External dependencies.
    var theme = require('theme');
    var Backbone = require('backbone');
    var ThemeEvent = require('events/ThemeEvent');

    var UserModel = require('models/UserModel');
    var userModel = new UserModel();

    var ModuleHomeConnect = Backbone.View.extend({

        user: null,

        initialize: function (options) {
            this.options = options;

            this.render();
            this.addListeners();
            this.readPrograms();
        },

        render: function () {
            this.$buttons = $(this.options.params.buttonTag);

            this.$accessToken = $('[name="customer_home_connect_access_token"]');
            this.$refreshToken = $('[name="customer_home_connect_refresh_token"]');
            this.$tokenExpires = $('[name="customer_home_connect_token_expires"]');
            this.$el.addClass('rendered');

            return this;
        },

        addListeners: function () {
            $(window).on('show-home-connect', function() {
                window.location.reload(true);
            });

            $(window).on(ThemeEvent.FETCH_USER_COMPLETE + '.home-connect', _.bind(this.onFetchUserComplete, this));
            $(window).on(ThemeEvent.ERROR_FETCH_USER + '.home-connect', _.bind(this.onFetchUserComplete, this));
        },

        readPrograms: function () {
            var programs = null;

            if ($('input[type="hidden"][name="home_connect_programs"]').length) {
                programs = JSON.parse($('input[type="hidden"][name="home_connect_programs"]').val());
                programs = _.compact(programs);
            }

            this.programs = programs;
        },

        onFetchUserComplete: function (e, user) {
            $(window).off(ThemeEvent.FETCH_USER_COMPLETE + '.home-connect');
            $(window).off(ThemeEvent.ERROR_FETCH_USER + '.home-connect');
            this.updateUser(user);
        },

        updateUser: function (user) {
            this.user = user;
            this.refresh();
        },

        refresh: function () {
            var $btn = null,
                template = '',
                templateId = 'disabled',
                templates = {
                'connect': '#module-home-connect-button-connect',
                'start': '#module-home-connect-button-start',
                'disabled': '#module-home-connect-button-disabled',
            };

            if (this.user && this.user.user) {
                if (this.user.user.homeConnect && this.user.user.homeConnect.accessToken) {
                    templateId = 'start';
                    this.updateToken(this.user.user.homeConnect);
                } else {
                    templateId = 'connect';
                }
            }

            if (this.programs) {
                template = _.template($(templates[templateId]).text());

                _.each(this.programs, function(item, index) {
                    $btn = this.$buttons.eq(index);
                    if ($btn.length) {
                        $btn
                            .find('.wrapper')
                            .html(template({
                                homeConnectMode: item.mode,
                                homeConnectProgram: encodeURIComponent(JSON.stringify(item)),
                            }));
                    }
                }, this);
            }

            $(window).trigger('refresh-home-connect');
        },

        updateToken: function (homeConnect) {
            this.$accessToken.val(homeConnect.accessToken);
            this.$refreshToken.val(homeConnect.refreshToken);
            this.$tokenExpires.val(homeConnect.tokenExpires);
        },
    });

    module.exports = ModuleHomeConnect;
});

define('views/SalesforceContactFormView',['require','exports','module','theme','backbone','events/ThemeEvent','models/UserModel'],function (require, exports, module) {
    'use strict';

    // External dependencies.
    var theme = require('theme');
    var Backbone = require('backbone');
    var ThemeEvent = require('events/ThemeEvent');
    var UserModel = require('models/UserModel');
    var userModel = new UserModel();

    var ModuleSalesforceContactFormView = Backbone.View.extend({

        views: null,
        template: null,
        templateInputCoupon: null,
        feedbackTemplates: null,
        categoryData: null,
        category: '',
        requestReason: '',
        requestSubject: '',
        $form: null,
        $salesforceContent: null,
        $inputRequired: null,
        $submitButton: null,
        $feedbackWrapper: null,
        isSending: false,
        subject: '',
        formUrl: '',

        initialize: function (options) {
            options = _.extend({}, this.$el.data(), options);

            this.render();
            this.renderSalesforce();
            this.addEventListeners();
        },

        render: function (e) {

        },

        renderSalesforce: function (e) {
            this.template = _.template($('#salesforce-contact-form').html());
            this.templateInputCoupon = _.template($('#salesforce-contact-form-input-coupon').html());
            this.feedbackTemplates = {
                'feedback-success': $('#salesforce-contact-form-feedback-success').text(),
                'feedback-error': $('#salesforce-contact-form-feedback-error').text(),
                'feedback-error-fields': $('#salesforce-contact-form-feedback-error-fields').text(),
            };

            this.$form = this.$('.form-salesforce');
            this.$salesforceContent = this.$('.salesforce-content');
            this.$submitButton = this.$('button[type="submit"]');
            this.$feedbackWrapper = this.$('.feedback-wrapper');
            this.$el.addClass('rendered');

            this.url = this.$form.attr('action');
            return this;
        },

        addEventListeners: function () {
            $(document).on('change', '.form-salesforce .selectpicker', _.bind(this.onSelectPickerChange, this));
            this.$form.on('submit', _.bind(this.submitForm, this));

            $(window).on(ThemeEvent.FETCH_USER_COMPLETE + '.salesforce', _.bind(this.onFetchUserComplete, this));
            $(window).on(ThemeEvent.ERROR_FETCH_USER + '.salesforce', _.bind(this.onFetchUserComplete, this));

            return this;
        },

        getUrlParam: function (name) {
            var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
            if (!results) {
                return null;
            }

            return decodeURI(results[1]) || 0;
        },

        onFetchUserComplete: function (e) {
            $(window).off(ThemeEvent.FETCH_USER_COMPLETE + '.salesforce');
            $(window).off(ThemeEvent.ERROR_FETCH_USER + '.salesforce');

            var paramContactForm = this.getUrlParam('contact-form');
            this.showContactForm = paramContactForm === '1' || paramContactForm === 'true' ? true : false;

            if (!userModel.isLoggedIn() && !this.showContactForm) {
                this.$('#wrapper-login').removeClass('hidden');
                this.$('#wrapper-salesforce .restricted-access-wrapper').removeClass('hidden');
            } else {
                if (!userModel.hasCustomerGroup() || this.showContactForm) {
                    this.$('#wrapper-guest').removeClass('hidden');
                } else if (userModel.hasCustomerGroup('JO')) {
                    if (!userModel.hasEmail()) {
                        // Attribute email is empty. User must be a guest.
                        this.$('#wrapper-guest').removeClass('hidden');
                    } else {
                        this.$('#wrapper-jo').removeClass('hidden');
                        this.fillUserData('#wrapper-jo span[data-src]', 'text');
                    }
                } else if (userModel.hasCustomerGroup('HD')) {
                    this.$('#wrapper-hd').removeClass('hidden');
                    this.fillUserData('#wrapper-hd span[data-src]', 'text');
                    this.fillUserData('#wrapper-hd img[data-src]', 'img');
                    this.fillUserData('#wrapper-hd a[data-src]', 'link');
                }

                if (!this.showContactForm) {
                    this.fillUserData('input[data-src]', 'input');
                }
            }

            this.enableFields();
            this.$('#wrapper-salesforce').removeClass('hidden');

            this.$('#wrapper-loading').remove();
            this.$('#wrapper-login.hidden').remove();
            this.$('#wrapper-guest.hidden').remove();
            this.$('#wrapper-jo.hidden').remove();
            this.$('#wrapper-hd.hidden').remove();
            this.$('#wrapper-salesforce.hidden').remove();

            this.$inputRequired = this.$('input[required],select[required],textarea[required]');
            this.$form.find('input[required],select[required],textarea[required]').on('input change', _.bind(this.updateSubmitButton, this));

            $(window).trigger('resize');

            this.fetchForm();
        },

        fillUserData: function (selector, type) {
            var user = userModel.get('user');

            this.$(selector).each(function(index, el) {
                var i = 0, j = 0,
                    val = '',
                    $el = $(el),
                    sep = $el.data('sep'),
                    dataSrc = $el.data('src'),
                    dataSrcDeep = null,
                    regex = new RegExp(sep + '$');

                if (dataSrc.indexOf(',') >= 0) {
                    dataSrc = dataSrc.split(',');
                    for (i = 0; i < dataSrc.length; i++) {
                        if (dataSrc[i].indexOf('.') === -1) {
                            val += user[dataSrc[i]] + sep;
                        } else {
                            dataSrcDeep = dataSrc[i].split('.');
                            val += user[dataSrcDeep[0]][dataSrcDeep[1]] + sep;
                        }
                    }

                    val = val.replace(regex, '');
                } else {
                    if (dataSrc.indexOf('.') === -1) {
                        val += user[dataSrc];
                    } else {
                        dataSrcDeep = dataSrc.split('.');
                        val += user[dataSrcDeep[0]][dataSrcDeep[1]];
                    }
                }

                if (val) {
                    if (type === 'input') {
                        $el.val(val);
                    } else if (type === 'text') {
                        $el.text(val);
                    } else if (type === 'img') {
                        $el.attr('src', val);
                    } else if (type === 'link') {
                        $el.attr('href', $el.attr('href') + val);
                    }
                }
            });
        },

        fetchForm: function () {
            $.ajax({
                url: this.url,
                method: 'POST',
                success: _.bind(this.onFetchFormComplete, this),
                error: _.bind(function(jqXHR, ajaxSettings, thrownError) {
                    this.showFeedback(false);
                    console.log(jqXHR, ajaxSettings, thrownError);
                }, this),
            });
        },

        onFetchFormComplete: function(response) {
            if (response && response.data && response.data.sfCaseTree && response.data.sfCaseTree.category && response.data.sfCaseTree.category.length) {
                this.categoryData = response.data.sfCaseTree.category;
                this.$form.find('[name=send]').val(true);
                this.$salesforceContent.empty();
                this.buildFormItem(ModuleSalesforceContactFormView.TYPE_CATEGORY);
            } else {
                this.showFeedback(false);
                console.log(response);
            }
        },

        buildFormItem: function(type, firstValue, secondValue) {
            var i,
                source = null,
                payload = {
                    type: type,
                    options: [],
                };

            if (type === ModuleSalesforceContactFormView.TYPE_CATEGORY) {
                source = this.categoryData;
            } else if (type === ModuleSalesforceContactFormView.TYPE_REQUEST_REASON || type === ModuleSalesforceContactFormView.TYPE_REQUEST_SUBJECT) {
                if (type === ModuleSalesforceContactFormView.TYPE_REQUEST_REASON) {
                    this.$('select[data-type="' + ModuleSalesforceContactFormView.TYPE_REQUEST_REASON + '"]').closest('.bootstrap-select').remove();
                    this.$('select[data-type="' + ModuleSalesforceContactFormView.TYPE_REQUEST_SUBJECT + '"]').closest('.bootstrap-select').remove();
                } else {
                    this.$('select[data-type="' + ModuleSalesforceContactFormView.TYPE_REQUEST_SUBJECT + '"]').closest('.bootstrap-select').remove();
                }

                if (!_.isEmpty(firstValue)) {
                    source = _.findWhere(this.categoryData, {value: firstValue});
                    source = source.requestReason;
                    this.requestReason = source;
                }

                if (type === ModuleSalesforceContactFormView.TYPE_REQUEST_SUBJECT) {
                    if (!_.isEmpty(secondValue)) {
                        source = _.findWhere(source, {value: secondValue});
                        source = source.requestSubject;
                        this.requestSubject = source;
                    } else {
                        source = null;
                    }
                }

            }

            if (source && source.length) {
                for (i = 0; i < source.length; i++) {
                    payload.options.push({
                        label: source[i].label,
                        value: source[i].value,
                    });
                }

                this.$salesforceContent.append(this.template(payload));
                this.enableFields();
                this.$('.selectpicker').selectpicker();
            }

            if (/GUTSCHEIN/i.test(secondValue) && !this.$('#coupon').length) {
                this.$salesforceContent.append(this.templateInputCoupon());
            }
        },

        removeInputCoupon: function() {
            this.$('#coupon').remove();
        },

        enableFields: function () {
            if (userModel.isLoggedIn() || this.showContactForm) {
                this.$('[data-restricted-access="true"][disabled="disabled"]').removeAttr('disabled').attr('data-restricted-access', false);
            }
        },

        onSelectPickerChange: function (e) {
            var el = e.currentTarget,
                $el = $(el),
                $firstSelector = null;

            // Check if the select element is inside this view.
            if (this.$el.has(el)) {
                if ($el.data('type') === ModuleSalesforceContactFormView.TYPE_CATEGORY) {
                    this.removeInputCoupon();
                    this.buildFormItem(ModuleSalesforceContactFormView.TYPE_REQUEST_REASON, $el.val());
                    this.subjectCategory = $el.val();
                    this.subject = this.subjectCategory;
                } else if ($el.data('type') === ModuleSalesforceContactFormView.TYPE_REQUEST_REASON) {
                    if (_.isEmpty($el.val())) {
                        this.removeInputCoupon();
                    }

                    $firstSelector = this.$('.selectpicker[data-salesforce="true"][data-type="' + ModuleSalesforceContactFormView.TYPE_CATEGORY + '"]');
                    this.buildFormItem(ModuleSalesforceContactFormView.TYPE_REQUEST_SUBJECT, $firstSelector.val(), $el.val());
                    this.subjectReason = $el.val();
                    this.subject = this.subjectCategory + ' - ' + this.subjectReason;
                } else if ($el.data('type') === ModuleSalesforceContactFormView.TYPE_REQUEST_SUBJECT) {
                    this.subjectSubject = $el.val();
                    this.subject = this.subjectCategory + ' - ' + this.subjectReason + ' - ' + this.subjectSubject;
                }
            }

            this.$el.find('input[name="subject"]').val(this.subject);
            this.updateSubmitButton();
        },

        updateSubmitButton: function(e) {
            var allInput = true,
                allSelect = true;

            if (this.isSending) {
                return;
            }

            this.$inputRequired.each(function (index, el) {
                var $el = $(el);

                if ($el.is('[type="checkbox"]') && !$el.is(':checked')) {
                    allInput = false;
                } else if (!$el.val()) {
                    allInput = false;
                }
            });

            this.$('.selectpicker[data-salesforce="true"]').each(function (index, el) {
                var $el = $(el);
                if (!$el.val()) {
                    allSelect = false;
                }
            });

            if (allInput && allSelect) {
                this.refreshSubmitButton(true);
            } else {
                this.refreshSubmitButton(false);
            }
        },

        refreshSubmitButton: function(active) {
            if (active) {
                this.$submitButton.removeClass('btn-disabled').prop('disabled', false);
            } else {
                this.$submitButton.addClass('btn-disabled').prop('disabled', true);
            }
        },

        submitForm: function(e) {
            e.preventDefault();

            if (this.isSending) {
                return false;
            }

            this.isSending = true;
            this.refreshSubmitButton(false);

            $.ajax({
                url: this.url,
                method: 'POST',
                data: this.$form.serialize(),
                success: _.bind(this.onSendFormComplete, this),
                error: _.bind(function(jqXHR, ajaxSettings, thrownError) {
                    this.showFeedback(false);
                    console.log(jqXHR, ajaxSettings, thrownError);
                }, this),
            });
        },

        onSendFormComplete: function(response) {
            if (response && response.data && response.data.sfCreateCase && response.data.sfCreateCase.success === true) {
                this.showFeedback(true);
            } else {
                this.showFeedback(false);
            }
        },


        showFeedback: function (success) {
            var templateId = '',
                transitionEvent = ThemeEvent.getTransitionEvent();

            if (success) {
                templateId = 'feedback-success';
            } else {
                templateId = 'feedback-error';
            }

            this.$form.one(transitionEvent, $.proxy(function(e) {
                var $feedbackWrapper = this.$feedbackWrapper;
                $feedbackWrapper.empty().append(_.template(this.feedbackTemplates[templateId]));
                $feedbackWrapper.removeClass('collapsed').addClass('expanded');
            }, this));

            this.$form.addClass('collapsed');
        },
    });

    ModuleSalesforceContactFormView.TYPE_CATEGORY = 'category'
    ModuleSalesforceContactFormView.TYPE_REQUEST_REASON = 'reason'
    ModuleSalesforceContactFormView.TYPE_REQUEST_SUBJECT = 'subjectType'

    module.exports = ModuleSalesforceContactFormView;
});

define('views/RestrictedAccessView',['require','exports','module','theme','backbone','bowser','events/ThemeEvent','models/UserModel'],function (require, exports, module) {
    'use strict';

    // External dependencies.
    var theme = require('theme');
    var Backbone = require('backbone');
    var bowser = require('bowser');

    var ThemeEvent = require('events/ThemeEvent');
    var UserModel = require('models/UserModel');
    var userModel = new UserModel();


    var ModuleRestrictedAccessView = Backbone.View.extend({

        initialize: function (options) {
            this.options = _.extend({}, this.$el.data(), options);

            this.render();
            this.addEventListeners();
        },

        render: function () {
            this.$modal = $('#modal-login-registration');
        },

        addEventListeners: function () {
            $('body').on('click.module-restricted-access-view', '[data-restricted-access="true"]', _.bind(this.onCheckToken, this));
            $(window).on(ThemeEvent.RESTRICTED_ACCESS, _.bind(this.onCheckToken, this));

            this.listenTo(userModel, ThemeEvent.CHECK_TOKEN_COMPLETE, this.checkTokenComplete);
            this.listenTo(userModel, ThemeEvent.ERROR_CHECK_TOKEN, this.checkTokenError);
            this.listenTo(userModel, ThemeEvent.RESTRICTED_ACCESS_COMPLETE, this.onRestrictedAccessComplete);

            this.$modal.on('hidden.bs.modal', _.bind(this.onHiddenModal, this));
        },

        onCheckToken: function (e, eventName, eventParams) {
            e.preventDefault();

            var event = '',
                params = '',
                $invoker = $(e.currentTarget);

            if (e.type === ThemeEvent.RESTRICTED_ACCESS) {
                event = eventName;
                params = eventParams;
            } else {
                event = $invoker.data('event');
                params = $invoker.data('params');
            }

            userModel.set('event', event);
            userModel.set('params', params);

            userModel.checkToken();

        },

        checkTokenComplete: function (e) {
            // Check if the token is valid.
            if (e.valid) {
                userModel.triggerEvent();
            } else {
                $('#modal-login-registration').modal('show');
            }
        },

        checkTokenError: function (e) {
            $('#modal-login-registration').modal('show');
        },

        onRestrictedAccessComplete: function (e) {
            $('#modal-login-registration').modal('hide');
        },

        onHiddenModal: function (e) {
            userModel.set('event', '');
            userModel.set('params', '');
        },

    });

    module.exports = ModuleRestrictedAccessView;
});

define('views/NewsletterView',['require','exports','module','theme','backbone','events/ThemeEvent','models/UserModel'],function (require, exports, module) {
    'use strict';

    // External dependencies.
    var theme = require('theme');
    var Backbone = require('backbone');
    var ThemeEvent = require('events/ThemeEvent');
    var UserModel = require('models/UserModel');
    var userModel = new UserModel();

    var ModuleNewsletterView = Backbone.View.extend({

        userIsGuest: true,
        cookieName: 'newsletter',
        cookieExpires: 30 * 24 * 60 * 60,
        cookieExpiresSubscribed: 365 * 24 * 60 * 60,
        timerDuration: 60 * 1000,

        initialize: function (options) {
            options = _.extend({}, this.$el.data(), options);
            this.render();
            this.addListeners();
            this.checkSubscription();
        },

        events: {},

        render: function (e) {
            this.$el.addClass('rendered');
            return this;
        },

        addListeners: function () {
            $(window).on(ThemeEvent.FETCH_USER_COMPLETE + '.home-connect', _.bind(this.onFetchUserComplete, this));
            $(window).on(ThemeEvent.ERROR_FETCH_USER + '.home-connect', _.bind(this.onFetchUserComplete, this));

            this.$el.on('hidden.bs.modal', _.bind(this.onHiddenModal, this));
        },

        onFetchUserComplete: function (e, user) {
            // Check
                // - if the modal-newsletter is enabled AND not disabled (white list can be overwritten by a blacklist).
                // - if user has not refused to subscribe the newsletter.
                // - if the user is not logged in or logged in as guest.
            var canShowNewsletterModal = $('.newsletter-modal-enabled').length && $('.newsletter-modal-disabled').length === 0;
            if (canShowNewsletterModal && !this.isCookieSet() && (!userModel.isLoggedIn() || !userModel.hasCustomerGroup())) {
                this.startTimer();
            }
        },

        onHiddenModal: function (e) {
            userModel.saveCookie(this.cookieName, true, this.cookieExpires);
        },

        isCookieSet: function () {
            return userModel.readCookie(this.cookieName);
        },

        startTimer: function () {
            _.delay(_.bind(this.showNewsletter, this), this.timerDuration);
        },

        showNewsletter: function () {
            if ($('.modal').is(':visible')) {
                this.startTimer();
            } else {
                this.$el.modal('show');
            }

        },

        checkSubscription: function () {
            // Check if user is subscribed to the newsletter, then set cookie for one year
            if ($('.newsletter-subscription').length !== 0) {
                userModel.saveCookie(this.cookieName, true, this.cookieExpiresSubscribed);
            }
        },
    });

    module.exports = ModuleNewsletterView;
});

define('views/AddToCartButtonStickyView',['require','exports','module','theme','backbone'],function (require, exports, module) {
    'use strict';

    // External dependencies.
    var theme = require('theme');
    var Backbone = require('backbone');

    var AddToCartButtonStickyView = Backbone.View.extend({

        $body: null,
        $window: null,

        initialize: function (options) {
            this.render();
            this.$window.on('scroll', _.bind(this.onScroll, this));
        },

        render: function (e) {
            this.$window = $(window);
            this.$body = $('body');

            this.$el.addClass('rendered');
        },

        onScroll: function (e) {
            var scrollPosition = this.$window.scrollTop(),
                minScrollPosition = $('.module-product-detail-content .btn.btn-red').offset().top;

            var size = this.$body.attr('data-size') || 'xs';

            var isSticky = (scrollPosition > minScrollPosition) && (size === 'sm' || size === 'xs');

            if (isSticky && !this.$el.hasClass('active')) {
                this.$el.addClass('active');
            } else if (!isSticky && this.$el.hasClass('active')) {
                this.$el.removeClass('active');
            }
        },

        resize: function (e) {
            this.onScroll();
        },
    });

    module.exports = AddToCartButtonStickyView;
});

define('views/SwiperView',['require','exports','module','theme','backbone','swiper'],function (require, exports, module) {
    "use strict";

    // External dependencies.
    var theme = require('theme');
    var Backbone = require('backbone');
    var Swiper = require('swiper');

    var ModuleSwiperView = Backbone.View.extend({

        templateBullet: null,

        initialize: function (options) {
            this.options = _.extend({}, options);
            this.render();
        },

        render: function () {
            this.swiper();
            return this;
        },

        swiper: function () {
            var options = {
                slidesPerView: 1,
                spaceBetween: 30,
                loop: true,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
            };

            options = _.extend({}, options, this.options, this.$el.data('swiper'));

            var swiper = new Swiper(this.$('.swiper-container'), options);
        },
    });

    module.exports = ModuleSwiperView;
});

define('views/BlogCardProductRecipe',['require','exports','module','backbone','models/UserModel'],function (require, exports, module) {
    'use strict';

    // External dependencies.
    var Backbone = require('backbone');
    var UserModel = require('models/UserModel');


    var userModel = new UserModel();


    var BlogCardProductRecipe = Backbone.View.extend({

        template: null,

        initialize: function (payload) {
            this.views = [];

            payload = _.extend({}, this.$el.data(), payload);

            this.onSuccess = _.bind(this.onSuccess, this);
            this.onError = _.bind(this.onError, this);

            this.render(payload.options);
        },

        render: function (options) {
            this.template = _.template($(this.$el.data('template')).text());

            if (options.recipe || options.article) {
                this.renderCard(options);
            } else if (options.product) {
                this.$form = this.$('form');
                this.fetchProduct(options);
            }

            return this;
        },

        fetchProduct: function (options) {
            var data = this.$form.serialize();

            $.ajax({
                url: isapi.urls.productsFetch,
                method: 'GET',
                data: data,
                beforeSend: $.proxy(function(xhr) {
                    userModel.addAuthToken(xhr);
                }, this),
                success: this.onSuccess,
                error: this.onError,
            });
        },

        onSuccess: function (response) {
            var hasProducts = (response && response.products && response.products.length);
            var options = null;

            if (hasProducts) {
                options = {
                    title: response.products[0].name,
                    img: response.products[0].image_thumb,
                    thumbs: response.products[0].thumbs,
                    link: response.products[0].url_product_view,
                    product: true,
                };

                this.renderCard(options);
            } else {
                this.hideColumn();
            }
        },

        onError: function (e) {
            this.hideColumn();
        },

        renderCard: function (options) {
            var html = this.template({card: options});
            this.$el.append(html);
            this.$el.addClass('rendered');
        },

        hideColumn: function () {
            this.$el.closest('.module-blog-card-product-recipe-item').remove();
        },

    });

    module.exports = BlogCardProductRecipe;
});

define('models/ZipcodeCheckModel',['require','exports','module','backbone','events/ThemeEvent'],function (require, exports, module) {
    'use strict';

    // External dependencies.
    var Backbone = require('backbone');
    var ThemeEvent = require('events/ThemeEvent');

    /**
     * ZipcodeCheck  model
     * @type {Backbone.Model}
     */
    var ZipcodeCheckModel = Backbone.Model.extend({

        /**
         * true if loading zip.
         */
        loadingZip: false,

        defaults: {
            zip: '',
            checkingZip: [], // has the zip codes that must be checked, using array here to handle request delay.
        },

        initialize: function (options) {
            this.addEventListeners();
        },

        addEventListeners: function () {
            this.listenTo(this, 'change:zip', this.zipChanged);
        },

        /**
         * Add token to data.
         * ATTENTION: This is NOT the authToken!!!
         *
         * @return {String}
         */
        getToken: function () {
            return isapi.token;
        },

        checkZip: function () {
            var data = {
                zip: this.get('zip'),
                country: this.get('country'),
                token: this.getToken(),
            };

            this.get('checkingZip').push(this.get('zip'));
            this.trigger('change:checkingZip', this, this.get('checkingZip'));

            $.ajax({
                url: isapi.urls.zipCheck,
                method: 'POST',
                data: data,
                success: $.proxy(function (response) {
                    this.get('checkingZip').shift();
                    this.trigger('change:checkingZip', this, this.get('checkingZip'));

                    if (this.get('checkingZip').length) return;

                    if (response && response.status && response.status === 'success' && response.content && response.content.status === 'success' && response.content.zip && String(response.content.zip) === String(this.get('zip')) && String(this.get('zip'))) {
                        if (response.content.outlet) {
                            this.set('city', response.content.outlet);
                        } else {
                            this.set('city', '');
                        }

                        if (response.content.vs) {
                            this.set('vs', response.content.vs);
                        } else {
                            this.set('vs', '');
                        }

                        this.trigger(ThemeEvent.CHECK_ZIP_COMPLETE);
                    } else if (response && response.status && response.status === 'success' && response.content && response.content.status === 'error') {
                        this.trigger(ThemeEvent.ERROR_ZIP_NOT_FOUND);
                    }
                }, this),
                error: $.proxy(function() {
                    this.get('checkingZip').shift();
                    this.trigger(ThemeEvent.ERROR_UNKNOWN);
                }, this),
            });
        },

    });

    module.exports = ZipcodeCheckModel;
});

define('views/ZipcodeCheckView',['require','exports','module','backbone','events/ThemeEvent','models/ZipcodeCheckModel'],function (require, exports, module) {
    "use strict";

    // External dependencies.
    var Backbone = require('backbone');
    var ThemeEvent = require('events/ThemeEvent');
    var ZipcodeCheckModel = require('models/ZipcodeCheckModel');


    var ModuleZipcodeCheckView = Backbone.View.extend({

        isValid: false,
        zip: '',
        $country: null,
        $city: null,
        $msg: null,

        tmplZipFound: null,
        tmplZipNotFound: null,
        tmplVsNotFound: null,

        initialize: function (options) {
            options = _.extend({}, this.$el.data(), options);
            this.zipcodeCheckModel = new ZipcodeCheckModel();

            this.render();
            this.addEventListeners();
        },

        events: {
            'input': 'onInput',
            'blur': 'onBlur',
        },

        render: function (e) {
            this.$msg = $(this.$el.data('msg-target'));
            this.$country = $(this.$el.data('country-selector'));
            this.$city = $(this.$el.data('city-selector'));

            var htmlFound, htmlNotFound, htmlVsNotFound;

            if (this.$el.closest('form').hasClass('new-born-form')) {
                htmlFound = $('#module-zipcode-check-msg-zip-found-new-born').html();
                htmlNotFound = $('#module-zipcode-check-msg-zip-not-found-new-born').html();
            } else {
                htmlFound = $('#module-zipcode-check-msg-zip-found').html();
                htmlNotFound = $('#module-zipcode-check-msg-zip-not-found').html();
            }

            htmlVsNotFound = $('#module-zipcode-check-msg-vs-not-found-new-born').html();

            this.tmplZipFound = _.template(htmlFound);
            this.tmplZipNotFound = _.template(htmlNotFound);
            this.tmplZipVsNotFound = _.template(htmlVsNotFound);

            this.$el.addClass('rendered');
        },

        addEventListeners: function () {
            this.listenTo(this.zipcodeCheckModel, ThemeEvent.CHECK_ZIP_COMPLETE, this.onCheckZipComplete);
            this.listenTo(this.zipcodeCheckModel, ThemeEvent.ERROR_ZIP_NOT_FOUND, this.onCheckZipNotFound);

            this.$country.on('change', this.onCountryChange.bind(this));
        },

        onCountryChange: function (e) {
            var country = this.$country.val(),
                length = country === 'DE' ? 5 : country === 'AT' ? 4 : 0,
                pattern = '^\\d{' + length + '}$';

            this.$el.attr('pattern', pattern);
            this.onInput();
        },

        onInput: function (params) {
            var country = this.$country.val(),
                zip = this.$el.val(),
                maxZipLength = country === 'DE' ? 5 : country === 'AT' ? 4 : 0,
                check = zip.length === maxZipLength;

            this.isValid = false;
            this.emptyMessage();
            this.$el.removeClass('is-valid is-invalid');

            this.zipcodeCheckModel.set('country', country);
            this.zipcodeCheckModel.set('zip', zip);

            this.$el.trigger(ThemeEvent.CHECK_ZIP_UNVERIFYED);

            if (check) {
                this.zipcodeCheckModel.checkZip();
            } else if (zip.length > maxZipLength) {
                this.zipcodeCheckModel.checkZip();
            }
        },

        onBlur: function (e) {
            if (this.isValid && this.$city.length) {
                this.$city.val(this.zipcodeCheckModel.get('city'));
                var city = this.$city[0];
                setTimeout(function () {
                    city.selectionStart = city.selectionEnd = 10000;
                    $(city).trigger('refresh');
                }, 0);
            }
        },

        onCheckZipComplete: function (e) {
            var $form = this.$el.closest('form');

            if ($form.hasClass('new-born-form') && $form.attr('data-step') === '1') {
                var obj = {
                    city: this.zipcodeCheckModel.get('city'),
                    country: this.zipcodeCheckModel.get('country'),
                    vs: this.zipcodeCheckModel.get('vs')
                }

                if (obj.vs !== '') {
                    this.$el.trigger(ThemeEvent.CHECK_ZIP_COMPLETE, obj);

                    this.updateMessage(this.tmplZipFound());

                    this.$el.addClass('is-valid');
                    this.isValid = true;
                } else {
                    this.onCheckZipVsNotFound();
                }
            } else {
                this.updateMessage(this.tmplZipFound());

                this.$el.addClass('is-valid');
                this.isValid = true;
            }
        },

        onCheckZipNotFound: function (e) {
            this.updateMessage(this.tmplZipNotFound());
            this.$el.addClass('is-invalid');

            var $form = this.$el.closest('form');

            if ($form.hasClass('new-born-form') && $form.attr('data-step') === '1') {
                this.$el.trigger(ThemeEvent.ERROR_ZIP_NOT_FOUND);
            }
        },

        onCheckZipVsNotFound: function (e) {
            this.updateMessage(this.tmplZipVsNotFound());
            this.$el.addClass('is-invalid');
            this.$el.trigger(ThemeEvent.ERROR_ZIP_NOT_FOUND);
        },

        emptyMessage: function () {
            this.$msg.empty().addClass('hidden');
        },

        updateMessage: function (message) {
            this.$msg.html(message).removeClass('hidden');
        },

    });

    module.exports = ModuleZipcodeCheckView;
});

define('views/CodeConfirmationView',['require','exports','module','backbone','views/FormView','events/ThemeEvent'],function (require, exports, module) {
    'use strict';

    // External dependencies.
    var Backbone = require('backbone');

    var FormView = require('views/FormView');
    var ThemeEvent = require('events/ThemeEvent');

    var ModuleCodeConfirmationView = Backbone.View.extend({

        views: null,

        initialize: function (options) {
            this.views = [];

            options = _.extend({}, this.$el.data(), options);
            this.render();
        },

        render: function (e) {
            this.$el.addClass('rendered');
        },
    });

    // Add global listener.
    $(window).on(ThemeEvent.APPEND_CONFIRMATION_CODE, function (e, container) {
        var $container = $(container);
        var tmpl = _.template($('#tmpl-code-confirmation').html());

        if ($container.length) {
            $container.empty().append(tmpl());

            var $target = $container.find('.module-code-confirmation');

            new ModuleCodeConfirmationView({
                el: $target,
            });

            $(window).trigger(ThemeEvent.APPEND_CONFIRMATION_CODE_COMPLETE, container);
        } else {
            console.error('container "' + container + '" not found!');
        }
    })

    module.exports = ModuleCodeConfirmationView;
});

define('views/VideoExternView',['require','exports','module','backbone'],function (require, exports, module) {
    'use strict';

    // External dependencies.
    var Backbone = require('backbone');

    var VideoExternView = Backbone.View.extend({

        initialize: function (options) {
            this.render();
            this.resize = _.bind(this.resize, this);

            document.addEventListener('OTC0003', _.bind(this.loadVideo, this));
            _.delay(_.bind(this.showMessage, this), 1000);
        },

        render: function (e) {
            this.$el.addClass('rendered');
            this.resize();
        },

        loadVideo: function () {
            this.$el.find('.placeholder').empty();
        },

        showMessage: function () {
            this.$('.thumb-btn-wrapper .info-box').addClass('rendered');
        },

        resize: function () {
            var needScroll = false;
            var $infoBox = this.$('.info-box');
            var $text = this.$('.info-box .text');

            $infoBox.removeClass('need-scroll');

            _.defer(function () {
                if ($text.length) {
                    needScroll = $text[0].scrollHeight > $text[0].clientHeight;
                }

                if (needScroll) {
                    $infoBox.addClass('need-scroll');
                }
            }, 10);
        },
    });

    module.exports = VideoExternView;
});

define('views/ToTopButtonView',['require','exports','module','backbone'],function (require, exports, module) {
    'use strict';

    // External dependencies.
    var Backbone = require('backbone');

    var ToTopButtonView = Backbone.View.extend({

        initialize: function (options) {
            options = _.extend({}, this.$el.data(), options);

            // Check if add-to-cart-button-sticky is present on the site.
            // Only setup the button if it IS NOT.
            if ($('.module-add-to-cart-button-sticky').length === 0) {
                this.render().enableEvents().resize();
                this.lastScrollTop = this.getScrollTop();
            }
        },

        events: {
            'click a[href="#"]': 'onClick',
        },

        onPreventDefault: function (e) {
            e.preventDefault();
            return false;
        },

        render: function () {
            return this;
        },

        enableEvents: function () {
            _.delay(_.bind(function() {
                $(window).on('scroll', _.bind(this.onScroll, this));
            }, this), 500);

            return this;
        },

        onClick: function (e) {
            if (e && e.preventDefault) e.preventDefault();

            window.scrollTo(0, 0);
        },

        onScroll: function () {
            var scrollTop = this.getScrollTop();
            var totalScrollTop = scrollTop <= 0 ? 0 : scrollTop;
            var scrollRange = $(document).height() - $(window).height();

            if (scrollTop > this.lastScrollTop) {
                // Scroll down.

                if (this.size === 'lg' || this.size === 'md') {
                    this.$el.removeClass('inactive');
                } else {
                    if (totalScrollTop > scrollRange - 90) {
                        this.$el.removeClass('inactive');
                    } else {
                        this.$el.addClass('inactive');
                    }
                }
            } else {
                // Scroll up.
                if (totalScrollTop < 100) {
                    this.$el.addClass('inactive');
                } else if (this.size === 'sm' || this.size === 'xs') {
                    this.$el.removeClass('inactive');
                }
            }

            // For Mobile or negative scrolling
            this.lastScrollTop = totalScrollTop;

            if (this.size === 'lg' || this.size === 'md') {
                var footerHeight = $('#footer').height();
                var initialBottom = getComputedStyle(this.el).getPropertyValue('--bottom-initial');

                if (footerHeight > 100) {
                    // Footer is too big.
                    footerHeight = 0;
                }

                var bottom = 0;
                if (totalScrollTop > scrollRange - footerHeight) {
                    bottom = (parseInt(initialBottom, 10) + footerHeight) - (scrollRange - totalScrollTop);
                    this.$el[0].style.setProperty('--bottom', bottom + 'px');
                } else {
                    bottom = initialBottom;
                    this.$el[0].style.setProperty('--bottom', bottom);
                }
            } else {
                var initialBottom = getComputedStyle(this.el).getPropertyValue('--bottom-initial');
                this.$el[0].style.setProperty('--bottom', initialBottom);
            }
        },

        getScrollTop: function () {
            return window.pageYOffset || document.documentElement.scrollTop;
        },

        resize: function () {
            this.size = $('body').attr('data-size') || 'xs';
        },

    });

    module.exports = ToTopButtonView;
});

define('views/VoucherHeaderView',['require','exports','module','backbone','models/UserModel','Clock'],function (require, exports, module) {
    'use strict';

    // External dependencies.
    var Backbone = require('backbone');

    var UserModel = require('models/UserModel');
    var userModel = new UserModel();

    var Clock = require('Clock');

    var VoucherHeaderView = Backbone.View.extend({

        initialize: function (options) {
            options = _.extend({}, this.$el.data(), options);
            this.cookieName = 'VoucherBanner';

            document.addEventListener('OTC0003', _.bind(this.validate, this));
        },

        validate: function (e) {
            var voucherCookie = this.readCookie();
            var queryString;
            var urlParams;
            var actionId;
            var voucherCode;

            // Get actionId and voucherCode, either from cookie or GET params
            if (voucherCookie === null) {
                queryString = window.location.search;
                urlParams = new URLSearchParams(queryString);
                actionId = urlParams.get('actionId');
                voucherCode = urlParams.get('voucherCode');
            } else {
                queryString = '?' + voucherCookie;
                urlParams = new URLSearchParams(queryString);
                actionId = urlParams.get('actionId');
                voucherCode = urlParams.get('voucherCode');
            }

            if (actionId && voucherCode) {
                this.voucherHeaderAjax = $.ajax({
                    url: isapi.urls.voucherCampaign,
                    method: 'GET',
                    data: 'actionId=' + actionId + '&voucherCode=' + voucherCode,
                    success: $.proxy(function (response) {
                        if (response) {
                            if (response.campaignDurationInSeconds > 0 && response.voucherCode.valid && response.voucherCode.status === 'OPEN') {
                                if (voucherCookie === null) {
                                    this.createCookie(actionId, voucherCode, response.campaign.descriptionExternal, response.campaignDurationInSeconds);
                                }

                                this.render(response);
                            } else {
                                this.clearCookie();
                            }
                        }
                    }, this),
                    error: $.proxy(function () {
                        console.log('error');
                    }, this),
                });
            }
        },

        render: function (data) {
            this.tmpl = _.template($('#module-voucher-header').text());

            // Retrieve data from cookie
            var voucherCookie = this.readCookie();
            var queryString = '?' + voucherCookie;
            var cookieParams = new URLSearchParams(queryString);
            var closed = cookieParams.get('closed');
            var expiresTimestamp = cookieParams.get('expiresTimestamp');
            expiresTimestamp = new Date(expiresTimestamp).getTime();
            var modalText = cookieParams.get('modalText');
            var voucherCode = cookieParams.get('voucherCode');
            var timeDiff = expiresTimestamp - Date.now();
            timeDiff = new Date(timeDiff);
            var timeInterval = ('0' + timeDiff.getMinutes()).substr(-2) + ':' + ('0' + timeDiff.getSeconds()).substr(-2);

            // Check if voucher is expired
            if (parseInt(expiresTimestamp) - Date.now() <= 0) {
                return;
            }

            // Show success notice, since the voucher is valid
            $('.module-voucher').removeClass('hidden');

            // Don't show banner if it's been closed
            if (closed !== 'false') {
                return;
            }

            // Fill Modal
            $('#modal-voucher-campaign .modal-body .col-xs-12').html(modalText);

            this.templateOptions = {
                code: voucherCode,
                time: timeInterval,
                value: data.campaign.value,
                currency: data.campaign.currency
            };

            // Start countdown timer
            this.options= _.extend({}, {countdownTimestamp: expiresTimestamp}, this.options);
            this.initCountdown(this.options);
            this.clock.start();
            this.clock.trigger(Clock.ONE_SECOND_ELAPSED);

            // Render Banner
            this.$el.html(this.tmpl(this.templateOptions));
            this.$el.addClass('rendered');

            // Add Click event (after rendering the html)
            this.$el.find('.close').on('click', _.bind(this.close, this));
        },

        close: function (e) {
            this.clock.stop();
            this.$el.html('');

            // Set closed to true in cookie (override cookie)
            var oldCookie = this.readCookie();
            var queryString = '?' + oldCookie;
            var cookieParams = new URLSearchParams(queryString);
            var value = 'actionId=' + cookieParams.get('actionId') +
                        '&voucherCode=' + cookieParams.get('voucherCode') +
                        '&expiresTimestamp=' + cookieParams.get('expiresTimestamp') +
                        '&modalText=' + cookieParams.get('modalText') +
                        '&closed=true';

            var now = new Date();
            var expiresTimestamp = cookieParams.get('expiresTimestamp');
            expiresTimestamp = new Date(expiresTimestamp);
            var duration = Math.round((expiresTimestamp - now) / 1000);

            userModel.saveCookie(this.cookieName, value, duration);
        },

        readCookie: function () {
            return userModel.readCookie(this.cookieName);
        },

        createCookie: function (actionId, voucherCode, description, duration) {
            var expires = Date.now() + (duration * 1000);
            var date = new Date();
            date.setTime(expires);
            var expiresTimestamp = (date.toUTCString());

            var value = 'actionId=' + actionId + '&voucherCode=' + voucherCode + '&expiresTimestamp=' + expiresTimestamp + '&modalText=' + description + '&closed=false';

            userModel.saveCookie(this.cookieName, value, duration);
        },

        clearCookie: function () {
            userModel.clearCookie(this.cookieName);
        },

        clockHandler: function (e) {
            var clock = this.clock,
                timeRemaining = clock.getClockDisplay().split(':'),
                payload = {
                    hours: parseInt(timeRemaining[0], 10) % 24,
                    minutes: parseInt(timeRemaining[1], 10),
                    seconds: parseInt(timeRemaining[2], 10),
                };

            // Calculate days remaining.
            payload.days = (parseInt(timeRemaining[0], 10) - payload.hours) / 24;

            // Update countdown
            var minutes = payload.minutes;
            var seconds = payload.seconds;

            if (minutes < 0) {
                minutes = 0;
            }
            if (minutes < 10) {
                minutes = '0' + minutes;
            }

            if (seconds < 0) {
                seconds = 0;
            }
            if (seconds < 10) {
                seconds = '0' + seconds;
            }

            this.templateOptions.time = minutes + ':' + seconds;
            this.$el.html(this.tmpl(this.templateOptions));

            // Re-add click event on close button
            this.$el.find('.close').on('click', _.bind(this.close, this));
        },

        hideBanner: function () {
            this.clearCookie();
            this.$el.html('');
        },

        initCountdown: function (options) {
            var timeDiff = options.countdownTimestamp - Date.now();

            var clock = new Clock({direction:'ccw', format: 'hh:mm:ss', seconds: parseInt(timeDiff / 1000, 10) });

            clock.on(Clock.ONE_SECOND_ELAPSED, _.bind(this.clockHandler, this));
            clock.on(Clock.TIME_IS_UP, _.bind(this.hideBanner, this));

            this.clock = clock;
        },

    });

    module.exports = VoucherHeaderView;
});

define('views/SearchResultsView',['require','exports','module','backbone','james-search','models/UserModel','events/ThemeEvent'],function (require, exports, module) {
    'use strict';

    // External dependencies.
    var Backbone = require('backbone');
    var JamesSearch = require("james-search");
    var UserModel = require('models/UserModel');

    var ThemeEvent = require('events/ThemeEvent');
    var userModel = new UserModel();


    var ModuleSearchResults = Backbone.View.extend({

        views: null,
        template: null,
        favorites: 0,

        /**
         * The actions this view is interested in.
         */
        actions: [
            'fetch-user',
            'fetch-favorites',
        ],

        initialize: function (options) {
            this.views = [];

            options = _.extend({}, this.$el.data(), options);
            this.options = _.extend({}, options, window.jamesSearchSettings.search);
            this.view = this.options.view;

            this.total = 0;
            this.createJamesSearch();

            this.onSubmit = _.bind(this.onSubmit, this);
            this.onSuccess = _.bind(this.onSuccess, this);
            this.onError = _.bind(this.onError, this);

            this.render();
            this.resetPage();
            this.addEventListeners();
            this.addScrollObserver();
        },

        createJamesSearch: function () {
            this.jamesSearch = new JamesSearch({
                search: window.jamesSearchSettings.search,
            });
        },

        render: function (e) {
            this.$form = this.$('form:first');
            this.template = _.template($(this.options.template).html());
            this.$page = this.$form.find('[name="page"]');

            this.$query = this.$form.find('[name="q"]');
            this.$query.val(this.options.query);
            this.query = this.options.query;

            this.$per_page = this.$form.find('[name="per_page"]');
            this.$per_page.val(this.options.per_page);

            this.$total = $('.module-pagination.total');
            this.$filterForm = $('.form.james-search-filter-form');

            this.$jamesSearchResults = this.$el.find('.james-search-results');

            this.enableEvents();
            this.$el.addClass('rendered');

            this.renderFilterChannelTemplate();

            return this;
        },

        setPage: function (page) {
            this.$page.val(page);
            this.currentPage = page;
        },

        addEventListeners: function () {
            this.listenTo(userModel, ThemeEvent.FETCH_USER_COMPLETE, this.onFetchUserComplete);
            this.listenTo(userModel, ThemeEvent.ERROR_FETCH_USER, this.onFetchUserError);
            this.listenTo(userModel, ThemeEvent.ERROR_UNKNOWN, this.onFetchUserError);
            this.listenTo(userModel, ThemeEvent.FETCH_FAVORITES_COMPLETE, this.onFetchFavoritesComplete);
            this.listenTo(userModel, ThemeEvent.ERROR_FETCH_FAVORITES, this.onFetchFavoritesError);

            this.filterFormEvents();
        },

        filterFormEvents: function () {
            this.$filterForm.on('change', 'input[type="checkbox"]', _.bind(function () {
                this.emptyResults();
                this.resetPage();
                this.submit();
            }, this));

            this.$filterForm.find('.james-search-filter-channel').on('click', 'a', _.bind(function (e) {
                e.preventDefault();

                this.template = _.template($(e.currentTarget.dataset.template).html());
                this.view = e.currentTarget.dataset.view;

                this.emptyResults();
                this.resetPage();
                this.submit();
            }, this));

            this.$filterForm.find('.james-search-filter-checkbox').on('click', '.btn-reset', _.bind(function () {
                this.resetFilter();
            }, this));
        },

        enableEvents: function () {
            this.$form.on('submit', this.onSubmit);
        },

        disableEvents: function () {
            this.$form.off('submit', this.onSubmit);
        },

        onFetchUserComplete: function (e) {
            if (userModel.isLoggedIn()) {
                userModel.fetchFavorites();
            } else {
                this.submit();
            }
        },

        onFetchUserError: function (e) {
            if (!userModel.hasAction(this.actions, e.action)) return;

            this.submit();
        },

        onFetchFavoritesComplete: function (e) {
            this.favorites = e.favorites;
            this.submit();
        },

        onFetchFavoritesError: function (e) {
            if (!userModel.hasAction(this.actions, e.action)) return;

            this.submit();
        },

        submit: function () {
            if (this.$form.length) {
                this.onSubmit();
            }

            if (this.$filterForm.find('input[type="checkbox"]:checked').length) {
                this.$filterForm.find('.btn-reset').parent().removeClass('hidden');
            } else {
                this.$filterForm.find('.btn-reset').parent().addClass('hidden');
            }

            _.delay(function () {
                $(window).trigger('resize');
            }, 500);
        },

        onSubmit: function (e) {
            if (e && e.preventDefault) e.preventDefault();
            if (this.$el.hasClass('loading')) return;

            var data = this.$form.serializeArray();

            if (this.$filterForm.length && this.$filterForm.serialize() !== '') {
                var checkboxArr = [];

                _.forEach(this.$filterForm.find('input[type="checkbox"]:checked'), _.bind(function (value) {
                    var dataField = {
                        'name': 'filter[][' + value.dataset.number + '][field]',
                        'value': value.dataset.field
                    };

                    var dataOp = {
                        'name': 'filter[][' + value.dataset.number + '][op]',
                        'value': value.dataset.op
                    }
                        ;
                    var dataValue = {
                        'name': 'filter[][' + value.dataset.number + '][value]',
                        'value': value.value
                    };

                    checkboxArr.push(dataField);
                    checkboxArr.push(dataOp);
                    checkboxArr.push(dataValue);
                }, this));

                _.forEach(checkboxArr, function (value) {
                    data.push(value)
                });
            }

            this.$el.addClass('loading');

            var headers = {};
            if (this.options.headers.length) {
                for (var i = 0; i < this.options.headers.length; i++) {
                    var header = this.options.headers[i].split(':');
                    var key = header.shift().trim();
                    var value = header.shift().trim();
                    headers[key] = value;
                }
            }

            var url = this.options.url;
            var type = this.view === 'products' ? 'ProductDataType' : this.view;

            url = url.replace(/f\[type\]\[\]=[^&]*/, 'f[type][]=' + type);

            $.ajax({
                url: url,
                method: 'GET',
                data: data,
                headers: headers,
                beforeSend: $.proxy(function (xhr) {
                    $('.james-search-preloader').toggleClass('hidden');
                    userModel.addAuthToken(xhr);
                }, this),
                success: this.onSuccess,
                error: this.onError,
            });
        },

        onSuccess: function (data) {
            var channel = {};

            channel.items = [];
            channel.alias = this.view;
            channel.total = data.found;
            this.total = data.found;

            $('.james-search-preloader').toggleClass('hidden');
            this.$total.removeClass('hidden');

            if (channel.alias === 'products') {
                _.map(data.hits, _.bind(function (hit) {
                    var doc = hit.document || {};
                    var common = doc._common || {};
                    var productI18n = doc._product_i18n || {};
                    var commonI18n = doc._common_i18n || {};
                    var product = doc._product || {};

                    var id = doc.id || '';
                    var imageUrl = common.imageUrl || null;
                    var name = productI18n.name || '';
                    var badges = (productI18n.properties && productI18n.properties.Badge && Array.isArray(productI18n.properties.Badge)) ? productI18n.properties.Badge : [];
                    var url = commonI18n.url || '';
                    var price = product.price ? String(product.price).replace('.', ',') : '';
                    var referencePrice = product.referencePrice ? String(product.referencePrice).replace('.', ',') : '';
                    var unit = product.unit ? product.unit : '';
                    var referenceUnit = product.referenceUnit ? product.referenceUnit : '';
                    var purchaseUnit = product.purchaseUnit ? product.purchaseUnit : '';

                    // Ensure badges is an array and filter out invalid entries
                    badges = Array.isArray(badges) ? badges : [];

                    if (!name || !url || !price) {
                        console.warn('Missing product data', hit.document, 'imageUrl: ' + imageUrl, ' | name: ' + name, ' | url: ' + url, ' | price: ' + price);
                        return;
                    }

                    if (price && price.indexOf(',') === -1) {
                        price += ',00';
                    } else if (price && price.split(',')[1].length === 1) {
                        price += '0';
                    }

                    if (referencePrice && referencePrice.indexOf(',') === -1) {
                        referencePrice += ',00';
                    } else if (referencePrice && referencePrice.split(',')[1].length === 1) {
                        referencePrice += '0';
                    }

                    badges = this.mapBadges(badges, id);

                    var item = {
                        id: id,
                        title: name,
                        data: {
                            id: id,
                            name: name,
                            url_product_view: url,
                            image: imageUrl,
                            image_thumb: imageUrl,
                            prices: [
                                {
                                    price: price,
                                    unit_price: referencePrice ? referencePrice + '€ / ' + referenceUnit + unit : '',
                                }
                            ],
                            sales: {
                                isSellable: true,
                            },
                            net_filling_quantity: purchaseUnit + unit,
                            package_contents: '',
                            badges: badges,
                        }
                    };

                    channel.items.push(item);
                }, this));
            } else {
                _.map(data.hits, _.bind(function (hit) {
                    var contents = hit.document['_' + this.view];
                    var imageUrl = hit.document._common && hit.document._common.imageUrl ? hit.document._common.imageUrl : null;

                    var item = {
                        id: hit.document.id,
                        title: contents.name,
                        content: contents.description,
                        url: contents.url,
                        image: imageUrl,
                    };

                    channel.items.push(item);
                }, this));
            }

            if (channel.items && channel.items.length) {
                if (channel.alias === 'products') {
                    channel.items = this.setFavorites(channel.items);
                    this.renderProduct({
                        'jamesSearch': true,
                        'products': channel.items,
                    });

                    this.activateSelectPicker();

                    _.delay(function () {
                        if (userModel.get('products') && userModel.get('products')) {
                            $(window).trigger(ThemeEvent.FETCH_PRODUCTS_COMPLETE, [userModel.get('products')]);
                        }
                    }, 100);
                } else {
                    this.renderItems(channel);
                }
            }

            this.renderTotalTemplate(channel.total);

            $('body').trigger('refresh.theme');
            this.$el.removeClass('loading');
            _.delay(function () {
                $(window).trigger('resize');
            }, 10);
        },

        onError: function (e) {
            this.$el.removeClass('loading');
            $('.james-search-preloader').toggleClass('hidden');

            var errorTemplate = _.template($('#james-search-error-template').html());
            this.renderResultsTemplate(errorTemplate);
        },

        setFavorites: function (products) {
            if (this.favorites && this.favorites.length) {
                for (var i = 0; i < products.length; i++) {
                    products[i].data.favorite = this.favorites.indexOf(products[i].data.id) >= 0 ? true : false;
                }
            }

            return products;
        },

        renderFilterChannelTemplate: function () {
            var filterTemplate = _.template($('#james-search-filter-channel-template').html());
            var channelArr = [];

            window.jamesSearchSettings.search.label.forEach(_.bind(function (label, index) {
                var item = {};
                item.alias = window.jamesSearchSettings.search.alias[index];
                item.label = label;
                item.query = window.jamesSearchSettings.search.query;

                channelArr.push(item);
            }, this));

            var html = filterTemplate({
                items: channelArr
            });

            if (channelArr.length) {
                this.$filterForm.find('.james-search-filter-channel').html(html);
            } else {
                this.$filterForm.find('.james-search-filter-channel').parent().addClass('hidden');
            }
        },

        renderTotalTemplate: function (total) {
            var pageTemplate = _.template($('#pagination-total').html());
            var pagination = {
                page: this.currentPage,
                total: total
            };
            var html = pageTemplate({ pagination: pagination });

            if (total) {
                this.$total.html(html);
            } else {
                this.$total.empty().addClass('hidden');
                this.renderResultsTemplate(_.template($('#james-search-not-found-template').html()));

                if (this.view !== 'products' && !this.$filterForm.find('.james-search-filter-checkbox').is(':empty')) {
                    this.$filterForm.find('.james-search-filter-checkbox').empty();
                }
            }
        },

        renderItems: function (items) {
            var html = this.template(items);

            this.renderResultsTemplate(html);

            if (!this.$filterForm.find('.james-search-filter-checkbox').is(':empty')) {
                this.$filterForm.find('.james-search-filter-checkbox').empty();
            }
        },

        renderProduct: function (items) {
            var html = this.template(items);
            this.renderResultsTemplate(html);


            if (this.$filterForm.find('.james-search-filter-checkbox').is(':empty')) {
                this.$filterForm.find('.james-search-filter-checkbox').html(_.template($('#james-search-filter-checkbox-template').html()));
            }
        },

        emptyResults: function () {
            this.$jamesSearchResults.empty();
        },

        renderResultsTemplate: function (html) {
            this.$jamesSearchResults.append(html);
        },

        resetFilter: function () {
            this.$filterForm[0].reset();
            this.emptyResults();
            this.resetPage();
            this.submit();
        },

        resetPage: function () {
            this.setPage(1);
        },

        hasItemsToLoad: function () {
            var result = this.options.per_page * this.currentPage < this.total;
            return result;
        },

        activateSelectPicker: function () {
            var $select = this.$('.selectpicker').selectpicker();
            $select.on('change', _.bind(this.updateProductAmount, this));
        },

        updateProductAmount: function (e) {
            var value = $(e.currentTarget).val();
            var $btn = this.$('.btn[data-products]');
            var data = $btn.data('products');

            data.products[0].amount = value;
            $btn.data('products', data);
        },

        mapBadges: function (badges, id) {
            const badgeMapping = {
                "NEU": "#d10019",
                "BIO": "#93c01f",
                "MSC": "#005ba7",
                "ASC": "#00a6a3",
                "exklusiv": "#601122",
                "vegetarisch": "#fff",
                "vegan": "#49702f",
                "glutenfrei": "#fff",
                "laktosefrei": "#fff",
                "by Johann Lafer": "#fff",
            };

            badges = _.map(badges, function(badge) {
                var bgColor = badgeMapping[badge];
                if (bgColor) {
                    return { 'text': badge, 'bg-color': bgColor };
                } else {
                    console.warn('Badge ' + badge + ' not found in the predefined list (article id ' + id + ').');
                    return null;
                }
            });

            badges = _.filter(badges, function(badge) { return badge !== null});

            return badges;
        },

        addScrollObserver: function () {
            $(window).on('scroll', _.throttle(_.bind(function () {
                var scrollTop = $(window).scrollTop();
                var windowHeight = $(window).height();
                var elOffset = this.$el.offset().top + this.$el.outerHeight();

                if (this.hasItemsToLoad() && scrollTop + windowHeight >= elOffset && !this.$el.hasClass('loading')) {
                    this.loadMoreItems();
                }
            }, this), 200));
        },

        loadMoreItems: function () {
            this.setPage(this.currentPage + 1);
            this.submit();
        },
    });

    module.exports = ModuleSearchResults;
});

define('views/FetchProductView',['require','exports','module','backbone','models/UserModel','events/ThemeEvent'],function (require, exports, module) {
    'use strict';

    // External dependencies.
    var Backbone = require('backbone');
    var UserModel = require('models/UserModel');

    var ThemeEvent = require('events/ThemeEvent');
    var userModel = new UserModel();


    var ModuleFetchProduct = Backbone.View.extend({

        views: null,
        template: null,
        favorites: 0,

        /**
         * The actions this view is interested in.
         */
         actions: [
            'fetch-user',
            'fetch-favorites',
        ],

        initialize: function (options) {
            this.views = [];

            options = _.extend({}, this.$el.data(), options);

            this.options = options;

            this.onSubmit = _.bind(this.onSubmit, this);
            this.onSuccess = _.bind(this.onSuccess, this);
            this.onError = _.bind(this.onError, this);

            this.addEventListeners();

            this.render();
        },

        render: function (e) {
            this.$form = this.$('form:first');
            this.template = _.template($(this.$el.data('template')).text());

            this.enableEvents();
            this.$el.addClass('rendered');

            return this;
        },

        addEventListeners: function () {
            this.listenTo(userModel, ThemeEvent.FETCH_USER_COMPLETE, this.onFetchUserComplete);
            this.listenTo(userModel, ThemeEvent.ERROR_FETCH_USER, this.onFetchUserError);
            this.listenTo(userModel, ThemeEvent.ERROR_UNKNOWN, this.onFetchUserError);
            this.listenTo(userModel, ThemeEvent.FETCH_FAVORITES_COMPLETE, this.onFetchFavoritesComplete);
            this.listenTo(userModel, ThemeEvent.ERROR_FETCH_FAVORITES, this.onFetchFavoritesError);
        },

        enableEvents: function () {
            this.$form.on('submit', this.onSubmit);
        },

        disableEvents: function () {
            this.$form.off('submit', this.onSubmit);
        },

        onFetchUserComplete: function (e) {
            if (userModel.isLoggedIn()) {
                userModel.fetchFavorites();
            } else {
                this.submit();
            }
        },

        onFetchUserError: function (e) {
            if (!userModel.hasAction(this.actions, e.action)) return;

            this.submit();
        },

        onFetchFavoritesComplete: function (e) {
            this.favorites = e.favorites;
            this.submit();
        },

        onFetchFavoritesError: function (e) {
            if (!userModel.hasAction(this.actions, e.action)) return;

            this.submit();
        },

        submit: function () {
            if (this.$form.length) {
                this.onSubmit();
            }
        },

        onSubmit: function (e) {
            if (e && e.preventDefault) e.preventDefault();
            if (this.$el.hasClass('loading')) return;

            var data = this.$form.serialize();

            this.$el.addClass('loading');

            $.ajax({
                url: isapi.urls.productsFetch,
                method: 'GET',
                data: data,
                beforeSend: $.proxy(function(xhr) {
                    userModel.addAuthToken(xhr);
                }, this),
                success: this.onSuccess,
                error: this.onError,
            });
        },

        onSuccess: function (data) {
            var hasProducts = (data && data.products && data.products.length);

            if (hasProducts) {
                data = this.setFavorites(data);
                this.renderProduct(data);
                this.activateSelectPicker();

                _.delay(function() {
                    if (userModel.get('products') && userModel.get('products')) {
                        $(window).trigger(ThemeEvent.FETCH_PRODUCTS_COMPLETE, [userModel.get('products')]);
                    }
                }, 100);

                $('body').trigger('refresh.theme');
            }

            this.$el.removeClass('empty loading');
            this.$('.preloader').remove();
        },

        onError: function (e) {
            this.$el.removeClass('loading');
        },

        setFavorites: function (data) {
            if (this.favorites && this.favorites.length) {
                for (var i = 0; i < data.products.length; i++) {
                    data.products[i].favorite = this.favorites.indexOf(data.products[i].id) >= 0 ? true : false;
                }
            }

            return data;
        },

        renderProduct: function (data) {
            var html = this.template({product: data.products[0]});
            this.$el.append(html);
        },

        activateSelectPicker: function () {
            var $select = this.$('.selectpicker').selectpicker();
            $select.on('change', _.bind(this.updateProductAmount, this));
        },

        updateProductAmount: function (e) {
            var value = $(e.currentTarget).val();
            var $btn = this.$('.btn[data-products]');
            var data = $btn.data('products');
            data.products[0].amount = value;
            $btn.data('products', data);
        },

    });

    module.exports = ModuleFetchProduct;
});

define('views/CountdownView',['require','exports','module','theme','backbone','Clock','bowser','events/ThemeEvent','models/UserModel'],function (require, exports, module) {
    'use strict';

    // External dependencies.
    var theme = require('theme');
    var Backbone = require('backbone');
    var Clock = require('Clock');
    var bowser = require('bowser');

    var ThemeEvent = require('events/ThemeEvent');
    var UserModel = require('models/UserModel');
    var userModel = new UserModel();

    var ModuleCountdownView = Backbone.View.extend({

        /**
         * The template for the countdown.
         */
        template: null,

        /**
         * Html element where we render the value of the countdown.
         */
        $value: null,

        /**
         * The interval id of the countdown.
         */
        countdownId: 0,

        initialize: function (options) {
            this.views = [];

            options = _.extend({}, this.$el.data(), options);
            if (options.waitHeader) {
                $(window).on(ThemeEvent.REFRESH_COUNTDOWN, _.bind(this.refreshCountdown, this));
            } else {
                this.initCountdown(options);
                this.render();
            }
        },

        refreshCountdown: function () {
            this.initCountdown(this.$el.data());
            this.render();
        },

        render: function () {
            this.$value = this.$('.value');
            this.template = _.template($(this.$el.data('template')).text());
            this.$el.addClass('rendered');

            this.clock.start();
            this.clock.trigger(Clock.ONE_SECOND_ELAPSED);

            return this;
        },

        clockHandler: function (e) {
            var clock = this.clock,
                timeRemaining = clock.getClockDisplay().split(':'),
                payload = {
                    hours: parseInt(timeRemaining[0], 10) % 24,
                    minutes: parseInt(timeRemaining[1], 10),
                    seconds: parseInt(timeRemaining[2], 10),
                };

            // Calculate days remaining.
            payload.days = (parseInt(timeRemaining[0], 10) - payload.hours) / 24;

            // Update countdown
            this.$value.html(this.template(payload));
        },

        initCountdown: function (options) {
            var seconds = (options.countdownTimestamp - userModel.timestamp()),
                clock = new Clock({direction:'ccw', format: 'hh:mm:ss', seconds: seconds});

            clock.on(Clock.ONE_SECOND_ELAPSED, _.bind(this.clockHandler, this));
            clock.on(Clock.TIME_IS_UP, _.bind(this.clockHandler, this));

            this.clock = clock;
        },

    });

    module.exports = ModuleCountdownView;
});

define('views/.BodyView',['require','exports','module','theme','backbone','james-search','bootstrap-select','bootstrap-tabcollapse','bootstrap-datepicker','bootstrap-datepicker-languages-AMD','object-fit-polyfill','libs/copyToClipboard','bowser','models/UserModel','views/ShareContentView','views/ContainerView','views/AddToCartComplete','views/HeaderLoginView','views/HeaderCartView','views/LoginView','views/GuestLoginView','views/GridView','views/ProductsInfiniteView','views/RecipesInfiniteView','views/RatingView','views/ProductsCarouselView','views/BannerCarouselView','views/ProductDetailGalleryView','views/HeaderSearchView','views/ProductCollapseView','views/CheckoutDeliveryView','views/CheckoutTimepickerView','views/CheckoutTableTotalAlertView','views/PaymentMethodView','views/CheckoutPrintItemView','views/CheckoutNavigationView','views/SelectDateView','views/ModalMessagesView','views/ModalLoginRegistrationView','views/FeedbackView','views/CatalogOrderView','views/NewBornRegisterView','views/ForgotPwStandAloneView','views/ModalAddToCartView','views/ModalAddToFavoritesView','views/ModalDeliveryDatetimeSelectView','views/ModalAjaxHtmlView','views/HeaderTopAccountMenuView','views/HeaderTopOrderView','views/HeaderMenuView','views/HeaderContentView','views/MobileAccountMenuView','views/MobileMenuView','views/MenuItemView','views/ProductsSliderView','views/PromotionCodesView','views/PromotionCodeDetailView','views/SpotlightSliderView','views/SpotlightIconsView','views/TooltipView','views/FilterView','views/HomeConnectView','views/SalesforceContactFormView','views/RestrictedAccessView','views/NewsletterView','views/AddToCartButtonStickyView','views/SwiperView','views/BlogCardProductRecipe','views/ZipcodeCheckView','views/CodeConfirmationView','views/VideoExternView','views/ToTopButtonView','views/VoucherHeaderView','views/SearchResultsView','views/FetchProductView','views/FormView','views/ContainerView','views/FilterView','views/CountdownView','views/TooltipView'],function (require, exports, module) {
    "use strict";

    // External dependencies.
    var theme = require("theme");
    var Backbone = require("backbone");

    var JamesSearch = require("james-search");

    require("bootstrap-select");
    require("bootstrap-tabcollapse");
    require("bootstrap-datepicker");
    require("bootstrap-datepicker-languages-AMD");
    require("object-fit-polyfill");
    var copyToClipboard = require("libs/copyToClipboard");

    objectFitPolyfill();

    var bowser = window.bowser = require("bowser");

    var UserModel = require('models/UserModel');
    var userModel = new UserModel();


    var BodyView = Backbone.View.extend({

        el: "body",
        views: null,
        size: null,
        scrollTween: null,
        language: "de",
        width: 0,
        height: 0,
        main: null,
        header: null,
        footer: null,

        initialize: function (options) {
            this.views = [];

            options = _.extend({}, this.$el.data(), options);

            theme.bodyView = this;
            this.views = [];
            this.el.view = this;
            this.width = window.innerWidth;
            this.height = window.innerHeight;
            this.language = this.$el.closest('[lang]').attr('lang') || 'de';
            this.$main = this.$("main#main");
            this.$header = this.$("header#header");
            this.$footer = this.$("footer#footer");

            //Bind functions
            this.bindFunctions();

            //Render the website
            this.initializeBody();

            this.updateSize();

            this.render();

            this.setupJamesSearch();

            $(window).trigger('theme-rendered');

            // Postpone the call to let other modules initialize.
            _.delay(function () {
                userModel.fetchUser();
            }, 1);
        },

        bindFunctions: function (e) {
            this.resize = _.bind(this.resize, this);
            this.refreshTheme = _.bind(this.refreshTheme, this);
        },

        initializeBody: function (e) {
            //Bowser
            if (bowser.mobile) {
                this.$el.addClass("mobile");
            }

            if (bowser.tablet) {
                this.$el.addClass("tablet");
            }

            if (bowser.msie) {
                if (bowser.version == 11) {
                    this.$el.addClass(" msie11");
                } else if (bowser.version == 10) {
                    this.$el.addClass(" msie10");
                } else if (bowser.version == 9) {
                    this.$el.addClass(" msie9");
                } else if (bowser.version == 8) {
                    this.$el.addClass(" msie8");
                }

                this.$el.addClass(" msie");
            }

            if (bowser.msedge) {
                this.$el.addClass(" msedge");
            }

            // Add touch events for debugging in chrome.
            $("#clickDebugClose").on("touchstart", function (e) {
                if (e && e.preventDefault) e.preventDefault();
                if (e && e.stopImmediatePropagation) e.stopImmediatePropagation();
                $("#debug-only").remove();
            });

            $(".module-cookies-button").on("touchstart", function (e) {
                if (e && e.preventDefault) e.preventDefault();
                if (e && e.stopImmediatePropagation) e.stopImmediatePropagation();
                window.acceptCookies();
            });
        },

        events: {
            'refresh.theme': "refreshTheme"
        },

        enableEvents: function () {
            //Remove previous events
            this.disableEvents();

            $(window).on("resize", this.resize);
            $(document).on('click', '[data-toggle="modal"]', this.onPreventDefault);
            $('.ot-sdk-show-settings').on('click', this.onPreventDefault);

            return this;
        },

        onPreventDefault: function (e) {
            e.preventDefault();
        },

        disableEvents: function () {
            $(window).off("resize", this.resize);
            $(document).off('click', '[data-toggle="modal"]', this.onPreventDefault);

            return this;
        },

        render: function () {
            //Reset the views array
            theme.views = [];

            // Set selects plugin
            this.setSelects();

            // Set tabs plugin
            this.setTabs();

            // Set datepicker plugin
            this.setDates();

            // Set to the top
            this.setToTheTop();

            // Set up tables
            this.setupTables();

            // Set up collapsable
            this.setupCollapsable();

            // Set up pw-show
            this.setupPwShow();

            // Set up tables
            this.setupBootstrapCarousel();

            // Set up copy to clipboard
            this.setupCopyToClipboard();

            // Set set product btn group
            this.setProductBtnGroup();

            // Load modules
            this.setModules([
                {
                    viewClass: require("views/ShareContentView"),
                    name: "moduleShareContentView",
                    tag: ".module-share-content"
                },
                {
                    viewClass: require("views/ContainerView"),
                    name: "moduleContainerView",
                    tag: ".module-container"
                },
                {
                    viewClass: require("views/AddToCartComplete"),
                    name: "addToCartComplete",
                    tag: "body"
                },
                {
                    viewClass: require("views/HeaderLoginView"),
                    name: "moduleHeaderLoginView",
                    tag: ".module-header-login"
                },
                {
                    viewClass: require("views/HeaderCartView"),
                    name: "moduleHeaderCartView",
                    tag: ".module-header-cart"
                },
                {
                    viewClass: require("views/LoginView"),
                    name: "moduleLoginView",
                    tag: ".module-login"
                },
                {
                    viewClass: require("views/GuestLoginView"),
                    name: "moduleGuestLoginView",
                    tag: ".module-guest-login"
                },
                {
                    viewClass: require("views/GridView"),
                    name: "moduleGridView",
                    tag: ".module-grid"
                },
                {
                    viewClass: require("views/ProductsInfiniteView"),
                    name: "moduleProductsInfiniteView",
                    tag: ".module-products-infinite"
                },
                {
                    viewClass: require("views/RecipesInfiniteView"),
                    name: "moduleRecipesInfiniteView",
                    tag: ".module-recipes-infinite"
                },
                {
                    viewClass: require("views/RatingView"),
                    name: "moduleRatingView",
                    tag: ".module-rating"
                },
                {
                    viewClass: require("views/ProductsCarouselView"),
                    name: "moduleProductsCarouselView",
                    tag: ".module-products-carousel"
                },
                {
                    viewClass: require("views/BannerCarouselView"),
                    name: "moduleBannerCarouselView",
                    tag: ".module-banner-carousel"
                },
                {
                    viewClass: require("views/ProductDetailGalleryView"),
                    name: "moduleProductDetailGalleryView",
                    tag: ".module-product-detail-gallery"
                },
                {
                    viewClass: require("views/HeaderSearchView"),
                    name: "moduleHeaderSearchView",
                    tag: ".module-header-search"
                },
                {
                    viewClass: require("views/ProductCollapseView"),
                    name: "moduleProductCollapseView",
                    tag: ".module-product-collapse"
                },
                {
                    viewClass: require("views/CheckoutDeliveryView"),
                    name: "moduleCheckoutDeliveryView",
                    tag: ".module-checkout-delivery"
                },
                {
                    viewClass: require("views/CheckoutTimepickerView"),
                    name: "ModuleCheckoutTimepickerView",
                    tag: ".module-checkout-timepicker"
                },
                {
                    viewClass: require("views/CheckoutTableTotalAlertView"),
                    name: "moduleCheckoutTableTotalAlertView",
                    tag: ".module-checkout-table-total-alert"
                },
                {
                    viewClass: require("views/PaymentMethodView"),
                    name: "modulePaymentMethodView",
                    tag: ".module-payment-method-select"
                },
                {
                    viewClass: require("views/CheckoutPrintItemView"),
                    name: "moduleCheckoutPrintItemView",
                    tag: ".module-checkout-print-item"
                },
                {
                    viewClass: require("views/CheckoutNavigationView"),
                    name: "moduleCheckoutNavigationView",
                    tag: ".module-checkout-navigation"
                },
                {
                    viewClass: require("views/SelectDateView"),
                    name: "moduleSelectDateView",
                    tag: ".module-select-date"
                },
                {
                    viewClass: require("views/ModalMessagesView"),
                    name: "moduleModalMessagesView",
                    tag: "#modal-messages"
                },
                {
                    viewClass: require("views/ModalLoginRegistrationView"),
                    name: "moduleModalLoginRegistrationView",
                    tag: "#modal-login-registration"
                },
                {
                    viewClass: require("views/FeedbackView"),
                    name: "moduleFeedback",
                    tag: ".module-feedback"
                },
                {
                    viewClass: require("views/CatalogOrderView"),
                    name: "moduleCatalogOrderView",
                    tag: ".module-catalog-order"
                },
                {
                    viewClass: require("views/NewBornRegisterView"),
                    name: "moduleNewBornRegisterView",
                    tag: ".module-new-born-register"
                },
                {
                    viewClass: require("views/ForgotPwStandAloneView"),
                    name: "moduleForgotPwStandAlone",
                    tag: ".module-forgot-pw-stand-alone"
                },
                {
                    viewClass: require("views/ModalAddToCartView"),
                    name: "moduleModalAddToCartView",
                    tag: "#modal-add-to-cart"
                },
                {
                    viewClass: require("views/ModalAddToFavoritesView"),
                    name: "moduleModalAddToFavoritesView",
                    tag: "#modal-add-to-favorites"
                },
                {
                    viewClass: require("views/ModalDeliveryDatetimeSelectView"),
                    name: "moduleModalDeliveryDatetimeSelectView",
                    tag: "#modal-delivery-datetime-select"
                },
                {
                    viewClass: require("views/ModalAjaxHtmlView"),
                    name: "modalAjaxHtmlView",
                    tag: "#modal-ajax-html"
                },
                {
                    viewClass: require("views/HeaderTopAccountMenuView"),
                    name: "moduleHeaderTopAccountMenuView",
                    tag: ".module-header-top-account"
                },
                {
                    viewClass: require("views/HeaderTopOrderView"),
                    name: "moduleHeaderTopOrderView",
                    tag: ".module-header-top-order"
                },
                {
                    viewClass: require("views/HeaderMenuView"),
                    name: "moduleHeaderMenuView",
                    tag: ".module-header-menu"
                },
                {
                    viewClass: require("views/HeaderContentView"),
                    name: "headerContentView",
                    tag: ".header-content"
                },
                {
                    viewClass: require("views/MobileAccountMenuView"),
                    name: "moduleMobileAccountMenuView",
                    tag: ".module-mobile-account-menu"
                },
                {
                    viewClass: require("views/MobileMenuView"),
                    name: "moduleMobileMenuView",
                    tag: ".module-mobile-menu"
                },
                {
                    viewClass: require("views/MenuItemView"),
                    name: "moduleMenuItemView",
                    tag: ".module-menu-item"
                },
                {
                    viewClass: require("views/ProductsSliderView"),
                    name: "moduleProductsSliderView",
                    tag: ".module-products-slider"
                },
                {
                    viewClass: require("views/PromotionCodesView"),
                    name: "modulePromotionCodesView",
                    tag: ".module-promotion-codes"
                },
                {
                    viewClass: require("views/PromotionCodeDetailView"),
                    name: "modulePromotionCodeDetailView",
                    tag: ".module-promotion-code-detail"
                },
                {
                    viewClass: require("views/SpotlightSliderView"),
                    name: "ModuleSpotlightSliderView",
                    tag: ".module-spotlight-slider"
                },
                {
                    viewClass: require("views/SpotlightIconsView"),
                    name: "SpotlightIcons",
                    tag: ".module-spotlight-icons"
                },
                {
                    viewClass: require("views/TooltipView"),
                    name: "moduleTooltipView",
                    tag: ".module-tooltip"
                },
                {
                    viewClass: require("views/FilterView"),
                    name: "moduleFilterView",
                    tag: ".module-filter"
                },
                {
                    viewClass: require("views/HomeConnectView"),
                    name: "moduleHomeConnectView",
                    tag: ".module-home-connect",
                    params: {
                        buttonTag: ".module-home-connect-button",
                    },
                },
                {
                    viewClass: require("views/SalesforceContactFormView"),
                    name: "moduleSalesforceContactFormView",
                    tag: ".module-salesforce-contact-form",
                },
                {
                    viewClass: require("views/RestrictedAccessView"),
                    name: "moduleRestrictedAccessView",
                    tag: "body",
                },
                {
                    viewClass: require("views/NewsletterView"),
                    name: "moduleNewsletterView",
                    tag: "#modal-newsletter",
                },
                {
                    viewClass: require("views/AddToCartButtonStickyView"),
                    name: "addToCartButtonStickyView",
                    tag: ".module-add-to-cart-button-sticky"
                },
                {
                    viewClass: require("views/SwiperView"),
                    name: "swiperView",
                    tag: ".module-swiper"
                },
                {
                    viewClass: require("views/BlogCardProductRecipe"),
                    name: "blogCardProductRecipe",
                    tag: ".module-blog-card-product-recipe"
                },
                {
                    viewClass: require("views/ZipcodeCheckView"),
                    name: "zipcodeCheckView",
                    tag: ".module-zipcode-check"
                },
                // {
                // viewClass: require("views/ThankYouCampaignView"),
                // name: "thankYouCampaignView",
                // tag: ".module-thank-you-campaign"
                // },
                {
                    viewClass: require("views/CodeConfirmationView"),
                    name: "codeConfirmationViewView",
                    tag: ".module-code-confirmation"
                },
                {
                    viewClass: require("views/VideoExternView"),
                    name: "videoExternView",
                    tag: ".module-video-extern"
                },
                {
                    viewClass: require("views/ToTopButtonView"),
                    name: "moduleToTopButtonView",
                    tag: ".module-to-top-button"
                },
                {
                    viewClass: require("views/VoucherHeaderView"),
                    name: "moduleVoucherHeaderView",
                    tag: ".module-voucher-header"
                },
                {
                    viewClass: require("views/SearchResultsView"),
                    name: "moduleSearchResults",
                    tag: ".search-results"
                },
                {
                    viewClass: require("views/FetchProductView"),
                    name: "moduleFetchProductViewView",
                    tag: ".module-fetch-product"
                },
            ]);

            this.addModalFix();
            this.refreshTheme();

            // Resize
            this.resize();

            // Enable events
            this.enableEvents();
        },

        addModalFix: function () {
            $(document).on('show.bs.modal', function (e) {
                _.delay(function () {
                    var $modal = $(e.target).find('.modal-body');
                    var $btnFix = $modal.find('button.fix');

                    if (!$btnFix.length) {
                        $btnFix = $('<button class="ios-fix" tabIndex="-1"></button>').appendTo($modal);
                    }

                    $btnFix.click();
                }, 250);
            });
        },

        setSelects: function () {
            this.$el.find('.selectpicker').selectpicker({
                size: 5
            });
        },

        setTabs: function () {
            this.$el.find('.nav-tabs:not(.no-tabs)').tabCollapse();
        },

        setDates: function () {
            this.$el.find('.datepicker:not(.custom-datepicker)').datepicker({
                format: 'dd.mm.yyyy',
                language: this.language || 'de',
                autoclose: true,
            });
        },

        setToTheTop: function () {
            var $toTheTop = this.$el.find(".to-the-top");

            $toTheTop.off("click").on("click", this.onToTheTopClick);
        },

        setupTables: function () {
            var $tables = this.$el.find('table, .table');

            function escapeHtml(text) {
                return text.replace(/[\"&<>]/g, function (a) {
                    return {
                        '"': '&quot;',
                        '&': '&amp;',
                        '<': '&lt;',
                        '>': '&gt;'
                    }[a];
                });
            };

            $tables.each(function (index, table) {
                var $table = $(table),
                    labels = $table.find('> thead th').map(function (el) {
                        return $.trim($(this).text());
                    }).get(),
                    totalLabels = labels.length;

                if (totalLabels) {
                    $table.find('> tbody > tr > td').each(function (index, td) {
                        var $td = $(td),
                            text = escapeHtml(labels[index % totalLabels]);
                        $td.attr('data-label', text);
                    });
                }
            });
        },

        setupCollapsable: function () {
            $('.collapse').on('show.bs.collapse', this.resize);
            $('.collapse').on('shown.bs.collapse', this.refreshTheme);
        },

        setupPwShow: function () {
            $('body').on('click', '.pw-show', function (e) {
                var $el = $(e.currentTarget);
                var $input = $el.siblings('input');

                if ($input.attr('type') === 'password') {
                    $input.attr('type', 'text');
                } else {
                    $input.attr('type', 'password');
                }
            });
        },

        setupBootstrapCarousel: function () {
            $('.carousel.slide').each(function (index, el) {
                var $el = $(el);
                var totalItems = $el.find('.item').size();

                if (totalItems > 1) {
                    $el.find('.nav-arrow').removeClass('hidden').addClass('visible');

                    $el.find('.carousel-inner').on('swiperight', function () {
                        $el.find('.module-products-infinite-slider-prev').trigger('click');
                    });

                    $el.find('.carousel-inner').on('swipeleft', function () {
                        $el.find('.module-products-infinite-slider-next').trigger('click');
                    });
                }

                $el.on('slide.bs.carousel', function (e) {
                    _.delay(function () {
                        var $item = $el.find('.item .module-container');
                        $item.trigger('carousel-resize');
                    }, 10);
                });
            });

            // Initialize Bootstrap carousel.
            $('.carousel').carousel({
                interval: 5000,
            });
        },

        setupCopyToClipboard: function () {
            if (!$('#coupon-copy').length || !$('#coupon-copy-btn').length) {
                return;
            }

            var couponCopyTmpl = _.template($('#coupon-copy').html());
            var couponCopyBtnTmpl = _.template($('#coupon-copy-btn').html());

            $('.coupon-copy').each(function (index, el) {
                var $el = $(el);
                var data = null;

                if (!$el.find('.coupon').length) {
                    data = {
                        coupon: $el.html(),
                        unique: _.uniqueId(),
                    };

                    $el.html(couponCopyTmpl(data));

                    if ($el.hasClass('coupon-copy-btn')) {
                        $el.after(couponCopyBtnTmpl(data));
                    }
                }
            });

            $(document).on('click', '[data-copy-to-clipboard]', function (e) {
                e.preventDefault();
                var $el = $(e.currentTarget);
                var $target = $($el.data('copy-to-clipboard'));
                var payload = $target.data('payload');

                if ($target.length && !_.isEmpty(payload)) {
                    var result = copyToClipboard(payload);
                    var $boxCopyText = $target.closest('.box-copy-text');

                    if (result) {
                        var $copy = $boxCopyText.find('.copy');
                        var $success = $boxCopyText.find('.copy-success');
                        $copy.hide();
                        $success.show();
                        _.delay(function () {
                            $copy.show();
                            $success.hide();
                        }, 1000);
                    }
                }
            });
        },

        setProductBtnGroup: function (e) {
            $(document).on('change', '.module-product-btn-group input, .module-product-btn-group select', function(e) {
                var $input = $(e.currentTarget);
                var $group = $input.closest('.module-product-btn-group');
                var $btn = $group.find('[data-products]');
                var products = $btn.attr('data-products');
                products = JSON.parse(products);
                products.products[0].amount = parseInt($input.val(), 10);
                $btn.attr('data-products', JSON.stringify(products));
            });
        },

        onToTheTopClick: function (e) {
            if (e && e.preventDefault) e.preventDefault();

            TweenMax.to(window, 1, {
                ease: Strong.easeOut,
                scrollTo: {
                    y: 0
                }
            });
        },

        refreshTheme: function (e) {
            this.setModules([
                {
                    viewClass: require("views/FormView"),
                    name: "moduleFormView",
                    tag: "body"
                },
                {
                    viewClass: require("views/ContainerView"),
                    name: "moduleContainerView",
                    tag: ".module-container"
                }, {
                    viewClass: require("views/FilterView"),
                    name: "moduleFilterView",
                    tag: ".module-filter"
                },
                {
                    viewClass: require("views/CountdownView"),
                    name: "moduleCountdownView",
                    tag: ".module-countdown"
                },
                {
                    viewClass: require("views/TooltipView"),
                    name: "moduleTooltipView",
                    tag: ".module-tooltip"
                },
            ]);

            objectFitPolyfill();
        },

        setModules: function (items) {
            if (!items) return;

            if (!_.isArray(items)) {
                items = [items];
            }

            var i;
            var imax = items.length;
            var j;
            var jmax;

            var item;
            var $elements;
            var $element;
            var element;

            for (i = 0; i < imax; i++) {
                item = items[i];

                $elements = $(item.tag);

                jmax = $elements.length;

                for (j = 0; j < jmax; j++) {
                    element = $elements[j];
                    $element = $(element);

                    // Avoid that a module is rendered more than once if the module is already rendered.
                    // Checking the class "rendered" isn't a good solution because an element can have
                    // more than one module.
                    if ($element.data('views') && $element.data('views').length && _.indexOf($element.data('views'), (item.name)) !== -1) {
                        // Go away.
                        continue;
                    } else {
                        if ($element.data('views') && $element.data('views').length) {
                            // Add the current view name to data view of the element.
                            $element.data('views').push(item.name);
                        } else {
                            // Create an array and add the current view name to data view of the element.
                            $element.data('views', [item.name]);
                        }
                    }

                    if (item.name && element[item.name]) {
                        element[item.name].render();
                    } else {
                        var view = new (item.viewClass)({
                            el: element,
                            index: j,
                            parentView: this,
                            params: item.params,
                        });

                        this.views.push(view);
                    }
                }
            }
        },

        resize: function (e) {
            this.updateSize();
            this.resizeSelects();

            var i;
            var imax = this.views.length;

            var view;
            for (i = 0; i < imax; i++) {
                view = this.views[i];
                if (view.resize) {
                    view.resize(e);
                }
            }
        },

        updateSize: function () {
            this.width = window.innerWidth;
            this.height = window.innerHeight;

            if (this.width >= 1200) {
                this.size = "lg";
            } else if (this.width >= 992) {
                this.size = "md";
            } else if (this.width >= 768) {
                this.size = "sm";
            } else {
                this.size = "xs";
            }

            this.$el.removeClass('xs sm md lg').addClass(this.size).attr('data-size', this.size);

            // Hack for sticky footer
            this.updateSizeForStickyFooter();

            return this;
        },

        updateSizeForStickyFooter: function () {
            var h = '',
                contentHeight = this.$header.outerHeight(true) + this.$main.height() + this.$footer.outerHeight(true) + $('#module-cookies').outerHeight();

            // Hack for sticky footer
            this.$main.height('');

            if (contentHeight < window.innerHeight) {
                h = window.innerHeight - (this.$header.outerHeight(true) + this.$footer.outerHeight(true) + $('#module-cookies').outerHeight());
                this.$main.height(h + 'px');
            } else {
                this.$main.height('');
            }
        },

        /**
         *
         */
        setupJamesSearch: function (e) {
            // Auto create JamesSearch instances.
            JamesSearch.autoCreate();

            // Update input field on resize
            document.addEventListener(JamesSearch.EVENTS.boxBeforeResize, function (e) {
                if (bowser.mobile || bowser.tablet) {
                    e.data.style.maxWidth = '100%';
                    e.data.style.left = '0';
                    e.data.style.right = '0';
                } else {
                    e.data.style.maxWidth = '1140px';
                    e.data.style.left = '50%';
                    e.data.style.transform = 'translateX(-50%)';
                    e.data.style.right = '0';
                }
            });
        },

        resizeSelects: function () {
            if (bowser.mobile || bowser.tablet) {
                this.$el.find('.selectpicker:not([multiple])').addClass('mobile').selectpicker('mobile');
            } else {
                this.$el.find('.selectpicker.mobile:not([multiple])').selectpicker('render');
            }
        },
    });

    module.exports = BodyView;
});

/**
 * jGestures: a jQuery plugin for gesture events
 * Copyright 2010-2011 Neue Digitale / Razorfish GmbH
 * Copyright 2011-2012, Razorfish GmbH
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * @copyright Razorfish GmbH
 * @author martin.krause@razorfish.de
 * @version 0.90.1
 * @contributor NicolasBernie
 * @requires jQuery JavaScript Library v1.4.2 - http://jquery.com/- Copyright 2010, John Resig- Dual licensed under the MIT or GPL Version 2 licenses. http://jquery.org/license
 */
(function(c){c.jGestures={};c.jGestures.defaults={};c.jGestures.defaults.thresholdShake={requiredShakes:10,freezeShakes:100,frontback:{sensitivity:10},leftright:{sensitivity:10},updown:{sensitivity:10}};c.jGestures.defaults.thresholdPinchopen=0.05;c.jGestures.defaults.thresholdPinchmove=0.05;c.jGestures.defaults.thresholdPinch=0.05;c.jGestures.defaults.thresholdPinchclose=0.05;c.jGestures.defaults.thresholdRotatecw=5;c.jGestures.defaults.thresholdRotateccw=5;c.jGestures.defaults.thresholdMove=20;c.jGestures.defaults.thresholdSwipe=100;c.jGestures.data={};c.jGestures.data.capableDevicesInUserAgentString=["iPad","iPhone","iPod","Mobile Safari"];c.jGestures.data.hasGestures=(function(){var k;for(k=0;k<c.jGestures.data.capableDevicesInUserAgentString.length;k++){if(navigator.userAgent.indexOf(c.jGestures.data.capableDevicesInUserAgentString[k])!==-1){return true}}return false})();c.hasGestures=c.jGestures.data.hasGestures;c.jGestures.events={touchstart:"jGestures.touchstart",touchendStart:"jGestures.touchend;start",touchendProcessed:"jGestures.touchend;processed",gesturestart:"jGestures.gesturestart",gestureendStart:"jGestures.gestureend;start",gestureendProcessed:"jGestures.gestureend;processed"};jQuery.each({orientationchange_orientationchange01:"orientationchange",gestureend_pinchopen01:"pinchopen",gestureend_pinchclose01:"pinchclose",gestureend_rotatecw01:"rotatecw",gestureend_rotateccw01:"rotateccw",gesturechange_pinch01:"pinch",gesturechange_rotate01:"rotate",touchstart_swipe13:"swipemove",touchstart_swipe01:"swipeone",touchstart_swipe02:"swipetwo",touchstart_swipe03:"swipethree",touchstart_swipe04:"swipefour",touchstart_swipe05:"swipeup",touchstart_swipe06:"swiperightup",touchstart_swipe07:"swiperight",touchstart_swipe08:"swiperightdown",touchstart_swipe09:"swipedown",touchstart_swipe10:"swipeleftdown",touchstart_swipe11:"swipeleft",touchstart_swipe12:"swipeleftup",touchstart_tap01:"tapone",touchstart_tap02:"taptwo",touchstart_tap03:"tapthree",touchstart_tap04:"tapfour",devicemotion_shake01:"shake",devicemotion_shake02:"shakefrontback",devicemotion_shake03:"shakeleftright",devicemotion_shake04:"shakeupdown"},function(l,k){jQuery.event.special[k]={setup:function(){var r=l.split("_");var o=r[0];var m=r[1].slice(0,r[1].length-2);var p=jQuery(this);var q;var n;if(!p.data("ojQueryGestures")||!p.data("ojQueryGestures")[o]){q=p.data("ojQueryGestures")||{};n={};n[o]=true;c.extend(true,q,n);p.data("ojQueryGestures",q);if(c.hasGestures){switch(m){case"orientationchange":p.get(0).addEventListener("orientationchange",a,false);break;case"shake":case"shakefrontback":case"shakeleftright":case"shakeupdown":case"tilt":p.get(0).addEventListener("devicemotion",b,false);break;case"tap":case"swipe":case"swipeup":case"swiperightup":case"swiperight":case"swiperightdown":case"swipedown":case"swipeleftdown":case"swipeleft":p.get(0).addEventListener("touchstart",h,false);break;case"pinchopen":case"pinchclose":case"rotatecw":case"rotateccw":p.get(0).addEventListener("gesturestart",e,false);p.get(0).addEventListener("gestureend",i,false);break;case"pinch":case"rotate":p.get(0).addEventListener("gesturestart",e,false);p.get(0).addEventListener("gesturechange",f,false);break}}else{switch(m){case"tap":case"swipe":p.bind("mousedown",h);break;case"orientationchange":case"pinchopen":case"pinchclose":case"rotatecw":case"rotateccw":case"pinch":case"rotate":case"shake":case"tilt":break}}}return false},add:function(n){var m=jQuery(this);var o=m.data("ojQueryGestures");o[n.type]={originalType:n.type};return false},remove:function(n){var m=jQuery(this);var o=m.data("ojQueryGestures");o[n.type]=false;m.data("ojQueryGestures",o);return false},teardown:function(){var r=l.split("_");var o=r[0];var m=r[1].slice(0,r[1].length-2);var p=jQuery(this);var q;var n;if(!p.data("ojQueryGestures")||!p.data("ojQueryGestures")[o]){q=p.data("ojQueryGestures")||{};n={};n[o]=false;c.extend(true,q,n);p.data("ojQueryGestures",q);if(c.hasGestures){switch(m){case"orientationchange":p.get(0).removeEventListener("orientationchange",a,false);break;case"shake":case"shakefrontback":case"shakeleftright":case"shakeupdown":case"tilt":p.get(0).removeEventListener("devicemotion",b,false);break;case"tap":case"swipe":case"swipeup":case"swiperightup":case"swiperight":case"swiperightdown":case"swipedown":case"swipeleftdown":case"swipeleft":case"swipeleftup":p.get(0).removeEventListener("touchstart",h,false);p.get(0).removeEventListener("touchmove",g,false);p.get(0).removeEventListener("touchend",j,false);break;case"pinchopen":case"pinchclose":case"rotatecw":case"rotateccw":p.get(0).removeEventListener("gesturestart",e,false);p.get(0).removeEventListener("gestureend",i,false);break;case"pinch":case"rotate":p.get(0).removeEventListener("gesturestart",e,false);p.get(0).removeEventListener("gesturechange",f,false);break}}else{switch(m){case"tap":case"swipe":p.unbind("mousedown",h);p.unbind("mousemove",g);p.unbind("mouseup",j);break;case"orientationchange":case"pinchopen":case"pinchclose":case"rotatecw":case"rotateccw":case"pinch":case"rotate":case"shake":case"tilt":break}}}return false}}});function d(l){l.startMove=(l.startMove)?l.startMove:{startX:null,startY:null,timestamp:null};var m=new Date().getTime();var n;var p;if(l.touches){p=[{lastX:l.deltaX,lastY:l.deltaY,moved:null,startX:l.screenX-l.startMove.screenX,startY:l.screenY-l.startMove.screenY}];n={vector:l.vector||null,orientation:window.orientation||null,lastX:((p[0].lastX>0)?+1:((p[0].lastX<0)?-1:0)),lastY:((p[0].lastY>0)?+1:((p[0].lastY<0)?-1:0)),startX:((p[0].startX>0)?+1:((p[0].startX<0)?-1:0)),startY:((p[0].startY>0)?+1:((p[0].startY<0)?-1:0))};p[0].moved=Math.sqrt(Math.pow(Math.abs(p[0].startX),2)+Math.pow(Math.abs(p[0].startY),2));var k=p[0].lastX,o=p[0].lastY;direction=null;if(k==0||o/k<=-2||o/k>=2){if(o>0){direction="down"}else{if(o<0){direction="up"}}}else{if(o==0||k/o<=-2||k/o>=2){if(k>0){direction="right"}else{if(k<0){direction="left"}}}else{if(0.5<o/k&&o/k<2){if(o>0){direction="rightdown"}else{if(o<0){direction="leftup"}}}else{if(-2<o/k&&o/k<-0.5){if(o>0){direction="leftdown"}else{if(o<0){direction="rightup"}}}}}}n.name=direction}return{type:l.type||null,originalEvent:l.event||null,delta:p||null,direction:n||{orientation:window.orientation||null,vector:l.vector||null},duration:(l.duration)?l.duration:(l.startMove.timestamp)?m-l.timestamp:null,rotation:l.rotation||null,scale:l.scale||null,description:l.description||[l.type,":",l.touches,":",((p[0].lastX!=0)?((p[0].lastX>0)?"right":"left"):"steady"),":",((p[0].lastY!=0)?((p[0].lastY>0)?"down":"up"):"steady")].join("")}}function a(l){var k=["landscape:clockwise:","portrait:default:","landscape:counterclockwise:","portrait:upsidedown:"];c(window).triggerHandler("orientationchange",{direction:{orientation:window.orientation},description:["orientationchange:",k[((window.orientation/90)+1)],window.orientation].join("")})}function b(r){var k;var t=jQuery(window);var o=t.data("ojQueryGestures");var m=c.jGestures.defaults.thresholdShake;var n=o.oDeviceMotionLastDevicePosition||{accelerationIncludingGravity:{x:0,y:0,z:0},shake:{eventCount:0,intervalsPassed:0,intervalsFreeze:0},shakeleftright:{eventCount:0,intervalsPassed:0,intervalsFreeze:0},shakefrontback:{eventCount:0,intervalsPassed:0,intervalsFreeze:0},shakeupdown:{eventCount:0,intervalsPassed:0,intervalsFreeze:0}};var q={accelerationIncludingGravity:{x:r.accelerationIncludingGravity.x,y:r.accelerationIncludingGravity.y,z:r.accelerationIncludingGravity.z},shake:{eventCount:n.shake.eventCount,intervalsPassed:n.shake.intervalsPassed,intervalsFreeze:n.shake.intervalsFreeze},shakeleftright:{eventCount:n.shakeleftright.eventCount,intervalsPassed:n.shakeleftright.intervalsPassed,intervalsFreeze:n.shakeleftright.intervalsFreeze},shakefrontback:{eventCount:n.shakefrontback.eventCount,intervalsPassed:n.shakefrontback.intervalsPassed,intervalsFreeze:n.shakefrontback.intervalsFreeze},shakeupdown:{eventCount:n.shakeupdown.eventCount,intervalsPassed:n.shakeupdown.intervalsPassed,intervalsFreeze:n.shakeupdown.intervalsFreeze}};var p;var s;var l;for(k in o){switch(k){case"shake":case"shakeleftright":case"shakefrontback":case"shakeupdown":p=[];s=[];p.push(k);if(++q[k].intervalsFreeze>m.freezeShakes&&q[k].intervalsFreeze<(2*m.freezeShakes)){break}q[k].intervalsFreeze=0;q[k].intervalsPassed++;if((k==="shake"||k==="shakeleftright")&&(q.accelerationIncludingGravity.x>m.leftright.sensitivity||q.accelerationIncludingGravity.x<(-1*m.leftright.sensitivity))){p.push("leftright");p.push("x-axis")}if((k==="shake"||k==="shakefrontback")&&(q.accelerationIncludingGravity.y>m.frontback.sensitivity||q.accelerationIncludingGravity.y<(-1*m.frontback.sensitivity))){p.push("frontback");p.push("y-axis")}if((k==="shake"||k==="shakeupdown")&&(q.accelerationIncludingGravity.z+9.81>m.updown.sensitivity||q.accelerationIncludingGravity.z+9.81<(-1*m.updown.sensitivity))){p.push("updown");p.push("z-axis")}if(p.length>1){if(++q[k].eventCount==m.requiredShakes&&(q[k].intervalsPassed)<m.freezeShakes){t.triggerHandler(k,d({type:k,description:p.join(":"),event:r,duration:q[k].intervalsPassed*5}));q[k].eventCount=0;q[k].intervalsPassed=0;q[k].intervalsFreeze=m.freezeShakes+1}else{if(q[k].eventCount==m.requiredShakes&&(q[k].intervalsPassed)>m.freezeShakes){q[k].eventCount=0;q[k].intervalsPassed=0}}}break}l={};l.oDeviceMotionLastDevicePosition=q;t.data("ojQueryGestures",c.extend(true,o,l))}}function h(l){var k=jQuery(l.currentTarget);k.triggerHandler(c.jGestures.events.touchstart,l);if(c.hasGestures){l.currentTarget.addEventListener("touchmove",g,false);l.currentTarget.addEventListener("touchend",j,false)}else{k.bind("mousemove",g);k.bind("mouseup",j)}var n=k.data("ojQueryGestures");var m=(l.touches)?l.touches[0]:l;var o={};o.oLastSwipemove={screenX:m.screenX,screenY:m.screenY,timestamp:new Date().getTime()};o.oStartTouch={screenX:m.screenX,screenY:m.screenY,timestamp:new Date().getTime()};k.data("ojQueryGestures",c.extend(true,n,o))}function g(t){var v=jQuery(t.currentTarget);var s=v.data("ojQueryGestures");var q=!!t.touches;var l=(q)?t.changedTouches[0].screenX:t.screenX;var k=(q)?t.changedTouches[0].screenY:t.screenY;var r=s.oLastSwipemove;var o=l-r.screenX;var n=k-r.screenY;var u;if(!!s.oLastSwipemove){u=d({type:"swipemove",touches:(q)?t.touches.length:"1",screenY:k,screenX:l,deltaY:n,deltaX:o,startMove:r,event:t,timestamp:r.timestamp});v.triggerHandler(u.type,u)}var m={};var p=(t.touches)?t.touches[0]:t;m.oLastSwipemove={screenX:p.screenX,screenY:p.screenY,timestamp:new Date().getTime()};v.data("ojQueryGestures",c.extend(true,s,m))}function j(r){var v=jQuery(r.currentTarget);var x=!!r.changedTouches;var u=(x)?r.changedTouches.length:"1";var p=(x)?r.changedTouches[0].screenX:r.screenX;var o=(x)?r.changedTouches[0].screenY:r.screenY;v.triggerHandler(c.jGestures.events.touchendStart,r);if(c.hasGestures){r.currentTarget.removeEventListener("touchmove",g,false);r.currentTarget.removeEventListener("touchend",j,false)}else{v.unbind("mousemove",g);v.unbind("mouseup",j)}var m=v.data("ojQueryGestures");var y=(Math.abs(m.oStartTouch.screenX-p)>c.jGestures.defaults.thresholdMove||Math.abs(m.oStartTouch.screenY-o)>c.jGestures.defaults.thresholdMove)?true:false;var B=(Math.abs(m.oStartTouch.screenX-p)>c.jGestures.defaults.thresholdSwipe||Math.abs(m.oStartTouch.screenY-o)>c.jGestures.defaults.thresholdSwipe)?true:false;var A;var t;var n;var l;var k;var q;var w=["zero","one","two","three","four"];var s;for(A in m){t=m.oStartTouch;n={};p=(x)?r.changedTouches[0].screenX:r.screenX;o=(x)?r.changedTouches[0].screenY:r.screenY;l=p-t.screenX;k=o-t.screenY;q=d({type:"swipe",touches:u,screenY:o,screenX:p,deltaY:k,deltaX:l,startMove:t,event:r,timestamp:t.timestamp});s=false;switch(A){case"swipeone":case"swipetwo":case"swipethree":case"swipefour":case"swipeup":case"swiperightup":case"swiperight":case"swiperightdown":case"swipedown":case"swipeleftdown":case"swipeleft":case"swipeleftup":if(x===false&&u>=1&&y===false){break}if(x===false||(u>=1&&y===true&&B===true)){s=true;q.type=["swipe",w[u]].join("");if(q.type==A){v.triggerHandler(q.type,q);break}if(q.direction.name!==null){q.type="swipe"+q.direction.name;if(q.type==A){v.triggerHandler(q.type,q)}}}break;case"tapone":case"taptwo":case"tapthree":case"tapfour":if((y!==true&&s!==true)&&(w[u]==A.slice(3))){q.description=["tap",w[u]].join("");q.type=["tap",w[u]].join("");if(q.type==A){v.triggerHandler(q.type,q)}}break}var z={};v.data("ojQueryGestures",c.extend(true,m,z));v.data("ojQueryGestures",c.extend(true,m,z))}v.triggerHandler(c.jGestures.events.touchendProcessed,r)}function e(l){var k=jQuery(l.currentTarget);k.triggerHandler(c.jGestures.events.gesturestart,l);var m=k.data("ojQueryGestures");var n={};n.oStartTouch={timestamp:new Date().getTime()};k.data("ojQueryGestures",c.extend(true,m,n))}function f(l){var k=jQuery(l.currentTarget);var p,m,r,o;var q=k.data("ojQueryGestures");var n;for(n in q){switch(n){case"pinch":p=l.scale;if(((p<1)&&(p%1)<(1-c.jGestures.defaults.thresholdPinchclose))||((p>1)&&(p%1)>(c.jGestures.defaults.thresholdPinchopen))){m=(p<1)?-1:+1;o=d({type:"pinch",scale:p,touches:null,startMove:q.oStartTouch,event:l,timestamp:q.oStartTouch.timestamp,vector:m,description:["pinch:",m,":",((p<1)?"close":"open")].join("")});k.triggerHandler(o.type,o)}break;case"rotate":p=l.rotation;if(((p<1)&&(-1*(p)>c.jGestures.defaults.thresholdRotateccw))||((p>1)&&(p>c.jGestures.defaults.thresholdRotatecw))){m=(p<1)?-1:+1;o=d({type:"rotate",rotation:p,touches:null,startMove:q.oStartTouch,event:l,timestamp:q.oStartTouch.timestamp,vector:m,description:["rotate:",m,":",((p<1)?"counterclockwise":"clockwise")].join("")});k.triggerHandler(o.type,o)}break}}}function i(l){var k=jQuery(l.currentTarget);k.triggerHandler(c.jGestures.events.gestureendStart,l);var n;var o=k.data("ojQueryGestures");var m;for(m in o){switch(m){case"pinchclose":n=l.scale;if((n<1)&&(n%1)<(1-c.jGestures.defaults.thresholdPinchclose)){k.triggerHandler("pinchclose",d({type:"pinchclose",scale:n,vector:-1,touches:null,startMove:o.oStartTouch,event:l,timestamp:o.oStartTouch.timestamp,description:"pinch:-1:close"}))}break;case"pinchopen":n=l.scale;if((n>1)&&(n%1)>(c.jGestures.defaults.thresholdPinchopen)){k.triggerHandler("pinchopen",d({type:"pinchopen",scale:n,vector:+1,touches:null,startMove:o.oStartTouch,event:l,timestamp:o.oStartTouch.timestamp,description:"pinch:+1:open"}))}break;case"rotatecw":n=l.rotation;if((n>1)&&(n>c.jGestures.defaults.thresholdRotatecw)){k.triggerHandler("rotatecw",d({type:"rotatecw",rotation:n,vector:+1,touches:null,startMove:o.oStartTouch,event:l,timestamp:o.oStartTouch.timestamp,description:"rotate:+1:clockwise"}))}break;case"rotateccw":n=l.rotation;if((n<1)&&(-1*(n)>c.jGestures.defaults.thresholdRotateccw)){k.triggerHandler("rotateccw",d({type:"rotateccw",rotation:n,vector:-1,touches:null,startMove:o.oStartTouch,event:l,timestamp:o.oStartTouch.timestamp,description:"rotate:-1:counterclockwise"}))}break}}k.triggerHandler(c.jGestures.events.gestureendProcessed,l)}})(jQuery);
define("jquery-gestures", ["jquery"], function(){});

/*!
 * VERSION: 1.19.0
 * DATE: 2016-07-14
 * UPDATES AND DOCS AT: http://greensock.com
 * 
 * Includes all of the following: TweenLite, TweenMax, TimelineLite, TimelineMax, EasePack, CSSPlugin, RoundPropsPlugin, BezierPlugin, AttrPlugin, DirectionalRotationPlugin
 *
 * @license Copyright (c) 2008-2016, GreenSock. All rights reserved.
 * This work is subject to the terms at http://greensock.com/standard-license or for
 * Club GreenSock members, the software agreement that was issued with your membership.
 * 
 * @author: Jack Doyle, jack@greensock.com
 **/
var _gsScope="undefined"!=typeof module&&module.exports&&"undefined"!=typeof global?global:this||window;(_gsScope._gsQueue||(_gsScope._gsQueue=[])).push(function(){"use strict";_gsScope._gsDefine("TweenMax",["core.Animation","core.SimpleTimeline","TweenLite"],function(a,b,c){var d=function(a){var b,c=[],d=a.length;for(b=0;b!==d;c.push(a[b++]));return c},e=function(a,b,c){var d,e,f=a.cycle;for(d in f)e=f[d],a[d]="function"==typeof e?e(c,b[c]):e[c%e.length];delete a.cycle},f=function(a,b,d){c.call(this,a,b,d),this._cycle=0,this._yoyo=this.vars.yoyo===!0,this._repeat=this.vars.repeat||0,this._repeatDelay=this.vars.repeatDelay||0,this._dirty=!0,this.render=f.prototype.render},g=1e-10,h=c._internals,i=h.isSelector,j=h.isArray,k=f.prototype=c.to({},.1,{}),l=[];f.version="1.19.0",k.constructor=f,k.kill()._gc=!1,f.killTweensOf=f.killDelayedCallsTo=c.killTweensOf,f.getTweensOf=c.getTweensOf,f.lagSmoothing=c.lagSmoothing,f.ticker=c.ticker,f.render=c.render,k.invalidate=function(){return this._yoyo=this.vars.yoyo===!0,this._repeat=this.vars.repeat||0,this._repeatDelay=this.vars.repeatDelay||0,this._uncache(!0),c.prototype.invalidate.call(this)},k.updateTo=function(a,b){var d,e=this.ratio,f=this.vars.immediateRender||a.immediateRender;b&&this._startTime<this._timeline._time&&(this._startTime=this._timeline._time,this._uncache(!1),this._gc?this._enabled(!0,!1):this._timeline.insert(this,this._startTime-this._delay));for(d in a)this.vars[d]=a[d];if(this._initted||f)if(b)this._initted=!1,f&&this.render(0,!0,!0);else if(this._gc&&this._enabled(!0,!1),this._notifyPluginsOfEnabled&&this._firstPT&&c._onPluginEvent("_onDisable",this),this._time/this._duration>.998){var g=this._totalTime;this.render(0,!0,!1),this._initted=!1,this.render(g,!0,!1)}else if(this._initted=!1,this._init(),this._time>0||f)for(var h,i=1/(1-e),j=this._firstPT;j;)h=j.s+j.c,j.c*=i,j.s=h-j.c,j=j._next;return this},k.render=function(a,b,c){this._initted||0===this._duration&&this.vars.repeat&&this.invalidate();var d,e,f,i,j,k,l,m,n=this._dirty?this.totalDuration():this._totalDuration,o=this._time,p=this._totalTime,q=this._cycle,r=this._duration,s=this._rawPrevTime;if(a>=n-1e-7?(this._totalTime=n,this._cycle=this._repeat,this._yoyo&&0!==(1&this._cycle)?(this._time=0,this.ratio=this._ease._calcEnd?this._ease.getRatio(0):0):(this._time=r,this.ratio=this._ease._calcEnd?this._ease.getRatio(1):1),this._reversed||(d=!0,e="onComplete",c=c||this._timeline.autoRemoveChildren),0===r&&(this._initted||!this.vars.lazy||c)&&(this._startTime===this._timeline._duration&&(a=0),(0>s||0>=a&&a>=-1e-7||s===g&&"isPause"!==this.data)&&s!==a&&(c=!0,s>g&&(e="onReverseComplete")),this._rawPrevTime=m=!b||a||s===a?a:g)):1e-7>a?(this._totalTime=this._time=this._cycle=0,this.ratio=this._ease._calcEnd?this._ease.getRatio(0):0,(0!==p||0===r&&s>0)&&(e="onReverseComplete",d=this._reversed),0>a&&(this._active=!1,0===r&&(this._initted||!this.vars.lazy||c)&&(s>=0&&(c=!0),this._rawPrevTime=m=!b||a||s===a?a:g)),this._initted||(c=!0)):(this._totalTime=this._time=a,0!==this._repeat&&(i=r+this._repeatDelay,this._cycle=this._totalTime/i>>0,0!==this._cycle&&this._cycle===this._totalTime/i&&a>=p&&this._cycle--,this._time=this._totalTime-this._cycle*i,this._yoyo&&0!==(1&this._cycle)&&(this._time=r-this._time),this._time>r?this._time=r:this._time<0&&(this._time=0)),this._easeType?(j=this._time/r,k=this._easeType,l=this._easePower,(1===k||3===k&&j>=.5)&&(j=1-j),3===k&&(j*=2),1===l?j*=j:2===l?j*=j*j:3===l?j*=j*j*j:4===l&&(j*=j*j*j*j),1===k?this.ratio=1-j:2===k?this.ratio=j:this._time/r<.5?this.ratio=j/2:this.ratio=1-j/2):this.ratio=this._ease.getRatio(this._time/r)),o===this._time&&!c&&q===this._cycle)return void(p!==this._totalTime&&this._onUpdate&&(b||this._callback("onUpdate")));if(!this._initted){if(this._init(),!this._initted||this._gc)return;if(!c&&this._firstPT&&(this.vars.lazy!==!1&&this._duration||this.vars.lazy&&!this._duration))return this._time=o,this._totalTime=p,this._rawPrevTime=s,this._cycle=q,h.lazyTweens.push(this),void(this._lazy=[a,b]);this._time&&!d?this.ratio=this._ease.getRatio(this._time/r):d&&this._ease._calcEnd&&(this.ratio=this._ease.getRatio(0===this._time?0:1))}for(this._lazy!==!1&&(this._lazy=!1),this._active||!this._paused&&this._time!==o&&a>=0&&(this._active=!0),0===p&&(2===this._initted&&a>0&&this._init(),this._startAt&&(a>=0?this._startAt.render(a,b,c):e||(e="_dummyGS")),this.vars.onStart&&(0!==this._totalTime||0===r)&&(b||this._callback("onStart"))),f=this._firstPT;f;)f.f?f.t[f.p](f.c*this.ratio+f.s):f.t[f.p]=f.c*this.ratio+f.s,f=f._next;this._onUpdate&&(0>a&&this._startAt&&this._startTime&&this._startAt.render(a,b,c),b||(this._totalTime!==p||e)&&this._callback("onUpdate")),this._cycle!==q&&(b||this._gc||this.vars.onRepeat&&this._callback("onRepeat")),e&&(!this._gc||c)&&(0>a&&this._startAt&&!this._onUpdate&&this._startTime&&this._startAt.render(a,b,c),d&&(this._timeline.autoRemoveChildren&&this._enabled(!1,!1),this._active=!1),!b&&this.vars[e]&&this._callback(e),0===r&&this._rawPrevTime===g&&m!==g&&(this._rawPrevTime=0))},f.to=function(a,b,c){return new f(a,b,c)},f.from=function(a,b,c){return c.runBackwards=!0,c.immediateRender=0!=c.immediateRender,new f(a,b,c)},f.fromTo=function(a,b,c,d){return d.startAt=c,d.immediateRender=0!=d.immediateRender&&0!=c.immediateRender,new f(a,b,d)},f.staggerTo=f.allTo=function(a,b,g,h,k,m,n){h=h||0;var o,p,q,r,s=0,t=[],u=function(){g.onComplete&&g.onComplete.apply(g.onCompleteScope||this,arguments),k.apply(n||g.callbackScope||this,m||l)},v=g.cycle,w=g.startAt&&g.startAt.cycle;for(j(a)||("string"==typeof a&&(a=c.selector(a)||a),i(a)&&(a=d(a))),a=a||[],0>h&&(a=d(a),a.reverse(),h*=-1),o=a.length-1,q=0;o>=q;q++){p={};for(r in g)p[r]=g[r];if(v&&(e(p,a,q),null!=p.duration&&(b=p.duration,delete p.duration)),w){w=p.startAt={};for(r in g.startAt)w[r]=g.startAt[r];e(p.startAt,a,q)}p.delay=s+(p.delay||0),q===o&&k&&(p.onComplete=u),t[q]=new f(a[q],b,p),s+=h}return t},f.staggerFrom=f.allFrom=function(a,b,c,d,e,g,h){return c.runBackwards=!0,c.immediateRender=0!=c.immediateRender,f.staggerTo(a,b,c,d,e,g,h)},f.staggerFromTo=f.allFromTo=function(a,b,c,d,e,g,h,i){return d.startAt=c,d.immediateRender=0!=d.immediateRender&&0!=c.immediateRender,f.staggerTo(a,b,d,e,g,h,i)},f.delayedCall=function(a,b,c,d,e){return new f(b,0,{delay:a,onComplete:b,onCompleteParams:c,callbackScope:d,onReverseComplete:b,onReverseCompleteParams:c,immediateRender:!1,useFrames:e,overwrite:0})},f.set=function(a,b){return new f(a,0,b)},f.isTweening=function(a){return c.getTweensOf(a,!0).length>0};var m=function(a,b){for(var d=[],e=0,f=a._first;f;)f instanceof c?d[e++]=f:(b&&(d[e++]=f),d=d.concat(m(f,b)),e=d.length),f=f._next;return d},n=f.getAllTweens=function(b){return m(a._rootTimeline,b).concat(m(a._rootFramesTimeline,b))};f.killAll=function(a,c,d,e){null==c&&(c=!0),null==d&&(d=!0);var f,g,h,i=n(0!=e),j=i.length,k=c&&d&&e;for(h=0;j>h;h++)g=i[h],(k||g instanceof b||(f=g.target===g.vars.onComplete)&&d||c&&!f)&&(a?g.totalTime(g._reversed?0:g.totalDuration()):g._enabled(!1,!1))},f.killChildTweensOf=function(a,b){if(null!=a){var e,g,k,l,m,n=h.tweenLookup;if("string"==typeof a&&(a=c.selector(a)||a),i(a)&&(a=d(a)),j(a))for(l=a.length;--l>-1;)f.killChildTweensOf(a[l],b);else{e=[];for(k in n)for(g=n[k].target.parentNode;g;)g===a&&(e=e.concat(n[k].tweens)),g=g.parentNode;for(m=e.length,l=0;m>l;l++)b&&e[l].totalTime(e[l].totalDuration()),e[l]._enabled(!1,!1)}}};var o=function(a,c,d,e){c=c!==!1,d=d!==!1,e=e!==!1;for(var f,g,h=n(e),i=c&&d&&e,j=h.length;--j>-1;)g=h[j],(i||g instanceof b||(f=g.target===g.vars.onComplete)&&d||c&&!f)&&g.paused(a)};return f.pauseAll=function(a,b,c){o(!0,a,b,c)},f.resumeAll=function(a,b,c){o(!1,a,b,c)},f.globalTimeScale=function(b){var d=a._rootTimeline,e=c.ticker.time;return arguments.length?(b=b||g,d._startTime=e-(e-d._startTime)*d._timeScale/b,d=a._rootFramesTimeline,e=c.ticker.frame,d._startTime=e-(e-d._startTime)*d._timeScale/b,d._timeScale=a._rootTimeline._timeScale=b,b):d._timeScale},k.progress=function(a,b){return arguments.length?this.totalTime(this.duration()*(this._yoyo&&0!==(1&this._cycle)?1-a:a)+this._cycle*(this._duration+this._repeatDelay),b):this._time/this.duration()},k.totalProgress=function(a,b){return arguments.length?this.totalTime(this.totalDuration()*a,b):this._totalTime/this.totalDuration()},k.time=function(a,b){return arguments.length?(this._dirty&&this.totalDuration(),a>this._duration&&(a=this._duration),this._yoyo&&0!==(1&this._cycle)?a=this._duration-a+this._cycle*(this._duration+this._repeatDelay):0!==this._repeat&&(a+=this._cycle*(this._duration+this._repeatDelay)),this.totalTime(a,b)):this._time},k.duration=function(b){return arguments.length?a.prototype.duration.call(this,b):this._duration},k.totalDuration=function(a){return arguments.length?-1===this._repeat?this:this.duration((a-this._repeat*this._repeatDelay)/(this._repeat+1)):(this._dirty&&(this._totalDuration=-1===this._repeat?999999999999:this._duration*(this._repeat+1)+this._repeatDelay*this._repeat,this._dirty=!1),this._totalDuration)},k.repeat=function(a){return arguments.length?(this._repeat=a,this._uncache(!0)):this._repeat},k.repeatDelay=function(a){return arguments.length?(this._repeatDelay=a,this._uncache(!0)):this._repeatDelay},k.yoyo=function(a){return arguments.length?(this._yoyo=a,this):this._yoyo},f},!0),_gsScope._gsDefine("TimelineLite",["core.Animation","core.SimpleTimeline","TweenLite"],function(a,b,c){var d=function(a){b.call(this,a),this._labels={},this.autoRemoveChildren=this.vars.autoRemoveChildren===!0,this.smoothChildTiming=this.vars.smoothChildTiming===!0,this._sortChildren=!0,this._onUpdate=this.vars.onUpdate;var c,d,e=this.vars;for(d in e)c=e[d],i(c)&&-1!==c.join("").indexOf("{self}")&&(e[d]=this._swapSelfInParams(c));i(e.tweens)&&this.add(e.tweens,0,e.align,e.stagger)},e=1e-10,f=c._internals,g=d._internals={},h=f.isSelector,i=f.isArray,j=f.lazyTweens,k=f.lazyRender,l=_gsScope._gsDefine.globals,m=function(a){var b,c={};for(b in a)c[b]=a[b];return c},n=function(a,b,c){var d,e,f=a.cycle;for(d in f)e=f[d],a[d]="function"==typeof e?e.call(b[c],c):e[c%e.length];delete a.cycle},o=g.pauseCallback=function(){},p=function(a){var b,c=[],d=a.length;for(b=0;b!==d;c.push(a[b++]));return c},q=d.prototype=new b;return d.version="1.19.0",q.constructor=d,q.kill()._gc=q._forcingPlayhead=q._hasPause=!1,q.to=function(a,b,d,e){var f=d.repeat&&l.TweenMax||c;return b?this.add(new f(a,b,d),e):this.set(a,d,e)},q.from=function(a,b,d,e){return this.add((d.repeat&&l.TweenMax||c).from(a,b,d),e)},q.fromTo=function(a,b,d,e,f){var g=e.repeat&&l.TweenMax||c;return b?this.add(g.fromTo(a,b,d,e),f):this.set(a,e,f)},q.staggerTo=function(a,b,e,f,g,i,j,k){var l,o,q=new d({onComplete:i,onCompleteParams:j,callbackScope:k,smoothChildTiming:this.smoothChildTiming}),r=e.cycle;for("string"==typeof a&&(a=c.selector(a)||a),a=a||[],h(a)&&(a=p(a)),f=f||0,0>f&&(a=p(a),a.reverse(),f*=-1),o=0;o<a.length;o++)l=m(e),l.startAt&&(l.startAt=m(l.startAt),l.startAt.cycle&&n(l.startAt,a,o)),r&&(n(l,a,o),null!=l.duration&&(b=l.duration,delete l.duration)),q.to(a[o],b,l,o*f);return this.add(q,g)},q.staggerFrom=function(a,b,c,d,e,f,g,h){return c.immediateRender=0!=c.immediateRender,c.runBackwards=!0,this.staggerTo(a,b,c,d,e,f,g,h)},q.staggerFromTo=function(a,b,c,d,e,f,g,h,i){return d.startAt=c,d.immediateRender=0!=d.immediateRender&&0!=c.immediateRender,this.staggerTo(a,b,d,e,f,g,h,i)},q.call=function(a,b,d,e){return this.add(c.delayedCall(0,a,b,d),e)},q.set=function(a,b,d){return d=this._parseTimeOrLabel(d,0,!0),null==b.immediateRender&&(b.immediateRender=d===this._time&&!this._paused),this.add(new c(a,0,b),d)},d.exportRoot=function(a,b){a=a||{},null==a.smoothChildTiming&&(a.smoothChildTiming=!0);var e,f,g=new d(a),h=g._timeline;for(null==b&&(b=!0),h._remove(g,!0),g._startTime=0,g._rawPrevTime=g._time=g._totalTime=h._time,e=h._first;e;)f=e._next,b&&e instanceof c&&e.target===e.vars.onComplete||g.add(e,e._startTime-e._delay),e=f;return h.add(g,0),g},q.add=function(e,f,g,h){var j,k,l,m,n,o;if("number"!=typeof f&&(f=this._parseTimeOrLabel(f,0,!0,e)),!(e instanceof a)){if(e instanceof Array||e&&e.push&&i(e)){for(g=g||"normal",h=h||0,j=f,k=e.length,l=0;k>l;l++)i(m=e[l])&&(m=new d({tweens:m})),this.add(m,j),"string"!=typeof m&&"function"!=typeof m&&("sequence"===g?j=m._startTime+m.totalDuration()/m._timeScale:"start"===g&&(m._startTime-=m.delay())),j+=h;return this._uncache(!0)}if("string"==typeof e)return this.addLabel(e,f);if("function"!=typeof e)throw"Cannot add "+e+" into the timeline; it is not a tween, timeline, function, or string.";e=c.delayedCall(0,e)}if(b.prototype.add.call(this,e,f),(this._gc||this._time===this._duration)&&!this._paused&&this._duration<this.duration())for(n=this,o=n.rawTime()>e._startTime;n._timeline;)o&&n._timeline.smoothChildTiming?n.totalTime(n._totalTime,!0):n._gc&&n._enabled(!0,!1),n=n._timeline;return this},q.remove=function(b){if(b instanceof a){this._remove(b,!1);var c=b._timeline=b.vars.useFrames?a._rootFramesTimeline:a._rootTimeline;return b._startTime=(b._paused?b._pauseTime:c._time)-(b._reversed?b.totalDuration()-b._totalTime:b._totalTime)/b._timeScale,this}if(b instanceof Array||b&&b.push&&i(b)){for(var d=b.length;--d>-1;)this.remove(b[d]);return this}return"string"==typeof b?this.removeLabel(b):this.kill(null,b)},q._remove=function(a,c){b.prototype._remove.call(this,a,c);var d=this._last;return d?this._time>d._startTime+d._totalDuration/d._timeScale&&(this._time=this.duration(),this._totalTime=this._totalDuration):this._time=this._totalTime=this._duration=this._totalDuration=0,this},q.append=function(a,b){return this.add(a,this._parseTimeOrLabel(null,b,!0,a))},q.insert=q.insertMultiple=function(a,b,c,d){return this.add(a,b||0,c,d)},q.appendMultiple=function(a,b,c,d){return this.add(a,this._parseTimeOrLabel(null,b,!0,a),c,d)},q.addLabel=function(a,b){return this._labels[a]=this._parseTimeOrLabel(b),this},q.addPause=function(a,b,d,e){var f=c.delayedCall(0,o,d,e||this);return f.vars.onComplete=f.vars.onReverseComplete=b,f.data="isPause",this._hasPause=!0,this.add(f,a)},q.removeLabel=function(a){return delete this._labels[a],this},q.getLabelTime=function(a){return null!=this._labels[a]?this._labels[a]:-1},q._parseTimeOrLabel=function(b,c,d,e){var f;if(e instanceof a&&e.timeline===this)this.remove(e);else if(e&&(e instanceof Array||e.push&&i(e)))for(f=e.length;--f>-1;)e[f]instanceof a&&e[f].timeline===this&&this.remove(e[f]);if("string"==typeof c)return this._parseTimeOrLabel(c,d&&"number"==typeof b&&null==this._labels[c]?b-this.duration():0,d);if(c=c||0,"string"!=typeof b||!isNaN(b)&&null==this._labels[b])null==b&&(b=this.duration());else{if(f=b.indexOf("="),-1===f)return null==this._labels[b]?d?this._labels[b]=this.duration()+c:c:this._labels[b]+c;c=parseInt(b.charAt(f-1)+"1",10)*Number(b.substr(f+1)),b=f>1?this._parseTimeOrLabel(b.substr(0,f-1),0,d):this.duration()}return Number(b)+c},q.seek=function(a,b){return this.totalTime("number"==typeof a?a:this._parseTimeOrLabel(a),b!==!1)},q.stop=function(){return this.paused(!0)},q.gotoAndPlay=function(a,b){return this.play(a,b)},q.gotoAndStop=function(a,b){return this.pause(a,b)},q.render=function(a,b,c){this._gc&&this._enabled(!0,!1);var d,f,g,h,i,l,m,n=this._dirty?this.totalDuration():this._totalDuration,o=this._time,p=this._startTime,q=this._timeScale,r=this._paused;if(a>=n-1e-7)this._totalTime=this._time=n,this._reversed||this._hasPausedChild()||(f=!0,h="onComplete",i=!!this._timeline.autoRemoveChildren,0===this._duration&&(0>=a&&a>=-1e-7||this._rawPrevTime<0||this._rawPrevTime===e)&&this._rawPrevTime!==a&&this._first&&(i=!0,this._rawPrevTime>e&&(h="onReverseComplete"))),this._rawPrevTime=this._duration||!b||a||this._rawPrevTime===a?a:e,a=n+1e-4;else if(1e-7>a)if(this._totalTime=this._time=0,(0!==o||0===this._duration&&this._rawPrevTime!==e&&(this._rawPrevTime>0||0>a&&this._rawPrevTime>=0))&&(h="onReverseComplete",f=this._reversed),0>a)this._active=!1,this._timeline.autoRemoveChildren&&this._reversed?(i=f=!0,h="onReverseComplete"):this._rawPrevTime>=0&&this._first&&(i=!0),this._rawPrevTime=a;else{if(this._rawPrevTime=this._duration||!b||a||this._rawPrevTime===a?a:e,0===a&&f)for(d=this._first;d&&0===d._startTime;)d._duration||(f=!1),d=d._next;a=0,this._initted||(i=!0)}else{if(this._hasPause&&!this._forcingPlayhead&&!b){if(a>=o)for(d=this._first;d&&d._startTime<=a&&!l;)d._duration||"isPause"!==d.data||d.ratio||0===d._startTime&&0===this._rawPrevTime||(l=d),d=d._next;else for(d=this._last;d&&d._startTime>=a&&!l;)d._duration||"isPause"===d.data&&d._rawPrevTime>0&&(l=d),d=d._prev;l&&(this._time=a=l._startTime,this._totalTime=a+this._cycle*(this._totalDuration+this._repeatDelay))}this._totalTime=this._time=this._rawPrevTime=a}if(this._time!==o&&this._first||c||i||l){if(this._initted||(this._initted=!0),this._active||!this._paused&&this._time!==o&&a>0&&(this._active=!0),0===o&&this.vars.onStart&&(0===this._time&&this._duration||b||this._callback("onStart")),m=this._time,m>=o)for(d=this._first;d&&(g=d._next,m===this._time&&(!this._paused||r));)(d._active||d._startTime<=m&&!d._paused&&!d._gc)&&(l===d&&this.pause(),d._reversed?d.render((d._dirty?d.totalDuration():d._totalDuration)-(a-d._startTime)*d._timeScale,b,c):d.render((a-d._startTime)*d._timeScale,b,c)),d=g;else for(d=this._last;d&&(g=d._prev,m===this._time&&(!this._paused||r));){if(d._active||d._startTime<=o&&!d._paused&&!d._gc){if(l===d){for(l=d._prev;l&&l.endTime()>this._time;)l.render(l._reversed?l.totalDuration()-(a-l._startTime)*l._timeScale:(a-l._startTime)*l._timeScale,b,c),l=l._prev;l=null,this.pause()}d._reversed?d.render((d._dirty?d.totalDuration():d._totalDuration)-(a-d._startTime)*d._timeScale,b,c):d.render((a-d._startTime)*d._timeScale,b,c)}d=g}this._onUpdate&&(b||(j.length&&k(),this._callback("onUpdate"))),h&&(this._gc||(p===this._startTime||q!==this._timeScale)&&(0===this._time||n>=this.totalDuration())&&(f&&(j.length&&k(),this._timeline.autoRemoveChildren&&this._enabled(!1,!1),this._active=!1),!b&&this.vars[h]&&this._callback(h)))}},q._hasPausedChild=function(){for(var a=this._first;a;){if(a._paused||a instanceof d&&a._hasPausedChild())return!0;a=a._next}return!1},q.getChildren=function(a,b,d,e){e=e||-9999999999;for(var f=[],g=this._first,h=0;g;)g._startTime<e||(g instanceof c?b!==!1&&(f[h++]=g):(d!==!1&&(f[h++]=g),a!==!1&&(f=f.concat(g.getChildren(!0,b,d)),h=f.length))),g=g._next;return f},q.getTweensOf=function(a,b){var d,e,f=this._gc,g=[],h=0;for(f&&this._enabled(!0,!0),d=c.getTweensOf(a),e=d.length;--e>-1;)(d[e].timeline===this||b&&this._contains(d[e]))&&(g[h++]=d[e]);return f&&this._enabled(!1,!0),g},q.recent=function(){return this._recent},q._contains=function(a){for(var b=a.timeline;b;){if(b===this)return!0;b=b.timeline}return!1},q.shiftChildren=function(a,b,c){c=c||0;for(var d,e=this._first,f=this._labels;e;)e._startTime>=c&&(e._startTime+=a),e=e._next;if(b)for(d in f)f[d]>=c&&(f[d]+=a);return this._uncache(!0)},q._kill=function(a,b){if(!a&&!b)return this._enabled(!1,!1);for(var c=b?this.getTweensOf(b):this.getChildren(!0,!0,!1),d=c.length,e=!1;--d>-1;)c[d]._kill(a,b)&&(e=!0);return e},q.clear=function(a){var b=this.getChildren(!1,!0,!0),c=b.length;for(this._time=this._totalTime=0;--c>-1;)b[c]._enabled(!1,!1);return a!==!1&&(this._labels={}),this._uncache(!0)},q.invalidate=function(){for(var b=this._first;b;)b.invalidate(),b=b._next;return a.prototype.invalidate.call(this)},q._enabled=function(a,c){if(a===this._gc)for(var d=this._first;d;)d._enabled(a,!0),d=d._next;return b.prototype._enabled.call(this,a,c)},q.totalTime=function(b,c,d){this._forcingPlayhead=!0;var e=a.prototype.totalTime.apply(this,arguments);return this._forcingPlayhead=!1,e},q.duration=function(a){return arguments.length?(0!==this.duration()&&0!==a&&this.timeScale(this._duration/a),this):(this._dirty&&this.totalDuration(),this._duration)},q.totalDuration=function(a){if(!arguments.length){if(this._dirty){for(var b,c,d=0,e=this._last,f=999999999999;e;)b=e._prev,e._dirty&&e.totalDuration(),e._startTime>f&&this._sortChildren&&!e._paused?this.add(e,e._startTime-e._delay):f=e._startTime,e._startTime<0&&!e._paused&&(d-=e._startTime,this._timeline.smoothChildTiming&&(this._startTime+=e._startTime/this._timeScale),this.shiftChildren(-e._startTime,!1,-9999999999),f=0),c=e._startTime+e._totalDuration/e._timeScale,c>d&&(d=c),e=b;this._duration=this._totalDuration=d,this._dirty=!1}return this._totalDuration}return a&&this.totalDuration()?this.timeScale(this._totalDuration/a):this},q.paused=function(b){if(!b)for(var c=this._first,d=this._time;c;)c._startTime===d&&"isPause"===c.data&&(c._rawPrevTime=0),c=c._next;return a.prototype.paused.apply(this,arguments)},q.usesFrames=function(){for(var b=this._timeline;b._timeline;)b=b._timeline;return b===a._rootFramesTimeline},q.rawTime=function(){return this._paused?this._totalTime:(this._timeline.rawTime()-this._startTime)*this._timeScale},d},!0),_gsScope._gsDefine("TimelineMax",["TimelineLite","TweenLite","easing.Ease"],function(a,b,c){var d=function(b){a.call(this,b),this._repeat=this.vars.repeat||0,this._repeatDelay=this.vars.repeatDelay||0,this._cycle=0,this._yoyo=this.vars.yoyo===!0,this._dirty=!0},e=1e-10,f=b._internals,g=f.lazyTweens,h=f.lazyRender,i=_gsScope._gsDefine.globals,j=new c(null,null,1,0),k=d.prototype=new a;return k.constructor=d,k.kill()._gc=!1,d.version="1.19.0",k.invalidate=function(){return this._yoyo=this.vars.yoyo===!0,this._repeat=this.vars.repeat||0,this._repeatDelay=this.vars.repeatDelay||0,this._uncache(!0),a.prototype.invalidate.call(this)},k.addCallback=function(a,c,d,e){return this.add(b.delayedCall(0,a,d,e),c)},k.removeCallback=function(a,b){if(a)if(null==b)this._kill(null,a);else for(var c=this.getTweensOf(a,!1),d=c.length,e=this._parseTimeOrLabel(b);--d>-1;)c[d]._startTime===e&&c[d]._enabled(!1,!1);return this},k.removePause=function(b){return this.removeCallback(a._internals.pauseCallback,b)},k.tweenTo=function(a,c){c=c||{};var d,e,f,g={ease:j,useFrames:this.usesFrames(),immediateRender:!1},h=c.repeat&&i.TweenMax||b;for(e in c)g[e]=c[e];return g.time=this._parseTimeOrLabel(a),d=Math.abs(Number(g.time)-this._time)/this._timeScale||.001,f=new h(this,d,g),g.onStart=function(){f.target.paused(!0),f.vars.time!==f.target.time()&&d===f.duration()&&f.duration(Math.abs(f.vars.time-f.target.time())/f.target._timeScale),c.onStart&&f._callback("onStart")},f},k.tweenFromTo=function(a,b,c){c=c||{},a=this._parseTimeOrLabel(a),c.startAt={onComplete:this.seek,onCompleteParams:[a],callbackScope:this},c.immediateRender=c.immediateRender!==!1;var d=this.tweenTo(b,c);return d.duration(Math.abs(d.vars.time-a)/this._timeScale||.001)},k.render=function(a,b,c){this._gc&&this._enabled(!0,!1);var d,f,i,j,k,l,m,n,o=this._dirty?this.totalDuration():this._totalDuration,p=this._duration,q=this._time,r=this._totalTime,s=this._startTime,t=this._timeScale,u=this._rawPrevTime,v=this._paused,w=this._cycle;if(a>=o-1e-7)this._locked||(this._totalTime=o,this._cycle=this._repeat),this._reversed||this._hasPausedChild()||(f=!0,j="onComplete",k=!!this._timeline.autoRemoveChildren,0===this._duration&&(0>=a&&a>=-1e-7||0>u||u===e)&&u!==a&&this._first&&(k=!0,u>e&&(j="onReverseComplete"))),this._rawPrevTime=this._duration||!b||a||this._rawPrevTime===a?a:e,this._yoyo&&0!==(1&this._cycle)?this._time=a=0:(this._time=p,a=p+1e-4);else if(1e-7>a)if(this._locked||(this._totalTime=this._cycle=0),this._time=0,(0!==q||0===p&&u!==e&&(u>0||0>a&&u>=0)&&!this._locked)&&(j="onReverseComplete",f=this._reversed),0>a)this._active=!1,this._timeline.autoRemoveChildren&&this._reversed?(k=f=!0,j="onReverseComplete"):u>=0&&this._first&&(k=!0),this._rawPrevTime=a;else{if(this._rawPrevTime=p||!b||a||this._rawPrevTime===a?a:e,0===a&&f)for(d=this._first;d&&0===d._startTime;)d._duration||(f=!1),d=d._next;a=0,this._initted||(k=!0)}else if(0===p&&0>u&&(k=!0),this._time=this._rawPrevTime=a,this._locked||(this._totalTime=a,0!==this._repeat&&(l=p+this._repeatDelay,this._cycle=this._totalTime/l>>0,0!==this._cycle&&this._cycle===this._totalTime/l&&a>=r&&this._cycle--,this._time=this._totalTime-this._cycle*l,this._yoyo&&0!==(1&this._cycle)&&(this._time=p-this._time),this._time>p?(this._time=p,a=p+1e-4):this._time<0?this._time=a=0:a=this._time)),this._hasPause&&!this._forcingPlayhead&&!b){if(a=this._time,a>=q)for(d=this._first;d&&d._startTime<=a&&!m;)d._duration||"isPause"!==d.data||d.ratio||0===d._startTime&&0===this._rawPrevTime||(m=d),d=d._next;else for(d=this._last;d&&d._startTime>=a&&!m;)d._duration||"isPause"===d.data&&d._rawPrevTime>0&&(m=d),d=d._prev;m&&(this._time=a=m._startTime,this._totalTime=a+this._cycle*(this._totalDuration+this._repeatDelay))}if(this._cycle!==w&&!this._locked){var x=this._yoyo&&0!==(1&w),y=x===(this._yoyo&&0!==(1&this._cycle)),z=this._totalTime,A=this._cycle,B=this._rawPrevTime,C=this._time;if(this._totalTime=w*p,this._cycle<w?x=!x:this._totalTime+=p,this._time=q,this._rawPrevTime=0===p?u-1e-4:u,this._cycle=w,this._locked=!0,q=x?0:p,this.render(q,b,0===p),b||this._gc||this.vars.onRepeat&&this._callback("onRepeat"),q!==this._time)return;if(y&&(q=x?p+1e-4:-1e-4,this.render(q,!0,!1)),this._locked=!1,this._paused&&!v)return;this._time=C,this._totalTime=z,this._cycle=A,this._rawPrevTime=B}if(!(this._time!==q&&this._first||c||k||m))return void(r!==this._totalTime&&this._onUpdate&&(b||this._callback("onUpdate")));if(this._initted||(this._initted=!0),this._active||!this._paused&&this._totalTime!==r&&a>0&&(this._active=!0),0===r&&this.vars.onStart&&(0===this._totalTime&&this._totalDuration||b||this._callback("onStart")),n=this._time,n>=q)for(d=this._first;d&&(i=d._next,n===this._time&&(!this._paused||v));)(d._active||d._startTime<=this._time&&!d._paused&&!d._gc)&&(m===d&&this.pause(),d._reversed?d.render((d._dirty?d.totalDuration():d._totalDuration)-(a-d._startTime)*d._timeScale,b,c):d.render((a-d._startTime)*d._timeScale,b,c)),d=i;else for(d=this._last;d&&(i=d._prev,n===this._time&&(!this._paused||v));){if(d._active||d._startTime<=q&&!d._paused&&!d._gc){if(m===d){for(m=d._prev;m&&m.endTime()>this._time;)m.render(m._reversed?m.totalDuration()-(a-m._startTime)*m._timeScale:(a-m._startTime)*m._timeScale,b,c),m=m._prev;m=null,this.pause()}d._reversed?d.render((d._dirty?d.totalDuration():d._totalDuration)-(a-d._startTime)*d._timeScale,b,c):d.render((a-d._startTime)*d._timeScale,b,c)}d=i}this._onUpdate&&(b||(g.length&&h(),this._callback("onUpdate"))),j&&(this._locked||this._gc||(s===this._startTime||t!==this._timeScale)&&(0===this._time||o>=this.totalDuration())&&(f&&(g.length&&h(),this._timeline.autoRemoveChildren&&this._enabled(!1,!1),this._active=!1),!b&&this.vars[j]&&this._callback(j)))},k.getActive=function(a,b,c){null==a&&(a=!0),null==b&&(b=!0),null==c&&(c=!1);var d,e,f=[],g=this.getChildren(a,b,c),h=0,i=g.length;for(d=0;i>d;d++)e=g[d],e.isActive()&&(f[h++]=e);return f},k.getLabelAfter=function(a){a||0!==a&&(a=this._time);var b,c=this.getLabelsArray(),d=c.length;for(b=0;d>b;b++)if(c[b].time>a)return c[b].name;return null},k.getLabelBefore=function(a){null==a&&(a=this._time);for(var b=this.getLabelsArray(),c=b.length;--c>-1;)if(b[c].time<a)return b[c].name;return null},k.getLabelsArray=function(){var a,b=[],c=0;for(a in this._labels)b[c++]={time:this._labels[a],name:a};return b.sort(function(a,b){return a.time-b.time}),b},k.progress=function(a,b){return arguments.length?this.totalTime(this.duration()*(this._yoyo&&0!==(1&this._cycle)?1-a:a)+this._cycle*(this._duration+this._repeatDelay),b):this._time/this.duration()},k.totalProgress=function(a,b){return arguments.length?this.totalTime(this.totalDuration()*a,b):this._totalTime/this.totalDuration()},k.totalDuration=function(b){return arguments.length?-1!==this._repeat&&b?this.timeScale(this.totalDuration()/b):this:(this._dirty&&(a.prototype.totalDuration.call(this),this._totalDuration=-1===this._repeat?999999999999:this._duration*(this._repeat+1)+this._repeatDelay*this._repeat),this._totalDuration)},k.time=function(a,b){return arguments.length?(this._dirty&&this.totalDuration(),a>this._duration&&(a=this._duration),this._yoyo&&0!==(1&this._cycle)?a=this._duration-a+this._cycle*(this._duration+this._repeatDelay):0!==this._repeat&&(a+=this._cycle*(this._duration+this._repeatDelay)),this.totalTime(a,b)):this._time},k.repeat=function(a){return arguments.length?(this._repeat=a,this._uncache(!0)):this._repeat},k.repeatDelay=function(a){return arguments.length?(this._repeatDelay=a,this._uncache(!0)):this._repeatDelay},k.yoyo=function(a){return arguments.length?(this._yoyo=a,this):this._yoyo},k.currentLabel=function(a){return arguments.length?this.seek(a,!0):this.getLabelBefore(this._time+1e-8)},d},!0),function(){var a=180/Math.PI,b=[],c=[],d=[],e={},f=_gsScope._gsDefine.globals,g=function(a,b,c,d){c===d&&(c=d-(d-b)/1e6),a===b&&(b=a+(c-a)/1e6),this.a=a,this.b=b,this.c=c,this.d=d,this.da=d-a,this.ca=c-a,this.ba=b-a},h=",x,y,z,left,top,right,bottom,marginTop,marginLeft,marginRight,marginBottom,paddingLeft,paddingTop,paddingRight,paddingBottom,backgroundPosition,backgroundPosition_y,",i=function(a,b,c,d){var e={a:a},f={},g={},h={c:d},i=(a+b)/2,j=(b+c)/2,k=(c+d)/2,l=(i+j)/2,m=(j+k)/2,n=(m-l)/8;return e.b=i+(a-i)/4,f.b=l+n,e.c=f.a=(e.b+f.b)/2,f.c=g.a=(l+m)/2,g.b=m-n,h.b=k+(d-k)/4,g.c=h.a=(g.b+h.b)/2,[e,f,g,h]},j=function(a,e,f,g,h){var j,k,l,m,n,o,p,q,r,s,t,u,v,w=a.length-1,x=0,y=a[0].a;for(j=0;w>j;j++)n=a[x],k=n.a,l=n.d,m=a[x+1].d,h?(t=b[j],u=c[j],v=(u+t)*e*.25/(g?.5:d[j]||.5),o=l-(l-k)*(g?.5*e:0!==t?v/t:0),p=l+(m-l)*(g?.5*e:0!==u?v/u:0),q=l-(o+((p-o)*(3*t/(t+u)+.5)/4||0))):(o=l-(l-k)*e*.5,p=l+(m-l)*e*.5,q=l-(o+p)/2),o+=q,p+=q,n.c=r=o,0!==j?n.b=y:n.b=y=n.a+.6*(n.c-n.a),n.da=l-k,n.ca=r-k,n.ba=y-k,f?(s=i(k,y,r,l),a.splice(x,1,s[0],s[1],s[2],s[3]),x+=4):x++,y=p;n=a[x],n.b=y,n.c=y+.4*(n.d-y),n.da=n.d-n.a,n.ca=n.c-n.a,n.ba=y-n.a,f&&(s=i(n.a,y,n.c,n.d),a.splice(x,1,s[0],s[1],s[2],s[3]))},k=function(a,d,e,f){var h,i,j,k,l,m,n=[];if(f)for(a=[f].concat(a),i=a.length;--i>-1;)"string"==typeof(m=a[i][d])&&"="===m.charAt(1)&&(a[i][d]=f[d]+Number(m.charAt(0)+m.substr(2)));if(h=a.length-2,0>h)return n[0]=new g(a[0][d],0,0,a[-1>h?0:1][d]),n;for(i=0;h>i;i++)j=a[i][d],k=a[i+1][d],n[i]=new g(j,0,0,k),e&&(l=a[i+2][d],b[i]=(b[i]||0)+(k-j)*(k-j),c[i]=(c[i]||0)+(l-k)*(l-k));return n[i]=new g(a[i][d],0,0,a[i+1][d]),n},l=function(a,f,g,i,l,m){var n,o,p,q,r,s,t,u,v={},w=[],x=m||a[0];l="string"==typeof l?","+l+",":h,null==f&&(f=1);for(o in a[0])w.push(o);if(a.length>1){for(u=a[a.length-1],t=!0,n=w.length;--n>-1;)if(o=w[n],Math.abs(x[o]-u[o])>.05){t=!1;break}t&&(a=a.concat(),m&&a.unshift(m),a.push(a[1]),m=a[a.length-3])}for(b.length=c.length=d.length=0,n=w.length;--n>-1;)o=w[n],e[o]=-1!==l.indexOf(","+o+","),v[o]=k(a,o,e[o],m);for(n=b.length;--n>-1;)b[n]=Math.sqrt(b[n]),c[n]=Math.sqrt(c[n]);if(!i){for(n=w.length;--n>-1;)if(e[o])for(p=v[w[n]],s=p.length-1,q=0;s>q;q++)r=p[q+1].da/c[q]+p[q].da/b[q]||0,d[q]=(d[q]||0)+r*r;for(n=d.length;--n>-1;)d[n]=Math.sqrt(d[n])}for(n=w.length,q=g?4:1;--n>-1;)o=w[n],p=v[o],j(p,f,g,i,e[o]),t&&(p.splice(0,q),p.splice(p.length-q,q));return v},m=function(a,b,c){b=b||"soft";var d,e,f,h,i,j,k,l,m,n,o,p={},q="cubic"===b?3:2,r="soft"===b,s=[];if(r&&c&&(a=[c].concat(a)),null==a||a.length<q+1)throw"invalid Bezier data";for(m in a[0])s.push(m);for(j=s.length;--j>-1;){for(m=s[j],p[m]=i=[],n=0,l=a.length,k=0;l>k;k++)d=null==c?a[k][m]:"string"==typeof(o=a[k][m])&&"="===o.charAt(1)?c[m]+Number(o.charAt(0)+o.substr(2)):Number(o),r&&k>1&&l-1>k&&(i[n++]=(d+i[n-2])/2),i[n++]=d;for(l=n-q+1,n=0,k=0;l>k;k+=q)d=i[k],e=i[k+1],f=i[k+2],h=2===q?0:i[k+3],i[n++]=o=3===q?new g(d,e,f,h):new g(d,(2*e+d)/3,(2*e+f)/3,f);i.length=n}return p},n=function(a,b,c){for(var d,e,f,g,h,i,j,k,l,m,n,o=1/c,p=a.length;--p>-1;)for(m=a[p],f=m.a,g=m.d-f,h=m.c-f,i=m.b-f,d=e=0,k=1;c>=k;k++)j=o*k,l=1-j,d=e-(e=(j*j*g+3*l*(j*h+l*i))*j),n=p*c+k-1,b[n]=(b[n]||0)+d*d},o=function(a,b){b=b>>0||6;var c,d,e,f,g=[],h=[],i=0,j=0,k=b-1,l=[],m=[];for(c in a)n(a[c],g,b);for(e=g.length,d=0;e>d;d++)i+=Math.sqrt(g[d]),f=d%b,m[f]=i,f===k&&(j+=i,f=d/b>>0,l[f]=m,h[f]=j,i=0,m=[]);return{length:j,lengths:h,
segments:l}},p=_gsScope._gsDefine.plugin({propName:"bezier",priority:-1,version:"1.3.7",API:2,global:!0,init:function(a,b,c){this._target=a,b instanceof Array&&(b={values:b}),this._func={},this._mod={},this._props=[],this._timeRes=null==b.timeResolution?6:parseInt(b.timeResolution,10);var d,e,f,g,h,i=b.values||[],j={},k=i[0],n=b.autoRotate||c.vars.orientToBezier;this._autoRotate=n?n instanceof Array?n:[["x","y","rotation",n===!0?0:Number(n)||0]]:null;for(d in k)this._props.push(d);for(f=this._props.length;--f>-1;)d=this._props[f],this._overwriteProps.push(d),e=this._func[d]="function"==typeof a[d],j[d]=e?a[d.indexOf("set")||"function"!=typeof a["get"+d.substr(3)]?d:"get"+d.substr(3)]():parseFloat(a[d]),h||j[d]!==i[0][d]&&(h=j);if(this._beziers="cubic"!==b.type&&"quadratic"!==b.type&&"soft"!==b.type?l(i,isNaN(b.curviness)?1:b.curviness,!1,"thruBasic"===b.type,b.correlate,h):m(i,b.type,j),this._segCount=this._beziers[d].length,this._timeRes){var p=o(this._beziers,this._timeRes);this._length=p.length,this._lengths=p.lengths,this._segments=p.segments,this._l1=this._li=this._s1=this._si=0,this._l2=this._lengths[0],this._curSeg=this._segments[0],this._s2=this._curSeg[0],this._prec=1/this._curSeg.length}if(n=this._autoRotate)for(this._initialRotations=[],n[0]instanceof Array||(this._autoRotate=n=[n]),f=n.length;--f>-1;){for(g=0;3>g;g++)d=n[f][g],this._func[d]="function"==typeof a[d]?a[d.indexOf("set")||"function"!=typeof a["get"+d.substr(3)]?d:"get"+d.substr(3)]:!1;d=n[f][2],this._initialRotations[f]=(this._func[d]?this._func[d].call(this._target):this._target[d])||0,this._overwriteProps.push(d)}return this._startRatio=c.vars.runBackwards?1:0,!0},set:function(b){var c,d,e,f,g,h,i,j,k,l,m=this._segCount,n=this._func,o=this._target,p=b!==this._startRatio;if(this._timeRes){if(k=this._lengths,l=this._curSeg,b*=this._length,e=this._li,b>this._l2&&m-1>e){for(j=m-1;j>e&&(this._l2=k[++e])<=b;);this._l1=k[e-1],this._li=e,this._curSeg=l=this._segments[e],this._s2=l[this._s1=this._si=0]}else if(b<this._l1&&e>0){for(;e>0&&(this._l1=k[--e])>=b;);0===e&&b<this._l1?this._l1=0:e++,this._l2=k[e],this._li=e,this._curSeg=l=this._segments[e],this._s1=l[(this._si=l.length-1)-1]||0,this._s2=l[this._si]}if(c=e,b-=this._l1,e=this._si,b>this._s2&&e<l.length-1){for(j=l.length-1;j>e&&(this._s2=l[++e])<=b;);this._s1=l[e-1],this._si=e}else if(b<this._s1&&e>0){for(;e>0&&(this._s1=l[--e])>=b;);0===e&&b<this._s1?this._s1=0:e++,this._s2=l[e],this._si=e}h=(e+(b-this._s1)/(this._s2-this._s1))*this._prec||0}else c=0>b?0:b>=1?m-1:m*b>>0,h=(b-c*(1/m))*m;for(d=1-h,e=this._props.length;--e>-1;)f=this._props[e],g=this._beziers[f][c],i=(h*h*g.da+3*d*(h*g.ca+d*g.ba))*h+g.a,this._mod[f]&&(i=this._mod[f](i,o)),n[f]?o[f](i):o[f]=i;if(this._autoRotate){var q,r,s,t,u,v,w,x=this._autoRotate;for(e=x.length;--e>-1;)f=x[e][2],v=x[e][3]||0,w=x[e][4]===!0?1:a,g=this._beziers[x[e][0]],q=this._beziers[x[e][1]],g&&q&&(g=g[c],q=q[c],r=g.a+(g.b-g.a)*h,t=g.b+(g.c-g.b)*h,r+=(t-r)*h,t+=(g.c+(g.d-g.c)*h-t)*h,s=q.a+(q.b-q.a)*h,u=q.b+(q.c-q.b)*h,s+=(u-s)*h,u+=(q.c+(q.d-q.c)*h-u)*h,i=p?Math.atan2(u-s,t-r)*w+v:this._initialRotations[e],this._mod[f]&&(i=this._mod[f](i,o)),n[f]?o[f](i):o[f]=i)}}}),q=p.prototype;p.bezierThrough=l,p.cubicToQuadratic=i,p._autoCSS=!0,p.quadraticToCubic=function(a,b,c){return new g(a,(2*b+a)/3,(2*b+c)/3,c)},p._cssRegister=function(){var a=f.CSSPlugin;if(a){var b=a._internals,c=b._parseToProxy,d=b._setPluginRatio,e=b.CSSPropTween;b._registerComplexSpecialProp("bezier",{parser:function(a,b,f,g,h,i){b instanceof Array&&(b={values:b}),i=new p;var j,k,l,m=b.values,n=m.length-1,o=[],q={};if(0>n)return h;for(j=0;n>=j;j++)l=c(a,m[j],g,h,i,n!==j),o[j]=l.end;for(k in b)q[k]=b[k];return q.values=o,h=new e(a,"bezier",0,0,l.pt,2),h.data=l,h.plugin=i,h.setRatio=d,0===q.autoRotate&&(q.autoRotate=!0),!q.autoRotate||q.autoRotate instanceof Array||(j=q.autoRotate===!0?0:Number(q.autoRotate),q.autoRotate=null!=l.end.left?[["left","top","rotation",j,!1]]:null!=l.end.x?[["x","y","rotation",j,!1]]:!1),q.autoRotate&&(g._transform||g._enableTransforms(!1),l.autoRotate=g._target._gsTransform,l.proxy.rotation=l.autoRotate.rotation||0,g._overwriteProps.push("rotation")),i._onInitTween(l.proxy,q,g._tween),h}})}},q._mod=function(a){for(var b,c=this._overwriteProps,d=c.length;--d>-1;)b=a[c[d]],b&&"function"==typeof b&&(this._mod[c[d]]=b)},q._kill=function(a){var b,c,d=this._props;for(b in this._beziers)if(b in a)for(delete this._beziers[b],delete this._func[b],c=d.length;--c>-1;)d[c]===b&&d.splice(c,1);if(d=this._autoRotate)for(c=d.length;--c>-1;)a[d[c][2]]&&d.splice(c,1);return this._super._kill.call(this,a)}}(),_gsScope._gsDefine("plugins.CSSPlugin",["plugins.TweenPlugin","TweenLite"],function(a,b){var c,d,e,f,g=function(){a.call(this,"css"),this._overwriteProps.length=0,this.setRatio=g.prototype.setRatio},h=_gsScope._gsDefine.globals,i={},j=g.prototype=new a("css");j.constructor=g,g.version="1.19.0",g.API=2,g.defaultTransformPerspective=0,g.defaultSkewType="compensated",g.defaultSmoothOrigin=!0,j="px",g.suffixMap={top:j,right:j,bottom:j,left:j,width:j,height:j,fontSize:j,padding:j,margin:j,perspective:j,lineHeight:""};var k,l,m,n,o,p,q,r,s=/(?:\-|\.|\b)(\d|\.|e\-)+/g,t=/(?:\d|\-\d|\.\d|\-\.\d|\+=\d|\-=\d|\+=.\d|\-=\.\d)+/g,u=/(?:\+=|\-=|\-|\b)[\d\-\.]+[a-zA-Z0-9]*(?:%|\b)/gi,v=/(?![+-]?\d*\.?\d+|[+-]|e[+-]\d+)[^0-9]/g,w=/(?:\d|\-|\+|=|#|\.)*/g,x=/opacity *= *([^)]*)/i,y=/opacity:([^;]*)/i,z=/alpha\(opacity *=.+?\)/i,A=/^(rgb|hsl)/,B=/([A-Z])/g,C=/-([a-z])/gi,D=/(^(?:url\(\"|url\())|(?:(\"\))$|\)$)/gi,E=function(a,b){return b.toUpperCase()},F=/(?:Left|Right|Width)/i,G=/(M11|M12|M21|M22)=[\d\-\.e]+/gi,H=/progid\:DXImageTransform\.Microsoft\.Matrix\(.+?\)/i,I=/,(?=[^\)]*(?:\(|$))/gi,J=/[\s,\(]/i,K=Math.PI/180,L=180/Math.PI,M={},N=document,O=function(a){return N.createElementNS?N.createElementNS("http://www.w3.org/1999/xhtml",a):N.createElement(a)},P=O("div"),Q=O("img"),R=g._internals={_specialProps:i},S=navigator.userAgent,T=function(){var a=S.indexOf("Android"),b=O("a");return m=-1!==S.indexOf("Safari")&&-1===S.indexOf("Chrome")&&(-1===a||Number(S.substr(a+8,1))>3),o=m&&Number(S.substr(S.indexOf("Version/")+8,1))<6,n=-1!==S.indexOf("Firefox"),(/MSIE ([0-9]{1,}[\.0-9]{0,})/.exec(S)||/Trident\/.*rv:([0-9]{1,}[\.0-9]{0,})/.exec(S))&&(p=parseFloat(RegExp.$1)),b?(b.style.cssText="top:1px;opacity:.55;",/^0.55/.test(b.style.opacity)):!1}(),U=function(a){return x.test("string"==typeof a?a:(a.currentStyle?a.currentStyle.filter:a.style.filter)||"")?parseFloat(RegExp.$1)/100:1},V=function(a){window.console&&console.log(a)},W="",X="",Y=function(a,b){b=b||P;var c,d,e=b.style;if(void 0!==e[a])return a;for(a=a.charAt(0).toUpperCase()+a.substr(1),c=["O","Moz","ms","Ms","Webkit"],d=5;--d>-1&&void 0===e[c[d]+a];);return d>=0?(X=3===d?"ms":c[d],W="-"+X.toLowerCase()+"-",X+a):null},Z=N.defaultView?N.defaultView.getComputedStyle:function(){},$=g.getStyle=function(a,b,c,d,e){var f;return T||"opacity"!==b?(!d&&a.style[b]?f=a.style[b]:(c=c||Z(a))?f=c[b]||c.getPropertyValue(b)||c.getPropertyValue(b.replace(B,"-$1").toLowerCase()):a.currentStyle&&(f=a.currentStyle[b]),null==e||f&&"none"!==f&&"auto"!==f&&"auto auto"!==f?f:e):U(a)},_=R.convertToPixels=function(a,c,d,e,f){if("px"===e||!e)return d;if("auto"===e||!d)return 0;var h,i,j,k=F.test(c),l=a,m=P.style,n=0>d,o=1===d;if(n&&(d=-d),o&&(d*=100),"%"===e&&-1!==c.indexOf("border"))h=d/100*(k?a.clientWidth:a.clientHeight);else{if(m.cssText="border:0 solid red;position:"+$(a,"position")+";line-height:0;","%"!==e&&l.appendChild&&"v"!==e.charAt(0)&&"rem"!==e)m[k?"borderLeftWidth":"borderTopWidth"]=d+e;else{if(l=a.parentNode||N.body,i=l._gsCache,j=b.ticker.frame,i&&k&&i.time===j)return i.width*d/100;m[k?"width":"height"]=d+e}l.appendChild(P),h=parseFloat(P[k?"offsetWidth":"offsetHeight"]),l.removeChild(P),k&&"%"===e&&g.cacheWidths!==!1&&(i=l._gsCache=l._gsCache||{},i.time=j,i.width=h/d*100),0!==h||f||(h=_(a,c,d,e,!0))}return o&&(h/=100),n?-h:h},aa=R.calculateOffset=function(a,b,c){if("absolute"!==$(a,"position",c))return 0;var d="left"===b?"Left":"Top",e=$(a,"margin"+d,c);return a["offset"+d]-(_(a,b,parseFloat(e),e.replace(w,""))||0)},ba=function(a,b){var c,d,e,f={};if(b=b||Z(a,null))if(c=b.length)for(;--c>-1;)e=b[c],(-1===e.indexOf("-transform")||Ca===e)&&(f[e.replace(C,E)]=b.getPropertyValue(e));else for(c in b)(-1===c.indexOf("Transform")||Ba===c)&&(f[c]=b[c]);else if(b=a.currentStyle||a.style)for(c in b)"string"==typeof c&&void 0===f[c]&&(f[c.replace(C,E)]=b[c]);return T||(f.opacity=U(a)),d=Pa(a,b,!1),f.rotation=d.rotation,f.skewX=d.skewX,f.scaleX=d.scaleX,f.scaleY=d.scaleY,f.x=d.x,f.y=d.y,Ea&&(f.z=d.z,f.rotationX=d.rotationX,f.rotationY=d.rotationY,f.scaleZ=d.scaleZ),f.filters&&delete f.filters,f},ca=function(a,b,c,d,e){var f,g,h,i={},j=a.style;for(g in c)"cssText"!==g&&"length"!==g&&isNaN(g)&&(b[g]!==(f=c[g])||e&&e[g])&&-1===g.indexOf("Origin")&&("number"==typeof f||"string"==typeof f)&&(i[g]="auto"!==f||"left"!==g&&"top"!==g?""!==f&&"auto"!==f&&"none"!==f||"string"!=typeof b[g]||""===b[g].replace(v,"")?f:0:aa(a,g),void 0!==j[g]&&(h=new ra(j,g,j[g],h)));if(d)for(g in d)"className"!==g&&(i[g]=d[g]);return{difs:i,firstMPT:h}},da={width:["Left","Right"],height:["Top","Bottom"]},ea=["marginLeft","marginRight","marginTop","marginBottom"],fa=function(a,b,c){if("svg"===(a.nodeName+"").toLowerCase())return(c||Z(a))[b]||0;if(a.getBBox&&Ma(a))return a.getBBox()[b]||0;var d=parseFloat("width"===b?a.offsetWidth:a.offsetHeight),e=da[b],f=e.length;for(c=c||Z(a,null);--f>-1;)d-=parseFloat($(a,"padding"+e[f],c,!0))||0,d-=parseFloat($(a,"border"+e[f]+"Width",c,!0))||0;return d},ga=function(a,b){if("contain"===a||"auto"===a||"auto auto"===a)return a+" ";(null==a||""===a)&&(a="0 0");var c,d=a.split(" "),e=-1!==a.indexOf("left")?"0%":-1!==a.indexOf("right")?"100%":d[0],f=-1!==a.indexOf("top")?"0%":-1!==a.indexOf("bottom")?"100%":d[1];if(d.length>3&&!b){for(d=a.split(", ").join(",").split(","),a=[],c=0;c<d.length;c++)a.push(ga(d[c]));return a.join(",")}return null==f?f="center"===e?"50%":"0":"center"===f&&(f="50%"),("center"===e||isNaN(parseFloat(e))&&-1===(e+"").indexOf("="))&&(e="50%"),a=e+" "+f+(d.length>2?" "+d[2]:""),b&&(b.oxp=-1!==e.indexOf("%"),b.oyp=-1!==f.indexOf("%"),b.oxr="="===e.charAt(1),b.oyr="="===f.charAt(1),b.ox=parseFloat(e.replace(v,"")),b.oy=parseFloat(f.replace(v,"")),b.v=a),b||a},ha=function(a,b){return"function"==typeof a&&(a=a(r,q)),"string"==typeof a&&"="===a.charAt(1)?parseInt(a.charAt(0)+"1",10)*parseFloat(a.substr(2)):parseFloat(a)-parseFloat(b)||0},ia=function(a,b){return"function"==typeof a&&(a=a(r,q)),null==a?b:"string"==typeof a&&"="===a.charAt(1)?parseInt(a.charAt(0)+"1",10)*parseFloat(a.substr(2))+b:parseFloat(a)||0},ja=function(a,b,c,d){var e,f,g,h,i,j=1e-6;return"function"==typeof a&&(a=a(r,q)),null==a?h=b:"number"==typeof a?h=a:(e=360,f=a.split("_"),i="="===a.charAt(1),g=(i?parseInt(a.charAt(0)+"1",10)*parseFloat(f[0].substr(2)):parseFloat(f[0]))*(-1===a.indexOf("rad")?1:L)-(i?0:b),f.length&&(d&&(d[c]=b+g),-1!==a.indexOf("short")&&(g%=e,g!==g%(e/2)&&(g=0>g?g+e:g-e)),-1!==a.indexOf("_cw")&&0>g?g=(g+9999999999*e)%e-(g/e|0)*e:-1!==a.indexOf("ccw")&&g>0&&(g=(g-9999999999*e)%e-(g/e|0)*e)),h=b+g),j>h&&h>-j&&(h=0),h},ka={aqua:[0,255,255],lime:[0,255,0],silver:[192,192,192],black:[0,0,0],maroon:[128,0,0],teal:[0,128,128],blue:[0,0,255],navy:[0,0,128],white:[255,255,255],fuchsia:[255,0,255],olive:[128,128,0],yellow:[255,255,0],orange:[255,165,0],gray:[128,128,128],purple:[128,0,128],green:[0,128,0],red:[255,0,0],pink:[255,192,203],cyan:[0,255,255],transparent:[255,255,255,0]},la=function(a,b,c){return a=0>a?a+1:a>1?a-1:a,255*(1>6*a?b+(c-b)*a*6:.5>a?c:2>3*a?b+(c-b)*(2/3-a)*6:b)+.5|0},ma=g.parseColor=function(a,b){var c,d,e,f,g,h,i,j,k,l,m;if(a)if("number"==typeof a)c=[a>>16,a>>8&255,255&a];else{if(","===a.charAt(a.length-1)&&(a=a.substr(0,a.length-1)),ka[a])c=ka[a];else if("#"===a.charAt(0))4===a.length&&(d=a.charAt(1),e=a.charAt(2),f=a.charAt(3),a="#"+d+d+e+e+f+f),a=parseInt(a.substr(1),16),c=[a>>16,a>>8&255,255&a];else if("hsl"===a.substr(0,3))if(c=m=a.match(s),b){if(-1!==a.indexOf("="))return a.match(t)}else g=Number(c[0])%360/360,h=Number(c[1])/100,i=Number(c[2])/100,e=.5>=i?i*(h+1):i+h-i*h,d=2*i-e,c.length>3&&(c[3]=Number(a[3])),c[0]=la(g+1/3,d,e),c[1]=la(g,d,e),c[2]=la(g-1/3,d,e);else c=a.match(s)||ka.transparent;c[0]=Number(c[0]),c[1]=Number(c[1]),c[2]=Number(c[2]),c.length>3&&(c[3]=Number(c[3]))}else c=ka.black;return b&&!m&&(d=c[0]/255,e=c[1]/255,f=c[2]/255,j=Math.max(d,e,f),k=Math.min(d,e,f),i=(j+k)/2,j===k?g=h=0:(l=j-k,h=i>.5?l/(2-j-k):l/(j+k),g=j===d?(e-f)/l+(f>e?6:0):j===e?(f-d)/l+2:(d-e)/l+4,g*=60),c[0]=g+.5|0,c[1]=100*h+.5|0,c[2]=100*i+.5|0),c},na=function(a,b){var c,d,e,f=a.match(oa)||[],g=0,h=f.length?"":a;for(c=0;c<f.length;c++)d=f[c],e=a.substr(g,a.indexOf(d,g)-g),g+=e.length+d.length,d=ma(d,b),3===d.length&&d.push(1),h+=e+(b?"hsla("+d[0]+","+d[1]+"%,"+d[2]+"%,"+d[3]:"rgba("+d.join(","))+")";return h+a.substr(g)},oa="(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3}){1,2}\\b";for(j in ka)oa+="|"+j+"\\b";oa=new RegExp(oa+")","gi"),g.colorStringFilter=function(a){var b,c=a[0]+a[1];oa.test(c)&&(b=-1!==c.indexOf("hsl(")||-1!==c.indexOf("hsla("),a[0]=na(a[0],b),a[1]=na(a[1],b)),oa.lastIndex=0},b.defaultStringFilter||(b.defaultStringFilter=g.colorStringFilter);var pa=function(a,b,c,d){if(null==a)return function(a){return a};var e,f=b?(a.match(oa)||[""])[0]:"",g=a.split(f).join("").match(u)||[],h=a.substr(0,a.indexOf(g[0])),i=")"===a.charAt(a.length-1)?")":"",j=-1!==a.indexOf(" ")?" ":",",k=g.length,l=k>0?g[0].replace(s,""):"";return k?e=b?function(a){var b,m,n,o;if("number"==typeof a)a+=l;else if(d&&I.test(a)){for(o=a.replace(I,"|").split("|"),n=0;n<o.length;n++)o[n]=e(o[n]);return o.join(",")}if(b=(a.match(oa)||[f])[0],m=a.split(b).join("").match(u)||[],n=m.length,k>n--)for(;++n<k;)m[n]=c?m[(n-1)/2|0]:g[n];return h+m.join(j)+j+b+i+(-1!==a.indexOf("inset")?" inset":"")}:function(a){var b,f,m;if("number"==typeof a)a+=l;else if(d&&I.test(a)){for(f=a.replace(I,"|").split("|"),m=0;m<f.length;m++)f[m]=e(f[m]);return f.join(",")}if(b=a.match(u)||[],m=b.length,k>m--)for(;++m<k;)b[m]=c?b[(m-1)/2|0]:g[m];return h+b.join(j)+i}:function(a){return a}},qa=function(a){return a=a.split(","),function(b,c,d,e,f,g,h){var i,j=(c+"").split(" ");for(h={},i=0;4>i;i++)h[a[i]]=j[i]=j[i]||j[(i-1)/2>>0];return e.parse(b,h,f,g)}},ra=(R._setPluginRatio=function(a){this.plugin.setRatio(a);for(var b,c,d,e,f,g=this.data,h=g.proxy,i=g.firstMPT,j=1e-6;i;)b=h[i.v],i.r?b=Math.round(b):j>b&&b>-j&&(b=0),i.t[i.p]=b,i=i._next;if(g.autoRotate&&(g.autoRotate.rotation=g.mod?g.mod(h.rotation,this.t):h.rotation),1===a||0===a)for(i=g.firstMPT,f=1===a?"e":"b";i;){if(c=i.t,c.type){if(1===c.type){for(e=c.xs0+c.s+c.xs1,d=1;d<c.l;d++)e+=c["xn"+d]+c["xs"+(d+1)];c[f]=e}}else c[f]=c.s+c.xs0;i=i._next}},function(a,b,c,d,e){this.t=a,this.p=b,this.v=c,this.r=e,d&&(d._prev=this,this._next=d)}),sa=(R._parseToProxy=function(a,b,c,d,e,f){var g,h,i,j,k,l=d,m={},n={},o=c._transform,p=M;for(c._transform=null,M=b,d=k=c.parse(a,b,d,e),M=p,f&&(c._transform=o,l&&(l._prev=null,l._prev&&(l._prev._next=null)));d&&d!==l;){if(d.type<=1&&(h=d.p,n[h]=d.s+d.c,m[h]=d.s,f||(j=new ra(d,"s",h,j,d.r),d.c=0),1===d.type))for(g=d.l;--g>0;)i="xn"+g,h=d.p+"_"+i,n[h]=d.data[i],m[h]=d[i],f||(j=new ra(d,i,h,j,d.rxp[i]));d=d._next}return{proxy:m,end:n,firstMPT:j,pt:k}},R.CSSPropTween=function(a,b,d,e,g,h,i,j,k,l,m){this.t=a,this.p=b,this.s=d,this.c=e,this.n=i||b,a instanceof sa||f.push(this.n),this.r=j,this.type=h||0,k&&(this.pr=k,c=!0),this.b=void 0===l?d:l,this.e=void 0===m?d+e:m,g&&(this._next=g,g._prev=this)}),ta=function(a,b,c,d,e,f){var g=new sa(a,b,c,d-c,e,-1,f);return g.b=c,g.e=g.xs0=d,g},ua=g.parseComplex=function(a,b,c,d,e,f,h,i,j,l){c=c||f||"","function"==typeof d&&(d=d(r,q)),h=new sa(a,b,0,0,h,l?2:1,null,!1,i,c,d),d+="",e&&oa.test(d+c)&&(d=[c,d],g.colorStringFilter(d),c=d[0],d=d[1]);var m,n,o,p,u,v,w,x,y,z,A,B,C,D=c.split(", ").join(",").split(" "),E=d.split(", ").join(",").split(" "),F=D.length,G=k!==!1;for((-1!==d.indexOf(",")||-1!==c.indexOf(","))&&(D=D.join(" ").replace(I,", ").split(" "),E=E.join(" ").replace(I,", ").split(" "),F=D.length),F!==E.length&&(D=(f||"").split(" "),F=D.length),h.plugin=j,h.setRatio=l,oa.lastIndex=0,m=0;F>m;m++)if(p=D[m],u=E[m],x=parseFloat(p),x||0===x)h.appendXtra("",x,ha(u,x),u.replace(t,""),G&&-1!==u.indexOf("px"),!0);else if(e&&oa.test(p))B=u.indexOf(")")+1,B=")"+(B?u.substr(B):""),C=-1!==u.indexOf("hsl")&&T,p=ma(p,C),u=ma(u,C),y=p.length+u.length>6,y&&!T&&0===u[3]?(h["xs"+h.l]+=h.l?" transparent":"transparent",h.e=h.e.split(E[m]).join("transparent")):(T||(y=!1),C?h.appendXtra(y?"hsla(":"hsl(",p[0],ha(u[0],p[0]),",",!1,!0).appendXtra("",p[1],ha(u[1],p[1]),"%,",!1).appendXtra("",p[2],ha(u[2],p[2]),y?"%,":"%"+B,!1):h.appendXtra(y?"rgba(":"rgb(",p[0],u[0]-p[0],",",!0,!0).appendXtra("",p[1],u[1]-p[1],",",!0).appendXtra("",p[2],u[2]-p[2],y?",":B,!0),y&&(p=p.length<4?1:p[3],h.appendXtra("",p,(u.length<4?1:u[3])-p,B,!1))),oa.lastIndex=0;else if(v=p.match(s)){if(w=u.match(t),!w||w.length!==v.length)return h;for(o=0,n=0;n<v.length;n++)A=v[n],z=p.indexOf(A,o),h.appendXtra(p.substr(o,z-o),Number(A),ha(w[n],A),"",G&&"px"===p.substr(z+A.length,2),0===n),o=z+A.length;h["xs"+h.l]+=p.substr(o)}else h["xs"+h.l]+=h.l||h["xs"+h.l]?" "+u:u;if(-1!==d.indexOf("=")&&h.data){for(B=h.xs0+h.data.s,m=1;m<h.l;m++)B+=h["xs"+m]+h.data["xn"+m];h.e=B+h["xs"+m]}return h.l||(h.type=-1,h.xs0=h.e),h.xfirst||h},va=9;for(j=sa.prototype,j.l=j.pr=0;--va>0;)j["xn"+va]=0,j["xs"+va]="";j.xs0="",j._next=j._prev=j.xfirst=j.data=j.plugin=j.setRatio=j.rxp=null,j.appendXtra=function(a,b,c,d,e,f){var g=this,h=g.l;return g["xs"+h]+=f&&(h||g["xs"+h])?" "+a:a||"",c||0===h||g.plugin?(g.l++,g.type=g.setRatio?2:1,g["xs"+g.l]=d||"",h>0?(g.data["xn"+h]=b+c,g.rxp["xn"+h]=e,g["xn"+h]=b,g.plugin||(g.xfirst=new sa(g,"xn"+h,b,c,g.xfirst||g,0,g.n,e,g.pr),g.xfirst.xs0=0),g):(g.data={s:b+c},g.rxp={},g.s=b,g.c=c,g.r=e,g)):(g["xs"+h]+=b+(d||""),g)};var wa=function(a,b){b=b||{},this.p=b.prefix?Y(a)||a:a,i[a]=i[this.p]=this,this.format=b.formatter||pa(b.defaultValue,b.color,b.collapsible,b.multi),b.parser&&(this.parse=b.parser),this.clrs=b.color,this.multi=b.multi,this.keyword=b.keyword,this.dflt=b.defaultValue,this.pr=b.priority||0},xa=R._registerComplexSpecialProp=function(a,b,c){"object"!=typeof b&&(b={parser:c});var d,e,f=a.split(","),g=b.defaultValue;for(c=c||[g],d=0;d<f.length;d++)b.prefix=0===d&&b.prefix,b.defaultValue=c[d]||g,e=new wa(f[d],b)},ya=R._registerPluginProp=function(a){if(!i[a]){var b=a.charAt(0).toUpperCase()+a.substr(1)+"Plugin";xa(a,{parser:function(a,c,d,e,f,g,j){var k=h.com.greensock.plugins[b];return k?(k._cssRegister(),i[d].parse(a,c,d,e,f,g,j)):(V("Error: "+b+" js file not loaded."),f)}})}};j=wa.prototype,j.parseComplex=function(a,b,c,d,e,f){var g,h,i,j,k,l,m=this.keyword;if(this.multi&&(I.test(c)||I.test(b)?(h=b.replace(I,"|").split("|"),i=c.replace(I,"|").split("|")):m&&(h=[b],i=[c])),i){for(j=i.length>h.length?i.length:h.length,g=0;j>g;g++)b=h[g]=h[g]||this.dflt,c=i[g]=i[g]||this.dflt,m&&(k=b.indexOf(m),l=c.indexOf(m),k!==l&&(-1===l?h[g]=h[g].split(m).join(""):-1===k&&(h[g]+=" "+m)));b=h.join(", "),c=i.join(", ")}return ua(a,this.p,b,c,this.clrs,this.dflt,d,this.pr,e,f)},j.parse=function(a,b,c,d,f,g,h){return this.parseComplex(a.style,this.format($(a,this.p,e,!1,this.dflt)),this.format(b),f,g)},g.registerSpecialProp=function(a,b,c){xa(a,{parser:function(a,d,e,f,g,h,i){var j=new sa(a,e,0,0,g,2,e,!1,c);return j.plugin=h,j.setRatio=b(a,d,f._tween,e),j},priority:c})},g.useSVGTransformAttr=m||n;var za,Aa="scaleX,scaleY,scaleZ,x,y,z,skewX,skewY,rotation,rotationX,rotationY,perspective,xPercent,yPercent".split(","),Ba=Y("transform"),Ca=W+"transform",Da=Y("transformOrigin"),Ea=null!==Y("perspective"),Fa=R.Transform=function(){this.perspective=parseFloat(g.defaultTransformPerspective)||0,this.force3D=g.defaultForce3D!==!1&&Ea?g.defaultForce3D||"auto":!1},Ga=window.SVGElement,Ha=function(a,b,c){var d,e=N.createElementNS("http://www.w3.org/2000/svg",a),f=/([a-z])([A-Z])/g;for(d in c)e.setAttributeNS(null,d.replace(f,"$1-$2").toLowerCase(),c[d]);return b.appendChild(e),e},Ia=N.documentElement,Ja=function(){var a,b,c,d=p||/Android/i.test(S)&&!window.chrome;return N.createElementNS&&!d&&(a=Ha("svg",Ia),b=Ha("rect",a,{width:100,height:50,x:100}),c=b.getBoundingClientRect().width,b.style[Da]="50% 50%",b.style[Ba]="scaleX(0.5)",d=c===b.getBoundingClientRect().width&&!(n&&Ea),Ia.removeChild(a)),d}(),Ka=function(a,b,c,d,e,f){var h,i,j,k,l,m,n,o,p,q,r,s,t,u,v=a._gsTransform,w=Oa(a,!0);v&&(t=v.xOrigin,u=v.yOrigin),(!d||(h=d.split(" ")).length<2)&&(n=a.getBBox(),b=ga(b).split(" "),h=[(-1!==b[0].indexOf("%")?parseFloat(b[0])/100*n.width:parseFloat(b[0]))+n.x,(-1!==b[1].indexOf("%")?parseFloat(b[1])/100*n.height:parseFloat(b[1]))+n.y]),c.xOrigin=k=parseFloat(h[0]),c.yOrigin=l=parseFloat(h[1]),d&&w!==Na&&(m=w[0],n=w[1],o=w[2],p=w[3],q=w[4],r=w[5],s=m*p-n*o,i=k*(p/s)+l*(-o/s)+(o*r-p*q)/s,j=k*(-n/s)+l*(m/s)-(m*r-n*q)/s,k=c.xOrigin=h[0]=i,l=c.yOrigin=h[1]=j),v&&(f&&(c.xOffset=v.xOffset,c.yOffset=v.yOffset,v=c),e||e!==!1&&g.defaultSmoothOrigin!==!1?(i=k-t,j=l-u,v.xOffset+=i*w[0]+j*w[2]-i,v.yOffset+=i*w[1]+j*w[3]-j):v.xOffset=v.yOffset=0),f||a.setAttribute("data-svg-origin",h.join(" "))},La=function(a){try{return a.getBBox()}catch(a){}},Ma=function(a){return!!(Ga&&a.getBBox&&a.getCTM&&La(a)&&(!a.parentNode||a.parentNode.getBBox&&a.parentNode.getCTM))},Na=[1,0,0,1,0,0],Oa=function(a,b){var c,d,e,f,g,h,i=a._gsTransform||new Fa,j=1e5,k=a.style;if(Ba?d=$(a,Ca,null,!0):a.currentStyle&&(d=a.currentStyle.filter.match(G),d=d&&4===d.length?[d[0].substr(4),Number(d[2].substr(4)),Number(d[1].substr(4)),d[3].substr(4),i.x||0,i.y||0].join(","):""),c=!d||"none"===d||"matrix(1, 0, 0, 1, 0, 0)"===d,c&&Ba&&((h="none"===Z(a).display)||!a.parentNode)&&(h&&(f=k.display,k.display="block"),a.parentNode||(g=1,Ia.appendChild(a)),d=$(a,Ca,null,!0),c=!d||"none"===d||"matrix(1, 0, 0, 1, 0, 0)"===d,f?k.display=f:h&&Ta(k,"display"),g&&Ia.removeChild(a)),(i.svg||a.getBBox&&Ma(a))&&(c&&-1!==(k[Ba]+"").indexOf("matrix")&&(d=k[Ba],c=0),e=a.getAttribute("transform"),c&&e&&(-1!==e.indexOf("matrix")?(d=e,c=0):-1!==e.indexOf("translate")&&(d="matrix(1,0,0,1,"+e.match(/(?:\-|\b)[\d\-\.e]+\b/gi).join(",")+")",c=0))),c)return Na;for(e=(d||"").match(s)||[],va=e.length;--va>-1;)f=Number(e[va]),e[va]=(g=f-(f|=0))?(g*j+(0>g?-.5:.5)|0)/j+f:f;return b&&e.length>6?[e[0],e[1],e[4],e[5],e[12],e[13]]:e},Pa=R.getTransform=function(a,c,d,e){if(a._gsTransform&&d&&!e)return a._gsTransform;var f,h,i,j,k,l,m=d?a._gsTransform||new Fa:new Fa,n=m.scaleX<0,o=2e-5,p=1e5,q=Ea?parseFloat($(a,Da,c,!1,"0 0 0").split(" ")[2])||m.zOrigin||0:0,r=parseFloat(g.defaultTransformPerspective)||0;if(m.svg=!(!a.getBBox||!Ma(a)),m.svg&&(Ka(a,$(a,Da,c,!1,"50% 50%")+"",m,a.getAttribute("data-svg-origin")),za=g.useSVGTransformAttr||Ja),f=Oa(a),f!==Na){if(16===f.length){var s,t,u,v,w,x=f[0],y=f[1],z=f[2],A=f[3],B=f[4],C=f[5],D=f[6],E=f[7],F=f[8],G=f[9],H=f[10],I=f[12],J=f[13],K=f[14],M=f[11],N=Math.atan2(D,H);m.zOrigin&&(K=-m.zOrigin,I=F*K-f[12],J=G*K-f[13],K=H*K+m.zOrigin-f[14]),m.rotationX=N*L,N&&(v=Math.cos(-N),w=Math.sin(-N),s=B*v+F*w,t=C*v+G*w,u=D*v+H*w,F=B*-w+F*v,G=C*-w+G*v,H=D*-w+H*v,M=E*-w+M*v,B=s,C=t,D=u),N=Math.atan2(-z,H),m.rotationY=N*L,N&&(v=Math.cos(-N),w=Math.sin(-N),s=x*v-F*w,t=y*v-G*w,u=z*v-H*w,G=y*w+G*v,H=z*w+H*v,M=A*w+M*v,x=s,y=t,z=u),N=Math.atan2(y,x),m.rotation=N*L,N&&(v=Math.cos(-N),w=Math.sin(-N),x=x*v+B*w,t=y*v+C*w,C=y*-w+C*v,D=z*-w+D*v,y=t),m.rotationX&&Math.abs(m.rotationX)+Math.abs(m.rotation)>359.9&&(m.rotationX=m.rotation=0,m.rotationY=180-m.rotationY),m.scaleX=(Math.sqrt(x*x+y*y)*p+.5|0)/p,m.scaleY=(Math.sqrt(C*C+G*G)*p+.5|0)/p,m.scaleZ=(Math.sqrt(D*D+H*H)*p+.5|0)/p,m.rotationX||m.rotationY?m.skewX=0:(m.skewX=B||C?Math.atan2(B,C)*L+m.rotation:m.skewX||0,Math.abs(m.skewX)>90&&Math.abs(m.skewX)<270&&(n?(m.scaleX*=-1,m.skewX+=m.rotation<=0?180:-180,m.rotation+=m.rotation<=0?180:-180):(m.scaleY*=-1,m.skewX+=m.skewX<=0?180:-180))),m.perspective=M?1/(0>M?-M:M):0,m.x=I,m.y=J,m.z=K,m.svg&&(m.x-=m.xOrigin-(m.xOrigin*x-m.yOrigin*B),m.y-=m.yOrigin-(m.yOrigin*y-m.xOrigin*C))}else if(!Ea||e||!f.length||m.x!==f[4]||m.y!==f[5]||!m.rotationX&&!m.rotationY){var O=f.length>=6,P=O?f[0]:1,Q=f[1]||0,R=f[2]||0,S=O?f[3]:1;m.x=f[4]||0,m.y=f[5]||0,i=Math.sqrt(P*P+Q*Q),j=Math.sqrt(S*S+R*R),k=P||Q?Math.atan2(Q,P)*L:m.rotation||0,l=R||S?Math.atan2(R,S)*L+k:m.skewX||0,Math.abs(l)>90&&Math.abs(l)<270&&(n?(i*=-1,l+=0>=k?180:-180,k+=0>=k?180:-180):(j*=-1,l+=0>=l?180:-180)),m.scaleX=i,m.scaleY=j,m.rotation=k,m.skewX=l,Ea&&(m.rotationX=m.rotationY=m.z=0,m.perspective=r,m.scaleZ=1),m.svg&&(m.x-=m.xOrigin-(m.xOrigin*P+m.yOrigin*R),m.y-=m.yOrigin-(m.xOrigin*Q+m.yOrigin*S))}m.zOrigin=q;for(h in m)m[h]<o&&m[h]>-o&&(m[h]=0)}return d&&(a._gsTransform=m,m.svg&&(za&&a.style[Ba]?b.delayedCall(.001,function(){Ta(a.style,Ba)}):!za&&a.getAttribute("transform")&&b.delayedCall(.001,function(){a.removeAttribute("transform")}))),m},Qa=function(a){var b,c,d=this.data,e=-d.rotation*K,f=e+d.skewX*K,g=1e5,h=(Math.cos(e)*d.scaleX*g|0)/g,i=(Math.sin(e)*d.scaleX*g|0)/g,j=(Math.sin(f)*-d.scaleY*g|0)/g,k=(Math.cos(f)*d.scaleY*g|0)/g,l=this.t.style,m=this.t.currentStyle;if(m){c=i,i=-j,j=-c,b=m.filter,l.filter="";var n,o,q=this.t.offsetWidth,r=this.t.offsetHeight,s="absolute"!==m.position,t="progid:DXImageTransform.Microsoft.Matrix(M11="+h+", M12="+i+", M21="+j+", M22="+k,u=d.x+q*d.xPercent/100,v=d.y+r*d.yPercent/100;if(null!=d.ox&&(n=(d.oxp?q*d.ox*.01:d.ox)-q/2,o=(d.oyp?r*d.oy*.01:d.oy)-r/2,u+=n-(n*h+o*i),v+=o-(n*j+o*k)),s?(n=q/2,o=r/2,t+=", Dx="+(n-(n*h+o*i)+u)+", Dy="+(o-(n*j+o*k)+v)+")"):t+=", sizingMethod='auto expand')",-1!==b.indexOf("DXImageTransform.Microsoft.Matrix(")?l.filter=b.replace(H,t):l.filter=t+" "+b,(0===a||1===a)&&1===h&&0===i&&0===j&&1===k&&(s&&-1===t.indexOf("Dx=0, Dy=0")||x.test(b)&&100!==parseFloat(RegExp.$1)||-1===b.indexOf(b.indexOf("Alpha"))&&l.removeAttribute("filter")),!s){var y,z,A,B=8>p?1:-1;for(n=d.ieOffsetX||0,o=d.ieOffsetY||0,d.ieOffsetX=Math.round((q-((0>h?-h:h)*q+(0>i?-i:i)*r))/2+u),d.ieOffsetY=Math.round((r-((0>k?-k:k)*r+(0>j?-j:j)*q))/2+v),va=0;4>va;va++)z=ea[va],y=m[z],c=-1!==y.indexOf("px")?parseFloat(y):_(this.t,z,parseFloat(y),y.replace(w,""))||0,A=c!==d[z]?2>va?-d.ieOffsetX:-d.ieOffsetY:2>va?n-d.ieOffsetX:o-d.ieOffsetY,l[z]=(d[z]=Math.round(c-A*(0===va||2===va?1:B)))+"px"}}},Ra=R.set3DTransformRatio=R.setTransformRatio=function(a){var b,c,d,e,f,g,h,i,j,k,l,m,o,p,q,r,s,t,u,v,w,x,y,z=this.data,A=this.t.style,B=z.rotation,C=z.rotationX,D=z.rotationY,E=z.scaleX,F=z.scaleY,G=z.scaleZ,H=z.x,I=z.y,J=z.z,L=z.svg,M=z.perspective,N=z.force3D;if(((1===a||0===a)&&"auto"===N&&(this.tween._totalTime===this.tween._totalDuration||!this.tween._totalTime)||!N)&&!J&&!M&&!D&&!C&&1===G||za&&L||!Ea)return void(B||z.skewX||L?(B*=K,x=z.skewX*K,y=1e5,b=Math.cos(B)*E,e=Math.sin(B)*E,c=Math.sin(B-x)*-F,f=Math.cos(B-x)*F,x&&"simple"===z.skewType&&(s=Math.tan(x-z.skewY*K),s=Math.sqrt(1+s*s),c*=s,f*=s,z.skewY&&(s=Math.tan(z.skewY*K),s=Math.sqrt(1+s*s),b*=s,e*=s)),L&&(H+=z.xOrigin-(z.xOrigin*b+z.yOrigin*c)+z.xOffset,I+=z.yOrigin-(z.xOrigin*e+z.yOrigin*f)+z.yOffset,za&&(z.xPercent||z.yPercent)&&(p=this.t.getBBox(),H+=.01*z.xPercent*p.width,I+=.01*z.yPercent*p.height),p=1e-6,p>H&&H>-p&&(H=0),p>I&&I>-p&&(I=0)),u=(b*y|0)/y+","+(e*y|0)/y+","+(c*y|0)/y+","+(f*y|0)/y+","+H+","+I+")",L&&za?this.t.setAttribute("transform","matrix("+u):A[Ba]=(z.xPercent||z.yPercent?"translate("+z.xPercent+"%,"+z.yPercent+"%) matrix(":"matrix(")+u):A[Ba]=(z.xPercent||z.yPercent?"translate("+z.xPercent+"%,"+z.yPercent+"%) matrix(":"matrix(")+E+",0,0,"+F+","+H+","+I+")");if(n&&(p=1e-4,p>E&&E>-p&&(E=G=2e-5),p>F&&F>-p&&(F=G=2e-5),!M||z.z||z.rotationX||z.rotationY||(M=0)),B||z.skewX)B*=K,q=b=Math.cos(B),r=e=Math.sin(B),z.skewX&&(B-=z.skewX*K,q=Math.cos(B),r=Math.sin(B),"simple"===z.skewType&&(s=Math.tan((z.skewX-z.skewY)*K),s=Math.sqrt(1+s*s),q*=s,r*=s,z.skewY&&(s=Math.tan(z.skewY*K),s=Math.sqrt(1+s*s),b*=s,e*=s))),c=-r,f=q;else{if(!(D||C||1!==G||M||L))return void(A[Ba]=(z.xPercent||z.yPercent?"translate("+z.xPercent+"%,"+z.yPercent+"%) translate3d(":"translate3d(")+H+"px,"+I+"px,"+J+"px)"+(1!==E||1!==F?" scale("+E+","+F+")":""));b=f=1,c=e=0}j=1,d=g=h=i=k=l=0,m=M?-1/M:0,o=z.zOrigin,p=1e-6,v=",",w="0",B=D*K,B&&(q=Math.cos(B),r=Math.sin(B),h=-r,k=m*-r,d=b*r,g=e*r,j=q,m*=q,b*=q,e*=q),B=C*K,B&&(q=Math.cos(B),r=Math.sin(B),s=c*q+d*r,t=f*q+g*r,i=j*r,l=m*r,d=c*-r+d*q,g=f*-r+g*q,j*=q,m*=q,c=s,f=t),1!==G&&(d*=G,g*=G,j*=G,m*=G),1!==F&&(c*=F,f*=F,i*=F,l*=F),1!==E&&(b*=E,e*=E,h*=E,k*=E),(o||L)&&(o&&(H+=d*-o,I+=g*-o,J+=j*-o+o),L&&(H+=z.xOrigin-(z.xOrigin*b+z.yOrigin*c)+z.xOffset,I+=z.yOrigin-(z.xOrigin*e+z.yOrigin*f)+z.yOffset),p>H&&H>-p&&(H=w),p>I&&I>-p&&(I=w),p>J&&J>-p&&(J=0)),u=z.xPercent||z.yPercent?"translate("+z.xPercent+"%,"+z.yPercent+"%) matrix3d(":"matrix3d(",u+=(p>b&&b>-p?w:b)+v+(p>e&&e>-p?w:e)+v+(p>h&&h>-p?w:h),u+=v+(p>k&&k>-p?w:k)+v+(p>c&&c>-p?w:c)+v+(p>f&&f>-p?w:f),C||D||1!==G?(u+=v+(p>i&&i>-p?w:i)+v+(p>l&&l>-p?w:l)+v+(p>d&&d>-p?w:d),u+=v+(p>g&&g>-p?w:g)+v+(p>j&&j>-p?w:j)+v+(p>m&&m>-p?w:m)+v):u+=",0,0,0,0,1,0,",u+=H+v+I+v+J+v+(M?1+-J/M:1)+")",A[Ba]=u};j=Fa.prototype,j.x=j.y=j.z=j.skewX=j.skewY=j.rotation=j.rotationX=j.rotationY=j.zOrigin=j.xPercent=j.yPercent=j.xOffset=j.yOffset=0,j.scaleX=j.scaleY=j.scaleZ=1,xa("transform,scale,scaleX,scaleY,scaleZ,x,y,z,rotation,rotationX,rotationY,rotationZ,skewX,skewY,shortRotation,shortRotationX,shortRotationY,shortRotationZ,transformOrigin,svgOrigin,transformPerspective,directionalRotation,parseTransform,force3D,skewType,xPercent,yPercent,smoothOrigin",{parser:function(a,b,c,d,f,h,i){if(d._lastParsedTransform===i)return f;d._lastParsedTransform=i;var j;"function"==typeof i[c]&&(j=i[c],i[c]=b);var k,l,m,n,o,p,s,t,u,v=a._gsTransform,w=a.style,x=1e-6,y=Aa.length,z=i,A={},B="transformOrigin",C=Pa(a,e,!0,z.parseTransform),D=z.transform&&("function"==typeof z.transform?z.transform(r,q):z.transform);if(d._transform=C,D&&"string"==typeof D&&Ba)l=P.style,l[Ba]=D,l.display="block",l.position="absolute",N.body.appendChild(P),k=Pa(P,null,!1),C.svg&&(p=C.xOrigin,s=C.yOrigin,k.x-=C.xOffset,k.y-=C.yOffset,(z.transformOrigin||z.svgOrigin)&&(D={},Ka(a,ga(z.transformOrigin),D,z.svgOrigin,z.smoothOrigin,!0),p=D.xOrigin,s=D.yOrigin,k.x-=D.xOffset-C.xOffset,k.y-=D.yOffset-C.yOffset),(p||s)&&(t=Oa(P,!0),k.x-=p-(p*t[0]+s*t[2]),k.y-=s-(p*t[1]+s*t[3]))),N.body.removeChild(P),k.perspective||(k.perspective=C.perspective),null!=z.xPercent&&(k.xPercent=ia(z.xPercent,C.xPercent)),null!=z.yPercent&&(k.yPercent=ia(z.yPercent,C.yPercent));else if("object"==typeof z){if(k={scaleX:ia(null!=z.scaleX?z.scaleX:z.scale,C.scaleX),scaleY:ia(null!=z.scaleY?z.scaleY:z.scale,C.scaleY),scaleZ:ia(z.scaleZ,C.scaleZ),x:ia(z.x,C.x),y:ia(z.y,C.y),z:ia(z.z,C.z),xPercent:ia(z.xPercent,C.xPercent),yPercent:ia(z.yPercent,C.yPercent),perspective:ia(z.transformPerspective,C.perspective)},o=z.directionalRotation,null!=o)if("object"==typeof o)for(l in o)z[l]=o[l];else z.rotation=o;"string"==typeof z.x&&-1!==z.x.indexOf("%")&&(k.x=0,k.xPercent=ia(z.x,C.xPercent)),"string"==typeof z.y&&-1!==z.y.indexOf("%")&&(k.y=0,k.yPercent=ia(z.y,C.yPercent)),k.rotation=ja("rotation"in z?z.rotation:"shortRotation"in z?z.shortRotation+"_short":"rotationZ"in z?z.rotationZ:C.rotation-C.skewY,C.rotation-C.skewY,"rotation",A),Ea&&(k.rotationX=ja("rotationX"in z?z.rotationX:"shortRotationX"in z?z.shortRotationX+"_short":C.rotationX||0,C.rotationX,"rotationX",A),k.rotationY=ja("rotationY"in z?z.rotationY:"shortRotationY"in z?z.shortRotationY+"_short":C.rotationY||0,C.rotationY,"rotationY",A)),k.skewX=ja(z.skewX,C.skewX-C.skewY),(k.skewY=ja(z.skewY,C.skewY))&&(k.skewX+=k.skewY,k.rotation+=k.skewY)}for(Ea&&null!=z.force3D&&(C.force3D=z.force3D,n=!0),C.skewType=z.skewType||C.skewType||g.defaultSkewType,m=C.force3D||C.z||C.rotationX||C.rotationY||k.z||k.rotationX||k.rotationY||k.perspective,m||null==z.scale||(k.scaleZ=1);--y>-1;)u=Aa[y],D=k[u]-C[u],(D>x||-x>D||null!=z[u]||null!=M[u])&&(n=!0,
f=new sa(C,u,C[u],D,f),u in A&&(f.e=A[u]),f.xs0=0,f.plugin=h,d._overwriteProps.push(f.n));return D=z.transformOrigin,C.svg&&(D||z.svgOrigin)&&(p=C.xOffset,s=C.yOffset,Ka(a,ga(D),k,z.svgOrigin,z.smoothOrigin),f=ta(C,"xOrigin",(v?C:k).xOrigin,k.xOrigin,f,B),f=ta(C,"yOrigin",(v?C:k).yOrigin,k.yOrigin,f,B),(p!==C.xOffset||s!==C.yOffset)&&(f=ta(C,"xOffset",v?p:C.xOffset,C.xOffset,f,B),f=ta(C,"yOffset",v?s:C.yOffset,C.yOffset,f,B)),D=za?null:"0px 0px"),(D||Ea&&m&&C.zOrigin)&&(Ba?(n=!0,u=Da,D=(D||$(a,u,e,!1,"50% 50%"))+"",f=new sa(w,u,0,0,f,-1,B),f.b=w[u],f.plugin=h,Ea?(l=C.zOrigin,D=D.split(" "),C.zOrigin=(D.length>2&&(0===l||"0px"!==D[2])?parseFloat(D[2]):l)||0,f.xs0=f.e=D[0]+" "+(D[1]||"50%")+" 0px",f=new sa(C,"zOrigin",0,0,f,-1,f.n),f.b=l,f.xs0=f.e=C.zOrigin):f.xs0=f.e=D):ga(D+"",C)),n&&(d._transformType=C.svg&&za||!m&&3!==this._transformType?2:3),j&&(i[c]=j),f},prefix:!0}),xa("boxShadow",{defaultValue:"0px 0px 0px 0px #999",prefix:!0,color:!0,multi:!0,keyword:"inset"}),xa("borderRadius",{defaultValue:"0px",parser:function(a,b,c,f,g,h){b=this.format(b);var i,j,k,l,m,n,o,p,q,r,s,t,u,v,w,x,y=["borderTopLeftRadius","borderTopRightRadius","borderBottomRightRadius","borderBottomLeftRadius"],z=a.style;for(q=parseFloat(a.offsetWidth),r=parseFloat(a.offsetHeight),i=b.split(" "),j=0;j<y.length;j++)this.p.indexOf("border")&&(y[j]=Y(y[j])),m=l=$(a,y[j],e,!1,"0px"),-1!==m.indexOf(" ")&&(l=m.split(" "),m=l[0],l=l[1]),n=k=i[j],o=parseFloat(m),t=m.substr((o+"").length),u="="===n.charAt(1),u?(p=parseInt(n.charAt(0)+"1",10),n=n.substr(2),p*=parseFloat(n),s=n.substr((p+"").length-(0>p?1:0))||""):(p=parseFloat(n),s=n.substr((p+"").length)),""===s&&(s=d[c]||t),s!==t&&(v=_(a,"borderLeft",o,t),w=_(a,"borderTop",o,t),"%"===s?(m=v/q*100+"%",l=w/r*100+"%"):"em"===s?(x=_(a,"borderLeft",1,"em"),m=v/x+"em",l=w/x+"em"):(m=v+"px",l=w+"px"),u&&(n=parseFloat(m)+p+s,k=parseFloat(l)+p+s)),g=ua(z,y[j],m+" "+l,n+" "+k,!1,"0px",g);return g},prefix:!0,formatter:pa("0px 0px 0px 0px",!1,!0)}),xa("borderBottomLeftRadius,borderBottomRightRadius,borderTopLeftRadius,borderTopRightRadius",{defaultValue:"0px",parser:function(a,b,c,d,f,g){return ua(a.style,c,this.format($(a,c,e,!1,"0px 0px")),this.format(b),!1,"0px",f)},prefix:!0,formatter:pa("0px 0px",!1,!0)}),xa("backgroundPosition",{defaultValue:"0 0",parser:function(a,b,c,d,f,g){var h,i,j,k,l,m,n="background-position",o=e||Z(a,null),q=this.format((o?p?o.getPropertyValue(n+"-x")+" "+o.getPropertyValue(n+"-y"):o.getPropertyValue(n):a.currentStyle.backgroundPositionX+" "+a.currentStyle.backgroundPositionY)||"0 0"),r=this.format(b);if(-1!==q.indexOf("%")!=(-1!==r.indexOf("%"))&&r.split(",").length<2&&(m=$(a,"backgroundImage").replace(D,""),m&&"none"!==m)){for(h=q.split(" "),i=r.split(" "),Q.setAttribute("src",m),j=2;--j>-1;)q=h[j],k=-1!==q.indexOf("%"),k!==(-1!==i[j].indexOf("%"))&&(l=0===j?a.offsetWidth-Q.width:a.offsetHeight-Q.height,h[j]=k?parseFloat(q)/100*l+"px":parseFloat(q)/l*100+"%");q=h.join(" ")}return this.parseComplex(a.style,q,r,f,g)},formatter:ga}),xa("backgroundSize",{defaultValue:"0 0",formatter:function(a){return a+="",ga(-1===a.indexOf(" ")?a+" "+a:a)}}),xa("perspective",{defaultValue:"0px",prefix:!0}),xa("perspectiveOrigin",{defaultValue:"50% 50%",prefix:!0}),xa("transformStyle",{prefix:!0}),xa("backfaceVisibility",{prefix:!0}),xa("userSelect",{prefix:!0}),xa("margin",{parser:qa("marginTop,marginRight,marginBottom,marginLeft")}),xa("padding",{parser:qa("paddingTop,paddingRight,paddingBottom,paddingLeft")}),xa("clip",{defaultValue:"rect(0px,0px,0px,0px)",parser:function(a,b,c,d,f,g){var h,i,j;return 9>p?(i=a.currentStyle,j=8>p?" ":",",h="rect("+i.clipTop+j+i.clipRight+j+i.clipBottom+j+i.clipLeft+")",b=this.format(b).split(",").join(j)):(h=this.format($(a,this.p,e,!1,this.dflt)),b=this.format(b)),this.parseComplex(a.style,h,b,f,g)}}),xa("textShadow",{defaultValue:"0px 0px 0px #999",color:!0,multi:!0}),xa("autoRound,strictUnits",{parser:function(a,b,c,d,e){return e}}),xa("border",{defaultValue:"0px solid #000",parser:function(a,b,c,d,f,g){var h=$(a,"borderTopWidth",e,!1,"0px"),i=this.format(b).split(" "),j=i[0].replace(w,"");return"px"!==j&&(h=parseFloat(h)/_(a,"borderTopWidth",1,j)+j),this.parseComplex(a.style,this.format(h+" "+$(a,"borderTopStyle",e,!1,"solid")+" "+$(a,"borderTopColor",e,!1,"#000")),i.join(" "),f,g)},color:!0,formatter:function(a){var b=a.split(" ");return b[0]+" "+(b[1]||"solid")+" "+(a.match(oa)||["#000"])[0]}}),xa("borderWidth",{parser:qa("borderTopWidth,borderRightWidth,borderBottomWidth,borderLeftWidth")}),xa("float,cssFloat,styleFloat",{parser:function(a,b,c,d,e,f){var g=a.style,h="cssFloat"in g?"cssFloat":"styleFloat";return new sa(g,h,0,0,e,-1,c,!1,0,g[h],b)}});var Sa=function(a){var b,c=this.t,d=c.filter||$(this.data,"filter")||"",e=this.s+this.c*a|0;100===e&&(-1===d.indexOf("atrix(")&&-1===d.indexOf("radient(")&&-1===d.indexOf("oader(")?(c.removeAttribute("filter"),b=!$(this.data,"filter")):(c.filter=d.replace(z,""),b=!0)),b||(this.xn1&&(c.filter=d=d||"alpha(opacity="+e+")"),-1===d.indexOf("pacity")?0===e&&this.xn1||(c.filter=d+" alpha(opacity="+e+")"):c.filter=d.replace(x,"opacity="+e))};xa("opacity,alpha,autoAlpha",{defaultValue:"1",parser:function(a,b,c,d,f,g){var h=parseFloat($(a,"opacity",e,!1,"1")),i=a.style,j="autoAlpha"===c;return"string"==typeof b&&"="===b.charAt(1)&&(b=("-"===b.charAt(0)?-1:1)*parseFloat(b.substr(2))+h),j&&1===h&&"hidden"===$(a,"visibility",e)&&0!==b&&(h=0),T?f=new sa(i,"opacity",h,b-h,f):(f=new sa(i,"opacity",100*h,100*(b-h),f),f.xn1=j?1:0,i.zoom=1,f.type=2,f.b="alpha(opacity="+f.s+")",f.e="alpha(opacity="+(f.s+f.c)+")",f.data=a,f.plugin=g,f.setRatio=Sa),j&&(f=new sa(i,"visibility",0,0,f,-1,null,!1,0,0!==h?"inherit":"hidden",0===b?"hidden":"inherit"),f.xs0="inherit",d._overwriteProps.push(f.n),d._overwriteProps.push(c)),f}});var Ta=function(a,b){b&&(a.removeProperty?(("ms"===b.substr(0,2)||"webkit"===b.substr(0,6))&&(b="-"+b),a.removeProperty(b.replace(B,"-$1").toLowerCase())):a.removeAttribute(b))},Ua=function(a){if(this.t._gsClassPT=this,1===a||0===a){this.t.setAttribute("class",0===a?this.b:this.e);for(var b=this.data,c=this.t.style;b;)b.v?c[b.p]=b.v:Ta(c,b.p),b=b._next;1===a&&this.t._gsClassPT===this&&(this.t._gsClassPT=null)}else this.t.getAttribute("class")!==this.e&&this.t.setAttribute("class",this.e)};xa("className",{parser:function(a,b,d,f,g,h,i){var j,k,l,m,n,o=a.getAttribute("class")||"",p=a.style.cssText;if(g=f._classNamePT=new sa(a,d,0,0,g,2),g.setRatio=Ua,g.pr=-11,c=!0,g.b=o,k=ba(a,e),l=a._gsClassPT){for(m={},n=l.data;n;)m[n.p]=1,n=n._next;l.setRatio(1)}return a._gsClassPT=g,g.e="="!==b.charAt(1)?b:o.replace(new RegExp("(?:\\s|^)"+b.substr(2)+"(?![\\w-])"),"")+("+"===b.charAt(0)?" "+b.substr(2):""),a.setAttribute("class",g.e),j=ca(a,k,ba(a),i,m),a.setAttribute("class",o),g.data=j.firstMPT,a.style.cssText=p,g=g.xfirst=f.parse(a,j.difs,g,h)}});var Va=function(a){if((1===a||0===a)&&this.data._totalTime===this.data._totalDuration&&"isFromStart"!==this.data.data){var b,c,d,e,f,g=this.t.style,h=i.transform.parse;if("all"===this.e)g.cssText="",e=!0;else for(b=this.e.split(" ").join("").split(","),d=b.length;--d>-1;)c=b[d],i[c]&&(i[c].parse===h?e=!0:c="transformOrigin"===c?Da:i[c].p),Ta(g,c);e&&(Ta(g,Ba),f=this.t._gsTransform,f&&(f.svg&&(this.t.removeAttribute("data-svg-origin"),this.t.removeAttribute("transform")),delete this.t._gsTransform))}};for(xa("clearProps",{parser:function(a,b,d,e,f){return f=new sa(a,d,0,0,f,2),f.setRatio=Va,f.e=b,f.pr=-10,f.data=e._tween,c=!0,f}}),j="bezier,throwProps,physicsProps,physics2D".split(","),va=j.length;va--;)ya(j[va]);j=g.prototype,j._firstPT=j._lastParsedTransform=j._transform=null,j._onInitTween=function(a,b,h,j){if(!a.nodeType)return!1;this._target=q=a,this._tween=h,this._vars=b,r=j,k=b.autoRound,c=!1,d=b.suffixMap||g.suffixMap,e=Z(a,""),f=this._overwriteProps;var n,p,s,t,u,v,w,x,z,A=a.style;if(l&&""===A.zIndex&&(n=$(a,"zIndex",e),("auto"===n||""===n)&&this._addLazySet(A,"zIndex",0)),"string"==typeof b&&(t=A.cssText,n=ba(a,e),A.cssText=t+";"+b,n=ca(a,n,ba(a)).difs,!T&&y.test(b)&&(n.opacity=parseFloat(RegExp.$1)),b=n,A.cssText=t),b.className?this._firstPT=p=i.className.parse(a,b.className,"className",this,null,null,b):this._firstPT=p=this.parse(a,b,null),this._transformType){for(z=3===this._transformType,Ba?m&&(l=!0,""===A.zIndex&&(w=$(a,"zIndex",e),("auto"===w||""===w)&&this._addLazySet(A,"zIndex",0)),o&&this._addLazySet(A,"WebkitBackfaceVisibility",this._vars.WebkitBackfaceVisibility||(z?"visible":"hidden"))):A.zoom=1,s=p;s&&s._next;)s=s._next;x=new sa(a,"transform",0,0,null,2),this._linkCSSP(x,null,s),x.setRatio=Ba?Ra:Qa,x.data=this._transform||Pa(a,e,!0),x.tween=h,x.pr=-1,f.pop()}if(c){for(;p;){for(v=p._next,s=t;s&&s.pr>p.pr;)s=s._next;(p._prev=s?s._prev:u)?p._prev._next=p:t=p,(p._next=s)?s._prev=p:u=p,p=v}this._firstPT=t}return!0},j.parse=function(a,b,c,f){var g,h,j,l,m,n,o,p,s,t,u=a.style;for(g in b)n=b[g],"function"==typeof n&&(n=n(r,q)),h=i[g],h?c=h.parse(a,n,g,this,c,f,b):(m=$(a,g,e)+"",s="string"==typeof n,"color"===g||"fill"===g||"stroke"===g||-1!==g.indexOf("Color")||s&&A.test(n)?(s||(n=ma(n),n=(n.length>3?"rgba(":"rgb(")+n.join(",")+")"),c=ua(u,g,m,n,!0,"transparent",c,0,f)):s&&J.test(n)?c=ua(u,g,m,n,!0,null,c,0,f):(j=parseFloat(m),o=j||0===j?m.substr((j+"").length):"",(""===m||"auto"===m)&&("width"===g||"height"===g?(j=fa(a,g,e),o="px"):"left"===g||"top"===g?(j=aa(a,g,e),o="px"):(j="opacity"!==g?0:1,o="")),t=s&&"="===n.charAt(1),t?(l=parseInt(n.charAt(0)+"1",10),n=n.substr(2),l*=parseFloat(n),p=n.replace(w,"")):(l=parseFloat(n),p=s?n.replace(w,""):""),""===p&&(p=g in d?d[g]:o),n=l||0===l?(t?l+j:l)+p:b[g],o!==p&&""!==p&&(l||0===l)&&j&&(j=_(a,g,j,o),"%"===p?(j/=_(a,g,100,"%")/100,b.strictUnits!==!0&&(m=j+"%")):"em"===p||"rem"===p||"vw"===p||"vh"===p?j/=_(a,g,1,p):"px"!==p&&(l=_(a,g,l,p),p="px"),t&&(l||0===l)&&(n=l+j+p)),t&&(l+=j),!j&&0!==j||!l&&0!==l?void 0!==u[g]&&(n||n+""!="NaN"&&null!=n)?(c=new sa(u,g,l||j||0,0,c,-1,g,!1,0,m,n),c.xs0="none"!==n||"display"!==g&&-1===g.indexOf("Style")?n:m):V("invalid "+g+" tween value: "+b[g]):(c=new sa(u,g,j,l-j,c,0,g,k!==!1&&("px"===p||"zIndex"===g),0,m,n),c.xs0=p))),f&&c&&!c.plugin&&(c.plugin=f);return c},j.setRatio=function(a){var b,c,d,e=this._firstPT,f=1e-6;if(1!==a||this._tween._time!==this._tween._duration&&0!==this._tween._time)if(a||this._tween._time!==this._tween._duration&&0!==this._tween._time||this._tween._rawPrevTime===-1e-6)for(;e;){if(b=e.c*a+e.s,e.r?b=Math.round(b):f>b&&b>-f&&(b=0),e.type)if(1===e.type)if(d=e.l,2===d)e.t[e.p]=e.xs0+b+e.xs1+e.xn1+e.xs2;else if(3===d)e.t[e.p]=e.xs0+b+e.xs1+e.xn1+e.xs2+e.xn2+e.xs3;else if(4===d)e.t[e.p]=e.xs0+b+e.xs1+e.xn1+e.xs2+e.xn2+e.xs3+e.xn3+e.xs4;else if(5===d)e.t[e.p]=e.xs0+b+e.xs1+e.xn1+e.xs2+e.xn2+e.xs3+e.xn3+e.xs4+e.xn4+e.xs5;else{for(c=e.xs0+b+e.xs1,d=1;d<e.l;d++)c+=e["xn"+d]+e["xs"+(d+1)];e.t[e.p]=c}else-1===e.type?e.t[e.p]=e.xs0:e.setRatio&&e.setRatio(a);else e.t[e.p]=b+e.xs0;e=e._next}else for(;e;)2!==e.type?e.t[e.p]=e.b:e.setRatio(a),e=e._next;else for(;e;){if(2!==e.type)if(e.r&&-1!==e.type)if(b=Math.round(e.s+e.c),e.type){if(1===e.type){for(d=e.l,c=e.xs0+b+e.xs1,d=1;d<e.l;d++)c+=e["xn"+d]+e["xs"+(d+1)];e.t[e.p]=c}}else e.t[e.p]=b+e.xs0;else e.t[e.p]=e.e;else e.setRatio(a);e=e._next}},j._enableTransforms=function(a){this._transform=this._transform||Pa(this._target,e,!0),this._transformType=this._transform.svg&&za||!a&&3!==this._transformType?2:3};var Wa=function(a){this.t[this.p]=this.e,this.data._linkCSSP(this,this._next,null,!0)};j._addLazySet=function(a,b,c){var d=this._firstPT=new sa(a,b,0,0,this._firstPT,2);d.e=c,d.setRatio=Wa,d.data=this},j._linkCSSP=function(a,b,c,d){return a&&(b&&(b._prev=a),a._next&&(a._next._prev=a._prev),a._prev?a._prev._next=a._next:this._firstPT===a&&(this._firstPT=a._next,d=!0),c?c._next=a:d||null!==this._firstPT||(this._firstPT=a),a._next=b,a._prev=c),a},j._mod=function(a){for(var b=this._firstPT;b;)"function"==typeof a[b.p]&&a[b.p]===Math.round&&(b.r=1),b=b._next},j._kill=function(b){var c,d,e,f=b;if(b.autoAlpha||b.alpha){f={};for(d in b)f[d]=b[d];f.opacity=1,f.autoAlpha&&(f.visibility=1)}for(b.className&&(c=this._classNamePT)&&(e=c.xfirst,e&&e._prev?this._linkCSSP(e._prev,c._next,e._prev._prev):e===this._firstPT&&(this._firstPT=c._next),c._next&&this._linkCSSP(c._next,c._next._next,e._prev),this._classNamePT=null),c=this._firstPT;c;)c.plugin&&c.plugin!==d&&c.plugin._kill&&(c.plugin._kill(b),d=c.plugin),c=c._next;return a.prototype._kill.call(this,f)};var Xa=function(a,b,c){var d,e,f,g;if(a.slice)for(e=a.length;--e>-1;)Xa(a[e],b,c);else for(d=a.childNodes,e=d.length;--e>-1;)f=d[e],g=f.type,f.style&&(b.push(ba(f)),c&&c.push(f)),1!==g&&9!==g&&11!==g||!f.childNodes.length||Xa(f,b,c)};return g.cascadeTo=function(a,c,d){var e,f,g,h,i=b.to(a,c,d),j=[i],k=[],l=[],m=[],n=b._internals.reservedProps;for(a=i._targets||i.target,Xa(a,k,m),i.render(c,!0,!0),Xa(a,l),i.render(0,!0,!0),i._enabled(!0),e=m.length;--e>-1;)if(f=ca(m[e],k[e],l[e]),f.firstMPT){f=f.difs;for(g in d)n[g]&&(f[g]=d[g]);h={};for(g in f)h[g]=k[e][g];j.push(b.fromTo(m[e],c,h,f))}return j},a.activate([g]),g},!0),function(){var a=_gsScope._gsDefine.plugin({propName:"roundProps",version:"1.6.0",priority:-1,API:2,init:function(a,b,c){return this._tween=c,!0}}),b=function(a){for(;a;)a.f||a.blob||(a.m=Math.round),a=a._next},c=a.prototype;c._onInitAllProps=function(){for(var a,c,d,e=this._tween,f=e.vars.roundProps.join?e.vars.roundProps:e.vars.roundProps.split(","),g=f.length,h={},i=e._propLookup.roundProps;--g>-1;)h[f[g]]=Math.round;for(g=f.length;--g>-1;)for(a=f[g],c=e._firstPT;c;)d=c._next,c.pg?c.t._mod(h):c.n===a&&(2===c.f&&c.t?b(c.t._firstPT):(this._add(c.t,a,c.s,c.c),d&&(d._prev=c._prev),c._prev?c._prev._next=d:e._firstPT===c&&(e._firstPT=d),c._next=c._prev=null,e._propLookup[a]=i)),c=d;return!1},c._add=function(a,b,c,d){this._addTween(a,b,c,c+d,b,Math.round),this._overwriteProps.push(b)}}(),function(){_gsScope._gsDefine.plugin({propName:"attr",API:2,version:"0.6.0",init:function(a,b,c,d){var e,f;if("function"!=typeof a.setAttribute)return!1;for(e in b)f=b[e],"function"==typeof f&&(f=f(d,a)),this._addTween(a,"setAttribute",a.getAttribute(e)+"",f+"",e,!1,e),this._overwriteProps.push(e);return!0}})}(),_gsScope._gsDefine.plugin({propName:"directionalRotation",version:"0.3.0",API:2,init:function(a,b,c,d){"object"!=typeof b&&(b={rotation:b}),this.finals={};var e,f,g,h,i,j,k=b.useRadians===!0?2*Math.PI:360,l=1e-6;for(e in b)"useRadians"!==e&&(h=b[e],"function"==typeof h&&(h=h(d,a)),j=(h+"").split("_"),f=j[0],g=parseFloat("function"!=typeof a[e]?a[e]:a[e.indexOf("set")||"function"!=typeof a["get"+e.substr(3)]?e:"get"+e.substr(3)]()),h=this.finals[e]="string"==typeof f&&"="===f.charAt(1)?g+parseInt(f.charAt(0)+"1",10)*Number(f.substr(2)):Number(f)||0,i=h-g,j.length&&(f=j.join("_"),-1!==f.indexOf("short")&&(i%=k,i!==i%(k/2)&&(i=0>i?i+k:i-k)),-1!==f.indexOf("_cw")&&0>i?i=(i+9999999999*k)%k-(i/k|0)*k:-1!==f.indexOf("ccw")&&i>0&&(i=(i-9999999999*k)%k-(i/k|0)*k)),(i>l||-l>i)&&(this._addTween(a,e,g,g+i,e),this._overwriteProps.push(e)));return!0},set:function(a){var b;if(1!==a)this._super.setRatio.call(this,a);else for(b=this._firstPT;b;)b.f?b.t[b.p](this.finals[b.p]):b.t[b.p]=this.finals[b.p],b=b._next}})._autoCSS=!0,_gsScope._gsDefine("easing.Back",["easing.Ease"],function(a){var b,c,d,e=_gsScope.GreenSockGlobals||_gsScope,f=e.com.greensock,g=2*Math.PI,h=Math.PI/2,i=f._class,j=function(b,c){var d=i("easing."+b,function(){},!0),e=d.prototype=new a;return e.constructor=d,e.getRatio=c,d},k=a.register||function(){},l=function(a,b,c,d,e){var f=i("easing."+a,{easeOut:new b,easeIn:new c,easeInOut:new d},!0);return k(f,a),f},m=function(a,b,c){this.t=a,this.v=b,c&&(this.next=c,c.prev=this,this.c=c.v-b,this.gap=c.t-a)},n=function(b,c){var d=i("easing."+b,function(a){this._p1=a||0===a?a:1.70158,this._p2=1.525*this._p1},!0),e=d.prototype=new a;return e.constructor=d,e.getRatio=c,e.config=function(a){return new d(a)},d},o=l("Back",n("BackOut",function(a){return(a-=1)*a*((this._p1+1)*a+this._p1)+1}),n("BackIn",function(a){return a*a*((this._p1+1)*a-this._p1)}),n("BackInOut",function(a){return(a*=2)<1?.5*a*a*((this._p2+1)*a-this._p2):.5*((a-=2)*a*((this._p2+1)*a+this._p2)+2)})),p=i("easing.SlowMo",function(a,b,c){b=b||0===b?b:.7,null==a?a=.7:a>1&&(a=1),this._p=1!==a?b:0,this._p1=(1-a)/2,this._p2=a,this._p3=this._p1+this._p2,this._calcEnd=c===!0},!0),q=p.prototype=new a;return q.constructor=p,q.getRatio=function(a){var b=a+(.5-a)*this._p;return a<this._p1?this._calcEnd?1-(a=1-a/this._p1)*a:b-(a=1-a/this._p1)*a*a*a*b:a>this._p3?this._calcEnd?1-(a=(a-this._p3)/this._p1)*a:b+(a-b)*(a=(a-this._p3)/this._p1)*a*a*a:this._calcEnd?1:b},p.ease=new p(.7,.7),q.config=p.config=function(a,b,c){return new p(a,b,c)},b=i("easing.SteppedEase",function(a){a=a||1,this._p1=1/a,this._p2=a+1},!0),q=b.prototype=new a,q.constructor=b,q.getRatio=function(a){return 0>a?a=0:a>=1&&(a=.999999999),(this._p2*a>>0)*this._p1},q.config=b.config=function(a){return new b(a)},c=i("easing.RoughEase",function(b){b=b||{};for(var c,d,e,f,g,h,i=b.taper||"none",j=[],k=0,l=0|(b.points||20),n=l,o=b.randomize!==!1,p=b.clamp===!0,q=b.template instanceof a?b.template:null,r="number"==typeof b.strength?.4*b.strength:.4;--n>-1;)c=o?Math.random():1/l*n,d=q?q.getRatio(c):c,"none"===i?e=r:"out"===i?(f=1-c,e=f*f*r):"in"===i?e=c*c*r:.5>c?(f=2*c,e=f*f*.5*r):(f=2*(1-c),e=f*f*.5*r),o?d+=Math.random()*e-.5*e:n%2?d+=.5*e:d-=.5*e,p&&(d>1?d=1:0>d&&(d=0)),j[k++]={x:c,y:d};for(j.sort(function(a,b){return a.x-b.x}),h=new m(1,1,null),n=l;--n>-1;)g=j[n],h=new m(g.x,g.y,h);this._prev=new m(0,0,0!==h.t?h:h.next)},!0),q=c.prototype=new a,q.constructor=c,q.getRatio=function(a){var b=this._prev;if(a>b.t){for(;b.next&&a>=b.t;)b=b.next;b=b.prev}else for(;b.prev&&a<=b.t;)b=b.prev;return this._prev=b,b.v+(a-b.t)/b.gap*b.c},q.config=function(a){return new c(a)},c.ease=new c,l("Bounce",j("BounceOut",function(a){return 1/2.75>a?7.5625*a*a:2/2.75>a?7.5625*(a-=1.5/2.75)*a+.75:2.5/2.75>a?7.5625*(a-=2.25/2.75)*a+.9375:7.5625*(a-=2.625/2.75)*a+.984375}),j("BounceIn",function(a){return(a=1-a)<1/2.75?1-7.5625*a*a:2/2.75>a?1-(7.5625*(a-=1.5/2.75)*a+.75):2.5/2.75>a?1-(7.5625*(a-=2.25/2.75)*a+.9375):1-(7.5625*(a-=2.625/2.75)*a+.984375)}),j("BounceInOut",function(a){var b=.5>a;return a=b?1-2*a:2*a-1,a=1/2.75>a?7.5625*a*a:2/2.75>a?7.5625*(a-=1.5/2.75)*a+.75:2.5/2.75>a?7.5625*(a-=2.25/2.75)*a+.9375:7.5625*(a-=2.625/2.75)*a+.984375,b?.5*(1-a):.5*a+.5})),l("Circ",j("CircOut",function(a){return Math.sqrt(1-(a-=1)*a)}),j("CircIn",function(a){return-(Math.sqrt(1-a*a)-1)}),j("CircInOut",function(a){return(a*=2)<1?-.5*(Math.sqrt(1-a*a)-1):.5*(Math.sqrt(1-(a-=2)*a)+1)})),d=function(b,c,d){var e=i("easing."+b,function(a,b){this._p1=a>=1?a:1,this._p2=(b||d)/(1>a?a:1),this._p3=this._p2/g*(Math.asin(1/this._p1)||0),this._p2=g/this._p2},!0),f=e.prototype=new a;return f.constructor=e,f.getRatio=c,f.config=function(a,b){return new e(a,b)},e},l("Elastic",d("ElasticOut",function(a){return this._p1*Math.pow(2,-10*a)*Math.sin((a-this._p3)*this._p2)+1},.3),d("ElasticIn",function(a){return-(this._p1*Math.pow(2,10*(a-=1))*Math.sin((a-this._p3)*this._p2))},.3),d("ElasticInOut",function(a){return(a*=2)<1?-.5*(this._p1*Math.pow(2,10*(a-=1))*Math.sin((a-this._p3)*this._p2)):this._p1*Math.pow(2,-10*(a-=1))*Math.sin((a-this._p3)*this._p2)*.5+1},.45)),l("Expo",j("ExpoOut",function(a){return 1-Math.pow(2,-10*a)}),j("ExpoIn",function(a){return Math.pow(2,10*(a-1))-.001}),j("ExpoInOut",function(a){return(a*=2)<1?.5*Math.pow(2,10*(a-1)):.5*(2-Math.pow(2,-10*(a-1)))})),l("Sine",j("SineOut",function(a){return Math.sin(a*h)}),j("SineIn",function(a){return-Math.cos(a*h)+1}),j("SineInOut",function(a){return-.5*(Math.cos(Math.PI*a)-1)})),i("easing.EaseLookup",{find:function(b){return a.map[b]}},!0),k(e.SlowMo,"SlowMo","ease,"),k(c,"RoughEase","ease,"),k(b,"SteppedEase","ease,"),o},!0)}),_gsScope._gsDefine&&_gsScope._gsQueue.pop()(),function(a,b){"use strict";var c={},d=a.GreenSockGlobals=a.GreenSockGlobals||a;if(!d.TweenLite){var e,f,g,h,i,j=function(a){var b,c=a.split("."),e=d;for(b=0;b<c.length;b++)e[c[b]]=e=e[c[b]]||{};return e},k=j("com.greensock"),l=1e-10,m=function(a){var b,c=[],d=a.length;for(b=0;b!==d;c.push(a[b++]));return c},n=function(){},o=function(){var a=Object.prototype.toString,b=a.call([]);return function(c){return null!=c&&(c instanceof Array||"object"==typeof c&&!!c.push&&a.call(c)===b)}}(),p={},q=function(e,f,g,h){this.sc=p[e]?p[e].sc:[],p[e]=this,this.gsClass=null,this.func=g;var i=[];this.check=function(k){for(var l,m,n,o,r,s=f.length,t=s;--s>-1;)(l=p[f[s]]||new q(f[s],[])).gsClass?(i[s]=l.gsClass,t--):k&&l.sc.push(this);if(0===t&&g){if(m=("com.greensock."+e).split("."),n=m.pop(),o=j(m.join("."))[n]=this.gsClass=g.apply(g,i),h)if(d[n]=c[n]=o,r="undefined"!=typeof module&&module.exports,!r&&"function"==typeof define&&define.amd)define((a.GreenSockAMDPath?a.GreenSockAMDPath+"/":"")+e.split(".").pop(),[],function(){return o});else if(r)if(e===b){module.exports=c[b]=o;for(s in c)o[s]=c[s]}else c[b]&&(c[b][n]=o);for(s=0;s<this.sc.length;s++)this.sc[s].check()}},this.check(!0)},r=a._gsDefine=function(a,b,c,d){return new q(a,b,c,d)},s=k._class=function(a,b,c){return b=b||function(){},r(a,[],function(){return b},c),b};r.globals=d;var t=[0,0,1,1],u=s("easing.Ease",function(a,b,c,d){this._func=a,this._type=c||0,this._power=d||0,this._params=b?t.concat(b):t},!0),v=u.map={},w=u.register=function(a,b,c,d){for(var e,f,g,h,i=b.split(","),j=i.length,l=(c||"easeIn,easeOut,easeInOut").split(",");--j>-1;)for(f=i[j],e=d?s("easing."+f,null,!0):k.easing[f]||{},g=l.length;--g>-1;)h=l[g],v[f+"."+h]=v[h+f]=e[h]=a.getRatio?a:a[h]||new a};for(g=u.prototype,g._calcEnd=!1,g.getRatio=function(a){if(this._func)return this._params[0]=a,this._func.apply(null,this._params);var b=this._type,c=this._power,d=1===b?1-a:2===b?a:.5>a?2*a:2*(1-a);return 1===c?d*=d:2===c?d*=d*d:3===c?d*=d*d*d:4===c&&(d*=d*d*d*d),1===b?1-d:2===b?d:.5>a?d/2:1-d/2},e=["Linear","Quad","Cubic","Quart","Quint,Strong"],f=e.length;--f>-1;)g=e[f]+",Power"+f,w(new u(null,null,1,f),g,"easeOut",!0),w(new u(null,null,2,f),g,"easeIn"+(0===f?",easeNone":"")),w(new u(null,null,3,f),g,"easeInOut");v.linear=k.easing.Linear.easeIn,v.swing=k.easing.Quad.easeInOut;var x=s("events.EventDispatcher",function(a){this._listeners={},this._eventTarget=a||this});g=x.prototype,g.addEventListener=function(a,b,c,d,e){e=e||0;var f,g,j=this._listeners[a],k=0;for(this!==h||i||h.wake(),null==j&&(this._listeners[a]=j=[]),g=j.length;--g>-1;)f=j[g],f.c===b&&f.s===c?j.splice(g,1):0===k&&f.pr<e&&(k=g+1);j.splice(k,0,{c:b,s:c,up:d,pr:e})},g.removeEventListener=function(a,b){var c,d=this._listeners[a];if(d)for(c=d.length;--c>-1;)if(d[c].c===b)return void d.splice(c,1)},g.dispatchEvent=function(a){var b,c,d,e=this._listeners[a];if(e)for(b=e.length,b>1&&(e=e.slice(0)),c=this._eventTarget;--b>-1;)d=e[b],d&&(d.up?d.c.call(d.s||c,{type:a,target:c}):d.c.call(d.s||c))};var y=a.requestAnimationFrame,z=a.cancelAnimationFrame,A=Date.now||function(){return(new Date).getTime()},B=A();for(e=["ms","moz","webkit","o"],f=e.length;--f>-1&&!y;)y=a[e[f]+"RequestAnimationFrame"],z=a[e[f]+"CancelAnimationFrame"]||a[e[f]+"CancelRequestAnimationFrame"];s("Ticker",function(a,b){var c,d,e,f,g,j=this,k=A(),m=b!==!1&&y?"auto":!1,o=500,p=33,q="tick",r=function(a){var b,h,i=A()-B;i>o&&(k+=i-p),B+=i,j.time=(B-k)/1e3,b=j.time-g,(!c||b>0||a===!0)&&(j.frame++,g+=b+(b>=f?.004:f-b),h=!0),a!==!0&&(e=d(r)),h&&j.dispatchEvent(q)};x.call(j),j.time=j.frame=0,j.tick=function(){r(!0)},j.lagSmoothing=function(a,b){o=a||1/l,p=Math.min(b,o,0)},j.sleep=function(){null!=e&&(m&&z?z(e):clearTimeout(e),d=n,e=null,j===h&&(i=!1))},j.wake=function(a){null!==e?j.sleep():a?k+=-B+(B=A()):j.frame>10&&(B=A()-o+5),d=0===c?n:m&&y?y:function(a){return setTimeout(a,1e3*(g-j.time)+1|0)},j===h&&(i=!0),r(2)},j.fps=function(a){return arguments.length?(c=a,f=1/(c||60),g=this.time+f,void j.wake()):c},j.useRAF=function(a){return arguments.length?(j.sleep(),m=a,void j.fps(c)):m},j.fps(a),setTimeout(function(){"auto"===m&&j.frame<5&&"hidden"!==document.visibilityState&&j.useRAF(!1)},1500)}),g=k.Ticker.prototype=new k.events.EventDispatcher,g.constructor=k.Ticker;var C=s("core.Animation",function(a,b){if(this.vars=b=b||{},this._duration=this._totalDuration=a||0,this._delay=Number(b.delay)||0,this._timeScale=1,this._active=b.immediateRender===!0,this.data=b.data,this._reversed=b.reversed===!0,V){i||h.wake();var c=this.vars.useFrames?U:V;c.add(this,c._time),this.vars.paused&&this.paused(!0)}});h=C.ticker=new k.Ticker,g=C.prototype,g._dirty=g._gc=g._initted=g._paused=!1,g._totalTime=g._time=0,g._rawPrevTime=-1,g._next=g._last=g._onUpdate=g._timeline=g.timeline=null,g._paused=!1;var D=function(){i&&A()-B>2e3&&h.wake(),setTimeout(D,2e3)};D(),g.play=function(a,b){return null!=a&&this.seek(a,b),this.reversed(!1).paused(!1)},g.pause=function(a,b){return null!=a&&this.seek(a,b),this.paused(!0)},g.resume=function(a,b){return null!=a&&this.seek(a,b),this.paused(!1)},g.seek=function(a,b){return this.totalTime(Number(a),b!==!1)},g.restart=function(a,b){return this.reversed(!1).paused(!1).totalTime(a?-this._delay:0,b!==!1,!0)},g.reverse=function(a,b){return null!=a&&this.seek(a||this.totalDuration(),b),this.reversed(!0).paused(!1)},g.render=function(a,b,c){},g.invalidate=function(){return this._time=this._totalTime=0,this._initted=this._gc=!1,this._rawPrevTime=-1,(this._gc||!this.timeline)&&this._enabled(!0),this},g.isActive=function(){var a,b=this._timeline,c=this._startTime;return!b||!this._gc&&!this._paused&&b.isActive()&&(a=b.rawTime())>=c&&a<c+this.totalDuration()/this._timeScale},g._enabled=function(a,b){return i||h.wake(),this._gc=!a,this._active=this.isActive(),b!==!0&&(a&&!this.timeline?this._timeline.add(this,this._startTime-this._delay):!a&&this.timeline&&this._timeline._remove(this,!0)),!1},g._kill=function(a,b){return this._enabled(!1,!1)},g.kill=function(a,b){return this._kill(a,b),this},g._uncache=function(a){for(var b=a?this:this.timeline;b;)b._dirty=!0,b=b.timeline;return this},g._swapSelfInParams=function(a){for(var b=a.length,c=a.concat();--b>-1;)"{self}"===a[b]&&(c[b]=this);return c},g._callback=function(a){var b=this.vars,c=b[a],d=b[a+"Params"],e=b[a+"Scope"]||b.callbackScope||this,f=d?d.length:0;switch(f){case 0:c.call(e);break;case 1:c.call(e,d[0]);break;case 2:c.call(e,d[0],d[1]);break;default:c.apply(e,d)}},g.eventCallback=function(a,b,c,d){if("on"===(a||"").substr(0,2)){var e=this.vars;if(1===arguments.length)return e[a];null==b?delete e[a]:(e[a]=b,e[a+"Params"]=o(c)&&-1!==c.join("").indexOf("{self}")?this._swapSelfInParams(c):c,e[a+"Scope"]=d),"onUpdate"===a&&(this._onUpdate=b)}return this},g.delay=function(a){return arguments.length?(this._timeline.smoothChildTiming&&this.startTime(this._startTime+a-this._delay),this._delay=a,this):this._delay},g.duration=function(a){return arguments.length?(this._duration=this._totalDuration=a,this._uncache(!0),this._timeline.smoothChildTiming&&this._time>0&&this._time<this._duration&&0!==a&&this.totalTime(this._totalTime*(a/this._duration),!0),this):(this._dirty=!1,this._duration)},g.totalDuration=function(a){return this._dirty=!1,arguments.length?this.duration(a):this._totalDuration},g.time=function(a,b){return arguments.length?(this._dirty&&this.totalDuration(),this.totalTime(a>this._duration?this._duration:a,b)):this._time},g.totalTime=function(a,b,c){if(i||h.wake(),!arguments.length)return this._totalTime;if(this._timeline){if(0>a&&!c&&(a+=this.totalDuration()),this._timeline.smoothChildTiming){this._dirty&&this.totalDuration();var d=this._totalDuration,e=this._timeline;if(a>d&&!c&&(a=d),this._startTime=(this._paused?this._pauseTime:e._time)-(this._reversed?d-a:a)/this._timeScale,e._dirty||this._uncache(!1),e._timeline)for(;e._timeline;)e._timeline._time!==(e._startTime+e._totalTime)/e._timeScale&&e.totalTime(e._totalTime,!0),e=e._timeline}this._gc&&this._enabled(!0,!1),(this._totalTime!==a||0===this._duration)&&(I.length&&X(),this.render(a,b,!1),I.length&&X())}return this},g.progress=g.totalProgress=function(a,b){var c=this.duration();return arguments.length?this.totalTime(c*a,b):c?this._time/c:this.ratio},g.startTime=function(a){return arguments.length?(a!==this._startTime&&(this._startTime=a,this.timeline&&this.timeline._sortChildren&&this.timeline.add(this,a-this._delay)),this):this._startTime},g.endTime=function(a){return this._startTime+(0!=a?this.totalDuration():this.duration())/this._timeScale},g.timeScale=function(a){if(!arguments.length)return this._timeScale;if(a=a||l,this._timeline&&this._timeline.smoothChildTiming){var b=this._pauseTime,c=b||0===b?b:this._timeline.totalTime();this._startTime=c-(c-this._startTime)*this._timeScale/a}return this._timeScale=a,this._uncache(!1)},g.reversed=function(a){return arguments.length?(a!=this._reversed&&(this._reversed=a,this.totalTime(this._timeline&&!this._timeline.smoothChildTiming?this.totalDuration()-this._totalTime:this._totalTime,!0)),this):this._reversed},g.paused=function(a){if(!arguments.length)return this._paused;var b,c,d=this._timeline;return a!=this._paused&&d&&(i||a||h.wake(),b=d.rawTime(),c=b-this._pauseTime,!a&&d.smoothChildTiming&&(this._startTime+=c,this._uncache(!1)),this._pauseTime=a?b:null,this._paused=a,this._active=this.isActive(),!a&&0!==c&&this._initted&&this.duration()&&(b=d.smoothChildTiming?this._totalTime:(b-this._startTime)/this._timeScale,this.render(b,b===this._totalTime,!0))),this._gc&&!a&&this._enabled(!0,!1),this};var E=s("core.SimpleTimeline",function(a){C.call(this,0,a),this.autoRemoveChildren=this.smoothChildTiming=!0});g=E.prototype=new C,g.constructor=E,g.kill()._gc=!1,g._first=g._last=g._recent=null,g._sortChildren=!1,g.add=g.insert=function(a,b,c,d){var e,f;if(a._startTime=Number(b||0)+a._delay,a._paused&&this!==a._timeline&&(a._pauseTime=a._startTime+(this.rawTime()-a._startTime)/a._timeScale),a.timeline&&a.timeline._remove(a,!0),a.timeline=a._timeline=this,a._gc&&a._enabled(!0,!0),e=this._last,this._sortChildren)for(f=a._startTime;e&&e._startTime>f;)e=e._prev;return e?(a._next=e._next,e._next=a):(a._next=this._first,this._first=a),a._next?a._next._prev=a:this._last=a,a._prev=e,this._recent=a,this._timeline&&this._uncache(!0),this},g._remove=function(a,b){return a.timeline===this&&(b||a._enabled(!1,!0),a._prev?a._prev._next=a._next:this._first===a&&(this._first=a._next),a._next?a._next._prev=a._prev:this._last===a&&(this._last=a._prev),a._next=a._prev=a.timeline=null,a===this._recent&&(this._recent=this._last),this._timeline&&this._uncache(!0)),this},g.render=function(a,b,c){var d,e=this._first;for(this._totalTime=this._time=this._rawPrevTime=a;e;)d=e._next,(e._active||a>=e._startTime&&!e._paused)&&(e._reversed?e.render((e._dirty?e.totalDuration():e._totalDuration)-(a-e._startTime)*e._timeScale,b,c):e.render((a-e._startTime)*e._timeScale,b,c)),e=d},g.rawTime=function(){return i||h.wake(),this._totalTime};var F=s("TweenLite",function(b,c,d){if(C.call(this,c,d),this.render=F.prototype.render,null==b)throw"Cannot tween a null target.";this.target=b="string"!=typeof b?b:F.selector(b)||b;var e,f,g,h=b.jquery||b.length&&b!==a&&b[0]&&(b[0]===a||b[0].nodeType&&b[0].style&&!b.nodeType),i=this.vars.overwrite;if(this._overwrite=i=null==i?T[F.defaultOverwrite]:"number"==typeof i?i>>0:T[i],(h||b instanceof Array||b.push&&o(b))&&"number"!=typeof b[0])for(this._targets=g=m(b),this._propLookup=[],this._siblings=[],e=0;e<g.length;e++)f=g[e],f?"string"!=typeof f?f.length&&f!==a&&f[0]&&(f[0]===a||f[0].nodeType&&f[0].style&&!f.nodeType)?(g.splice(e--,1),this._targets=g=g.concat(m(f))):(this._siblings[e]=Y(f,this,!1),1===i&&this._siblings[e].length>1&&$(f,this,null,1,this._siblings[e])):(f=g[e--]=F.selector(f),"string"==typeof f&&g.splice(e+1,1)):g.splice(e--,1);else this._propLookup={},this._siblings=Y(b,this,!1),1===i&&this._siblings.length>1&&$(b,this,null,1,this._siblings);(this.vars.immediateRender||0===c&&0===this._delay&&this.vars.immediateRender!==!1)&&(this._time=-l,this.render(Math.min(0,-this._delay)))},!0),G=function(b){return b&&b.length&&b!==a&&b[0]&&(b[0]===a||b[0].nodeType&&b[0].style&&!b.nodeType);
},H=function(a,b){var c,d={};for(c in a)S[c]||c in b&&"transform"!==c&&"x"!==c&&"y"!==c&&"width"!==c&&"height"!==c&&"className"!==c&&"border"!==c||!(!P[c]||P[c]&&P[c]._autoCSS)||(d[c]=a[c],delete a[c]);a.css=d};g=F.prototype=new C,g.constructor=F,g.kill()._gc=!1,g.ratio=0,g._firstPT=g._targets=g._overwrittenProps=g._startAt=null,g._notifyPluginsOfEnabled=g._lazy=!1,F.version="1.19.0",F.defaultEase=g._ease=new u(null,null,1,1),F.defaultOverwrite="auto",F.ticker=h,F.autoSleep=120,F.lagSmoothing=function(a,b){h.lagSmoothing(a,b)},F.selector=a.$||a.jQuery||function(b){var c=a.$||a.jQuery;return c?(F.selector=c,c(b)):"undefined"==typeof document?b:document.querySelectorAll?document.querySelectorAll(b):document.getElementById("#"===b.charAt(0)?b.substr(1):b)};var I=[],J={},K=/(?:(-|-=|\+=)?\d*\.?\d*(?:e[\-+]?\d+)?)[0-9]/gi,L=function(a){for(var b,c=this._firstPT,d=1e-6;c;)b=c.blob?a?this.join(""):this.start:c.c*a+c.s,c.m?b=c.m(b,this._target||c.t):d>b&&b>-d&&(b=0),c.f?c.fp?c.t[c.p](c.fp,b):c.t[c.p](b):c.t[c.p]=b,c=c._next},M=function(a,b,c,d){var e,f,g,h,i,j,k,l=[a,b],m=0,n="",o=0;for(l.start=a,c&&(c(l),a=l[0],b=l[1]),l.length=0,e=a.match(K)||[],f=b.match(K)||[],d&&(d._next=null,d.blob=1,l._firstPT=l._applyPT=d),i=f.length,h=0;i>h;h++)k=f[h],j=b.substr(m,b.indexOf(k,m)-m),n+=j||!h?j:",",m+=j.length,o?o=(o+1)%5:"rgba("===j.substr(-5)&&(o=1),k===e[h]||e.length<=h?n+=k:(n&&(l.push(n),n=""),g=parseFloat(e[h]),l.push(g),l._firstPT={_next:l._firstPT,t:l,p:l.length-1,s:g,c:("="===k.charAt(1)?parseInt(k.charAt(0)+"1",10)*parseFloat(k.substr(2)):parseFloat(k)-g)||0,f:0,m:o&&4>o?Math.round:0}),m+=k.length;return n+=b.substr(m),n&&l.push(n),l.setRatio=L,l},N=function(a,b,c,d,e,f,g,h,i){"function"==typeof d&&(d=d(i||0,a));var j,k,l="get"===c?a[b]:c,m=typeof a[b],n="string"==typeof d&&"="===d.charAt(1),o={t:a,p:b,s:l,f:"function"===m,pg:0,n:e||b,m:f?"function"==typeof f?f:Math.round:0,pr:0,c:n?parseInt(d.charAt(0)+"1",10)*parseFloat(d.substr(2)):parseFloat(d)-l||0};return"number"!==m&&("function"===m&&"get"===c&&(k=b.indexOf("set")||"function"!=typeof a["get"+b.substr(3)]?b:"get"+b.substr(3),o.s=l=g?a[k](g):a[k]()),"string"==typeof l&&(g||isNaN(l))?(o.fp=g,j=M(l,d,h||F.defaultStringFilter,o),o={t:j,p:"setRatio",s:0,c:1,f:2,pg:0,n:e||b,pr:0,m:0}):n||(o.s=parseFloat(l),o.c=parseFloat(d)-o.s||0)),o.c?((o._next=this._firstPT)&&(o._next._prev=o),this._firstPT=o,o):void 0},O=F._internals={isArray:o,isSelector:G,lazyTweens:I,blobDif:M},P=F._plugins={},Q=O.tweenLookup={},R=0,S=O.reservedProps={ease:1,delay:1,overwrite:1,onComplete:1,onCompleteParams:1,onCompleteScope:1,useFrames:1,runBackwards:1,startAt:1,onUpdate:1,onUpdateParams:1,onUpdateScope:1,onStart:1,onStartParams:1,onStartScope:1,onReverseComplete:1,onReverseCompleteParams:1,onReverseCompleteScope:1,onRepeat:1,onRepeatParams:1,onRepeatScope:1,easeParams:1,yoyo:1,immediateRender:1,repeat:1,repeatDelay:1,data:1,paused:1,reversed:1,autoCSS:1,lazy:1,onOverwrite:1,callbackScope:1,stringFilter:1,id:1},T={none:0,all:1,auto:2,concurrent:3,allOnStart:4,preexisting:5,"true":1,"false":0},U=C._rootFramesTimeline=new E,V=C._rootTimeline=new E,W=30,X=O.lazyRender=function(){var a,b=I.length;for(J={};--b>-1;)a=I[b],a&&a._lazy!==!1&&(a.render(a._lazy[0],a._lazy[1],!0),a._lazy=!1);I.length=0};V._startTime=h.time,U._startTime=h.frame,V._active=U._active=!0,setTimeout(X,1),C._updateRoot=F.render=function(){var a,b,c;if(I.length&&X(),V.render((h.time-V._startTime)*V._timeScale,!1,!1),U.render((h.frame-U._startTime)*U._timeScale,!1,!1),I.length&&X(),h.frame>=W){W=h.frame+(parseInt(F.autoSleep,10)||120);for(c in Q){for(b=Q[c].tweens,a=b.length;--a>-1;)b[a]._gc&&b.splice(a,1);0===b.length&&delete Q[c]}if(c=V._first,(!c||c._paused)&&F.autoSleep&&!U._first&&1===h._listeners.tick.length){for(;c&&c._paused;)c=c._next;c||h.sleep()}}},h.addEventListener("tick",C._updateRoot);var Y=function(a,b,c){var d,e,f=a._gsTweenID;if(Q[f||(a._gsTweenID=f="t"+R++)]||(Q[f]={target:a,tweens:[]}),b&&(d=Q[f].tweens,d[e=d.length]=b,c))for(;--e>-1;)d[e]===b&&d.splice(e,1);return Q[f].tweens},Z=function(a,b,c,d){var e,f,g=a.vars.onOverwrite;return g&&(e=g(a,b,c,d)),g=F.onOverwrite,g&&(f=g(a,b,c,d)),e!==!1&&f!==!1},$=function(a,b,c,d,e){var f,g,h,i;if(1===d||d>=4){for(i=e.length,f=0;i>f;f++)if((h=e[f])!==b)h._gc||h._kill(null,a,b)&&(g=!0);else if(5===d)break;return g}var j,k=b._startTime+l,m=[],n=0,o=0===b._duration;for(f=e.length;--f>-1;)(h=e[f])===b||h._gc||h._paused||(h._timeline!==b._timeline?(j=j||_(b,0,o),0===_(h,j,o)&&(m[n++]=h)):h._startTime<=k&&h._startTime+h.totalDuration()/h._timeScale>k&&((o||!h._initted)&&k-h._startTime<=2e-10||(m[n++]=h)));for(f=n;--f>-1;)if(h=m[f],2===d&&h._kill(c,a,b)&&(g=!0),2!==d||!h._firstPT&&h._initted){if(2!==d&&!Z(h,b))continue;h._enabled(!1,!1)&&(g=!0)}return g},_=function(a,b,c){for(var d=a._timeline,e=d._timeScale,f=a._startTime;d._timeline;){if(f+=d._startTime,e*=d._timeScale,d._paused)return-100;d=d._timeline}return f/=e,f>b?f-b:c&&f===b||!a._initted&&2*l>f-b?l:(f+=a.totalDuration()/a._timeScale/e)>b+l?0:f-b-l};g._init=function(){var a,b,c,d,e,f,g=this.vars,h=this._overwrittenProps,i=this._duration,j=!!g.immediateRender,k=g.ease;if(g.startAt){this._startAt&&(this._startAt.render(-1,!0),this._startAt.kill()),e={};for(d in g.startAt)e[d]=g.startAt[d];if(e.overwrite=!1,e.immediateRender=!0,e.lazy=j&&g.lazy!==!1,e.startAt=e.delay=null,this._startAt=F.to(this.target,0,e),j)if(this._time>0)this._startAt=null;else if(0!==i)return}else if(g.runBackwards&&0!==i)if(this._startAt)this._startAt.render(-1,!0),this._startAt.kill(),this._startAt=null;else{0!==this._time&&(j=!1),c={};for(d in g)S[d]&&"autoCSS"!==d||(c[d]=g[d]);if(c.overwrite=0,c.data="isFromStart",c.lazy=j&&g.lazy!==!1,c.immediateRender=j,this._startAt=F.to(this.target,0,c),j){if(0===this._time)return}else this._startAt._init(),this._startAt._enabled(!1),this.vars.immediateRender&&(this._startAt=null)}if(this._ease=k=k?k instanceof u?k:"function"==typeof k?new u(k,g.easeParams):v[k]||F.defaultEase:F.defaultEase,g.easeParams instanceof Array&&k.config&&(this._ease=k.config.apply(k,g.easeParams)),this._easeType=this._ease._type,this._easePower=this._ease._power,this._firstPT=null,this._targets)for(f=this._targets.length,a=0;f>a;a++)this._initProps(this._targets[a],this._propLookup[a]={},this._siblings[a],h?h[a]:null,a)&&(b=!0);else b=this._initProps(this.target,this._propLookup,this._siblings,h,0);if(b&&F._onPluginEvent("_onInitAllProps",this),h&&(this._firstPT||"function"!=typeof this.target&&this._enabled(!1,!1)),g.runBackwards)for(c=this._firstPT;c;)c.s+=c.c,c.c=-c.c,c=c._next;this._onUpdate=g.onUpdate,this._initted=!0},g._initProps=function(b,c,d,e,f){var g,h,i,j,k,l;if(null==b)return!1;J[b._gsTweenID]&&X(),this.vars.css||b.style&&b!==a&&b.nodeType&&P.css&&this.vars.autoCSS!==!1&&H(this.vars,b);for(g in this.vars)if(l=this.vars[g],S[g])l&&(l instanceof Array||l.push&&o(l))&&-1!==l.join("").indexOf("{self}")&&(this.vars[g]=l=this._swapSelfInParams(l,this));else if(P[g]&&(j=new P[g])._onInitTween(b,this.vars[g],this,f)){for(this._firstPT=k={_next:this._firstPT,t:j,p:"setRatio",s:0,c:1,f:1,n:g,pg:1,pr:j._priority,m:0},h=j._overwriteProps.length;--h>-1;)c[j._overwriteProps[h]]=this._firstPT;(j._priority||j._onInitAllProps)&&(i=!0),(j._onDisable||j._onEnable)&&(this._notifyPluginsOfEnabled=!0),k._next&&(k._next._prev=k)}else c[g]=N.call(this,b,g,"get",l,g,0,null,this.vars.stringFilter,f);return e&&this._kill(e,b)?this._initProps(b,c,d,e,f):this._overwrite>1&&this._firstPT&&d.length>1&&$(b,this,c,this._overwrite,d)?(this._kill(c,b),this._initProps(b,c,d,e,f)):(this._firstPT&&(this.vars.lazy!==!1&&this._duration||this.vars.lazy&&!this._duration)&&(J[b._gsTweenID]=!0),i)},g.render=function(a,b,c){var d,e,f,g,h=this._time,i=this._duration,j=this._rawPrevTime;if(a>=i-1e-7)this._totalTime=this._time=i,this.ratio=this._ease._calcEnd?this._ease.getRatio(1):1,this._reversed||(d=!0,e="onComplete",c=c||this._timeline.autoRemoveChildren),0===i&&(this._initted||!this.vars.lazy||c)&&(this._startTime===this._timeline._duration&&(a=0),(0>j||0>=a&&a>=-1e-7||j===l&&"isPause"!==this.data)&&j!==a&&(c=!0,j>l&&(e="onReverseComplete")),this._rawPrevTime=g=!b||a||j===a?a:l);else if(1e-7>a)this._totalTime=this._time=0,this.ratio=this._ease._calcEnd?this._ease.getRatio(0):0,(0!==h||0===i&&j>0)&&(e="onReverseComplete",d=this._reversed),0>a&&(this._active=!1,0===i&&(this._initted||!this.vars.lazy||c)&&(j>=0&&(j!==l||"isPause"!==this.data)&&(c=!0),this._rawPrevTime=g=!b||a||j===a?a:l)),this._initted||(c=!0);else if(this._totalTime=this._time=a,this._easeType){var k=a/i,m=this._easeType,n=this._easePower;(1===m||3===m&&k>=.5)&&(k=1-k),3===m&&(k*=2),1===n?k*=k:2===n?k*=k*k:3===n?k*=k*k*k:4===n&&(k*=k*k*k*k),1===m?this.ratio=1-k:2===m?this.ratio=k:.5>a/i?this.ratio=k/2:this.ratio=1-k/2}else this.ratio=this._ease.getRatio(a/i);if(this._time!==h||c){if(!this._initted){if(this._init(),!this._initted||this._gc)return;if(!c&&this._firstPT&&(this.vars.lazy!==!1&&this._duration||this.vars.lazy&&!this._duration))return this._time=this._totalTime=h,this._rawPrevTime=j,I.push(this),void(this._lazy=[a,b]);this._time&&!d?this.ratio=this._ease.getRatio(this._time/i):d&&this._ease._calcEnd&&(this.ratio=this._ease.getRatio(0===this._time?0:1))}for(this._lazy!==!1&&(this._lazy=!1),this._active||!this._paused&&this._time!==h&&a>=0&&(this._active=!0),0===h&&(this._startAt&&(a>=0?this._startAt.render(a,b,c):e||(e="_dummyGS")),this.vars.onStart&&(0!==this._time||0===i)&&(b||this._callback("onStart"))),f=this._firstPT;f;)f.f?f.t[f.p](f.c*this.ratio+f.s):f.t[f.p]=f.c*this.ratio+f.s,f=f._next;this._onUpdate&&(0>a&&this._startAt&&a!==-1e-4&&this._startAt.render(a,b,c),b||(this._time!==h||d||c)&&this._callback("onUpdate")),e&&(!this._gc||c)&&(0>a&&this._startAt&&!this._onUpdate&&a!==-1e-4&&this._startAt.render(a,b,c),d&&(this._timeline.autoRemoveChildren&&this._enabled(!1,!1),this._active=!1),!b&&this.vars[e]&&this._callback(e),0===i&&this._rawPrevTime===l&&g!==l&&(this._rawPrevTime=0))}},g._kill=function(a,b,c){if("all"===a&&(a=null),null==a&&(null==b||b===this.target))return this._lazy=!1,this._enabled(!1,!1);b="string"!=typeof b?b||this._targets||this.target:F.selector(b)||b;var d,e,f,g,h,i,j,k,l,m=c&&this._time&&c._startTime===this._startTime&&this._timeline===c._timeline;if((o(b)||G(b))&&"number"!=typeof b[0])for(d=b.length;--d>-1;)this._kill(a,b[d],c)&&(i=!0);else{if(this._targets){for(d=this._targets.length;--d>-1;)if(b===this._targets[d]){h=this._propLookup[d]||{},this._overwrittenProps=this._overwrittenProps||[],e=this._overwrittenProps[d]=a?this._overwrittenProps[d]||{}:"all";break}}else{if(b!==this.target)return!1;h=this._propLookup,e=this._overwrittenProps=a?this._overwrittenProps||{}:"all"}if(h){if(j=a||h,k=a!==e&&"all"!==e&&a!==h&&("object"!=typeof a||!a._tempKill),c&&(F.onOverwrite||this.vars.onOverwrite)){for(f in j)h[f]&&(l||(l=[]),l.push(f));if((l||!a)&&!Z(this,c,b,l))return!1}for(f in j)(g=h[f])&&(m&&(g.f?g.t[g.p](g.s):g.t[g.p]=g.s,i=!0),g.pg&&g.t._kill(j)&&(i=!0),g.pg&&0!==g.t._overwriteProps.length||(g._prev?g._prev._next=g._next:g===this._firstPT&&(this._firstPT=g._next),g._next&&(g._next._prev=g._prev),g._next=g._prev=null),delete h[f]),k&&(e[f]=1);!this._firstPT&&this._initted&&this._enabled(!1,!1)}}return i},g.invalidate=function(){return this._notifyPluginsOfEnabled&&F._onPluginEvent("_onDisable",this),this._firstPT=this._overwrittenProps=this._startAt=this._onUpdate=null,this._notifyPluginsOfEnabled=this._active=this._lazy=!1,this._propLookup=this._targets?{}:[],C.prototype.invalidate.call(this),this.vars.immediateRender&&(this._time=-l,this.render(Math.min(0,-this._delay))),this},g._enabled=function(a,b){if(i||h.wake(),a&&this._gc){var c,d=this._targets;if(d)for(c=d.length;--c>-1;)this._siblings[c]=Y(d[c],this,!0);else this._siblings=Y(this.target,this,!0)}return C.prototype._enabled.call(this,a,b),this._notifyPluginsOfEnabled&&this._firstPT?F._onPluginEvent(a?"_onEnable":"_onDisable",this):!1},F.to=function(a,b,c){return new F(a,b,c)},F.from=function(a,b,c){return c.runBackwards=!0,c.immediateRender=0!=c.immediateRender,new F(a,b,c)},F.fromTo=function(a,b,c,d){return d.startAt=c,d.immediateRender=0!=d.immediateRender&&0!=c.immediateRender,new F(a,b,d)},F.delayedCall=function(a,b,c,d,e){return new F(b,0,{delay:a,onComplete:b,onCompleteParams:c,callbackScope:d,onReverseComplete:b,onReverseCompleteParams:c,immediateRender:!1,lazy:!1,useFrames:e,overwrite:0})},F.set=function(a,b){return new F(a,0,b)},F.getTweensOf=function(a,b){if(null==a)return[];a="string"!=typeof a?a:F.selector(a)||a;var c,d,e,f;if((o(a)||G(a))&&"number"!=typeof a[0]){for(c=a.length,d=[];--c>-1;)d=d.concat(F.getTweensOf(a[c],b));for(c=d.length;--c>-1;)for(f=d[c],e=c;--e>-1;)f===d[e]&&d.splice(c,1)}else for(d=Y(a).concat(),c=d.length;--c>-1;)(d[c]._gc||b&&!d[c].isActive())&&d.splice(c,1);return d},F.killTweensOf=F.killDelayedCallsTo=function(a,b,c){"object"==typeof b&&(c=b,b=!1);for(var d=F.getTweensOf(a,b),e=d.length;--e>-1;)d[e]._kill(c,a)};var aa=s("plugins.TweenPlugin",function(a,b){this._overwriteProps=(a||"").split(","),this._propName=this._overwriteProps[0],this._priority=b||0,this._super=aa.prototype},!0);if(g=aa.prototype,aa.version="1.19.0",aa.API=2,g._firstPT=null,g._addTween=N,g.setRatio=L,g._kill=function(a){var b,c=this._overwriteProps,d=this._firstPT;if(null!=a[this._propName])this._overwriteProps=[];else for(b=c.length;--b>-1;)null!=a[c[b]]&&c.splice(b,1);for(;d;)null!=a[d.n]&&(d._next&&(d._next._prev=d._prev),d._prev?(d._prev._next=d._next,d._prev=null):this._firstPT===d&&(this._firstPT=d._next)),d=d._next;return!1},g._mod=g._roundProps=function(a){for(var b,c=this._firstPT;c;)b=a[this._propName]||null!=c.n&&a[c.n.split(this._propName+"_").join("")],b&&"function"==typeof b&&(2===c.f?c.t._applyPT.m=b:c.m=b),c=c._next},F._onPluginEvent=function(a,b){var c,d,e,f,g,h=b._firstPT;if("_onInitAllProps"===a){for(;h;){for(g=h._next,d=e;d&&d.pr>h.pr;)d=d._next;(h._prev=d?d._prev:f)?h._prev._next=h:e=h,(h._next=d)?d._prev=h:f=h,h=g}h=b._firstPT=e}for(;h;)h.pg&&"function"==typeof h.t[a]&&h.t[a]()&&(c=!0),h=h._next;return c},aa.activate=function(a){for(var b=a.length;--b>-1;)a[b].API===aa.API&&(P[(new a[b])._propName]=a[b]);return!0},r.plugin=function(a){if(!(a&&a.propName&&a.init&&a.API))throw"illegal plugin definition.";var b,c=a.propName,d=a.priority||0,e=a.overwriteProps,f={init:"_onInitTween",set:"setRatio",kill:"_kill",round:"_mod",mod:"_mod",initAll:"_onInitAllProps"},g=s("plugins."+c.charAt(0).toUpperCase()+c.substr(1)+"Plugin",function(){aa.call(this,c,d),this._overwriteProps=e||[]},a.global===!0),h=g.prototype=new aa(c);h.constructor=g,g.API=a.API;for(b in f)"function"==typeof a[b]&&(h[f[b]]=a[b]);return g.version=a.version,aa.activate([g]),g},e=a._gsQueue){for(f=0;f<e.length;f++)e[f]();for(g in p)p[g].func||a.console.log("GSAP encountered missing dependency: "+g)}i=!1}}("undefined"!=typeof module&&module.exports&&"undefined"!=typeof global?global:this||window,"TweenMax");
define("gsap", function(){});

/*!
 * VERSION: 1.19.0
 * DATE: 2016-07-16
 * UPDATES AND DOCS AT: http://greensock.com
 *
 * @license Copyright (c) 2008-2016, GreenSock. All rights reserved.
 * This work is subject to the terms at http://greensock.com/standard-license or for
 * Club GreenSock members, the software agreement that was issued with your membership.
 * 
 * @author: Jack Doyle, jack@greensock.com
 */
!function(a,b){"use strict";var c={},d=a.GreenSockGlobals=a.GreenSockGlobals||a;if(!d.TweenLite){var e,f,g,h,i,j=function(a){var b,c=a.split("."),e=d;for(b=0;b<c.length;b++)e[c[b]]=e=e[c[b]]||{};return e},k=j("com.greensock"),l=1e-10,m=function(a){var b,c=[],d=a.length;for(b=0;b!==d;c.push(a[b++]));return c},n=function(){},o=function(){var a=Object.prototype.toString,b=a.call([]);return function(c){return null!=c&&(c instanceof Array||"object"==typeof c&&!!c.push&&a.call(c)===b)}}(),p={},q=function(e,f,g,h){this.sc=p[e]?p[e].sc:[],p[e]=this,this.gsClass=null,this.func=g;var i=[];this.check=function(k){for(var l,m,n,o,r,s=f.length,t=s;--s>-1;)(l=p[f[s]]||new q(f[s],[])).gsClass?(i[s]=l.gsClass,t--):k&&l.sc.push(this);if(0===t&&g){if(m=("com.greensock."+e).split("."),n=m.pop(),o=j(m.join("."))[n]=this.gsClass=g.apply(g,i),h)if(d[n]=c[n]=o,r="undefined"!=typeof module&&module.exports,!r&&"function"==typeof define&&define.amd)define((a.GreenSockAMDPath?a.GreenSockAMDPath+"/":"")+e.split(".").pop(),[],function(){return o});else if(r)if(e===b){module.exports=c[b]=o;for(s in c)o[s]=c[s]}else c[b]&&(c[b][n]=o);for(s=0;s<this.sc.length;s++)this.sc[s].check()}},this.check(!0)},r=a._gsDefine=function(a,b,c,d){return new q(a,b,c,d)},s=k._class=function(a,b,c){return b=b||function(){},r(a,[],function(){return b},c),b};r.globals=d;var t=[0,0,1,1],u=s("easing.Ease",function(a,b,c,d){this._func=a,this._type=c||0,this._power=d||0,this._params=b?t.concat(b):t},!0),v=u.map={},w=u.register=function(a,b,c,d){for(var e,f,g,h,i=b.split(","),j=i.length,l=(c||"easeIn,easeOut,easeInOut").split(",");--j>-1;)for(f=i[j],e=d?s("easing."+f,null,!0):k.easing[f]||{},g=l.length;--g>-1;)h=l[g],v[f+"."+h]=v[h+f]=e[h]=a.getRatio?a:a[h]||new a};for(g=u.prototype,g._calcEnd=!1,g.getRatio=function(a){if(this._func)return this._params[0]=a,this._func.apply(null,this._params);var b=this._type,c=this._power,d=1===b?1-a:2===b?a:.5>a?2*a:2*(1-a);return 1===c?d*=d:2===c?d*=d*d:3===c?d*=d*d*d:4===c&&(d*=d*d*d*d),1===b?1-d:2===b?d:.5>a?d/2:1-d/2},e=["Linear","Quad","Cubic","Quart","Quint,Strong"],f=e.length;--f>-1;)g=e[f]+",Power"+f,w(new u(null,null,1,f),g,"easeOut",!0),w(new u(null,null,2,f),g,"easeIn"+(0===f?",easeNone":"")),w(new u(null,null,3,f),g,"easeInOut");v.linear=k.easing.Linear.easeIn,v.swing=k.easing.Quad.easeInOut;var x=s("events.EventDispatcher",function(a){this._listeners={},this._eventTarget=a||this});g=x.prototype,g.addEventListener=function(a,b,c,d,e){e=e||0;var f,g,j=this._listeners[a],k=0;for(this!==h||i||h.wake(),null==j&&(this._listeners[a]=j=[]),g=j.length;--g>-1;)f=j[g],f.c===b&&f.s===c?j.splice(g,1):0===k&&f.pr<e&&(k=g+1);j.splice(k,0,{c:b,s:c,up:d,pr:e})},g.removeEventListener=function(a,b){var c,d=this._listeners[a];if(d)for(c=d.length;--c>-1;)if(d[c].c===b)return void d.splice(c,1)},g.dispatchEvent=function(a){var b,c,d,e=this._listeners[a];if(e)for(b=e.length,b>1&&(e=e.slice(0)),c=this._eventTarget;--b>-1;)d=e[b],d&&(d.up?d.c.call(d.s||c,{type:a,target:c}):d.c.call(d.s||c))};var y=a.requestAnimationFrame,z=a.cancelAnimationFrame,A=Date.now||function(){return(new Date).getTime()},B=A();for(e=["ms","moz","webkit","o"],f=e.length;--f>-1&&!y;)y=a[e[f]+"RequestAnimationFrame"],z=a[e[f]+"CancelAnimationFrame"]||a[e[f]+"CancelRequestAnimationFrame"];s("Ticker",function(a,b){var c,d,e,f,g,j=this,k=A(),m=b!==!1&&y?"auto":!1,o=500,p=33,q="tick",r=function(a){var b,h,i=A()-B;i>o&&(k+=i-p),B+=i,j.time=(B-k)/1e3,b=j.time-g,(!c||b>0||a===!0)&&(j.frame++,g+=b+(b>=f?.004:f-b),h=!0),a!==!0&&(e=d(r)),h&&j.dispatchEvent(q)};x.call(j),j.time=j.frame=0,j.tick=function(){r(!0)},j.lagSmoothing=function(a,b){o=a||1/l,p=Math.min(b,o,0)},j.sleep=function(){null!=e&&(m&&z?z(e):clearTimeout(e),d=n,e=null,j===h&&(i=!1))},j.wake=function(a){null!==e?j.sleep():a?k+=-B+(B=A()):j.frame>10&&(B=A()-o+5),d=0===c?n:m&&y?y:function(a){return setTimeout(a,1e3*(g-j.time)+1|0)},j===h&&(i=!0),r(2)},j.fps=function(a){return arguments.length?(c=a,f=1/(c||60),g=this.time+f,void j.wake()):c},j.useRAF=function(a){return arguments.length?(j.sleep(),m=a,void j.fps(c)):m},j.fps(a),setTimeout(function(){"auto"===m&&j.frame<5&&"hidden"!==document.visibilityState&&j.useRAF(!1)},1500)}),g=k.Ticker.prototype=new k.events.EventDispatcher,g.constructor=k.Ticker;var C=s("core.Animation",function(a,b){if(this.vars=b=b||{},this._duration=this._totalDuration=a||0,this._delay=Number(b.delay)||0,this._timeScale=1,this._active=b.immediateRender===!0,this.data=b.data,this._reversed=b.reversed===!0,V){i||h.wake();var c=this.vars.useFrames?U:V;c.add(this,c._time),this.vars.paused&&this.paused(!0)}});h=C.ticker=new k.Ticker,g=C.prototype,g._dirty=g._gc=g._initted=g._paused=!1,g._totalTime=g._time=0,g._rawPrevTime=-1,g._next=g._last=g._onUpdate=g._timeline=g.timeline=null,g._paused=!1;var D=function(){i&&A()-B>2e3&&h.wake(),setTimeout(D,2e3)};D(),g.play=function(a,b){return null!=a&&this.seek(a,b),this.reversed(!1).paused(!1)},g.pause=function(a,b){return null!=a&&this.seek(a,b),this.paused(!0)},g.resume=function(a,b){return null!=a&&this.seek(a,b),this.paused(!1)},g.seek=function(a,b){return this.totalTime(Number(a),b!==!1)},g.restart=function(a,b){return this.reversed(!1).paused(!1).totalTime(a?-this._delay:0,b!==!1,!0)},g.reverse=function(a,b){return null!=a&&this.seek(a||this.totalDuration(),b),this.reversed(!0).paused(!1)},g.render=function(a,b,c){},g.invalidate=function(){return this._time=this._totalTime=0,this._initted=this._gc=!1,this._rawPrevTime=-1,(this._gc||!this.timeline)&&this._enabled(!0),this},g.isActive=function(){var a,b=this._timeline,c=this._startTime;return!b||!this._gc&&!this._paused&&b.isActive()&&(a=b.rawTime())>=c&&a<c+this.totalDuration()/this._timeScale},g._enabled=function(a,b){return i||h.wake(),this._gc=!a,this._active=this.isActive(),b!==!0&&(a&&!this.timeline?this._timeline.add(this,this._startTime-this._delay):!a&&this.timeline&&this._timeline._remove(this,!0)),!1},g._kill=function(a,b){return this._enabled(!1,!1)},g.kill=function(a,b){return this._kill(a,b),this},g._uncache=function(a){for(var b=a?this:this.timeline;b;)b._dirty=!0,b=b.timeline;return this},g._swapSelfInParams=function(a){for(var b=a.length,c=a.concat();--b>-1;)"{self}"===a[b]&&(c[b]=this);return c},g._callback=function(a){var b=this.vars,c=b[a],d=b[a+"Params"],e=b[a+"Scope"]||b.callbackScope||this,f=d?d.length:0;switch(f){case 0:c.call(e);break;case 1:c.call(e,d[0]);break;case 2:c.call(e,d[0],d[1]);break;default:c.apply(e,d)}},g.eventCallback=function(a,b,c,d){if("on"===(a||"").substr(0,2)){var e=this.vars;if(1===arguments.length)return e[a];null==b?delete e[a]:(e[a]=b,e[a+"Params"]=o(c)&&-1!==c.join("").indexOf("{self}")?this._swapSelfInParams(c):c,e[a+"Scope"]=d),"onUpdate"===a&&(this._onUpdate=b)}return this},g.delay=function(a){return arguments.length?(this._timeline.smoothChildTiming&&this.startTime(this._startTime+a-this._delay),this._delay=a,this):this._delay},g.duration=function(a){return arguments.length?(this._duration=this._totalDuration=a,this._uncache(!0),this._timeline.smoothChildTiming&&this._time>0&&this._time<this._duration&&0!==a&&this.totalTime(this._totalTime*(a/this._duration),!0),this):(this._dirty=!1,this._duration)},g.totalDuration=function(a){return this._dirty=!1,arguments.length?this.duration(a):this._totalDuration},g.time=function(a,b){return arguments.length?(this._dirty&&this.totalDuration(),this.totalTime(a>this._duration?this._duration:a,b)):this._time},g.totalTime=function(a,b,c){if(i||h.wake(),!arguments.length)return this._totalTime;if(this._timeline){if(0>a&&!c&&(a+=this.totalDuration()),this._timeline.smoothChildTiming){this._dirty&&this.totalDuration();var d=this._totalDuration,e=this._timeline;if(a>d&&!c&&(a=d),this._startTime=(this._paused?this._pauseTime:e._time)-(this._reversed?d-a:a)/this._timeScale,e._dirty||this._uncache(!1),e._timeline)for(;e._timeline;)e._timeline._time!==(e._startTime+e._totalTime)/e._timeScale&&e.totalTime(e._totalTime,!0),e=e._timeline}this._gc&&this._enabled(!0,!1),(this._totalTime!==a||0===this._duration)&&(I.length&&X(),this.render(a,b,!1),I.length&&X())}return this},g.progress=g.totalProgress=function(a,b){var c=this.duration();return arguments.length?this.totalTime(c*a,b):c?this._time/c:this.ratio},g.startTime=function(a){return arguments.length?(a!==this._startTime&&(this._startTime=a,this.timeline&&this.timeline._sortChildren&&this.timeline.add(this,a-this._delay)),this):this._startTime},g.endTime=function(a){return this._startTime+(0!=a?this.totalDuration():this.duration())/this._timeScale},g.timeScale=function(a){if(!arguments.length)return this._timeScale;if(a=a||l,this._timeline&&this._timeline.smoothChildTiming){var b=this._pauseTime,c=b||0===b?b:this._timeline.totalTime();this._startTime=c-(c-this._startTime)*this._timeScale/a}return this._timeScale=a,this._uncache(!1)},g.reversed=function(a){return arguments.length?(a!=this._reversed&&(this._reversed=a,this.totalTime(this._timeline&&!this._timeline.smoothChildTiming?this.totalDuration()-this._totalTime:this._totalTime,!0)),this):this._reversed},g.paused=function(a){if(!arguments.length)return this._paused;var b,c,d=this._timeline;return a!=this._paused&&d&&(i||a||h.wake(),b=d.rawTime(),c=b-this._pauseTime,!a&&d.smoothChildTiming&&(this._startTime+=c,this._uncache(!1)),this._pauseTime=a?b:null,this._paused=a,this._active=this.isActive(),!a&&0!==c&&this._initted&&this.duration()&&(b=d.smoothChildTiming?this._totalTime:(b-this._startTime)/this._timeScale,this.render(b,b===this._totalTime,!0))),this._gc&&!a&&this._enabled(!0,!1),this};var E=s("core.SimpleTimeline",function(a){C.call(this,0,a),this.autoRemoveChildren=this.smoothChildTiming=!0});g=E.prototype=new C,g.constructor=E,g.kill()._gc=!1,g._first=g._last=g._recent=null,g._sortChildren=!1,g.add=g.insert=function(a,b,c,d){var e,f;if(a._startTime=Number(b||0)+a._delay,a._paused&&this!==a._timeline&&(a._pauseTime=a._startTime+(this.rawTime()-a._startTime)/a._timeScale),a.timeline&&a.timeline._remove(a,!0),a.timeline=a._timeline=this,a._gc&&a._enabled(!0,!0),e=this._last,this._sortChildren)for(f=a._startTime;e&&e._startTime>f;)e=e._prev;return e?(a._next=e._next,e._next=a):(a._next=this._first,this._first=a),a._next?a._next._prev=a:this._last=a,a._prev=e,this._recent=a,this._timeline&&this._uncache(!0),this},g._remove=function(a,b){return a.timeline===this&&(b||a._enabled(!1,!0),a._prev?a._prev._next=a._next:this._first===a&&(this._first=a._next),a._next?a._next._prev=a._prev:this._last===a&&(this._last=a._prev),a._next=a._prev=a.timeline=null,a===this._recent&&(this._recent=this._last),this._timeline&&this._uncache(!0)),this},g.render=function(a,b,c){var d,e=this._first;for(this._totalTime=this._time=this._rawPrevTime=a;e;)d=e._next,(e._active||a>=e._startTime&&!e._paused)&&(e._reversed?e.render((e._dirty?e.totalDuration():e._totalDuration)-(a-e._startTime)*e._timeScale,b,c):e.render((a-e._startTime)*e._timeScale,b,c)),e=d},g.rawTime=function(){return i||h.wake(),this._totalTime};var F=s("TweenLite",function(b,c,d){if(C.call(this,c,d),this.render=F.prototype.render,null==b)throw"Cannot tween a null target.";this.target=b="string"!=typeof b?b:F.selector(b)||b;var e,f,g,h=b.jquery||b.length&&b!==a&&b[0]&&(b[0]===a||b[0].nodeType&&b[0].style&&!b.nodeType),i=this.vars.overwrite;if(this._overwrite=i=null==i?T[F.defaultOverwrite]:"number"==typeof i?i>>0:T[i],(h||b instanceof Array||b.push&&o(b))&&"number"!=typeof b[0])for(this._targets=g=m(b),this._propLookup=[],this._siblings=[],e=0;e<g.length;e++)f=g[e],f?"string"!=typeof f?f.length&&f!==a&&f[0]&&(f[0]===a||f[0].nodeType&&f[0].style&&!f.nodeType)?(g.splice(e--,1),this._targets=g=g.concat(m(f))):(this._siblings[e]=Y(f,this,!1),1===i&&this._siblings[e].length>1&&$(f,this,null,1,this._siblings[e])):(f=g[e--]=F.selector(f),"string"==typeof f&&g.splice(e+1,1)):g.splice(e--,1);else this._propLookup={},this._siblings=Y(b,this,!1),1===i&&this._siblings.length>1&&$(b,this,null,1,this._siblings);(this.vars.immediateRender||0===c&&0===this._delay&&this.vars.immediateRender!==!1)&&(this._time=-l,this.render(Math.min(0,-this._delay)))},!0),G=function(b){return b&&b.length&&b!==a&&b[0]&&(b[0]===a||b[0].nodeType&&b[0].style&&!b.nodeType)},H=function(a,b){var c,d={};for(c in a)S[c]||c in b&&"transform"!==c&&"x"!==c&&"y"!==c&&"width"!==c&&"height"!==c&&"className"!==c&&"border"!==c||!(!P[c]||P[c]&&P[c]._autoCSS)||(d[c]=a[c],delete a[c]);a.css=d};g=F.prototype=new C,g.constructor=F,g.kill()._gc=!1,g.ratio=0,g._firstPT=g._targets=g._overwrittenProps=g._startAt=null,g._notifyPluginsOfEnabled=g._lazy=!1,F.version="1.19.0",F.defaultEase=g._ease=new u(null,null,1,1),F.defaultOverwrite="auto",F.ticker=h,F.autoSleep=120,F.lagSmoothing=function(a,b){h.lagSmoothing(a,b)},F.selector=a.$||a.jQuery||function(b){var c=a.$||a.jQuery;return c?(F.selector=c,c(b)):"undefined"==typeof document?b:document.querySelectorAll?document.querySelectorAll(b):document.getElementById("#"===b.charAt(0)?b.substr(1):b)};var I=[],J={},K=/(?:(-|-=|\+=)?\d*\.?\d*(?:e[\-+]?\d+)?)[0-9]/gi,L=function(a){for(var b,c=this._firstPT,d=1e-6;c;)b=c.blob?a?this.join(""):this.start:c.c*a+c.s,c.m?b=c.m(b,this._target||c.t):d>b&&b>-d&&(b=0),c.f?c.fp?c.t[c.p](c.fp,b):c.t[c.p](b):c.t[c.p]=b,c=c._next},M=function(a,b,c,d){var e,f,g,h,i,j,k,l=[a,b],m=0,n="",o=0;for(l.start=a,c&&(c(l),a=l[0],b=l[1]),l.length=0,e=a.match(K)||[],f=b.match(K)||[],d&&(d._next=null,d.blob=1,l._firstPT=l._applyPT=d),i=f.length,h=0;i>h;h++)k=f[h],j=b.substr(m,b.indexOf(k,m)-m),n+=j||!h?j:",",m+=j.length,o?o=(o+1)%5:"rgba("===j.substr(-5)&&(o=1),k===e[h]||e.length<=h?n+=k:(n&&(l.push(n),n=""),g=parseFloat(e[h]),l.push(g),l._firstPT={_next:l._firstPT,t:l,p:l.length-1,s:g,c:("="===k.charAt(1)?parseInt(k.charAt(0)+"1",10)*parseFloat(k.substr(2)):parseFloat(k)-g)||0,f:0,m:o&&4>o?Math.round:0}),m+=k.length;return n+=b.substr(m),n&&l.push(n),l.setRatio=L,l},N=function(a,b,c,d,e,f,g,h,i){"function"==typeof d&&(d=d(i||0,a));var j,k,l="get"===c?a[b]:c,m=typeof a[b],n="string"==typeof d&&"="===d.charAt(1),o={t:a,p:b,s:l,f:"function"===m,pg:0,n:e||b,m:f?"function"==typeof f?f:Math.round:0,pr:0,c:n?parseInt(d.charAt(0)+"1",10)*parseFloat(d.substr(2)):parseFloat(d)-l||0};return"number"!==m&&("function"===m&&"get"===c&&(k=b.indexOf("set")||"function"!=typeof a["get"+b.substr(3)]?b:"get"+b.substr(3),o.s=l=g?a[k](g):a[k]()),"string"==typeof l&&(g||isNaN(l))?(o.fp=g,j=M(l,d,h||F.defaultStringFilter,o),o={t:j,p:"setRatio",s:0,c:1,f:2,pg:0,n:e||b,pr:0,m:0}):n||(o.s=parseFloat(l),o.c=parseFloat(d)-o.s||0)),o.c?((o._next=this._firstPT)&&(o._next._prev=o),this._firstPT=o,o):void 0},O=F._internals={isArray:o,isSelector:G,lazyTweens:I,blobDif:M},P=F._plugins={},Q=O.tweenLookup={},R=0,S=O.reservedProps={ease:1,delay:1,overwrite:1,onComplete:1,onCompleteParams:1,onCompleteScope:1,useFrames:1,runBackwards:1,startAt:1,onUpdate:1,onUpdateParams:1,onUpdateScope:1,onStart:1,onStartParams:1,onStartScope:1,onReverseComplete:1,onReverseCompleteParams:1,onReverseCompleteScope:1,onRepeat:1,onRepeatParams:1,onRepeatScope:1,easeParams:1,yoyo:1,immediateRender:1,repeat:1,repeatDelay:1,data:1,paused:1,reversed:1,autoCSS:1,lazy:1,onOverwrite:1,callbackScope:1,stringFilter:1,id:1},T={none:0,all:1,auto:2,concurrent:3,allOnStart:4,preexisting:5,"true":1,"false":0},U=C._rootFramesTimeline=new E,V=C._rootTimeline=new E,W=30,X=O.lazyRender=function(){var a,b=I.length;for(J={};--b>-1;)a=I[b],a&&a._lazy!==!1&&(a.render(a._lazy[0],a._lazy[1],!0),a._lazy=!1);I.length=0};V._startTime=h.time,U._startTime=h.frame,V._active=U._active=!0,setTimeout(X,1),C._updateRoot=F.render=function(){var a,b,c;if(I.length&&X(),V.render((h.time-V._startTime)*V._timeScale,!1,!1),U.render((h.frame-U._startTime)*U._timeScale,!1,!1),I.length&&X(),h.frame>=W){W=h.frame+(parseInt(F.autoSleep,10)||120);for(c in Q){for(b=Q[c].tweens,a=b.length;--a>-1;)b[a]._gc&&b.splice(a,1);0===b.length&&delete Q[c]}if(c=V._first,(!c||c._paused)&&F.autoSleep&&!U._first&&1===h._listeners.tick.length){for(;c&&c._paused;)c=c._next;c||h.sleep()}}},h.addEventListener("tick",C._updateRoot);var Y=function(a,b,c){var d,e,f=a._gsTweenID;if(Q[f||(a._gsTweenID=f="t"+R++)]||(Q[f]={target:a,tweens:[]}),b&&(d=Q[f].tweens,d[e=d.length]=b,c))for(;--e>-1;)d[e]===b&&d.splice(e,1);return Q[f].tweens},Z=function(a,b,c,d){var e,f,g=a.vars.onOverwrite;return g&&(e=g(a,b,c,d)),g=F.onOverwrite,g&&(f=g(a,b,c,d)),e!==!1&&f!==!1},$=function(a,b,c,d,e){var f,g,h,i;if(1===d||d>=4){for(i=e.length,f=0;i>f;f++)if((h=e[f])!==b)h._gc||h._kill(null,a,b)&&(g=!0);else if(5===d)break;return g}var j,k=b._startTime+l,m=[],n=0,o=0===b._duration;for(f=e.length;--f>-1;)(h=e[f])===b||h._gc||h._paused||(h._timeline!==b._timeline?(j=j||_(b,0,o),0===_(h,j,o)&&(m[n++]=h)):h._startTime<=k&&h._startTime+h.totalDuration()/h._timeScale>k&&((o||!h._initted)&&k-h._startTime<=2e-10||(m[n++]=h)));for(f=n;--f>-1;)if(h=m[f],2===d&&h._kill(c,a,b)&&(g=!0),2!==d||!h._firstPT&&h._initted){if(2!==d&&!Z(h,b))continue;h._enabled(!1,!1)&&(g=!0)}return g},_=function(a,b,c){for(var d=a._timeline,e=d._timeScale,f=a._startTime;d._timeline;){if(f+=d._startTime,e*=d._timeScale,d._paused)return-100;d=d._timeline}return f/=e,f>b?f-b:c&&f===b||!a._initted&&2*l>f-b?l:(f+=a.totalDuration()/a._timeScale/e)>b+l?0:f-b-l};g._init=function(){var a,b,c,d,e,f,g=this.vars,h=this._overwrittenProps,i=this._duration,j=!!g.immediateRender,k=g.ease;if(g.startAt){this._startAt&&(this._startAt.render(-1,!0),this._startAt.kill()),e={};for(d in g.startAt)e[d]=g.startAt[d];if(e.overwrite=!1,e.immediateRender=!0,e.lazy=j&&g.lazy!==!1,e.startAt=e.delay=null,this._startAt=F.to(this.target,0,e),j)if(this._time>0)this._startAt=null;else if(0!==i)return}else if(g.runBackwards&&0!==i)if(this._startAt)this._startAt.render(-1,!0),this._startAt.kill(),this._startAt=null;else{0!==this._time&&(j=!1),c={};for(d in g)S[d]&&"autoCSS"!==d||(c[d]=g[d]);if(c.overwrite=0,c.data="isFromStart",c.lazy=j&&g.lazy!==!1,c.immediateRender=j,this._startAt=F.to(this.target,0,c),j){if(0===this._time)return}else this._startAt._init(),this._startAt._enabled(!1),this.vars.immediateRender&&(this._startAt=null)}if(this._ease=k=k?k instanceof u?k:"function"==typeof k?new u(k,g.easeParams):v[k]||F.defaultEase:F.defaultEase,g.easeParams instanceof Array&&k.config&&(this._ease=k.config.apply(k,g.easeParams)),this._easeType=this._ease._type,this._easePower=this._ease._power,this._firstPT=null,this._targets)for(f=this._targets.length,a=0;f>a;a++)this._initProps(this._targets[a],this._propLookup[a]={},this._siblings[a],h?h[a]:null,a)&&(b=!0);else b=this._initProps(this.target,this._propLookup,this._siblings,h,0);if(b&&F._onPluginEvent("_onInitAllProps",this),h&&(this._firstPT||"function"!=typeof this.target&&this._enabled(!1,!1)),g.runBackwards)for(c=this._firstPT;c;)c.s+=c.c,c.c=-c.c,c=c._next;this._onUpdate=g.onUpdate,this._initted=!0},g._initProps=function(b,c,d,e,f){var g,h,i,j,k,l;if(null==b)return!1;J[b._gsTweenID]&&X(),this.vars.css||b.style&&b!==a&&b.nodeType&&P.css&&this.vars.autoCSS!==!1&&H(this.vars,b);for(g in this.vars)if(l=this.vars[g],S[g])l&&(l instanceof Array||l.push&&o(l))&&-1!==l.join("").indexOf("{self}")&&(this.vars[g]=l=this._swapSelfInParams(l,this));else if(P[g]&&(j=new P[g])._onInitTween(b,this.vars[g],this,f)){for(this._firstPT=k={_next:this._firstPT,t:j,p:"setRatio",s:0,c:1,f:1,n:g,pg:1,pr:j._priority,m:0},h=j._overwriteProps.length;--h>-1;)c[j._overwriteProps[h]]=this._firstPT;(j._priority||j._onInitAllProps)&&(i=!0),(j._onDisable||j._onEnable)&&(this._notifyPluginsOfEnabled=!0),k._next&&(k._next._prev=k)}else c[g]=N.call(this,b,g,"get",l,g,0,null,this.vars.stringFilter,f);return e&&this._kill(e,b)?this._initProps(b,c,d,e,f):this._overwrite>1&&this._firstPT&&d.length>1&&$(b,this,c,this._overwrite,d)?(this._kill(c,b),this._initProps(b,c,d,e,f)):(this._firstPT&&(this.vars.lazy!==!1&&this._duration||this.vars.lazy&&!this._duration)&&(J[b._gsTweenID]=!0),i)},g.render=function(a,b,c){var d,e,f,g,h=this._time,i=this._duration,j=this._rawPrevTime;if(a>=i-1e-7)this._totalTime=this._time=i,this.ratio=this._ease._calcEnd?this._ease.getRatio(1):1,this._reversed||(d=!0,e="onComplete",c=c||this._timeline.autoRemoveChildren),0===i&&(this._initted||!this.vars.lazy||c)&&(this._startTime===this._timeline._duration&&(a=0),(0>j||0>=a&&a>=-1e-7||j===l&&"isPause"!==this.data)&&j!==a&&(c=!0,j>l&&(e="onReverseComplete")),this._rawPrevTime=g=!b||a||j===a?a:l);else if(1e-7>a)this._totalTime=this._time=0,this.ratio=this._ease._calcEnd?this._ease.getRatio(0):0,(0!==h||0===i&&j>0)&&(e="onReverseComplete",d=this._reversed),0>a&&(this._active=!1,0===i&&(this._initted||!this.vars.lazy||c)&&(j>=0&&(j!==l||"isPause"!==this.data)&&(c=!0),this._rawPrevTime=g=!b||a||j===a?a:l)),this._initted||(c=!0);else if(this._totalTime=this._time=a,this._easeType){var k=a/i,m=this._easeType,n=this._easePower;(1===m||3===m&&k>=.5)&&(k=1-k),3===m&&(k*=2),1===n?k*=k:2===n?k*=k*k:3===n?k*=k*k*k:4===n&&(k*=k*k*k*k),1===m?this.ratio=1-k:2===m?this.ratio=k:.5>a/i?this.ratio=k/2:this.ratio=1-k/2}else this.ratio=this._ease.getRatio(a/i);if(this._time!==h||c){if(!this._initted){if(this._init(),!this._initted||this._gc)return;if(!c&&this._firstPT&&(this.vars.lazy!==!1&&this._duration||this.vars.lazy&&!this._duration))return this._time=this._totalTime=h,this._rawPrevTime=j,I.push(this),void(this._lazy=[a,b]);this._time&&!d?this.ratio=this._ease.getRatio(this._time/i):d&&this._ease._calcEnd&&(this.ratio=this._ease.getRatio(0===this._time?0:1))}for(this._lazy!==!1&&(this._lazy=!1),this._active||!this._paused&&this._time!==h&&a>=0&&(this._active=!0),0===h&&(this._startAt&&(a>=0?this._startAt.render(a,b,c):e||(e="_dummyGS")),this.vars.onStart&&(0!==this._time||0===i)&&(b||this._callback("onStart"))),f=this._firstPT;f;)f.f?f.t[f.p](f.c*this.ratio+f.s):f.t[f.p]=f.c*this.ratio+f.s,f=f._next;this._onUpdate&&(0>a&&this._startAt&&a!==-1e-4&&this._startAt.render(a,b,c),b||(this._time!==h||d||c)&&this._callback("onUpdate")),e&&(!this._gc||c)&&(0>a&&this._startAt&&!this._onUpdate&&a!==-1e-4&&this._startAt.render(a,b,c),d&&(this._timeline.autoRemoveChildren&&this._enabled(!1,!1),this._active=!1),!b&&this.vars[e]&&this._callback(e),0===i&&this._rawPrevTime===l&&g!==l&&(this._rawPrevTime=0))}},g._kill=function(a,b,c){if("all"===a&&(a=null),null==a&&(null==b||b===this.target))return this._lazy=!1,this._enabled(!1,!1);b="string"!=typeof b?b||this._targets||this.target:F.selector(b)||b;var d,e,f,g,h,i,j,k,l,m=c&&this._time&&c._startTime===this._startTime&&this._timeline===c._timeline;if((o(b)||G(b))&&"number"!=typeof b[0])for(d=b.length;--d>-1;)this._kill(a,b[d],c)&&(i=!0);else{if(this._targets){for(d=this._targets.length;--d>-1;)if(b===this._targets[d]){h=this._propLookup[d]||{},this._overwrittenProps=this._overwrittenProps||[],e=this._overwrittenProps[d]=a?this._overwrittenProps[d]||{}:"all";break}}else{if(b!==this.target)return!1;h=this._propLookup,e=this._overwrittenProps=a?this._overwrittenProps||{}:"all"}if(h){if(j=a||h,k=a!==e&&"all"!==e&&a!==h&&("object"!=typeof a||!a._tempKill),c&&(F.onOverwrite||this.vars.onOverwrite)){for(f in j)h[f]&&(l||(l=[]),l.push(f));if((l||!a)&&!Z(this,c,b,l))return!1}for(f in j)(g=h[f])&&(m&&(g.f?g.t[g.p](g.s):g.t[g.p]=g.s,i=!0),g.pg&&g.t._kill(j)&&(i=!0),g.pg&&0!==g.t._overwriteProps.length||(g._prev?g._prev._next=g._next:g===this._firstPT&&(this._firstPT=g._next),g._next&&(g._next._prev=g._prev),g._next=g._prev=null),delete h[f]),k&&(e[f]=1);!this._firstPT&&this._initted&&this._enabled(!1,!1)}}return i},g.invalidate=function(){return this._notifyPluginsOfEnabled&&F._onPluginEvent("_onDisable",this),this._firstPT=this._overwrittenProps=this._startAt=this._onUpdate=null,this._notifyPluginsOfEnabled=this._active=this._lazy=!1,this._propLookup=this._targets?{}:[],C.prototype.invalidate.call(this),this.vars.immediateRender&&(this._time=-l,this.render(Math.min(0,-this._delay))),this},g._enabled=function(a,b){if(i||h.wake(),a&&this._gc){var c,d=this._targets;if(d)for(c=d.length;--c>-1;)this._siblings[c]=Y(d[c],this,!0);else this._siblings=Y(this.target,this,!0)}return C.prototype._enabled.call(this,a,b),this._notifyPluginsOfEnabled&&this._firstPT?F._onPluginEvent(a?"_onEnable":"_onDisable",this):!1},F.to=function(a,b,c){return new F(a,b,c)},F.from=function(a,b,c){return c.runBackwards=!0,c.immediateRender=0!=c.immediateRender,new F(a,b,c)},F.fromTo=function(a,b,c,d){return d.startAt=c,d.immediateRender=0!=d.immediateRender&&0!=c.immediateRender,new F(a,b,d)},F.delayedCall=function(a,b,c,d,e){return new F(b,0,{delay:a,onComplete:b,onCompleteParams:c,callbackScope:d,onReverseComplete:b,onReverseCompleteParams:c,immediateRender:!1,lazy:!1,useFrames:e,overwrite:0})},F.set=function(a,b){return new F(a,0,b)},F.getTweensOf=function(a,b){if(null==a)return[];a="string"!=typeof a?a:F.selector(a)||a;var c,d,e,f;if((o(a)||G(a))&&"number"!=typeof a[0]){for(c=a.length,d=[];--c>-1;)d=d.concat(F.getTweensOf(a[c],b));for(c=d.length;--c>-1;)for(f=d[c],e=c;--e>-1;)f===d[e]&&d.splice(c,1)}else for(d=Y(a).concat(),c=d.length;--c>-1;)(d[c]._gc||b&&!d[c].isActive())&&d.splice(c,1);return d},F.killTweensOf=F.killDelayedCallsTo=function(a,b,c){"object"==typeof b&&(c=b,b=!1);for(var d=F.getTweensOf(a,b),e=d.length;--e>-1;)d[e]._kill(c,a)};var aa=s("plugins.TweenPlugin",function(a,b){this._overwriteProps=(a||"").split(","),this._propName=this._overwriteProps[0],this._priority=b||0,this._super=aa.prototype},!0);if(g=aa.prototype,aa.version="1.19.0",aa.API=2,g._firstPT=null,g._addTween=N,g.setRatio=L,g._kill=function(a){var b,c=this._overwriteProps,d=this._firstPT;if(null!=a[this._propName])this._overwriteProps=[];else for(b=c.length;--b>-1;)null!=a[c[b]]&&c.splice(b,1);for(;d;)null!=a[d.n]&&(d._next&&(d._next._prev=d._prev),d._prev?(d._prev._next=d._next,d._prev=null):this._firstPT===d&&(this._firstPT=d._next)),d=d._next;return!1},g._mod=g._roundProps=function(a){for(var b,c=this._firstPT;c;)b=a[this._propName]||null!=c.n&&a[c.n.split(this._propName+"_").join("")],b&&"function"==typeof b&&(2===c.f?c.t._applyPT.m=b:c.m=b),c=c._next},F._onPluginEvent=function(a,b){var c,d,e,f,g,h=b._firstPT;if("_onInitAllProps"===a){for(;h;){for(g=h._next,d=e;d&&d.pr>h.pr;)d=d._next;(h._prev=d?d._prev:f)?h._prev._next=h:e=h,(h._next=d)?d._prev=h:f=h,h=g}h=b._firstPT=e}for(;h;)h.pg&&"function"==typeof h.t[a]&&h.t[a]()&&(c=!0),h=h._next;return c},aa.activate=function(a){for(var b=a.length;--b>-1;)a[b].API===aa.API&&(P[(new a[b])._propName]=a[b]);return!0},r.plugin=function(a){if(!(a&&a.propName&&a.init&&a.API))throw"illegal plugin definition.";var b,c=a.propName,d=a.priority||0,e=a.overwriteProps,f={init:"_onInitTween",set:"setRatio",kill:"_kill",round:"_mod",mod:"_mod",initAll:"_onInitAllProps"},g=s("plugins."+c.charAt(0).toUpperCase()+c.substr(1)+"Plugin",function(){aa.call(this,c,d),this._overwriteProps=e||[]},a.global===!0),h=g.prototype=new aa(c);h.constructor=g,g.API=a.API;for(b in f)"function"==typeof a[b]&&(h[f[b]]=a[b]);return g.version=a.version,aa.activate([g]),g},e=a._gsQueue){for(f=0;f<e.length;f++)e[f]();for(g in p)p[g].func||a.console.log("GSAP encountered missing dependency: "+g)}i=!1}}("undefined"!=typeof module&&module.exports&&"undefined"!=typeof global?global:this||window,"TweenLite");
define("TweenLite", function(){});

/*!
 * VERSION: 1.8.0
 * DATE: 2016-07-09
 * UPDATES AND DOCS AT: http://greensock.com
 *
 * @license Copyright (c) 2008-2016, GreenSock. All rights reserved.
 * This work is subject to the terms at http://greensock.com/standard-license or for
 * Club GreenSock members, the software agreement that was issued with your membership.
 * 
 * @author: Jack Doyle, jack@greensock.com
 **/
var _gsScope="undefined"!=typeof module&&module.exports&&"undefined"!=typeof global?global:this||window;(_gsScope._gsQueue||(_gsScope._gsQueue=[])).push(function(){"use strict";var a=document.documentElement,b=window,c=function(c,d){var e="x"===d?"Width":"Height",f="scroll"+e,g="client"+e,h=document.body;return c===b||c===a||c===h?Math.max(a[f],h[f])-(b["inner"+e]||a[g]||h[g]):c[f]-c["offset"+e]},d=function(a){return"string"==typeof a&&(a=TweenLite.selector(a)),a.length&&a!==b&&a[0]&&a[0].style&&!a.nodeType&&(a=a[0]),a===b||a.nodeType&&a.style?a:null},e=function(c,d){var e="scroll"+("x"===d?"Left":"Top");return c===b&&(null!=c.pageXOffset?e="page"+d.toUpperCase()+"Offset":c=null!=a[e]?a:document.body),function(){return c[e]}},f=function(c,f){var g=d(c).getBoundingClientRect(),h=!f||f===b||f===document.body,i=(h?a:f).getBoundingClientRect(),j={x:g.left-i.left,y:g.top-i.top};return!h&&f&&(j.x+=e(f,"x")(),j.y+=e(f,"y")()),j},g=function(a,b,d){var e=typeof a;return"number"===e||"string"===e&&"="===a.charAt(1)?a:"max"===a?c(b,d):Math.min(c(b,d),f(a,b)[d])},h=_gsScope._gsDefine.plugin({propName:"scrollTo",API:2,version:"1.8.0",init:function(a,c,d){return this._wdw=a===b,this._target=a,this._tween=d,"object"!=typeof c?(c={y:c},"string"==typeof c.y&&"max"!==c.y&&"="!==c.y.charAt(1)&&(c.x=c.y)):c.nodeType&&(c={y:c,x:c}),this.vars=c,this._autoKill=c.autoKill!==!1,this.getX=e(a,"x"),this.getY=e(a,"y"),this.x=this.xPrev=this.getX(),this.y=this.yPrev=this.getY(),null!=c.x?(this._addTween(this,"x",this.x,g(c.x,a,"x")-(c.offsetX||0),"scrollTo_x",!0),this._overwriteProps.push("scrollTo_x")):this.skipX=!0,null!=c.y?(this._addTween(this,"y",this.y,g(c.y,a,"y")-(c.offsetY||0),"scrollTo_y",!0),this._overwriteProps.push("scrollTo_y")):this.skipY=!0,!0},set:function(a){this._super.setRatio.call(this,a);var d=this._wdw||!this.skipX?this.getX():this.xPrev,e=this._wdw||!this.skipY?this.getY():this.yPrev,f=e-this.yPrev,g=d-this.xPrev,i=h.autoKillThreshold;this.x<0&&(this.x=0),this.y<0&&(this.y=0),this._autoKill&&(!this.skipX&&(g>i||-i>g)&&d<c(this._target,"x")&&(this.skipX=!0),!this.skipY&&(f>i||-i>f)&&e<c(this._target,"y")&&(this.skipY=!0),this.skipX&&this.skipY&&(this._tween.kill(),this.vars.onAutoKill&&this.vars.onAutoKill.apply(this.vars.onAutoKillScope||this._tween,this.vars.onAutoKillParams||[]))),this._wdw?b.scrollTo(this.skipX?d:this.x,this.skipY?e:this.y):(this.skipY||(this._target.scrollTop=this.y),this.skipX||(this._target.scrollLeft=this.x)),this.xPrev=this.x,this.yPrev=this.y}}),i=h.prototype;h.max=c,h.getOffset=f,h.autoKillThreshold=7,i._kill=function(a){return a.scrollTo_x&&(this.skipX=!0),a.scrollTo_y&&(this.skipY=!0),this._super._kill.call(this,a)}}),_gsScope._gsDefine&&_gsScope._gsQueue.pop()(),function(a){"use strict";var b=function(){return(_gsScope.GreenSockGlobals||_gsScope)[a]};"function"==typeof define&&define.amd?define('gsap-scrollto',["TweenLite"],b):"undefined"!=typeof module&&module.exports&&(require("../TweenLite.js"),module.exports=b())}("ScrollToPlugin");
/**
 * Add setInterval, clearInterval, setTimeout, clearTimeout to TweenMax
 */
define('gsap-interval',['require','exports','module','gsap'],function (require, exports, module) {
    require("gsap");

    /**
     * Set an interval
     */
    TimelineMax.setInterval = TweenMax.setInterval = function (callback, seconds, scope, params, repeat) {
        scope = scope || null;
        params = params || null;

        if (isNaN(repeat)) {
            repeat = -1;
        }

        var tl = new TimelineMax({
            repeat: repeat
        });

        tl.call(callback, params, scope, seconds);

        return tl;
    };

    /**
     * Set a timeout
     */
    TimelineMax.setTimeout = TweenMax.setTimeout = function (callback, seconds, scope, params) {
        return TweenMax.setInterval(callback, seconds, scope, params, 0);
    };

    /**
     * Clear interval
     */
    TimelineMax.clearInterval = TweenMax.clearInterval = function (tween) {
        if (tween) tween.kill();
    };

    /**
     * Clear timeout
     */
    TimelineMax.clearTimeout = TweenMax.clearTimeout = function (tween) {
        if (tween) tween.kill();
    };

    module.exports = TweenMax;
});

// Fetch global instance of jquery
define('jquery', [], function() {
    return jQuery;
});

// Break out the application running from the configuration definition to
// assist with testing.
require(["config"], function () {
    // Kick off the application.
    require([
        "modernizr",
        "bowser",
        "jquery",
        "underscore",
        "theme",
        "views/.BodyView",
        "jquery-gestures",
        "gsap",
        "gsap-scrollto",
        "gsap-interval",
        "james-search"
    ], function (
        ModernizrVar,
        bowser,
        $,
        _,
        theme,
        BodyView,
        jgestures,
        TweenMax,
        TweenMaxScrollTo,
        TweenMaxInterval
    ) {
        //On Ready
        $(function () {
            new BodyView();

            window.theme = theme;
        });

    });
});

define("main", function(){});

}());